import * as angular from 'angular';
import { module } from 'angular';
import { SETTINGS, HelpField, DeploymentStrategyRegistry, FormValidator, FormikFormField, TextInput, AccountService, ReactSelectInput, CheckboxInput, MapEditorInput, NumberInput, NetworkReader, SubnetReader, ReactInjector, TetheredSelect, TaskMonitor, FunctionWriter, ReactModal, WizardModal, WizardPage, noop, ConfirmationModalService, ApplicationReader, AddEntityTagLinks, ReactInject, Details, AccountTag, Overrides, CollapsibleSection, HelpContentsRegistry, REST, LabeledValue, timestamp, useData, SubnetTag, withErrorBoundary, InstanceWriter, TaskExecutor, CloudProviderRegistry, FirewallLabels, RecentHistoryService, InstanceReader, LabeledValueList, LinkWithClipboard, robotToHuman, Tooltip, InstanceLoadBalancerHealth, LoadBalancerServerGroup, HealthCounts, LoadBalancerInstances, LoadBalancerClusterContainer, logger, LoadBalancerDataUtils, Spinner, HoverablePopover, SpinFormik, ModalClose, SubmitButton, SelectInput, CertificateReader, relativeTime, Overridable, ValidationMessage, CustomLabels, Validators, spelNumberCheck, SpInput, SpelNumberInput, ChecklistInput, useDeepObjectDiff, useMountStatusRef, createFakeReactSyntheticEvent, Markdown, NameUtils, AccountSelectInput, RegionSelectField, InfrastructureCaches, LoadBalancerWriter, ManagedMenuItem, SECURITY_GROUP_READER, LOAD_BALANCER_READ_SERVICE, MANAGED_RESOURCE_DETAILS_INDICATOR, APPLICATION_STATE_PROVIDER, Registry, BakeExecutionLabel, AuthenticationService, PipelineTemplates, BakeryReader, StageConstants, AppListExtractor, StageConfigField, yamlDocumentsToString, ExecutionDetailsSection, ExecutionStepDetails, StageFailureMessage, NgGenericArtifactDelegate, ExpectedArtifactSelectorViewController, ExecutionBarLabel, ExpectedArtifactService, ArtifactReferenceService, EXECUTION_SERVICE, PipelineConfigService, ModalWizard, SecurityGroupWriter, filterObjectValues, CACHE_INITIALIZER_SERVICE, confirmNotManaged, DeployInitializer, DeployingIntoManagedClusterWarning, ServerGroupDetailsField, DeploymentStrategySelector, ServerGroupNamePreview, TaskReason, ToggleButtonGroup, ToggleSize, usePrevious, NgReact, PlatformHealthOverride, MapEditor, UserVerification, TaskMonitorWrapper, MinMaxDesiredChanges, ServerGroupWarningMessageService, ModalInjector, ClusterTargetBuilder, ServerGroupReader, CloudMetricsReader, TaskMonitorModal, EntitySource, ViewChangesLink, CapacityDetailsSection, ViewScalingActivitiesLink, ShowUserData, SERVER_GROUP_COMMAND_REGISTRY_PROVIDER, setMatchingResourceSummary, INSTANCE_TYPE_SERVICE, SERVER_GROUP_WRITER, ApplicationNameValidator } from '@spinnaker/core';
import * as React from 'react';
import React__default, { useState, useEffect } from 'react';
import _, { isEmpty, forOwn, uniqBy, cloneDeep, flatten, isNil, orderBy, isEqual, sortBy, pickBy, groupBy, get, uniq, difference, some, isNumber, filter, set, chain, partition, map as map$1, every, values, head, extend, intersection, keyBy, find, flatMap, has, clone, keys, xor } from 'lodash';
import classNames from 'classnames';
import { Subject, from, combineLatest, BehaviorSubject, of, Observable } from 'rxjs';
import { map, distinctUntilChanged, shareReplay, switchMap, withLatestFrom, takeUntil, tap, mergeMap, catchError, debounceTime, take } from 'rxjs/operators';
import { Dropdown, Modal, Button, Tooltip as Tooltip$1, OverlayTrigger, Checkbox, ModalFooter, MenuItem } from 'react-bootstrap';
import { $q } from 'ngimport';
import { react2angular } from 'react2angular';
import { UISref, UISrefActive } from '@uirouter/react';
import { UIRouterContextComponent } from '@uirouter/react-hybrid';
import UIROUTER_ANGULARJS from '@uirouter/angularjs';
import ANGULAR_UI_BOOTSTRAP from 'angular-ui-bootstrap';
import { SortableHandle, arrayMove, SortableElement, SortableContainer } from 'react-sortable-hoc';
import { Form, Field } from 'formik';
import Select from 'react-select';
import VirtualizedSelect from 'react-virtualized-select';
import { Chart, LineController, LineElement, PointElement, LinearScale, Title, TimeScale, Tooltip as Tooltip$2, Legend, Filler } from 'chart.js';
import 'chartjs-adapter-luxon';

var _a$2;
const AWSProviderSettings = SETTINGS.providers.aws || {
  defaults: {}
};
if (AWSProviderSettings) {
  AWSProviderSettings.adHocInfraWritesEnabled = (_a$2 = AWSProviderSettings.adHocInfraWritesEnabled) != null ? _a$2 : true;
  AWSProviderSettings.resetToOriginal = SETTINGS.resetProvider("aws");
}

const footerComponent = {
  bindings: {
    action: "&",
    isValid: "&",
    cancel: "&",
    account: "=?",
    verification: "=?"
  },
  template: `
    <div class="modal-footer">
      <user-verification account="$ctrl.account" verification="$ctrl.verification"></user-verification>
      <button type="submit" ng-click="$ctrl.action()" style="display:none"></button> <!-- Allows form submission via enter keypress-->
      <button class="btn btn-default" ng-click="$ctrl.cancel()">Cancel</button>
      <button type="submit"
              class="btn btn-primary"
              ng-click="$ctrl.action()"
              ng-disabled="!$ctrl.isValid()">
        Submit
      </button>
    </div>
  `,
  controller: () => {
  }
};
const AWS_FOOTER_COMPONENT = "spinnaker.amazon.footer";
module(AWS_FOOTER_COMPONENT, []).component("awsFooter", footerComponent);

const COMMON_MODULE = "spinnaker.amazon.common";
module(COMMON_MODULE, [AWS_FOOTER_COMPONENT]);

class AdditionalFields extends React__default.Component {
  constructor() {
    super(...arguments);
    this.handleChange = (key, value) => {
      this.props.command.termination[key] = value;
      this.forceUpdate();
    };
  }
  render() {
    var _a;
    const { command } = this.props;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group",
      style: { marginTop: "20px" }
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "well-compact alert alert-warning"
    }, /* @__PURE__ */ React__default.createElement("strong", null, "Note:"), " a rolling push only updates the", " ", /* @__PURE__ */ React__default.createElement("em", null, "launch ", Boolean((_a = AWSProviderSettings.serverGroups) == null ? void 0 : _a.enableLaunchTemplates) ? "template" : "configuration"), " ", "for the auto scaling group.", /* @__PURE__ */ React__default.createElement("br", null), " Changes to the following fields will be ignored:", /* @__PURE__ */ React__default.createElement("ul", null, /* @__PURE__ */ React__default.createElement("li", null, "Account, Region, Subnet Type"), /* @__PURE__ */ React__default.createElement("li", null, "Capacity"), /* @__PURE__ */ React__default.createElement("li", null, "Load Balancers"), /* @__PURE__ */ React__default.createElement("li", null, "Health Check Configuration"), /* @__PURE__ */ React__default.createElement("li", null, "Termination Policies, Enable Traffic flag"))), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12 checkbox"
    }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
      type: "checkbox",
      checked: command.termination.relaunchAllInstances,
      onChange: (e) => this.handleChange("relaunchAllInstances", e.target.checked)
    }), /* @__PURE__ */ React__default.createElement("b", null, "Relaunch all instances"), /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "strategy.rollingPush.relaunchAll"
    })))), !command.termination.relaunchAllInstances && /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-5 sm-label-right"
    }, "Total relaunches", /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "strategy.rollingPush.totalRelaunches"
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-2"
    }, /* @__PURE__ */ React__default.createElement("input", {
      className: "form-control input-sm",
      type: "number",
      value: command.termination.totalRelaunches,
      onChange: (e) => this.handleChange("totalRelaunches", e.target.value),
      min: "0"
    }))), (command.termination.totalRelaunches > 0 || command.termination.relaunchAllInstances) && /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-5 sm-label-right"
    }, "Concurrent relaunches", /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "strategy.rollingPush.concurrentRelaunches"
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-2"
    }, /* @__PURE__ */ React__default.createElement("input", {
      className: "form-control input-sm",
      type: "number",
      value: command.termination.concurrentRelaunches,
      onChange: (e) => this.handleChange("concurrentRelaunches", e.target.value),
      min: "1"
    }))), (command.termination.totalRelaunches > 0 || command.termination.relaunchAllInstances) && /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-5 sm-label-right"
    }, "Order", /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "strategy.rollingPush.order"
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-3"
    }, /* @__PURE__ */ React__default.createElement("select", {
      className: "input input-sm",
      style: { width: "100px" },
      value: command.termination.order,
      onChange: (e) => this.handleChange("order", e.target.value)
    }, /* @__PURE__ */ React__default.createElement("option", {
      value: "oldest"
    }, "oldest first"), /* @__PURE__ */ React__default.createElement("option", {
      value: "newest"
    }, "newest first")))));
  }
}

var _a$1;
DeploymentStrategyRegistry.registerStrategy({
  label: "Rolling Push (not recommended)",
  description: `Updates the launch ${((_a$1 = AWSProviderSettings.serverGroups) == null ? void 0 : _a$1.enableLaunchTemplates) ? "template" : "configuration"} for this server group, then terminates instances incrementally,
    replacing them with instances launched with the updated configuration. This is not a best practice - it goes against
    the principles of immutable infrastructure - but may be necessary in some cases.`,
  key: "rollingpush",
  providerRestricted: true,
  additionalFields: [
    "termination.totalRelaunches",
    "termination.concurrentRelaunches",
    "termination.order",
    "termination.relaunchAllInstances"
  ],
  AdditionalFieldsComponent: AdditionalFields,
  initializationMethod: (command) => {
    var _a2, _b;
    command.termination = command.termination || {
      order: "oldest",
      relaunchAllInstances: true,
      concurrentRelaunches: 1,
      totalRelaunches: (_b = Number((_a2 = command == null ? void 0 : command.capacity) == null ? void 0 : _a2.max)) != null ? _b : 1
    };
  }
});

class AwsFunctionTransformer {
  constructor() {
    this.convertFunctionForEditing = (functionDef) => ({
      ...functionDef,
      envVariables: functionDef.environment ? functionDef.environment.variables : {},
      credentials: functionDef.account,
      tracingConfig: {
        mode: functionDef.tracingConfig ? functionDef.tracingConfig.mode : ""
      },
      deadLetterConfig: {
        targetArn: functionDef.deadLetterConfig ? functionDef.deadLetterConfig.targetArn : ""
      },
      KMSKeyArn: functionDef.kmskeyArn ? functionDef.kmskeyArn : "",
      subnetIds: functionDef.vpcConfig ? functionDef.vpcConfig.subnetIds : [],
      securityGroupIds: functionDef.vpcConfig ? functionDef.vpcConfig.securityGroupIds : [],
      vpcId: functionDef.vpcConfig ? functionDef.vpcConfig.vpcId : "",
      operation: "",
      cloudProvider: functionDef.cloudProvider,
      region: functionDef.region,
      targetGroups: isEmpty(functionDef.targetGroups) ? "" : functionDef.targetGroups
    });
  }
  normalizeFunction(functionDef) {
    const normalizedFunctionDef = functionDef;
    normalizedFunctionDef.credentials = functionDef.account;
    return normalizedFunctionDef;
  }
  constructNewAwsFunctionTemplate(application) {
    const defaultCredentials = application.defaultCredentials.aws || AWSProviderSettings.defaults.account;
    const defaultRegion = application.defaultRegions.aws || AWSProviderSettings.defaults.region;
    return {
      role: "",
      runtime: "",
      s3bucket: "",
      s3key: "",
      handler: "",
      functionName: "",
      publish: false,
      tags: {},
      memorySize: 128,
      description: "",
      credentials: defaultCredentials,
      cloudProvider: "aws",
      detail: "",
      region: defaultRegion,
      envVariables: {},
      tracingConfig: {
        mode: "PassThrough"
      },
      kmskeyArn: "",
      vpcId: "",
      subnetIds: [],
      securityGroupIds: [],
      timeout: 3,
      deadLetterConfig: {
        targetArn: ""
      },
      operation: "",
      targetGroups: ""
    };
  }
}

const iamRoleValidator = (value, label) => {
  const isIAMRole = value.match(/^arn:aws:iam::\d{12}:role\/?\/[a-zA-Z_0-9+=,.@\-_/]+/);
  return isIAMRole ? void 0 : `Invalid role.  ${label} must match regular expression: arn:aws:iam::d{12}:role/?[a-zA-Z_0-9+=,.@-_/]+`;
};
const s3BucketNameValidator = (value, label) => {
  const s3BucketName = value.match(/^[0-9A-Za-z.-]*[^.]$/);
  const err = s3BucketName ? void 0 : `Invalid S3 Bucket name.  ${label} must match regular expression: [0-9A-Za-z.-]*[^.]$`;
  return err;
};
const awsArnValidator = (value, label) => {
  const arn = value.match(/arn:aws[a-zA-Z-]?:[a-zA-Z_0-9.-]+:./);
  return arn ? void 0 : `Invalid ARN.  ${label} must match regular expression: /arn:aws[a-zA-Z-]?:[a-zA-Z_0-9.-]+:./`;
};
const awsTagsValidator = (value, label) => {
  return isEmpty(value) ? `At least one ${label} is required` : void 0;
};

class ExecutionRole extends React__default.Component {
  constructor(props) {
    super(props);
  }
  validate(values) {
    const validator = new FormValidator(values);
    validator.field("role", "Role ARN").required().withValidators(iamRoleValidator);
    return validator.validateForm();
  }
  render() {
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-11"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "sp-margin-m-bottom"
    }, /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "role",
      label: "Role ARN",
      input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
        ...props,
        placeholder: "Enter role ARN",
        name: "role"
      }),
      required: true
    }))));
  }
}

const availableRuntimes = [
  "nodejs10.x",
  "nodejs12.x",
  "java8",
  "java11",
  "python2.7",
  "python3.6",
  "python3.7",
  "python3.8",
  "dotnetcore2.1",
  "dotnetcore3.1",
  "go1.x",
  "ruby2.5",
  "ruby2.7",
  "provided"
];
class FunctionBasicInformation extends React__default.Component {
  constructor() {
    super(...arguments);
    this.state = {
      accounts: [],
      existingFunctionNames: [],
      regions: []
    };
    this.props$ = new Subject();
    this.destroy$ = new Subject();
  }
  validate(values) {
    const validator = new FormValidator(values);
    validator.field("s3bucket", "S3 Bucket Name").optional().withValidators(s3BucketNameValidator);
    const errors = validator.validateForm();
    if (this.props.isNew && this.state.existingFunctionNames.includes(this.props.app.name.concat("-").concat(values.functionName))) {
      errors.functionName = `There is already a function in ${values.credentials}:${values.region} with that name.`;
    }
    return errors;
  }
  componentDidUpdate() {
    this.props$.next(this.props);
  }
  componentWillUnmount() {
    this.destroy$.next();
  }
  componentDidMount() {
    const formValues$ = this.props$.pipe(map((props) => props.formik.values));
    const form = {
      account$: formValues$.pipe(map((x) => x.credentials), distinctUntilChanged()),
      region$: formValues$.pipe(map((x) => x.region), distinctUntilChanged()),
      functionName$: formValues$.pipe(map((x) => x.functionName), distinctUntilChanged()),
      runtime$: formValues$.pipe(map((x) => x.runtime), distinctUntilChanged()),
      s3bucket$: formValues$.pipe(map((x) => x.s3bucket), distinctUntilChanged()),
      s3key$: formValues$.pipe(map((x) => x.s3key), distinctUntilChanged()),
      handler$: formValues$.pipe(map((x) => x.handler), distinctUntilChanged())
    };
    const allAccounts$ = from(AccountService.listAccounts("aws")).pipe(shareReplay(1));
    const accountRegions$ = combineLatest([form.account$, allAccounts$]).pipe(switchMap(([currentAccount, _allAccounts]) => AccountService.getRegionsForAccount(currentAccount)), shareReplay(1));
    const allFunctions$ = this.props.app.getDataSource("functions").data$;
    const regionfunctions$ = combineLatest([allFunctions$, form.account$, form.region$]).pipe(map(([allFunctions, currentAccount, currentRegion]) => {
      return allFunctions.filter((fn) => fn.account === currentAccount && fn.region === currentRegion).map((fn) => fn.functionName);
    }), shareReplay(1));
    accountRegions$.pipe(withLatestFrom(form.region$), takeUntil(this.destroy$)).subscribe(([accountRegions, selectedRegion]) => {
      if (!accountRegions.some((x) => x.name === selectedRegion)) {
        this.props.formik.setFieldValue("region", accountRegions[0] && accountRegions[0].name);
      }
    });
    combineLatest([allAccounts$, accountRegions$, regionfunctions$]).pipe(takeUntil(this.destroy$)).subscribe(([accounts, regions, existingFunctionNames]) => {
      return this.setState({ accounts, regions, existingFunctionNames });
    });
  }
  render() {
    const { isNew } = this.props;
    const { errors, values } = this.props.formik;
    const { accounts, regions } = this.state;
    const className = classNames({
      well: true,
      "alert-danger": !!errors.functionName,
      "alert-info": !errors.functionName
    });
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "container-fluid form-horizontal "
    }, isNew && /* @__PURE__ */ React__default.createElement("div", {
      className
    }, /* @__PURE__ */ React__default.createElement("strong", null, "Your function will be named: "), /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "aws.function.name"
    }), /* @__PURE__ */ React__default.createElement("span", null, this.props.app.name, "-", values.functionName), /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "functionName",
      input: () => null
    })), /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "credentials",
      label: "Account",
      input: (props) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
        ...props,
        stringOptions: accounts.map((acc) => acc.name),
        clearable: true
      })
    }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "region",
      label: "Region",
      input: (props) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
        ...props,
        stringOptions: regions.map((reg) => reg.name),
        clearable: true
      })
    }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "functionName",
      label: "Function Name",
      help: /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "aws.function.name"
      }),
      input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
        ...props
      })
    }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "runtime",
      label: "Runtime",
      help: /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "aws.function.runtime"
      }),
      input: (props) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
        ...props,
        stringOptions: availableRuntimes,
        clearable: true
      })
    }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "s3bucket",
      label: "S3 Bucket",
      help: /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "aws.function.s3bucket"
      }),
      input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
        ...props,
        placeholder: "S3 bucket name"
      })
    }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "s3key",
      label: "S3 Key",
      help: /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "aws.function.s3key"
      }),
      input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
        ...props,
        placeholder: "object.zip"
      })
    }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "handler",
      label: "Handler",
      help: /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "aws.function.handler"
      }),
      input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
        ...props,
        placeholder: "filename.method"
      })
    }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "publish",
      label: "Publish",
      input: (props) => /* @__PURE__ */ React__default.createElement(CheckboxInput, {
        ...props
      })
    }));
  }
}

class FunctionDebugAndErrorHandling extends React__default.Component {
  constructor(props) {
    super(props);
    this.validate = (values) => {
      const validator = new FormValidator(values);
      validator.field("deadLetterConfig.targetArn", "Target ARN").optional().withValidators(awsArnValidator);
      return validator.validateForm();
    };
  }
  render() {
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "container-fluid form-horizontal "
    }, "Dead Letter Config", /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "deadLetterConfig.targetArn",
      label: "Target ARN",
      help: /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "aws.function.deadletterqueue"
      }),
      input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
        ...props
      })
    }), "X-Ray Tracing", /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "tracingConfig.mode",
      label: "Mode",
      help: /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "aws.function.tracingConfig.mode"
      }),
      input: (props) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
        ...props,
        stringOptions: ["Active", "PassThrough"],
        clearable: true
      })
    }));
  }
}

class FunctionEnvironmentVariables extends React__default.Component {
  constructor() {
    super(...arguments);
    this.validate = (values) => {
      const validator = new FormValidator(values);
      validator.field("kmskeyArn", "KMS Key ARN").optional().withValidators(awsArnValidator);
      return validator.validateForm();
    };
  }
  render() {
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "container-fluid form-horizontal "
    }, /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "envVariables",
      label: "Env Variables",
      input: (props) => /* @__PURE__ */ React__default.createElement(MapEditorInput, {
        ...props,
        allowEmptyValues: true,
        addButtonLabel: "Add"
      })
    }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "kmskeyArn",
      label: "Key ARN",
      help: /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "aws.function.kmsKeyArn"
      }),
      input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
        ...props
      })
    }));
  }
}

class FunctionSettings extends React__default.Component {
  constructor() {
    super(...arguments);
    this.validate = () => {
      const errors = {};
      return errors;
    };
  }
  render() {
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "container-fluid form-horizontal "
    }, /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "description",
      label: "Description",
      input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
        ...props
      })
    }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "memorySize",
      label: "Memory (MB)",
      help: /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "aws.functionBasicSettings.memorySize"
      }),
      input: (props) => /* @__PURE__ */ React__default.createElement(NumberInput, {
        ...props,
        min: 128,
        max: 3008
      })
    }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "timeout",
      label: "Timeout (seconds)",
      help: /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "aws.functionBasicSettings.timeout"
      }),
      input: (props) => /* @__PURE__ */ React__default.createElement(NumberInput, {
        ...props,
        min: 1,
        max: 900
      })
    }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "targetGroups",
      label: "Target Group Name",
      input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
        ...props
      })
    }));
  }
}

class FunctionTags extends React__default.Component {
  constructor() {
    super(...arguments);
    this.validate = (values) => {
      const validator = new FormValidator(values);
      validator.field("tags", "Tag").required().withValidators(awsTagsValidator);
      return validator.validateForm();
    };
  }
  render() {
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "container-fluid form-horizontal "
    }, /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "tags",
      input: (props) => /* @__PURE__ */ React__default.createElement(MapEditorInput, {
        ...props,
        allowEmptyValues: false,
        addButtonLabel: "Add"
      })
    }));
  }
}

class VpcReader {
  static listVpcs() {
    if (this.cache) {
      return this.cache;
    }
    this.cache = NetworkReader.listNetworksByProvider("aws").then((vpcs) => {
      return vpcs.map((vpc) => {
        vpc.label = vpc.name;
        vpc.deprecated = !!vpc.deprecated;
        if (vpc.deprecated) {
          vpc.label += " (deprecated)";
        }
        return vpc;
      });
    });
    return this.cache;
  }
  static resetCache() {
    this.cache = null;
  }
  static getVpcName(id) {
    return this.listVpcs().then((vpcs) => {
      const match = vpcs.find((test) => {
        return test.id === id;
      });
      return match ? match.name : null;
    });
  }
}

class Network extends React__default.Component {
  constructor(props) {
    super(props);
    this.state = {
      vpcOptions: [],
      accounts: null,
      regions: [],
      subnets: [],
      availableSubnets: [],
      securityGroups: null
    };
    this.props$ = new Subject();
    this.destroy$ = new Subject();
    this.handleSubnetUpdate = (options) => {
      const subnetsSelected = options.map((o) => o.value);
      this.props.formik.setFieldValue("subnetIds", subnetsSelected);
    };
    this.handleSecurityGroupsUpdate = (options) => {
      const sgSelected = options.map((o) => o.value);
      this.props.formik.setFieldValue("securityGroupIds", sgSelected);
    };
    this.setVpc = (vpcId) => {
      this.props.formik.setFieldValue("vpcId", vpcId);
      this.props.formik.setFieldValue("subnetIds", []);
      const { availableSubnets } = this.state;
      const subs = availableSubnets.filter(function(s) {
        return s.vpcId.includes(vpcId);
      });
      this.setState({ subnets: subs });
    };
    this.toSubnetOption = (value) => {
      return { value: value.subnetId, label: value.subnetId };
    };
    this.getSecurityGroupsByVpc = (sgs) => {
      const { values } = this.props.formik;
      const sgOptions = [];
      forOwn(sgs, function(sgByAccount, acc) {
        if (acc === values.credentials) {
          forOwn(sgByAccount, function(sgByRegion, provider) {
            if (provider === "aws") {
              forOwn(sgByRegion, function(groups, region) {
                if (region === values.region) {
                  groups.forEach(function(group) {
                    if (group.vpcId === values.vpcId) {
                      sgOptions.push({ value: group.id, label: group.name });
                    }
                  });
                }
              });
            }
          });
        }
      });
      return sgOptions;
    };
    this.getSubnetOptions = () => {
      const { subnets, availableSubnets } = this.state;
      const { values } = this.props.formik;
      if (!this.props.isNew && values.vpcId) {
        return availableSubnets.filter(function(s) {
          return s.vpcId.includes(values.vpcId);
        }).map(this.toSubnetOption);
      } else {
        return subnets.map(this.toSubnetOption);
      }
    };
    this.getAllVpcs();
  }
  getAllVpcs() {
    from(VpcReader.listVpcs()).pipe(takeUntil(this.destroy$)).subscribe((Vpcs) => {
      this.setState({ vpcOptions: Vpcs });
    });
  }
  validate() {
    return {};
  }
  getAvailableSubnets() {
    return SubnetReader.listSubnetsByProvider("aws");
  }
  getAvailableSecurityGroups() {
    return ReactInjector.securityGroupReader.getAllSecurityGroups();
  }
  makeSubnetOptions(availableSubnets) {
    const subOptions = availableSubnets.map((s) => ({ subnetId: s.id, vpcId: s.vpcId }));
    const uniqueSubOptions = uniqBy(subOptions, "subnetId");
    return uniqueSubOptions;
  }
  componentDidUpdate() {
    this.props$.next(this.props);
  }
  componentWillUnmount() {
    this.destroy$.next();
  }
  componentDidMount() {
    const allSubnets = Promise.resolve(this.getAvailableSubnets()).then((subnets) => {
      subnets.forEach((subnet) => {
        subnet.label = subnet.id;
        subnet.deprecated = !!subnet.deprecated;
        if (subnet.deprecated) {
          subnet.label += " (deprecated)";
        }
      });
      return subnets.filter((s) => s.label);
    }).then((subnets) => {
      return this.makeSubnetOptions(subnets);
    });
    const secGroups$ = Promise.resolve(this.getAvailableSecurityGroups());
    combineLatest([allSubnets, secGroups$]).pipe(takeUntil(this.destroy$)).subscribe(([availableSubnets, securityGroups]) => {
      return this.setState({ availableSubnets, securityGroups });
    });
  }
  render() {
    const { vpcOptions, securityGroups } = this.state;
    const { values } = this.props.formik;
    const subnetOptions = this.getSubnetOptions();
    const sgOptions = securityGroups ? this.getSecurityGroupsByVpc(securityGroups) : [];
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-11"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "sp-margin-m-bottom"
    }, values.credentials && /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "vpcId",
      label: "VPC Id",
      help: /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "aws.function.vpc.id"
      }),
      input: (props) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
        ...props,
        stringOptions: vpcOptions.filter((v) => v.account === values.credentials).map((v) => v.id),
        clearable: true
      }),
      onChange: this.setVpc,
      required: false
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-4 sm-label-right"
    }, /* @__PURE__ */ React__default.createElement("b", null, "Subnets "), /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "aws.function.subnet"
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-7"
    }, subnetOptions.length === 0 && /* @__PURE__ */ React__default.createElement("div", {
      className: "form-control-static"
    }, "No subnets found in the selected account/region/VPC"), values.vpcId ? /* @__PURE__ */ React__default.createElement(TetheredSelect, {
      multi: true,
      options: subnetOptions,
      value: values.subnetIds,
      onChange: this.handleSubnetUpdate
    }) : null)), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-4 sm-label-right"
    }, /* @__PURE__ */ React__default.createElement("b", null, "Security Groups "), /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "aws.function.subnet"
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-7"
    }, sgOptions.length === 0 && /* @__PURE__ */ React__default.createElement("div", {
      className: "form-control-static"
    }, "No security groups found in the selected account/region/VPC"), values.credentials && values.vpcId ? /* @__PURE__ */ React__default.createElement(TetheredSelect, {
      multi: true,
      options: sgOptions,
      value: values.securityGroupIds,
      onChange: this.handleSecurityGroupsUpdate
    }) : null))));
  }
}

const _CreateLambdaFunction = class extends React__default.Component {
  constructor(props) {
    super(props);
    this._isUnmounted = false;
    this.submit = (values) => {
      const { app } = this.props;
      const { isNew } = this.state;
      const functionCommandFormatted = cloneDeep(values);
      const descriptor = isNew ? "Create" : "Update";
      const taskMonitor = new TaskMonitor({
        application: app,
        title: `${isNew ? "Creating" : "Updating"} your function`,
        modalInstance: TaskMonitor.modalInstanceEmulation(() => this.props.dismissModal()),
        onTaskComplete: () => {
          this.checkForS3Update(functionCommandFormatted, descriptor);
        }
      });
      taskMonitor.submit(() => {
        functionCommandFormatted.type = "lambdaFunction";
        if (!isNew) {
          functionCommandFormatted.operation = "updateLambdaFunctionConfiguration";
        } else {
          functionCommandFormatted.operation = "createLambdaFunction";
        }
        return FunctionWriter.upsertFunction(functionCommandFormatted, app, descriptor);
      });
      this.setState({ taskMonitor });
    };
    const functionTransformer = new AwsFunctionTransformer();
    const funcCommand = props.functionDef ? functionTransformer.convertFunctionForEditing(props.functionDef) : functionTransformer.constructNewAwsFunctionTemplate(props.app);
    this.state = {
      isNew: !props.functionDef,
      functionCommand: funcCommand,
      taskMonitor: null
    };
  }
  static show(props) {
    const modalProps = { dialogClassName: "wizard-modal modal-lg" };
    return ReactModal.show(_CreateLambdaFunction, props, modalProps);
  }
  componentWillUnmount() {
    this._isUnmounted = true;
    if (this.refreshUnsubscribe) {
      this.refreshUnsubscribe();
    }
  }
  onApplicationRefresh(values) {
    if (this._isUnmounted) {
      return;
    }
    this.refreshUnsubscribe = void 0;
    this.props.dismissModal();
    this.setState({ taskMonitor: void 0 });
    const newStateParams = {
      name: values.name,
      accountId: values.credentials,
      region: values.region,
      vpcId: values.vpcId,
      provider: "aws"
    };
    if (!ReactInjector.$state.includes("**.functionDetails")) {
      ReactInjector.$state.go(".functionDetails", newStateParams);
    } else {
      ReactInjector.$state.go("^.functionDetails", newStateParams);
    }
  }
  onTaskComplete(values) {
    this.props.app.functions.refresh();
    this.refreshUnsubscribe = this.props.app.functions.onNextRefresh(null, () => this.onApplicationRefresh(values));
  }
  checkForS3Update(functionCommandFormatted, descriptor) {
    const { isNew } = this.state;
    if (!isNew && (functionCommandFormatted.s3bucket || functionCommandFormatted.s3key)) {
      functionCommandFormatted.operation = "updateLambdaFunctionCode";
      const { app } = this.props;
      FunctionWriter.upsertFunction(functionCommandFormatted, app, descriptor);
    }
    this.onTaskComplete(functionCommandFormatted);
  }
  render() {
    const { app, dismissModal, forPipelineConfig, functionDef } = this.props;
    const { isNew, functionCommand, taskMonitor } = this.state;
    let heading = forPipelineConfig ? "Configure Existing Function" : "Create New Function";
    if (!isNew) {
      heading = `Edit ${functionCommand.functionName}: ${functionCommand.region}: ${functionCommand.credentials}`;
    }
    return /* @__PURE__ */ React__default.createElement(WizardModal, {
      heading,
      initialValues: functionCommand,
      taskMonitor,
      dismissModal,
      closeModal: this.submit,
      submitButtonLabel: forPipelineConfig ? isNew ? "Add" : "Done" : isNew ? "Create" : "Update",
      render: ({ formik, nextIdx, wizard }) => {
        return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(WizardPage, {
          label: "Basic information",
          wizard,
          order: nextIdx(),
          render: ({ innerRef }) => /* @__PURE__ */ React__default.createElement(FunctionBasicInformation, {
            ref: innerRef,
            app,
            formik,
            isNew,
            functionDef
          })
        }), /* @__PURE__ */ React__default.createElement(WizardPage, {
          label: "Execution Role",
          wizard,
          order: nextIdx(),
          render: ({ innerRef }) => {
            return /* @__PURE__ */ React__default.createElement(ExecutionRole, {
              ref: innerRef,
              formik,
              isNew,
              functionDef
            });
          }
        }), /* @__PURE__ */ React__default.createElement(WizardPage, {
          label: "Environment",
          wizard,
          order: nextIdx(),
          render: ({ innerRef }) => {
            return /* @__PURE__ */ React__default.createElement(FunctionEnvironmentVariables, {
              ref: innerRef,
              formik,
              isNew,
              functionDef
            });
          }
        }), /* @__PURE__ */ React__default.createElement(WizardPage, {
          label: "Tags",
          wizard,
          order: nextIdx(),
          render: ({ innerRef }) => {
            return /* @__PURE__ */ React__default.createElement(FunctionTags, {
              ref: innerRef,
              formik,
              isNew,
              functionDef
            });
          }
        }), /* @__PURE__ */ React__default.createElement(WizardPage, {
          label: "Settings",
          wizard,
          order: nextIdx(),
          render: ({ innerRef }) => {
            return /* @__PURE__ */ React__default.createElement(FunctionSettings, {
              ref: innerRef,
              formik,
              isNew,
              functionDef
            });
          }
        }), /* @__PURE__ */ React__default.createElement(WizardPage, {
          label: "Network",
          wizard,
          order: nextIdx(),
          render: ({ innerRef }) => {
            return /* @__PURE__ */ React__default.createElement(Network, {
              ref: innerRef,
              app,
              formik,
              isNew
            });
          }
        }), /* @__PURE__ */ React__default.createElement(WizardPage, {
          label: "Debugging and Error Handling",
          wizard,
          order: nextIdx(),
          render: ({ innerRef }) => {
            return /* @__PURE__ */ React__default.createElement(FunctionDebugAndErrorHandling, {
              ref: innerRef,
              formik,
              isNew,
              functionDef
            });
          }
        }));
      }
    });
  }
};
let CreateLambdaFunction = _CreateLambdaFunction;
CreateLambdaFunction.defaultProps = {
  closeModal: noop,
  dismissModal: noop
};

class FunctionActions extends React__default.Component {
  constructor(props) {
    super(props);
    this.editFunction = () => {
      const { functionDef } = this.props;
      const { application } = this.state;
      const FunctionModal = CreateLambdaFunction;
      FunctionModal.show({ app: application, functionDef });
    };
    this.deleteFunction = () => {
      const { app, functionDef, functionFromParams } = this.props;
      const taskMonitor = {
        application: app,
        title: "Deleting " + functionFromParams.functionName
      };
      const command = {
        cloudProvider: functionDef.cloudProvider,
        functionName: functionDef.functionName,
        region: functionDef.region,
        credentials: functionDef.credentials
      };
      const submitMethod = () => FunctionWriter.deleteFunction(command, app);
      ConfirmationModalService.confirm({
        header: `Really delete ${functionFromParams.functionName} in ${functionFromParams.region}: ${functionFromParams.account}?`,
        buttonText: `Delete ${functionFromParams.functionName}`,
        account: functionFromParams.account,
        taskMonitorConfig: taskMonitor,
        submitMethod
      });
    };
    this.entityTagUpdate = () => {
      this.props.app.functions.refresh();
    };
    this.state = { application: props.app };
  }
  componentDidMount() {
    const { app, functionDef } = this.props;
    let application;
    const functionAppName = functionDef.functionName.split("-")[0];
    if (functionAppName === app.name) {
      application = app;
    } else {
      ApplicationReader.getApplication(functionAppName).then((functionApp) => {
        this.setState({ application: functionApp });
      }).catch(() => {
        this.setState({ application: this.props.app });
      });
    }
    this.setState({
      application
    });
  }
  render() {
    const { app, functionDef } = this.props;
    const { application } = this.state;
    return /* @__PURE__ */ React__default.createElement("div", {
      style: { display: "inline-block" }
    }, AWSProviderSettings.adHocInfraWritesEnabled && /* @__PURE__ */ React__default.createElement(Dropdown, {
      className: "dropdown",
      id: "function-actions-dropdown"
    }, /* @__PURE__ */ React__default.createElement(Dropdown.Toggle, {
      className: "btn btn-sm btn-primary dropdown-toggle"
    }, /* @__PURE__ */ React__default.createElement("span", null, "Function Actions")), /* @__PURE__ */ React__default.createElement(Dropdown.Menu, {
      className: "dropdown-menu"
    }, /* @__PURE__ */ React__default.createElement("li", {
      className: !application ? "disabled" : ""
    }, /* @__PURE__ */ React__default.createElement("a", {
      className: "clickable",
      onClick: this.editFunction
    }, "Edit Function")), functionDef.functionName && /* @__PURE__ */ React__default.createElement("li", null, /* @__PURE__ */ React__default.createElement("a", {
      className: "clickable",
      onClick: this.deleteFunction
    }, "Delete Function")), SETTINGS && SETTINGS.feature.entityTags && /* @__PURE__ */ React__default.createElement(AddEntityTagLinks, {
      component: functionDef,
      application: app,
      entityType: "function",
      onUpdate: this.entityTagUpdate
    }))));
  }
}

class AwsReactInject extends ReactInject {
  get awsInstanceTypeService() {
    return this.$injector.get("awsInstanceTypeService");
  }
  get awsServerGroupCommandBuilder() {
    return this.$injector.get("awsServerGroupCommandBuilder");
  }
  get awsServerGroupConfigurationService() {
    return this.$injector.get("awsServerGroupConfigurationService");
  }
  get awsServerGroupTransformer() {
    return this.$injector.get("awsServerGroupTransformer");
  }
  get functionReader() {
    return this.$injector.get("functionReader");
  }
  get evaluateCloudFormationChangeSetExecutionService() {
    return this.$injector.get("evaluateCloudFormationChangeSetExecutionService");
  }
  initialize($injector) {
    this.$injector = $injector;
  }
}
const AwsReactInjector = new AwsReactInject();

var __defProp$8 = Object.defineProperty;
var __getOwnPropDesc$8 = Object.getOwnPropertyDescriptor;
var __decorateClass$8 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$8(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$8(target, key, result);
  return result;
};
let AmazonFunctionDetails = class extends React__default.Component {
  constructor(props) {
    super(props);
    this.destroy$ = new Subject();
    this.state = {
      loading: true
    };
  }
  extractFunction() {
    const { app, functionObj: functionFromProps } = this.props;
    const functionDef = app.functions.data.find((test) => {
      return test.functionName === functionFromProps.functionName && test.region === functionFromProps.region && test.account === functionFromProps.account;
    });
    if (functionDef) {
      from(AwsReactInjector.functionReader.getFunctionDetails("aws", functionFromProps.account, functionFromProps.region, functionFromProps.functionName)).pipe(takeUntil(this.destroy$)).subscribe((details) => {
        if (details.length) {
          this.setState({
            functionDef: details[0],
            loading: false
          });
        }
      });
    } else {
      this.setState({
        functionDef: {},
        loading: false
      });
    }
  }
  componentDidMount() {
    const { app } = this.props;
    const dataSource = app.functions;
    from(dataSource.ready()).pipe(takeUntil(this.destroy$)).subscribe(() => {
      const dataSourceUnsubscribe = dataSource.onRefresh(null, () => this.extractFunction());
      this.setState({ dataSourceUnsubscribe });
      this.extractFunction();
    });
  }
  componentWillUnmount() {
    this.state.dataSourceUnsubscribe && this.state.dataSourceUnsubscribe();
    this.destroy$.next();
  }
  render() {
    const { app } = this.props;
    const { loading, functionDef } = this.state;
    if (loading) {
      return /* @__PURE__ */ React__default.createElement(Details, {
        loading
      });
    }
    const functionDetails = /* @__PURE__ */ React__default.createElement("dl", {
      className: "horizontal-when-filters-collapsed dl-horizontal dl-narrow"
    }, /* @__PURE__ */ React__default.createElement("dt", null, "Last Modified "), /* @__PURE__ */ React__default.createElement("dd", null, functionDef.lastModified), /* @__PURE__ */ React__default.createElement("dt", null, "In"), /* @__PURE__ */ React__default.createElement("dd", null, /* @__PURE__ */ React__default.createElement(AccountTag, {
      account: functionDef.account
    }), " ", functionDef.region), /* @__PURE__ */ React__default.createElement("dt", null, "VPC"), /* @__PURE__ */ React__default.createElement("dd", null, functionDef.vpcConfig ? functionDef.vpcConfig.vpcId : "Default"), /* @__PURE__ */ React__default.createElement("dt", null, "Function ARN"), /* @__PURE__ */ React__default.createElement("dd", null, functionDef.functionArn), /* @__PURE__ */ React__default.createElement("dt", null, "Revision ID"), /* @__PURE__ */ React__default.createElement("dd", null, functionDef.revisionId), /* @__PURE__ */ React__default.createElement("dt", null, "Version"), /* @__PURE__ */ React__default.createElement("dd", null, functionDef.version));
    const eventSourceDetails = /* @__PURE__ */ React__default.createElement("dl", {
      className: "horizontal-when-filters-collapsed dl-horizontal dl-narrow"
    }, functionDef.eventSourceMappings && functionDef.eventSourceMappings.length !== 0 ? functionDef.eventSourceMappings.map((value) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("h5", null, /* @__PURE__ */ React__default.createElement("strong", null, "Event Source")), /* @__PURE__ */ React__default.createElement("dl", null, /* @__PURE__ */ React__default.createElement("dt", null, "ARN"), /* @__PURE__ */ React__default.createElement("dd", null, value.eventSourceArn), /* @__PURE__ */ React__default.createElement("dt", null, "State"), /* @__PURE__ */ React__default.createElement("dd", null, value.state)))) : "None");
    const aliasConfigurationDetails = /* @__PURE__ */ React__default.createElement("dl", {
      className: "horizontal-when-filters-collapsed dl-horizontal dl-narrow"
    }, functionDef.aliasConfigurations && functionDef.aliasConfigurations.length !== 0 ? functionDef.aliasConfigurations.map((value) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("h5", null, /* @__PURE__ */ React__default.createElement("strong", null, "Alias Details")), /* @__PURE__ */ React__default.createElement("dl", null, /* @__PURE__ */ React__default.createElement("dt", null, "Name"), /* @__PURE__ */ React__default.createElement("dd", null, value.name), /* @__PURE__ */ React__default.createElement("dt", null, "ARN"), /* @__PURE__ */ React__default.createElement("dd", null, value.aliasArn)))) : "None");
    const functionDetailsSection = /* @__PURE__ */ React__default.createElement(CollapsibleSection, {
      heading: "Function Details"
    }, functionDetails);
    const eventSourceDetailsSection = /* @__PURE__ */ React__default.createElement(CollapsibleSection, {
      heading: "Event Source Details"
    }, eventSourceDetails);
    const aliasConfigurationDetailsSection = /* @__PURE__ */ React__default.createElement(CollapsibleSection, {
      heading: "Alias Configuration Details"
    }, aliasConfigurationDetails);
    return /* @__PURE__ */ React__default.createElement(Details, {
      loading: this.state.loading
    }, isEmpty(this.state.functionDef) ? "Function not found." : /* @__PURE__ */ React__default.createElement(Details.Header, {
      icon: /* @__PURE__ */ React__default.createElement("i", {
        className: "fa fa-xs fa-fw fa-asterisk"
      }),
      name: this.state.functionDef.functionName
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "actions"
    }, /* @__PURE__ */ React__default.createElement(FunctionActions, {
      app,
      functionDef,
      functionFromParams: {
        account: this.state.functionDef.account,
        region: this.state.functionDef.region,
        functionName: this.state.functionDef.functionName
      }
    }))), !isEmpty(this.state.functionDef) ? functionDetailsSection : "", !isEmpty(this.state.functionDef) && !isEmpty(this.state.functionDef.eventSourceMappings) ? eventSourceDetailsSection : "", !isEmpty(this.state.functionDef) && !isEmpty(this.state.functionDef.aliasConfigurations) ? aliasConfigurationDetailsSection : "");
  }
};
AmazonFunctionDetails = __decorateClass$8([
  Overrides("function.details", "aws")
], AmazonFunctionDetails);

const AWS_FUNCTION_MODULE = "spinnaker.amazon.function";
module(AWS_FUNCTION_MODULE, []);

const helpContents = {
  "aws.associateElasticIp.elasticIp": `<p>(Optional) <b>Elastic IP</b> is an IP address that Spinnaker will associate with this cluster.</p>
     <p>If specified, this elastic IP must exist and not already be attached to an instance or cluster.</p>
     <p>If left blank, Spinnaker will make a selection from the list of available elastic IPs in the provided account and region.</p>`,
  "aws.associateElasticIp.type": `<p><b>Type</b> of elastic IP to associate:'
      <ul>
        <li><b>standard</b> is usable in EC2 Classic</li>
        <li><b>vpc</b> is usable in VPC</li>
      </ul>`,
  "aws.serverGroup.subnet": `The subnet selection determines the VPC in which your server group will run. Options vary by account and region; the most common ones are:
      <ul>
        <li><b>None (EC2 Classic)</b>: instances will not run in a VPC</li>
        <li><b>internal</b> instances will be restricted to internal clients (i.e. require VPN access)</li>
        <li><b>external</b> instances will be publicly accessible and running in VPC</li>
      </ul>`,
  "aws.loadBalancer.subnet": `The subnet selection determines the VPC in which your load balancer will run.<br/>
     This also restricts the server groups which can be serviced by the load balancer.
     Options vary by account and region; the most common ones are:
     <ul>
      <li><b>None (EC2 Classic)</b>: the load balancer will not run in a VPC</li>
      <li><b>internal</b> access to the load balancer will be restricted to internal clients (i.e. require VPN access)</li>
      <li><b>external</b> the load balancer will be publicly accessible and running in VPC</li>
    </ul>`,
  "aws.loadBalancer.detail": `<p>(Optional) <b>Detail</b> is a string of free-form alphanumeric characters; by convention, we recommend using "frontend".</p>
     <p>However, if your stack name needs to be longer (load balancer names are limited to 32 characters), consider changing it to "elb", or omit it altogether.</p>`,
  "aws.loadBalancer.internal": "Controls the load balancer scheme, <strong>not</strong> the subnet. By default, load balancers are created with a DNS name that resolves to public IP addresses. Specify internal to create a load balancer with a DNS name that resolves to private IP addresses.",
  "aws.loadBalancer.stack": "(Optional) <b>Stack</b> is one of the core naming components of a cluster, used to create vertical stacks of dependent services for integration testing.",
  "aws.loadBalancer.name": "<p>The load balancer name is formed by combining the application name, the <b>Stack</b> field, and the <b>Detail</b> field.</p>",
  "aws.loadBalancer.targetGroups": "Add a target group if you want to associate this with an Application Load Balancer (ALB) or Network Load Balancer (NLB)",
  "aws.loadBalancer.loadBalancers": "Add a load balancer directly if you created a Classic Load Balancer (a classic load balancer does not have target groups)",
  "aws.loadBalancer.ruleCondition.host": `<p>You can specify a single host name (for example, <em>my.example.com</em>). A host name is case insensitive, can be up to 128 characters in length, and can contain any of the following characters. Note that you can include up to three wildcard characters.</p>
      <ul>
        <li>A-Z, a-z, 0-9</li>
        <li>- .</li>
        <li>* (matches 0 or more characters)</li>
        <li>? (matches exactly 1 character)</li>
      </ul>
     <p>Note that <strong>*.example.com</strong> will match <strong>test.example.com</strong> but won't match <strong>example.com</strong>.</p>`,
  "aws.loadBalancer.ruleCondition.path": `<p>You can specify a single path pattern (for example, <em>/img/*</em>). A path pattern is case sensitive, can be up to 128 characters in length, and can contain any of the following characters. Note that you can include up to three wildcard characters.</p>
      <ul>
        <li>A-Z, a-z, 0-9</li>
        <li>_ - . $ / ~ " ' @ : +</li>
        <li>& (using &amp;amp;)</li>
        <li>* (matches 0 or more characters)</li>
        <li>? (matches exactly 1 character)</li>
      </ul>
      <p>Note that the path pattern is used to route requests but does not alter them. For example, if a rule has a path pattern of <em>/img/*</em>, the rule would forward a request for <em>/img/picture.jpg</em> to the specified target group as a request for <em>/img/picture.jpg</em>.</p>`,
  "aws.loadBalancer.oidcAuthentication": "Authentication requires a configured OIDC client.",
  "aws.serverGroup.stack": "(Optional) <b>Stack</b> is one of the core naming components of a cluster, used to create vertical stacks of dependent services for integration testing.",
  "aws.serverGroup.detail": "(Optional) <b>Detail</b> is a string of free-form alphanumeric characters and hyphens to describe any other variables.",
  "aws.serverGroup.imageName": "(Required) <b>Image</b> is the deployable Amazon Machine Image. Images are restricted to the account and region selected.",
  "aws.serverGroup.storageType": `AWS offers various storage options like temporary block-level storage via instance store (SSD, HDD) and Amazon Elastic Block Store (EBS). This column lists the storage type supported for the instance type.`,
  "aws.serverGroup.instancesDistribution": `Learn more in <a target="_blank" href="https://docs.aws.amazon.com/autoscaling/ec2/userguide/asg-purchase-options.html">AWS docs</a>.`,
  "aws.serverGroup.spotMaxPrice": "The maximum price per unit hour to pay for a Spot instance. By <b>default (empty)</b>, Amazon EC2 Auto Scaling uses the On-Demand price as the maximum Spot price.",
  "aws.serverGroup.spotAllocationStrategy": `<p>Indicates how to allocate instances across Spot Instance pools.</p>
      <ul>
        <li><b>capacity-optimized (recommended)</b>: Instances launched using Spot pools that are optimally chosen based on the available Spot capacity.</li>
        <li><b>capacity-optimized-prioritized</b>: Instances launched using the priority on a best-effort basis to determine which launch template override to use first, but AWS optimizes for capacity first.</li>
        <li><b>lowest-price (default)</b>: Instances launched using Spot pools with the lowest price, and evenly allocated across the number of Spot pools specified</li>
      </ul>`,
  "aws.serverGroup.spotInstancePoolCount": `Number of lowest priced Spot Instance pools to diversify across. Only applicable for strategy 'lowest-price'. <b>Default: 2.</b>`,
  "aws.serverGroup.odAllocationStrategy": `The only strategy / <b>default is 'prioritized'</b>. The order specified in the list of selected instance types is used to determine which instance type to use first when fulfilling On-Demand capacity.`,
  "aws.serverGroup.odBase": `Minimum amount of the Auto Scaling Group's capacity that must be fulfilled by On-Demand Instances. This base portion is provisioned first as the group scales. <b>Default: 0.</b>`,
  "aws.serverGroup.odPercentAboveBase": `Percentages of On-Demand and Spot instances for additional capacity beyond OnDemandBaseCapacity.<b>Default: 100.</b>`,
  "aws.serverGroup.instanceTypeWeight": `The number of capacity units gives the instance type a proportional weight to other instance types. When specified, weights count towards desired capacity.`,
  "aws.serverGroup.instanceTypes": `Specify up to 20 instance types.`,
  "aws.serverGroup.multipleInstanceTypes": `Instance types a server group can launch, first (highest priority) to last (lowest priority).`,
  "aws.serverGroup.unlimitedCpuCredits": `<p>CPU credits can be configured with 2 modes:</p><br/>
      <ul>
        <li><b>Unlimited (i.e. Unlimited On)</b>: Can sustain high CPU utilization for any period of time whenever required.<br/>
            If the average CPU usage over a rolling 24-hour period exceeds the baseline, charges for surplus credits will apply.</li>
        <li><b>Standard (i.e. Unlimited Off)</b>: <b>Default mode in Spinnaker.</b> Suited to workloads with an average CPU utilization that is consistently below the baseline CPU utilization of the instance.<br/>
            To burst above the baseline, the instance spends credits that it has accrued in its CPU credit balance.</li>
      </ul>`,
  "aws.serverGroup.capacityRebalance": `Enabling <b>Capacity Rebalance</b> allows EC2 Auto Scaling to proactively replace Spot Instances that have received a rebalance recommendation, <b>before</b> it is interrupted by AWS EC2.`,
  "aws.serverGroup.advancedMode": `Advanced mode allows you to configure allocation strategies, multiple instance types with weighting, instance distribution across Spot / On-Demand and their proportions in the server group. Learn more in <a target="_blank" href="https://docs.aws.amazon.com/autoscaling/ec2/userguide/asg-purchase-options.html">AWS docs</a>.`,
  "aws.serverGroup.legacyUdf": `<p>(Optional) <b>User Data Format</b> allows overriding of the format used when generating user data during deployment. The default format used is configured
      in the application's attributes, editable via the 'Config' tab.</p>
      <p><b>Default</b> will use the value from the application's configuration.</p>
      <p><b>Modern</b> will use the modern template.</p>
      <p><b>Legacy</b> will use the legacy (<b>deprecated</b>) template.</p>
      <p>This option is intended to allow testing migration from legacy to modern before configuring it for the entire application. If unsure, pick <b>Default</b>.</p>`,
  "aws.serverGroup.base64UserData": "(Optional) <b>UserData</b> is a base64 encoded string.",
  "aws.serverGroup.enabledMetrics": "(Optional) <b>Enabled Metrics</b> are the Auto Scaling Group metrics to enable on this group. Existing metrics are not modified.",
  "aws.serverGroup.imdsv2": "(Recommended) <b>IMDSv2</b> helps mitigate AWS credential theft from the exploitation of SSRF vulnerabilities in web applications. All modern AWS SDKs support IMDSv2 and it should not be disabled unless you're using a legacy SDK.",
  "aws.serverGroup.instanceMonitoring": "(Optional) <b>Instance Monitoring</b> whether to enable detailed monitoring of instances. Group metrics must be disabled to update an ASG with Instance Monitoring set to false.",
  "aws.serverGroup.tags": "(Optional) <b>Tags</b> are propagated to the instances in this cluster.",
  "aws.serverGroup.allImages": "Search for an image that does not match the name of your application.",
  "aws.serverGroup.filterImages": "Select from a pre-filtered list of images matching the name of your application.",
  "aws.serverGroup.traffic": `<p>Enables the "AddToLoadBalancer" scaling process, which is used by Spinnaker and discovery services to determine if the server group is enabled.</p>
     <p>Will be automatically enabled when any non "custom" deployment strategy is selected.</p>`,
  "aws.securityGroup.vpc": `
    <p>The VPC to which this {{firewall}} will apply.</p>
    <p>If you wish to use VPC but are unsure which VPC to use, the most common one is "Main".</p>
    <p>If you do not wish to use VPC, select "None".</p>`,
  "aws.securityGroup.name": "<p>The {{firewall}} name is formed by combining the application name, the <b>Stack</b> field, and the <b>Detail</b> field.</p>",
  "aws.securityGroup.cross.account.ingress.help": "<p>Accounts that are excluded will not show up in this list</p>",
  "aws.scalingPolicy.search.restricted": `<p>Resets dimensions to "AutoScalingGroupName: {name of the ASG}" and provides
        a simpler, combined input for the namespace and metric name fields.</p>`,
  "aws.scalingPolicy.search.all": `
    <p>Allows you to edit the dimensions and namespace to find a specific metric for this alarm.</p>`,
  "aws.blockDeviceMappings.useSource": `
    <p>Spinnaker will use the block device mappings of the existing server group when deploying a new server group.</p>
    <p>In the event that there is no existing server group, the
        <a target="_blank" href="https://github.com/spinnaker/clouddriver/blob/master/clouddriver-aws/src/main/groovy/com/netflix/spinnaker/clouddriver/aws/deploy/InstanceTypeUtils.java">defaults</a>
        for the selected instance type will be used.</p>`,
  "aws.blockDeviceMappings.useAMI": "<p>Spinnaker will use the block device mappings from the selected AMI when deploying a new server group.</p>",
  "aws.blockDeviceMappings.useDefaults": '<p>Spinnaker will use the <a target="_blank" href="https://github.com/spinnaker/clouddriver/blob/master/clouddriver-aws/src/main/groovy/com/netflix/spinnaker/clouddriver/aws/deploy/InstanceTypeUtils.java">default block device mappings</a> for the selected instance type when deploying a new server group.</p>',
  "aws.targetGroup.protocol": "The protocol to use for routing traffic to the targets. Cannot be edited after being saved; if you want to use a different protocol, create a new target group, save the load balancer, move your targets, and then delete this target group.",
  "aws.targetGroup.targetType": "Determines how targets are specified. Only set to ip if you need to attach individual ips. Cannot be edited after being saved; if you want to use a different target type, create a new target group, save the load balancer, move your targets, and then delete this target group.",
  "aws.targetGroup.port": "The port on which the targets receive traffic. Cannot be edited after being saved; if you want to use a different port, create a new target group, save the load balancer, move your targets, and then delete this target group.",
  "aws.targetGroup.attributes.deregistrationDelay": "The amount of time for the load balancer to wait before changing the state of a deregistering target from draining to unused. The range is 0-3600 seconds. The default value is 300 seconds.",
  "aws.targetGroup.attributes.stickinessEnabled": " Indicates whether sticky sessions are enabled.",
  "aws.targetGroup.attributes.deregistrationDelayConnectionTermination": "If enabled, your Network Load Balancer will terminate active connections when deregistration delay is reached.",
  "aws.targetGroup.attributes.preserveClientIp": "If enabled, your Network Load Balancer will preserve client IP addresses to the target.",
  "aws.targetGroup.attributes.stickinessType": "The type of sticky sessions. The only current possible value is <code>lb_cookie</code>.",
  "aws.targetGroup.attributes.stickinessDuration": "The time period, in seconds, during which requests from a client should be routed to the same target. After this time period expires, the load balancer-generated cookie is considered stale. The range is 1 second to 1 week (604800 seconds). The default value is 1 day (86400 seconds).",
  "aws.targetGroup.attributes.healthCheckPort.trafficPort": "The port the load balancer uses when performing health checks on targets. The default is <b>traffic-port</b>, which is the port on which each target receives traffic from the load balancer.",
  "aws.targetGroup.healthCheckProtocol": "TCP health checks only support 10s and 30s intervals",
  "aws.targetGroup.healthCheckTimeout": "Target groups with TCP or TLS protocol must have a 6s timeout for HTTP health checks or a 10s timeout for HTTPS/TLS health checks.",
  "aws.targetGroup.nlbHealthcheckThreshold": "The healthy and unhealthy threshold for NLBs must be equal. This represents the number of successful and failed healthchecks required for healthy and unhealthy targets, respectively.",
  "aws.serverGroup.capacityConstraint": `
      <p>Ensures that the capacity of this server group has not changed in the background (i.e. due to autoscaling activity).</p>
      <p>If the capacity has changed, this resize operation will be rejected.</p>`,
  "aws.tagImage.consideredStages": `Limit which previous stages will be considered when locating AMI's to tag. If left unchecked, AMI's generated by any upstream stage will be tagged.`,
  "aws.loadBalancer.redirect.host": `The hostname. This component is not percent-encoded. The hostname can contain <code>#{host}</code>.`,
  "aws.loadBalancer.redirect.path": `The absolute path, starting with the leading "/". This component is not percent-encoded. The path can contain <code>#{host}</code>, <code>#{path}</code>, and <code>#{port}</code>.`,
  "aws.loadBalancer.redirect.port": `The port. You can specify a value from 1 to 65535 or <code>#{port}</code>.`,
  "aws.loadBalancer.redirect.protocol": `The protocol. You can specify HTTP, HTTPS, or <code>#{protocol}</code>. You can redirect HTTP to HTTP, HTTP to HTTPS, and HTTPS to HTTPS. You cannot redirect HTTPS to HTTP.`,
  "aws.loadBalancer.redirect.query": `The query parameters, URL-encoded when necessary, but not percent-encoded. Do not include the leading "?", as it is automatically added. You can specify any of the reserved keywords.`,
  "aws.loadBalancer.redirect.statusCode": `The HTTP redirect code. The redirect is either permanent (HTTP 301) or temporary (HTTP 302).`,
  "aws.loadBalancer.redirect": `<p>A URI consists of the following components: protocol://hostname:port/path?query. You must modify at least one of the following components to avoid a redirect loop: protocol, hostname, port, or path. Any components that you do not modify retain their original values.

        <p>You can reuse URI components using the following reserved keywords:

            <ul><li>#{protocol}
            <li>#{host}
            <li>#{port}
            <li>#{path} (the leading "/" is removed)
            <li>#{query}
        </ul>
        <p>For example, you can change the path to "/new/#{path}", the hostname to "example.#{host}", or the query to "#{query}&value=xyz".`,
  "aws.cloudformation.source": `
      <p>Where the template file content is read from.</p>
      <p>
        <b>text:</b> The template is supplied statically to the pipeline from the below text-box.
      </p>
      <p>
        <b>artifact:</b> The template is read from an artifact supplied/created upstream. The expected artifact must be referenced here, and will be bound at runtime.
      </p>
  `,
  "aws.cloudformation.expectedArtifact": `The artifact that is to be applied to this stage. The artifact should represent a valid cloudformation template.`,
  "aws.function.name": `Enter a name that describes the purpose of your function. Function name will be prefixed with the application name.`,
  "aws.function.runtime": `Choose the language to use to write your function`,
  "aws.function.s3key": `The Amazon S3 key of the deployment package`,
  "aws.function.handler": `The name of the method within your code that Lambda calls to execute your function. The format includes the file name. It can also include namespaces and other qualifiers, depending on the runtime.`,
  "aws.function.s3bucket": `An Amazon S3 bucket in the same AWS Region as your function. The bucket can be in a different AWS account.`,
  "aws.function.execution.role": `Lambda will create an execution role with permission to upload logs to Amazon CloudWatch Logs. You can also choose an existing role that defines the permissions of your function.`,
  "aws.function.env.vars": `You can define environment variables as key-value pairs that are accessible from your function code. These are useful to store configuration settings without the need to change function code`,
  "aws.function.tags": `You can use tags to group and filter your functions. A tag consists of a case-sensitive key-value pair`,
  "aws.functionBasicSettings.memorySize": `Your function is allocated CPU proportional to the memory configured.`,
  "aws.functionBasicSettings.timeout": `The amount of time that Lambda allows a function to run before stopping it. The default is 3 seconds. The maximum allowed value is 900 seconds.`,
  "aws.function.publish": `Set to true to publish the first version of the function during creation.`,
  "aws.function.deadletterqueue": `A dead letter queue configuration that specifies the queue or topic where Lambda sends asynchronous events when they fail processing. (SNS or SQS)`,
  "aws.function.tracingConfig.mode": `The function's AWS X-Ray tracing configuration.`,
  "aws.function.kmsKeyArn": `The ARN of the AWS Key Management Service (AWS KMS) key that's used to encrypt your function's environment variables. If it's not provided, AWS Lambda uses a default service key.`,
  "aws.cloudformation.changeSet.options": `<p>Action to take when the created ChangeSet contains a replacement.</p>
        <p>
          <b>ask:</b> Execution will be put on hold asking for user feedback.
        </p>
        <p>
          <b>skip it:</b> ChangeSet will not be executed and stage will continue.
        </p>
        <p>
          <b>execute it</b> ChangeSet will be executed.
        </p>
        <p>
          <b>fail stage</b> ChangeSet will not be executed and the stage will fail.
        </p>`
};
Object.keys(helpContents).forEach((key) => HelpContentsRegistry.register(key, helpContents[key]));

class AwsImageReader {
  findImages(params) {
    if (!params.q || params.q.length < 3) {
      return $q.when([{ message: "Please enter at least 3 characters...", disabled: true }]);
    }
    return REST("/images/find").query(params).get().catch(() => []);
  }
  getImage(amiName, region, credentials) {
    return REST("/images").path(credentials, region, amiName).query({ provider: "aws" }).get().then((results) => results && results.length ? results[0] : null).catch(() => null);
  }
}

var _a, _b, _c, _d, _e, _f;
const m5 = {
  type: "m5",
  description: "m5 instances provide a balance of compute, memory, and network resources. They are a good choice for most applications.",
  instanceTypes: [
    {
      name: "m5.large",
      label: "Large",
      cpu: 2,
      memory: 8,
      storage: { type: "EBS" },
      costFactor: 2
    },
    {
      name: "m5.xlarge",
      label: "XLarge",
      cpu: 4,
      memory: 16,
      storage: { type: "EBS" },
      costFactor: 3
    },
    {
      name: "m5.2xlarge",
      label: "2XLarge",
      cpu: 8,
      memory: 32,
      storage: { type: "EBS" },
      costFactor: 4
    }
  ]
};
const t2gp = {
  type: "t2",
  description: "t2 instances are a good choice for workloads that don\u2019t use the full CPU often or consistently, but occasionally need to burst (e.g. web servers, developer environments and small databases).",
  instanceTypes: [
    {
      name: "t2.small",
      label: "Small",
      cpu: 1,
      memory: 2,
      storage: { type: "EBS" },
      costFactor: 1,
      cpuCreditsPerHour: 12
    },
    {
      name: "t2.medium",
      label: "Medium",
      cpu: 2,
      memory: 4,
      storage: { type: "EBS" },
      costFactor: 1,
      cpuCreditsPerHour: 24
    },
    {
      name: "t2.large",
      label: "Large",
      cpu: 2,
      memory: 8,
      storage: { type: "EBS" },
      costFactor: 2,
      cpuCreditsPerHour: 36
    },
    {
      name: "t2.xlarge",
      label: "XLarge",
      cpu: 4,
      memory: 16,
      storage: { type: "EBS" },
      costFactor: 3,
      cpuCreditsPerHour: 54
    },
    {
      name: "t2.2xlarge",
      label: "2XLarge",
      cpu: 8,
      memory: 32,
      storage: { type: "EBS" },
      costFactor: 4,
      cpuCreditsPerHour: 81
    }
  ]
};
const t3gp = {
  type: "t3",
  description: "t3 instances are a good choice for workloads that don\u2019t use the full CPU often or consistently, but occasionally need to burst (e.g. web servers, developer environments and small databases).",
  instanceTypes: [
    {
      name: "t3.small",
      label: "Small",
      cpu: 2,
      memory: 2,
      storage: { type: "EBS" },
      costFactor: 1,
      cpuCreditsPerHour: 24
    },
    {
      name: "t3.medium",
      label: "Medium",
      cpu: 2,
      memory: 4,
      storage: { type: "EBS" },
      costFactor: 1,
      cpuCreditsPerHour: 24
    },
    {
      name: "t3.large",
      label: "Large",
      cpu: 2,
      memory: 8,
      storage: { type: "EBS" },
      costFactor: 2,
      cpuCreditsPerHour: 36
    },
    {
      name: "t3.xlarge",
      label: "XLarge",
      cpu: 4,
      memory: 16,
      storage: { type: "EBS" },
      costFactor: 3,
      cpuCreditsPerHour: 96
    },
    {
      name: "t3.2xlarge",
      label: "2XLarge",
      cpu: 8,
      memory: 32,
      storage: { type: "EBS" },
      costFactor: 4,
      cpuCreditsPerHour: 192
    }
  ]
};
const t2 = {
  type: "t2",
  description: "t2 instances are a good choice for workloads that don\u2019t use the full CPU often or consistently, but occasionally need to burst (e.g. web servers, developer environments and small databases).",
  instanceTypes: [
    {
      name: "t2.nano",
      label: "Nano",
      cpu: 1,
      memory: 0.5,
      storage: { type: "EBS" },
      costFactor: 1,
      cpuCreditsPerHour: 3
    },
    {
      name: "t2.micro",
      label: "Micro",
      cpu: 1,
      memory: 1,
      storage: { type: "EBS" },
      costFactor: 1,
      cpuCreditsPerHour: 6
    },
    {
      name: "t2.small",
      label: "Small",
      cpu: 1,
      memory: 2,
      storage: { type: "EBS" },
      costFactor: 1,
      cpuCreditsPerHour: 12
    }
  ]
};
const t3 = {
  type: "t3",
  description: "t3 instances are a good choice for workloads that don\u2019t use the full CPU often or consistently, but occasionally need to burst (e.g. web servers, developer environments and small databases).",
  instanceTypes: [
    {
      name: "t3.nano",
      label: "Nano",
      cpu: 2,
      memory: 0.5,
      storage: { type: "EBS" },
      costFactor: 1,
      cpuCreditsPerHour: 6
    },
    {
      name: "t3.micro",
      label: "Micro",
      cpu: 2,
      memory: 1,
      storage: { type: "EBS" },
      costFactor: 1,
      cpuCreditsPerHour: 12
    },
    {
      name: "t3.small",
      label: "Small",
      cpu: 2,
      memory: 2,
      storage: { type: "EBS" },
      costFactor: 1,
      cpuCreditsPerHour: 24
    }
  ]
};
const r5 = {
  type: "r5",
  description: "r5 instances are optimized for memory-intensive applications and have the lowest cost per GiB of RAM among Amazon EC2 instance types.",
  instanceTypes: [
    {
      name: "r5.large",
      label: "Large",
      cpu: 2,
      memory: 16,
      storage: { type: "EBS" },
      costFactor: 1
    },
    {
      name: "r5.xlarge",
      label: "XLarge",
      cpu: 4,
      memory: 32,
      storage: { type: "EBS" },
      costFactor: 2
    },
    {
      name: "r5.2xlarge",
      label: "2XLarge",
      cpu: 8,
      memory: 64,
      storage: { type: "EBS" },
      costFactor: 2
    },
    {
      name: "r5.4xlarge",
      label: "4XLarge",
      cpu: 16,
      memory: 128,
      storage: { type: "EBS" },
      costFactor: 3
    }
  ]
};
const defaultCategories = [
  {
    type: "general",
    label: "General Purpose",
    families: [m5, t2gp, t3gp],
    icon: "hdd",
    showCpuCredits: true,
    descriptionListOverride: [
      m5.description,
      "t2/t3 instances are a good choice for workloads that don\u2019t use the full CPU often or consistently, but occasionally need to burst (e.g. web servers, developer environments and small databases)."
    ]
  },
  {
    type: "memory",
    label: "High Memory",
    families: [r5],
    icon: "hdd"
  },
  {
    type: "micro",
    label: "Micro Utility",
    families: [t2, t3],
    icon: "hdd",
    showCpuCredits: true,
    descriptionListOverride: [
      "t2/t3 instances are a good choice for workloads that don\u2019t use the full CPU often or consistently, but occasionally need to burst (e.g. web servers, developer environments and small databases)."
    ]
  },
  {
    type: "custom",
    label: "Custom Type",
    families: [],
    icon: "asterisk"
  }
];
const excludeCategories = (_c = (_b = (_a = AWSProviderSettings.instanceTypes) == null ? void 0 : _a.exclude) == null ? void 0 : _b.categories) != null ? _c : [];
const excludeFamilies = (_f = (_e = (_d = AWSProviderSettings.instanceTypes) == null ? void 0 : _d.exclude) == null ? void 0 : _e.families) != null ? _f : [];
const categories = defaultCategories.filter(({ type }) => !excludeCategories.includes(type)).map((category) => Object.assign({}, category, {
  families: category.families.filter(({ type }) => !excludeFamilies.includes(type))
}));

const AMAZON_INSTANCE_AWSINSTANCETYPE_SERVICE = "spinnaker.amazon.instanceType.service";
module(AMAZON_INSTANCE_AWSINSTANCETYPE_SERVICE, []).factory("awsInstanceTypeService", [
  "$q",
  function($q) {
    function getCategories() {
      return $q.when(categories);
    }
    const getAllTypesByRegion = function getAllTypesByRegion2() {
      return REST("/instanceTypes").get().then(function(types) {
        return _.chain(types).map(function(type) {
          return {
            ...type,
            key: [type.region, type.account, type.name].join(":")
          };
        }).uniqBy("key").groupBy("region").value();
      });
    };
    const instanceClassOrder = ["xlarge", "large", "medium", "small", "micro", "nano"];
    function sortTypesByFamilyAndSize(o1, o2) {
      const type1 = o1.split(".");
      const type2 = o2.split(".");
      const [family1, class1 = ""] = type1;
      const [family2, class2 = ""] = type2;
      if (family1 !== family2) {
        if (family1 > family2) {
          return 1;
        } else if (family1 < family2) {
          return -1;
        }
        return 0;
      }
      const t1Idx = instanceClassOrder.findIndex((el) => class1.endsWith(el));
      const t2Idx = instanceClassOrder.findIndex((el) => class2.endsWith(el));
      if (t1Idx === -1 || t2Idx === -1) {
        return 0;
      }
      if (t1Idx === 0 && t2Idx === 0) {
        const size1 = parseInt(class1.replace("xlarge", "")) || 0;
        const size2 = parseInt(class2.replace("xlarge", "")) || 0;
        if (size2 < size1) {
          return 1;
        } else if (size2 > size1) {
          return -1;
        }
        return 0;
      }
      if (t1Idx > t2Idx) {
        return -1;
      } else if (t1Idx < t2Idx) {
        return 1;
      }
      return 0;
    }
    function getAvailableTypesForRegions(availableInstanceTypes, selectedRegions) {
      selectedRegions = selectedRegions || [];
      let availableTypes = [];
      if (selectedRegions && selectedRegions.length) {
        availableTypes = availableInstanceTypes[selectedRegions[0]] || [];
      }
      selectedRegions.forEach(function(selectedRegion) {
        if (availableInstanceTypes[selectedRegion]) {
          availableTypes = _.intersectionBy(availableTypes, availableInstanceTypes[selectedRegion], "name");
        }
      });
      return availableTypes == null ? void 0 : availableTypes.sort((a, b) => sortTypesByFamilyAndSize(a.name, b.name));
    }
    const families = {
      ec2ClassicSupported: ["m1", "m3", "t1", "c1", "c3", "cc2", "cr1", "m2", "r3", "d2", "hs1", "i2", "g2"],
      ebsOptimized: ["c4", "d2", "f1", "g3", "i3", "m4", "m5", "p2", "r4", "r5", "x1"],
      burstablePerf: ["t2", "t3", "t3a", "t4g"]
    };
    function filterInstanceTypes(instanceTypes, virtualizationType, vpcConfigured, architecture) {
      return _.filter(instanceTypes, function(i) {
        if (virtualizationType === "*" && architecture === "*") {
          return true;
        }
        if (!vpcConfigured && !families.ec2ClassicSupported.includes(i.name.split(".")[0])) {
          return false;
        }
        if (virtualizationType && !i.supportedVirtualizationTypes.includes(virtualizationType)) {
          return false;
        }
        if (architecture && !i.supportedArchitectures.includes(architecture)) {
          return false;
        }
        return true;
      });
    }
    function isEbsOptimized(instanceType) {
      if (!instanceType) {
        return false;
      }
      const family = _.split(instanceType, ".", 1)[0];
      return families.ebsOptimized.includes(family);
    }
    function isBurstingSupportedForAllTypes(instanceTypes) {
      if (!instanceTypes || !instanceTypes.length) {
        return false;
      }
      return instanceTypes.every((instanceType) => isBurstingSupported(instanceType));
    }
    function isBurstingSupported(instanceType) {
      if (!instanceType) {
        return false;
      }
      const family = _.split(instanceType, ".", 1)[0];
      return families.burstablePerf.includes(family);
    }
    function getInstanceTypesInCategory(instanceTypesToFilter, category) {
      var _a;
      if (!instanceTypesToFilter || !instanceTypesToFilter.length || !category) {
        return [];
      }
      if (category === "custom") {
        return instanceTypesToFilter;
      }
      const instanceTypesInCategory = _.flatten((_a = _.find(defaultCategories, { type: category })) == null ? void 0 : _a.families.map((f) => f.instanceTypes.map((it) => it.name)));
      return _.intersection(instanceTypesToFilter, instanceTypesInCategory);
    }
    return {
      getCategories,
      getAvailableTypesForRegions,
      getAllTypesByRegion,
      filterInstanceTypes,
      isEbsOptimized,
      isBurstingSupportedForAllTypes,
      getInstanceTypesInCategory
    };
  }
]);

const InstanceInformation = ({
  account,
  availabilityZone,
  instanceType,
  capacityType,
  launchTime,
  provider,
  region,
  serverGroup,
  showInstanceType
}) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(LabeledValue, {
  label: "Launched",
  value: launchTime ? timestamp(launchTime) : "Unknown"
}), /* @__PURE__ */ React__default.createElement(LabeledValue, {
  label: "In",
  value: /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(AccountTag, {
    account
  }), availabilityZone || "Unknown")
}), showInstanceType && /* @__PURE__ */ React__default.createElement(LabeledValue, {
  label: "Type",
  value: instanceType || "Unknown"
}), showInstanceType && capacityType && /* @__PURE__ */ React__default.createElement(LabeledValue, {
  label: "Capacity Type",
  value: capacityType || "Unknown"
}), serverGroup && /* @__PURE__ */ React__default.createElement(LabeledValue, {
  label: "Server Group",
  value: /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(UIRouterContextComponent, null, /* @__PURE__ */ React__default.createElement(UISref, {
    to: "^.serverGroup",
    params: {
      region,
      accountId: account,
      serverGroup,
      provider
    }
  }, /* @__PURE__ */ React__default.createElement("a", null, serverGroup))))
}));

const defaultLabel = "None (EC2 Classic)";
function VpcTag(props) {
  const { vpcId } = props;
  const fetchVpcLabel = useData(async () => {
    const name = await VpcReader.getVpcName(props.vpcId);
    return name ? `${name} (${props.vpcId})` : `(${props.vpcId})`;
  }, defaultLabel, [vpcId]);
  const label = vpcId ? fetchVpcLabel.result : defaultLabel;
  return /* @__PURE__ */ React__default.createElement("span", {
    className: "vpc-tag"
  }, label);
}

const AmazonInstanceInformation = ({ instance }) => {
  const { imageId, serverGroup, subnetId, vpcId } = instance;
  return /* @__PURE__ */ React__default.createElement(CollapsibleSection, {
    heading: "Instance Information",
    defaultExpanded: true
  }, /* @__PURE__ */ React__default.createElement("dl", {
    className: "dl-horizontal dl-narrow"
  }, /* @__PURE__ */ React__default.createElement(InstanceInformation, {
    account: instance.account,
    availabilityZone: instance.availabilityZone,
    instanceType: instance.instanceType,
    capacityType: instance.capacityType,
    launchTime: instance.launchTime,
    provider: instance.provider,
    region: instance.region,
    serverGroup: instance.serverGroup,
    showInstanceType: true
  }), serverGroup && /* @__PURE__ */ React__default.createElement(LabeledValue, {
    label: "VPC",
    value: /* @__PURE__ */ React__default.createElement(VpcTag, {
      vpcId
    })
  }), subnetId && /* @__PURE__ */ React__default.createElement(LabeledValue, {
    label: "Subnet",
    value: /* @__PURE__ */ React__default.createElement(SubnetTag, {
      subnetId
    })
  }), imageId && /* @__PURE__ */ React__default.createElement(LabeledValue, {
    label: "Image ID",
    value: imageId
  })));
};

const AMAZON_INSTANCE_INFORMATION_COMPONENT = "spinnaker.application.amazonInstanceInformation.component";
module(AMAZON_INSTANCE_INFORMATION_COMPONENT, []).component("amazonInstanceInformation", react2angular(withErrorBoundary(AmazonInstanceInformation, "amazonInstanceInformation"), ["instance"]));

class AmazonInstanceWriter extends InstanceWriter {
  static deregisterInstancesFromTargetGroup(instanceGroups, application, targetGroupNames) {
    const jobs = super.buildMultiInstanceJob(instanceGroups, "deregisterInstancesFromLoadBalancer");
    jobs.forEach((job) => job.targetGroupNames = targetGroupNames);
    const descriptor = super.buildMultiInstanceDescriptor(jobs, "Deregister", `from ${targetGroupNames.join(" and ")}`);
    return TaskExecutor.executeTask({
      job: jobs,
      application,
      description: descriptor
    });
  }
  static deregisterInstanceFromTargetGroup(instance, application, params = {}) {
    params.type = "deregisterInstancesFromLoadBalancer";
    params.instanceIds = [instance.id];
    params.targetGroupNames = instance.targetGroups;
    params.region = instance.region;
    params.credentials = instance.account;
    params.cloudProvider = instance.cloudProvider;
    return TaskExecutor.executeTask({
      job: [params],
      application,
      description: `Deregister instance: ${instance.id}`
    });
  }
  static registerInstancesWithTargetGroup(instanceGroups, application, targetGroupNames) {
    const jobs = super.buildMultiInstanceJob(instanceGroups, "registerInstancesWithLoadBalancer");
    jobs.forEach((job) => job.targetGroupNames = targetGroupNames);
    const descriptor = super.buildMultiInstanceDescriptor(jobs, "Register", `with ${targetGroupNames.join(" and ")}`);
    return TaskExecutor.executeTask({
      job: jobs,
      application,
      description: descriptor
    });
  }
  static registerInstanceWithTargetGroup(instance, application, params = {}) {
    params.type = "registerInstancesWithLoadBalancer";
    params.instanceIds = [instance.id];
    params.targetGroupNames = instance.targetGroups;
    params.region = instance.region;
    params.credentials = instance.account;
    params.cloudProvider = instance.cloudProvider;
    return TaskExecutor.executeTask({
      job: [params],
      application,
      description: `Register instance: ${instance.id}`
    });
  }
}

const getAllTargetGroups = (loadBalancers) => {
  const allTargetGroups = loadBalancers.map((d) => d.targetGroups);
  const targetGroups = flatten(allTargetGroups);
  return targetGroups;
};
const applyHealthCheckInfoToTargetGroups = (healthMetrics, targetGroups, account) => {
  healthMetrics.forEach((metric) => {
    if (metric.type === "TargetGroup") {
      metric.targetGroups.forEach((tg) => {
        var _a, _b, _c;
        const group = (_a = targetGroups.find((g) => g.name === tg.name && g.account === account)) != null ? _a : {};
        const useTrafficPort = group.healthCheckPort === "traffic-port" || isNil(group.healthCheckPort);
        const port = useTrafficPort ? group.port : group.healthCheckPort;
        tg.healthCheckProtocol = (_b = group.healthCheckProtocol) == null ? void 0 : _b.toLowerCase();
        tg.healthCheckPath = `:${port}${(_c = group.healthCheckPath) != null ? _c : ""}`;
      });
    }
  });
};

const AMAZON_INSTANCE_DETAILS_INSTANCE_DETAILS_CONTROLLER = "spinnaker.amazon.instance.details.controller";
module(AMAZON_INSTANCE_DETAILS_INSTANCE_DETAILS_CONTROLLER, [UIROUTER_ANGULARJS, ANGULAR_UI_BOOTSTRAP]).controller("awsInstanceDetailsCtrl", [
  "$scope",
  "$state",
  "instance",
  "app",
  "moniker",
  "environment",
  "$q",
  "overrides",
  function($scope, $state, instance, app, moniker, environment, $q, overrides) {
    $scope.isDisabled = !AWSProviderSettings.adHocInfraWritesEnabled;
    $scope.detailsTemplateUrl = CloudProviderRegistry.getValue("aws", "instance.detailsTemplateUrl");
    $scope.state = {
      loading: true,
      standalone: app.isStandalone,
      instancePort: _.get(app, "attributes.instancePort") || SETTINGS.defaultInstancePort || 80
    };
    $scope.application = app;
    $scope.moniker = moniker;
    $scope.environment = environment;
    $scope.securityGroupsLabel = FirewallLabels.get("Firewalls");
    function extractHealthMetrics(instance2, latest) {
      if (app.isStandalone) {
        instance2.health = latest.health;
      }
      instance2.health = instance2.health || [];
      const displayableMetrics = instance2.health.filter(function(metric) {
        return metric.type !== "Amazon" || metric.state !== "Unknown";
      });
      if (!app.isStandalone) {
        const targetGroups = getAllTargetGroups(app.loadBalancers.data.filter(function(loadBalancer) {
          return loadBalancer.cloudProvider === "aws";
        }));
        applyHealthCheckInfoToTargetGroups(displayableMetrics, targetGroups, instance2.account);
      }
      if (latest.health) {
        displayableMetrics.forEach(function(metric) {
          const detailsMatch = latest.health.filter(function(latestHealth) {
            return latestHealth.type === metric.type;
          });
          if (detailsMatch.length) {
            _.defaults(metric, detailsMatch[0]);
          }
        });
      }
      $scope.healthMetrics = displayableMetrics;
    }
    function retrieveInstance() {
      const extraData = {};
      let instanceSummary, loadBalancers, targetGroups, account, region, vpcId, serverGroupDisabled;
      if (!app.serverGroups) {
        instanceSummary = { id: instance.instanceId };
        loadBalancers = [];
        targetGroups = [];
        account = instance.account;
        region = instance.region;
      } else {
        app.serverGroups.data.some(function(serverGroup) {
          return serverGroup.instances.some(function(possibleInstance) {
            if (possibleInstance.id === instance.instanceId) {
              instanceSummary = possibleInstance;
              loadBalancers = serverGroup.loadBalancers;
              targetGroups = serverGroup.targetGroups;
              account = serverGroup.account;
              region = serverGroup.region;
              vpcId = serverGroup.vpcId;
              serverGroupDisabled = serverGroup.isDisabled;
              extraData.serverGroup = serverGroup.name;
              extraData.vpcId = serverGroup.vpcId;
              return true;
            }
          });
        });
        if (!instanceSummary) {
          app.loadBalancers.data.some(function(loadBalancer) {
            return loadBalancer.instances.some(function(possibleInstance) {
              if (possibleInstance.id === instance.instanceId) {
                instanceSummary = possibleInstance;
                loadBalancers = [loadBalancer.name];
                account = loadBalancer.account;
                region = loadBalancer.region;
                vpcId = loadBalancer.vpcId;
                return true;
              }
            }) || loadBalancer.targetGroups.some(function(targetGroup) {
              return targetGroup.instances.some(function(possibleInstance) {
                if (possibleInstance.id === instance.instanceId) {
                  instanceSummary = possibleInstance;
                  targetGroups = [targetGroup.name];
                  account = loadBalancer.account;
                  region = loadBalancer.region;
                  vpcId = loadBalancer.vpcId;
                  return true;
                }
              });
            });
          });
          if (!instanceSummary) {
            app.loadBalancers.data.some(function(loadBalancer) {
              return loadBalancer.serverGroups.some(function(serverGroup) {
                if (!serverGroup.isDisabled) {
                  return false;
                }
                return serverGroup.instances.some(function(possibleInstance) {
                  if (possibleInstance.id === instance.instanceId) {
                    instanceSummary = possibleInstance;
                    loadBalancers = [loadBalancer.name];
                    account = loadBalancer.account;
                    region = loadBalancer.region;
                    vpcId = loadBalancer.vpcId;
                    return true;
                  }
                });
              }) || loadBalancer.targetGroups.some(function(targetGroup) {
                targetGroup.serverGroups.some(function(serverGroup) {
                  if (!serverGroup.isDisabled) {
                    return false;
                  }
                  return serverGroup.instances.some(function(possibleInstance) {
                    if (possibleInstance.id === instance.instanceId) {
                      instanceSummary = possibleInstance;
                      loadBalancers = [loadBalancer.name];
                      account = loadBalancer.account;
                      region = loadBalancer.region;
                      vpcId = loadBalancer.vpcId;
                      return true;
                    }
                  });
                });
              });
            });
          }
        }
      }
      if (instanceSummary && account && region) {
        instanceSummary.account = account;
        extraData.account = account;
        extraData.region = region;
        RecentHistoryService.addExtraDataToLatest("instances", extraData);
        return InstanceReader.getInstanceDetails(account, region, instance.instanceId).then((details) => {
          if ($scope.$$destroyed) {
            return;
          }
          $scope.state.loading = false;
          extractHealthMetrics(instanceSummary, details);
          $scope.instance = _.defaults(details, instanceSummary);
          $scope.instance.account = account;
          $scope.instance.region = region;
          $scope.instance.vpcId = vpcId;
          $scope.instance.serverGroupDisabled = serverGroupDisabled;
          $scope.instance.loadBalancers = loadBalancers;
          $scope.instance.targetGroups = targetGroups;
          if ($scope.instance.networkInterfaces) {
            $scope.instance.ipv6Addresses = _.flatMap($scope.instance.networkInterfaces, (i) => i.ipv6Addresses.map((a) => ({
              ip: a.ipv6Address,
              url: `http://${a.ipv6Address}:${$scope.state.instancePort}`
            })));
            const permanentNetworkInterfaces = $scope.instance.networkInterfaces.filter((f) => f.attachment.deleteOnTermination === false);
            if (permanentNetworkInterfaces.length) {
              $scope.instance.permanentIps = permanentNetworkInterfaces.map((f) => f.privateIpAddress);
            }
          }
          $scope.baseIpAddress = details.publicDnsName || details.privateIpAddress;
          if (overrides.instanceDetailsLoaded) {
            overrides.instanceDetailsLoaded();
          }
        }, autoClose);
      }
      if (!instanceSummary) {
        $scope.instanceIdNotFound = instance.instanceId;
        $scope.state.loading = false;
      }
      return $q.when(null);
    }
    function autoClose() {
      if ($scope.$$destroyed) {
        return;
      }
      if (app.isStandalone) {
        $scope.state.loading = false;
        $scope.instanceIdNotFound = instance.instanceId;
        $scope.state.notFoundStandalone = true;
        RecentHistoryService.removeLastItem("instances");
      } else {
        $state.go("^", { allowModalToStayOpen: true }, { location: "replace" });
      }
    }
    this.canDeregisterFromLoadBalancer = function() {
      const healthMetrics = $scope.instance.health || [];
      return healthMetrics.some(function(health) {
        return health.type === "LoadBalancer";
      });
    };
    this.canRegisterWithLoadBalancer = function() {
      const instance2 = $scope.instance;
      const healthMetrics = instance2.health || [];
      if (!instance2.loadBalancers || !instance2.loadBalancers.length) {
        return false;
      }
      const outOfService = healthMetrics.some(function(health) {
        return health.type === "LoadBalancer" && health.state === "OutOfService";
      });
      const hasLoadBalancerHealth = healthMetrics.some(function(health) {
        return health.type === "LoadBalancer";
      });
      return outOfService || !hasLoadBalancerHealth;
    };
    this.canDeregisterFromTargetGroup = function() {
      const healthMetrics = $scope.instance.health || [];
      return healthMetrics.some(function(health) {
        return health.type === "TargetGroup" && health.state !== "OutOfService";
      });
    };
    this.canRegisterWithTargetGroup = function() {
      const instance2 = $scope.instance;
      const healthMetrics = instance2.health || [];
      if (!instance2.targetGroups || !instance2.targetGroups.length) {
        return false;
      }
      const outOfService = healthMetrics.some(function(health) {
        return health.type === "TargetGroup" && health.state === "OutOfService";
      });
      const hasTargetGroupHealth = healthMetrics.some(function(health) {
        return health.type === "TargetGroup";
      });
      return outOfService || !hasTargetGroupHealth;
    };
    this.canRegisterWithDiscovery = function() {
      const instance2 = $scope.instance;
      const healthMetrics = instance2.health || [];
      const discoveryHealth = healthMetrics.filter(function(health) {
        return health.type === "Discovery";
      });
      return discoveryHealth.length ? discoveryHealth[0].state === "OutOfService" : false;
    };
    this.terminateInstance = function terminateInstance() {
      const instance2 = $scope.instance;
      const taskMonitor = {
        application: app,
        title: "Terminating " + instance2.instanceId,
        onTaskComplete: function() {
          if ($state.includes("**.instanceDetails", { instanceId: instance2.instanceId })) {
            $state.go("^");
          }
        }
      };
      const submitMethod = function() {
        return AmazonInstanceWriter.terminateInstance(instance2, app);
      };
      ConfirmationModalService.confirm({
        header: "Really terminate " + instance2.instanceId + "?",
        buttonText: "Terminate " + instance2.instanceId,
        account: instance2.account,
        taskMonitorConfig: taskMonitor,
        submitMethod
      });
    };
    this.terminateInstanceAndShrinkServerGroup = function terminateInstanceAndShrinkServerGroup() {
      const instance2 = $scope.instance;
      const taskMonitor = {
        application: app,
        title: "Terminating " + instance2.instanceId + " and shrinking server group",
        onTaskComplete: function() {
          if ($state.includes("**.instanceDetails", { instanceId: instance2.instanceId })) {
            $state.go("^");
          }
        }
      };
      const submitMethod = function() {
        return AmazonInstanceWriter.terminateInstanceAndShrinkServerGroup(instance2, app);
      };
      ConfirmationModalService.confirm({
        header: "Really terminate " + instance2.instanceId + " and shrink " + instance2.serverGroup + "?",
        buttonText: "Terminate " + instance2.instanceId + " and shrink " + instance2.serverGroup,
        account: instance2.account,
        taskMonitorConfig: taskMonitor,
        submitMethod
      });
    };
    this.rebootInstance = function rebootInstance() {
      const instance2 = $scope.instance;
      const taskMonitor = {
        application: app,
        title: "Rebooting " + instance2.instanceId
      };
      const submitMethod = (params = {}) => {
        if (app.attributes && app.attributes.platformHealthOnlyShowOverride && app.attributes.platformHealthOnly) {
          params.interestingHealthProviderNames = ["Amazon"];
        }
        return AmazonInstanceWriter.rebootInstance(instance2, app, params);
      };
      ConfirmationModalService.confirm({
        header: "Really reboot " + instance2.instanceId + "?",
        buttonText: "Reboot " + instance2.instanceId,
        account: instance2.account,
        platformHealthOnlyShowOverride: app.attributes.platformHealthOnlyShowOverride,
        platformHealthType: "Amazon",
        taskMonitorConfig: taskMonitor,
        submitMethod
      });
    };
    this.registerInstanceWithLoadBalancer = function registerInstanceWithLoadBalancer() {
      const instance2 = $scope.instance;
      const loadBalancerNames = instance2.loadBalancers.join(" and ");
      const taskMonitor = {
        application: app,
        title: "Registering " + instance2.instanceId + " with " + loadBalancerNames
      };
      const submitMethod = function() {
        return AmazonInstanceWriter.registerInstanceWithLoadBalancer(instance2, app);
      };
      ConfirmationModalService.confirm({
        header: "Really register " + instance2.instanceId + " with " + loadBalancerNames + "?",
        buttonText: "Register " + instance2.instanceId,
        account: instance2.account,
        taskMonitorConfig: taskMonitor,
        submitMethod
      });
    };
    this.deregisterInstanceFromLoadBalancer = function deregisterInstanceFromLoadBalancer() {
      const instance2 = $scope.instance;
      const loadBalancerNames = instance2.loadBalancers.join(" and ");
      const taskMonitor = {
        application: app,
        title: "Deregistering " + instance2.instanceId + " from " + loadBalancerNames
      };
      const submitMethod = function() {
        return AmazonInstanceWriter.deregisterInstanceFromLoadBalancer(instance2, app);
      };
      ConfirmationModalService.confirm({
        header: "Really deregister " + instance2.instanceId + " from " + loadBalancerNames + "?",
        buttonText: "Deregister " + instance2.instanceId,
        account: instance2.account,
        taskMonitorConfig: taskMonitor,
        submitMethod
      });
    };
    this.registerInstanceWithTargetGroup = function registerInstanceWithTargetGroup() {
      const instance2 = $scope.instance;
      const targetGroupNames = instance2.targetGroups.join(" and ");
      const taskMonitor = {
        application: app,
        title: "Registering " + instance2.instanceId + " with " + targetGroupNames
      };
      const submitMethod = function() {
        return AmazonInstanceWriter.registerInstanceWithTargetGroup(instance2, app);
      };
      ConfirmationModalService.confirm({
        header: "Really register " + instance2.instanceId + " with " + targetGroupNames + "?",
        buttonText: "Register " + instance2.instanceId,
        account: instance2.account,
        taskMonitorConfig: taskMonitor,
        submitMethod
      });
    };
    this.deregisterInstanceFromTargetGroup = function deregisterInstanceFromTargetGroup() {
      const instance2 = $scope.instance;
      const targetGroupNames = instance2.targetGroups.join(" and ");
      const taskMonitor = {
        application: app,
        title: "Deregistering " + instance2.instanceId + " from " + targetGroupNames
      };
      const submitMethod = function() {
        return AmazonInstanceWriter.deregisterInstanceFromTargetGroup(instance2, app);
      };
      ConfirmationModalService.confirm({
        header: "Really deregister " + instance2.instanceId + " from " + targetGroupNames + "?",
        buttonText: "Deregister " + instance2.instanceId,
        account: instance2.account,
        taskMonitorConfig: taskMonitor,
        submitMethod
      });
    };
    this.enableInstanceInDiscovery = function enableInstanceInDiscovery() {
      const instance2 = $scope.instance;
      const taskMonitor = {
        application: app,
        title: "Enabling " + instance2.instanceId + " in discovery"
      };
      const submitMethod = function() {
        return AmazonInstanceWriter.enableInstanceInDiscovery(instance2, app);
      };
      ConfirmationModalService.confirm({
        header: "Really enable " + instance2.instanceId + " in discovery?",
        buttonText: "Enable " + instance2.instanceId,
        account: instance2.account,
        taskMonitorConfig: taskMonitor,
        submitMethod
      });
    };
    this.disableInstanceInDiscovery = function disableInstanceInDiscovery() {
      const instance2 = $scope.instance;
      const taskMonitor = {
        application: app,
        title: "Disabling " + instance2.instanceId + " in discovery"
      };
      const submitMethod = function() {
        return AmazonInstanceWriter.disableInstanceInDiscovery(instance2, app);
      };
      ConfirmationModalService.confirm({
        header: "Really disable " + instance2.instanceId + " in discovery?",
        buttonText: "Disable " + instance2.instanceId,
        account: instance2.account,
        taskMonitorConfig: taskMonitor,
        submitMethod
      });
    };
    this.hasHealthState = function hasHealthState(healthProviderType, state) {
      const instance2 = $scope.instance;
      const healthMetrics = instance2.health || [];
      return healthMetrics.some(function(health) {
        return health.type === healthProviderType && health.state === state;
      });
    };
    const constructInstanceActions = (instance2) => {
      const constantActions = [
        { label: "Reboot", triggerAction: this.rebootInstance },
        { label: "Terminate", triggerAction: this.terminateInstance },
        { label: "Terminate and Shrink Server Group", triggerAction: this.terminateInstanceAndShrinkServerGroup }
      ];
      const conditionalActions = [];
      if (this.canRegisterWithDiscovery() && !instance2.serverGroupDisabled) {
        conditionalActions.push({
          label: "Enable In Discovery",
          triggerAction: this.enableInstanceInDiscovery
        });
      }
      if (this.hasHealthState("Discovery", "Up") || this.hasHealthState("Discovery", "Down")) {
        conditionalActions.push({
          label: "Disable in Discovery",
          triggerAction: this.disableInstanceInDiscovery
        });
      }
      if (this.canRegisterWithLoadBalancer()) {
        conditionalActions.push({
          label: "Register with Load Balancer",
          triggerAction: this.registerInstanceWithLoadBalancer
        });
      }
      if (this.canDeregisterFromLoadBalancer()) {
        conditionalActions.push({
          label: "Deregister from Load Balancer",
          triggerAction: this.deregisterInstanceFromLoadBalancer
        });
      }
      if (this.canRegisterWithTargetGroup()) {
        conditionalActions.push({
          label: "Register with Target Group",
          triggerAction: this.registerInstanceWithTargetGroup
        });
      }
      if (this.canDeregisterFromTargetGroup()) {
        conditionalActions.push({
          label: "Deregister from Target Group",
          triggerAction: this.deregisterInstanceFromTargetGroup
        });
      }
      return conditionalActions.concat(constantActions);
    };
    const initialize = app.isStandalone ? retrieveInstance() : $q.all([app.serverGroups.ready(), app.loadBalancers.ready()]).then(retrieveInstance);
    initialize.then(() => {
      $scope.instanceActions = constructInstanceActions($scope.instance);
      if (!$scope.$$destroyed && !app.isStandalone) {
        app.serverGroups.onRefresh($scope, retrieveInstance);
      }
    });
    $scope.account = instance.account;
  }
]);

const InstanceDns = ({
  instancePort,
  ipv6Addresses,
  permanentIps,
  privateDnsName,
  privateIpAddress,
  publicDnsName,
  publicIpAddress
}) => {
  const portSuffix = instancePort ? `:${instancePort}` : "";
  return /* @__PURE__ */ React.createElement(LabeledValueList, {
    className: "horizontal-when-filters-collapsed"
  }, privateDnsName && /* @__PURE__ */ React.createElement(LabeledValue, {
    label: "Private DNS Name",
    value: /* @__PURE__ */ React.createElement(LinkWithClipboard, {
      text: privateDnsName,
      url: `http://${privateDnsName}${portSuffix}`
    })
  }), publicDnsName && /* @__PURE__ */ React.createElement(LabeledValue, {
    label: "Public DNS Name",
    value: /* @__PURE__ */ React.createElement(LinkWithClipboard, {
      text: publicDnsName,
      url: `http://${publicDnsName}${portSuffix}`
    })
  }), privateIpAddress && /* @__PURE__ */ React.createElement(LabeledValue, {
    label: "Private IP Address",
    value: /* @__PURE__ */ React.createElement(LinkWithClipboard, {
      text: privateIpAddress,
      url: `http://${privateIpAddress}${portSuffix}`
    })
  }), Boolean(permanentIps == null ? void 0 : permanentIps.length) && /* @__PURE__ */ React.createElement(LabeledValue, {
    label: "Permanent IP Address",
    value: permanentIps.map((ip) => /* @__PURE__ */ React.createElement(LinkWithClipboard, {
      key: ip,
      text: ip,
      url: `http://${ip}${portSuffix}`
    }))
  }), publicIpAddress && /* @__PURE__ */ React.createElement(LabeledValue, {
    label: "Public IP Address",
    value: /* @__PURE__ */ React.createElement(LinkWithClipboard, {
      text: publicIpAddress,
      url: `http://${publicIpAddress}${portSuffix}`
    })
  }), Boolean(ipv6Addresses == null ? void 0 : ipv6Addresses.length) && /* @__PURE__ */ React.createElement(LabeledValue, {
    label: `IPv6 Address${ipv6Addresses.length > 1 ? "es" : ""}`,
    value: ipv6Addresses.map((ipv6) => /* @__PURE__ */ React.createElement(LinkWithClipboard, {
      key: ipv6.ip,
      text: ipv6.ip,
      url: ipv6.url
    }))
  }));
};

const INSTANCE_DNS_COMPONENT = "spinnaker.application.instanceDns.component";
module(INSTANCE_DNS_COMPONENT, []).component("instanceDns", react2angular(withErrorBoundary(InstanceDns, "instanceDns"), [
  "instancePort",
  "ipv6Addresses",
  "permanentIps",
  "privateDnsName",
  "privateIpAddress",
  "publicDnsName",
  "publicIpAddress"
]));

const InstanceSecurityGroups = ({ instance }) => {
  const { account, region, provider, securityGroups, vpcId } = instance;
  const sortedSecurityGroups = orderBy(securityGroups, ["groupName"], ["asc"]);
  const securityGroupLabel = FirewallLabels.get("Firewalls");
  return /* @__PURE__ */ React__default.createElement(CollapsibleSection, {
    heading: securityGroupLabel,
    defaultExpanded: true
  }, /* @__PURE__ */ React__default.createElement(UIRouterContextComponent, null, /* @__PURE__ */ React__default.createElement("ul", null, (sortedSecurityGroups || []).map((sg) => /* @__PURE__ */ React__default.createElement("li", {
    key: sg.groupId
  }, /* @__PURE__ */ React__default.createElement(UISref, {
    to: "^.firewallDetails",
    params: {
      name: sg.groupName,
      accountId: account,
      region,
      vpcId,
      provider
    }
  }, /* @__PURE__ */ React__default.createElement("a", null, sg.groupName, " (", sg.groupId, ")")))))));
};

const INSTANCE_SECURITY_GROUPS_COMPONENT = "spinnaker.application.instanceSecurityGroups.component";
module(INSTANCE_SECURITY_GROUPS_COMPONENT, []).component("instanceSecurityGroups", react2angular(withErrorBoundary(InstanceSecurityGroups, "instanceSecurityGroups"), ["instance"]));

const InstanceStatus = ({
  healthMetrics,
  healthState,
  metricTypes,
  customHealthUrl,
  privateIpAddress
}) => {
  const hasLoadBalancer = metricTypes.includes("LoadBalancer");
  const hasTargetGroup = metricTypes.includes("TargetGroup");
  return /* @__PURE__ */ React__default.createElement(CollapsibleSection, {
    heading: "Status",
    defaultExpanded: true
  }, !healthMetrics.length && /* @__PURE__ */ React__default.createElement("p", null, healthState === "Starting" ? "Starting" : "No health metrics found for this instance"), /* @__PURE__ */ React__default.createElement("dl", {
    className: "horizontal-when-filters-collapsed"
  }, healthMetrics.sort((a, b) => a.type < b.type ? -1 : a.type > b.type ? 1 : 0).map((metric) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, {
    key: `${metric.type}-${metric.description}`
  }, /* @__PURE__ */ React__default.createElement("dt", null, robotToHuman(metric.type)), /* @__PURE__ */ React__default.createElement("dd", null, !metricTypes.includes(metric.type) && /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(Tooltip, {
    value: metric.state.toLowerCase() === "down" ? metric.description : "",
    placement: "left"
  }, /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("span", {
    className: `glyphicon glyphicon-${metric.state}-triangle`
  }), /* @__PURE__ */ React__default.createElement("span", null, robotToHuman(metric.state)))), /* @__PURE__ */ React__default.createElement("span", {
    className: "pad-left small"
  }, metric.healthCheckUrl && /* @__PURE__ */ React__default.createElement("a", {
    target: "_blank",
    href: metric.healthCheckUrl
  }, "Health Check"), metric.healthCheckUrl && metric.statusPageUrl && /* @__PURE__ */ React__default.createElement("span", null, " | "), metric.statusPageUrl && /* @__PURE__ */ React__default.createElement("a", {
    target: "_blank",
    href: metric.statusPageUrl
  }, "Status"), customHealthUrl && metric.type === customHealthUrl.type && /* @__PURE__ */ React__default.createElement("span", null, " ", "|", " ", /* @__PURE__ */ React__default.createElement("a", {
    target: "_blank",
    href: customHealthUrl.href
  }, customHealthUrl.text)))), hasLoadBalancer && metric.type === "LoadBalancer" && (metric.loadBalancers || []).map((lb) => /* @__PURE__ */ React__default.createElement(InstanceLoadBalancerHealth, {
    key: `lb-${lb.name}`,
    loadBalancer: lb
  })), hasTargetGroup && metric.type === "TargetGroup" && (metric.targetGroups || []).map((tg) => /* @__PURE__ */ React__default.createElement(InstanceLoadBalancerHealth, {
    key: `tg-${tg.name}`,
    loadBalancer: tg,
    ipAddress: privateIpAddress
  })))))));
};

const INSTANCE_STATUS_COMPONENT = "spinnaker.application.instanceStatus.component";
module(INSTANCE_STATUS_COMPONENT, []).component("instanceStatus", react2angular(withErrorBoundary(InstanceStatus, "instanceStatus"), [
  "healthMetrics",
  "healthState",
  "metricTypes",
  "customHealthUrl",
  "privateIpAddress"
]));

const InstanceTags = ({ tags }) => {
  const sortedTags = orderBy(tags, ["key"], ["asc"]);
  return /* @__PURE__ */ React__default.createElement(CollapsibleSection, {
    heading: "Tags",
    defaultExpanded: true
  }, !tags.length && /* @__PURE__ */ React__default.createElement("div", null, "No tags associated with this server"), tags.length && sortedTags.map((tag) => /* @__PURE__ */ React__default.createElement(LabeledValue, {
    key: tag.key,
    label: tag.key,
    value: tag.value
  })));
};

const INSTANCE_TAGS_COMPONENT = "spinnaker.application.instanceTags.component";
module(INSTANCE_TAGS_COMPONENT, []).component("instanceTags", react2angular(withErrorBoundary(InstanceTags, "instanceTags"), ["tags"]));

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$i = ".target-group-title {\n  color: var(--color-mineshaft);\n  font-weight: 600;\n  font-size: 14px;\n  padding-right: 15px;\n  text-transform: uppercase;\n  padding-left: 10px;\n}\n.cluster-container .target-group-container {\n  margin-top: 3px;\n}\n.cluster-container .target-group-container:not(:first-child) {\n  padding-top: 5px;\n}\n.target-group-container .target-group-header {\n  padding: 4px 0;\n}\n.target-group-container .server-group-title {\n  padding-top: 0;\n}\n.target-group-container .server-group-title .clickable-row {\n  margin-top: -1px;\n}\n.target-group-container .no-margin-y {\n  margin-top: -1px !important;\n  margin-bottom: 0 !important;\n}\n.target-group-container > div > .text-right {\n  padding-right: 10px;\n  font-weight: 600;\n}\n.listener-targets {\n  display: inline-block;\n  vertical-align: top;\n}\n";
styleInject(css_248z$i);

class TargetGroup extends React__default.Component {
  render() {
    const { targetGroup, showInstances, showServerGroups, loadBalancer } = this.props;
    const ServerGroups = orderBy(targetGroup.serverGroups, ["isDisabled", "name"], ["asc", "desc"]).map((serverGroup) => /* @__PURE__ */ React__default.createElement(LoadBalancerServerGroup, {
      key: serverGroup.name,
      account: serverGroup.account,
      region: serverGroup.region,
      serverGroup,
      showInstances
    }));
    const params = {
      loadBalancerName: loadBalancer.name,
      region: targetGroup.region,
      accountId: targetGroup.account,
      name: targetGroup.name,
      vpcId: targetGroup.vpcId,
      provider: targetGroup.cloudProvider
    };
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "target-group-container container-fluid no-padding"
    }, /* @__PURE__ */ React__default.createElement(UISrefActive, {
      class: "active"
    }, /* @__PURE__ */ React__default.createElement(UISref, {
      to: ".targetGroupDetails",
      params
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: `clickable clickable-row row no-margin-y target-group-header`
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-8 target-group-title"
    }, targetGroup.name), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-4 text-right"
    }, /* @__PURE__ */ React__default.createElement(HealthCounts, {
      container: targetGroup.instanceCounts
    }))))), showServerGroups && ServerGroups, !showServerGroups && showInstances && /* @__PURE__ */ React__default.createElement(LoadBalancerInstances, {
      serverGroups: targetGroup.serverGroups,
      instances: targetGroup.instances
    }));
  }
}

class AmazonLoadBalancerClusterContainer extends React__default.Component {
  shouldComponentUpdate(nextProps) {
    const serverGroupsDiffer = () => !isEqual((nextProps.serverGroups || []).map((g) => g.name), (this.props.serverGroups || []).map((g) => g.name));
    const targetGroupsDiffer = () => !isEqual((nextProps.loadBalancer.targetGroups || []).map((t) => t.name), (this.props.loadBalancer.targetGroups || []).map((t) => t.name));
    return nextProps.showInstances !== this.props.showInstances || nextProps.showServerGroups !== this.props.showServerGroups || nextProps.loadBalancer !== this.props.loadBalancer || serverGroupsDiffer() || targetGroupsDiffer();
  }
  render() {
    const { loadBalancer, showInstances, showServerGroups } = this.props;
    if (loadBalancer.loadBalancerType !== "classic") {
      const alb = loadBalancer;
      const TargetGroups = alb.targetGroups.map((targetGroup) => {
        return /* @__PURE__ */ React__default.createElement(TargetGroup, {
          key: targetGroup.name,
          loadBalancer,
          targetGroup,
          showInstances,
          showServerGroups
        });
      });
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "cluster-container"
      }, TargetGroups);
    } else {
      return /* @__PURE__ */ React__default.createElement(LoadBalancerClusterContainer, {
        ...this.props
      });
    }
  }
}

class AmazonLoadBalancerDataUtils {
  static buildTargetGroup(match, serverGroup) {
    if (!match) {
      return null;
    }
    const targetGroup = {
      name: match.name,
      vpcId: match.vpcId,
      cloudProvider: match.cloudProvider,
      account: match.account,
      region: match.region,
      loadBalancerNames: match.loadBalancerNames
    };
    targetGroup.instanceCounts = { up: 0, down: 0, succeeded: 0, failed: 0, outOfService: 0, unknown: 0, starting: 0 };
    serverGroup.instances.forEach((instance) => {
      const tgHealth = instance.health.find((h) => h.type === "TargetGroup");
      if (tgHealth) {
        const matchedHealth = tgHealth.targetGroups.find((tg) => tg.name === match.name);
        if (matchedHealth !== void 0 && matchedHealth.healthState !== void 0) {
          const healthState = matchedHealth.healthState.toLowerCase();
          if (targetGroup.instanceCounts[healthState] !== void 0) {
            targetGroup.instanceCounts[healthState]++;
          }
        }
      }
    });
    return targetGroup;
  }
  static populateTargetGroups(application, serverGroup) {
    return $q.all([AccountService.getAccountDetails(serverGroup.account), application.getDataSource("loadBalancers").ready()]).then((data) => {
      const awsAccount = data[0] && data[0].awsAccount || serverGroup.account;
      const loadBalancers = application.loadBalancers.data.filter((lb) => lb.loadBalancerType === "application" || lb.loadBalancerType === "network");
      const targetGroups = serverGroup.targetGroups.map((targetGroupName) => {
        const allTargetGroups = flatten(loadBalancers.map((lb) => lb.targetGroups || []));
        const targetGroup = allTargetGroups.find((tg) => tg.name === targetGroupName && tg.region === serverGroup.region && tg.account === awsAccount);
        return this.buildTargetGroup(targetGroup, serverGroup);
      }).filter((tg) => tg);
      return targetGroups;
    });
  }
}

class LoadBalancerListItem extends React__default.Component {
  constructor() {
    super(...arguments);
    this.onClick = (e) => {
      this.props.onItemClick(this.props.loadBalancer);
      e.nativeEvent.preventDefault();
    };
  }
  render() {
    return /* @__PURE__ */ React__default.createElement("a", {
      onClick: this.onClick
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "name"
    }, this.props.loadBalancer.name), /* @__PURE__ */ React__default.createElement(HealthCounts, {
      container: this.props.loadBalancer.instanceCounts
    }));
  }
}
class LoadBalancerButton extends React__default.Component {
  constructor() {
    super(...arguments);
    this.onClick = (e) => {
      this.props.onItemClick(this.props.loadBalancer);
      e.nativeEvent.preventDefault();
    };
  }
  render() {
    return /* @__PURE__ */ React__default.createElement(Tooltip, {
      value: `${this.props.label || "Load Balancer"}: ${this.props.loadBalancer.name}`
    }, /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-link no-padding",
      onClick: this.onClick
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "badge badge-counter"
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "icon"
    }, /* @__PURE__ */ React__default.createElement("i", {
      className: "fa icon-sitemap"
    })))));
  }
}
class AmazonLoadBalancersTag extends React__default.Component {
  constructor(props) {
    super(props);
    this.mounted = false;
    this.showLoadBalancerDetails = (loadBalancer) => {
      const { $state } = ReactInjector;
      const serverGroup = this.props.serverGroup;
      logger.log({ category: "Cluster Pod", action: `Load Load Balancer Details (multiple menu)` });
      const nextState = $state.current.name.endsWith(".clusters") ? ".loadBalancerDetails" : "^.loadBalancerDetails";
      $state.go(nextState, {
        region: serverGroup.region,
        accountId: serverGroup.account,
        name: loadBalancer.name,
        provider: serverGroup.type
      });
    };
    this.showTargetGroupDetails = (targetGroup) => {
      const { $state } = ReactInjector;
      logger.log({ category: "Cluster Pod", action: `Load Target Group Details (multiple menu)` });
      const nextState = $state.current.name.endsWith(".clusters") ? ".targetGroupDetails" : "^.targetGroupDetails";
      $state.go(nextState, {
        region: targetGroup.region,
        accountId: targetGroup.account,
        name: targetGroup.name,
        provider: "aws",
        loadBalancerName: targetGroup.loadBalancerNames[0]
      });
    };
    this.handleShowPopover = () => {
      logger.log({ category: "Cluster Pod", action: `Show Load Balancers Menu` });
    };
    this.handleClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };
    this.state = {
      loadBalancers: [],
      targetGroups: [],
      isLoading: true
    };
  }
  componentDidMount() {
    this.mounted = true;
    this.loadBalancersRefreshUnsubscribe = this.props.application.getDataSource("loadBalancers").onRefresh(null, () => {
      this.forceUpdate();
    });
    LoadBalancerDataUtils.populateLoadBalancers(this.props.application, this.props.serverGroup).then((loadBalancers) => {
      if (this.mounted) {
        this.setState({ loadBalancers, isLoading: false });
      }
    });
    AmazonLoadBalancerDataUtils.populateTargetGroups(this.props.application, this.props.serverGroup).then((targetGroups) => {
      if (this.mounted) {
        this.setState({ targetGroups });
      }
    });
  }
  componentWillUnmount() {
    this.mounted = false;
    this.loadBalancersRefreshUnsubscribe();
  }
  render() {
    const { loadBalancers, targetGroups, isLoading } = this.state;
    const targetGroupCount = targetGroups && targetGroups.length || 0;
    const loadBalancerCount = loadBalancers && loadBalancers.length || 0;
    const totalCount = targetGroupCount + loadBalancerCount;
    if (!totalCount) {
      return isLoading ? /* @__PURE__ */ React__default.createElement(Spinner, {
        size: "nano"
      }) : null;
    }
    const className = `load-balancers-tag ${totalCount > 1 ? "overflowing" : ""}`;
    const popover = /* @__PURE__ */ React__default.createElement("div", {
      className: "menu-load-balancers"
    }, loadBalancerCount > 0 && /* @__PURE__ */ React__default.createElement("div", {
      className: "menu-load-balancers-header"
    }, "Load Balancers"), sortBy(loadBalancers, "name").map((loadBalancer) => /* @__PURE__ */ React__default.createElement(LoadBalancerListItem, {
      key: loadBalancer.name,
      loadBalancer,
      onItemClick: this.showLoadBalancerDetails
    })), targetGroupCount > 0 && /* @__PURE__ */ React__default.createElement("div", {
      className: "menu-load-balancers-header"
    }, "Target Groups"), sortBy(targetGroups, "name").map((targetGroup) => /* @__PURE__ */ React__default.createElement(LoadBalancerListItem, {
      key: targetGroup.name,
      loadBalancer: targetGroup,
      onItemClick: this.showTargetGroupDetails
    })));
    return /* @__PURE__ */ React__default.createElement("span", {
      className
    }, totalCount > 1 && /* @__PURE__ */ React__default.createElement(HoverablePopover, {
      delayShow: 100,
      delayHide: 150,
      onShow: this.handleShowPopover,
      placement: "bottom",
      template: popover,
      hOffsetPercent: "80%",
      container: this.props.container,
      className: "no-padding menu-load-balancers"
    }, /* @__PURE__ */ React__default.createElement("button", {
      onClick: this.handleClick,
      className: "btn btn-link btn-multiple-load-balancers clearfix no-padding"
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "badge badge-counter"
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "icon"
    }, /* @__PURE__ */ React__default.createElement("i", {
      className: "fa icon-sitemap"
    })), " ", totalCount))), loadBalancers.length === 1 && targetGroups.length === 0 && /* @__PURE__ */ React__default.createElement("span", {
      className: "btn-load-balancer"
    }, /* @__PURE__ */ React__default.createElement(LoadBalancerButton, {
      key: loadBalancers[0].name,
      label: "Load Balancer",
      loadBalancer: loadBalancers[0],
      onItemClick: this.showLoadBalancerDetails
    })), targetGroups.length === 1 && loadBalancers.length === 0 && /* @__PURE__ */ React__default.createElement("span", {
      className: "btn-load-balancer"
    }, /* @__PURE__ */ React__default.createElement(LoadBalancerButton, {
      key: targetGroups[0].name,
      label: "Target Group",
      loadBalancer: targetGroups[0],
      onItemClick: this.showTargetGroupDetails
    })));
  }
}

const ALBAdvancedSettings = React__default.forwardRef((_, ref) => /* @__PURE__ */ React__default.createElement("div", {
  ref
}, /* @__PURE__ */ React__default.createElement(FormikFormField, {
  name: "idleTimeout",
  label: "Idle Timeout",
  help: /* @__PURE__ */ React__default.createElement(HelpField, {
    id: "loadBalancer.advancedSettings.idleTimeout"
  }),
  input: (inputProps) => /* @__PURE__ */ React__default.createElement(NumberInput, {
    ...inputProps,
    min: 0
  })
}), /* @__PURE__ */ React__default.createElement(FormikFormField, {
  name: "deletionProtection",
  label: "Protection",
  help: /* @__PURE__ */ React__default.createElement(HelpField, {
    id: "loadBalancer.advancedSettings.deletionProtection"
  }),
  input: (inputProps) => /* @__PURE__ */ React__default.createElement(CheckboxInput, {
    ...inputProps,
    text: "Enable delete protection"
  })
}), /* @__PURE__ */ React__default.createElement(FormikFormField, {
  name: "dualstack",
  label: "Dualstack",
  help: /* @__PURE__ */ React__default.createElement(HelpField, {
    id: "loadBalancer.advancedSettings.albIpAddressType"
  }),
  input: (inputProps) => /* @__PURE__ */ React__default.createElement(CheckboxInput, {
    ...inputProps,
    text: "Assign Ipv4 and IPv6"
  })
})));

var css_248z$h = ".configure-config-modal .StandardFieldLayout .sm-label-right {\n  min-width: 160px;\n}\n";
styleInject(css_248z$h);

const _ConfigureOidcConfigModal = class extends React__default.Component {
  constructor(props) {
    super(props);
    this.close = (reason) => {
      this.props.dismissModal(reason);
    };
    this.submit = (data) => {
      this.props.closeModal(data);
    };
    this.validate = () => {
      return {};
    };
    const config = props.config || {};
    this.state = {
      initialValues: {
        authorizationEndpoint: config.authorizationEndpoint || "",
        clientId: config.clientId || "",
        clientSecret: config.clientSecret || "",
        issuer: config.issuer || "",
        scope: config.scope || "openid",
        sessionCookieName: config.sessionCookieName || "AWSELBAuthSessionCookie",
        tokenEndpoint: config.tokenEndpoint || "",
        userInfoEndpoint: config.userInfoEndpoint || ""
      }
    };
  }
  static show(props) {
    return ReactModal.show(_ConfigureOidcConfigModal, props);
  }
  render() {
    const { initialValues } = this.state;
    const submitLabel = "Save Client";
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "configure-config-modal"
    }, /* @__PURE__ */ React__default.createElement(SpinFormik, {
      initialValues,
      onSubmit: this.submit,
      validate: this.validate,
      render: ({ isValid }) => /* @__PURE__ */ React__default.createElement(Form, {
        className: "form-horizontal"
      }, /* @__PURE__ */ React__default.createElement(ModalClose, {
        dismiss: this.close
      }), /* @__PURE__ */ React__default.createElement(Modal.Header, null, /* @__PURE__ */ React__default.createElement(Modal.Title, null, "Configure OIDC Client")), /* @__PURE__ */ React__default.createElement(Modal.Body, null, /* @__PURE__ */ React__default.createElement(FormikFormField, {
        name: "issuer",
        label: "Issuer",
        required: true,
        input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
          ...props,
          placeholder: "Enter the OpenId Provider"
        })
      }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
        name: "authorizationEndpoint",
        label: "Authorization Endpoint",
        required: true,
        input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
          ...props,
          placeholder: "Enter OpenID provider server endpoint"
        })
      }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
        name: "tokenEndpoint",
        label: "Token Endpoint",
        required: true,
        input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
          ...props,
          placeholder: "Enter a URI for your token endpoint"
        })
      }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
        name: "userInfoEndpoint",
        label: "User info Endpoint",
        required: true,
        input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
          ...props,
          placeholder: "Enter a URI for your user info endpoint"
        })
      }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
        name: "clientId",
        label: "Client ID",
        required: true,
        input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
          ...props,
          placeholder: "Enter the client ID"
        })
      }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
        name: "clientSecret",
        label: "Client secret",
        required: true,
        input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
          ...props,
          placeholder: "Enter the client secret"
        })
      })), /* @__PURE__ */ React__default.createElement(Modal.Footer, null, /* @__PURE__ */ React__default.createElement("button", {
        className: "btn btn-default",
        onClick: this.close,
        type: "button"
      }, "Cancel"), /* @__PURE__ */ React__default.createElement(SubmitButton, {
        isDisabled: !isValid,
        submitting: false,
        isFormSubmit: true,
        label: submitLabel
      })))
    }));
  }
};
let ConfigureOidcConfigModal = _ConfigureOidcConfigModal;
ConfigureOidcConfigModal.defaultProps = {
  closeModal: noop,
  dismissModal: noop
};

const _ConfigureRedirectConfigModal = class extends React__default.Component {
  constructor(props) {
    super(props);
    this.close = (reason) => {
      this.props.dismissModal(reason);
    };
    this.submit = (data) => {
      const filteredData = pickBy(data, (value) => value && value !== "");
      this.props.closeModal(filteredData);
    };
    const config = props.config || {};
    this.initialValues = {
      host: config.host || "",
      path: config.path || "",
      port: config.port || "",
      protocol: config.protocol || void 0,
      query: config.query || "",
      statusCode: config.statusCode || "HTTP_301"
    };
  }
  static show(props) {
    return ReactModal.show(_ConfigureRedirectConfigModal, props);
  }
  render() {
    const submitLabel = "Save Config";
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "configure-config-modal"
    }, /* @__PURE__ */ React__default.createElement(SpinFormik, {
      initialValues: this.initialValues,
      onSubmit: this.submit,
      render: ({ isValid }) => /* @__PURE__ */ React__default.createElement(Form, {
        className: "form-horizontal"
      }, /* @__PURE__ */ React__default.createElement(ModalClose, {
        dismiss: this.close
      }), /* @__PURE__ */ React__default.createElement(Modal.Header, null, /* @__PURE__ */ React__default.createElement(Modal.Title, null, "Configure Redirect ", /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "aws.loadBalancer.redirect"
      }))), /* @__PURE__ */ React__default.createElement(Modal.Body, null, /* @__PURE__ */ React__default.createElement(FormikFormField, {
        name: "host",
        label: "Host",
        required: false,
        input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
          ...props
        }),
        help: /* @__PURE__ */ React__default.createElement(HelpField, {
          id: "aws.loadBalancer.redirect.host"
        })
      }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
        name: "path",
        label: "Path",
        required: false,
        input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
          ...props
        }),
        help: /* @__PURE__ */ React__default.createElement(HelpField, {
          id: "aws.loadBalancer.redirect.path"
        })
      }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
        name: "port",
        label: "Port",
        required: false,
        input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
          ...props
        }),
        help: /* @__PURE__ */ React__default.createElement(HelpField, {
          id: "aws.loadBalancer.redirect.port"
        })
      }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
        name: "protocol",
        label: "Protocol",
        required: false,
        input: (props) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
          ...props,
          stringOptions: ["HTTP", "HTTPS", "#{protocol}"],
          placeholder: "Select Protocol",
          clearable: false,
          style: { width: "130px" }
        }),
        help: /* @__PURE__ */ React__default.createElement(HelpField, {
          id: "aws.loadBalancer.redirect.protocol"
        })
      }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
        name: "query",
        label: "Query",
        required: false,
        input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
          ...props
        }),
        help: /* @__PURE__ */ React__default.createElement(HelpField, {
          id: "aws.loadBalancer.redirect.query"
        })
      }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
        name: "statusCode",
        label: "Status Code",
        required: true,
        input: (props) => /* @__PURE__ */ React__default.createElement(SelectInput, {
          ...props,
          options: ["HTTP_301", "HTTP_302"]
        }),
        help: /* @__PURE__ */ React__default.createElement(HelpField, {
          id: "aws.loadBalancer.redirect.statusCode"
        })
      })), /* @__PURE__ */ React__default.createElement(Modal.Footer, null, /* @__PURE__ */ React__default.createElement("button", {
        className: "btn btn-default",
        onClick: this.close,
        type: "button"
      }, "Cancel"), /* @__PURE__ */ React__default.createElement(SubmitButton, {
        isDisabled: !isValid,
        submitting: false,
        isFormSubmit: true,
        label: submitLabel
      })))
    }));
  }
};
let ConfigureRedirectConfigModal = _ConfigureRedirectConfigModal;
ConfigureRedirectConfigModal.defaultProps = {
  closeModal: noop,
  dismissModal: noop
};

class OidcConfigReader {
  static getOidcConfigsByApp(app) {
    return REST("/oidcConfigs").query({ app }).get();
  }
}

class AmazonCertificateReader {
  static listCertificates() {
    return CertificateReader.listCertificatesByProvider("aws").then((certificates) => {
      return AccountService.listAllAccounts("aws").then((allAccountDetails) => {
        const accountIdToName = allAccountDetails.reduce((acc, accountDetails) => {
          acc[accountDetails.accountId] = accountDetails.name;
          return acc;
        }, {});
        const sortedCertificates = sortBy(certificates, "serverCertificateName");
        return groupBy(sortedCertificates, (cert) => {
          const [, , , , accountId] = cert.arn.split(":");
          return accountIdToName[accountId] || "unknown";
        });
      });
    });
  }
}

var __defProp$7 = Object.defineProperty;
var __getOwnPropDesc$7 = Object.getOwnPropertyDescriptor;
var __decorateClass$7 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$7(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$7(target, key, result);
  return result;
};
let AmazonCertificateSelectField = class extends React__default.Component {
  render() {
    const { certificates, accountName, onCertificateSelect, currentValue } = this.props;
    const certificatesForAccount = certificates[accountName] || [];
    const certificateOptions = certificatesForAccount.map((cert) => {
      return { label: cert.serverCertificateName, value: cert.serverCertificateName };
    });
    const currentCert = certificatesForAccount.find((c) => c.serverCertificateName === currentValue);
    return /* @__PURE__ */ React__default.createElement("div", {
      style: { width: "100%" }
    }, /* @__PURE__ */ React__default.createElement(Select, {
      className: "input-sm",
      wrapperStyle: { width: "100%" },
      clearable: true,
      required: true,
      options: certificateOptions,
      onChange: (value) => onCertificateSelect(value.value),
      value: currentValue
    }), currentCert && /* @__PURE__ */ React__default.createElement("div", {
      className: "small sp-margin-xs-top sp-margin-m-bottom sp-margin-m-left"
    }, /* @__PURE__ */ React__default.createElement("div", null, "Uploaded ", relativeTime(currentCert.uploadDate), " (", timestamp(currentCert.uploadDate), ")"), /* @__PURE__ */ React__default.createElement("b", null, "Expires ", relativeTime(currentCert.expiration)), " (", timestamp(currentCert.expiration), ")"));
  }
};
AmazonCertificateSelectField = __decorateClass$7([
  Overridable("amazon.certificateSelectField")
], AmazonCertificateSelectField);

const DragHandle$1 = SortableHandle(() => /* @__PURE__ */ React__default.createElement("span", {
  className: "pipeline-drag-handle clickable glyphicon glyphicon-resize-vertical"
}));
const defaultAuthAction = {
  authenticateOidcConfig: {
    authorizationEndpoint: "",
    clientId: "",
    issuer: "",
    scope: "openid",
    sessionCookieName: "AWSELBAuthSessionCookie",
    tokenEndpoint: "",
    userInfoEndpoint: ""
  },
  type: "authenticate-oidc"
};
class ALBListeners extends React__default.Component {
  constructor(props) {
    super(props);
    this.protocols = ["HTTP", "HTTPS"];
    this.initialActionsWithAuth = new Set();
    this.initialListenersWithDefaultAuth = new Set();
    this.removedAuthActions = new Map();
    this.attachClientSecret = (action, oidcConfigs) => {
      if (action.type === "authenticate-oidc") {
        const config = oidcConfigs.find((c) => c.clientId === action.authenticateOidcConfig.clientId);
        if (config) {
          action.authenticateOidcConfig.clientSecret = config.clientSecret;
        }
      }
    };
    this.addListener = () => {
      this.props.formik.values.listeners.push({
        certificates: [],
        protocol: "HTTP",
        port: 80,
        defaultActions: [
          {
            type: "forward",
            targetGroupName: ""
          }
        ],
        rules: []
      });
      this.updateListeners();
    };
    this.addRule = (listener) => {
      const newRule = {
        priority: null,
        actions: [
          {
            type: "forward",
            targetGroupName: ""
          }
        ],
        conditions: [
          {
            field: "path-pattern",
            values: [""]
          }
        ]
      };
      listener.rules.push(newRule);
      this.updateListeners();
    };
    this.removeRule = (listener, index) => {
      listener.rules.splice(index, 1);
      this.updateListeners();
    };
    this.handleConditionFieldChanged = (condition, newField) => {
      condition.field = newField;
      if (newField === "http-request-method") {
        condition.values = [];
      }
      this.updateListeners();
    };
    this.handleConditionValueChanged = (condition, newValue) => {
      condition.values[0] = newValue;
      this.updateListeners();
    };
    this.handleHttpRequestMethodChanged = (condition, newValue, selected) => {
      let newValues = condition.values || [];
      if (selected) {
        newValues.push(newValue);
      } else {
        newValues = newValues.filter((v) => v !== newValue);
      }
      condition.values = newValues;
      condition.httpRequestMethodConfig = {
        values: newValues
      };
      this.updateListeners();
    };
    this.addCondition = (rule) => {
      if (rule.conditions.length === 1) {
        const field = rule.conditions[0].field === "path-pattern" ? "host-header" : "path-pattern";
        rule.conditions.push({ field, values: [""] });
      }
      this.updateListeners();
    };
    this.removeCondition = (rule, index) => {
      rule.conditions.splice(index, 1);
      this.updateListeners();
    };
    this.handleRuleActionTargetChanged = (action, newTarget) => {
      action.targetGroupName = newTarget;
      this.updateListeners();
    };
    this.handleRuleActionTypeChanged = (action, newType) => {
      action.type = newType;
      if (action.type === "forward") {
        delete action.redirectActionConfig;
      } else if (action.type === "redirect") {
        action.redirectActionConfig = {
          statusCode: "HTTP_301"
        };
        delete action.targetGroupName;
      }
      this.updateListeners();
    };
    this.handleSortEnd = (sortEnd, listener) => {
      listener.rules = arrayMove(listener.rules, sortEnd.oldIndex, sortEnd.newIndex);
      this.updateListeners();
    };
    this.configureOidcClient = (action) => {
      ConfigureOidcConfigModal.show({ config: action.authenticateOidcConfig }).then((config) => {
        action.authenticateOidcConfig = config;
        this.updateListeners();
      }).catch(() => {
      });
    };
    this.configureRedirect = (action) => {
      ConfigureRedirectConfigModal.show({ config: action.redirectActionConfig }).then((config) => {
        action.redirectActionConfig = config;
        this.updateListeners();
      }).catch(() => {
      });
    };
    this.authenticateRuleToggle = (listener, ruleIndex) => {
      const rules = listener.rules[ruleIndex];
      const actions = rules && rules.actions || listener.defaultActions;
      if (actions) {
        const authIndex = actions.findIndex((a) => a.type === "authenticate-oidc");
        if (authIndex !== -1) {
          this.removeAuthAction(listener, actions, authIndex, ruleIndex);
        } else {
          const removedAction = this.removedAuthActions.has(listener) ? this.removedAuthActions.get(listener)[ruleIndex || -1] : void 0;
          const newAuthAction = removedAction || { ...defaultAuthAction };
          actions.unshift({ ...newAuthAction });
        }
        this.updateListeners();
      }
    };
    this.oidcConfigChanged = (action, config) => {
      action.authenticateOidcConfig = { ...config };
      this.updateListeners();
    };
    this.redirectConfigChanged = (action, config) => {
      action.redirectActionConfig = { ...config };
      this.updateListeners();
    };
    this.state = {
      certificates: [],
      certificateTypes: get(AWSProviderSettings, "loadBalancers.certificateTypes", ["iam", "acm"]),
      oidcConfigs: void 0
    };
    this.props.formik.initialValues.listeners.forEach((l) => {
      const hasDefaultAuth = l.defaultActions[0].type === "authenticate-oidc";
      if (hasDefaultAuth) {
        this.initialListenersWithDefaultAuth.add(l);
      }
      l.rules.forEach((r) => {
        if (r.actions[0].type === "authenticate-oidc") {
          this.initialActionsWithAuth.add(r.actions);
        }
      });
    });
  }
  getAllTargetGroupsFromListeners(listeners) {
    const actions = flatten(listeners.map((l) => l.defaultActions));
    const rules = flatten(listeners.map((l) => l.rules));
    actions.push(...flatten(rules.map((r) => r.actions)));
    return uniq(actions.map((a) => a.targetGroupName));
  }
  validate(values) {
    const errors = {};
    const targetGroupNames = values.targetGroups.map((tg) => tg.name);
    const usedTargetGroupNames = this.getAllTargetGroupsFromListeners(values.listeners);
    const unusedTargetGroupNames = difference(targetGroupNames, usedTargetGroupNames);
    if (unusedTargetGroupNames.length === 1) {
      errors.listeners = `Target group ${unusedTargetGroupNames[0]} is unused.`;
    } else if (unusedTargetGroupNames.length > 1) {
      errors.listeners = `Target groups ${unusedTargetGroupNames.join(", ")} are unused.`;
    }
    const { listeners } = values;
    if (uniqBy(listeners, "port").length < listeners.length) {
      errors.listenerPorts = "Multiple listeners cannot use the same port.";
    }
    const missingRuleFields = values.listeners.find((l) => {
      const defaultActionsHaveMissingTarget = !!l.defaultActions.find((da) => da.type === "forward" && !da.targetGroupName || da.type === "authenticate-oidc" && !da.authenticateOidcConfig.clientId || da.type === "redirect" && (!da.redirectActionConfig || !some(da.redirectActionConfig, (field) => field && field !== "")));
      const rulesHaveMissingFields = !!l.rules.find((rule) => {
        const missingTargets = !!rule.actions.find((a) => a.type === "forward" && !a.targetGroupName);
        const missingAuth = !!rule.actions.find((a) => a.type === "authenticate-oidc" && !a.authenticateOidcConfig.clientId);
        const missingValue = !!rule.conditions.find((c) => {
          if (c.field === "http-request-method") {
            return !c.values.length;
          }
          return c.values.includes("");
        });
        return missingTargets || missingAuth || missingValue;
      });
      return defaultActionsHaveMissingTarget || rulesHaveMissingFields;
    });
    if (missingRuleFields) {
      errors.listeners = `Missing fields in rule configuration.`;
    }
    return errors;
  }
  componentDidMount() {
    this.loadCertificates();
    this.loadOidcClients();
  }
  loadCertificates() {
    AmazonCertificateReader.listCertificates().then((certificates) => {
      this.setState({ certificates });
    });
  }
  loadOidcClients() {
    OidcConfigReader.getOidcConfigsByApp(this.props.app.name).then((oidcConfigs) => {
      if (oidcConfigs && oidcConfigs.length) {
        this.props.formik.values.listeners.forEach((listener) => {
          listener.defaultActions.forEach((action) => this.attachClientSecret(action, oidcConfigs));
          listener.rules.forEach((rule) => rule.actions.forEach((action) => this.attachClientSecret(action, oidcConfigs)));
        });
      }
      this.setState({ oidcConfigs });
      this.updateListeners();
    }).catch(() => {
    });
  }
  updateListeners() {
    this.props.formik.setFieldValue("listeners", this.props.formik.values.listeners);
  }
  needsCert(listener) {
    return listener.protocol === "HTTPS";
  }
  showCertificateSelect(certificate) {
    return certificate.type === "iam" && this.state.certificates && Object.keys(this.state.certificates).length > 0;
  }
  addListenerCertificate(listener) {
    listener.certificates = listener.certificates || [];
    listener.certificates.push({
      certificateArn: void 0,
      type: "iam",
      name: void 0
    });
  }
  removeAuthActions(listener) {
    const authIndex = listener.defaultActions.findIndex((a) => a.type === "authenticate-oidc");
    if (authIndex !== -1) {
      this.removeAuthAction(listener, listener.defaultActions, authIndex, -1);
    }
    listener.rules.forEach((rule, ruleIndex) => {
      const index = rule.actions.findIndex((a) => a.type === "authenticate-oidc");
      if (index !== -1) {
        this.removeAuthAction(listener, rule.actions, index, ruleIndex);
      }
    });
    this.updateListeners();
  }
  reenableAuthActions(listener) {
    const removedAuthActions = this.removedAuthActions.has(listener) ? this.removedAuthActions.get(listener) : [];
    const existingDefaultAuthAction = removedAuthActions[-1];
    if (existingDefaultAuthAction) {
      removedAuthActions[-1] = void 0;
      listener.defaultActions.unshift({ ...existingDefaultAuthAction });
    }
    listener.rules.forEach((rule, ruleIndex) => {
      const existingAuthAction = removedAuthActions[ruleIndex];
      removedAuthActions[ruleIndex] = void 0;
      if (existingAuthAction) {
        rule.actions.unshift({ ...existingAuthAction });
      }
    });
  }
  listenerProtocolChanged(listener, newProtocol) {
    listener.protocol = newProtocol;
    if (listener.protocol === "HTTPS") {
      listener.port = 443;
      if (!listener.certificates || listener.certificates.length === 0) {
        this.addListenerCertificate(listener);
      }
      this.reenableAuthActions(listener);
    }
    if (listener.protocol === "HTTP") {
      listener.port = 80;
      listener.certificates.length = 0;
      this.removeAuthActions(listener);
    }
    this.updateListeners();
  }
  listenerPortChanged(listener, newPort) {
    listener.port = Number.parseInt(newPort, 10);
    this.updateListeners();
  }
  certificateTypeChanged(certificate, newType) {
    certificate.type = newType;
    this.updateListeners();
  }
  handleCertificateChanged(certificate, newCertificateName) {
    certificate.name = newCertificateName;
    this.updateListeners();
  }
  removeListener(index) {
    this.props.formik.values.listeners.splice(index, 1);
    this.updateListeners();
  }
  removeAuthActionInternal(listener, actions, authIndex, ruleIndex = -1) {
    const removedAuthAction = actions.splice(authIndex, 1)[0];
    if (!this.removedAuthActions.has(listener)) {
      this.removedAuthActions.set(listener, []);
    }
    this.removedAuthActions.get(listener)[ruleIndex || -1] = removedAuthAction;
    this.updateListeners();
  }
  removeAuthAction(listener, actions, authIndex, ruleIndex = -1) {
    const confirmDefaultRemove = ruleIndex === -1 && this.initialListenersWithDefaultAuth.has(listener);
    const confirmRemove = ruleIndex > -1 && this.initialActionsWithAuth.has(actions);
    if (confirmDefaultRemove || confirmRemove) {
      ConfirmationModalService.confirm({
        header: "Really remove authentication?",
        buttonText: `Remove Auth`,
        submitMethod: () => {
          this.removeAuthActionInternal(listener, actions, authIndex, ruleIndex);
          if (confirmDefaultRemove) {
            this.initialListenersWithDefaultAuth.delete(listener);
          }
          if (confirmRemove) {
            this.initialActionsWithAuth.delete(actions);
          }
          return $q.resolve();
        }
      });
    } else {
      this.removeAuthActionInternal(listener, actions, authIndex, ruleIndex);
    }
  }
  render() {
    const { errors, values } = this.props.formik;
    const { certificates, certificateTypes, oidcConfigs } = this.state;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "container-fluid form-horizontal"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12"
    }, values.listeners.map((listener, index) => /* @__PURE__ */ React__default.createElement("div", {
      key: index,
      className: "wizard-pod"
    }, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", {
      className: "wizard-pod-row header"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "wizard-pod-row-title"
    }, "Listen On"), /* @__PURE__ */ React__default.createElement("div", {
      className: "wizard-pod-row-contents spread"
    }, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("span", {
      className: "wizard-pod-content"
    }, /* @__PURE__ */ React__default.createElement("label", null, "Protocol"), /* @__PURE__ */ React__default.createElement("select", {
      className: "form-control input-sm inline-number",
      style: { width: "80px" },
      value: listener.protocol,
      onChange: (event) => this.listenerProtocolChanged(listener, event.target.value)
    }, this.protocols.map((p) => /* @__PURE__ */ React__default.createElement("option", {
      key: p
    }, p)))), /* @__PURE__ */ React__default.createElement("span", {
      className: "wizard-pod-content"
    }, /* @__PURE__ */ React__default.createElement("label", null, "Port"), /* @__PURE__ */ React__default.createElement("input", {
      className: "form-control input-sm inline-number",
      type: "text",
      min: 0,
      value: listener.port || "",
      onChange: (event) => this.listenerPortChanged(listener, event.target.value),
      style: { width: "80px" },
      required: true
    }))), /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("a", {
      className: "sm-label clickable",
      onClick: () => this.removeListener(index)
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-trash"
    }))))), this.needsCert(listener) && /* @__PURE__ */ React__default.createElement("div", {
      className: "wizard-pod-row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "wizard-pod-row-title"
    }, "Certificate"), /* @__PURE__ */ React__default.createElement("div", {
      className: "wizard-pod-row-contents"
    }, listener.certificates.map((certificate, cIndex) => /* @__PURE__ */ React__default.createElement("div", {
      key: cIndex,
      style: { width: "100%", display: "flex", flexDirection: "row" }
    }, /* @__PURE__ */ React__default.createElement("select", {
      className: "form-control input-sm inline-number",
      style: { width: "45px" },
      value: certificate.type,
      onChange: (event) => this.certificateTypeChanged(certificate, event.target.value)
    }, certificateTypes.map((t) => /* @__PURE__ */ React__default.createElement("option", {
      key: t
    }, t))), this.showCertificateSelect(certificate) && /* @__PURE__ */ React__default.createElement(AmazonCertificateSelectField, {
      certificates,
      accountName: values.credentials,
      currentValue: certificate.name,
      app: this.props.app,
      onCertificateSelect: (value) => this.handleCertificateChanged(certificate, value)
    }), !this.showCertificateSelect(certificate) && /* @__PURE__ */ React__default.createElement("input", {
      className: "form-control input-sm no-spel",
      style: { display: "inline-block" },
      type: "text",
      value: certificate.name,
      onChange: (event) => this.handleCertificateChanged(certificate, event.target.value),
      required: true
    }))))), /* @__PURE__ */ React__default.createElement("div", {
      className: "wizard-pod-row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "wizard-pod-row-contents",
      style: { padding: "0" }
    }, /* @__PURE__ */ React__default.createElement("table", {
      className: "table table-condensed packed rules-table"
    }, /* @__PURE__ */ React__default.createElement("thead", null, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("th", {
      style: { width: "15px", padding: "0" }
    }), /* @__PURE__ */ React__default.createElement("th", null, "If"), /* @__PURE__ */ React__default.createElement("th", {
      style: { width: "315px" }
    }, "Then"), /* @__PURE__ */ React__default.createElement("th", {
      style: { width: "45px" }
    }))), /* @__PURE__ */ React__default.createElement(Rules, {
      addCondition: this.addCondition,
      addRule: this.addRule,
      authenticateRuleToggle: this.authenticateRuleToggle,
      distance: 10,
      handleConditionFieldChanged: this.handleConditionFieldChanged,
      handleConditionValueChanged: this.handleConditionValueChanged,
      handleHttpRequestMethodChanged: this.handleHttpRequestMethodChanged,
      handleRuleActionTargetChanged: this.handleRuleActionTargetChanged,
      handleRuleActionTypeChanged: this.handleRuleActionTypeChanged,
      listener,
      helperClass: "rule-sortable-helper",
      removeRule: this.removeRule,
      removeCondition: this.removeCondition,
      targetGroups: values.targetGroups,
      oidcConfigs,
      oidcConfigChanged: this.oidcConfigChanged,
      redirectConfigChanged: this.redirectConfigChanged,
      onSortEnd: (sortEnd) => this.handleSortEnd(sortEnd, listener),
      configureOidcClient: this.configureOidcClient,
      configureRedirect: this.configureRedirect
    }))))))), errors.listenerPorts && /* @__PURE__ */ React__default.createElement("div", {
      className: "wizard-pod-row-errors"
    }, /* @__PURE__ */ React__default.createElement(ValidationMessage, {
      type: "error",
      message: errors.listenerPorts
    })), errors.listeners && /* @__PURE__ */ React__default.createElement("div", {
      className: "wizard-pod-row-errors"
    }, /* @__PURE__ */ React__default.createElement(ValidationMessage, {
      type: "error",
      message: errors.listeners
    })), /* @__PURE__ */ React__default.createElement("table", {
      className: "table table-condensed packed"
    }, /* @__PURE__ */ React__default.createElement("tbody", null, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement("button", {
      type: "button",
      className: "add-new col-md-12",
      onClick: this.addListener
    }, /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-plus-sign"
    }), " Add new listener")))))))));
  }
}
const Rule = SortableElement((props) => /* @__PURE__ */ React__default.createElement("tr", {
  className: "listener-rule"
}, /* @__PURE__ */ React__default.createElement("td", {
  className: "handle"
}, /* @__PURE__ */ React__default.createElement(DragHandle$1, null)), /* @__PURE__ */ React__default.createElement("td", null, props.rule.conditions.map((condition, cIndex) => /* @__PURE__ */ React__default.createElement("div", {
  key: cIndex,
  className: "listener-rule-condition"
}, /* @__PURE__ */ React__default.createElement("select", {
  className: "form-control input-sm inline-number",
  value: condition.field,
  onChange: (event) => props.handleConditionFieldChanged(condition, event.target.value),
  style: { width: "40%" },
  required: true
}, (props.rule.conditions.length === 1 || condition.field === "host-header") && /* @__PURE__ */ React__default.createElement("option", {
  value: "host-header"
}, "Host"), (props.rule.conditions.length === 1 || condition.field === "path-pattern") && /* @__PURE__ */ React__default.createElement("option", {
  value: "path-pattern"
}, "Path"), (props.rule.conditions.length === 1 || condition.field === "http-request-method") && /* @__PURE__ */ React__default.createElement("option", {
  value: "http-request-method"
}, "Method(s)")), condition.field === "path-pattern" && /* @__PURE__ */ React__default.createElement(HelpField, {
  id: "aws.loadBalancer.ruleCondition.path"
}), condition.field === "host-header" && /* @__PURE__ */ React__default.createElement(HelpField, {
  id: "aws.loadBalancer.ruleCondition.host"
}), condition.field !== "http-request-method" && /* @__PURE__ */ React__default.createElement("input", {
  className: "form-control input-sm",
  type: "text",
  value: condition.values[0],
  onChange: (event) => props.handleConditionValueChanged(condition, event.target.value),
  maxLength: 128,
  required: true,
  style: { width: "63%" }
}), condition.field === "http-request-method" && /* @__PURE__ */ React__default.createElement("div", {
  className: "col-md-6 checkbox"
}, ["DELETE", "GET", "PATCH", "POST", "PUT"].map((httpMethod) => /* @__PURE__ */ React__default.createElement("label", {
  key: `${httpMethod}-checkbox`
}, /* @__PURE__ */ React__default.createElement("input", {
  type: "checkbox",
  checked: condition.values.includes(httpMethod),
  onChange: (event) => props.handleHttpRequestMethodChanged(condition, httpMethod, event.target.checked)
}), httpMethod))), /* @__PURE__ */ React__default.createElement("span", {
  className: "remove-condition"
}, cIndex === 1 && /* @__PURE__ */ React__default.createElement("a", {
  className: "btn btn-sm btn-link clickable",
  onClick: () => props.removeCondition(props.rule, cIndex),
  style: { padding: "0" }
}, /* @__PURE__ */ React__default.createElement(Tooltip, {
  value: "Remove Condition"
}, /* @__PURE__ */ React__default.createElement("span", {
  className: "glyphicon glyphicon-trash"
})))))), props.rule.conditions.length === 1 && /* @__PURE__ */ React__default.createElement("div", {
  className: "add-new-container"
}, /* @__PURE__ */ React__default.createElement("button", {
  type: "button",
  className: "add-new col-md-12",
  onClick: () => props.addCondition(props.rule)
}, /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("span", {
  className: "glyphicon glyphicon-plus-sign"
}), " Add new condition")), /* @__PURE__ */ React__default.createElement("span", {
  style: { minWidth: "15px" }
}))), /* @__PURE__ */ React__default.createElement("td", null, props.rule.actions.map((action, index) => /* @__PURE__ */ React__default.createElement(Action, {
  key: index,
  action,
  actionTypeChanged: (type) => props.handleRuleActionTypeChanged(action, type),
  oidcConfigChanged: (config) => props.oidcConfigChanged(action, config),
  redirectConfigChanged: (config) => props.redirectConfigChanged(action, config),
  targetChanged: (target) => props.handleRuleActionTargetChanged(action, target),
  targetGroups: props.targetGroups,
  oidcConfigs: props.oidcConfigs,
  configureOidcClient: props.configureOidcClient,
  configureRedirect: props.configureRedirect
}))), /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement(RuleActions, {
  ruleIndex: props.ruleIndex,
  listener: props.listener,
  authenticateRuleToggle: props.authenticateRuleToggle,
  removeRule: props.removeRule,
  actions: props.rule.actions
}))));
const Action = (props) => {
  var _a;
  if (props.action.type !== "authenticate-oidc") {
    const redirectConfig = props.action.redirectActionConfig || props.action.redirectConfig;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "horizontal top"
    }, /* @__PURE__ */ React__default.createElement("select", {
      className: "form-control input-sm",
      style: { width: "80px" },
      value: props.action.type,
      onChange: (event) => props.actionTypeChanged(event.target.value)
    }, /* @__PURE__ */ React__default.createElement("option", {
      value: "forward"
    }, "forward to"), /* @__PURE__ */ React__default.createElement("option", {
      value: "redirect"
    }, "redirect to")), props.action.type === "forward" && /* @__PURE__ */ React__default.createElement("select", {
      className: "form-control input-sm",
      value: props.action.targetGroupName,
      onChange: (event) => props.targetChanged(event.target.value),
      required: true
    }, /* @__PURE__ */ React__default.createElement("option", {
      value: ""
    }), uniq(props.targetGroups.map((tg) => tg.name)).map((name) => /* @__PURE__ */ React__default.createElement("option", {
      key: name
    }, name))), props.action.type === "redirect" && /* @__PURE__ */ React__default.createElement("dl", {
      className: "dl-horizontal dl-narrow"
    }, /* @__PURE__ */ React__default.createElement("dt", null, "Host"), /* @__PURE__ */ React__default.createElement("dd", null, redirectConfig.host), /* @__PURE__ */ React__default.createElement("dt", null, "Path"), /* @__PURE__ */ React__default.createElement("dd", null, redirectConfig.path), /* @__PURE__ */ React__default.createElement("dt", null, "Port"), /* @__PURE__ */ React__default.createElement("dd", null, redirectConfig.port), /* @__PURE__ */ React__default.createElement("dt", null, "Protocol"), /* @__PURE__ */ React__default.createElement("dd", null, redirectConfig.protocol), /* @__PURE__ */ React__default.createElement("dt", null, "Query"), /* @__PURE__ */ React__default.createElement("dd", null, redirectConfig.query), /* @__PURE__ */ React__default.createElement("dt", null, "Status Code"), /* @__PURE__ */ React__default.createElement("dd", null, redirectConfig.statusCode), /* @__PURE__ */ React__default.createElement("dt", null, /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-link no-padding",
      type: "button",
      onClick: () => props.configureRedirect(props.action)
    }, "Configure..."))));
  }
  if (props.action.type === "authenticate-oidc") {
    const clientId = props.action.authenticateOidcConfig.clientId;
    const disableManualOidcDialog = get(AWSProviderSettings, "loadBalancers.disableManualOidcDialog", false);
    const showOidcConfigs = disableManualOidcDialog || props.oidcConfigs && props.oidcConfigs.length > 0 && (!clientId || props.oidcConfigs.find((c) => c.clientId === clientId));
    const oidcOptions = ((_a = props.oidcConfigs) == null ? void 0 : _a.length) ? props.oidcConfigs.map((config) => /* @__PURE__ */ React__default.createElement("option", {
      key: config.clientId
    }, config.clientId)) : /* @__PURE__ */ React__default.createElement("option", {
      disabled: true
    }, "No ", CustomLabels.get("OIDC client"), " config found");
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "horizontal middle",
      style: { height: "30px" }
    }, /* @__PURE__ */ React__default.createElement("span", {
      style: { whiteSpace: "pre" }
    }, "auth with ", CustomLabels.get("OIDC client"), " "), showOidcConfigs && /* @__PURE__ */ React__default.createElement("select", {
      className: "form-control input-sm",
      value: clientId,
      onChange: (event) => props.oidcConfigChanged(props.oidcConfigs.find((c) => c.clientId === event.target.value)),
      required: true
    }, /* @__PURE__ */ React__default.createElement("option", {
      value: ""
    }), oidcOptions), !showOidcConfigs && /* @__PURE__ */ React__default.createElement("a", {
      onClick: () => props.configureOidcClient(props.action),
      className: "clickable"
    }, clientId || "Configure..."), /* @__PURE__ */ React__default.createElement("span", {
      style: { whiteSpace: "pre" }
    }, /* @__PURE__ */ React__default.createElement("em", null, " and then")));
  }
  return null;
};
const RuleActions = (props) => {
  const hasAuth = Boolean(props.actions.find((a) => a.type === "authenticate-oidc"));
  const allowAuth = props.listener.protocol === "HTTPS";
  const tooltip = hasAuth ? "Remove authentication from rule" : "Authenticate rule";
  const icon = hasAuth ? "fas fa-fw fa-lock-open" : "fas fa-fw fa-user-lock";
  return /* @__PURE__ */ React__default.createElement("span", null, allowAuth && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("a", {
    className: "btn btn-sm btn-link clickable",
    onClick: () => props.authenticateRuleToggle(props.listener, props.ruleIndex),
    style: { padding: "0" }
  }, /* @__PURE__ */ React__default.createElement(Tooltip, {
    value: tooltip
  }, /* @__PURE__ */ React__default.createElement("i", {
    className: icon
  }))), /* @__PURE__ */ React__default.createElement(HelpField, {
    id: "aws.loadBalancer.oidcAuthentication"
  })), props.ruleIndex !== void 0 && props.ruleIndex >= 0 && props.removeRule && /* @__PURE__ */ React__default.createElement("a", {
    className: "btn btn-sm btn-link clickable",
    onClick: () => props.removeRule(props.listener, props.ruleIndex),
    style: { padding: "0" }
  }, /* @__PURE__ */ React__default.createElement(Tooltip, {
    value: "Remove Rule"
  }, /* @__PURE__ */ React__default.createElement("i", {
    className: "far fa-fw fa-trash-alt"
  }))));
};
const Rules = SortableContainer((props) => /* @__PURE__ */ React__default.createElement("tbody", null, /* @__PURE__ */ React__default.createElement("tr", {
  className: "not-sortable"
}, /* @__PURE__ */ React__default.createElement("td", null), /* @__PURE__ */ React__default.createElement("td", null, "Default"), /* @__PURE__ */ React__default.createElement("td", null, props.listener.defaultActions.map((action, index) => /* @__PURE__ */ React__default.createElement(Action, {
  key: index,
  action,
  actionTypeChanged: (type) => props.handleRuleActionTypeChanged(action, type),
  targetChanged: (target) => props.handleRuleActionTargetChanged(action, target),
  targetGroups: props.targetGroups,
  oidcConfigs: props.oidcConfigs,
  oidcConfigChanged: (config) => props.oidcConfigChanged(action, config),
  redirectConfigChanged: (config) => props.redirectConfigChanged(action, config),
  configureOidcClient: props.configureOidcClient,
  configureRedirect: props.configureRedirect
}))), /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement(RuleActions, {
  listener: props.listener,
  actions: props.listener.defaultActions,
  authenticateRuleToggle: props.authenticateRuleToggle
}))), props.listener.rules.sort((a, b) => a.priority - b.priority).map((rule, index) => /* @__PURE__ */ React__default.createElement(Rule, {
  key: index,
  rule,
  addCondition: props.addCondition,
  handleConditionFieldChanged: props.handleConditionFieldChanged,
  handleConditionValueChanged: props.handleConditionValueChanged,
  handleHttpRequestMethodChanged: props.handleHttpRequestMethodChanged,
  handleRuleActionTargetChanged: props.handleRuleActionTargetChanged,
  handleRuleActionTypeChanged: props.handleRuleActionTypeChanged,
  oidcConfigChanged: props.oidcConfigChanged,
  redirectConfigChanged: props.redirectConfigChanged,
  removeCondition: props.removeCondition,
  authenticateRuleToggle: props.authenticateRuleToggle,
  removeRule: props.removeRule,
  targetGroups: props.targetGroups,
  oidcConfigs: props.oidcConfigs,
  listener: props.listener,
  index,
  ruleIndex: index,
  configureOidcClient: props.configureOidcClient,
  configureRedirect: props.configureRedirect
})), /* @__PURE__ */ React__default.createElement("tr", {
  className: "not-sortable"
}, /* @__PURE__ */ React__default.createElement("td", {
  colSpan: 5
}, /* @__PURE__ */ React__default.createElement("button", {
  type: "button",
  className: "add-new col-md-12",
  onClick: () => props.addRule(props.listener)
}, /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("span", {
  className: "glyphicon glyphicon-plus-sign"
}), " Add new rule"))))));

const isNameInUse = (existingNames, credentials, region) => (name) => get(existingNames, [credentials, region], []).includes(name.toLowerCase()) ? `There is already a target group in ${credentials}:${region} with that name.` : null;
const isNameLong = (appNameLength) => (name) => name.length < 32 - appNameLength ? null : "Target group names are automatically prefixed with their application name and cannot exceed 32 characters in length.";
const isValidTimeout = (targetGroup) => (value) => {
  const num = isNumber(value) ? value : Number.parseInt(value, 10);
  const { protocol, healthCheckProtocol } = targetGroup;
  if (protocol === "TCP" || protocol === "TLS") {
    if (healthCheckProtocol === "HTTP" && num !== 6) {
      return "HTTP health check timeouts for TCP/TLS target groups must be 6s";
    }
    if ((healthCheckProtocol === "HTTPS" || healthCheckProtocol === "TLS") && num !== 10) {
      return "HTTPS/TLS health check timeouts for TCP/TLS target groups must be 10s";
    }
  }
  return null;
};
const isValidHealthCheckInterval = (targetGroup) => (value) => targetGroup.healthCheckProtocol !== "TCP" || targetGroup.healthCheckProtocol === "TCP" && (Number.parseInt(value, 10) === 10 || Number.parseInt(value, 10) === 30) ? null : "TCP health checks only support 10s and 30s intervals";

class TargetGroups$1 extends React__default.Component {
  constructor(props) {
    super(props);
    this.protocols = ["HTTP", "HTTPS"];
    this.targetTypes = ["instance", "ip", "lambda"];
    this.destroy$ = new Subject();
    this.addTargetGroup = () => {
      const { setFieldValue, values } = this.props.formik;
      const tgLength = values.targetGroups.length;
      values.targetGroups.push({
        name: `targetgroup${tgLength ? `${tgLength}` : ""}`,
        protocol: "HTTP",
        port: 7001,
        targetType: "instance",
        healthCheckProtocol: "HTTP",
        healthCheckPort: "7001",
        healthCheckPath: "/healthcheck",
        healthCheckTimeout: 5,
        healthCheckInterval: 10,
        healthyThreshold: 10,
        unhealthyThreshold: 2,
        attributes: {
          deregistrationDelay: 300,
          stickinessEnabled: false,
          stickinessType: "lb_cookie",
          stickinessDuration: 8400
        }
      });
      setFieldValue("targetGroups", values.targetGroups);
    };
    const oldTargetGroupCount = !props.isNew ? props.formik.initialValues.targetGroups.length : 0;
    this.state = {
      existingTargetGroupNames: {},
      oldTargetGroupCount
    };
  }
  validate(values) {
    const duplicateTargetGroups = uniq(flatten(filter(groupBy(values.targetGroups, "name"), (count) => count.length > 1)).map((tg) => tg.name));
    const formValidator = new FormValidator(values);
    const { arrayForEach } = formValidator;
    formValidator.field("targetGroups").withValidators(arrayForEach((builder, item) => {
      builder.field("name", "Name").withValidators(isNameInUse(this.state.existingTargetGroupNames, values.credentials, values.region), isNameLong(this.props.app.name.length), Validators.valueUnique(duplicateTargetGroups, "There is already a target group in this load balancer with the same name."));
      builder.field("healthCheckInterval", "Health Check Interval").withValidators(isValidHealthCheckInterval(item), Validators.checkBetween("healthCheckInterval", 5, 300));
      builder.field("healthyThreshold", "Healthy Threshold").withValidators(Validators.checkBetween("healthyThreshold", 2, 10));
      builder.field("unhealthyThreshold", "Unhealthy Threshold").spelAware().withValidators(Validators.checkBetween("unhealthyThreshold", 2, 10));
      builder.field("healthCheckTimeout", "Timeout").withValidators(isValidTimeout(item), Validators.checkBetween("healthCheckTimeout", 2, 120));
      if (item.targetType !== "lambda") {
        builder.field("protocol", "Protocol").required();
        builder.field("healthCheckPath", "Health Check Path").required();
        builder.field("healthCheckProtocol", "Health Check Protocol").required();
        builder.field("name", "Name").required();
        builder.field("healthyThreshold", "Healthy Threshold").required().spelAware().withValidators((value) => spelNumberCheck(value));
        builder.field("unhealthyThreshold", "Unhealthy Threshold").required().spelAware().withValidators((value) => spelNumberCheck(value));
        builder.field("healthCheckInterval", "Health Check Interval").required().spelAware().withValidators((value) => spelNumberCheck(value));
        builder.field("healthCheckPort", "Health Check Port").required().spelAware().withValidators((value) => value === "traffic-port" ? null : spelNumberCheck(value));
        builder.field("port", "Port").required().spelAware().withValidators((value) => spelNumberCheck(value));
        builder.field("healthyThreshold", "Healthy Threshold").required().spelAware().withValidators((value) => spelNumberCheck(value), Validators.checkBetween("healthyThreshold", 2, 10));
        builder.field("unhealthyThreshold", "Unhealthy Threshold").required().spelAware().withValidators((value) => spelNumberCheck(value), Validators.checkBetween("unhealthyThreshold", 2, 10));
      }
    }));
    return formValidator.validateForm();
  }
  removeAppName(name) {
    return name.replace(`${this.props.app.name}-`, "");
  }
  updateLoadBalancerNames(props) {
    const { app, loadBalancer } = props;
    const targetGroupsByAccountAndRegion = {};
    from(app.getDataSource("loadBalancers").refresh(true)).pipe(takeUntil(this.destroy$)).subscribe(() => {
      app.getDataSource("loadBalancers").data.forEach((lb) => {
        if (lb.loadBalancerType !== "classic") {
          if (!loadBalancer || lb.name !== loadBalancer.name) {
            lb.targetGroups.forEach((targetGroup) => {
              targetGroupsByAccountAndRegion[lb.account] = targetGroupsByAccountAndRegion[lb.account] || {};
              targetGroupsByAccountAndRegion[lb.account][lb.region] = targetGroupsByAccountAndRegion[lb.account][lb.region] || [];
              targetGroupsByAccountAndRegion[lb.account][lb.region].push(this.removeAppName(targetGroup.name));
            });
          }
        }
      });
      this.setState({ existingTargetGroupNames: targetGroupsByAccountAndRegion }, () => this.props.formik.validateForm());
    });
  }
  targetGroupFieldChanged(index, field, value) {
    const { setFieldValue, values } = this.props.formik;
    const targetGroup = values.targetGroups[index];
    if (field === "targetType" && value === "lambda") {
      delete targetGroup.port;
    }
    set(targetGroup, field, value);
    setFieldValue("targetGroups", values.targetGroups);
  }
  removeTargetGroup(index) {
    const { setFieldValue, values } = this.props.formik;
    const { oldTargetGroupCount } = this.state;
    values.targetGroups.splice(index, 1);
    if (index < oldTargetGroupCount) {
      this.setState({ oldTargetGroupCount: oldTargetGroupCount - 1 });
    }
    setFieldValue("targetGroups", values.targetGroups);
  }
  componentDidMount() {
    this.updateLoadBalancerNames(this.props);
  }
  componentWillUnmount() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  render() {
    const { app } = this.props;
    const { errors, values } = this.props.formik;
    const { oldTargetGroupCount } = this.state;
    const ProtocolOptions = this.protocols.map((p) => /* @__PURE__ */ React__default.createElement("option", {
      key: p
    }, p));
    const TargetTypeOptions = this.targetTypes.map((p) => /* @__PURE__ */ React__default.createElement("option", {
      key: p
    }, p));
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "container-fluid form-horizontal"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12"
    }, values.targetGroups.map((targetGroup, index) => {
      const tgErrors = errors.targetGroups && errors.targetGroups[index] || {};
      const has6sTimeout = (targetGroup.protocol === "TCP" || targetGroup.protocol === "TLS") && targetGroup.healthCheckProtocol === "HTTP";
      const has10sTimeout = (targetGroup.protocol === "TCP" || targetGroup.protocol === "TLS") && targetGroup.healthCheckProtocol === "HTTPS";
      return /* @__PURE__ */ React__default.createElement("div", {
        key: index,
        className: "wizard-pod"
      }, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row header"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-title"
      }, "Group Name"), /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-contents"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-data"
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "group-name-prefix"
      }, app.name, "-"), /* @__PURE__ */ React__default.createElement("input", {
        className: "form-control input-sm target-group-name",
        type: "text",
        value: targetGroup.name,
        onChange: (event) => this.targetGroupFieldChanged(index, "name", event.target.value),
        required: true,
        disabled: index < oldTargetGroupCount
      }), /* @__PURE__ */ React__default.createElement("a", {
        className: "sm-label clickable",
        onClick: () => this.removeTargetGroup(index)
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "glyphicon glyphicon-trash"
      }))), tgErrors.name && /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-errors"
      }, /* @__PURE__ */ React__default.createElement(ValidationMessage, {
        type: "error",
        message: tgErrors.name
      })))), /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-title"
      }, /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "aws.targetGroup.targetType"
      }), " ", /* @__PURE__ */ React__default.createElement("span", null, "Target Type\xA0")), /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-contents"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-data"
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "wizard-pod-content"
      }, /* @__PURE__ */ React__default.createElement("select", {
        className: "form-control input-sm",
        value: targetGroup.targetType,
        onChange: (event) => this.targetGroupFieldChanged(index, "targetType", event.target.value),
        disabled: index < oldTargetGroupCount
      }, TargetTypeOptions))))), targetGroup.targetType !== "lambda" && /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-title"
      }, "Backend Connection"), /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-contents"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-data"
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "wizard-pod-content"
      }, /* @__PURE__ */ React__default.createElement("label", null, "Protocol "), /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "aws.targetGroup.protocol"
      }), " ", /* @__PURE__ */ React__default.createElement("select", {
        className: "form-control input-sm inline-number",
        value: targetGroup.protocol,
        onChange: (event) => this.targetGroupFieldChanged(index, "protocol", event.target.value),
        disabled: index < oldTargetGroupCount
      }, ProtocolOptions)), /* @__PURE__ */ React__default.createElement("span", {
        className: "wizard-pod-content"
      }, /* @__PURE__ */ React__default.createElement("label", null, "Port "), /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "aws.targetGroup.port"
      }), " ", /* @__PURE__ */ React__default.createElement("input", {
        className: "form-control input-sm inline-number",
        value: targetGroup.port,
        onChange: (event) => this.targetGroupFieldChanged(index, "port", event.target.value),
        type: "text",
        required: true,
        disabled: index < oldTargetGroupCount
      }))))), /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-title"
      }, "Healthcheck"), /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-contents"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-data"
      }, targetGroup.targetType !== "lambda" && /* @__PURE__ */ React__default.createElement("span", {
        className: "wizard-pod-content"
      }, /* @__PURE__ */ React__default.createElement("label", null, "Protocol "), targetGroup.healthCheckProtocol === "TCP" && /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "aws.targetGroup.healthCheckProtocol"
      }), " ", /* @__PURE__ */ React__default.createElement("select", {
        className: "form-control input-sm inline-number",
        value: targetGroup.healthCheckProtocol,
        onChange: (event) => this.targetGroupFieldChanged(index, "healthCheckProtocol", event.target.value)
      }, ProtocolOptions)), targetGroup.targetType !== "lambda" && /* @__PURE__ */ React__default.createElement("span", {
        className: "wizard-pod-content"
      }, /* @__PURE__ */ React__default.createElement("label", null, "Port "), /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "aws.targetGroup.attributes.healthCheckPort.trafficPort"
      }), " ", /* @__PURE__ */ React__default.createElement("select", {
        className: "form-control input-sm inline-number",
        style: { width: "90px" },
        value: targetGroup.healthCheckPort === "traffic-port" ? "traffic-port" : "manual",
        onChange: (event) => this.targetGroupFieldChanged(index, "healthCheckPort", event.target.value === "traffic-port" ? "traffic-port" : "")
      }, /* @__PURE__ */ React__default.createElement("option", {
        value: "traffic-port"
      }, "Traffic Port"), /* @__PURE__ */ React__default.createElement("option", {
        value: "manual"
      }, "Manual")), " ", /* @__PURE__ */ React__default.createElement(SpInput, {
        className: "form-control input-sm inline-number",
        error: tgErrors.healthCheckPort,
        style: {
          visibility: targetGroup.healthCheckPort === "traffic-port" ? "hidden" : "inherit"
        },
        name: "healthCheckPort",
        required: true,
        value: targetGroup.healthCheckPort,
        onChange: (event) => this.targetGroupFieldChanged(index, "healthCheckPort", event.target.value)
      })), /* @__PURE__ */ React__default.createElement("span", {
        className: "wizard-pod-content"
      }, /* @__PURE__ */ React__default.createElement("label", null, "Path "), /* @__PURE__ */ React__default.createElement(SpInput, {
        error: tgErrors.healthCheckPath,
        name: "healthCheckPath",
        required: true,
        value: targetGroup.healthCheckPath,
        onChange: (event) => this.targetGroupFieldChanged(index, "healthCheckPath", event.target.value)
      })), /* @__PURE__ */ React__default.createElement("span", {
        className: "wizard-pod-content"
      }, /* @__PURE__ */ React__default.createElement("label", null, "Timeout "), (has6sTimeout || has10sTimeout) && /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "aws.targetGroup.healthCheckTimeout"
      }), /* @__PURE__ */ React__default.createElement(SpelNumberInput, {
        error: tgErrors.healthCheckTimeout,
        disabled: has6sTimeout || has10sTimeout,
        required: true,
        value: has6sTimeout ? 6 : has10sTimeout ? 10 : targetGroup.healthCheckTimeout,
        min: 2,
        max: 120,
        onChange: (value) => this.targetGroupFieldChanged(index, "healthCheckTimeout", value)
      })), /* @__PURE__ */ React__default.createElement("span", {
        className: "wizard-pod-content"
      }, /* @__PURE__ */ React__default.createElement("label", null, "Interval "), /* @__PURE__ */ React__default.createElement(SpelNumberInput, {
        error: tgErrors.healthCheckInterval,
        required: true,
        value: targetGroup.healthCheckInterval,
        min: 5,
        max: 300,
        onChange: (value) => this.targetGroupFieldChanged(index, "healthCheckInterval", value)
      }))))), /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-title"
      }, "Healthcheck Threshold"), /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-contents"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-data"
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "wizard-pod-content"
      }, /* @__PURE__ */ React__default.createElement("label", null, "Healthy "), /* @__PURE__ */ React__default.createElement(SpelNumberInput, {
        error: tgErrors.healthyThreshold,
        value: targetGroup.healthyThreshold,
        min: 2,
        max: 10,
        onChange: (value) => this.targetGroupFieldChanged(index, "healthyThreshold", value)
      })), /* @__PURE__ */ React__default.createElement("span", {
        className: "wizard-pod-content"
      }, /* @__PURE__ */ React__default.createElement("label", null, "Unhealthy "), /* @__PURE__ */ React__default.createElement(SpelNumberInput, {
        error: tgErrors.unhealthyThreshold,
        required: true,
        value: targetGroup.unhealthyThreshold,
        min: 2,
        max: 10,
        onChange: (value) => this.targetGroupFieldChanged(index, "unhealthyThreshold", value)
      }))))), /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-title"
      }, "Attributes"), targetGroup.targetType !== "lambda" ? /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-contents"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-data"
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "wizard-pod-content"
      }, /* @__PURE__ */ React__default.createElement("label", null, "Dereg. Delay"), /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "aws.targetGroup.attributes.deregistrationDelay"
      }), " ", /* @__PURE__ */ React__default.createElement("input", {
        className: "form-control input-sm inline-number",
        type: "text",
        value: targetGroup.attributes.deregistrationDelay,
        onChange: (event) => this.targetGroupFieldChanged(index, "attributes.deregistrationDelay", event.target.value)
      })), /* @__PURE__ */ React__default.createElement("span", {
        className: "wizard-pod-content"
      }, /* @__PURE__ */ React__default.createElement("label", {
        className: "checkbox-inline",
        style: { paddingTop: "2px" }
      }, /* @__PURE__ */ React__default.createElement("input", {
        type: "checkbox",
        checked: targetGroup.attributes.stickinessEnabled,
        onChange: (event) => this.targetGroupFieldChanged(index, "attributes.stickinessEnabled", event.target.checked)
      }), " ", /* @__PURE__ */ React__default.createElement("label", null, "Sticky"), /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "aws.targetGroup.attributes.stickinessEnabled"
      }))), targetGroup.attributes.stickinessEnabled && /* @__PURE__ */ React__default.createElement("span", {
        className: "wizard-pod-content"
      }, /* @__PURE__ */ React__default.createElement("label", null, "Duration "), /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "aws.targetGroup.attributes.stickinessDuration"
      }), " ", /* @__PURE__ */ React__default.createElement("input", {
        className: "form-control input-sm inline-number",
        value: targetGroup.attributes.stickinessDuration,
        onChange: (event) => this.targetGroupFieldChanged(index, "attributes.stickinessDuration", event.target.value),
        type: "text"
      })))) : /* @__PURE__ */ React__default.createElement("span", {
        className: "wizard-pod-content"
      }, /* @__PURE__ */ React__default.createElement("label", {
        className: "checkbox-inline",
        style: { paddingTop: "2px" }
      }, /* @__PURE__ */ React__default.createElement("input", {
        type: "checkbox",
        checked: targetGroup.attributes.multiValueHeadersEnabled,
        onChange: (event) => this.targetGroupFieldChanged(index, "attributes.multiValueHeadersEnabled", event.target.checked)
      }), " ", /* @__PURE__ */ React__default.createElement("label", null, "Enable Multi Value Headers"))))));
    }), /* @__PURE__ */ React__default.createElement("table", {
      className: "table table-condensed packed"
    }, /* @__PURE__ */ React__default.createElement("tbody", null, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement("button", {
      type: "button",
      className: "add-new col-md-12",
      onClick: this.addTargetGroup
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-plus-sign"
    }), " Add new target group"))))))));
  }
}

class AvailabilityZoneSelector extends React__default.Component {
  constructor(props) {
    super(props);
    this.handleUsePreferredZonesChanged = (event) => {
      const usePreferredZones = event.target.value === "true";
      this.setState({ usePreferredZones });
      if (usePreferredZones) {
        this.setDefaultZones(this.props);
      }
    };
    this.handleSelectedZonesChanged = (zones) => {
      this.props.onChange([...zones]);
    };
    this.state = {
      defaultZones: [],
      usePreferredZones: props.usePreferredZones || !props.selectedZones || props.selectedZones.length === 0
    };
    this.setDefaultZones(props);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.region !== this.props.region || nextProps.credentials !== this.props.credentials) {
      this.setDefaultZones(nextProps);
    }
  }
  setDefaultZones(props) {
    const { credentials, onChange, region } = props;
    const { usePreferredZones } = this.state;
    AccountService.getAvailabilityZonesForAccountAndRegion("aws", credentials, region).then((preferredZones) => {
      this.setState({ defaultZones: preferredZones });
      if (usePreferredZones && preferredZones) {
        onChange(preferredZones.slice());
      }
    });
  }
  render() {
    const { region, allZones, selectedZones } = this.props;
    const { defaultZones, usePreferredZones } = this.state;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-3 sm-label-right"
    }, "Availability Zones"), region && /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-7"
    }, /* @__PURE__ */ React__default.createElement("p", {
      className: "form-control-static"
    }, "Automatic Availability Zone Balancing:"), /* @__PURE__ */ React__default.createElement("select", {
      className: "form-control input-sm",
      value: usePreferredZones ? "true" : "false",
      onChange: this.handleUsePreferredZonesChanged
    }, /* @__PURE__ */ React__default.createElement("option", {
      value: "true"
    }, "Enabled"), /* @__PURE__ */ React__default.createElement("option", {
      value: "false"
    }, "Manual")), /* @__PURE__ */ React__default.createElement("br", null), usePreferredZones && /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("p", {
      className: "form-control-static"
    }, "Server group will be available in:"), /* @__PURE__ */ React__default.createElement("ul", null, defaultZones.map((zone) => /* @__PURE__ */ React__default.createElement("li", {
      key: zone
    }, zone)))), !usePreferredZones && /* @__PURE__ */ React__default.createElement("div", null, "Restrict server group instances to:", /* @__PURE__ */ React__default.createElement(ChecklistInput, {
      stringOptions: allZones,
      value: selectedZones,
      onChange: (e) => this.handleSelectedZonesChanged(e.target.value)
    }))));
  }
}

function isClassicLockout(region, credentials, application) {
  const { classicLaunchLockout, classicLaunchAllowlist: allowlist } = AWSProviderSettings;
  const appCreationDate = Number(get(application, "attributes.createTs", 0));
  const appCreatedAfterLockout = appCreationDate > (classicLaunchLockout || 0);
  const isAllowlisted = !!allowlist && allowlist.some((e) => e.region === region && e.credentials === credentials);
  return appCreatedAfterLockout || !isAllowlisted;
}
function getOptions(subnets, isClassicHidden) {
  const sortByLabel = (a, b) => a.label.localeCompare(b.label);
  const asOption = (subnet) => ({ value: subnet.purpose, label: subnet.label });
  const classicOption = isClassicHidden ? [] : [{ label: "None (EC2 Classic)", value: "" }];
  const activeOptions = subnets.filter((x) => !x.deprecated).sort(sortByLabel).map(asOption);
  const deprecatedOptions = subnets.filter((x) => x.deprecated).sort(sortByLabel).map(asOption);
  if (deprecatedOptions.length) {
    deprecatedOptions.unshift({ label: "-----------", value: "", disabled: true });
  }
  return classicOption.concat(activeOptions).concat(deprecatedOptions);
}
function getDefaultSubnet(subnets, defaultSubnetTypes = []) {
  for (const subnetType of defaultSubnetTypes) {
    const defaultSubnet = subnets.find((subnet) => subnetType === subnet.purpose);
    if (defaultSubnet) {
      return defaultSubnet;
    }
  }
  return void 0;
}
function SubnetSelectInput(props) {
  const {
    application,
    credentials,
    defaultSubnetTypes,
    hideClassic,
    name,
    onChange,
    readOnly,
    region,
    subnets,
    value,
    ...otherProps
  } = props;
  const subnetsDiff = useDeepObjectDiff(subnets);
  const options = React__default.useMemo(() => {
    const isClassicHidden = hideClassic || isClassicLockout(region, credentials, application);
    return getOptions(subnets, isClassicHidden);
  }, [hideClassic, region, credentials, application, subnetsDiff]);
  const defaultSubnet = getDefaultSubnet(subnets, defaultSubnetTypes) || subnets[0];
  const mountStatus = useMountStatusRef().current;
  React__default.useEffect(() => {
    const isSelectionValid = options.some((o) => o.value === value);
    const applyDefault = !isSelectionValid || mountStatus !== "FIRST_RENDER";
    if (defaultSubnet && applyDefault) {
      onChange(createFakeReactSyntheticEvent({ name, value: defaultSubnet.purpose }));
    }
  }, [options]);
  if (readOnly) {
    return /* @__PURE__ */ React__default.createElement("p", {
      className: "form-control-static"
    }, props.value || "None (EC2 Classic)");
  }
  return /* @__PURE__ */ React__default.createElement(SelectInput, {
    options,
    value,
    onChange,
    ...otherProps
  });
}

class SubnetSelectField extends React.Component {
  constructor() {
    super(...arguments);
    this.handleChange = (event) => {
      const { component, onChange, field } = this.props;
      component[field] = event.target.value;
      onChange();
    };
  }
  render() {
    var _a, _b, _c;
    const {
      component,
      defaultSubnetTypes,
      field,
      helpKey,
      labelColumns,
      recommendedSubnetTypes,
      region,
      showSubnetWarning,
      ...otherProps
    } = this.props;
    const value = component[field];
    const recommended = (_b = recommendedSubnetTypes != null ? recommendedSubnetTypes : (_a = AWSProviderSettings.serverGroups) == null ? void 0 : _a.recommendedSubnets) != null ? _b : [];
    const defaults = defaultSubnetTypes != null ? defaultSubnetTypes : [AWSProviderSettings.defaults.subnetType];
    const isRecommended = recommended.some((subnet) => value && value.includes(subnet));
    const subnetWarning = (_c = AWSProviderSettings.serverGroups) == null ? void 0 : _c.subnetWarning;
    return /* @__PURE__ */ React.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React.createElement("div", {
      className: `col-md-${labelColumns} sm-label-right`
    }, "VPC Subnet ", /* @__PURE__ */ React.createElement(HelpField, {
      id: helpKey
    })), /* @__PURE__ */ React.createElement("div", {
      className: "col-md-7"
    }, region ? /* @__PURE__ */ React.createElement(SubnetSelectInput, {
      ...otherProps,
      inputClassName: "form-control input-sm",
      credentials: component.credentials,
      defaultSubnetTypes: defaults,
      region,
      value,
      onChange: this.handleChange
    }) : "(Select an account)", showSubnetWarning && !isRecommended && Boolean(subnetWarning) && /* @__PURE__ */ React.createElement("div", {
      className: "alert alert-warning sp-margin-s-top horizontal center"
    }, /* @__PURE__ */ React.createElement("i", {
      className: "fa fa-exclamation-triangle sp-margin-s-top"
    }), /* @__PURE__ */ React.createElement("div", {
      className: "sp-margin-s-left"
    }, /* @__PURE__ */ React.createElement(Markdown, {
      message: subnetWarning,
      style: { display: "inline-block", marginLeft: "2px" }
    })))));
  }
}

class LoadBalancerLocation extends React__default.Component {
  constructor() {
    super(...arguments);
    this.state = {
      accounts: void 0,
      availabilityZones: [],
      existingLoadBalancerNames: [],
      hideInternalFlag: false,
      internalFlagToggled: false,
      regions: [],
      subnets: []
    };
    this.props$ = new Subject();
    this.destroy$ = new Subject();
    this.internalFlagChanged = (event) => {
      this.setState({ internalFlagToggled: true });
      this.props.formik.handleChange(event);
    };
    this.handleSubnetUpdated = (subnetType) => {
      this.props.formik.setFieldValue("subnetType", subnetType);
    };
    this.accountUpdated = (account) => {
      this.props.formik.setFieldValue("credentials", account);
    };
    this.regionUpdated = (region) => {
      this.props.formik.setFieldValue("region", region);
    };
    this.stackChanged = (event) => {
      this.props.formik.setFieldValue("stack", event.target.value);
    };
    this.detailChanged = (event) => {
      this.props.formik.setFieldValue("detail", event.target.value);
    };
    this.handleAvailabilityZonesChanged = (zones) => {
      this.props.formik.setFieldValue("regionZones", zones);
    };
  }
  validate(values) {
    const errors = {};
    if (this.state.existingLoadBalancerNames.includes(values.name)) {
      errors.name = `There is already a load balancer in ${values.credentials}:${values.region} with that name.`;
    }
    if (values.name && values.name.length > 32) {
      errors.name = "Load balancer names cannot exceed 32 characters in length";
    }
    if (values.stack && !values.stack.match(/^[a-zA-Z0-9]*$/)) {
      errors.stack = "Stack can only contain letters and numbers.";
    }
    if (values.detail && !values.detail.match(/^[a-zA-Z0-9-]*$/)) {
      errors.detail = "Detail can only contain letters, numbers, and dashes.";
    }
    return errors;
  }
  buildName() {
    const { values } = this.props.formik;
    if (isNil(values.moniker)) {
      const nameParts = NameUtils.parseLoadBalancerName(values.name);
      values.stack = nameParts.stack;
      values.detail = nameParts.freeFormDetails;
    } else {
      values.stack = values.moniker.stack;
      values.detail = values.moniker.detail;
    }
    delete values.name;
  }
  shouldHideInternalFlag() {
    if (AWSProviderSettings) {
      if (AWSProviderSettings.loadBalancers && AWSProviderSettings.loadBalancers.inferInternalFlagFromSubnet) {
        delete this.props.formik.values.isInternal;
        return true;
      }
    }
    return false;
  }
  componentDidMount() {
    this.setState({ hideInternalFlag: this.shouldHideInternalFlag() });
    if (this.props.loadBalancer && this.props.isNew) {
      this.buildName();
    }
    const formValues$ = this.props$.pipe(map((props) => props.formik.values));
    const appName$ = this.props$.pipe(map((props) => props.app.name), distinctUntilChanged());
    const form = {
      account$: formValues$.pipe(map((x) => x.credentials), distinctUntilChanged()),
      region$: formValues$.pipe(map((x) => x.region), distinctUntilChanged()),
      subnetPurpose$: formValues$.pipe(map((x) => x.subnetType), distinctUntilChanged()),
      stack$: formValues$.pipe(map((x) => x.stack), distinctUntilChanged()),
      detail$: formValues$.pipe(map((x) => x.detail), distinctUntilChanged())
    };
    const allAccounts$ = from(AccountService.listAccounts("aws")).pipe(shareReplay(1));
    const accountRegions$ = combineLatest([form.account$, allAccounts$]).pipe(switchMap(([currentAccount, _allAccounts]) => AccountService.getRegionsForAccount(currentAccount)), shareReplay(1));
    const allLoadBalancers$ = this.props.app.getDataSource("loadBalancers").data$;
    const regionLoadBalancers$ = combineLatest([allLoadBalancers$, form.account$, form.region$]).pipe(map(([allLoadBalancers, currentAccount, currentRegion]) => {
      return allLoadBalancers.filter((lb) => lb.account === currentAccount && lb.region === currentRegion).map((lb) => lb.name);
    }), shareReplay(1));
    const regionSubnets$ = combineLatest([form.account$, form.region$]).pipe(switchMap(([currentAccount, currentRegion]) => this.getAvailableSubnets(currentAccount, currentRegion)), map((availableSubnets) => this.makeSubnetOptions(availableSubnets)), shareReplay(1));
    const subnet$ = combineLatest([regionSubnets$, form.subnetPurpose$]).pipe(map(([allSubnets, subnetPurpose]) => allSubnets && allSubnets.find((subnet) => subnet.purpose === subnetPurpose)));
    const availabilityZones$ = subnet$.pipe(map((subnet) => subnet ? uniq(subnet.availabilityZones).sort() : []));
    const regionZones$ = form.region$.pipe(withLatestFrom(accountRegions$), map(([currentRegion, accountRegions]) => accountRegions.find((region) => region.name === currentRegion)), map((region) => region ? region.availabilityZones : []));
    const moniker$ = combineLatest([appName$, form.stack$, form.detail$]).pipe(map(([app, stack, detail]) => {
      return { app, stack, detail, cluster: NameUtils.getClusterName(app, stack, detail) };
    }));
    accountRegions$.pipe(withLatestFrom(form.region$), takeUntil(this.destroy$)).subscribe(([accountRegions, selectedRegion]) => {
      if (!accountRegions.some((x) => x.name === selectedRegion)) {
        this.props.formik.setFieldValue("region", accountRegions[0] && accountRegions[0].name);
      }
    });
    regionZones$.pipe(takeUntil(this.destroy$)).subscribe((regionZones) => {
      this.props.formik.setFieldValue("regionZones", regionZones);
    });
    subnet$.pipe(takeUntil(this.destroy$)).subscribe((subnet) => {
      this.props.formik.setFieldValue("vpcId", subnet && subnet.vpcIds[0]);
      this.props.formik.setFieldValue("subnetType", subnet && subnet.purpose);
      if (!this.state.hideInternalFlag && !this.state.internalFlagToggled && subnet && subnet.purpose) {
        this.props.formik.setFieldValue("isInternal", subnet.purpose.includes("internal"));
      }
    });
    moniker$.pipe(takeUntil(this.destroy$)).subscribe((moniker) => {
      this.props.formik.setFieldValue("moniker", moniker);
      this.props.formik.setFieldValue("name", moniker.cluster);
    });
    combineLatest([allAccounts$, accountRegions$, availabilityZones$, regionLoadBalancers$, regionSubnets$]).pipe(takeUntil(this.destroy$)).subscribe(([accounts, regions, availabilityZones, existingLoadBalancerNames, subnets]) => {
      return this.setState({ accounts, regions, availabilityZones, existingLoadBalancerNames, subnets });
    });
  }
  componentDidUpdate() {
    this.props$.next(this.props);
  }
  componentWillUnmount() {
    this.destroy$.next();
  }
  getAvailableSubnets(credentials, region) {
    return SubnetReader.listSubnets().then((subnets) => {
      return chain(subnets).filter({ account: credentials, region }).reject({ target: "ec2" }).reject({ purpose: null }).value();
    });
  }
  makeSubnetOptions(availableSubnets) {
    const makeSubnetOption = (subnets) => {
      const { purpose, label, deprecated } = subnets[0];
      const vpcIds = uniq(subnets.map((x) => x.vpcId));
      const availabilityZones = uniq(subnets.map((x) => x.availabilityZone));
      return { purpose, label, deprecated, vpcIds, availabilityZones };
    };
    const grouped = groupBy(availableSubnets, (sn) => sn.purpose);
    return Object.keys(grouped).map((k) => grouped[k]).map((subnets) => makeSubnetOption(subnets));
  }
  render() {
    const { app } = this.props;
    const { errors, values } = this.props.formik;
    const { accounts, availabilityZones, hideInternalFlag, regions, subnets } = this.state;
    const className = classNames({
      "col-md-12": true,
      well: true,
      "alert-danger": !!errors.name,
      "alert-info": !errors.name
    });
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "container-fluid form-horizontal"
    }, !accounts && /* @__PURE__ */ React__default.createElement("div", {
      style: { height: "200px" }
    }, /* @__PURE__ */ React__default.createElement(Spinner, {
      size: "medium"
    })), accounts && /* @__PURE__ */ React__default.createElement("div", {
      className: "modal-body"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className
    }, /* @__PURE__ */ React__default.createElement("strong", null, "Your load balancer will be named: "), /* @__PURE__ */ React__default.createElement("span", null, values.name), /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "aws.loadBalancer.name"
    }), /* @__PURE__ */ React__default.createElement(Field, {
      type: "text",
      style: { display: "none" },
      className: "form-control input-sm no-spel",
      name: "name"
    }), errors.name && /* @__PURE__ */ React__default.createElement(ValidationMessage, {
      type: "error",
      message: errors.name
    }))), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-3 sm-label-right"
    }, "Account"), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-7"
    }, /* @__PURE__ */ React__default.createElement(AccountSelectInput, {
      value: values.credentials,
      onChange: (evt) => this.accountUpdated(evt.target.value),
      accounts,
      provider: "aws"
    }))), /* @__PURE__ */ React__default.createElement(RegionSelectField, {
      labelColumns: 3,
      component: values,
      field: "region",
      account: values.credentials,
      onChange: this.regionUpdated,
      regions
    }), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-3 sm-label-right"
    }, "Stack ", /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "aws.loadBalancer.stack"
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-3"
    }, /* @__PURE__ */ React__default.createElement("input", {
      type: "text",
      className: `form-control input-sm no-spel ${errors.stack ? "invalid" : ""}`,
      value: values.stack,
      name: "stack",
      onChange: this.stackChanged
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6 form-inline"
    }, /* @__PURE__ */ React__default.createElement("label", {
      className: "sm-label-right"
    }, /* @__PURE__ */ React__default.createElement("span", null, "Detail ", /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "aws.loadBalancer.detail"
    }), " ")), /* @__PURE__ */ React__default.createElement("input", {
      type: "text",
      className: `form-control input-sm no-spel ${errors.detail ? "invalid" : ""}`,
      value: values.detail,
      name: "detail",
      onChange: this.detailChanged
    })), errors.stack && /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-7 col-md-offset-3"
    }, /* @__PURE__ */ React__default.createElement(ValidationMessage, {
      type: "error",
      message: errors.stack
    })), errors.detail && /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-7 col-md-offset-3"
    }, /* @__PURE__ */ React__default.createElement(ValidationMessage, {
      type: "error",
      message: errors.detail
    }))), /* @__PURE__ */ React__default.createElement(AvailabilityZoneSelector, {
      credentials: values.credentials,
      region: values.region,
      onChange: this.handleAvailabilityZonesChanged,
      selectedZones: values.regionZones,
      allZones: availabilityZones
    }), /* @__PURE__ */ React__default.createElement(SubnetSelectField, {
      labelColumns: 3,
      helpKey: "aws.loadBalancer.subnet",
      component: values,
      field: "subnetType",
      region: values.region,
      subnets,
      application: app,
      onChange: () => this.handleSubnetUpdated(values.subnetType)
    }), values.vpcId && !hideInternalFlag && /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-3 sm-label-right"
    }, /* @__PURE__ */ React__default.createElement("b", null, "Internal"), " ", /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "aws.loadBalancer.internal"
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-7 checkbox"
    }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement(Field, {
      name: "isInternal",
      onChange: this.internalFlagChanged,
      render: ({ field: { value, ...field } }) => /* @__PURE__ */ React__default.createElement("input", {
        type: "checkbox",
        ...field,
        checked: !!value
      })
    }), "Create an internal load balancer")))));
  }
}

class SecurityGroups extends React__default.Component {
  constructor(props) {
    super(props);
    this.destroy$ = new Subject();
    this.props$ = new Subject();
    this.refresh$ = new Subject();
    this.clearRemoved = () => {
      this.setState({ removed: [] }, () => this.props.formik.validateForm());
    };
    this.handleSecurityGroupsChanged = (newValues) => {
      this.props.formik.setFieldValue("securityGroups", newValues.map((sg) => sg.value));
    };
    const defaultSecurityGroups = get(AWSProviderSettings, "defaultSecurityGroups", []);
    this.state = {
      availableSecurityGroups: [],
      defaultSecurityGroups,
      loaded: false,
      refreshing: false,
      removed: [],
      refreshTime: InfrastructureCaches.get("securityGroups").getStats().ageMax
    };
  }
  validate() {
    const { removed } = this.state;
    if (removed && removed.length) {
      const label = FirewallLabels.get("Firewalls");
      return { securityGroupsRemoved: `${label} removed: ${removed.join(", ")}` };
    }
    return {};
  }
  updateRemovedSecurityGroups(selectedGroups, availableGroups) {
    const { isNew } = this.props;
    const { defaultSecurityGroups, removed } = this.state;
    const getDesiredGroupNames = () => {
      const desired = selectedGroups.concat(removed).sort();
      const defaults = isNew ? defaultSecurityGroups : [];
      return uniq(defaults.concat(desired));
    };
    const getAvailableSecurityGroup = (name) => availableGroups.find((sg) => sg.name === name || sg.id === name);
    const [available, notAvailable] = partition(getDesiredGroupNames(), (name) => !!getAvailableSecurityGroup(name));
    const securityGroups = available.map((name) => getAvailableSecurityGroup(name).name);
    if (!isEqual(selectedGroups, securityGroups)) {
      this.props.formik.setFieldValue("securityGroups", securityGroups);
    }
    this.setState({ removed: notAvailable }, () => this.props.formik.validateForm());
  }
  onRefreshStart() {
    this.props.onLoadingChanged(true);
    this.setState({ refreshing: true });
  }
  onRefreshComplete() {
    this.props.onLoadingChanged(false);
    const refreshTime = InfrastructureCaches.get("securityGroups").getStats().ageMax;
    this.setState({ refreshing: false, loaded: true, refreshTime });
  }
  componentDidMount() {
    const allSecurityGroups$ = this.refresh$.pipe(tap(() => this.onRefreshStart()), switchMap(() => ReactInjector.cacheInitializer.refreshCache("securityGroups")), mergeMap(() => ReactInjector.securityGroupReader.getAllSecurityGroups()), tap(() => this.onRefreshComplete()));
    const formValues$ = this.props$.pipe(map((props) => props.formik.values));
    const vpcId$ = formValues$.pipe(map((values) => values.vpcId), distinctUntilChanged());
    const availableSecurityGroups$ = combineLatest([vpcId$, allSecurityGroups$]).pipe(withLatestFrom(formValues$), map(([[vpcId, allSecurityGroups], formValues]) => {
      const forAccount = allSecurityGroups[formValues.credentials] || {};
      const forRegion = forAccount.aws && forAccount.aws[formValues.region] || [];
      return forRegion.filter((securityGroup) => vpcId === securityGroup.vpcId).sort();
    }));
    availableSecurityGroups$.pipe(withLatestFrom(formValues$), takeUntil(this.destroy$)).subscribe(([availableSecurityGroups, formValues]) => {
      const makeOption = (sg) => ({ label: `${sg.name} (${sg.id})`, value: sg.name });
      this.setState({ availableSecurityGroups: availableSecurityGroups.map(makeOption) });
      this.updateRemovedSecurityGroups(formValues.securityGroups, availableSecurityGroups);
    });
    this.refresh$.next();
  }
  componentDidUpdate() {
    this.props$.next(this.props);
  }
  componentWillUnmount() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  render() {
    const { securityGroups } = this.props.formik.values;
    const { availableSecurityGroups, loaded, refreshing, removed, refreshTime } = this.state;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "container-fluid form-horizontal"
    }, /* @__PURE__ */ React__default.createElement("div", null, removed.length > 0 && /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "alert alert-warning"
    }, /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("i", {
      className: "fa fa-exclamation-triangle"
    }), "The following ", FirewallLabels.get("firewalls"), " could not be found in the selected account/region/VPC and were removed:"), /* @__PURE__ */ React__default.createElement("ul", null, removed.map((sg) => /* @__PURE__ */ React__default.createElement("li", {
      key: sg
    }, sg))), /* @__PURE__ */ React__default.createElement("p", {
      className: "text-right"
    }, /* @__PURE__ */ React__default.createElement("a", {
      className: "btn btn-sm btn-default dirty-flag-dismiss clickable",
      onClick: this.clearRemoved
    }, "Okay"))))), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-3 sm-label-right"
    }, FirewallLabels.get("Firewalls")), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-9"
    }, !loaded && /* @__PURE__ */ React__default.createElement("div", {
      style: { paddingTop: "13px" }
    }, /* @__PURE__ */ React__default.createElement(Spinner, {
      size: "small"
    })), loaded && /* @__PURE__ */ React__default.createElement(VirtualizedSelect, {
      multi: true,
      value: securityGroups,
      options: availableSecurityGroups,
      onChange: this.handleSecurityGroupsChanged,
      clearable: false
    }))), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group small",
      style: { marginTop: "20px" }
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-9 col-md-offset-3"
    }, /* @__PURE__ */ React__default.createElement("p", null, refreshing && /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("span", {
      className: "fa fa-sync-alt fa-spin"
    }), " "), FirewallLabels.get("Firewalls"), !refreshing && /* @__PURE__ */ React__default.createElement("span", null, " last refreshed ", timestamp(refreshTime)), refreshing && /* @__PURE__ */ React__default.createElement("span", null, " refreshing...")), /* @__PURE__ */ React__default.createElement("p", null, "If you're not finding a ", FirewallLabels.get("firewall"), " that was recently added,", " ", /* @__PURE__ */ React__default.createElement("a", {
      className: "clickable",
      onClick: () => this.refresh$.next()
    }, "click here"), " ", "to refresh the list.")))));
  }
}

class AwsLoadBalancerTransformer {
  updateHealthCounts(container) {
    const instances = container.instances;
    container.instanceCounts = {
      up: instances.filter((instance) => instance.health[0].state === "InService").length,
      down: instances.filter((instance) => instance.healthState === "Down").length,
      outOfService: instances.filter((instance) => instance.healthState === "OutOfService").length,
      starting: void 0,
      succeeded: void 0,
      failed: void 0,
      unknown: void 0
    };
    if (container.serverGroups) {
      const serverGroupInstances = flatten(container.serverGroups.map((sg) => sg.instances));
      container.instanceCounts.up = serverGroupInstances.filter((instance) => instance.health[0].state === "InService").length;
      container.instanceCounts.down = serverGroupInstances.filter((instance) => instance.healthState === "Down").length;
      container.instanceCounts.outOfService = serverGroupInstances.filter((instance) => instance.healthState === "OutOfService").length;
    }
  }
  transformInstance(instance, provider, account, region) {
    const health = instance.health || {};
    if (health.state === "healthy") {
      health.state = "InService";
    }
    instance.provider = provider;
    instance.account = account;
    instance.region = region;
    instance.healthState = health.state ? health.state === "InService" ? "Up" : "Down" : "OutOfService";
    instance.health = [health];
  }
  addVpcNameToContainer(container) {
    return (vpcs) => {
      const match = vpcs.find((test) => test.id === container.vpcId);
      container.vpcName = match ? match.name : "";
      return container;
    };
  }
  normalizeServerGroups(serverGroups, container, containerType, healthType) {
    serverGroups.forEach((serverGroup) => {
      serverGroup.account = serverGroup.account || container.account;
      serverGroup.region = serverGroup.region || container.region;
      serverGroup.cloudProvider = serverGroup.cloudProvider || container.cloudProvider;
      if (serverGroup.detachedInstances) {
        serverGroup.detachedInstances = serverGroup.detachedInstances.map((instanceId) => {
          return { id: instanceId };
        });
        serverGroup.instances = serverGroup.instances.concat(serverGroup.detachedInstances);
      } else {
        serverGroup.detachedInstances = [];
      }
      serverGroup.instances.forEach((instance) => {
        this.transformInstance(instance, container.type, container.account, container.region);
        instance[containerType] = [container.name];
        instance.health.type = healthType;
      });
      this.updateHealthCounts(serverGroup);
    });
  }
  normalizeTargetGroup(targetGroup) {
    this.normalizeServerGroups(targetGroup.serverGroups, targetGroup, "targetGroups", "TargetGroup");
    const activeServerGroups = filter(targetGroup.serverGroups, { isDisabled: false });
    targetGroup.provider = targetGroup.type;
    targetGroup.instances = chain(activeServerGroups).map("instances").flatten().value();
    targetGroup.detachedInstances = chain(activeServerGroups).map("detachedInstances").flatten().value();
    this.updateHealthCounts(targetGroup);
    return $q.all([VpcReader.listVpcs(), AccountService.listAllAccounts()]).then(([vpcs, accounts]) => {
      const tg = this.addVpcNameToContainer(targetGroup)(vpcs);
      tg.serverGroups = tg.serverGroups.map((serverGroup) => {
        const account = accounts.find((x) => x.name === serverGroup.account);
        const cloudProvider = account && account.cloudProvider || serverGroup.cloudProvider;
        serverGroup.cloudProvider = cloudProvider;
        serverGroup.instances.forEach((instance) => {
          instance.cloudProvider = cloudProvider;
          instance.provider = cloudProvider;
        });
        return { ...serverGroup, cloudProvider };
      });
      return tg;
    });
  }
  normalizeActions(loadBalancer) {
    if (loadBalancer.loadBalancerType === "application") {
      const alb = loadBalancer;
      alb.listeners.forEach((l) => {
        l.defaultActions.sort((a, b) => a.order - b.order);
        l.rules.forEach((r) => r.actions.sort((a, b) => a.order - b.order));
      });
    }
  }
  normalizeLoadBalancer(loadBalancer) {
    this.normalizeServerGroups(loadBalancer.serverGroups, loadBalancer, "loadBalancers", "LoadBalancer");
    let serverGroups = loadBalancer.serverGroups;
    if (loadBalancer.targetGroups) {
      const appLoadBalancer = loadBalancer;
      appLoadBalancer.targetGroups.forEach((targetGroup) => this.normalizeTargetGroup(targetGroup));
      serverGroups = flatten(map$1(appLoadBalancer.targetGroups, "serverGroups"));
    }
    loadBalancer.loadBalancerType = loadBalancer.loadBalancerType || "classic";
    loadBalancer.provider = loadBalancer.type;
    this.normalizeActions(loadBalancer);
    const activeServerGroups = filter(serverGroups, { isDisabled: false });
    loadBalancer.instances = chain(activeServerGroups).map("instances").flatten().value();
    loadBalancer.detachedInstances = chain(activeServerGroups).map("detachedInstances").flatten().value();
    this.updateHealthCounts(loadBalancer);
    return VpcReader.listVpcs().then((vpcs) => this.addVpcNameToContainer(loadBalancer)(vpcs));
  }
  static convertClassicLoadBalancerForEditing(loadBalancer) {
    const toEdit = {
      availabilityZones: void 0,
      isInternal: loadBalancer.isInternal,
      region: loadBalancer.region,
      cloudProvider: loadBalancer.cloudProvider,
      credentials: loadBalancer.credentials || loadBalancer.account,
      listeners: loadBalancer.listeners,
      loadBalancerType: "classic",
      name: loadBalancer.name,
      regionZones: loadBalancer.availabilityZones,
      securityGroups: loadBalancer.securityGroups,
      vpcId: loadBalancer.vpcId,
      healthCheck: void 0,
      healthTimeout: loadBalancer.healthTimeout,
      healthInterval: loadBalancer.healthInterval,
      healthyThreshold: loadBalancer.healthyThreshold,
      unhealthyThreshold: loadBalancer.unhealthyThreshold,
      healthCheckProtocol: loadBalancer.healthCheckProtocol,
      healthCheckPort: loadBalancer.healthCheckPort,
      healthCheckPath: loadBalancer.healthCheckPath,
      idleTimeout: loadBalancer.idleTimeout || 60,
      subnetType: loadBalancer.subnetType
    };
    if (loadBalancer.elb) {
      const elb = loadBalancer.elb;
      toEdit.securityGroups = elb.securityGroups;
      toEdit.vpcId = elb.vpcid || elb.vpcId;
      if (elb.listenerDescriptions) {
        toEdit.listeners = elb.listenerDescriptions.map((description) => {
          const listener = description.listener;
          if (listener.sslcertificateId) {
            const splitCertificateId = listener.sslcertificateId.split("/");
            listener.sslcertificateId = splitCertificateId[1];
            listener.sslCertificateType = splitCertificateId[0].split(":")[2];
          }
          return {
            internalProtocol: listener.instanceProtocol,
            internalPort: listener.instancePort,
            externalProtocol: listener.protocol,
            externalPort: listener.loadBalancerPort,
            sslCertificateId: listener.sslcertificateId,
            sslCertificateName: listener.sslcertificateId,
            sslCertificateType: listener.sslCertificateType,
            policyNames: description.policyNames
          };
        });
      }
      if (elb.healthCheck && elb.healthCheck.target) {
        toEdit.healthTimeout = elb.healthCheck.timeout;
        toEdit.healthInterval = elb.healthCheck.interval;
        toEdit.healthyThreshold = elb.healthCheck.healthyThreshold;
        toEdit.unhealthyThreshold = elb.healthCheck.unhealthyThreshold;
        const healthCheck = elb.healthCheck.target;
        const protocolIndex = healthCheck.indexOf(":");
        let pathIndex = healthCheck.indexOf("/");
        if (pathIndex === -1) {
          pathIndex = healthCheck.length;
        }
        if (protocolIndex !== -1) {
          toEdit.healthCheckProtocol = healthCheck.substring(0, protocolIndex);
          const healthCheckPort = Number(healthCheck.substring(protocolIndex + 1, pathIndex));
          toEdit.healthCheckPath = healthCheck.substring(pathIndex);
          if (!isNaN(healthCheckPort)) {
            toEdit.healthCheckPort = healthCheckPort;
          }
        }
      }
    }
    return toEdit;
  }
  static convertApplicationLoadBalancerForEditing(loadBalancer) {
    const applicationName = NameUtils.parseLoadBalancerName(loadBalancer.name).application;
    const toEdit = {
      availabilityZones: void 0,
      isInternal: loadBalancer.isInternal,
      region: loadBalancer.region,
      loadBalancerType: "application",
      cloudProvider: loadBalancer.cloudProvider,
      credentials: loadBalancer.account || loadBalancer.credentials,
      listeners: [],
      targetGroups: [],
      name: loadBalancer.name,
      regionZones: loadBalancer.availabilityZones,
      securityGroups: [],
      subnetType: loadBalancer.subnetType,
      vpcId: void 0,
      idleTimeout: loadBalancer.idleTimeout || 60,
      deletionProtection: loadBalancer.deletionProtection || false,
      ipAddressType: loadBalancer.ipAddressType || "ipv4",
      dualstack: loadBalancer.ipAddressType === "dualstack"
    };
    if (loadBalancer.elb) {
      const elb = loadBalancer.elb;
      toEdit.securityGroups = elb.securityGroups;
      toEdit.vpcId = elb.vpcid || elb.vpcId;
      if (elb.listeners) {
        toEdit.listeners = elb.listeners.map((listener) => {
          const certificates = [];
          if (listener.certificates) {
            listener.certificates.forEach((cert) => {
              const certArnParts = cert.certificateArn.split(":");
              const certParts = certArnParts[5].split("/");
              certificates.push({
                certificateArn: cert.certificateArn,
                type: certArnParts[2],
                name: certParts[1]
              });
            });
          }
          (listener.defaultActions || []).forEach((action) => {
            if (action.targetGroupName) {
              action.targetGroupName = action.targetGroupName.replace(`${applicationName}-`, "");
            }
            action.redirectActionConfig = action.redirectConfig;
          });
          listener.rules = (listener.rules || []).filter((l) => !l.default);
          listener.rules.forEach((rule) => {
            (rule.actions || []).forEach((action) => {
              if (action.targetGroupName) {
                action.targetGroupName = action.targetGroupName.replace(`${applicationName}-`, "");
              }
              action.redirectActionConfig = action.redirectConfig;
            });
            (rule.conditions || []).forEach((condition) => {
              if (condition.field === "http-request-method") {
                condition.values = condition.httpRequestMethodConfig.values;
              }
            });
            rule.conditions = rule.conditions || [];
          });
          listener.rules.sort((a, b) => a.priority - b.priority);
          return {
            protocol: listener.protocol,
            port: listener.port,
            defaultActions: listener.defaultActions,
            certificates,
            rules: listener.rules || [],
            sslPolicy: listener.sslPolicy
          };
        });
      }
      if (elb.targetGroups) {
        toEdit.targetGroups = elb.targetGroups.map((targetGroup) => {
          return {
            name: targetGroup.targetGroupName.replace(`${applicationName}-`, ""),
            protocol: targetGroup.protocol,
            port: targetGroup.port,
            targetType: targetGroup.targetType,
            healthCheckProtocol: targetGroup.healthCheckProtocol,
            healthCheckPort: targetGroup.healthCheckPort,
            healthCheckPath: targetGroup.healthCheckPath,
            healthCheckTimeout: targetGroup.healthCheckTimeoutSeconds,
            healthCheckInterval: targetGroup.healthCheckIntervalSeconds,
            healthyThreshold: targetGroup.healthyThresholdCount,
            unhealthyThreshold: targetGroup.unhealthyThresholdCount,
            attributes: {
              deregistrationDelay: Number(targetGroup.attributes["deregistration_delay.timeout_seconds"]),
              stickinessEnabled: targetGroup.attributes["stickiness.enabled"] === "true",
              stickinessType: targetGroup.attributes["stickiness.type"],
              stickinessDuration: Number(targetGroup.attributes["stickiness.lb_cookie.duration_seconds"]),
              multiValueHeadersEnabled: targetGroup.attributes["lambda.multi_value_headers.enabled"] === "true"
            }
          };
        });
      }
    }
    return toEdit;
  }
  static convertNetworkLoadBalancerForEditing(loadBalancer) {
    const applicationName = NameUtils.parseLoadBalancerName(loadBalancer.name).application;
    const toEdit = {
      availabilityZones: void 0,
      isInternal: loadBalancer.isInternal,
      region: loadBalancer.region,
      loadBalancerType: "network",
      cloudProvider: loadBalancer.cloudProvider,
      credentials: loadBalancer.account || loadBalancer.credentials,
      listeners: [],
      targetGroups: [],
      name: loadBalancer.name,
      regionZones: loadBalancer.availabilityZones,
      securityGroups: [],
      subnetType: loadBalancer.subnetType,
      vpcId: void 0,
      deletionProtection: loadBalancer.deletionProtection,
      loadBalancingCrossZone: loadBalancer.loadBalancingCrossZone,
      ipAddressType: loadBalancer.ipAddressType || "ipv4",
      dualstack: loadBalancer.ipAddressType === "dualstack"
    };
    if (loadBalancer.elb) {
      const elb = loadBalancer.elb;
      toEdit.securityGroups = elb.securityGroups;
      toEdit.vpcId = elb.vpcid || elb.vpcId;
      if (elb.listeners) {
        toEdit.listeners = elb.listeners.map((listener) => {
          const certificates = [];
          if (listener.certificates) {
            listener.certificates.forEach((cert) => {
              const certArnParts = cert.certificateArn.split(":");
              const certParts = certArnParts[5].split("/");
              certificates.push({
                certificateArn: cert.certificateArn,
                type: certArnParts[2],
                name: certParts[1]
              });
            });
          }
          (listener.defaultActions || []).forEach((action) => {
            if (action.targetGroupName) {
              action.targetGroupName = action.targetGroupName.replace(`${applicationName}-`, "");
            }
          });
          listener.rules = (listener.rules || []).filter((l) => !l.default);
          listener.rules.forEach((rule) => {
            (rule.actions || []).forEach((action) => {
              if (action.targetGroupName) {
                action.targetGroupName = action.targetGroupName.replace(`${applicationName}-`, "");
              }
            });
            rule.conditions = rule.conditions || [];
          });
          listener.rules.sort((a, b) => a.priority - b.priority);
          return {
            protocol: listener.protocol,
            port: listener.port,
            defaultActions: listener.defaultActions,
            certificates,
            rules: listener.rules || [],
            sslPolicy: listener.sslPolicy
          };
        });
      }
      if (elb.targetGroups) {
        toEdit.targetGroups = elb.targetGroups.map((targetGroup) => {
          return {
            name: targetGroup.targetGroupName.replace(`${applicationName}-`, ""),
            protocol: targetGroup.protocol,
            port: targetGroup.port,
            targetType: targetGroup.targetType,
            healthCheckProtocol: targetGroup.healthCheckProtocol,
            healthCheckPort: targetGroup.healthCheckPort,
            healthCheckTimeout: targetGroup.healthCheckTimeoutSeconds,
            healthCheckInterval: targetGroup.healthCheckIntervalSeconds,
            healthyThreshold: targetGroup.healthyThresholdCount,
            unhealthyThreshold: targetGroup.unhealthyThresholdCount,
            healthCheckPath: targetGroup.healthCheckPath,
            attributes: {
              deregistrationDelay: Number(targetGroup.attributes["deregistration_delay.timeout_seconds"]),
              deregistrationDelayConnectionTermination: Boolean(targetGroup.attributes["deregistration_delay.connection_termination.enabled"] === "true"),
              preserveClientIp: Boolean(targetGroup.attributes["preserve_client_ip.enabled"] === "true")
            }
          };
        });
      }
    }
    return toEdit;
  }
  static constructNewClassicLoadBalancerTemplate(application) {
    const defaultCredentials = application.defaultCredentials.aws || AWSProviderSettings.defaults.account;
    const defaultRegion = application.defaultRegions.aws || AWSProviderSettings.defaults.region;
    const defaultSubnetType = AWSProviderSettings.defaults.subnetType;
    return {
      availabilityZones: void 0,
      name: "",
      stack: "",
      detail: "",
      loadBalancerType: "classic",
      isInternal: false,
      cloudProvider: "aws",
      credentials: defaultCredentials,
      region: defaultRegion,
      vpcId: null,
      subnetType: defaultSubnetType,
      healthCheck: void 0,
      healthCheckProtocol: "HTTP",
      healthCheckPort: 7001,
      healthCheckPath: "/healthcheck",
      healthTimeout: 5,
      healthInterval: 10,
      healthyThreshold: 10,
      unhealthyThreshold: 2,
      idleTimeout: 60,
      regionZones: [],
      securityGroups: [],
      listeners: [
        {
          externalPort: 80,
          externalProtocol: "HTTP",
          internalPort: 7001,
          internalProtocol: "HTTP"
        }
      ]
    };
  }
  static constructNewApplicationLoadBalancerTemplate(application) {
    const defaultCredentials = application.defaultCredentials.aws || AWSProviderSettings.defaults.account;
    const defaultRegion = application.defaultRegions.aws || AWSProviderSettings.defaults.region;
    const defaultSubnetType = AWSProviderSettings.defaults.subnetType;
    const defaultPort = application.attributes.instancePort || SETTINGS.defaultInstancePort;
    const defaultTargetGroupName = `targetgroup`;
    return {
      name: "",
      availabilityZones: void 0,
      stack: "",
      detail: "",
      loadBalancerType: "application",
      ipAddressType: "ipv4",
      dualstack: false,
      isInternal: false,
      cloudProvider: "aws",
      credentials: defaultCredentials,
      region: defaultRegion,
      vpcId: null,
      subnetType: defaultSubnetType,
      idleTimeout: 60,
      deletionProtection: false,
      targetGroups: [
        {
          name: defaultTargetGroupName,
          protocol: "HTTP",
          port: defaultPort,
          targetType: "instance",
          healthCheckProtocol: "HTTP",
          healthCheckPort: "traffic-port",
          healthCheckPath: "/healthcheck",
          healthCheckTimeout: 5,
          healthCheckInterval: 10,
          healthyThreshold: 10,
          unhealthyThreshold: 2,
          attributes: {
            deregistrationDelay: 300,
            stickinessEnabled: false,
            stickinessType: "lb_cookie",
            stickinessDuration: 8400,
            multiValueHeadersEnabled: false
          }
        }
      ],
      regionZones: [],
      securityGroups: [],
      listeners: [
        {
          certificates: [],
          protocol: "HTTP",
          port: 80,
          defaultActions: [
            {
              type: "forward",
              targetGroupName: defaultTargetGroupName
            }
          ],
          rules: []
        }
      ]
    };
  }
  static constructNewNetworkLoadBalancerTemplate(application) {
    const defaultCredentials = application.defaultCredentials.aws || AWSProviderSettings.defaults.account;
    const defaultRegion = application.defaultRegions.aws || AWSProviderSettings.defaults.region;
    const defaultSubnetType = AWSProviderSettings.defaults.subnetType;
    const defaultTargetGroupName = `targetgroup`;
    return {
      name: "",
      availabilityZones: void 0,
      stack: "",
      detail: "",
      loadBalancerType: "network",
      isInternal: false,
      ipAddressType: "ipv4",
      dualstack: false,
      cloudProvider: "aws",
      credentials: defaultCredentials,
      region: defaultRegion,
      vpcId: null,
      subnetType: defaultSubnetType,
      deletionProtection: false,
      loadBalancingCrossZone: true,
      securityGroups: [],
      targetGroups: [
        {
          name: defaultTargetGroupName,
          protocol: "TCP",
          port: 7001,
          targetType: "instance",
          healthCheckProtocol: "TCP",
          healthCheckPath: "/healthcheck",
          healthCheckPort: "traffic-port",
          healthCheckTimeout: 5,
          healthCheckInterval: 10,
          healthyThreshold: 10,
          unhealthyThreshold: 10,
          attributes: {
            deregistrationDelay: 300
          }
        }
      ],
      regionZones: [],
      listeners: [
        {
          certificates: [],
          protocol: "TCP",
          port: 80,
          defaultActions: [
            {
              type: "forward",
              targetGroupName: defaultTargetGroupName
            }
          ],
          rules: []
        }
      ]
    };
  }
}

var css_248z$g = ".wizard-pod {\n  padding-bottom: 15px;\n}\n.wizard-pod > div {\n  border: 1px solid var(--color-cirrus);\n}\n.wizard-pod .wizard-pod-row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 5px;\n  border-bottom: 1px solid var(--color-cirrus);\n}\n.wizard-pod .wizard-pod-row label {\n  font-weight: 400;\n  padding-right: 5px;\n}\n.wizard-pod .wizard-pod-row.header {\n  background-color: var(--color-cirrus);\n}\n.wizard-pod .wizard-pod-row.header .glyphicon-trash {\n  padding: 0 8px;\n}\n.wizard-pod .wizard-pod-row.header .wizard-pod-row-contents .wizard-pod-row-title {\n  font-weight: 800;\n}\n.wizard-pod .wizard-pod-row.header .wizard-pod-row-contents .wizard-pod-row-data {\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n  padding: 0;\n}\n.wizard-pod .wizard-pod-row.header .wizard-pod-row-contents .wizard-pod-row-data label {\n  font-weight: 600;\n}\n.wizard-pod .wizard-pod-row.header .wizard-pod-row-contents .wizard-pod-row-data .wizard-pod-content {\n  padding: 0 10px 0 0;\n}\n.wizard-pod .wizard-pod-row .wizard-pod-row-title {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  max-height: 37px;\n  -ms-flex-preferred-size: 120px;\n      flex-basis: 120px;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: reverse;\n      -ms-flex-direction: row-reverse;\n          flex-direction: row-reverse;\n  font-weight: 600;\n  text-align: right;\n  margin-right: 10px;\n  width: 100px;\n}\n.wizard-pod .wizard-pod-row .wizard-pod-row-contents {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  -webkit-box-align: baseline;\n      -ms-flex-align: baseline;\n          align-items: baseline;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.wizard-pod .wizard-pod-row .wizard-pod-row-contents .wizard-pod-row-data {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  -webkit-box-align: baseline;\n      -ms-flex-align: baseline;\n          align-items: baseline;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  padding: 5px 0;\n}\n.wizard-pod .wizard-pod-row .wizard-pod-row-contents .wizard-pod-row-data.spread {\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.wizard-pod .wizard-pod-row .wizard-pod-row-contents .wizard-pod-row-data .wizard-pod-content {\n  padding: 0 10px 5px 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.wizard-pod .wizard-pod-row .wizard-pod-row-contents .wizard-pod-row-data .group-name-prefix {\n  -webkit-box-flex: 2;\n      -ms-flex-positive: 2;\n          flex-grow: 2;\n  white-space: nowrap;\n}\n.wizard-pod .wizard-pod-row .wizard-pod-row-contents .wizard-pod-row-data .rules-table thead th {\n  font-weight: 600;\n}\n.wizard-pod .wizard-pod-row .wizard-pod-row-contents .wizard-pod-row-data .rules-table td {\n  vertical-align: middle;\n}\n.wizard-pod .wizard-pod-row .wizard-pod-row-contents .wizard-pod-row-data .rules-table > tbody > tr:first-child > td {\n  border-top: none;\n}\n.wizard-pod .wizard-pod-row .wizard-pod-row-contents .wizard-pod-row-errors {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n.wizard-pod .listener-rule .handle {\n  cursor: move;\n  width: 10px;\n  padding: 0;\n}\n.wizard-pod .listener-rule .listener-rule-condition {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.wizard-pod .listener-rule .listener-rule-condition label {\n  white-space: nowrap;\n}\n.wizard-pod .listener-rule .listener-rule-condition .help-field > span {\n  top: 4px;\n  padding: 0 2px;\n}\n.wizard-pod .listener-rule .listener-rule-condition .remove-condition {\n  min-width: 15px;\n  padding-top: 4px;\n}\n.wizard-pod .listener-rule .add-new-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.wizard-pod .listener-rule .add-new-container .add-new {\n  padding: 2px;\n  margin-bottom: 0;\n}\n.rule-sortable-helper {\n  z-index: 99999;\n  width: 500px;\n}\n";
styleInject(css_248z$g);

const _CreateApplicationLoadBalancer = class extends React__default.Component {
  constructor(props) {
    super(props);
    this._isUnmounted = false;
    this.certificateTypes = get(AWSProviderSettings, "loadBalancers.certificateTypes", ["iam", "acm"]);
    this.submit = (values) => {
      const { app, forPipelineConfig, closeModal } = this.props;
      const { isNew } = this.state;
      const descriptor = isNew ? "Create" : "Update";
      const loadBalancerCommandFormatted = cloneDeep(values);
      loadBalancerCommandFormatted.listeners.forEach((listener) => {
        listener.defaultActions.forEach((a) => {
          if (a.authenticateOidcConfig) {
            a.authenticateOidcActionConfig = a.authenticateOidcConfig;
            delete a.authenticateOidcConfig;
          }
        });
        listener.rules.forEach((r) => r.actions.forEach((a) => {
          if (a.authenticateOidcConfig) {
            a.authenticateOidcActionConfig = a.authenticateOidcConfig;
            delete a.authenticateOidcConfig;
          }
        }));
      });
      if (forPipelineConfig) {
        this.formatListeners(loadBalancerCommandFormatted).then(() => {
          this.setIpAddressType(loadBalancerCommandFormatted);
          closeModal && closeModal(loadBalancerCommandFormatted);
        });
      } else {
        const taskMonitor = new TaskMonitor({
          application: app,
          title: `${isNew ? "Creating" : "Updating"} your load balancer`,
          modalInstance: TaskMonitor.modalInstanceEmulation(() => this.props.dismissModal()),
          onTaskComplete: () => this.onTaskComplete(loadBalancerCommandFormatted)
        });
        taskMonitor.submit(() => {
          return this.formatListeners(loadBalancerCommandFormatted).then(() => {
            this.formatCommand(loadBalancerCommandFormatted);
            return LoadBalancerWriter.upsertLoadBalancer(loadBalancerCommandFormatted, app, descriptor);
          });
        });
        this.setState({ taskMonitor });
      }
    };
    const loadBalancerCommand = props.command ? props.command : props.loadBalancer ? AwsLoadBalancerTransformer.convertApplicationLoadBalancerForEditing(props.loadBalancer) : AwsLoadBalancerTransformer.constructNewApplicationLoadBalancerTemplate(props.app);
    this.state = {
      includeSecurityGroups: !!loadBalancerCommand.vpcId,
      isNew: !props.loadBalancer,
      loadBalancerCommand,
      taskMonitor: null
    };
  }
  static show(props) {
    const modalProps = { dialogClassName: "wizard-modal modal-lg" };
    return ReactModal.show(_CreateApplicationLoadBalancer, props, modalProps);
  }
  certificateIdAsARN(accountId, certificateId, region, certificateType) {
    if (certificateId && (certificateId.indexOf("arn:aws:iam::") !== 0 || certificateId.indexOf("arn:aws:acm:") !== 0)) {
      if (certificateType === "iam") {
        return `arn:aws:iam::${accountId}:server-certificate/${certificateId}`;
      }
      if (certificateType === "acm") {
        return `arn:aws:acm:${region}:${accountId}:certificate/${certificateId}`;
      }
    }
    return certificateId;
  }
  formatListeners(command) {
    return AccountService.getAccountDetails(command.credentials).then((account) => {
      command.listeners.forEach((listener) => {
        if (listener.protocol === "HTTP") {
          delete listener.sslPolicy;
          listener.certificates = [];
        }
        listener.certificates.forEach((certificate) => {
          certificate.certificateArn = this.certificateIdAsARN(account.accountId, certificate.name, command.region, certificate.type || this.certificateTypes[0]);
        });
      });
    });
  }
  setAvailabilityZones(loadBalancerCommand) {
    const availabilityZones = {};
    availabilityZones[loadBalancerCommand.region] = loadBalancerCommand.regionZones || [];
    loadBalancerCommand.availabilityZones = availabilityZones;
  }
  addAppName(name) {
    return `${this.props.app.name}-${name}`;
  }
  manageTargetGroupNames(command) {
    (command.targetGroups || []).forEach((targetGroupDescription) => {
      targetGroupDescription.name = this.addAppName(targetGroupDescription.name);
    });
    (command.listeners || []).forEach((listenerDescription) => {
      listenerDescription.defaultActions.forEach((actionDescription) => {
        if (actionDescription.targetGroupName) {
          actionDescription.targetGroupName = this.addAppName(actionDescription.targetGroupName);
        }
      });
      (listenerDescription.rules || []).forEach((ruleDescription) => {
        ruleDescription.actions.forEach((actionDescription) => {
          if (actionDescription.targetGroupName) {
            actionDescription.targetGroupName = this.addAppName(actionDescription.targetGroupName);
          }
        });
      });
    });
  }
  manageRules(command) {
    command.listeners.forEach((listener) => {
      listener.rules.forEach((rule, index) => {
        rule.priority = index + 1;
        rule.conditions = rule.conditions.filter((condition) => {
          if (condition.field !== "http-request-method") {
            return condition.values[0].length > 0;
          }
          return condition.values.length > 0;
        });
      });
    });
  }
  setIpAddressType(command) {
    command.ipAddressType = command.dualstack ? "dualstack" : "ipv4";
    delete command.dualstack;
  }
  formatCommand(command) {
    this.setAvailabilityZones(command);
    this.manageTargetGroupNames(command);
    this.manageRules(command);
    this.setIpAddressType(command);
  }
  onApplicationRefresh(values) {
    if (this._isUnmounted) {
      return;
    }
    this.refreshUnsubscribe = void 0;
    this.props.dismissModal();
    this.setState({ taskMonitor: void 0 });
    const newStateParams = {
      name: values.name,
      accountId: values.credentials,
      region: values.region,
      vpcId: values.vpcId,
      provider: "aws"
    };
    if (!ReactInjector.$state.includes("**.loadBalancerDetails")) {
      ReactInjector.$state.go(".loadBalancerDetails", newStateParams);
    } else {
      ReactInjector.$state.go("^.loadBalancerDetails", newStateParams);
    }
  }
  componentWillUnmount() {
    this._isUnmounted = true;
    if (this.refreshUnsubscribe) {
      this.refreshUnsubscribe();
    }
  }
  onTaskComplete(values) {
    this.props.app.loadBalancers.refresh();
    this.refreshUnsubscribe = this.props.app.loadBalancers.onNextRefresh(null, () => this.onApplicationRefresh(values));
  }
  render() {
    const { app, dismissModal, forPipelineConfig, loadBalancer } = this.props;
    const { isNew, loadBalancerCommand, taskMonitor } = this.state;
    let heading = forPipelineConfig ? "Configure Application Load Balancer" : "Create New Application Load Balancer";
    if (!isNew) {
      heading = `Edit ${loadBalancerCommand.name}: ${loadBalancerCommand.region}: ${loadBalancerCommand.credentials}`;
    }
    return /* @__PURE__ */ React__default.createElement(WizardModal, {
      heading,
      initialValues: loadBalancerCommand,
      taskMonitor,
      dismissModal,
      closeModal: this.submit,
      submitButtonLabel: forPipelineConfig ? isNew ? "Add" : "Done" : isNew ? "Create" : "Update",
      render: ({ formik, nextIdx, wizard }) => {
        const showLocationSection = isNew || forPipelineConfig;
        const showSecurityGroups = !!formik.values.vpcId;
        return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, showLocationSection && /* @__PURE__ */ React__default.createElement(WizardPage, {
          label: "Location",
          wizard,
          order: nextIdx(),
          render: ({ innerRef }) => /* @__PURE__ */ React__default.createElement(LoadBalancerLocation, {
            app,
            forPipelineConfig,
            formik,
            isNew,
            loadBalancer,
            ref: innerRef
          })
        }), showSecurityGroups && /* @__PURE__ */ React__default.createElement(WizardPage, {
          label: FirewallLabels.get("Firewalls"),
          wizard,
          order: nextIdx(),
          render: ({ innerRef, onLoadingChanged }) => /* @__PURE__ */ React__default.createElement(SecurityGroups, {
            formik,
            isNew,
            onLoadingChanged,
            ref: innerRef
          })
        }), /* @__PURE__ */ React__default.createElement(WizardPage, {
          label: "Target Groups",
          wizard,
          order: nextIdx(),
          render: ({ innerRef }) => /* @__PURE__ */ React__default.createElement(TargetGroups$1, {
            ref: innerRef,
            app,
            formik,
            isNew,
            loadBalancer
          })
        }), /* @__PURE__ */ React__default.createElement(WizardPage, {
          label: "Listeners",
          wizard,
          order: nextIdx(),
          render: ({ innerRef }) => /* @__PURE__ */ React__default.createElement(ALBListeners, {
            ref: innerRef,
            app,
            formik
          })
        }), /* @__PURE__ */ React__default.createElement(WizardPage, {
          label: "Advanced Settings",
          wizard,
          order: nextIdx(),
          render: ({ innerRef }) => /* @__PURE__ */ React__default.createElement(ALBAdvancedSettings, {
            ref: innerRef
          })
        }));
      }
    });
  }
};
let CreateApplicationLoadBalancer = _CreateApplicationLoadBalancer;
CreateApplicationLoadBalancer.defaultProps = {
  closeModal: noop,
  dismissModal: noop
};

var css_248z$f = ".AmazonLoadBalancer-AdvancedSettings .StandardFieldLayout .sm-label-right {\n  width: 180px;\n}\n";
styleInject(css_248z$f);

class AdvancedSettings extends React__default.Component {
  render() {
    const { values } = this.props.formik;
    const { maxValue } = Validators;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group AmazonLoadBalancer-AdvancedSettings"
    }, /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "healthTimeout",
      label: "Timeout",
      required: true,
      help: /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "loadBalancer.advancedSettings.healthTimeout"
      }),
      input: (props) => /* @__PURE__ */ React__default.createElement(NumberInput, {
        ...props,
        min: 0,
        max: values.healthInterval
      }),
      validate: maxValue(values.healthInterval, "Timeout must be less than the health interval.")
    }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "healthInterval",
      label: "Interval",
      required: true,
      help: /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "loadBalancer.advancedSettings.healthInterval"
      }),
      input: (props) => /* @__PURE__ */ React__default.createElement(NumberInput, {
        ...props,
        min: 0
      })
    }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "healthyThreshold",
      label: "Healthy Threshold",
      required: true,
      help: /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "loadBalancer.advancedSettings.healthyThreshold"
      }),
      input: (props) => /* @__PURE__ */ React__default.createElement(NumberInput, {
        ...props,
        min: 0
      })
    }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "unhealthyThreshold",
      label: "Unhealthy Threshold",
      required: true,
      help: /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "loadBalancer.advancedSettings.unhealthyThreshold"
      }),
      input: (props) => /* @__PURE__ */ React__default.createElement(NumberInput, {
        ...props,
        min: 0
      })
    }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "idleTimeout",
      label: "Idle Timeout",
      required: true,
      help: /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "loadBalancer.advancedSettings.idleTimeout"
      }),
      input: (props) => /* @__PURE__ */ React__default.createElement(NumberInput, {
        ...props,
        min: 0
      })
    }), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12"
    }, /* @__PURE__ */ React__default.createElement("p", null, "Additional configuration options (cross-zone load balancing, session stickiness, access logs) are available via the AWS console.")));
  }
}

class HealthCheck extends React__default.Component {
  constructor() {
    super(...arguments);
    this.healthCheckPathChanged = (value) => {
      if (value && value.indexOf("/") !== 0) {
        this.props.formik.setFieldValue("healthCheckPath", `/${value}`);
      }
    };
  }
  requiresHealthCheckPath() {
    const { values } = this.props.formik;
    return values.healthCheckProtocol && values.healthCheckProtocol.indexOf("HTTP") === 0;
  }
  render() {
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "container-fluid form-horizontal"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-4 sm-label-right"
    }, "Ping"), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-8"
    }, /* @__PURE__ */ React__default.createElement("table", {
      className: "table table-condensed packed"
    }, /* @__PURE__ */ React__default.createElement("thead", null, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("th", {
      style: { width: "35%" }
    }, "Protocol"), /* @__PURE__ */ React__default.createElement("th", {
      style: { width: "30%" }
    }, "Port"), /* @__PURE__ */ React__default.createElement("th", null, this.requiresHealthCheckPath() && /* @__PURE__ */ React__default.createElement("span", null, "Path")))), /* @__PURE__ */ React__default.createElement("tbody", null, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "healthCheckProtocol",
      required: true,
      input: (props) => /* @__PURE__ */ React__default.createElement(SelectInput, {
        ...props,
        options: ["HTTP", "HTTPS", "SSL", "TCP"]
      })
    })), /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "healthCheckPort",
      required: true,
      input: (props) => /* @__PURE__ */ React__default.createElement(NumberInput, {
        ...props,
        min: 1,
        max: 65534
      })
    })), /* @__PURE__ */ React__default.createElement("td", null, this.requiresHealthCheckPath() && /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "healthCheckPath",
      input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
        ...props
      }),
      required: true,
      onChange: this.healthCheckPathChanged
    })))))));
  }
}

var css_248z$e = ".create-classic-load-balancer-wizard-listeners .Select-control {\n  height: 30px;\n}\n.create-classic-load-balancer-wizard-listeners .Select-control .Select-placeholder {\n  line-height: 26px;\n}\n.create-classic-load-balancer-wizard-listeners .Select-control .Select-value {\n  line-height: 26px !important;\n}\n.create-classic-load-balancer-wizard-listeners .Select-control .Select-value .Select-value-label {\n  line-height: 26px;\n}\n.create-classic-load-balancer-wizard-listeners .Select-control .Select-input {\n  height: 26px;\n}\n";
styleInject(css_248z$e);

class Listeners extends React__default.Component {
  constructor() {
    super(...arguments);
    this.protocols = ["HTTP", "HTTPS", "TCP", "SSL"];
    this.secureProtocols = ["HTTPS", "SSL"];
    this.certificateTypes = get(AWSProviderSettings, "loadBalancers.certificateTypes", ["iam", "acm"]);
    this.state = {
      certificates: []
    };
    this.addListener = () => {
      this.props.formik.values.listeners.push({
        internalProtocol: "HTTP",
        externalProtocol: "HTTP",
        externalPort: 80,
        internalPort: 80
      });
      this.updateListeners();
    };
  }
  componentDidMount() {
    this.loadCertificates();
  }
  loadCertificates() {
    AmazonCertificateReader.listCertificates().then((certificates) => {
      this.setState({ certificates });
    });
  }
  updateListeners() {
    const { values, setFieldValue } = this.props.formik;
    setFieldValue("listeners", values.listeners);
  }
  showCertificateSelect(listener) {
    return listener.sslCertificateType === "iam" && this.state.certificates && Object.keys(this.state.certificates).length > 0;
  }
  listenerExternalProtocolChanged(listener, newProtocol) {
    listener.externalProtocol = newProtocol;
    if (this.secureProtocols.includes(newProtocol)) {
      listener.externalPort = 443;
      if (this.certificateTypes.length >= 1) {
        listener.sslCertificateType = this.certificateTypes[0];
      }
    }
    if (newProtocol === "HTTP") {
      listener.externalPort = 80;
    }
    this.updateListeners();
  }
  listenerInternalProtocolChanged(listener, newProtocol) {
    listener.internalProtocol = newProtocol;
    this.updateListeners();
  }
  listenerExternalPortChanged(listener, newPort) {
    listener.externalPort = Number.parseInt(newPort, 10);
    this.updateListeners();
  }
  listenerInternalPortChanged(listener, newPort) {
    listener.internalPort = Number.parseInt(newPort, 10);
    this.updateListeners();
  }
  listenerCertificateTypeChanged(listener, newProtocol) {
    listener.sslCertificateType = newProtocol;
    this.updateListeners();
  }
  handleListenerCertificateChanged(listener, newCertificate) {
    listener.sslCertificateName = newCertificate;
    this.updateListeners();
  }
  removeListener(index) {
    this.props.formik.values.listeners.splice(index, 1);
    this.updateListeners();
  }
  renderCertificateSelector(listener) {
    if (!this.secureProtocols.includes(listener.externalProtocol)) {
      return null;
    } else if (this.showCertificateSelect(listener)) {
      const { values } = this.props.formik;
      const { certificates } = this.state;
      return /* @__PURE__ */ React__default.createElement(AmazonCertificateSelectField, {
        certificates,
        accountName: values.credentials,
        currentValue: listener.sslCertificateName,
        app: this.props.app,
        onCertificateSelect: (value) => this.handleListenerCertificateChanged(listener, value)
      });
    } else {
      return /* @__PURE__ */ React__default.createElement("input", {
        className: "input-sm",
        style: { width: "100%", marginLeft: "10px" },
        required: true,
        onChange: (e) => this.handleListenerCertificateChanged(listener, e.target.value),
        value: listener.sslCertificateName
      });
    }
  }
  render() {
    const { values } = this.props.formik;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "container-fluid form-horizontal create-classic-load-balancer-wizard-listeners"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12"
    }, /* @__PURE__ */ React__default.createElement("table", {
      className: "table table-condensed packed"
    }, /* @__PURE__ */ React__default.createElement("thead", null, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("th", null, "External Protocol"), /* @__PURE__ */ React__default.createElement("th", null, "External Port"), /* @__PURE__ */ React__default.createElement("th", null), /* @__PURE__ */ React__default.createElement("th", null, "Internal Protocol"), /* @__PURE__ */ React__default.createElement("th", null, "Internal Port"), /* @__PURE__ */ React__default.createElement("th", null))), /* @__PURE__ */ React__default.createElement("tbody", null, values.listeners.map((listener, index) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, {
      key: index
    }, /* @__PURE__ */ React__default.createElement("tr", {
      key: index + "-main"
    }, /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement("select", {
      className: "form-control input-sm",
      value: listener.externalProtocol,
      onChange: (event) => this.listenerExternalProtocolChanged(listener, event.target.value)
    }, this.protocols.map((p) => /* @__PURE__ */ React__default.createElement("option", {
      key: p
    }, p)))), /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement("input", {
      className: "form-control input-sm",
      type: "number",
      min: "0",
      value: listener.externalPort,
      onChange: (event) => this.listenerExternalPortChanged(listener, event.target.value),
      required: true
    })), /* @__PURE__ */ React__default.createElement("td", {
      className: "small",
      style: { paddingTop: "10px" }
    }, "\u2192"), /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement("select", {
      className: "form-control input-sm",
      value: listener.internalProtocol,
      onChange: (event) => this.listenerInternalProtocolChanged(listener, event.target.value)
    }, this.protocols.map((p) => /* @__PURE__ */ React__default.createElement("option", {
      key: p
    }, p)))), /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement("input", {
      className: "form-control input-sm",
      type: "number",
      min: "0",
      value: listener.internalPort,
      onChange: (event) => this.listenerInternalPortChanged(listener, event.target.value),
      required: true
    })), /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement("a", {
      className: "sm-label clickable",
      onClick: () => this.removeListener(index)
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-trash"
    })))), this.secureProtocols.includes(listener.externalProtocol) && /* @__PURE__ */ React__default.createElement("tr", {
      key: index + "-ssl"
    }, /* @__PURE__ */ React__default.createElement("td", {
      colSpan: 5,
      style: { borderTopWidth: 0 }
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "horizontal space-between"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "sm-label-right"
    }, "Certificate"), this.certificateTypes.length > 1 && /* @__PURE__ */ React__default.createElement("select", {
      style: { width: "45px", marginLeft: "10px" },
      className: "form-control input-sm",
      value: listener.sslCertificateType,
      onChange: (event) => this.listenerCertificateTypeChanged(listener, event.target.value)
    }, this.certificateTypes.map((t) => /* @__PURE__ */ React__default.createElement("option", {
      key: t
    }, t))), this.renderCertificateSelector(listener))))))), /* @__PURE__ */ React__default.createElement("tfoot", null, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", {
      colSpan: 5
    }, /* @__PURE__ */ React__default.createElement("button", {
      className: "add-new col-md-12",
      onClick: this.addListener,
      type: "button"
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-plus-sign"
    }), /* @__PURE__ */ React__default.createElement("span", null, " Add new port mapping")))))))));
  }
}

const _CreateClassicLoadBalancer = class extends React__default.Component {
  constructor(props) {
    super(props);
    this._isUnmounted = false;
    this.certificateTypes = get(AWSProviderSettings, "loadBalancers.certificateTypes", ["iam", "acm"]);
    this.submit = (values) => {
      const { app, forPipelineConfig, closeModal } = this.props;
      const { isNew } = this.state;
      const descriptor = isNew ? "Create" : "Update";
      const loadBalancerCommandFormatted = cloneDeep(values);
      if (forPipelineConfig) {
        this.formatListeners(loadBalancerCommandFormatted).then(() => {
          closeModal && closeModal(loadBalancerCommandFormatted);
        });
      } else {
        const taskMonitor = new TaskMonitor({
          application: app,
          title: `${isNew ? "Creating" : "Updating"} your load balancer`,
          modalInstance: TaskMonitor.modalInstanceEmulation(() => this.props.dismissModal()),
          onTaskComplete: () => this.onTaskComplete(loadBalancerCommandFormatted)
        });
        taskMonitor.submit(() => {
          return this.formatListeners(loadBalancerCommandFormatted).then(() => {
            this.formatCommand(loadBalancerCommandFormatted);
            return LoadBalancerWriter.upsertLoadBalancer(loadBalancerCommandFormatted, app, descriptor);
          });
        });
        this.setState({ taskMonitor });
      }
    };
    this.validate = (_values) => {
      const errors = {};
      return errors;
    };
    const loadBalancerCommand = props.command ? props.command : props.loadBalancer ? AwsLoadBalancerTransformer.convertClassicLoadBalancerForEditing(props.loadBalancer) : AwsLoadBalancerTransformer.constructNewClassicLoadBalancerTemplate(props.app);
    this.state = {
      isNew: !props.loadBalancer,
      loadBalancerCommand,
      taskMonitor: null
    };
  }
  static show(props) {
    const modalProps = { dialogClassName: "wizard-modal modal-lg" };
    return ReactModal.show(_CreateClassicLoadBalancer, props, modalProps);
  }
  certificateIdAsARN(accountId, certificateId, region, certificateType) {
    if (certificateId && (certificateId.indexOf("arn:aws:iam::") !== 0 || certificateId.indexOf("arn:aws:acm:") !== 0)) {
      if (certificateType === "iam") {
        return `arn:aws:iam::${accountId}:server-certificate/${certificateId}`;
      }
      if (certificateType === "acm") {
        return `arn:aws:acm:${region}:${accountId}:certificate/${certificateId}`;
      }
    }
    return certificateId;
  }
  formatListeners(command) {
    return AccountService.getAccountDetails(command.credentials).then((account) => {
      command.listeners.forEach((listener) => {
        listener.sslCertificateId = this.certificateIdAsARN(account.accountId, listener.sslCertificateName, command.region, listener.sslCertificateType || this.certificateTypes[0]);
      });
    });
  }
  clearSecurityGroupsIfNotInVpc(loadBalancer) {
    if (!loadBalancer.vpcId && !loadBalancer.subnetType) {
      loadBalancer.securityGroups = null;
    }
  }
  addHealthCheckToCommand(loadBalancer) {
    let healthCheck = null;
    const protocol = loadBalancer.healthCheckProtocol || "";
    if (protocol.startsWith("HTTP")) {
      healthCheck = `${protocol}:${loadBalancer.healthCheckPort}${loadBalancer.healthCheckPath}`;
    } else {
      healthCheck = `${protocol}:${loadBalancer.healthCheckPort}`;
    }
    loadBalancer.healthCheck = healthCheck;
  }
  setAvailabilityZones(loadBalancerCommand) {
    const availabilityZones = {};
    availabilityZones[loadBalancerCommand.region] = loadBalancerCommand.regionZones || [];
    loadBalancerCommand.availabilityZones = availabilityZones;
  }
  formatCommand(command) {
    this.setAvailabilityZones(command);
    this.clearSecurityGroupsIfNotInVpc(command);
    this.addHealthCheckToCommand(command);
  }
  onApplicationRefresh(values) {
    if (this._isUnmounted) {
      return;
    }
    this.refreshUnsubscribe = void 0;
    this.props.dismissModal();
    this.setState({ taskMonitor: void 0 });
    const newStateParams = {
      name: values.name,
      accountId: values.credentials,
      region: values.region,
      vpcId: values.vpcId,
      provider: "aws"
    };
    if (!ReactInjector.$state.includes("**.loadBalancerDetails")) {
      ReactInjector.$state.go(".loadBalancerDetails", newStateParams);
    } else {
      ReactInjector.$state.go("^.loadBalancerDetails", newStateParams);
    }
  }
  componentWillUnmount() {
    this._isUnmounted = true;
    if (this.refreshUnsubscribe) {
      this.refreshUnsubscribe();
    }
  }
  onTaskComplete(values) {
    this.props.app.loadBalancers.refresh();
    this.refreshUnsubscribe = this.props.app.loadBalancers.onNextRefresh(null, () => this.onApplicationRefresh(values));
  }
  render() {
    const { app, dismissModal, forPipelineConfig, loadBalancer } = this.props;
    const { isNew, loadBalancerCommand, taskMonitor } = this.state;
    const showLocationSection = isNew || forPipelineConfig;
    let heading = forPipelineConfig ? "Configure Classic Load Balancer" : "Create New Classic Load Balancer";
    if (!isNew) {
      heading = `Edit ${loadBalancerCommand.name}: ${loadBalancerCommand.region}: ${loadBalancerCommand.credentials}`;
    }
    return /* @__PURE__ */ React__default.createElement(WizardModal, {
      heading,
      initialValues: loadBalancerCommand,
      taskMonitor,
      dismissModal,
      closeModal: this.submit,
      submitButtonLabel: forPipelineConfig ? isNew ? "Add" : "Done" : isNew ? "Create" : "Update",
      validate: this.validate,
      render: ({ formik, nextIdx, wizard }) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, showLocationSection && /* @__PURE__ */ React__default.createElement(WizardPage, {
        label: "Location",
        wizard,
        order: nextIdx(),
        render: ({ innerRef }) => /* @__PURE__ */ React__default.createElement(LoadBalancerLocation, {
          app,
          formik,
          isNew,
          forPipelineConfig,
          loadBalancer,
          ref: innerRef
        })
      }), !!formik.values.vpcId && /* @__PURE__ */ React__default.createElement(WizardPage, {
        label: FirewallLabels.get("Firewall"),
        wizard,
        order: nextIdx(),
        render: ({ innerRef, onLoadingChanged }) => /* @__PURE__ */ React__default.createElement(SecurityGroups, {
          formik,
          isNew,
          onLoadingChanged,
          ref: innerRef
        })
      }), /* @__PURE__ */ React__default.createElement(WizardPage, {
        label: "Listeners",
        wizard,
        order: nextIdx(),
        render: ({ innerRef }) => /* @__PURE__ */ React__default.createElement(Listeners, {
          ref: innerRef,
          formik,
          app
        })
      }), /* @__PURE__ */ React__default.createElement(WizardPage, {
        label: "Health Check",
        wizard,
        order: nextIdx(),
        render: ({ innerRef }) => /* @__PURE__ */ React__default.createElement(HealthCheck, {
          ref: innerRef,
          formik
        })
      }), /* @__PURE__ */ React__default.createElement(WizardPage, {
        label: "Advanced Settings",
        wizard,
        order: nextIdx(),
        render: ({ innerRef }) => /* @__PURE__ */ React__default.createElement(AdvancedSettings, {
          ref: innerRef,
          formik
        })
      }))
    });
  }
};
let CreateClassicLoadBalancer = _CreateClassicLoadBalancer;
CreateClassicLoadBalancer.defaultProps = {
  closeModal: noop,
  dismissModal: noop
};

const NLBAdvancedSettings = React__default.forwardRef((props, ref) => /* @__PURE__ */ React__default.createElement("div", {
  ref
}, /* @__PURE__ */ React__default.createElement(FormikFormField, {
  name: "deletionProtection",
  label: "Protection",
  help: /* @__PURE__ */ React__default.createElement(HelpField, {
    id: "loadBalancer.advancedSettings.deletionProtection"
  }),
  input: (inputProps) => /* @__PURE__ */ React__default.createElement(CheckboxInput, {
    ...inputProps,
    text: "Enable deletion protection"
  })
}), /* @__PURE__ */ React__default.createElement(FormikFormField, {
  name: "loadBalancingCrossZone",
  label: "Cross-Zone Load Balancing",
  help: /* @__PURE__ */ React__default.createElement(HelpField, {
    id: "loadBalancer.advancedSettings.loadBalancingCrossZone"
  }),
  input: (inputProps) => /* @__PURE__ */ React__default.createElement(CheckboxInput, {
    ...inputProps,
    text: "Distribute traffic across zones"
  })
}), props.showDualstack && /* @__PURE__ */ React__default.createElement(FormikFormField, {
  name: "dualstack",
  label: "Dualstack",
  help: /* @__PURE__ */ React__default.createElement(HelpField, {
    id: "loadBalancer.advancedSettings.nlbIpAddressType"
  }),
  input: (inputProps) => /* @__PURE__ */ React__default.createElement(CheckboxInput, {
    ...inputProps,
    text: "Assign Ipv4 and IPv6"
  })
})));

function CertificateSelector({
  availableCertificates,
  certificates,
  formik,
  app,
  certificateTypes
}) {
  function certificateTypeChanged(certificate, newType) {
    certificate.type = newType;
    updateListeners();
  }
  function updateListeners() {
    formik.setFieldValue("listeners", formik.values.listeners);
  }
  function handleCertificateChanged(certificate, newCertificateName) {
    certificate.name = newCertificateName;
    updateListeners();
  }
  function showCertificateSelect(certificate) {
    return certificate.type === "iam" && certificates && Object.keys(certificates).length > 0;
  }
  const { values } = formik;
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "wizard-pod-row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "wizard-pod-row-title"
  }, "Certificate"), /* @__PURE__ */ React__default.createElement("div", {
    className: "wizard-pod-row-contents"
  }, availableCertificates.map((certificate, cIndex) => /* @__PURE__ */ React__default.createElement("div", {
    key: cIndex,
    style: { width: "100%", display: "flex", flexDirection: "row" }
  }, /* @__PURE__ */ React__default.createElement("select", {
    className: "form-control input-sm inline-number",
    style: { width: "45px" },
    value: certificate.type,
    onChange: (event) => certificateTypeChanged(certificate, event.target.value)
  }, certificateTypes.map((t) => /* @__PURE__ */ React__default.createElement("option", {
    key: t
  }, t))), showCertificateSelect(certificate) && /* @__PURE__ */ React__default.createElement(AmazonCertificateSelectField, {
    certificates,
    accountName: values.credentials,
    currentValue: certificate.name,
    app,
    onCertificateSelect: (value) => handleCertificateChanged(certificate, value)
  }), !showCertificateSelect(certificate) && /* @__PURE__ */ React__default.createElement("input", {
    className: "form-control input-sm no-spel",
    style: { display: "inline-block" },
    type: "text",
    value: certificate.name,
    onChange: (event) => handleCertificateChanged(certificate, event.target.value),
    required: true
  })))));
}

class NLBListeners extends React__default.Component {
  constructor(props) {
    super(props);
    this.protocols = ["TCP", "UDP", "TLS"];
    this.removedAuthActions = new Map();
    this.addListener = () => {
      this.props.formik.values.listeners.push({
        certificates: [],
        protocol: "TCP",
        port: 80,
        defaultActions: [
          {
            type: "forward",
            targetGroupName: ""
          }
        ],
        rules: []
      });
      this.updateListeners();
    };
    this.handleDefaultTargetChanged = (listener, newTarget) => {
      listener.defaultActions[0].targetGroupName = newTarget;
      this.updateListeners();
    };
    this.state = {
      certificates: [],
      certificateTypes: get(AWSProviderSettings, "loadBalancers.certificateTypes", ["iam", "acm"]),
      oidcConfigs: void 0
    };
  }
  getAllTargetGroupsFromListeners(listeners) {
    const actions = flatten(listeners.map((l) => l.defaultActions));
    const rules = flatten(listeners.map((l) => l.rules));
    actions.push(...flatten(rules.map((r) => r.actions)));
    return uniq(actions.map((a) => a.targetGroupName));
  }
  validate(values) {
    const errors = {};
    const targetGroupNames = values.targetGroups.map((tg) => tg.name);
    const usedTargetGroupNames = this.getAllTargetGroupsFromListeners(values.listeners);
    const unusedTargetGroupNames = difference(targetGroupNames, usedTargetGroupNames);
    if (unusedTargetGroupNames.length === 1) {
      errors.listeners = `Target group ${unusedTargetGroupNames[0]} is unused.`;
    } else if (unusedTargetGroupNames.length > 1) {
      errors.listeners = `Target groups ${unusedTargetGroupNames.join(", ")} are unused.`;
    }
    const { listeners } = values;
    if (uniqBy(listeners, "port").length < listeners.length) {
      errors.listenerPorts = "Multiple listeners cannot use the same port.";
    }
    return errors;
  }
  updateListeners() {
    this.props.formik.setFieldValue("listeners", this.props.formik.values.listeners);
  }
  componentDidMount() {
    this.loadCertificates();
  }
  addListenerCertificate(listener) {
    listener.certificates = listener.certificates || [];
    listener.certificates.push({
      certificateArn: void 0,
      type: "iam",
      name: void 0
    });
  }
  loadCertificates() {
    AmazonCertificateReader.listCertificates().then((certificates) => {
      this.setState({ certificates });
    });
  }
  listenerProtocolChanged(listener, newProtocol) {
    listener.protocol = newProtocol;
    if (listener.protocol === "TCP") {
      listener.port = 80;
    } else if (listener.protocol === "UDP") {
      listener.port = 53;
    } else if (listener.protocol === "TLS") {
      listener.port = 443;
      if (!listener.certificates || listener.certificates.length === 0) {
        this.addListenerCertificate(listener);
      }
      this.reenableAuthActions(listener);
    }
    this.updateListeners();
  }
  reenableAuthActions(listener) {
    const removedAuthActions = this.removedAuthActions.has(listener) ? this.removedAuthActions.get(listener) : [];
    const existingDefaultAuthAction = removedAuthActions[-1];
    if (existingDefaultAuthAction) {
      removedAuthActions[-1] = void 0;
      listener.defaultActions.unshift({ ...existingDefaultAuthAction });
    }
    listener.rules.forEach((rule, ruleIndex) => {
      const existingAuthAction = removedAuthActions[ruleIndex];
      removedAuthActions[ruleIndex] = void 0;
      if (existingAuthAction) {
        rule.actions.unshift({ ...existingAuthAction });
      }
    });
  }
  listenerPortChanged(listener, newPort) {
    listener.port = Number.parseInt(newPort, 10);
    this.updateListeners();
  }
  removeListener(index) {
    this.props.formik.values.listeners.splice(index, 1);
    this.updateListeners();
  }
  render() {
    const { errors, values } = this.props.formik;
    const { certificates, certificateTypes } = this.state;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "container-fluid form-horizontal"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12"
    }, values.listeners.map((listener, index) => /* @__PURE__ */ React__default.createElement("div", {
      key: index,
      className: "wizard-pod"
    }, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", {
      className: "wizard-pod-row header"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "wizard-pod-row-title"
    }, "Listen On"), /* @__PURE__ */ React__default.createElement("div", {
      className: "wizard-pod-row-contents spread"
    }, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("span", {
      className: "wizard-pod-content"
    }, /* @__PURE__ */ React__default.createElement("label", null, "Protocol"), /* @__PURE__ */ React__default.createElement("select", {
      className: "form-control input-sm inline-number",
      style: { width: "80px" },
      value: listener.protocol,
      onChange: (event) => this.listenerProtocolChanged(listener, event.target.value)
    }, this.protocols.map((p) => /* @__PURE__ */ React__default.createElement("option", {
      key: p
    }, p)))), /* @__PURE__ */ React__default.createElement("span", {
      className: "wizard-pod-content"
    }, /* @__PURE__ */ React__default.createElement("label", null, "Port"), /* @__PURE__ */ React__default.createElement("input", {
      className: "form-control input-sm inline-number",
      type: "text",
      min: 0,
      value: listener.port || "",
      onChange: (event) => this.listenerPortChanged(listener, event.target.value),
      style: { width: "80px" },
      required: true
    }))), /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("a", {
      className: "sm-label clickable",
      onClick: () => this.removeListener(index)
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-trash"
    }))))), /* @__PURE__ */ React__default.createElement("div", null, listener.protocol === "TLS" && /* @__PURE__ */ React__default.createElement(CertificateSelector, {
      availableCertificates: listener.certificates,
      formik: this.props.formik,
      app: this.props.app,
      certificateTypes,
      certificates
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "wizard-pod-row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "wizard-pod-row-title",
      style: { height: "30px" }
    }, "Rules"), /* @__PURE__ */ React__default.createElement("div", {
      className: "wizard-pod-row-contents",
      style: { padding: "0" }
    }, /* @__PURE__ */ React__default.createElement("table", {
      className: "table table-condensed packed rules-table"
    }, /* @__PURE__ */ React__default.createElement("thead", null, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("th", {
      style: { width: "10px", padding: "0" }
    }), /* @__PURE__ */ React__default.createElement("th", {
      style: { width: "226px" }
    }, "If"), /* @__PURE__ */ React__default.createElement("th", {
      style: { width: "75px" }
    }, "Then"), /* @__PURE__ */ React__default.createElement("th", null, "Target"), /* @__PURE__ */ React__default.createElement("th", {
      style: { width: "30px" }
    }))), /* @__PURE__ */ React__default.createElement("tbody", null, /* @__PURE__ */ React__default.createElement("tr", {
      className: "not-sortable"
    }, /* @__PURE__ */ React__default.createElement("td", null), /* @__PURE__ */ React__default.createElement("td", null, "Default"), /* @__PURE__ */ React__default.createElement("td", null, "forward to"), /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement("select", {
      className: "form-control input-sm",
      value: listener.defaultActions[0].targetGroupName,
      onChange: (event) => this.handleDefaultTargetChanged(listener, event.target.value),
      required: true
    }, /* @__PURE__ */ React__default.createElement("option", {
      value: ""
    }), uniq(values.targetGroups.map((tg) => tg.name)).map((name) => /* @__PURE__ */ React__default.createElement("option", {
      key: name
    }, name)))), /* @__PURE__ */ React__default.createElement("td", null))))))))), errors.listenerPorts && /* @__PURE__ */ React__default.createElement("div", {
      className: "wizard-pod-row-errors"
    }, /* @__PURE__ */ React__default.createElement(ValidationMessage, {
      type: "error",
      message: errors.listenerPorts
    })), errors.listeners && /* @__PURE__ */ React__default.createElement("div", {
      className: "wizard-pod-row-errors"
    }, /* @__PURE__ */ React__default.createElement(ValidationMessage, {
      type: "error",
      message: errors.listeners
    })), /* @__PURE__ */ React__default.createElement("table", {
      className: "table table-condensed packed"
    }, /* @__PURE__ */ React__default.createElement("tbody", null, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement("button", {
      type: "button",
      className: "add-new col-md-12",
      onClick: this.addListener
    }, /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-plus-sign"
    }), " Add new listener")))))))));
  }
}

class TargetGroups extends React__default.Component {
  constructor(props) {
    super(props);
    this.protocols = ["TCP", "UDP"];
    this.healthProtocols = ["TCP", "HTTP", "HTTPS"];
    this.targetTypes = ["instance", "ip"];
    this.destroy$ = new Subject();
    this.addTargetGroup = () => {
      const { setFieldValue, values } = this.props.formik;
      const tgLength = values.targetGroups.length;
      values.targetGroups.push({
        name: `targetgroup${tgLength ? `${tgLength}` : ""}`,
        protocol: "TCP",
        port: 7001,
        targetType: "instance",
        healthCheckProtocol: "TCP",
        healthCheckPort: "traffic-port",
        healthCheckPath: "/healthcheck",
        healthCheckTimeout: 5,
        healthCheckInterval: 10,
        healthyThreshold: 10,
        unhealthyThreshold: 10,
        attributes: {
          deregistrationDelay: 300,
          preserveClientIp: true
        }
      });
      setFieldValue("targetGroups", values.targetGroups);
    };
    const oldTargetGroupCount = !props.isNew ? props.formik.initialValues.targetGroups.length : 0;
    this.state = {
      existingTargetGroupNames: {},
      oldTargetGroupCount
    };
  }
  validate(values) {
    const duplicateTargetGroups = uniq(flatten(filter(groupBy(values.targetGroups, "name"), (count) => count.length > 1)).map((tg) => tg.name));
    const formValidator = new FormValidator(values);
    const { arrayForEach } = formValidator;
    formValidator.field("targetGroups").withValidators(arrayForEach((builder) => {
      builder.field("name", "Name").required().withValidators(isNameInUse(this.state.existingTargetGroupNames, values.credentials, values.region), isNameLong(this.props.app.name.length), Validators.valueUnique(duplicateTargetGroups, "There is already a target group in this load balancer with the same name."));
      builder.field("port", "Port").required().spelAware().withValidators((value) => spelNumberCheck(value));
      builder.field("healthCheckInterval", "Health Check Interval").required().spelAware().withValidators((value) => spelNumberCheck(value));
      builder.field("healthyThreshold", "Healthy Threshold").required().spelAware().withValidators((value) => spelNumberCheck(value));
      builder.field("unhealthyThreshold", "Unhealthy Threshold").required().spelAware().withValidators((value) => spelNumberCheck(value));
      builder.field("healthCheckPort", "Health Check Port").required().spelAware().withValidators((value) => value === "traffic-port" ? null : spelNumberCheck(value));
      builder.field("protocol", "Protocol").required();
      builder.field("healthCheckProtocol", "Health Check Protocol").required();
    }));
    return formValidator.validateForm();
  }
  removeAppName(name) {
    return name.replace(`${this.props.app.name}-`, "");
  }
  updateLoadBalancerNames(props) {
    const { app, loadBalancer } = props;
    const targetGroupsByAccountAndRegion = {};
    from(app.getDataSource("loadBalancers").refresh(true)).pipe(takeUntil(this.destroy$)).subscribe(() => {
      app.getDataSource("loadBalancers").data.forEach((lb) => {
        if (lb.loadBalancerType !== "classic") {
          if (!loadBalancer || lb.name !== loadBalancer.name) {
            lb.targetGroups.forEach((targetGroup) => {
              targetGroupsByAccountAndRegion[lb.account] = targetGroupsByAccountAndRegion[lb.account] || {};
              targetGroupsByAccountAndRegion[lb.account][lb.region] = targetGroupsByAccountAndRegion[lb.account][lb.region] || [];
              targetGroupsByAccountAndRegion[lb.account][lb.region].push(this.removeAppName(targetGroup.name));
            });
          }
        }
      });
      this.setState({ existingTargetGroupNames: targetGroupsByAccountAndRegion }, () => this.props.formik.validateForm());
    });
  }
  targetGroupFieldChanged(index, field, value) {
    const { setFieldValue, values } = this.props.formik;
    const targetGroup = values.targetGroups[index];
    set(targetGroup, field, value);
    if (field === "healthyThreshold") {
      set(targetGroup, "unhealthyThreshold", value);
    }
    setFieldValue("targetGroups", values.targetGroups);
  }
  removeTargetGroup(index) {
    const { setFieldValue, values } = this.props.formik;
    const { oldTargetGroupCount } = this.state;
    values.targetGroups.splice(index, 1);
    if (index < oldTargetGroupCount) {
      this.setState({ oldTargetGroupCount: oldTargetGroupCount - 1 });
    }
    setFieldValue("targetGroups", values.targetGroups);
  }
  componentDidMount() {
    this.updateLoadBalancerNames(this.props);
  }
  componentWillUnmount() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  render() {
    const { app } = this.props;
    const { errors, values } = this.props.formik;
    const { oldTargetGroupCount } = this.state;
    const ProtocolOptions = this.protocols.map((p) => /* @__PURE__ */ React__default.createElement("option", {
      key: p
    }, p));
    const HealthProtocolOptions = this.healthProtocols.map((p) => /* @__PURE__ */ React__default.createElement("option", {
      key: p
    }, p));
    const TargetTypeOptions = this.targetTypes.map((p) => /* @__PURE__ */ React__default.createElement("option", {
      key: p
    }, p));
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "container-fluid form-horizontal"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12"
    }, values.targetGroups.map((targetGroup, index) => {
      const tgErrors = errors.targetGroups && errors.targetGroups[index] || {};
      return /* @__PURE__ */ React__default.createElement("div", {
        key: index,
        className: "wizard-pod"
      }, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row header"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-title"
      }, "Group Name"), /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-contents"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-data"
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "group-name-prefix"
      }, app.name, "-"), /* @__PURE__ */ React__default.createElement("input", {
        className: "form-control input-sm target-group-name",
        type: "text",
        value: targetGroup.name,
        onChange: (event) => this.targetGroupFieldChanged(index, "name", event.target.value),
        required: true,
        disabled: index < oldTargetGroupCount
      }), /* @__PURE__ */ React__default.createElement("a", {
        className: "sm-label clickable",
        onClick: () => this.removeTargetGroup(index)
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "glyphicon glyphicon-trash"
      }))), tgErrors.name && /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-errors"
      }, /* @__PURE__ */ React__default.createElement(ValidationMessage, {
        type: "error",
        message: tgErrors.name
      })))), /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-title"
      }, /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "aws.targetGroup.targetType"
      }), " ", /* @__PURE__ */ React__default.createElement("span", null, "Target Type\xA0")), /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-contents"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-data"
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "wizard-pod-content"
      }, /* @__PURE__ */ React__default.createElement("select", {
        className: "form-control input-sm",
        value: targetGroup.targetType,
        onChange: (event) => this.targetGroupFieldChanged(index, "targetType", event.target.value),
        disabled: index < oldTargetGroupCount
      }, TargetTypeOptions))))), /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-title"
      }, "Backend Connection"), /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-contents"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-data"
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "wizard-pod-content"
      }, /* @__PURE__ */ React__default.createElement("label", null, "Protocol "), /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "aws.targetGroup.protocol"
      }), " ", /* @__PURE__ */ React__default.createElement("select", {
        className: "form-control input-sm inline-number",
        value: targetGroup.protocol,
        onChange: (event) => this.targetGroupFieldChanged(index, "protocol", event.target.value),
        disabled: index < oldTargetGroupCount
      }, ProtocolOptions)), /* @__PURE__ */ React__default.createElement("span", {
        className: "wizard-pod-content"
      }, /* @__PURE__ */ React__default.createElement("label", null, "Port "), /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "aws.targetGroup.port"
      }), " ", /* @__PURE__ */ React__default.createElement("input", {
        className: "form-control input-sm inline-number",
        value: targetGroup.port,
        onChange: (event) => this.targetGroupFieldChanged(index, "port", event.target.value),
        type: "text",
        required: true,
        disabled: index < oldTargetGroupCount
      }))))), /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-title"
      }, "Healthcheck"), /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-contents"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-data"
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "wizard-pod-content"
      }, /* @__PURE__ */ React__default.createElement("label", null, "Protocol "), /* @__PURE__ */ React__default.createElement("select", {
        disabled: index < oldTargetGroupCount,
        className: "form-control input-sm inline-number",
        value: targetGroup.healthCheckProtocol,
        onChange: (event) => this.targetGroupFieldChanged(index, "healthCheckProtocol", event.target.value)
      }, HealthProtocolOptions)), /* @__PURE__ */ React__default.createElement("span", {
        className: "wizard-pod-content"
      }, /* @__PURE__ */ React__default.createElement("label", null, "Port "), /* @__PURE__ */ React__default.createElement(SpInput, {
        className: "form-control input-sm inline-number",
        error: tgErrors.healthCheckPort,
        name: "healthCheckPort",
        required: true,
        value: targetGroup.healthCheckPort,
        onChange: (event) => this.targetGroupFieldChanged(index, "healthCheckPort", event.target.value)
      })), targetGroup.healthCheckProtocol !== "TCP" && /* @__PURE__ */ React__default.createElement("span", {
        className: "wizard-pod-content"
      }, /* @__PURE__ */ React__default.createElement("label", null, "Path "), /* @__PURE__ */ React__default.createElement(SpInput, {
        className: "form-control input-sm inline-text",
        error: tgErrors.healthCheckPath,
        name: "healthCheckPath",
        required: true,
        value: targetGroup.healthCheckPath,
        onChange: (event) => this.targetGroupFieldChanged(index, "healthCheckPath", event.target.value)
      })), /* @__PURE__ */ React__default.createElement("span", {
        className: "wizard-pod-content"
      }, /* @__PURE__ */ React__default.createElement("label", null, "Timeout "), /* @__PURE__ */ React__default.createElement(SpelNumberInput, {
        error: tgErrors.healthCheckTimeout,
        required: true,
        value: targetGroup.healthCheckTimeout,
        onChange: (value) => this.targetGroupFieldChanged(index, "healthCheckTimeout", value)
      })), /* @__PURE__ */ React__default.createElement("span", {
        className: "wizard-pod-content"
      }, /* @__PURE__ */ React__default.createElement("label", null, "Interval "), /* @__PURE__ */ React__default.createElement(SpelNumberInput, {
        error: tgErrors.healthCheckInterval,
        required: true,
        value: targetGroup.healthCheckInterval,
        onChange: (value) => this.targetGroupFieldChanged(index, "healthCheckInterval", value)
      }))))), /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-title"
      }, /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "aws.targetGroup.nlbHealthcheckThreshold"
      }), " ", /* @__PURE__ */ React__default.createElement("span", null, "Healthcheck Threshold\xA0")), /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-contents"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-data"
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "wizard-pod-content"
      }, /* @__PURE__ */ React__default.createElement(SpelNumberInput, {
        error: tgErrors.healthyThreshold,
        value: targetGroup.healthyThreshold,
        onChange: (value) => this.targetGroupFieldChanged(index, "healthyThreshold", value)
      }))))), /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-title"
      }, "Attributes"), /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-contents"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "wizard-pod-row-data"
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "wizard-pod-content"
      }, /* @__PURE__ */ React__default.createElement("label", null, "Dereg. Delay"), /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "aws.targetGroup.attributes.deregistrationDelay"
      }), " ", /* @__PURE__ */ React__default.createElement("input", {
        className: "form-control input-sm inline-number",
        type: "text",
        value: targetGroup.attributes.deregistrationDelay,
        onChange: (event) => this.targetGroupFieldChanged(index, "attributes.deregistrationDelay", event.target.value)
      })), /* @__PURE__ */ React__default.createElement("span", {
        className: "wizard-pod-content"
      }, /* @__PURE__ */ React__default.createElement(CheckboxInput, {
        name: "deregistrationDelayConnectionTermination",
        text: "Connection Termination",
        checked: targetGroup.attributes.deregistrationDelayConnectionTermination,
        onChange: (event) => {
          this.targetGroupFieldChanged(index, "attributes.deregistrationDelayConnectionTermination", event.target.checked);
        }
      }), /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "aws.targetGroup.attributes.deregistrationDelayConnectionTermination"
      })), targetGroup.targetType !== "instance" && /* @__PURE__ */ React__default.createElement("span", {
        className: "wizard-pod-content"
      }, /* @__PURE__ */ React__default.createElement(CheckboxInput, {
        name: "preserveClientIp",
        text: "Preserve Client IP",
        checked: targetGroup.attributes.preserveClientIp,
        onChange: (event) => {
          this.targetGroupFieldChanged(index, "attributes.preserveClientIp", event.target.checked);
        }
      }), /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "aws.targetGroup.attributes.preserveClientIp"
      })))))));
    }), /* @__PURE__ */ React__default.createElement("table", {
      className: "table table-condensed packed"
    }, /* @__PURE__ */ React__default.createElement("tbody", null, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement("button", {
      type: "button",
      className: "add-new col-md-12",
      onClick: this.addTargetGroup
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-plus-sign"
    }), " Add new target group"))))))));
  }
}

const _CreateNetworkLoadBalancer = class extends React__default.Component {
  constructor(props) {
    super(props);
    this._isUnmounted = false;
    this.certificateTypes = get(AWSProviderSettings, "loadBalancers.certificateTypes", ["iam", "acm"]);
    this.submit = (values) => {
      const { app, forPipelineConfig, closeModal } = this.props;
      const { isNew } = this.state;
      const descriptor = isNew ? "Create" : "Update";
      const loadBalancerCommandFormatted = cloneDeep(values);
      loadBalancerCommandFormatted.ipAddressType = loadBalancerCommandFormatted.dualstack ? "dualstack" : "ipv4";
      delete loadBalancerCommandFormatted.dualstack;
      if (forPipelineConfig) {
        this.formatListeners(loadBalancerCommandFormatted).then(() => {
          closeModal && closeModal(loadBalancerCommandFormatted);
        });
      } else {
        const taskMonitor = new TaskMonitor({
          application: app,
          title: `${isNew ? "Creating" : "Updating"} your load balancer`,
          modalInstance: TaskMonitor.modalInstanceEmulation(() => this.props.dismissModal()),
          onTaskComplete: () => this.onTaskComplete(loadBalancerCommandFormatted)
        });
        taskMonitor.submit(() => {
          return this.formatListeners(loadBalancerCommandFormatted).then(() => {
            this.formatCommand(loadBalancerCommandFormatted);
            return LoadBalancerWriter.upsertLoadBalancer(loadBalancerCommandFormatted, app, descriptor);
          });
        });
        this.setState({ taskMonitor });
      }
    };
    this.validate = () => {
      const errors = {};
      return errors;
    };
    const loadBalancerCommand = props.loadBalancer ? AwsLoadBalancerTransformer.convertNetworkLoadBalancerForEditing(props.loadBalancer) : AwsLoadBalancerTransformer.constructNewNetworkLoadBalancerTemplate(props.app);
    this.state = {
      isNew: !props.loadBalancer,
      loadBalancerCommand,
      taskMonitor: null
    };
  }
  static show(props) {
    const modalProps = { dialogClassName: "wizard-modal modal-lg" };
    return ReactModal.show(_CreateNetworkLoadBalancer, props, modalProps);
  }
  certificateIdAsARN(accountId, certificateId, region, certificateType) {
    if (certificateId && (certificateId.indexOf("arn:aws:iam::") !== 0 || certificateId.indexOf("arn:aws:acm:") !== 0)) {
      if (certificateType === "iam") {
        return `arn:aws:iam::${accountId}:server-certificate/${certificateId}`;
      }
      if (certificateType === "acm") {
        return `arn:aws:acm:${region}:${accountId}:certificate/${certificateId}`;
      }
    }
    return certificateId;
  }
  formatListeners(command) {
    return AccountService.getAccountDetails(command.credentials).then((account) => {
      command.listeners.forEach((listener) => {
        if (listener.protocol === "TCP") {
          delete listener.sslPolicy;
          listener.certificates = [];
        }
        listener.certificates.forEach((certificate) => {
          certificate.certificateArn = this.certificateIdAsARN(account.accountId, certificate.name, command.region, certificate.type || this.certificateTypes[0]);
        });
      });
    });
  }
  setAvailabilityZones(loadBalancerCommand) {
    const availabilityZones = {};
    availabilityZones[loadBalancerCommand.region] = loadBalancerCommand.regionZones || [];
    loadBalancerCommand.availabilityZones = availabilityZones;
  }
  addAppName(name) {
    return `${this.props.app.name}-${name}`;
  }
  manageTargetGroupNames(command) {
    (command.targetGroups || []).forEach((targetGroupDescription) => {
      targetGroupDescription.name = this.addAppName(targetGroupDescription.name);
    });
    (command.listeners || []).forEach((listenerDescription) => {
      listenerDescription.defaultActions.forEach((actionDescription) => {
        if (actionDescription.targetGroupName) {
          actionDescription.targetGroupName = this.addAppName(actionDescription.targetGroupName);
        }
      });
      (listenerDescription.rules || []).forEach((ruleDescription) => {
        ruleDescription.actions.forEach((actionDescription) => {
          if (actionDescription.targetGroupName) {
            actionDescription.targetGroupName = this.addAppName(actionDescription.targetGroupName);
          }
        });
      });
    });
  }
  manageRules(command) {
    command.listeners.forEach((listener) => {
      listener.rules.forEach((rule, index) => {
        rule.priority = index + 1;
        rule.conditions = rule.conditions.filter((condition) => condition.values[0].length > 0);
      });
    });
  }
  formatCommand(command) {
    this.setAvailabilityZones(command);
    this.manageTargetGroupNames(command);
    this.manageRules(command);
  }
  onApplicationRefresh(values) {
    if (this._isUnmounted) {
      return;
    }
    this.refreshUnsubscribe = void 0;
    this.props.dismissModal();
    this.setState({ taskMonitor: void 0 });
    const newStateParams = {
      name: values.name,
      accountId: values.credentials,
      region: values.region,
      vpcId: values.vpcId,
      provider: "aws"
    };
    if (!ReactInjector.$state.includes("**.loadBalancerDetails")) {
      ReactInjector.$state.go(".loadBalancerDetails", newStateParams);
    } else {
      ReactInjector.$state.go("^.loadBalancerDetails", newStateParams);
    }
  }
  componentWillUnmount() {
    this._isUnmounted = true;
    if (this.refreshUnsubscribe) {
      this.refreshUnsubscribe();
    }
  }
  onTaskComplete(values) {
    this.props.app.loadBalancers.refresh();
    this.refreshUnsubscribe = this.props.app.loadBalancers.onNextRefresh(null, () => this.onApplicationRefresh(values));
  }
  render() {
    const { app, dismissModal, forPipelineConfig, loadBalancer } = this.props;
    const { isNew, loadBalancerCommand, taskMonitor } = this.state;
    let heading = forPipelineConfig ? "Configure Network Load Balancer" : "Create New Network Load Balancer";
    if (!isNew) {
      heading = `Edit ${loadBalancerCommand.name}: ${loadBalancerCommand.region}: ${loadBalancerCommand.credentials}`;
    }
    const showLocationSection = isNew || forPipelineConfig;
    return /* @__PURE__ */ React__default.createElement(WizardModal, {
      heading,
      initialValues: loadBalancerCommand,
      taskMonitor,
      dismissModal,
      closeModal: this.submit,
      submitButtonLabel: forPipelineConfig ? isNew ? "Add" : "Done" : isNew ? "Create" : "Update",
      validate: this.validate,
      render: ({ formik, nextIdx, wizard }) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, showLocationSection && /* @__PURE__ */ React__default.createElement(WizardPage, {
        label: "Location",
        wizard,
        order: nextIdx(),
        render: ({ innerRef }) => /* @__PURE__ */ React__default.createElement(LoadBalancerLocation, {
          app,
          forPipelineConfig,
          formik,
          isNew,
          loadBalancer,
          ref: innerRef
        })
      }), /* @__PURE__ */ React__default.createElement(WizardPage, {
        label: "Target Groups",
        wizard,
        order: nextIdx(),
        render: ({ innerRef }) => /* @__PURE__ */ React__default.createElement(TargetGroups, {
          ref: innerRef,
          formik,
          app,
          isNew,
          loadBalancer
        })
      }), /* @__PURE__ */ React__default.createElement(WizardPage, {
        label: "Listeners",
        wizard,
        order: nextIdx(),
        render: ({ innerRef }) => /* @__PURE__ */ React__default.createElement(NLBListeners, {
          ref: innerRef,
          formik
        })
      }), /* @__PURE__ */ React__default.createElement(WizardPage, {
        label: "Advanced Settings",
        wizard,
        order: nextIdx(),
        render: ({ innerRef }) => /* @__PURE__ */ React__default.createElement(NLBAdvancedSettings, {
          ref: innerRef,
          showDualstack: !formik.values.isInternal && every(formik.values.targetGroups, { targetType: "instance" })
        })
      }))
    });
  }
};
let CreateNetworkLoadBalancer = _CreateNetworkLoadBalancer;
CreateNetworkLoadBalancer.defaultProps = {
  closeModal: noop,
  dismissModal: noop
};

const LoadBalancerTypes = [
  {
    type: "application",
    label: "Application",
    sublabel: "ALB",
    description: "Highly configurable, application-focused balancer. HTTP and HTTPS only.",
    component: CreateApplicationLoadBalancer
  },
  {
    type: "network",
    label: "Network",
    sublabel: "NLB",
    description: "Basic, high-performance balancer with fixed IP.",
    component: CreateNetworkLoadBalancer
  },
  {
    type: "classic",
    label: "Classic",
    sublabel: "Legacy",
    description: "Previous generation balancer (ELB).",
    component: CreateClassicLoadBalancer
  }
];

const _AmazonLoadBalancerChoiceModal = class extends React__default.Component {
  constructor(props) {
    super(props);
    this.choose = () => {
      const { children, ...loadBalancerProps } = this.props;
      this.close();
      this.state.selectedChoice.component.show(loadBalancerProps).then((loadBalancer) => {
        this.props.closeModal(loadBalancer);
      }).catch(() => {
      });
    };
    this.close = (reason) => {
      this.props.dismissModal(reason);
    };
    this.state = {
      choices: LoadBalancerTypes,
      selectedChoice: LoadBalancerTypes[0]
    };
  }
  static show(props) {
    return ReactModal.show(_AmazonLoadBalancerChoiceModal, {
      ...props,
      className: "create-pipeline-modal-overflow-visible modal-lg"
    }, { bsSize: "lg" });
  }
  choiceSelected(choice) {
    this.setState({ selectedChoice: choice });
  }
  getIncompatibility(choice, cloudProvider) {
    const { loadBalancer = {} } = CloudProviderRegistry.getProvider(cloudProvider);
    const {
      incompatibleLoadBalancerTypes = []
    } = loadBalancer;
    return incompatibleLoadBalancerTypes.find((lb) => lb.type === choice.type);
  }
  isIncompatibleWithAllProviders(choice) {
    const {
      app: { attributes }
    } = this.props;
    const { cloudProviders = [] } = attributes;
    if (cloudProviders.length > 0) {
      return cloudProviders.every((cloudProvider) => !!this.getIncompatibility(choice, cloudProvider));
    }
    return false;
  }
  render() {
    const {
      app: { attributes }
    } = this.props;
    const { cloudProviders = [] } = attributes;
    const { choices, selectedChoice } = this.state;
    const filteredChoices = choices.filter((choice) => !this.isIncompatibleWithAllProviders(choice));
    const incompatibilities = cloudProviders.map((cloudProvider) => this.getIncompatibility(selectedChoice, cloudProvider)).filter((x) => x);
    const loadBalancerWarning = AWSProviderSettings.createLoadBalancerWarnings && AWSProviderSettings.createLoadBalancerWarnings[selectedChoice.type];
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(ModalClose, {
      dismiss: this.close
    }), /* @__PURE__ */ React__default.createElement(Modal.Header, null, /* @__PURE__ */ React__default.createElement(Modal.Title, null, "Select Type of Load Balancer")), /* @__PURE__ */ React__default.createElement(Modal.Body, null, /* @__PURE__ */ React__default.createElement("div", {
      className: "modal-body"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "card-choices"
    }, filteredChoices.map((choice) => /* @__PURE__ */ React__default.createElement("div", {
      key: choice.type,
      className: `card ${selectedChoice === choice ? "active" : ""}`,
      onClick: () => this.choiceSelected(choice)
    }, /* @__PURE__ */ React__default.createElement("h3", {
      className: "load-balancer-label"
    }, choice.label), /* @__PURE__ */ React__default.createElement("h3", null, "(", choice.sublabel, ")"), /* @__PURE__ */ React__default.createElement("div", null, choice.description)))), /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, incompatibilities.length > 0 && incompatibilities.map((incompatibility) => /* @__PURE__ */ React__default.createElement("div", {
      className: "alert alert-warning"
    }, /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("i", {
      className: "fa fa-exclamation-triangle"
    }), " ", incompatibility.reason)))), !!loadBalancerWarning && /* @__PURE__ */ React__default.createElement("div", {
      className: "alert alert-warning"
    }, /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("i", {
      className: "fa fa-exclamation-triangle"
    }), /* @__PURE__ */ React__default.createElement(Markdown, {
      message: loadBalancerWarning,
      style: { display: "inline-block", marginLeft: "2px" }
    }))), /* @__PURE__ */ React__default.createElement("div", {
      className: "load-balancer-description"
    }))), /* @__PURE__ */ React__default.createElement(Modal.Footer, null, /* @__PURE__ */ React__default.createElement(Button, {
      onClick: this.choose
    }, "Configure Load Balancer ", /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-chevron-right"
    }))));
  }
};
let AmazonLoadBalancerChoiceModal = _AmazonLoadBalancerChoiceModal;
AmazonLoadBalancerChoiceModal.defaultProps = {
  closeModal: noop,
  dismissModal: noop
};

class LoadBalancerActions extends React__default.Component {
  constructor(props) {
    super(props);
    this.editLoadBalancer = () => {
      const { loadBalancer } = this.props;
      const { application } = this.state;
      const LoadBalancerModal = LoadBalancerTypes.find((t) => t.type === loadBalancer.loadBalancerType).component;
      LoadBalancerModal.show({ app: application, loadBalancer });
    };
    this.deleteLoadBalancer = () => {
      const { app, loadBalancer, loadBalancerFromParams } = this.props;
      if (loadBalancer.instances && loadBalancer.instances.length) {
        return;
      }
      const taskMonitor = {
        application: app,
        title: "Deleting " + loadBalancerFromParams.name
      };
      const command = {
        cloudProvider: loadBalancer.cloudProvider,
        loadBalancerName: loadBalancer.name,
        loadBalancerType: loadBalancer.loadBalancerType || "classic",
        regions: [loadBalancer.region],
        credentials: loadBalancer.account,
        vpcId: get(loadBalancer, "elb.vpcId", null)
      };
      const submitMethod = () => LoadBalancerWriter.deleteLoadBalancer(command, app);
      ConfirmationModalService.confirm({
        header: `Really delete ${loadBalancerFromParams.name} in ${loadBalancerFromParams.region}: ${loadBalancerFromParams.accountId}?`,
        buttonText: `Delete ${loadBalancerFromParams.name}`,
        account: loadBalancerFromParams.accountId,
        taskMonitorConfig: taskMonitor,
        submitMethod
      });
    };
    this.entityTagUpdate = () => {
      this.props.app.loadBalancers.refresh();
    };
    const { app, loadBalancer } = this.props;
    let application;
    const loadBalancerAppName = loadBalancer.name.split("-")[0];
    if (loadBalancerAppName === app.name) {
      application = app;
    } else {
      ApplicationReader.getApplication(loadBalancerAppName).then((loadBalancerApp) => {
        this.setState({ application: loadBalancerApp });
      }).catch(() => {
      });
    }
    this.state = {
      application
    };
  }
  render() {
    const { app, loadBalancer } = this.props;
    const { application } = this.state;
    const { loadBalancerType, instances, instanceCounts } = loadBalancer;
    const loadBalancerAppName = loadBalancer.name.split("-")[0];
    const clbInstances = loadBalancerType === "classic" && values(instanceCounts).filter((v) => v).length;
    const allowDeletion = !clbInstances && !instances.length;
    return /* @__PURE__ */ React__default.createElement("div", {
      style: { display: "inline-block" }
    }, AWSProviderSettings.adHocInfraWritesEnabled && /* @__PURE__ */ React__default.createElement(Dropdown, {
      className: "dropdown",
      id: "load-balancer-actions-dropdown"
    }, /* @__PURE__ */ React__default.createElement(Dropdown.Toggle, {
      className: "btn btn-sm btn-primary dropdown-toggle"
    }, /* @__PURE__ */ React__default.createElement("span", null, "Load Balancer Actions")), /* @__PURE__ */ React__default.createElement(Dropdown.Menu, {
      className: "dropdown-menu"
    }, application && /* @__PURE__ */ React__default.createElement(ManagedMenuItem, {
      resource: loadBalancer,
      application: app,
      onClick: this.editLoadBalancer
    }, "Edit Load Balancer"), !application && /* @__PURE__ */ React__default.createElement("li", {
      className: "disabled"
    }, /* @__PURE__ */ React__default.createElement("a", null, "Edit Load Balancer", " ", /* @__PURE__ */ React__default.createElement(HelpField, {
      content: `The application <b>${loadBalancerAppName}</b> must be configured before this load balancer can be edited.`
    }))), allowDeletion && /* @__PURE__ */ React__default.createElement(ManagedMenuItem, {
      resource: loadBalancer,
      application: app,
      onClick: this.deleteLoadBalancer
    }, "Delete Load Balancer"), !allowDeletion && /* @__PURE__ */ React__default.createElement("li", {
      className: "disabled"
    }, /* @__PURE__ */ React__default.createElement("a", null, "Delete Load Balancer", " ", /* @__PURE__ */ React__default.createElement(HelpField, {
      content: "You must detach all instances before you can delete this load balancer."
    }))), SETTINGS && SETTINGS.feature.entityTags && /* @__PURE__ */ React__default.createElement(AddEntityTagLinks, {
      component: loadBalancer,
      application: app,
      entityType: "loadBalancer",
      onUpdate: this.entityTagUpdate
    }))));
  }
}

const LOAD_BALANCER_ACTIONS = "spinnaker.amazon.loadBalancer.details.loadBalancerActions.component";
module(LOAD_BALANCER_ACTIONS, []).component("loadBalancerActions", react2angular(withErrorBoundary(LoadBalancerActions, "loadBalancerActions"), [
  "app",
  "loadBalancer",
  "loadBalancerFromParams"
]));

class AwsLoadBalancerDetailsController {
  constructor($scope, $state, $q, loadBalancer, app, securityGroupReader, loadBalancerReader) {
    this.$scope = $scope;
    this.$state = $state;
    this.$q = $q;
    this.app = app;
    this.securityGroupReader = securityGroupReader;
    this.loadBalancerReader = loadBalancerReader;
    this.state = { loading: true };
    this.firewallsLabel = FirewallLabels.get("Firewalls");
    this.oidcConfigPath = SETTINGS.oidcConfigPath;
    this.application = app;
    this.loadBalancerFromParams = loadBalancer;
    this.app.ready().then(() => this.extractLoadBalancer()).then(() => {
      if (!$scope.$$destroyed) {
        app.getDataSource("loadBalancers").onRefresh($scope, () => this.extractLoadBalancer());
      }
    });
  }
  autoClose() {
    if (this.$scope.$$destroyed) {
      return;
    }
    this.$state.params.allowModalToStayOpen = true;
    this.$state.go("^", null, { location: "replace" });
  }
  extractLoadBalancer() {
    const appLoadBalancer = this.app.loadBalancers.data.find((test) => {
      return test.name === this.loadBalancerFromParams.name && test.region === this.loadBalancerFromParams.region && test.account === this.loadBalancerFromParams.accountId;
    });
    if (appLoadBalancer) {
      const detailsLoader = this.loadBalancerReader.getLoadBalancerDetails("aws", this.loadBalancerFromParams.accountId, this.loadBalancerFromParams.region, this.loadBalancerFromParams.name);
      return detailsLoader.then((details) => {
        this.loadBalancer = appLoadBalancer;
        this.state.loading = false;
        const securityGroups = [];
        if (details.length) {
          this.loadBalancer.elb = details[0];
          this.loadBalancer.elb.vpcId = this.loadBalancer.elb.vpcId || this.loadBalancer.elb.vpcid;
          this.loadBalancer.account = this.loadBalancerFromParams.accountId;
          const sourceData = details[0];
          if (sourceData.loadBalancerType === "application" || sourceData.loadBalancerType === "network") {
            const elb = details[0];
            if (elb.listeners && elb.listeners.length) {
              this.elbProtocol = "http:";
              if (elb.listeners.some((l) => l.protocol === "HTTPS")) {
                this.elbProtocol = "https:";
              }
              this.listeners = [];
              elb.listeners.forEach((l) => {
                l.defaultActions.sort((a, b) => a.order - b.order);
                l.rules.forEach((r) => r.actions.sort((a, b) => a.order - b.order));
              });
              elb.listeners.forEach((listener) => {
                listener.rules.map((rule) => {
                  let inMatch = [
                    listener.protocol,
                    (rule.conditions.find((c) => c.field === "host-header") || { values: [""] }).values[0],
                    listener.port
                  ].filter((f) => f).join(":");
                  const path = (rule.conditions.find((c) => c.field === "path-pattern") || { values: [] }).values[0];
                  if (path) {
                    inMatch = `${inMatch}${path}`;
                  }
                  const actions = rule.actions.map((a) => {
                    const action = { ...a };
                    if (action.type === "forward") {
                      action.targetGroup = this.loadBalancer.targetGroups.find((tg) => tg.name === action.targetGroupName);
                    }
                    return action;
                  });
                  this.listeners.push({ in: inMatch, actions });
                });
              });
            }
            if (elb.ipAddressType === "dualstack") {
              this.ipAddressTypeDescription = "IPv4 and IPv6";
            }
            if (elb.ipAddressType === "ipv4") {
              this.ipAddressTypeDescription = "IPv4";
            }
          } else {
            const elb = details[0];
            if (elb.listenerDescriptions) {
              this.elbProtocol = "http:";
              if (elb.listenerDescriptions.some((l) => l.listener.protocol === "HTTPS")) {
                this.elbProtocol = "https:";
              }
            }
          }
          (this.loadBalancer.elb.securityGroups || []).forEach((securityGroupId) => {
            const match = this.securityGroupReader.getApplicationSecurityGroup(this.app, this.loadBalancerFromParams.accountId, this.loadBalancerFromParams.region, securityGroupId);
            if (match) {
              securityGroups.push(match);
            }
          });
          this.securityGroups = sortBy(securityGroups, "name");
          if (this.loadBalancer.subnets) {
            this.loadBalancer.subnetDetails = this.loadBalancer.subnets.reduce((subnetDetails, subnetId) => {
              SubnetReader.getSubnetByIdAndProvider(subnetId, this.loadBalancer.provider).then((subnetDetail) => {
                subnetDetails.push(subnetDetail);
              });
              return subnetDetails;
            }, []);
          }
        }
      }, () => this.autoClose());
    } else {
      this.autoClose();
    }
    if (!this.loadBalancer) {
      this.autoClose();
    }
    return this.$q.when(null);
  }
  getFirstSubnetPurpose(subnetDetailsList = []) {
    return head(subnetDetailsList.map((subnet) => subnet.purpose)) || "";
  }
}
AwsLoadBalancerDetailsController.$inject = [
  "$scope",
  "$state",
  "$q",
  "loadBalancer",
  "app",
  "securityGroupReader",
  "loadBalancerReader"
];
const AWS_LOAD_BALANCER_DETAILS_CTRL = "spinnaker.amazon.loadBalancer.details.controller";
module(AWS_LOAD_BALANCER_DETAILS_CTRL, [
  UIROUTER_ANGULARJS,
  SECURITY_GROUP_READER,
  LOAD_BALANCER_ACTIONS,
  LOAD_BALANCER_READ_SERVICE,
  MANAGED_RESOURCE_DETAILS_INDICATOR
]).controller("awsLoadBalancerDetailsCtrl", AwsLoadBalancerDetailsController);

class AwsTargetGroupDetailsController {
  constructor($scope, $q, $state, targetGroup, app) {
    this.$scope = $scope;
    this.$q = $q;
    this.$state = $state;
    this.app = app;
    this.state = { loading: true };
    this.application = app;
    this.targetGroupFromParams = targetGroup;
    this.app.ready().then(() => this.extractTargetGroup()).then(() => {
      if (!$scope.$$destroyed) {
        app.getDataSource("loadBalancers").onRefresh($scope, () => this.extractTargetGroup());
      }
    });
  }
  autoClose() {
    if (this.$scope.$$destroyed) {
      return;
    }
    this.$state.params.allowModalToStayOpen = true;
    this.$state.go("^", null, { location: "replace" });
  }
  extractTargetGroup() {
    const { loadBalancerName, region, accountId, name } = this.targetGroupFromParams;
    const appLoadBalancer = this.app.loadBalancers.data.find((test) => {
      return test.name === loadBalancerName && test.region === region && test.account === accountId;
    });
    if (!appLoadBalancer) {
      this.autoClose();
      return this.$q.when(null);
    }
    const targetGroup = appLoadBalancer.targetGroups.find((tg) => tg.name === name);
    if (!targetGroup) {
      this.autoClose();
      return this.$q.when(null);
    }
    this.targetGroup = targetGroup;
    this.loadBalancer = appLoadBalancer;
    this.state.loading = false;
    this.elbProtocol = "http:";
    if (this.loadBalancer.listeners && this.loadBalancer.listeners.some((l) => l.protocol === "HTTPS")) {
      this.elbProtocol = "https:";
    }
    return this.$q.when(null);
  }
}
AwsTargetGroupDetailsController.$inject = ["$scope", "$q", "$state", "targetGroup", "app"];
const AWS_TARGET_GROUP_DETAILS_CTRL = "spinnaker.amazon.loadBalancer.details.targetGroupDetails.controller";
module(AWS_TARGET_GROUP_DETAILS_CTRL, [UIROUTER_ANGULARJS, MANAGED_RESOURCE_DETAILS_INDICATOR]).controller("awsTargetGroupDetailsCtrl", AwsTargetGroupDetailsController);

var __defProp$6 = Object.defineProperty;
var __getOwnPropDesc$6 = Object.getOwnPropertyDescriptor;
var __decorateClass$6 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$6(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$6(target, key, result);
  return result;
};
let TargetGroupDetails = class extends React__default.Component {
  render() {
    return /* @__PURE__ */ React__default.createElement("h3", null, "Target Group Details");
  }
};
TargetGroupDetails = __decorateClass$6([
  Overridable("loadBalancer.targetGroupDetails")
], TargetGroupDetails);

const TARGET_GROUP_STATES = "spinnaker.amazon.loadBalancer.targetGroup.states";
module(TARGET_GROUP_STATES, [APPLICATION_STATE_PROVIDER]).config([
  "applicationStateProvider",
  (applicationStateProvider) => {
    const targetGroupDetails = {
      name: "targetGroupDetails",
      url: "/targetGroupDetails/:provider/:accountId/:region/:vpcId/:loadBalancerName/:name",
      params: {
        vpcId: {
          value: null,
          squash: true
        }
      },
      views: {
        "detail@../insight": {
          component: TargetGroupDetails,
          $type: "react"
        }
      },
      resolve: {
        accountId: ["$stateParams", ($stateParams) => $stateParams.accountId],
        targetGroup: [
          "$stateParams",
          ($stateParams) => {
            return {
              loadBalancerName: $stateParams.loadBalancerName,
              name: $stateParams.name,
              accountId: $stateParams.accountId,
              region: $stateParams.region,
              vpcId: $stateParams.vpcId
            };
          }
        ]
      },
      data: {
        pageTitleDetails: {
          title: "Target Group Details",
          nameParam: "name",
          accountParam: "accountId",
          regionParam: "region"
        }
      }
    };
    applicationStateProvider.addInsightDetailState(targetGroupDetails);
  }
]);

const AWS_LOAD_BALANCER_MODULE = "spinnaker.amazon.loadBalancer";
module(AWS_LOAD_BALANCER_MODULE, [
  AWS_LOAD_BALANCER_DETAILS_CTRL,
  AWS_TARGET_GROUP_DETAILS_CTRL,
  LOAD_BALANCER_ACTIONS,
  TARGET_GROUP_STATES
]);

var amazonLogo = "amazon.logo352d4e042476837f.svg";

const AMAZON_PIPELINE_STAGES_BAKE_BAKEEXECUTIONDETAILS_CONTROLLER = "spinnaker.amazon.pipeline.stage.bake.executionDetails.controller";
module(AMAZON_PIPELINE_STAGES_BAKE_BAKEEXECUTIONDETAILS_CONTROLLER, [UIROUTER_ANGULARJS]).controller("awsBakeExecutionDetailsCtrl", [
  "$scope",
  "$stateParams",
  "executionDetailsSectionService",
  "$interpolate",
  function($scope, $stateParams, executionDetailsSectionService, $interpolate) {
    $scope.configSections = ["bakeConfig", "taskStatus"];
    const initialized = () => {
      $scope.detailsSection = $stateParams.details;
      $scope.provider = $scope.stage.context.cloudProviderType || "aws";
      $scope.roscoMode = SETTINGS.feature.roscoMode || typeof SETTINGS.feature.roscoSelector === "function" && SETTINGS.feature.roscoSelector($scope.stage.context);
      $scope.bakeryDetailUrl = $interpolate($scope.roscoMode && SETTINGS.roscoDetailUrl ? SETTINGS.roscoDetailUrl : SETTINGS.bakeryDetailUrl);
      $scope.bakeFailedNoError = get($scope.stage, "context.status.result") === "FAILURE" && !$scope.stage.failureMessage;
    };
    const initialize = () => executionDetailsSectionService.synchronizeSection($scope.configSections, initialized);
    initialize();
    $scope.$on("$stateChangeSuccess", initialize);
  }
]);

const AMAZON_PIPELINE_STAGES_BAKE_AWSBAKESTAGE = "spinnaker.amazon.pipeline.stage.bakeStage";
module(AMAZON_PIPELINE_STAGES_BAKE_AWSBAKESTAGE, [AMAZON_PIPELINE_STAGES_BAKE_BAKEEXECUTIONDETAILS_CONTROLLER]).config(function() {
  Registry.pipeline.registerStage({
    provides: "bake",
    cloudProvider: "aws",
    label: "Bake",
    description: "Bakes an image",
    templateUrl: "amazon/src/pipeline/stages/bake/bakeStage.html",
    executionDetailsUrl: "amazon/src/pipeline/stages/bake/bakeExecutionDetails.html",
    executionLabelComponent: BakeExecutionLabel,
    extraLabelLines: (stage) => {
      return stage.masterStage.context.allPreviouslyBaked || stage.masterStage.context.somePreviouslyBaked ? 1 : 0;
    },
    supportsCustomTimeout: true,
    validators: [
      { type: "requiredField", fieldName: "package" },
      { type: "requiredField", fieldName: "regions" },
      {
        type: "upstreamVersionProvided",
        checkParentTriggers: true,
        getMessage: (labels) => "Bake stages should always have a stage or trigger preceding them that provides version information: <ul>" + labels.map((label) => `<li>${label}</li>`).join("") + "</ul>Otherwise, Spinnaker will bake and deploy the most-recently built package."
      }
    ],
    restartable: true
  });
}).controller("awsBakeStageCtrl", [
  "$scope",
  "$q",
  "$uibModal",
  function($scope, $q, $uibModal) {
    $scope.stage.extendedAttributes = $scope.stage.extendedAttributes || {};
    $scope.stage.regions = $scope.stage.regions && $scope.stage.regions.sort() || [];
    if (!$scope.stage.user) {
      $scope.stage.user = AuthenticationService.getAuthenticatedUser().name;
    }
    $scope.viewState = {
      loading: true,
      roscoMode: SETTINGS.feature.roscoMode || typeof SETTINGS.feature.roscoSelector === "function" && SETTINGS.feature.roscoSelector($scope.stage),
      minRootVolumeSize: AWSProviderSettings.minRootVolumeSize,
      showVmTypeSelector: true,
      bakeWarning: AWSProviderSettings.bakeWarning,
      dockerBakeWarning: AWSProviderSettings.dockerBakeWarning,
      showDockerPreview: AWSProviderSettings.dockerBakeryDeprecated && $scope.stage.storeType === "docker",
      showMigrationFields: $scope.pipeline.migrationStatus !== "Started",
      showStoreType: !AWSProviderSettings.dockerBakeryDeprecated
    };
    function initialize() {
      $q.all([
        BakeryReader.getRegions("aws"),
        BakeryReader.getBaseOsOptions("aws"),
        BakeryReader.getBaseLabelOptions(),
        ["ebs", "docker"]
      ]).then(function([regions, baseOsOptions, baseLabelOptions, storeTypes]) {
        $scope.regions = [...regions].sort();
        $scope.storeTypes = storeTypes;
        if (!$scope.stage.storeType && $scope.storeTypes && $scope.storeTypes.length) {
          $scope.stage.storeType = $scope.storeTypes[0];
        }
        if ($scope.regions.length === 1) {
          $scope.stage.region = $scope.regions[0];
        } else if (!$scope.regions.includes($scope.stage.region)) {
          delete $scope.stage.region;
        }
        if (!$scope.stage.regions.length && $scope.application.defaultRegions.aws) {
          $scope.stage.regions.push(...Object.keys($scope.application.defaultRegions.aws).sort());
        }
        $scope.baseOsOptions = baseOsOptions.baseImages;
        $scope.baseLabelOptions = baseLabelOptions;
        if (!$scope.stage.baseOs && $scope.baseOsOptions && $scope.baseOsOptions.length) {
          $scope.stage.baseOs = $scope.baseOsOptions[0].id;
        } else if ($scope.stage.baseOs && !($scope.baseOsOptions || []).find((baseOs) => baseOs.id === $scope.stage.baseOs)) {
          $scope.baseOsOptions.push({
            id: $scope.stage.baseOs,
            detailedDescription: "Custom",
            vmTypes: ["hvm", "pv"]
          });
        }
        if (!$scope.stage.baseLabel && $scope.baseLabelOptions && $scope.baseLabelOptions.length) {
          $scope.stage.baseLabel = $scope.baseLabelOptions[0];
        }
        setVmTypes();
        if (!$scope.stage.vmType && $scope.vmTypes && $scope.vmTypes.length) {
          $scope.stage.vmType = $scope.vmTypes[0];
        }
        $scope.showAdvancedOptions = showAdvanced();
        $scope.viewState.loading = false;
      });
    }
    function stageUpdated() {
      deleteEmptyProperties();
      if ($scope.stage.storeType === "ebs" && $scope.stage.cloudProviderType !== "aws") {
        $scope.stage.cloudProviderType = "aws";
      }
      if (typeof SETTINGS.feature.roscoSelector === "function") {
        $scope.viewState.roscoMode = SETTINGS.feature.roscoSelector($scope.stage);
      }
    }
    function deleteEmptyProperties() {
      _.forOwn($scope.stage, function(val, key) {
        if (val === "") {
          delete $scope.stage[key];
        }
      });
    }
    function showAdvanced() {
      const stg = $scope.stage;
      return !!(stg.templateFileName || stg.extendedAttributes && _.size(stg.extendedAttributes) > 0 || stg.varFileName || stg.baseName || stg.baseAmi || stg.amiName || stg.amiSuffix || stg.rootVolumeSize);
    }
    function setVmTypes() {
      if ($scope.baseOsOptions.length && $scope.baseOsOptions.every(({ vmTypes }) => vmTypes)) {
        const allVmTypes = $scope.baseOsOptions.length && new Set($scope.baseOsOptions.reduce((types, { vmTypes }) => types.concat(vmTypes), []));
        const baseOs = $scope.baseOsOptions.find(({ id }) => id === $scope.stage.baseOs);
        $scope.viewState.showVmTypeSelector = allVmTypes.size > 1;
        $scope.vmTypes = baseOs.vmTypes;
      } else {
        $scope.viewState.showVmTypeSelector = true;
        $scope.vmTypes = ["hvm", "pv"];
      }
    }
    this.addExtendedAttribute = function() {
      if (!$scope.stage.extendedAttributes) {
        $scope.stage.extendedAttributes = {};
      }
      $uibModal.open({
        templateUrl: PipelineTemplates.addExtendedAttributes,
        controller: "bakeStageAddExtendedAttributeController",
        controllerAs: "addExtendedAttribute",
        resolve: {
          extendedAttribute: function() {
            return {
              key: "",
              value: ""
            };
          }
        }
      }).result.then(function(extendedAttribute) {
        $scope.stage.extendedAttributes[extendedAttribute.key] = extendedAttribute.value;
      }).catch(() => {
      });
    };
    this.removeExtendedAttribute = function(key) {
      delete $scope.stage.extendedAttributes[key];
    };
    this.showTemplateFileName = function() {
      return $scope.viewState.roscoMode || $scope.stage.templateFileName;
    };
    this.showExtendedAttributes = function() {
      return $scope.viewState.roscoMode || $scope.stage.extendedAttributes && _.size($scope.stage.extendedAttributes) > 0;
    };
    this.showVarFileName = function() {
      return $scope.viewState.roscoMode || $scope.stage.varFileName;
    };
    this.handleBaseOsChange = function() {
      setVmTypes();
      if ($scope.vmTypes && $scope.vmTypes.length && !$scope.vmTypes.includes($scope.stage.vmType)) {
        $scope.stage.vmType = $scope.vmTypes[0];
      }
    };
    $scope.$watch("stage", stageUpdated, true);
    initialize();
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/pipeline/stages/bake/bakeStage.html", `<div ng-controller="awsBakeStageCtrl as bakeStageCtrl">
  <div ng-if="viewState.loading" class="horizontal center middle">
    <loading-spinner size="'small'"></loading-spinner>
  </div>
  <div ng-if="!viewState.loading && viewState.showDockerPreview">
    <div ng-if="viewState.dockerBakeWarning" class="alert alert-warning sp-margin-s-top horizontal middle">
      <i class="fa fa-exclamation-triangle"></i>
      <div class="sp-margin-s-left">
        <markdown message="viewState.dockerBakeWarning"></markdown>
      </div>
    </div>
    <div>
      <div class="alert alert-info horizontal middle">
        <i class="fa fa-info-circle"></i>
        <div class="sp-margin-s-left">
          <markdown
            message="'To edit bake configuration or view advanced options, migrate to EBS store type.'"
          ></markdown>
        </div>
      </div>
      <stage-config-field label="Store Type" ng-if="!viewState.roscoMode && viewState.showMigrationFields">
        <label class="radio-inline" ng-repeat="storeType in storeTypes">
          <input type="radio" ng-model="stage.storeType" ng-value="storeType" />
          {{storeType | uppercase}}
        </label>
      </stage-config-field>
      <stage-config-field label="Regions">
        <span class="sp-margin-xs-right" ng-repeat="region in stage.regions">{{region}}</span>
      </stage-config-field>
      <stage-config-field label="Skip Region Detection">{{!!stage.skipRegionDetection}}</stage-config-field>
      <stage-config-field label="Repo Path">{{stage.package}}</stage-config-field>
      <stage-config-field label="Base OS">{{stage.baseOs}}</stage-config-field>
      <stage-config-field label="VM Type">{{stage.vmType}}</stage-config-field>
      <stage-config-field label="Store Type">{{stage.storeType}}</stage-config-field>
      <stage-config-field label="Base Label">{{stage.baseLabel}}</stage-config-field>
    </div>
  </div>
  <div ng-if="!viewState.loading && !viewState.showDockerPreview">
    <div
      ng-if="pipeline.migrationStatus === 'Started' && viewState.bakeWarning"
      class="alert alert-warning sp-margin-s-top horizontal middle"
    >
      <i class="fa fa-exclamation-triangle"></i>
      <div class="sp-margin-s-left">
        <markdown message="viewState.bakeWarning"></markdown>
      </div>
    </div>
    <stage-config-field label="Regions">
      <checklist items="regions" model="stage.regions" inline="true" include-select-all-button="true"></checklist>
    </stage-config-field>
    <stage-config-field label="Skip Region Detection" help-key="pipeline.config.bake.skipRegionDetection">
      <div class="checkbox" style="margin-bottom: 0">
        <label>
          <input type="checkbox" ng-model="stage.skipRegionDetection" />
          Only bake explicitly selected regions
        </label>
      </div>
    </stage-config-field>
    <stage-config-field
      label="{{stage.storeType === 'docker' ? 'Repo Path' : 'Package'}}"
      help-key="pipeline.config.bake.package"
    >
      <input type="text" class="form-control input-sm" ng-model="stage.package" />
    </stage-config-field>
    <stage-config-field label="Base OS">
      <bake-stage-choose-os
        model="stage.baseOs"
        base-os-options="baseOsOptions"
        on-change="bakeStageCtrl.handleBaseOsChange()"
      ></bake-stage-choose-os>
    </stage-config-field>
    <stage-config-field label="VM Type" ng-if="viewState.showVmTypeSelector && viewState.showMigrationFields">
      <label class="radio-inline" ng-repeat="vmType in vmTypes">
        <input type="radio" ng-model="stage.vmType" ng-value="vmType" />
        {{vmType | uppercase}}
      </label>
    </stage-config-field>
    <stage-config-field
      label="Store Type"
      ng-if="!viewState.roscoMode && viewState.showMigrationFields && viewState.showStoreType"
    >
      <label class="radio-inline" ng-repeat="storeType in storeTypes">
        <input type="radio" ng-model="stage.storeType" ng-value="storeType" />
        {{storeType | uppercase}}
      </label>
    </stage-config-field>
    <stage-config-field label="Base Label">
      <label class="radio-inline" ng-repeat="baseLabel in baseLabelOptions">
        <input type="radio" ng-model="stage.baseLabel" ng-value="baseLabel" />
        {{baseLabel}}
      </label>
    </stage-config-field>
    <!-- Even if the roscoMode flag is false, we should show the control if rebake is set. -->
    <stage-config-field label="Rebake" ng-if="viewState.roscoMode || stage.rebake">
      <div class="checkbox" style="margin-bottom: 0">
        <label>
          <input type="checkbox" ng-model="stage.rebake" />
          Rebake image without regard to the status of any existing bake
        </label>
      </div>
    </stage-config-field>
    <div class="form-group">
      <div class="col-md-9 col-md-offset-1">
        <div class="checkbox">
          <label>
            <input type="checkbox" ng-model="showAdvancedOptions" />
            <strong>Show Advanced Options</strong>
          </label>
        </div>
      </div>
    </div>
    <div ng-class="{collapse: showAdvancedOptions !== true, 'collapse.in': !showAdvancedOptions === true}">
      <stage-config-field
        label="Template File Name"
        help-key="pipeline.config.bake.templateFileName"
        ng-if="bakeStageCtrl.showTemplateFileName() && viewState.showMigrationFields"
      >
        <input type="text" class="form-control input-sm" ng-model="stage.templateFileName" />
      </stage-config-field>
      <stage-config-field
        label="Extended Attributes"
        help-key="pipeline.config.bake.extendedAttributes"
        ng-if="bakeStageCtrl.showExtendedAttributes()"
      >
        <table class="table table-condensed packed">
          <thead>
            <tr>
              <th style="width: 40%">Key</th>
              <th style="width: 60%">Value</th>
              <th class="text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat="(key,value) in stage.extendedAttributes">
              <td>
                <strong class="small">{{key}}</strong>
              </td>
              <td>
                <input
                  type="text"
                  ng-model="stage.extendedAttributes[key]"
                  value="{{value}}"
                  class="form-control input-sm"
                />
              </td>
              <td class="text-right">
                <a class="small" href ng-click="bakeStageCtrl.removeExtendedAttribute(key)">Remove</a>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="7">
                <button class="btn btn-block btn-sm add-new" ng-click="bakeStageCtrl.addExtendedAttribute()">
                  <span class="glyphicon glyphicon-plus-sign"></span> Add Extended Attribute
                </button>
              </td>
            </tr>
          </tfoot>
        </table>
      </stage-config-field>
      <stage-config-field
        label="Var File Name"
        help-key="pipeline.config.bake.varFileName"
        ng-if="bakeStageCtrl.showVarFileName() && viewState.showMigrationFields"
      >
        <input type="text" class="form-control input-sm" ng-model="stage.varFileName" />
      </stage-config-field>
      <stage-config-field label="Root Volume Size" ng-if="viewState.minRootVolumeSize && viewState.showMigrationFields">
        <input
          type="number"
          class="form-control input-sm"
          style="width: 80px; display: inline-block"
          ng-min="viewState.minRootVolumeSize"
          ng-model="stage.rootVolumeSize"
        />
        GB <span class="small">(minimum: {{viewState.minRootVolumeSize}})</span>
      </stage-config-field>
      <stage-config-field label="Base Name" ng-if="stage.storeType !== 'docker' && viewState.showMigrationFields">
        <input type="text" class="form-control input-sm" ng-model="stage.baseName" />
      </stage-config-field>
      <stage-config-field
        label="Base AMI"
        help-key="pipeline.config.bake.baseAmi"
        ng-if="stage.storeType !== 'docker' && viewState.showMigrationFields"
      >
        <input type="text" class="form-control input-sm" ng-model="stage.baseAmi" />
      </stage-config-field>
      <stage-config-field
        label="{{stage.storeType === 'docker' ? 'Docker Image Name' : 'AMI Name'}}"
        help-key="pipeline.config.bake.amiName"
        ng-if="viewState.showMigrationFields"
      >
        <input type="text" class="form-control input-sm" ng-model="stage.amiName" />
      </stage-config-field>
      <stage-config-field
        label="{{stage.storeType === 'docker' ? 'Docker Image Prefix' : 'AMI Suffix'}}"
        help-key="pipeline.config.bake.amiSuffix"
        ng-if="viewState.showMigrationFields"
      >
        <input type="text" class="form-control input-sm" ng-model="stage.amiSuffix" />
      </stage-config-field>
    </div>
  </div>
</div>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/pipeline/stages/bake/bakeExecutionDetails.html", `<div ng-controller="awsBakeExecutionDetailsCtrl">
  <execution-details-section-nav sections="configSections"></execution-details-section-nav>
  <div class="step-section-details" ng-if="detailsSection === 'bakeConfig'">
    <div class="row">
      <div class="col-md-6">
        <dl class="dl-narrow dl-horizontal">
          <dt if-multiple-providers>Provider</dt>
          <dd if-multiple-providers>Amazon</dd>
          <dt>Image</dt>
          <dd>{{stage.context.ami}}</dd>
          <dt>Region</dt>
          <dd>{{stage.context.region}}</dd>
          <dt>Package</dt>
          <dd>{{stage.context.package}}</dd>
        </dl>
      </div>
      <div class="col-md-6">
        <dl class="dl-narrow dl-horizontal">
          <dt>Base OS</dt>
          <dd>{{stage.context.baseOs}}</dd>
          <dt>VM Type</dt>
          <dd>{{stage.context.vmType | uppercase}}</dd>
          <dt ng-if="!roscoMode">Store Type</dt>
          <dd ng-if="!roscoMode">{{stage.context.storeType | uppercase}}</dd>
          <dt ng-if="!roscoMode">Label</dt>
          <dd ng-if="!roscoMode">{{stage.context.baseLabel}}</dd>
          <dt ng-if="roscoMode || execution.trigger.rebake || stage.context.rebake">Rebake</dt>
          <dd ng-if="roscoMode || execution.trigger.rebake || stage.context.rebake">
            {{execution.trigger.rebake || stage.context.rebake || false}}
          </dd>
          <dt ng-if="stage.context.templateFileName">Template</dt>
          <dd ng-if="stage.context.templateFileName">{{stage.context.templateFileName}}</dd>
          <dt ng-if="stage.context.varFileName">Var File</dt>
          <dd ng-if="stage.context.varFileName">{{stage.context.varFileName}}</dd>
        </dl>
      </div>
    </div>
    <stage-failure-message
      stage="stage"
      message="stage.failureMessage"
      ng-if="stage.failureMessage"
    ></stage-failure-message>

    <div class="row" ng-if="stage.context.region && stage.context.status.resourceId">
      <div class="col-md-12">
        <div class="alert alert-{{stage.isFailed ? 'danger' : 'info'}}">
          <div ng-if="stage.context.previouslyBaked">No changes detected; reused existing bake</div>
          <div ng-if="stage.context.imageName">
            <strong>Image:</strong>
            <div select-on-dbl-click>{{stage.context.imageName}}</div>
            <div>({{stage.context.ami}})</div>
          </div>
          <span ng-if="bakeFailedNoError">Bake failed. </span>
          <a target="_blank" href="{{ bakeryDetailUrl(stage) }}">View Bakery Details</a>
          <span ng-if="bakeFailedNoError"> for more info.</span>
        </div>
      </div>
    </div>
  </div>
  <div class="step-section-details" ng-if="detailsSection === 'taskStatus'">
    <div class="row">
      <execution-step-details item="stage"></execution-step-details>
    </div>
  </div>
</div>
`);
}]);

const AMAZON_PIPELINE_STAGES_CLONESERVERGROUP_AWSCLONESERVERGROUPSTAGE = "spinnaker.amazon.pipeline.stage.cloneServerGroupStage";
module(AMAZON_PIPELINE_STAGES_CLONESERVERGROUP_AWSCLONESERVERGROUPSTAGE, []).config(function() {
  Registry.pipeline.registerStage({
    provides: "cloneServerGroup",
    cloudProvider: "aws",
    templateUrl: "amazon/src/pipeline/stages/cloneServerGroup/cloneServerGroupStage.html",
    executionStepLabelUrl: "amazon/src/pipeline/stages/cloneServerGroup/cloneServerGroupStepLabel.html",
    accountExtractor: (stage) => [stage.context.credentials],
    validators: [
      { type: "requiredField", fieldName: "targetCluster", fieldLabel: "cluster" },
      { type: "requiredField", fieldName: "target" },
      { type: "requiredField", fieldName: "region" },
      { type: "requiredField", fieldName: "credentials", fieldLabel: "account" }
    ]
  });
}).controller("awsCloneServerGroupStageCtrl", [
  "$scope",
  function($scope) {
    const stage = $scope.stage;
    $scope.viewState = {
      accountsLoaded: false
    };
    AccountService.listAccounts("aws").then((accounts) => {
      $scope.accounts = accounts;
      $scope.viewState.accountsLoaded = true;
    });
    this.cloneTargets = StageConstants.TARGET_LIST;
    stage.target = stage.target || this.cloneTargets[0].val;
    stage.application = $scope.application.name;
    stage.cloudProvider = "aws";
    stage.cloudProviderType = "aws";
    stage.viewState = {
      mode: "editPipeline"
    };
    if (stage.isNew && $scope.application.attributes.platformHealthOnlyShowOverride && $scope.application.attributes.platformHealthOnly) {
      stage.interestingHealthProviderNames = ["Amazon"];
    }
    if (!stage.credentials && $scope.application.defaultCredentials.aws) {
      stage.credentials = $scope.application.defaultCredentials.aws;
    }
    if (stage.isNew) {
      stage.useAmiBlockDeviceMappings = _.get($scope, "application.attributes.providerSettings.aws.useAmiBlockDeviceMappings", false);
      stage.copySourceCustomBlockDeviceMappings = false;
    }
    this.targetClusterUpdated = () => {
      if (stage.targetCluster) {
        const filterByCluster = AppListExtractor.monikerClusterNameFilter(stage.targetCluster);
        const moniker = _.first(AppListExtractor.getMonikers([$scope.application], filterByCluster));
        if (moniker) {
          stage.stack = moniker.stack;
          stage.freeFormDetails = moniker.detail;
        } else {
          const nameParts = NameUtils.parseClusterName(stage.targetCluster);
          stage.stack = nameParts.stack;
          stage.freeFormDetails = nameParts.freeFormDetails;
        }
      } else {
        stage.stack = "";
        stage.freeFormDetails = "";
      }
    };
    $scope.$watch("stage.targetCluster", this.targetClusterUpdated);
    this.removeCapacity = () => {
      delete stage.capacity;
    };
    if (!_.has(stage, "useSourceCapacity")) {
      stage.useSourceCapacity = true;
    }
    this.toggleSuspendedProcess = (process) => {
      stage.suspendedProcesses = stage.suspendedProcesses || [];
      const processIndex = stage.suspendedProcesses.indexOf(process);
      if (processIndex === -1) {
        stage.suspendedProcesses.push(process);
      } else {
        stage.suspendedProcesses.splice(processIndex, 1);
      }
    };
    this.processIsSuspended = (process) => {
      return stage.suspendedProcesses && stage.suspendedProcesses.includes(process);
    };
    this.getBlockDeviceMappingsSource = () => {
      if (stage.copySourceCustomBlockDeviceMappings) {
        return "source";
      } else if (stage.useAmiBlockDeviceMappings) {
        return "ami";
      }
      return "default";
    };
    this.selectBlockDeviceMappingsSource = (selection) => {
      if (selection === "source") {
        stage.copySourceCustomBlockDeviceMappings = true;
        stage.useAmiBlockDeviceMappings = false;
      } else if (selection === "ami") {
        stage.copySourceCustomBlockDeviceMappings = false;
        stage.useAmiBlockDeviceMappings = true;
      } else {
        stage.copySourceCustomBlockDeviceMappings = false;
        stage.useAmiBlockDeviceMappings = false;
      }
    };
    this.onRedBlackFieldChange = (key, value) => {
      _.set(stage, key, value);
    };
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/pipeline/stages/cloneServerGroup/cloneServerGroupStage.html", `<div ng-controller="awsCloneServerGroupStageCtrl as cloneServerGroupStageCtrl">
  <div ng-if="!pipeline.strategy">
    <div ng-if="viewState.loading" class="horizontal center middle">
      <loading-spinner size="'small'"></loading-spinner>
    </div>
    <div ng-if="!viewState.loading">
      <account-region-cluster-selector
        application="application"
        component="stage"
        accounts="accounts"
        single-region="true"
        cluster-field="targetCluster"
      >
      </account-region-cluster-selector>
    </div>
  </div>
  <stage-config-field label="Target">
    <target-select model="stage" options="cloneServerGroupStageCtrl.cloneTargets"></target-select>
  </stage-config-field>
  <div>
    <div class="form-group">
      <div class="col-md-3 sm-label-right">Capacity</div>
      <div class="col-md-9 radio">
        <label>
          <input
            type="radio"
            ng-model="stage.useSourceCapacity"
            ng-value="true"
            ng-click="cloneServerGroupStageCtrl.removeCapacity()"
            id="useSourceCapacityTrue"
          />
          Copy the capacity from the current server group
          <help-field key="serverGroupCapacity.useSourceCapacityTrue"></help-field>
        </label>
      </div>
      <div class="col-md-9 col-md-offset-3 radio">
        <label>
          <input type="radio" ng-model="stage.useSourceCapacity" ng-value="false" id="useSourceCapacityFalse" />
          Let me specify the capacity
          <help-field key="serverGroupCapacity.useSourceCapacityFalse"></help-field>
        </label>
      </div>
    </div>
    <div class="form-group">
      <div class="col-md-2 col-md-offset-3">Min</div>
      <div class="col-md-2">Max</div>
      <div class="col-md-2">Desired</div>
    </div>
    <div class="form-group">
      <div class="col-md-2 col-md-offset-3">
        <input
          type="number"
          ng-disabled="stage.useSourceCapacity"
          class="form-control input-sm"
          ng-model="stage.capacity.min"
          min="0"
          max="{{stage.capacity.max}}"
          required
        />
      </div>
      <div class="col-md-2">
        <input
          type="number"
          ng-disabled="stage.useSourceCapacity"
          class="form-control input-sm"
          ng-model="stage.capacity.max"
          min="{{stage.capacity.min}}"
          required
        />
      </div>
      <div class="col-md-2">
        <input
          type="number"
          ng-disabled="stage.useSourceCapacity"
          class="form-control input-sm"
          ng-model="stage.capacity.desired"
          min="{{stage.capacity.min}}"
          max="{{stage.capacity.max}}"
          required
        />
      </div>
    </div>
  </div>
  <stage-config-field label="Traffic" help-key="aws.serverGroup.traffic">
    <div class="checkbox">
      <label>
        <input
          type="checkbox"
          ng-click="cloneServerGroupStageCtrl.toggleSuspendedProcess('AddToLoadBalancer')"
          ng-checked="!cloneServerGroupStageCtrl.processIsSuspended('AddToLoadBalancer')"
        />
        Send client requests to new instances
      </label>
    </div>
  </stage-config-field>
  <stage-config-field label="AMI Block Device Mappings">
    <div class="radio">
      <div>
        <label>
          <input
            type="radio"
            ng-click="cloneServerGroupStageCtrl.selectBlockDeviceMappingsSource('source')"
            ng-checked="cloneServerGroupStageCtrl.getBlockDeviceMappingsSource() === 'source'"
            name="blockDeviceMappingsSource"
          />
          Copy from current server group
          <help-field key="aws.blockDeviceMappings.useSource"></help-field>
        </label>
      </div>
      <div>
        <label>
          <input
            type="radio"
            ng-click="cloneServerGroupStageCtrl.selectBlockDeviceMappingsSource('ami')"
            ng-checked="cloneServerGroupStageCtrl.getBlockDeviceMappingsSource() === 'ami'"
            name="blockDeviceMappingsSource"
          />
          Prefer AMI block device mappings
          <help-field key="aws.blockDeviceMappings.useAMI"></help-field>
        </label>
      </div>
      <div>
        <label>
          <input
            type="radio"
            ng-click="cloneServerGroupStageCtrl.selectBlockDeviceMappingsSource('default')"
            ng-checked="cloneServerGroupStageCtrl.getBlockDeviceMappingsSource() === 'default'"
            name="blockDeviceMappingsSource"
          />
          Defaults for selected instance type
          <help-field key="aws.blockDeviceMappings.useDefaults"></help-field>
        </label>
      </div>
    </div>
  </stage-config-field>
  <stage-platform-health-override application="application" stage="stage" platform-health-type="'Amazon'">
  </stage-platform-health-override>
  <deployment-strategy-selector
    field-columns="6"
    command="stage"
    on-field-change="cloneServerGroupStageCtrl.onRedBlackFieldChange"
  ></deployment-strategy-selector>
</div>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/pipeline/stages/cloneServerGroup/cloneServerGroupStepLabel.html", `<span class="task-label"> Clone Server Group: {{step.context.source.serverGroupName}} ({{step.context.region}}) </span>
`);
}]);

const CloudFormationChangeSetInfo = (props) => {
  const { stage, stageconfig } = props;
  const [changeSetName, setChangeSetName] = useState(stage.changeSetName ? stage.changeSetName : "ChangeSet-${ execution['id']}");
  const [executeChangeSet, setExecuteChangeSet] = useState(stage.executeChangeSet);
  const [actionOnReplacement, setActionOnReplacement] = useState(stage.actionOnReplacement);
  const modifyChangeSetName = (value) => {
    setChangeSetName(value);
    stageconfig.updateStageField({ changeSetName: value });
  };
  const toggleExecuteChangeSet = (checked) => {
    setExecuteChangeSet(checked);
    stageconfig.updateStageField({ executeChangeSet: checked });
  };
  const modifyActionOnReplacement = (value) => {
    setActionOnReplacement(value);
    stageconfig.updateStageField({ actionOnReplacement: value });
  };
  const actionOnReplacementOptions = [
    { value: "ask", label: "ask" },
    { value: "skip", label: "skip it" },
    { value: "execute", label: "execute it" },
    { value: "fail", label: "fail stage" }
  ];
  return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("hr", null), /* @__PURE__ */ React__default.createElement("h4", null, "ChangeSet Configuration"), /* @__PURE__ */ React__default.createElement(StageConfigField, {
    label: "ChangeSet Name"
  }, /* @__PURE__ */ React__default.createElement(TextInput, {
    className: "form-control",
    type: "text",
    value: changeSetName,
    onChange: (e) => modifyChangeSetName(e.target.value)
  })), /* @__PURE__ */ React__default.createElement(StageConfigField, {
    label: "Execute ChangeSet"
  }, /* @__PURE__ */ React__default.createElement(CheckboxInput, {
    checked: executeChangeSet,
    onChange: (e) => toggleExecuteChangeSet(e.target.checked)
  })), executeChangeSet && /* @__PURE__ */ React__default.createElement(StageConfigField, {
    label: "If ChangeSet contains a replacement",
    "help-key": "aws.cloudformation.changeSet.options"
  }, /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
    clearable: false,
    value: actionOnReplacement,
    options: actionOnReplacementOptions,
    onChange: (e) => modifyActionOnReplacement(e.target.value)
  })));
};
const CLOUD_FORMATION_CHANGE_SET_INFO = "spinnaker.amazon.cloudformation.changetset.info.component";
module(CLOUD_FORMATION_CHANGE_SET_INFO, []).component("cloudFormationChangeSetInfo", react2angular(withErrorBoundary(CloudFormationChangeSetInfo, "cloudFormationChangeSetInfo"), [
  "stage",
  "stageconfig"
]));

class CloudFormationTemplateController {
  constructor($scope) {
    this.$scope = $scope;
    this.$onInit = () => {
      if (typeof this.command.templateBody === "string") {
        this.rawTemplateBody = this.command.templateBody;
      } else {
        this.rawTemplateBody = yamlDocumentsToString(this.command.templateBody);
      }
    };
    this.handleChange = (rawTemplateBody, templateBody) => {
      this.command.templateBody = templateBody || rawTemplateBody;
      this.templateBody = templateBody || rawTemplateBody;
      this.rawTemplateBody = rawTemplateBody;
      this.$scope.$applyAsync();
    };
  }
}
CloudFormationTemplateController.$inject = ["$scope"];
const cloudFormationTemplateEntryComponent = {
  bindings: { command: "<", templateBody: "<" },
  controller: CloudFormationTemplateController,
  controllerAs: "ctrl",
  template: `
    <yaml-editor
      value="ctrl.rawTemplateBody"
      on-change="ctrl.handleChange"
    ></yaml-editor>`
};
const CLOUDFORMATION_TEMPLATE_ENTRY = "spinnaker.amazon.cloudformation.entry.component";
module(CLOUDFORMATION_TEMPLATE_ENTRY, []).component("cloudFormationTemplateEntry", cloudFormationTemplateEntryComponent);

class DeployExecutionDetails extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { stage, current, name } = this.props;
    return /* @__PURE__ */ React.createElement(ExecutionDetailsSection, {
      name,
      current
    }, /* @__PURE__ */ React.createElement(ExecutionStepDetails, {
      item: stage
    }), /* @__PURE__ */ React.createElement(StageFailureMessage, {
      stage,
      message: stage.failureMessage
    }));
  }
}
DeployExecutionDetails.title = "Task Status";

class DeployCloudFormationStackConfigController {
  constructor($scope) {
    this.$scope = $scope;
    this.state = {
      loaded: false
    };
    this.textSource = "text";
    this.artifactSource = "artifact";
    this.sources = [this.textSource, this.artifactSource];
    this.showClusterSelect = false;
    this.onStackArtifactEdited = (artifact) => {
      this.$scope.$applyAsync(() => {
        this.$scope.stage.stackArtifactId = null;
        this.$scope.stage.stackArtifact = artifact;
      });
    };
    this.onStackArtifactSelected = (expectedArtifact) => {
      this.onChangeStackArtifactId(expectedArtifact.id);
    };
    this.onChangeStackArtifactId = (artifactId) => {
      this.$scope.$applyAsync(() => {
        this.$scope.stage.stackArtifactId = artifactId;
        this.$scope.stage.stackArtifact = null;
      });
    };
    this.onStackArtifactAccountSelected = (stackArtifactAccount) => {
      this.$scope.$applyAsync(() => {
        this.$scope.stage.stackArtifactAccount = stackArtifactAccount;
      });
    };
    this.updatePipeline = (changes) => {
      this.$scope.$applyAsync(() => {
        extend(this.$scope.pipeline, changes);
      });
    };
    const dataToFetch = {
      accounts: AccountService.getAllAccountDetailsForProvider("aws"),
      artifactAccounts: AccountService.getArtifactAccounts()
    };
    $q.all(dataToFetch).then((backingData) => {
      const { accounts, artifactAccounts } = backingData;
      this.accounts = accounts;
      this.state.loaded = true;
      this.cloudFormationStackArtifactDelegate.setAccounts(artifactAccounts);
      this.cloudFormationStackArtifactController.updateAccounts(this.cloudFormationStackArtifactDelegate.getSelectedExpectedArtifact());
    });
    this.cloudFormationStackArtifactDelegate = new NgGenericArtifactDelegate($scope, "stack");
    this.cloudFormationStackArtifactController = new ExpectedArtifactSelectorViewController(this.cloudFormationStackArtifactDelegate);
  }
  canShowAccountSelect() {
    return this.$scope.stage.source === this.artifactSource && !this.$scope.showCreateArtifactForm && this.cloudFormationStackArtifactController.accountsForArtifact.length > 1;
  }
  toggleChangeSet() {
    this.$scope.stage.isChangeSet = !this.$scope.stage.isChangeSet;
  }
}
DeployCloudFormationStackConfigController.$inject = ["$scope"];

const EvaluateCloudFormationChangeSetExecutionApproval = (props) => {
  const { execution, stage, application } = props;
  const [submitting, setSubmitting] = useState(false);
  const [judgmentDecision, setJudgmentDecision] = useState("");
  const [error, setError] = useState(false);
  const provideJudgment = (judgmentDecision2) => {
    setSubmitting(true);
    setJudgmentDecision(judgmentDecision2);
    setError(false);
    AwsReactInjector.evaluateCloudFormationChangeSetExecutionService.evaluateExecution(application, execution, stage, judgmentDecision2);
  };
  const isSubmitting = (decision) => {
    return stage.judgmentStatus === decision || submitting && judgmentDecision === decision;
  };
  const handleContinueClick = () => {
    provideJudgment("skip");
  };
  const handleFailClick = () => {
    provideJudgment("fail");
  };
  const handleExecuteClick = () => {
    provideJudgment("execute");
  };
  return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("p", null, "This ChangeSet contains a replacement, which means there will be ", /* @__PURE__ */ React__default.createElement("b", null, "potential data loss"), " when executed."), /* @__PURE__ */ React__default.createElement("p", null, "How do you want to proceed?"), /* @__PURE__ */ React__default.createElement("div", {
    className: "action-buttons"
  }, /* @__PURE__ */ React__default.createElement("button", {
    className: "btn btn-danger",
    onClick: handleExecuteClick,
    disabled: submitting
  }, isSubmitting("Execute") && /* @__PURE__ */ React__default.createElement(Spinner, {
    mode: "circular"
  }), stage.context.stopButtonLabel || "Execute"), /* @__PURE__ */ React__default.createElement("button", {
    className: "btn btn-primary",
    disabled: submitting,
    onClick: handleContinueClick
  }, isSubmitting("Skip") && /* @__PURE__ */ React__default.createElement(Spinner, {
    mode: "circular"
  }), stage.context.skipButtonLabel || "Skip"), /* @__PURE__ */ React__default.createElement("button", {
    className: "btn btn-primary",
    disabled: submitting,
    onClick: handleFailClick
  }, isSubmitting("Fail") && /* @__PURE__ */ React__default.createElement(Spinner, {
    mode: "circular"
  }), stage.context.FailButtonLabel || "Fail"))), error && /* @__PURE__ */ React__default.createElement("div", {
    className: "error-message"
  }, "There was an error recording your decision. Please try again."));
};

class EvaluateCloudFormationChangeSetExecutionDetails extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { application, execution, stage, current, name } = this.props;
    const hasReplacement = stage.context.changeSetContainsReplacement;
    const askAction = hasReplacement && stage.isRunning && stage.context.actionOnReplacement === "ask";
    const isChangeSet = stage.context.isChangeSet;
    return /* @__PURE__ */ React.createElement(ExecutionDetailsSection, {
      name,
      current
    }, askAction ? /* @__PURE__ */ React.createElement(EvaluateCloudFormationChangeSetExecutionApproval, {
      key: stage.refId,
      application,
      execution,
      stage
    }) : /* @__PURE__ */ React.createElement("div", null, isChangeSet ? /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("dl", {
      className: "no-margin"
    }, /* @__PURE__ */ React.createElement("dt", null, "ChangeSet Name"), /* @__PURE__ */ React.createElement("dd", null, stage.context.changeSetName), /* @__PURE__ */ React.createElement("dt", null, "Replacement"), /* @__PURE__ */ React.createElement("dd", null, String(hasReplacement)), stage.context.changeSetExecutionChoice && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("dt", null, "Judgment"), /* @__PURE__ */ React.createElement("dd", null, stage.context.changeSetExecutionChoice), /* @__PURE__ */ React.createElement("dt", null, "Judged By"), /* @__PURE__ */ React.createElement("dd", null, stage.context.lastModifiedBy)))) : /* @__PURE__ */ React.createElement("div", null, "No changeSets found")));
  }
}
EvaluateCloudFormationChangeSetExecutionDetails.title = "Change Set Execution";

class EvaluateCloudFormationChangeSetExecutionLabel extends React.Component {
  render() {
    if (!this.props.executionMarker) {
      return /* @__PURE__ */ React.createElement(ExecutionBarLabel, {
        ...this.props
      });
    }
    const { stage } = this.props;
    if (stage.isRunning && stage.stages[0].context.changeSetContainsReplacement && stage.stages[0].context.actionOnReplacement === "ask") {
      const template = /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("b", null, stage.name)), /* @__PURE__ */ React.createElement(EvaluateCloudFormationChangeSetExecutionApproval, {
        stage: stage.masterStage,
        application: this.props.application,
        execution: this.props.execution
      }));
      return /* @__PURE__ */ React.createElement(HoverablePopover, {
        template
      }, this.props.children);
    }
    const tooltip = /* @__PURE__ */ React.createElement(Tooltip$1, {
      id: stage.id
    }, stage.name);
    return /* @__PURE__ */ React.createElement(OverlayTrigger, {
      placement: "top",
      overlay: tooltip
    }, /* @__PURE__ */ React.createElement("span", null, this.props.children));
  }
}

class EvaluateCloudFormationChangeSetExecutionMarkerIcon extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    if (this.props.stage.isRunning && this.props.stage.stages[0].context.changeSetContainsReplacement && this.props.stage.stages[0].context.actionOnReplacement === "ask") {
      this.props.stage.requiresAttention = true;
      return /* @__PURE__ */ React.createElement("span", {
        className: "fa fa-child"
      });
    }
    return null;
  }
}

const DEPLOY_CLOUDFORMATION_STACK_STAGE = "spinnaker.amazon.pipeline.stages.deployCloudFormationStage";
module(DEPLOY_CLOUDFORMATION_STACK_STAGE, []).config(() => {
  Registry.pipeline.registerStage({
    label: "Deploy (CloudFormation Stack)",
    description: "Deploy a CloudFormation Stack",
    key: "deployCloudFormation",
    cloudProvider: "aws",
    templateUrl: "amazon/src/pipeline/stages/deployCloudFormation/deployCloudFormationStackConfig.html",
    controller: "DeployCloudFormationStackConfigController",
    controllerAs: "ctrl",
    useCustomTooltip: true,
    executionDetailsSections: [DeployExecutionDetails, EvaluateCloudFormationChangeSetExecutionDetails],
    executionLabelComponent: EvaluateCloudFormationChangeSetExecutionLabel,
    producesArtifacts: true,
    supportsCustomTimeout: true,
    validators: [],
    markerIcon: EvaluateCloudFormationChangeSetExecutionMarkerIcon,
    accountExtractor: (stage) => stage.account ? [stage.account] : [],
    configAccountExtractor: (stage) => stage.account ? [stage.account] : [],
    artifactExtractor: ExpectedArtifactService.accumulateArtifacts(["stackArtifactId", "requiredArtifactIds"]),
    artifactRemover: ArtifactReferenceService.removeArtifactFromFields(["stackArtifactId", "requiredArtifactIds"])
  });
}).controller("DeployCloudFormationStackConfigController", DeployCloudFormationStackConfigController);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/pipeline/stages/deployCloudFormation/deployCloudFormationStackConfig.html", `<div ng-if="ctrl.state.loaded" class="clearfix">
  <div class="container-fluid form-horizontal">
    <h4>Basic Settings</h4>
    <div ng-if="!pipeline.strategy">
      <account-region-cluster-selector
        application="application"
        component="stage"
        accounts="ctrl.accounts"
        show-cluster-select="ctrl.showClusterSelect"
      >
      </account-region-cluster-selector>
    </div>
    <h4>Template Configuration</h4>
    <ng-form name="amazonCloudFormationTemplateSource">
      <stage-config-field label="Stack name">
        <label class="sm-label-right">
          <input type="text" class="form-control input-sm" required ng-model="stage.stackName" />
        </label>
        <br />
        <label>
          <input type="checkbox" ng-checked="stage.isChangeSet" ng-click="ctrl.toggleChangeSet()" />
          <strong>Create CloudFormation ChangeSet</strong>
        </label>
      </stage-config-field>

      <stage-config-field label="IAM role ARN">
        <label class="sm-label-right">
          <input type="text" class="form-control input-sm" ng-model="stage.roleARN" />
        </label>
      </stage-config-field>
      <stage-config-field label="Source" help-key="aws.cloudformation.source">
        <label class="sm-label-right">
          <input type="radio" ng-model="ctrl.$scope.stage.source" value="{{ctrl.textSource}}" />
          {{ ctrl.textSource | robotToHuman }}
          <span ng-if="stage.source === ctrl.textSource"> </span> </label
        ><br />
        <label class="sm-label-right">
          <input type="radio" ng-model="ctrl.$scope.stage.source" value="{{ctrl.artifactSource}}" />
          {{ ctrl.artifactSource | robotToHuman }}
        </label>
      </stage-config-field>
    </ng-form>
    <cloud-formation-template-entry
      ng-if="stage.source === ctrl.textSource"
      templateBody="stage.templateBody"
      command="stage"
    >
    </cloud-formation-template-entry>
    <stage-artifact-selector-delegate
      ng-if="ctrl.$scope.stage.source === ctrl.artifactSource"
      artifact="stage.stackArtifact"
      excluded-artifact-type-patterns="[]"
      expected-artifact-id="stage.stackArtifactId"
      field-columns="8"
      help-key="'aws.cloudformation.expectedArtifact'"
      label="'Expected Artifact'"
      on-artifact-edited="ctrl.onStackArtifactEdited"
      on-expected-artifact-selected="ctrl.onStackArtifactSelected"
      pipeline="pipeline"
      stage="stage"
    >
    </stage-artifact-selector-delegate>
    <div ng-if="stage.isChangeSet">
      <cloud-formation-change-set-info stage="stage" stageconfig="stageConfigCtrl"> </cloud-formation-change-set-info>
    </div>
    <hr />
    <stage-config-field label="Parameters" field-columns="6">
      <map-editor model="ctrl.$scope.stage.parameters" add-button-label="Add parameter"></map-editor>
    </stage-config-field>
    <hr />
    <stage-config-field label="Tags" field-columns="6">
      <map-editor model="ctrl.$scope.stage.tags" add-button-label="Add tag"></map-editor>
    </stage-config-field>
    <hr />
    <stage-config-field label="Capabilities" field-columns="6">
      <ui-select multiple ng-model="stage.capabilities" class="form-control input-sm">
        <ui-select-match>{{$item}}</ui-select-match>
        <ui-select-choices repeat="capability in ['CAPABILITY_IAM', 'CAPABILITY_NAMED_IAM', 'CAPABILITY_AUTO_EXPAND']">
          <span>{{ capability }}</span>
        </ui-select-choices>
      </ui-select>
    </stage-config-field>
  </div>
</div>
`);
}]);

class EvaluateCloudFormationChangeSetExecutionService {
  constructor(executionService) {
    this.executionService = executionService;
  }
  evaluateExecution(application, execution, stage, changeSetExecutionChoice) {
    const matcher = (result) => {
      const match = result.stages.find((test) => test.id === stage.id);
      return match && match.status !== "RUNNING";
    };
    return this.executionService.patchExecution(execution.id, stage.id, { changeSetExecutionChoice }).then(() => this.executionService.waitUntilExecutionMatches(execution.id, matcher)).then((updated) => this.executionService.updateExecution(application, updated));
  }
}
EvaluateCloudFormationChangeSetExecutionService.$inject = ["executionService"];
const AWS_EVALUATE_CLOUD_FORMATION_CHANGE_SET_EXECUTION_SERVICE = "spinnaker.amazon.deployCloudFormation.service";
module(AWS_EVALUATE_CLOUD_FORMATION_CHANGE_SET_EXECUTION_SERVICE, [EXECUTION_SERVICE]).service("evaluateCloudFormationChangeSetExecutionService", EvaluateCloudFormationChangeSetExecutionService);

const AMAZON_PIPELINE_STAGES_DESTROYASG_AWSDESTROYASGSTAGE = "spinnaker.amazon.pipeline.stage.aws.destroyAsgStage";
module(AMAZON_PIPELINE_STAGES_DESTROYASG_AWSDESTROYASGSTAGE, []).config(function() {
  Registry.pipeline.registerStage({
    provides: "destroyServerGroup",
    alias: "destroyAsg",
    cloudProvider: "aws",
    templateUrl: "amazon/src/pipeline/stages/destroyAsg/destroyAsgStage.html",
    executionStepLabelUrl: "amazon/src/pipeline/stages/destroyAsg/destroyAsgStepLabel.html",
    accountExtractor: (stage) => [stage.context.credentials],
    configAccountExtractor: (stage) => [stage.credentials],
    validators: [
      {
        type: "targetImpedance",
        message: "This pipeline will attempt to destroy a server group without deploying a new version into the same cluster."
      },
      { type: "requiredField", fieldName: "cluster" },
      { type: "requiredField", fieldName: "target" },
      { type: "requiredField", fieldName: "regions" },
      { type: "requiredField", fieldName: "credentials", fieldLabel: "account" }
    ]
  });
}).controller("awsDestroyAsgStageCtrl", [
  "$scope",
  function($scope) {
    const stage = $scope.stage;
    $scope.state = {
      accounts: false,
      regionsLoaded: false
    };
    AccountService.listAccounts("aws").then(function(accounts) {
      $scope.accounts = accounts;
      $scope.state.accounts = true;
    });
    $scope.regions = ["us-east-1", "us-west-1", "eu-west-1", "us-west-2"];
    $scope.targets = StageConstants.TARGET_LIST;
    stage.regions = stage.regions || [];
    stage.cloudProvider = "aws";
    if (!stage.credentials && $scope.application.defaultCredentials.aws) {
      stage.credentials = $scope.application.defaultCredentials.aws;
    }
    if (!stage.regions.length && $scope.application.defaultRegions.aws) {
      stage.regions.push($scope.application.defaultRegions.aws);
    }
    if (!stage.target) {
      stage.target = $scope.targets[0].val;
    }
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/pipeline/stages/destroyAsg/destroyAsgStage.html", `<div ng-controller="awsDestroyAsgStageCtrl as destroyAsgStageCtrl" class="form-horizontal">
  <div ng-if="!pipeline.strategy">
    <account-region-cluster-selector application="application" component="stage" accounts="accounts">
    </account-region-cluster-selector>
  </div>
  <stage-config-field label="Target">
    <target-select model="stage" options="targets"></target-select>
  </stage-config-field>
</div>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/pipeline/stages/destroyAsg/destroyAsgStepLabel.html", `<span class="task-label"> Destroy Server Group: {{step.context.serverGroupName}} ({{step.context.region}}) </span>
`);
}]);

const AMAZON_PIPELINE_STAGES_DISABLEASG_AWSDISABLEASGSTAGE = "spinnaker.amazon.pipeline.stage.disableAsgStage";
module(AMAZON_PIPELINE_STAGES_DISABLEASG_AWSDISABLEASGSTAGE, []).config(function() {
  Registry.pipeline.registerStage({
    provides: "disableServerGroup",
    alias: "disableAsg",
    cloudProvider: "aws",
    templateUrl: "amazon/src/pipeline/stages/disableAsg/disableAsgStage.html",
    executionStepLabelUrl: "amazon/src/pipeline/stages/disableAsg/disableAsgStepLabel.html",
    validators: [
      {
        type: "targetImpedance",
        message: "This pipeline will attempt to disable a server group without deploying a new version into the same cluster."
      },
      { type: "requiredField", fieldName: "cluster" },
      { type: "requiredField", fieldName: "target" },
      { type: "requiredField", fieldName: "regions" },
      { type: "requiredField", fieldName: "credentials", fieldLabel: "account" }
    ]
  });
}).controller("awsDisableAsgStageCtrl", [
  "$scope",
  function($scope) {
    const stage = $scope.stage;
    $scope.state = {
      accounts: false,
      regionsLoaded: false
    };
    AccountService.listAccounts("aws").then(function(accounts) {
      $scope.accounts = accounts;
      $scope.state.accounts = true;
    });
    $scope.targets = StageConstants.TARGET_LIST;
    stage.regions = stage.regions || [];
    stage.cloudProvider = "aws";
    if (stage.isNew && $scope.application.attributes.platformHealthOnlyShowOverride && $scope.application.attributes.platformHealthOnly) {
      stage.interestingHealthProviderNames = ["Amazon"];
    }
    if (!stage.credentials && $scope.application.defaultCredentials.aws) {
      stage.credentials = $scope.application.defaultCredentials.aws;
    }
    if (!stage.regions.length && $scope.application.defaultRegions.aws) {
      stage.regions.push($scope.application.defaultRegions.aws);
    }
    if (!stage.target) {
      stage.target = $scope.targets[0].val;
    }
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/pipeline/stages/disableAsg/disableAsgStage.html", `<div ng-controller="awsDisableAsgStageCtrl as disableAsgStageCtrl" class="form-horizontal">
  <div ng-if="!pipeline.strategy">
    <account-region-cluster-selector application="application" component="stage" accounts="accounts">
    </account-region-cluster-selector>
  </div>
  <stage-config-field label="Target">
    <target-select model="stage" options="targets"></target-select>
  </stage-config-field>
  <stage-platform-health-override application="application" stage="stage" platform-health-type="'Amazon'">
  </stage-platform-health-override>
</div>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/pipeline/stages/disableAsg/disableAsgStepLabel.html", `<span class="task-label"> Disable Server Group: {{step.context.serverGroupName}} ({{step.context.region}}) </span>
`);
}]);

const AMAZON_PIPELINE_STAGES_DISABLECLUSTER_AWSDISABLECLUSTERSTAGE = "spinnaker.amazon.pipeline.stage.disableClusterStage";
module(AMAZON_PIPELINE_STAGES_DISABLECLUSTER_AWSDISABLECLUSTERSTAGE, []).config(function() {
  Registry.pipeline.registerStage({
    provides: "disableCluster",
    cloudProvider: "aws",
    templateUrl: "amazon/src/pipeline/stages/disableCluster/disableClusterStage.html",
    validators: [
      { type: "requiredField", fieldName: "cluster" },
      {
        type: "requiredField",
        fieldName: "remainingEnabledServerGroups",
        fieldLabel: "Keep [X] enabled Server Groups"
      },
      { type: "requiredField", fieldName: "regions" },
      { type: "requiredField", fieldName: "credentials", fieldLabel: "account" }
    ]
  });
}).controller("awsDisableClusterStageCtrl", [
  "$scope",
  function($scope) {
    const ctrl = this;
    const stage = $scope.stage;
    $scope.state = {
      accounts: false,
      regionsLoaded: false
    };
    AccountService.listAccounts("aws").then(function(accounts) {
      $scope.accounts = accounts;
      $scope.state.accounts = true;
    });
    ctrl.reset = () => {
      ctrl.accountUpdated();
      ctrl.resetSelectedCluster();
    };
    stage.regions = stage.regions || [];
    stage.cloudProvider = "aws";
    if (stage.isNew && $scope.application.attributes.platformHealthOnlyShowOverride && $scope.application.attributes.platformHealthOnly) {
      stage.interestingHealthProviderNames = ["Amazon"];
    }
    if (!stage.credentials && $scope.application.defaultCredentials.aws) {
      stage.credentials = $scope.application.defaultCredentials.aws;
    }
    if (!stage.regions.length && $scope.application.defaultRegions.aws) {
      stage.regions.push($scope.application.defaultRegions.aws);
    }
    if (stage.remainingEnabledServerGroups === void 0) {
      stage.remainingEnabledServerGroups = 1;
    }
    ctrl.pluralize = function(str, val) {
      if (val === 1) {
        return str;
      }
      return str + "s";
    };
    if (stage.preferLargerOverNewer === void 0) {
      stage.preferLargerOverNewer = "false";
    }
    stage.preferLargerOverNewer = stage.preferLargerOverNewer.toString();
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/pipeline/stages/disableCluster/disableClusterStage.html", `<div ng-controller="awsDisableClusterStageCtrl as disableClusterStageCtrl" class="form-horizontal">
  <div ng-if="!pipeline.strategy">
    <account-region-cluster-selector application="application" component="stage" accounts="accounts">
    </account-region-cluster-selector>
  </div>
  <stage-config-field label="Disable Options">
    <div class="form-inline">
      Keep the
      <input
        type="number"
        min="0"
        required
        ng-model="stage.remainingEnabledServerGroups"
        class="form-control input-sm"
        style="width: 50px"
      />
      <select class="form-control input-sm" ng-model="stage.preferLargerOverNewer" style="width: 100px">
        <option value="true">largest</option>
        <option value="false">newest</option>
      </select>
      {{disableClusterStageCtrl.pluralize('server group', stage.remainingEnabledServerGroups)}} enabled.
    </div>
  </stage-config-field>
  <stage-platform-health-override application="application" stage="stage" platform-health-type="'Amazon'">
  </stage-platform-health-override>
</div>
`);
}]);

const AMAZON_PIPELINE_STAGES_ENABLEASG_AWSENABLEASGSTAGE = "spinnaker.amazon.pipeline.stage.enableAsgStage";
module(AMAZON_PIPELINE_STAGES_ENABLEASG_AWSENABLEASGSTAGE, []).config(function() {
  Registry.pipeline.registerStage({
    provides: "enableServerGroup",
    alias: "enableAsg",
    cloudProvider: "aws",
    templateUrl: "amazon/src/pipeline/stages/enableAsg/enableAsgStage.html",
    executionStepLabelUrl: "amazon/src/pipeline/stages/enableAsg/enableAsgStepLabel.html",
    validators: [
      { type: "requiredField", fieldName: "cluster" },
      { type: "requiredField", fieldName: "target" },
      { type: "requiredField", fieldName: "regions" },
      { type: "requiredField", fieldName: "credentials", fieldLabel: "account" }
    ]
  });
}).controller("awsEnableAsgStageCtrl", [
  "$scope",
  function($scope) {
    const ctrl = this;
    const stage = $scope.stage;
    $scope.state = {
      accounts: false,
      regionsLoaded: false
    };
    AccountService.listAccounts("aws").then(function(accounts) {
      $scope.accounts = accounts;
      $scope.state.accounts = true;
    });
    ctrl.reset = () => {
      ctrl.accountUpdated();
      ctrl.resetSelectedCluster();
    };
    $scope.targets = StageConstants.TARGET_LIST;
    stage.regions = stage.regions || [];
    stage.cloudProvider = "aws";
    if (stage.isNew && $scope.application.attributes.platformHealthOnlyShowOverride && $scope.application.attributes.platformHealthOnly) {
      stage.interestingHealthProviderNames = ["Amazon"];
    }
    if (!stage.credentials && $scope.application.defaultCredentials.aws) {
      stage.credentials = $scope.application.defaultCredentials.aws;
    }
    if (!stage.regions.length && $scope.application.defaultRegions.aws) {
      stage.regions.push($scope.application.defaultRegions.aws);
    }
    if (!stage.target) {
      stage.target = $scope.targets[0].val;
    }
    $scope.$watch("stage.credentials", $scope.accountUpdated);
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/pipeline/stages/enableAsg/enableAsgStage.html", `<div ng-controller="awsEnableAsgStageCtrl as enableAsgStageCtrl" class="form-horizontal">
  <div ng-if="!pipeline.strategy">
    <account-region-cluster-selector application="application" component="stage" accounts="accounts">
    </account-region-cluster-selector>
  </div>
  <stage-config-field label="Target">
    <target-select model="stage" options="targets"></target-select>
  </stage-config-field>
  <stage-platform-health-override application="application" stage="stage" platform-health-type="'Amazon'">
  </stage-platform-health-override>
</div>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/pipeline/stages/enableAsg/enableAsgStepLabel.html", `<span class="task-label"> Enable Server Group: {{step.context.serverGroupName}} ({{step.context.region}}) </span>
`);
}]);

const AMAZON_PIPELINE_STAGES_FINDAMI_AWSFINDAMISTAGE = "spinnaker.amazon.pipeline.stage.findAmiStage";
angular.module(AMAZON_PIPELINE_STAGES_FINDAMI_AWSFINDAMISTAGE, []).config(function() {
  Registry.pipeline.registerStage({
    provides: "findImage",
    alias: "findAmi",
    cloudProvider: "aws",
    templateUrl: "amazon/src/pipeline/stages/findAmi/findAmiStage.html",
    validators: [
      { type: "requiredField", fieldName: "cluster" },
      { type: "requiredField", fieldName: "selectionStrategy", fieldLabel: "Server Group Selection" },
      { type: "requiredField", fieldName: "regions" },
      { type: "requiredField", fieldName: "credentials" }
    ]
  });
}).controller("awsFindAmiStageCtrl", [
  "$scope",
  function($scope) {
    const stage = $scope.stage;
    $scope.state = {
      accounts: false,
      regionsLoaded: false
    };
    AccountService.listAccounts("aws").then(function(accounts) {
      $scope.accounts = accounts;
      $scope.state.accounts = true;
    });
    $scope.selectionStrategies = [
      {
        label: "Largest",
        val: "LARGEST",
        description: "When multiple server groups exist, prefer the server group with the most instances"
      },
      {
        label: "Newest",
        val: "NEWEST",
        description: "When multiple server groups exist, prefer the newest"
      },
      {
        label: "Oldest",
        val: "OLDEST",
        description: "When multiple server groups exist, prefer the oldest"
      },
      {
        label: "Fail",
        val: "FAIL",
        description: "When multiple server groups exist, fail"
      }
    ];
    stage.regions = stage.regions || [];
    stage.cloudProvider = "aws";
    stage.selectionStrategy = stage.selectionStrategy || $scope.selectionStrategies[0].val;
    if (angular.isUndefined(stage.onlyEnabled)) {
      stage.onlyEnabled = true;
    }
    if (!stage.credentials && $scope.application.defaultCredentials.aws) {
      stage.credentials = $scope.application.defaultCredentials.aws;
    }
    if (!stage.regions.length && $scope.application.defaultRegions.aws) {
      stage.regions.push($scope.application.defaultRegions.aws);
    }
    $scope.$watch("stage.credentials", $scope.accountUpdated);
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/pipeline/stages/findAmi/findAmiStage.html", `<div ng-controller="awsFindAmiStageCtrl as findAmiCtrl" class="form-horizontal">
  <account-region-cluster-selector
    application="application"
    component="stage"
    accounts="accounts"
    show-all-regions="true"
  >
  </account-region-cluster-selector>
  <stage-config-field label="Server Group Selection">
    <ui-select ng-model="stage.selectionStrategy" class="form-control input-sm">
      <ui-select-match placeholder="None">{{$select.selected.label}}</ui-select-match>
      <ui-select-choices repeat="strategy.val as strategy in selectionStrategies | filter: $select.search">
        <strong ng-bind-html="strategy.label | highlight: $select.search"></strong>
        <div ng-bind-html="strategy.description"></div>
      </ui-select-choices>
    </ui-select>
  </stage-config-field>
  <stage-config-field label="Server Group Filters">
    <label class="checkbox-inline">
      <input type="checkbox" ng-model="stage.onlyEnabled" />
      Only consider enabled Server Groups
    </label>
  </stage-config-field>
</div>
`);
}]);

const AMAZON_PIPELINE_STAGES_FINDIMAGEFROMTAGS_AWSFINDIMAGEFROMTAGSSTAGE = "spinnaker.amazon.pipeline.stage.findImageFromTagsStage";
module(AMAZON_PIPELINE_STAGES_FINDIMAGEFROMTAGS_AWSFINDIMAGEFROMTAGSSTAGE, []).config(function() {
  Registry.pipeline.registerStage({
    provides: "findImageFromTags",
    cloudProvider: "aws",
    templateUrl: "amazon/src/pipeline/stages/findImageFromTags/findImageFromTagsStage.html",
    executionDetailsUrl: "amazon/src/pipeline/stages/findImageFromTags/findImageFromTagsExecutionDetails.html",
    executionConfigSections: ["findImageConfig", "taskStatus"],
    validators: [
      { type: "requiredField", fieldName: "packageName" },
      { type: "requiredField", fieldName: "regions" },
      { type: "requiredField", fieldName: "tags" }
    ]
  });
}).controller("awsFindImageFromTagsStageCtrl", [
  "$scope",
  function($scope) {
    $scope.stage.tags = $scope.stage.tags || {};
    $scope.stage.regions = $scope.stage.regions || [];
    $scope.stage.cloudProvider = $scope.stage.cloudProvider || "aws";
    BakeryReader.getRegions("aws").then(function(regions) {
      $scope.regions = regions;
    });
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/pipeline/stages/findImageFromTags/findImageFromTagsStage.html", `<div ng-controller="awsFindImageFromTagsStageCtrl as findImageFromTagsCtrl" class="form-horizontal">
  <stage-config-field label="Package">
    <input type="text" class="form-control input-sm" ng-model="stage.packageName" />
  </stage-config-field>
  <stage-config-field label="Regions">
    <checklist items="regions" model="stage.regions" inline="true" include-select-all-button="true"></checklist>
  </stage-config-field>
  <stage-config-field label="Tags">
    <map-editor model="stage.tags" allow-empty="true"></map-editor>
  </stage-config-field>
</div>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/pipeline/stages/findImageFromTags/findImageFromTagsExecutionDetails.html", `<div ng-controller="BaseExecutionDetailsCtrl">
  <execution-details-section-nav sections="configSections"></execution-details-section-nav>
  <div class="step-section-details" ng-if="detailsSection === 'findImageConfig'">
    <div class="row">
      <div class="col-md-12">
        <dl class="dl-narrow dl-horizontal">
          <dt if-multiple-providers>Provider</dt>
          <dd if-multiple-providers>Amazon</dd>
          <dt>Package</dt>
          <dd>{{stage.context.packageName}}</dd>
          <dt>Regions</dt>
          <dd>{{stage.context.regions.join(', ')}}</dd>
          <dt>Tags</dt>
          <dd>
            <span ng-repeat="(key, val) in stage.context.tags"> {{key}}:{{val}}{{$last ? '' : ', '}} </span>
          </dd>
        </dl>
      </div>
    </div>
    <stage-failure-message stage="stage" message="stage.failureMessage"></stage-failure-message>

    <div class="row" ng-if="stage.context.amiDetails">
      <div class="col-md-12">
        <div class="well alert alert-info">
          <h4>Results</h4>
          <dl ng-repeat="image in stage.context.amiDetails" class="dl-narrow dl-horizontal">
            <dt>Region</dt>
            <dd>{{image.region}}</dd>
            <dt>Image ID</dt>
            <dd>{{image.imageId}}</dd>
            <dt>Name</dt>
            <dd>{{image.imageName}}</dd>
          </dl>
        </div>
      </div>
    </div>
  </div>

  <div class="step-section-details" ng-if="detailsSection === 'taskStatus'">
    <div class="row">
      <execution-step-details item="stage"></execution-step-details>
    </div>
  </div>
</div>
`);
}]);

const AMAZON_PIPELINE_STAGES_MODIFYSCALINGPROCESS_MODIFYSCALINGPROCESSSTAGE = "spinnaker.amazon.pipeline.stage.modifyScalingProcessStage";
module(AMAZON_PIPELINE_STAGES_MODIFYSCALINGPROCESS_MODIFYSCALINGPROCESSSTAGE, []).config(function() {
  Registry.pipeline.registerStage({
    label: "Modify Scaling Process",
    description: "Suspend/Resume Scaling Processes",
    key: "modifyAwsScalingProcess",
    alias: "modifyScalingProcess",
    controller: "ModifyScalingProcessStageCtrl",
    templateUrl: "amazon/src/pipeline/stages/modifyScalingProcess/modifyScalingProcessStage.html",
    executionDetailsUrl: "amazon/src/pipeline/stages/modifyScalingProcess/modifyScalingProcessExecutionDetails.html",
    executionConfigSections: ["modifyScalingProcessesConfig", "taskStatus"],
    validators: [
      { type: "requiredField", fieldName: "cluster" },
      { type: "requiredField", fieldName: "target" },
      { type: "requiredField", fieldName: "action" },
      { type: "requiredField", fieldName: "regions" },
      { type: "requiredField", fieldName: "processes" },
      { type: "requiredField", fieldName: "credentials", fieldLabel: "account" }
    ],
    cloudProvider: "aws",
    strategy: true
  });
}).controller("ModifyScalingProcessStageCtrl", [
  "$scope",
  "stage",
  function($scope, stage) {
    $scope.stage = stage;
    $scope.state = {
      accounts: false,
      regionsLoaded: false
    };
    AccountService.listAccounts("aws").then(function(accounts) {
      $scope.accounts = accounts;
      $scope.state.accounts = true;
    });
    $scope.targets = StageConstants.TARGET_LIST;
    $scope.actions = [
      {
        label: "Suspend",
        val: "suspend"
      },
      {
        label: "Resume",
        val: "resume"
      }
    ];
    $scope.processes = [
      "Launch",
      "Terminate",
      "AddToLoadBalancer",
      "AlarmNotification",
      "AZRebalance",
      "HealthCheck",
      "ReplaceUnhealthy",
      "ScheduledActions"
    ];
    stage.processes = stage.processes || [];
    stage.regions = stage.regions || [];
    stage.action = stage.action || $scope.actions[0].val;
    stage.target = stage.target || $scope.targets[0].val;
    stage.cloudProvider = "aws";
    if (!stage.credentials && $scope.application.defaultCredentials.aws) {
      stage.credentials = $scope.application.defaultCredentials.aws;
    }
    if (!stage.regions.length && $scope.application.defaultRegions.aws) {
      stage.regions.push($scope.application.defaultRegions.aws);
    }
    $scope.toggleProcess = function(process) {
      if (!stage.processes) {
        stage.processes = [];
      }
      const idx = stage.processes.indexOf(process);
      if (idx > -1) {
        stage.processes.splice(idx, 1);
      } else {
        stage.processes.push(process);
      }
    };
    $scope.$watch("stage.credentials", $scope.accountUpdated);
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/pipeline/stages/modifyScalingProcess/modifyScalingProcessStage.html", `<div class="form-horizontal">
  <div ng-if="!pipeline.strategy">
    <account-region-cluster-selector application="application" component="stage" accounts="accounts">
    </account-region-cluster-selector>
  </div>
  <stage-config-field label="Target">
    <target-select model="stage" options="targets"></target-select>
  </stage-config-field>
  <stage-config-field label="Action">
    <select
      class="form-control input-sm"
      required
      ng-model="stage.action"
      ng-options="a.val as a.label for a in actions"
    >
      <option>Select an action...</option>
    </select>
  </stage-config-field>
  <stage-config-field label="Processes" field-columns="8">
    <div class="checkbox" style="padding-left: 0">
      <checklist model="stage.processes" items="processes"></checklist>
    </div>
  </stage-config-field>
</div>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/pipeline/stages/modifyScalingProcess/modifyScalingProcessExecutionDetails.html", `<div ng-controller="BaseExecutionDetailsCtrl">
  <execution-details-section-nav sections="configSections"></execution-details-section-nav>
  <div class="step-section-details" ng-if="detailsSection === 'modifyScalingProcessesConfig'">
    <div class="row">
      <div class="col-md-9">
        <dl class="dl-narrow dl-horizontal">
          <dt>Account</dt>
          <dd><account-tag account="stage.context.credentials"></account-tag></dd>
          <dt>Region</dt>
          <dd>{{stage.context.region}}</dd>
          <dt>ASG Name</dt>
          <dd>{{stage.context.asgName}}</dd>
          <dt>Action</dt>
          <dd>{{stage.context.action}}</dd>
          <dt>Processes</dt>
          <dd>{{stage.context.processes.join(', ')}}</dd>
        </dl>
      </div>
    </div>
    <stage-failure-message stage="stage" message="stage.failureMessage"></stage-failure-message>

    <div class="row" ng-if="stage.context.execution.logs">
      <div class="col-md-12">
        <div class="well alert alert-info">
          <a target="_blank" href="{{stage.context.execution.logs}}"> View Execution Logs </a>
        </div>
      </div>
    </div>
  </div>

  <div class="step-section-details" ng-if="detailsSection === 'taskStatus'">
    <div class="row">
      <execution-step-details item="stage"></execution-step-details>
    </div>
  </div>
</div>
`);
}]);

const AMAZON_PIPELINE_STAGES_RESIZEASG_AWSRESIZEASGSTAGE = "spinnaker.amazon.pipeline.stage.aws.resizeAsgStage";
module(AMAZON_PIPELINE_STAGES_RESIZEASG_AWSRESIZEASGSTAGE, []).config(function() {
  Registry.pipeline.registerStage({
    provides: "resizeServerGroup",
    alias: "resizeAsg",
    cloudProvider: "aws",
    templateUrl: "amazon/src/pipeline/stages/resizeAsg/resizeAsgStage.html",
    executionStepLabelUrl: "amazon/src/pipeline/stages/resizeAsg/resizeAsgStepLabel.html",
    accountExtractor: (stage) => [stage.context.credentials],
    configAccountExtractor: (stage) => [stage.credentials],
    validators: [
      {
        type: "targetImpedance",
        message: "This pipeline will attempt to resize a server group without deploying a new version into the same cluster."
      },
      { type: "requiredField", fieldName: "target" },
      { type: "requiredField", fieldName: "action" },
      { type: "requiredField", fieldName: "regions" },
      { type: "requiredField", fieldName: "cluster" },
      { type: "requiredField", fieldName: "credentials", fieldLabel: "account" }
    ]
  });
}).controller("awsResizeAsgStageCtrl", [
  "$scope",
  function($scope) {
    const ctrl = this;
    const stage = $scope.stage;
    $scope.viewState = {
      accountsLoaded: false,
      regionsLoaded: false
    };
    AccountService.listAccounts("aws").then(function(accounts) {
      $scope.accounts = accounts;
      $scope.viewState.accountsLoaded = true;
    });
    $scope.resizeTargets = StageConstants.TARGET_LIST;
    $scope.scaleActions = [
      {
        label: "Scale Up",
        val: "scale_up"
      },
      {
        label: "Scale Down",
        val: "scale_down"
      },
      {
        label: "Scale to Cluster Size",
        val: "scale_to_cluster"
      },
      {
        label: "Scale to Exact Size",
        val: "scale_exact"
      }
    ];
    $scope.resizeTypes = [
      {
        label: "Percentage",
        val: "pct"
      },
      {
        label: "Incremental",
        val: "incr"
      }
    ];
    stage.capacity = stage.capacity || {};
    stage.regions = stage.regions || [];
    stage.target = stage.target || $scope.resizeTargets[0].val;
    stage.action = stage.action || $scope.scaleActions[0].val;
    stage.resizeType = stage.resizeType || $scope.resizeTypes[0].val;
    if (stage.targetHealthyDeployPercentage === void 0) {
      stage.targetHealthyDeployPercentage = 100;
    }
    if (!stage.action && stage.resizeType === "exact") {
      stage.action = "scale_exact";
    }
    stage.cloudProvider = "aws";
    if (stage.isNew && $scope.application.attributes.platformHealthOnlyShowOverride && $scope.application.attributes.platformHealthOnly) {
      stage.interestingHealthProviderNames = ["Amazon"];
    }
    if (!stage.credentials && $scope.application.defaultCredentials.aws) {
      stage.credentials = $scope.application.defaultCredentials.aws;
    }
    if (!stage.regions.length && $scope.application.defaultRegions.aws) {
      stage.regions.push($scope.application.defaultRegions.aws);
    }
    ctrl.updateResizeType = function() {
      if (stage.action === "scale_exact") {
        stage.resizeType = "exact";
        delete stage.scalePct;
        delete stage.scaleNum;
      } else {
        stage.capacity = {};
        if (stage.resizeType === "pct") {
          delete stage.scaleNum;
        } else {
          stage.resizeType = "incr";
          delete stage.scalePct;
          stage.scaleNum = stage.scaleNum || 0;
        }
      }
    };
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/pipeline/stages/resizeAsg/resizeAsgStage.html", `<div ng-controller="awsResizeAsgStageCtrl as resizeAsgStageCtrl">
  <div ng-if="!pipeline.strategy">
    <div ng-if="!viewState.accountsLoaded" class="horizontal center middle">
      <loading-spinner size="'small'"></loading-spinner>
    </div>
    <div ng-if="viewState.accountsLoaded">
      <account-region-cluster-selector application="application" component="stage" accounts="accounts">
      </account-region-cluster-selector>
    </div>
  </div>
  <stage-config-field label="Target">
    <target-select model="stage" options="resizeTargets"></target-select>
  </stage-config-field>
  <stage-config-field label="Action" help-key="pipeline.config.resizeAsg.action">
    <select
      class="form-control input-sm"
      required
      ng-model="stage.action"
      ng-change="resizeAsgStageCtrl.updateResizeType()"
      ng-options="a.val as a.label for a in scaleActions"
    >
      <option>Select an action...</option>
    </select>
  </stage-config-field>
  <div ng-if="stage.action !== 'scale_exact'">
    <stage-config-field label="{{stage.action === 'scale_to_cluster' ? 'Additional Capacity' : 'Type'}}">
      <select
        class="form-control input-sm"
        required
        ng-model="stage.resizeType"
        ng-change="resizeAsgStageCtrl.updateResizeType()"
        ng-options="t.val as t.label for t in resizeTypes"
      >
        <option>Select an action...</option>
      </select>
    </stage-config-field>
    <div ng-if="stage.resizeType === 'pct'">
      <stage-config-field label="Resize Percentage">
        <input type="number" min="0" ng-model="stage.scalePct" class="form-control input-sm" style="width: 80px" />
        <div>
          <em class="subinput-note"
            >This is the percentage by which the target server group's capacity will be increased</em
          >
        </div>
      </stage-config-field>
    </div>
    <div ng-if="stage.resizeType === 'incr'">
      <stage-config-field label="Resize-by Amount">
        <input type="number" min="0" ng-model="stage.scaleNum" class="form-control input-sm" style="width: 80px" />
        <div>
          <em class="subinput-note"
            >This is the exact amount by which the target server group's capacity will be increased</em
          >
        </div>
      </stage-config-field>
    </div>
    <div ng-if="stage.action === 'scale_up' || stage.action === 'scale_to_cluster'">
      <stage-config-field>
        <target-healthy-percentage-selector command="stage"></target-healthy-percentage-selector>
      </stage-config-field>
    </div>
  </div>
  <div ng-if="stage.action === 'scale_exact'">
    <stage-config-field class="small">
      <div class="row">
        <div class="col-md-3">Min</div>
        <div class="col-md-3">Max</div>
        <div class="col-md-3">Desired</div>
      </div>
    </stage-config-field>
    <stage-config-field label="Match Capacity">
      <div class="row">
        <div class="col-md-3">
          <input type="number" ng-model="stage.capacity.min" class="form-control input-sm" />
        </div>
        <div class="col-md-3">
          <input type="number" ng-model="stage.capacity.max" class="form-control input-sm" />
        </div>
        <div class="col-md-3">
          <input type="number" ng-model="stage.capacity.desired" class="form-control input-sm" />
        </div>
      </div>
    </stage-config-field>
    <stage-config-field>
      <em class="subinput-note">This is the exact amount to which the target server group will be scaled</em>
    </stage-config-field>
  </div>
  <stage-platform-health-override application="application" stage="stage" platform-health-type="'Amazon'">
  </stage-platform-health-override>
</div>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/pipeline/stages/resizeAsg/resizeAsgStepLabel.html", `<span class="task-label" ng-if="!step.context.useNameAsLabel">
  Resize Server Group: {{step.context.serverGroupName}} ({{step.context.region}})
</span>
<span class="task-label" ng-if="step.context.useNameAsLabel"> {{step.name}} </span>
`);
}]);

const AMAZON_PIPELINE_STAGES_ROLLBACKCLUSTER_AWSROLLBACKCLUSTERSTAGE = "spinnaker.amazon.pipeline.stage.rollbackClusterStage";
module(AMAZON_PIPELINE_STAGES_ROLLBACKCLUSTER_AWSROLLBACKCLUSTERSTAGE, []).config(function() {
  Registry.pipeline.registerStage({
    provides: "rollbackCluster",
    cloudProvider: "aws",
    templateUrl: "amazon/src/pipeline/stages/rollbackCluster/rollbackClusterStage.html",
    validators: [
      { type: "requiredField", fieldName: "cluster" },
      { type: "requiredField", fieldName: "regions" },
      { type: "requiredField", fieldName: "credentials", fieldLabel: "account" }
    ]
  });
}).controller("awsRollbackClusterStageCtrl", [
  "$scope",
  function($scope) {
    const ctrl = this;
    const stage = $scope.stage;
    $scope.state = {
      accounts: false,
      regionsLoaded: false
    };
    AccountService.listAccounts("aws").then(function(accounts) {
      $scope.accounts = accounts;
      $scope.state.accounts = true;
    });
    ctrl.reset = () => {
      ctrl.accountUpdated();
      ctrl.resetSelectedCluster();
    };
    stage.regions = stage.regions || [];
    stage.cloudProvider = "aws";
    stage.targetHealthyRollbackPercentage = stage.targetHealthyRollbackPercentage || 100;
    if (stage.isNew && $scope.application.attributes.platformHealthOnlyShowOverride && $scope.application.attributes.platformHealthOnly) {
      stage.interestingHealthProviderNames = ["Amazon"];
    }
    if (!stage.credentials && $scope.application.defaultCredentials.aws) {
      stage.credentials = $scope.application.defaultCredentials.aws;
    }
    if (!stage.regions.length && $scope.application.defaultRegions.aws) {
      stage.regions.push($scope.application.defaultRegions.aws);
    }
    $scope.viewState.dynamicRollbackTimeout = SETTINGS.feature.dynamicRollbackTimeout;
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/pipeline/stages/rollbackCluster/rollbackClusterStage.html", `<div ng-controller="awsRollbackClusterStageCtrl as rollbackClusterStageCtrl" class="form-horizontal">
  <div ng-if="!pipeline.strategy">
    <account-region-cluster-selector application="application" component="stage" accounts="accounts">
    </account-region-cluster-selector>
  </div>
  <stage-platform-health-override application="application" stage="stage" platform-health-type="'Amazon'">
  </stage-platform-health-override>

  <div class="row">
    <div class="col-sm-10 col-sm-offset-2" ng-if="stage.regions.length > 1">
      Wait
      <input
        type="number"
        min="0"
        ng-model="stage.waitTimeBetweenRegions"
        class="form-control input-sm inline-number"
      />
      seconds between regional rollbacks.
    </div>
    <div class="col-sm-10 col-sm-offset-2">
      Consider rollback successful when
      <input
        type="number"
        min="0"
        max="100"
        ng-model="stage.targetHealthyRollbackPercentage"
        class="form-control input-sm inline-number"
      />
      percent of instances are healthy.
    </div>
    <div class="col-sm-10 col-sm-offset-2" ng-if="viewState.dynamicRollbackTimeout">
      Rollback Timeout is
      <input
        type="number"
        min="0"
        max="100"
        ng-model="stage.rollbackTimeout"
        class="form-control input-sm inline-number"
      />
      minutes.
    </div>
  </div>
</div>
`);
}]);

const AMAZON_PIPELINE_STAGES_SCALEDOWNCLUSTER_AWSSCALEDOWNCLUSTERSTAGE = "spinnaker.amazon.pipeline.stage.scaleDownClusterStage";
module(AMAZON_PIPELINE_STAGES_SCALEDOWNCLUSTER_AWSSCALEDOWNCLUSTERSTAGE, []).config(function() {
  Registry.pipeline.registerStage({
    provides: "scaleDownCluster",
    cloudProvider: "aws",
    templateUrl: "amazon/src/pipeline/stages/scaleDownCluster/scaleDownClusterStage.html",
    accountExtractor: (stage) => [stage.context.credentials],
    configAccountExtractor: (stage) => [stage.credentials],
    validators: [
      { type: "requiredField", fieldName: "cluster" },
      {
        type: "requiredField",
        fieldName: "remainingFullSizeServerGroups",
        fieldLabel: "Keep [X] full size Server Groups"
      },
      { type: "requiredField", fieldName: "regions" },
      { type: "requiredField", fieldName: "credentials", fieldLabel: "account" }
    ],
    strategy: true
  });
}).controller("awsScaleDownClusterStageCtrl", [
  "$scope",
  function($scope) {
    const ctrl = this;
    const stage = $scope.stage;
    $scope.state = {
      accounts: false,
      regionsLoaded: false
    };
    AccountService.listAccounts("aws").then(function(accounts) {
      $scope.accounts = accounts;
      $scope.state.accounts = true;
    });
    stage.regions = stage.regions || [];
    stage.cloudProvider = "aws";
    if (!stage.credentials && $scope.application.defaultCredentials.aws) {
      stage.credentials = $scope.application.defaultCredentials.aws;
    }
    if (!stage.regions.length && $scope.application.defaultRegions.aws) {
      stage.regions.push($scope.application.defaultRegions.aws);
    }
    if (stage.remainingFullSizeServerGroups === void 0) {
      stage.remainingFullSizeServerGroups = 1;
    }
    if (stage.allowScaleDownActive === void 0) {
      stage.allowScaleDownActive = false;
    }
    ctrl.pluralize = function(str, val) {
      if (val === 1) {
        return str;
      }
      return str + "s";
    };
    if (stage.preferLargerOverNewer === void 0) {
      stage.preferLargerOverNewer = "false";
    }
    stage.preferLargerOverNewer = stage.preferLargerOverNewer.toString();
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/pipeline/stages/scaleDownCluster/scaleDownClusterStage.html", `<div ng-controller="awsScaleDownClusterStageCtrl as scaleDownClusterStageCtrl" class="form-horizontal">
  <div ng-if="!pipeline.strategy">
    <account-region-cluster-selector application="application" component="stage" accounts="accounts">
    </account-region-cluster-selector>
  </div>
  <stage-config-field label="Scale Down Options">
    <div class="form-inline">
      <p>
        Keep the
        <input
          type="number"
          min="0"
          required
          ng-model="stage.remainingFullSizeServerGroups"
          class="form-control input-sm"
          style="width: 50px"
        />
        <select class="form-control input-sm" ng-model="stage.preferLargerOverNewer" style="width: 100px">
          <option value="true">largest</option>
          <option value="false">newest</option>
        </select>
        {{scaleDownClusterStageCtrl.pluralize('server group', stage.remainingFullSizeServerGroups)}} at current size.
      </p>
      <p>The remaining server groups will be scaled down to zero instances.</p>
    </div>
  </stage-config-field>
  <div class="form-group">
    <div class="col-md-offset-3 col-md-6 checkbox">
      <label>
        <input type="checkbox" ng-model="stage.allowScaleDownActive" />
        Allow scale down of active server groups
      </label>
    </div>
  </div>
</div>
`);
}]);

const AMAZON_PIPELINE_STAGES_SHRINKCLUSTER_AWSSHRINKCLUSTERSTAGE = "spinnaker.amazon.pipeline.stage.aws.shrinkClusterStage";
module(AMAZON_PIPELINE_STAGES_SHRINKCLUSTER_AWSSHRINKCLUSTERSTAGE, []).config(function() {
  Registry.pipeline.registerStage({
    provides: "shrinkCluster",
    cloudProvider: "aws",
    templateUrl: "amazon/src/pipeline/stages/shrinkCluster/shrinkClusterStage.html",
    accountExtractor: (stage) => [stage.context.credentials],
    configAccountExtractor: (stage) => [stage.credentials],
    validators: [
      { type: "requiredField", fieldName: "cluster" },
      { type: "requiredField", fieldName: "shrinkToSize", fieldLabel: "shrink to [X] Server Groups" },
      { type: "requiredField", fieldName: "regions" },
      { type: "requiredField", fieldName: "credentials", fieldLabel: "account" }
    ]
  });
}).controller("awsShrinkClusterStageCtrl", [
  "$scope",
  function($scope) {
    const ctrl = this;
    const stage = $scope.stage;
    $scope.state = {
      accounts: false,
      regionsLoaded: false
    };
    AccountService.listAccounts("aws").then(function(accounts) {
      $scope.accounts = accounts;
      $scope.state.accounts = true;
    });
    stage.regions = stage.regions || [];
    stage.cloudProvider = "aws";
    if (!stage.credentials && $scope.application.defaultCredentials.aws) {
      stage.credentials = $scope.application.defaultCredentials.aws;
    }
    if (!stage.regions.length && $scope.application.defaultRegions.aws) {
      stage.regions.push($scope.application.defaultRegions.aws);
    }
    if (stage.shrinkToSize === void 0) {
      stage.shrinkToSize = 1;
    }
    if (stage.allowDeleteActive === void 0) {
      stage.allowDeleteActive = false;
    }
    ctrl.pluralize = function(str, val) {
      if (val === 1) {
        return str;
      }
      return str + "s";
    };
    if (stage.retainLargerOverNewer === void 0) {
      stage.retainLargerOverNewer = "false";
    }
    stage.retainLargerOverNewer = stage.retainLargerOverNewer.toString();
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/pipeline/stages/shrinkCluster/shrinkClusterStage.html", `<div ng-controller="awsShrinkClusterStageCtrl as shrinkClusterStageCtrl" class="form-horizontal">
  <div ng-if="!pipeline.strategy">
    <account-region-cluster-selector application="application" component="stage" accounts="accounts">
    </account-region-cluster-selector>
  </div>
  <stage-config-field label="Shrink Options">
    <div class="form-inline">
      Shrink to
      <input
        type="number"
        min="0"
        required
        ng-model="stage.shrinkToSize"
        class="form-control input-sm"
        style="width: 50px"
      />
      {{shrinkClusterStageCtrl.pluralize('server group', stage.shrinkToSize)}}, keeping the
      <select class="form-control input-sm" ng-model="stage.retainLargerOverNewer" style="width: 100px">
        <option value="true">largest</option>
        <option value="false">newest</option>
      </select>
    </div>
  </stage-config-field>
  <div class="form-group">
    <div class="col-md-offset-3 col-md-6 checkbox">
      <label>
        <input type="checkbox" ng-model="stage.allowDeleteActive" />
        Allow deletion of active server groups
      </label>
    </div>
  </div>
  <stage-platform-health-override application="application" stage="stage" platform-health-type="'Amazon'">
  </stage-platform-health-override>
</div>
`);
}]);

const AMAZON_PIPELINE_STAGES_TAGIMAGE_AWSTAGIMAGESTAGE = "spinnaker.amazon.pipeline.stage.tagImageStage";
module(AMAZON_PIPELINE_STAGES_TAGIMAGE_AWSTAGIMAGESTAGE, []).config(function() {
  Registry.pipeline.registerStage({
    provides: "upsertImageTags",
    cloudProvider: "aws",
    templateUrl: "amazon/src/pipeline/stages/tagImage/tagImageStage.html",
    executionDetailsUrl: "amazon/src/pipeline/stages/tagImage/tagImageExecutionDetails.html",
    executionConfigSections: ["tagImageConfig", "taskStatus"]
  });
}).controller("awsTagImageStageCtrl", [
  "$scope",
  ($scope) => {
    $scope.stage.tags = $scope.stage.tags || {};
    $scope.stage.cloudProvider = $scope.stage.cloudProvider || "aws";
    const initUpstreamStages = () => {
      const upstreamDependencies = PipelineConfigService.getAllUpstreamDependencies($scope.pipeline, $scope.stage).filter((stage) => StageConstants.IMAGE_PRODUCING_STAGES.includes(stage.type));
      $scope.consideredStages = new Map(upstreamDependencies.map((stage) => [stage.refId, stage.name]));
    };
    $scope.$watch("stage.requisiteStageRefIds", initUpstreamStages);
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/pipeline/stages/tagImage/tagImageStage.html", `<div ng-controller="awsTagImageStageCtrl as tagImageStageCtrl" class="form-horizontal">
  <stage-config-field label="Tags">
    <map-editor model="stage.tags" allow-empty="true"></map-editor>
  </stage-config-field>
  <stage-config-field label="Stages (optional)" help-key="aws.tagImage.consideredStages" help-key-expand="true">
    <div class="checkbox">
      <checklist model="stage.consideredStages" items="consideredStages"></checklist>
    </div>
  </stage-config-field>
</div>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/pipeline/stages/tagImage/tagImageExecutionDetails.html", `<div ng-controller="BaseExecutionDetailsCtrl">
  <execution-details-section-nav sections="configSections"></execution-details-section-nav>
  <div class="step-section-details" ng-if="detailsSection === 'tagImageConfig'">
    <div class="row" ng-if="stage.context.targets">
      <div class="col-md-12">
        <dl class="dl-narrow dl-horizontal">
          <dt if-multiple-providers>Provider</dt>
          <dd if-multiple-providers>Amazon</dd>
          <dt>Images</dt>
          <dd ng-repeat="target in stage.context.targets">
            {{target.imageName}}<br />
            <em>{{target.regions.join(', ')}}</em>
          </dd>
        </dl>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <dl class="dl-narrow dl-horizontal">
          <dt>Tags</dt>
          <dd ng-repeat="(key, val) in stage.context.tags" ng-if="val !== null">{{key}} = {{val}}</dd>
          <dt ng-if="stage.context.consideredStages">Stages</dt>
          <dd ng-repeat="consideredStage in stage.context.consideredStages">
            <stage-name stages="execution.stages" ref-id="consideredStage"></stage-name>
          </dd>
        </dl>
      </div>
    </div>

    <stage-failure-message stage="stage" message="stage.failureMessage"></stage-failure-message>
  </div>

  <div class="step-section-details" ng-if="detailsSection === 'taskStatus'">
    <div class="row">
      <execution-step-details item="stage"></execution-step-details>
    </div>
  </div>
</div>
`);
}]);

const AWS_REACT_MODULE = "spinnaker.amazon.react";
module(AWS_REACT_MODULE, []).run([
  "$injector",
  function($injector) {
    AwsReactInjector.initialize($injector);
  }
]);

const AMAZON_SEARCH_SEARCHRESULTFORMATTER = "spinnaker.amazon.search.searchResultFormatter";
module(AMAZON_SEARCH_SEARCHRESULTFORMATTER, []).factory("awsSearchResultFormatter", function() {
  return {
    securityGroups: function(entry) {
      return VpcReader.getVpcName(entry.vpcId).then(function(vpcName) {
        const region = vpcName ? entry.region + " - " + vpcName.toLowerCase() : entry.region;
        return entry.name + " (" + region + ")";
      });
    }
  };
});

const AMAZON_SECURITYGROUP_CONFIGURE_CONFIGSECURITYGROUP_MIXIN_CONTROLLER = "spinnaker.amazon.securityGroup.baseConfig.controller";
module(AMAZON_SECURITYGROUP_CONFIGURE_CONFIGSECURITYGROUP_MIXIN_CONTROLLER, [
  UIROUTER_ANGULARJS,
  SECURITY_GROUP_READER
]).controller("awsConfigSecurityGroupMixin", [
  "$scope",
  "$state",
  "$uibModalInstance",
  "application",
  "securityGroup",
  "securityGroupReader",
  "cacheInitializer",
  function($scope, $state, $uibModalInstance, application, securityGroup, securityGroupReader, cacheInitializer) {
    let allSecurityGroups;
    const ctrl = this;
    $scope.self = $scope;
    $scope.application = application;
    $scope.customComponentIsvalid = true;
    $scope.state = {
      submitting: false,
      regionError: void 0,
      refreshingSecurityGroups: false,
      removedRules: [],
      infiniteScroll: {
        numToAdd: 20,
        currentItems: 20
      }
    };
    $scope.allVpcs = [];
    $scope.wizard = ModalWizard;
    $scope.hideClassic = false;
    ctrl.addMoreItems = function() {
      $scope.state.infiniteScroll.currentItems += $scope.state.infiniteScroll.numToAdd;
    };
    const getAccount = () => $scope.securityGroup.accountName || $scope.securityGroup.credentials;
    function onApplicationRefresh() {
      if ($scope.$$destroyed) {
        return;
      }
      $uibModalInstance.close();
      const newStateParams = {
        name: $scope.securityGroup.name,
        accountId: getAccount(),
        region: $scope.securityGroup.regions[0],
        vpcId: $scope.securityGroup.vpcId,
        provider: "aws"
      };
      if (!$state.includes("**.firewallDetails")) {
        $state.go(".firewallDetails", newStateParams);
      } else {
        $state.go("^.firewallDetails", newStateParams);
      }
    }
    function onTaskComplete() {
      application.securityGroups.refresh();
      application.securityGroups.onNextRefresh($scope, onApplicationRefresh);
    }
    $scope.taskMonitor = new TaskMonitor({
      application,
      title: `Creating your ${FirewallLabels.get("firewall")}`,
      modalInstance: $uibModalInstance,
      onTaskComplete
    });
    $scope.securityGroup = securityGroup;
    ctrl.initializeAccounts = () => {
      return AccountService.listAllAccounts("aws").then(function(accounts) {
        $scope.accounts = accounts.filter((a) => a.authorized !== false);
        $scope.allAccounts = accounts;
        ctrl.accountUpdated();
      });
    };
    ctrl.upsert = function() {
      $scope.taskMonitor.submit(function() {
        return SecurityGroupWriter.upsertSecurityGroup($scope.securityGroup, application, "Create");
      });
    };
    function clearSecurityGroups() {
      $scope.availableSecurityGroups = [];
      $scope.existingSecurityGroupNames = [];
    }
    ctrl.accountUpdated = function() {
      const securityGroup2 = $scope.securityGroup;
      securityGroup2.account = securityGroup2.accountId = securityGroup2.accountName = securityGroup2.credentials;
      AccountService.getRegionsForAccount(getAccount()).then((regions) => {
        $scope.regions = regions.map((region) => region.name);
        clearSecurityGroups();
        ctrl.regionUpdated();
        if ($scope.state.isNew) {
          ctrl.updateName();
        }
      });
    };
    ctrl.regionUpdated = function() {
      const account = getAccount();
      const regions = $scope.securityGroup.regions || [];
      VpcReader.listVpcs().then(function(vpcs) {
        const vpcsByName = _.groupBy(vpcs.filter((vpc) => vpc.account === account), "label");
        $scope.allVpcs = vpcs;
        const available = [];
        _.forOwn(vpcsByName, function(vpcsToTest, label) {
          const foundInAllRegions = regions.every((region) => {
            return vpcsToTest.some((test) => test.region === region && test.account === account);
          });
          if (foundInAllRegions) {
            available.push({
              ids: vpcsToTest.filter((t) => regions.includes(t.region)).map((vpc) => vpc.id),
              label,
              deprecated: vpcsToTest[0].deprecated
            });
          }
        });
        $scope.activeVpcs = available.filter(function(vpc) {
          return !vpc.deprecated;
        });
        $scope.deprecatedVpcs = available.filter(function(vpc) {
          return vpc.deprecated;
        });
        $scope.vpcs = available;
        $scope.state.regionError = $scope.state.isClone && ($scope.securityGroup.regions || []).includes($scope.state.originRegion);
        ctrl.updateVpcId(available);
      });
    };
    this.updateVpcId = (available) => {
      const lockoutDate = AWSProviderSettings.classicLaunchLockout;
      if (!securityGroup.id && lockoutDate) {
        const createTs = Number(_.get(application, "attributes.createTs", 0));
        if (createTs >= lockoutDate) {
          $scope.hideClassic = true;
          if (!securityGroup.vpcId && available.length) {
            let defaultMatch;
            if (AWSProviderSettings.defaults.vpc) {
              const match2 = available.find((vpc) => vpc.label === AWSProviderSettings.defaults.vpc);
              if (match2) {
                defaultMatch = match2.ids[0];
              }
            }
            securityGroup.vpcId = defaultMatch || ($scope.activeVpcs.length ? $scope.activeVpcs[0].ids[0] : available[0].ids[0]);
          }
        }
      }
      const selectedVpc = $scope.allVpcs.find((vpc) => vpc.id === $scope.securityGroup.vpcId);
      const match = (available || []).find((vpc) => selectedVpc && selectedVpc.label === vpc.label);
      const defaultVpc = (available || []).find((vpc) => AWSProviderSettings.defaults.vpc === vpc.label) || ($scope.activeVpcs || [])[0];
      $scope.securityGroup.vpcId = match && match.ids[0] || defaultVpc && defaultVpc.ids[0];
      this.vpcUpdated();
    };
    this.vpcUpdated = function() {
      const account = getAccount();
      const regions = $scope.securityGroup.regions;
      if (account && regions.length) {
        configureFilteredSecurityGroups();
      } else {
        clearSecurityGroups();
      }
      $scope.coordinatesChanged.next();
    };
    function configureFilteredSecurityGroups() {
      const vpcId = $scope.securityGroup.vpcId || null;
      const account = getAccount();
      const regions = $scope.securityGroup.regions || [];
      let existingSecurityGroupNames = [];
      let availableSecurityGroups = [];
      regions.forEach(function(region) {
        let regionalVpcId = null;
        if (vpcId) {
          const baseVpc = _.find($scope.allVpcs, { id: vpcId });
          regionalVpcId = _.find($scope.allVpcs, { account, region, name: baseVpc.name }).id;
        }
        const regionalGroupNames = _.get(allSecurityGroups, [account, "aws", region].join("."), []).filter((sg) => sg.vpcId === regionalVpcId).map((sg) => sg.name);
        existingSecurityGroupNames = _.uniq(existingSecurityGroupNames.concat(regionalGroupNames));
        if (!availableSecurityGroups.length) {
          availableSecurityGroups = existingSecurityGroupNames;
        } else {
          availableSecurityGroups = _.intersection(availableSecurityGroups, regionalGroupNames);
        }
      });
      $scope.availableSecurityGroups = availableSecurityGroups;
      $scope.existingSecurityGroupNames = existingSecurityGroupNames;
      $scope.state.securityGroupsLoaded = true;
      clearInvalidSecurityGroups();
    }
    ctrl.mixinUpsert = function(descriptor) {
      $scope.taskMonitor.submit(function() {
        return SecurityGroupWriter.upsertSecurityGroup($scope.securityGroup, application, descriptor);
      });
    };
    function clearInvalidSecurityGroups() {
      const removed = $scope.state.removedRules;
      const securityGroup2 = $scope.securityGroup;
      $scope.securityGroup.securityGroupIngress = (securityGroup2.securityGroupIngress || []).filter((rule) => {
        if (rule.accountName && rule.vpcId && (rule.accountName !== securityGroup2.accountName || rule.vpcId !== securityGroup2.vpcId)) {
          return true;
        }
        if (rule.name && !$scope.availableSecurityGroups.includes(rule.name) && !removed.includes(rule.name)) {
          removed.push(rule.name);
          return false;
        }
        return true;
      });
      if (removed.length) {
        ModalWizard.markDirty("Ingress");
      }
    }
    ctrl.refreshSecurityGroups = function() {
      $scope.state.refreshingSecurityGroups = true;
      return cacheInitializer.refreshCache("securityGroups").then(function() {
        return ctrl.initializeSecurityGroups().then(function() {
          ctrl.vpcUpdated();
          $scope.state.refreshingSecurityGroups = false;
          setSecurityGroupRefreshTime();
        });
      });
    };
    function setSecurityGroupRefreshTime() {
      $scope.state.refreshTime = InfrastructureCaches.get("securityGroups").getStats().ageMax;
    }
    allSecurityGroups = {};
    $scope.allSecurityGroupsUpdated = new Subject();
    $scope.coordinatesChanged = new Subject();
    ctrl.initializeSecurityGroups = function() {
      return securityGroupReader.getAllSecurityGroups().then(function(securityGroups) {
        setSecurityGroupRefreshTime();
        allSecurityGroups = securityGroups;
        const account = $scope.securityGroup.credentials || $scope.securityGroup.accountName;
        const region = $scope.securityGroup.regions[0];
        const vpcId = $scope.securityGroup.vpcId || null;
        let availableGroups;
        if (account && region) {
          availableGroups = _.filter(securityGroups[account].aws[region], { vpcId });
        } else {
          availableGroups = securityGroups;
        }
        $scope.availableSecurityGroups = _.map(availableGroups, "name");
        const securityGroupExclusions = AWSProviderSettings.securityGroupExclusions;
        $scope.allSecurityGroups = securityGroupExclusions ? filterObjectValues(securityGroups, (name2) => !securityGroupExclusions.includes(name2)) : securityGroups;
        $scope.allSecurityGroupsUpdated.next();
        $scope.state.regionError = $scope.state.isClone && ($scope.securityGroup.regions || []).includes($scope.state.originRegion);
      });
    };
    ctrl.cancel = function() {
      $uibModalInstance.dismiss();
    };
    const classicPattern = /^[\x20-\x7F]+$/;
    const vpcPattern = /^[a-zA-Z0-9\s._\-:/()#,@[\]+=&;{}!$*]+$/;
    ctrl.getCurrentNamePattern = function() {
      return $scope.securityGroup.vpcId ? vpcPattern : classicPattern;
    };
    ctrl.updateName = function() {
      const { securityGroup: securityGroup2 } = $scope;
      const appName = application.isStandalone ? application.name.split("-")[0] : application.name;
      const name2 = NameUtils.getClusterName(appName, securityGroup2.stack, securityGroup2.detail);
      securityGroup2.name = name2;
      $scope.namePreview = name2;
    };
    ctrl.namePattern = {
      test: function(name2) {
        return ctrl.getCurrentNamePattern().test(name2);
      }
    };
    ctrl.addRule = function(ruleset) {
      ruleset.push({
        type: "tcp",
        startPort: 7001,
        endPort: 7001
      });
    };
    ctrl.removeRule = function(ruleset, index) {
      ruleset.splice(index, 1);
    };
    ctrl.updateRuleType = function(type, ruleset, index) {
      const rule = ruleset[index];
      if (type === "icmp" || type === "icmpv6") {
        rule.startPort = 0;
        rule.endPort = 0;
      }
    };
    ctrl.dismissRemovedRules = function() {
      $scope.state.removedRules = [];
      ModalWizard.markClean("Ingress");
      ModalWizard.markComplete("Ingress");
    };
  }
]);

const AMAZON_SECURITYGROUP_CLONE_CLONESECURITYGROUP_CONTROLLER = "spinnaker.amazon.securityGroup.clone.controller";
angular.module(AMAZON_SECURITYGROUP_CLONE_CLONESECURITYGROUP_CONTROLLER, [
  AMAZON_SECURITYGROUP_CONFIGURE_CONFIGSECURITYGROUP_MIXIN_CONTROLLER
]).controller("awsCloneSecurityGroupController", [
  "$scope",
  "$uibModalInstance",
  "$controller",
  "securityGroup",
  "application",
  function($scope, $uibModalInstance, $controller, securityGroup, application) {
    const vm = this;
    vm.firewallLabel = FirewallLabels.get("Firewall");
    $scope.pages = {
      location: "amazon/src/securityGroup/configure/createSecurityGroupProperties.html",
      ingress: "amazon/src/securityGroup/configure/createSecurityGroupIngress.html"
    };
    securityGroup.credentials = securityGroup.accountName;
    $scope.namePreview = securityGroup.name;
    angular.extend(this, $controller("awsConfigSecurityGroupMixin", {
      $scope,
      $uibModalInstance,
      application,
      securityGroup
    }));
    $scope.state.isNew = true;
    $scope.allowDuplicateNames = true;
    $scope.state.isClone = true;
    $scope.state.originRegion = securityGroup.regions && securityGroup.regions[0];
    AccountService.listAccounts("aws").then(function(accounts) {
      $scope.accounts = accounts;
      vm.accountUpdated();
    });
    securityGroup.securityGroupIngress = _.chain(securityGroup.inboundRules).filter(function(rule) {
      return rule.securityGroup;
    }).map(function(rule) {
      return rule.portRanges.map(function(portRange) {
        return {
          name: rule.securityGroup.name,
          type: rule.protocol,
          startPort: portRange.startPort,
          endPort: portRange.endPort
        };
      });
    }).flatten().value();
    securityGroup.ipIngress = _.chain(securityGroup.inboundRules).filter(function(rule) {
      return rule.range;
    }).map(function(rule) {
      return rule.portRanges.map(function(portRange) {
        return {
          cidr: rule.range.ip + rule.range.cidr,
          type: rule.protocol,
          startPort: portRange.startPort,
          endPort: portRange.endPort
        };
      });
    }).flatten().value();
    vm.upsert = function() {
      const { credentials } = $scope.securityGroup;
      Object.assign($scope.securityGroup, {
        account: credentials,
        accountName: credentials,
        accountId: credentials
      });
      vm.mixinUpsert("Clone");
    };
    vm.initializeSecurityGroups().then(vm.initializeAccounts);
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/securityGroup/configure/createSecurityGroupProperties.html", `<div class="container-fluid form-horizontal">
  <div class="modal-body">
    <div class="form-group">
      <div
        class="col-md-12 well"
        ng-class="{'alert-danger': form.securityGroupName.$error.validateUnique, 'alert-info': !form.securityGroupName.$error.validateUnique}"
      >
        <strong>Your <firewall-label label="firewall"></firewall-label> will be named:</strong>
        <span ng-bind="namePreview"></span>
        <help-field key="aws.securityGroup.name"></help-field>
        <input
          type="hidden"
          class="form-control input-sm"
          ng-model="securityGroup.name"
          ng-model-options="{allowInvalid: true}"
          validate-unique="{{allowDuplicateNames ? '' : 'existingSecurityGroupNames'}}"
          validate-ignore-case="true"
          name="securityGroupName"
          ng-pattern="ctrl.namePattern"
          trigger-validation="securityGroup.subnet"
          required
        />
        <validation-error
          ng-if="form.securityGroupName.$error.validateUnique && securityGroup.credentials"
          message="A {{ctrl.translate('firewall')}} named '{{namePreview}}' already exists in one or more of the selected regions. Use a unique stack and detail to create a new {{ctrl.translate('firewall')}}."
        ></validation-error>
        <validation-error
          ng-if="form.securityGroupName.$error.pattern"
          message="Name must match {{ctrl.getCurrentNamePattern().toString()}}"
        ></validation-error>
      </div>
    </div>
    <div class="form-group">
      <div class="col-md-3 sm-label-right">Account</div>
      <div class="col-md-8">
        <account-select-field
          component="securityGroup"
          field="credentials"
          accounts="accounts"
          provider="'aws'"
          on-change="ctrl.accountUpdated()"
        ></account-select-field>
      </div>
    </div>
    <div class="form-group">
      <div class="col-md-3 sm-label-right">Regions</div>
      <div class="col-md-8">
        <input type="hidden" ng-model="securityGroup.regions[0]" required />
        <checklist
          ng-if="securityGroup.credentials"
          items="regions"
          model="securityGroup.regions"
          inline="true"
          on-change="ctrl.regionUpdated()"
        ></checklist>
        <p class="form-control-static" ng-if="!securityGroup.credentials">(Select an account)</p>
        <validation-error
          ng-if="state.regionError"
          message="A security group cannot be cloned into a region it already exists in. Please deselect '{{state.originRegion}}' to clear this error."
        ></validation-error>
      </div>
    </div>
    <div class="form-group">
      <div class="col-md-3 sm-label-right">Stack</div>
      <div class="col-md-3">
        <input
          type="text"
          class="form-control input-sm no-spel"
          ng-model="securityGroup.stack"
          ng-change="ctrl.updateName()"
        />
      </div>
      <div class="col-md-2 sm-label-right">Detail</div>
      <div class="col-md-3">
        <input
          type="text"
          class="form-control input-sm no-spel"
          ng-model="securityGroup.detail"
          ng-change="ctrl.updateName()"
        />
      </div>
    </div>
    <div class="form-group">
      <div class="col-md-3 sm-label-right">Description (required)</div>
      <div class="col-md-8">
        <textarea required cols="2" class="form-control input-sm no-spel" ng-model="securityGroup.description">
        </textarea>
      </div>
    </div>
    <div class="form-group">
      <div class="col-md-3 sm-label-right">VPC <help-field key="aws.securityGroup.vpc"></help-field></div>
      <div class="col-md-8">
        <select
          class="form-control input-sm"
          ng-model="securityGroup.vpcId"
          ng-change="ctrl.vpcUpdated()"
          ng-if="securityGroup.regions.length"
        >
          <option value="" ng-if="!hideClassic">None (EC2 Classic)</option>
          <option
            ng-repeat="vpc in activeVpcs | orderBy: 'label'"
            value="{{vpc.ids[0]}}"
            ng-selected="securityGroup.vpcId === vpc.ids[0]"
          >
            {{vpc.label}}
          </option>
          <option ng-if="activeVpcs.length && deprecatedVpcs.length" disabled>---------------</option>
          <option
            ng-repeat="vpc in deprecatedVpcs | orderBy: 'label'"
            value="{{vpc.ids[0]}}"
            ng-selected="securityGroup.vpcId === vpc.ids[0]"
          >
            {{vpc.label}}
          </option>
        </select>
        <p class="form-control-static" ng-if="!securityGroup.credentials">(Select an account)</p>
        <p class="form-control-static" ng-if="securityGroup.credentials && !securityGroup.regions.length">
          (Select at least one region)
        </p>
      </div>
    </div>
  </div>
</div>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/securityGroup/configure/createSecurityGroupIngress.html", `<div class="container-fluid form-horizontal">
  <div class="modal-body">
    <div class="row">
      <div class="col-md-12" ng-if="state.removedRules.length">
        <div class="alert alert-danger">
          <p>
            <i class="fa fa-exclamation-triangle"></i> The following
            <firewall-label label="firewalls"></firewall-label> could not be found in the selected account/region/VPC
            and were removed:
          </p>
          <ul>
            <li ng-repeat="securityGroup in state.removedRules">{{securityGroup}}</li>
          </ul>
          <p class="text-right">
            <a class="btn btn-sm btn-primary dirty-flag-dismiss" href ng-click="ctrl.dismissRemovedRules()">Okay</a>
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <p class="info">
          <span class="glyphicon glyphicon-info-sign"></span> IP range rules can only be edited through the AWS Console.
        </p>
      </div>
    </div>
    <div class="form-group">
      <div class="col-md-12">
        <table class="table table-condensed packed">
          <thead>
            <tr>
              <th style="width: 50%"><firewall-label label="Firewall"></firewall-label></th>
              <th style="width: 15%">Protocol</th>
              <th style="width: 15%">Start Port</th>
              <th style="width: 15%">End Port</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat="rule in securityGroup.securityGroupIngress">
              <td>
                <ingress-rule-group-selector
                  rule="rule"
                  ng-if="state.securityGroupsLoaded"
                  security-group="securityGroup"
                  vpcs="allVpcs"
                  accounts="allAccounts"
                  all-security-groups="allSecurityGroups"
                  coordinates-changed="coordinatesChanged"
                  all-security-groups-updated="allSecurityGroupsUpdated"
                ></ingress-rule-group-selector>
              </td>
              <td>
                <select
                  class="form-control input-sm"
                  ng-model="rule.type"
                  ng-options="protocol as protocol.toUpperCase() for protocol in ['tcp', 'udp', 'icmp', 'icmpv6']"
                  ng-change="ctrl.updateRuleType(rule.type, securityGroup.securityGroupIngress, $index)"
                  required
                ></select>
              </td>
              <td><input class="form-control input-sm" type="number" min="0" ng-model="rule.startPort" required /></td>
              <td><input class="form-control input-sm" type="number" min="0" ng-model="rule.endPort" required /></td>
              <td>
                <a class="sm-label" ng-click="ctrl.removeRule(securityGroup.securityGroupIngress, $index)">
                  <span class="glyphicon glyphicon-trash"></span
                ></a>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="5">
                <button class="add-new col-md-12" ng-click="ctrl.addRule(securityGroup.securityGroupIngress)">
                  <span class="glyphicon glyphicon-plus-sign"></span> Add new
                  <firewall-label label="Firewall"></firewall-label> Rule
                </button>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
    <div class="form-group small" style="margin-top: 20px">
      <div class="col-md-12">
        <p>
          <span ng-if="state.refreshingSecurityGroups"><span class="fa fa-sync-alt fa-spin"></span></span>
          <firewall-label label="Firewalls"></firewall-label>
          <span ng-if="!state.refreshingSecurityGroups">last refreshed {{ state.refreshTime | timestamp }}</span>
          <span ng-if="state.refreshingSecurityGroups"> refreshing...</span>
        </p>
        <p>
          If you're not finding a <firewall-label label="firewall"></firewall-label> that was recently added,
          <a href ng-click="ctrl.refreshSecurityGroups()">click here</a> to refresh the list.
        </p>
      </div>
    </div>
    <security-group-details-custom security-group-details="securityGroup" ctrl="ctrl" scope="self" />
  </div>
</div>
`);
}]);

const AMAZON_SECURITYGROUP_CONFIGURE_CREATESECURITYGROUPCTRL = "spinnaker.amazon.securityGroup.create.controller";
angular.module(AMAZON_SECURITYGROUP_CONFIGURE_CREATESECURITYGROUPCTRL, [UIROUTER_ANGULARJS, CACHE_INITIALIZER_SERVICE]).controller("awsCreateSecurityGroupCtrl", [
  "$scope",
  "$uibModalInstance",
  "$state",
  "$controller",
  "cacheInitializer",
  "application",
  "securityGroup",
  function($scope, $uibModalInstance, $state, $controller, cacheInitializer, application, securityGroup) {
    $scope.pages = {
      location: "amazon/src/securityGroup/configure/createSecurityGroupProperties.html",
      ingress: "amazon/src/securityGroup/configure/createSecurityGroupIngress.html"
    };
    const ctrl = this;
    ctrl.translate = (label) => FirewallLabels.get(label);
    angular.extend(this, $controller("awsConfigSecurityGroupMixin", {
      $scope,
      $uibModalInstance,
      application,
      securityGroup
    }));
    $scope.state.isNew = true;
    ctrl.upsert = () => ctrl.mixinUpsert("Create");
    ctrl.initializeSecurityGroups().then(ctrl.initializeAccounts);
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/securityGroup/configure/createSecurityGroupProperties.html", `<div class="container-fluid form-horizontal">
  <div class="modal-body">
    <div class="form-group">
      <div
        class="col-md-12 well"
        ng-class="{'alert-danger': form.securityGroupName.$error.validateUnique, 'alert-info': !form.securityGroupName.$error.validateUnique}"
      >
        <strong>Your <firewall-label label="firewall"></firewall-label> will be named:</strong>
        <span ng-bind="namePreview"></span>
        <help-field key="aws.securityGroup.name"></help-field>
        <input
          type="hidden"
          class="form-control input-sm"
          ng-model="securityGroup.name"
          ng-model-options="{allowInvalid: true}"
          validate-unique="{{allowDuplicateNames ? '' : 'existingSecurityGroupNames'}}"
          validate-ignore-case="true"
          name="securityGroupName"
          ng-pattern="ctrl.namePattern"
          trigger-validation="securityGroup.subnet"
          required
        />
        <validation-error
          ng-if="form.securityGroupName.$error.validateUnique && securityGroup.credentials"
          message="A {{ctrl.translate('firewall')}} named '{{namePreview}}' already exists in one or more of the selected regions. Use a unique stack and detail to create a new {{ctrl.translate('firewall')}}."
        ></validation-error>
        <validation-error
          ng-if="form.securityGroupName.$error.pattern"
          message="Name must match {{ctrl.getCurrentNamePattern().toString()}}"
        ></validation-error>
      </div>
    </div>
    <div class="form-group">
      <div class="col-md-3 sm-label-right">Account</div>
      <div class="col-md-8">
        <account-select-field
          component="securityGroup"
          field="credentials"
          accounts="accounts"
          provider="'aws'"
          on-change="ctrl.accountUpdated()"
        ></account-select-field>
      </div>
    </div>
    <div class="form-group">
      <div class="col-md-3 sm-label-right">Regions</div>
      <div class="col-md-8">
        <input type="hidden" ng-model="securityGroup.regions[0]" required />
        <checklist
          ng-if="securityGroup.credentials"
          items="regions"
          model="securityGroup.regions"
          inline="true"
          on-change="ctrl.regionUpdated()"
        ></checklist>
        <p class="form-control-static" ng-if="!securityGroup.credentials">(Select an account)</p>
        <validation-error
          ng-if="state.regionError"
          message="A security group cannot be cloned into a region it already exists in. Please deselect '{{state.originRegion}}' to clear this error."
        ></validation-error>
      </div>
    </div>
    <div class="form-group">
      <div class="col-md-3 sm-label-right">Stack</div>
      <div class="col-md-3">
        <input
          type="text"
          class="form-control input-sm no-spel"
          ng-model="securityGroup.stack"
          ng-change="ctrl.updateName()"
        />
      </div>
      <div class="col-md-2 sm-label-right">Detail</div>
      <div class="col-md-3">
        <input
          type="text"
          class="form-control input-sm no-spel"
          ng-model="securityGroup.detail"
          ng-change="ctrl.updateName()"
        />
      </div>
    </div>
    <div class="form-group">
      <div class="col-md-3 sm-label-right">Description (required)</div>
      <div class="col-md-8">
        <textarea required cols="2" class="form-control input-sm no-spel" ng-model="securityGroup.description">
        </textarea>
      </div>
    </div>
    <div class="form-group">
      <div class="col-md-3 sm-label-right">VPC <help-field key="aws.securityGroup.vpc"></help-field></div>
      <div class="col-md-8">
        <select
          class="form-control input-sm"
          ng-model="securityGroup.vpcId"
          ng-change="ctrl.vpcUpdated()"
          ng-if="securityGroup.regions.length"
        >
          <option value="" ng-if="!hideClassic">None (EC2 Classic)</option>
          <option
            ng-repeat="vpc in activeVpcs | orderBy: 'label'"
            value="{{vpc.ids[0]}}"
            ng-selected="securityGroup.vpcId === vpc.ids[0]"
          >
            {{vpc.label}}
          </option>
          <option ng-if="activeVpcs.length && deprecatedVpcs.length" disabled>---------------</option>
          <option
            ng-repeat="vpc in deprecatedVpcs | orderBy: 'label'"
            value="{{vpc.ids[0]}}"
            ng-selected="securityGroup.vpcId === vpc.ids[0]"
          >
            {{vpc.label}}
          </option>
        </select>
        <p class="form-control-static" ng-if="!securityGroup.credentials">(Select an account)</p>
        <p class="form-control-static" ng-if="securityGroup.credentials && !securityGroup.regions.length">
          (Select at least one region)
        </p>
      </div>
    </div>
  </div>
</div>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/securityGroup/configure/createSecurityGroupIngress.html", `<div class="container-fluid form-horizontal">
  <div class="modal-body">
    <div class="row">
      <div class="col-md-12" ng-if="state.removedRules.length">
        <div class="alert alert-danger">
          <p>
            <i class="fa fa-exclamation-triangle"></i> The following
            <firewall-label label="firewalls"></firewall-label> could not be found in the selected account/region/VPC
            and were removed:
          </p>
          <ul>
            <li ng-repeat="securityGroup in state.removedRules">{{securityGroup}}</li>
          </ul>
          <p class="text-right">
            <a class="btn btn-sm btn-primary dirty-flag-dismiss" href ng-click="ctrl.dismissRemovedRules()">Okay</a>
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <p class="info">
          <span class="glyphicon glyphicon-info-sign"></span> IP range rules can only be edited through the AWS Console.
        </p>
      </div>
    </div>
    <div class="form-group">
      <div class="col-md-12">
        <table class="table table-condensed packed">
          <thead>
            <tr>
              <th style="width: 50%"><firewall-label label="Firewall"></firewall-label></th>
              <th style="width: 15%">Protocol</th>
              <th style="width: 15%">Start Port</th>
              <th style="width: 15%">End Port</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat="rule in securityGroup.securityGroupIngress">
              <td>
                <ingress-rule-group-selector
                  rule="rule"
                  ng-if="state.securityGroupsLoaded"
                  security-group="securityGroup"
                  vpcs="allVpcs"
                  accounts="allAccounts"
                  all-security-groups="allSecurityGroups"
                  coordinates-changed="coordinatesChanged"
                  all-security-groups-updated="allSecurityGroupsUpdated"
                ></ingress-rule-group-selector>
              </td>
              <td>
                <select
                  class="form-control input-sm"
                  ng-model="rule.type"
                  ng-options="protocol as protocol.toUpperCase() for protocol in ['tcp', 'udp', 'icmp', 'icmpv6']"
                  ng-change="ctrl.updateRuleType(rule.type, securityGroup.securityGroupIngress, $index)"
                  required
                ></select>
              </td>
              <td><input class="form-control input-sm" type="number" min="0" ng-model="rule.startPort" required /></td>
              <td><input class="form-control input-sm" type="number" min="0" ng-model="rule.endPort" required /></td>
              <td>
                <a class="sm-label" ng-click="ctrl.removeRule(securityGroup.securityGroupIngress, $index)">
                  <span class="glyphicon glyphicon-trash"></span
                ></a>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="5">
                <button class="add-new col-md-12" ng-click="ctrl.addRule(securityGroup.securityGroupIngress)">
                  <span class="glyphicon glyphicon-plus-sign"></span> Add new
                  <firewall-label label="Firewall"></firewall-label> Rule
                </button>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
    <div class="form-group small" style="margin-top: 20px">
      <div class="col-md-12">
        <p>
          <span ng-if="state.refreshingSecurityGroups"><span class="fa fa-sync-alt fa-spin"></span></span>
          <firewall-label label="Firewalls"></firewall-label>
          <span ng-if="!state.refreshingSecurityGroups">last refreshed {{ state.refreshTime | timestamp }}</span>
          <span ng-if="state.refreshingSecurityGroups"> refreshing...</span>
        </p>
        <p>
          If you're not finding a <firewall-label label="firewall"></firewall-label> that was recently added,
          <a href ng-click="ctrl.refreshSecurityGroups()">click here</a> to refresh the list.
        </p>
      </div>
    </div>
    <security-group-details-custom security-group-details="securityGroup" ctrl="ctrl" scope="self" />
  </div>
</div>
`);
}]);

const AMAZON_SECURITYGROUP_CONFIGURE_EDITSECURITYGROUPCTRL = "spinnaker.amazon.securityGroup.edit.controller";
angular.module(AMAZON_SECURITYGROUP_CONFIGURE_EDITSECURITYGROUPCTRL, [UIROUTER_ANGULARJS]).controller("awsEditSecurityGroupCtrl", [
  "$scope",
  "$uibModalInstance",
  "$state",
  "application",
  "securityGroup",
  "$controller",
  function($scope, $uibModalInstance, $state, application, securityGroup, $controller) {
    $scope.self = $scope;
    $scope.pages = {
      ingress: "amazon/src/securityGroup/configure/createSecurityGroupIngress.html"
    };
    $scope.securityGroup = securityGroup;
    $scope.state = {
      refreshingSecurityGroups: false
    };
    $scope.securityGroup.regions = [$scope.securityGroup.region];
    $scope.securityGroup.credentials = $scope.securityGroup.accountName;
    angular.extend(this, $controller("awsConfigSecurityGroupMixin", {
      $scope,
      $uibModalInstance,
      application,
      securityGroup
    }));
    $scope.state.isNew = false;
    $scope.taskMonitor = new TaskMonitor({
      application,
      title: `Updating your ${FirewallLabels.get("firewall")}`,
      modalInstance: $uibModalInstance,
      onTaskComplete: () => application.securityGroups.refresh()
    });
    securityGroup.securityGroupIngress = _.chain(securityGroup.inboundRules).filter((rule) => rule.securityGroup).map((rule) => rule.portRanges.map((portRange) => {
      const vpcId = rule.securityGroup.vpcId === securityGroup.vpcId ? null : rule.securityGroup.vpcId;
      return {
        accountName: rule.securityGroup.accountName || rule.securityGroup.accountId,
        accountId: rule.securityGroup.accountId,
        vpcId,
        id: rule.securityGroup.id,
        name: rule.securityGroup.inferredName ? null : rule.securityGroup.name,
        type: rule.protocol,
        startPort: portRange.startPort,
        endPort: portRange.endPort,
        existing: true
      };
    })).flatten().value();
    securityGroup.ipIngress = _.chain(securityGroup.inboundRules).filter(function(rule) {
      return rule.range;
    }).map(function(rule) {
      return rule.portRanges.map(function(portRange) {
        return {
          cidr: rule.range.ip + rule.range.cidr,
          type: rule.protocol,
          startPort: portRange.startPort,
          endPort: portRange.endPort
        };
      });
    }).flatten().value();
    this.upsert = function() {
      const group = $scope.securityGroup;
      const command = {
        credentials: group.accountName,
        name: group.name,
        description: group.description,
        vpcId: group.vpcId,
        region: group.region,
        securityGroupIngress: group.securityGroupIngress,
        ipIngress: group.ipIngress
      };
      $scope.taskMonitor.submit(function() {
        return SecurityGroupWriter.upsertSecurityGroup(command, application, "Update");
      });
    };
    this.cancel = function() {
      $uibModalInstance.dismiss();
    };
    this.initializeSecurityGroups().then(this.initializeAccounts);
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/securityGroup/configure/createSecurityGroupIngress.html", `<div class="container-fluid form-horizontal">
  <div class="modal-body">
    <div class="row">
      <div class="col-md-12" ng-if="state.removedRules.length">
        <div class="alert alert-danger">
          <p>
            <i class="fa fa-exclamation-triangle"></i> The following
            <firewall-label label="firewalls"></firewall-label> could not be found in the selected account/region/VPC
            and were removed:
          </p>
          <ul>
            <li ng-repeat="securityGroup in state.removedRules">{{securityGroup}}</li>
          </ul>
          <p class="text-right">
            <a class="btn btn-sm btn-primary dirty-flag-dismiss" href ng-click="ctrl.dismissRemovedRules()">Okay</a>
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <p class="info">
          <span class="glyphicon glyphicon-info-sign"></span> IP range rules can only be edited through the AWS Console.
        </p>
      </div>
    </div>
    <div class="form-group">
      <div class="col-md-12">
        <table class="table table-condensed packed">
          <thead>
            <tr>
              <th style="width: 50%"><firewall-label label="Firewall"></firewall-label></th>
              <th style="width: 15%">Protocol</th>
              <th style="width: 15%">Start Port</th>
              <th style="width: 15%">End Port</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat="rule in securityGroup.securityGroupIngress">
              <td>
                <ingress-rule-group-selector
                  rule="rule"
                  ng-if="state.securityGroupsLoaded"
                  security-group="securityGroup"
                  vpcs="allVpcs"
                  accounts="allAccounts"
                  all-security-groups="allSecurityGroups"
                  coordinates-changed="coordinatesChanged"
                  all-security-groups-updated="allSecurityGroupsUpdated"
                ></ingress-rule-group-selector>
              </td>
              <td>
                <select
                  class="form-control input-sm"
                  ng-model="rule.type"
                  ng-options="protocol as protocol.toUpperCase() for protocol in ['tcp', 'udp', 'icmp', 'icmpv6']"
                  ng-change="ctrl.updateRuleType(rule.type, securityGroup.securityGroupIngress, $index)"
                  required
                ></select>
              </td>
              <td><input class="form-control input-sm" type="number" min="0" ng-model="rule.startPort" required /></td>
              <td><input class="form-control input-sm" type="number" min="0" ng-model="rule.endPort" required /></td>
              <td>
                <a class="sm-label" ng-click="ctrl.removeRule(securityGroup.securityGroupIngress, $index)">
                  <span class="glyphicon glyphicon-trash"></span
                ></a>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="5">
                <button class="add-new col-md-12" ng-click="ctrl.addRule(securityGroup.securityGroupIngress)">
                  <span class="glyphicon glyphicon-plus-sign"></span> Add new
                  <firewall-label label="Firewall"></firewall-label> Rule
                </button>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
    <div class="form-group small" style="margin-top: 20px">
      <div class="col-md-12">
        <p>
          <span ng-if="state.refreshingSecurityGroups"><span class="fa fa-sync-alt fa-spin"></span></span>
          <firewall-label label="Firewalls"></firewall-label>
          <span ng-if="!state.refreshingSecurityGroups">last refreshed {{ state.refreshTime | timestamp }}</span>
          <span ng-if="state.refreshingSecurityGroups"> refreshing...</span>
        </p>
        <p>
          If you're not finding a <firewall-label label="firewall"></firewall-label> that was recently added,
          <a href ng-click="ctrl.refreshSecurityGroups()">click here</a> to refresh the list.
        </p>
      </div>
    </div>
    <security-group-details-custom security-group-details="securityGroup" ctrl="ctrl" scope="self" />
  </div>
</div>
`);
}]);

class IngressRuleSelectorController {
  constructor() {
    this.infiniteScroll = {
      currentItems: 20
    };
  }
  addMoreItems() {
    this.infiniteScroll.currentItems += 20;
  }
  resetCurrentItems() {
    this.infiniteScroll.currentItems = 20;
  }
  addRegionalVpc(vpc) {
    const account = vpc.account;
    if (!this.regionalVpcs[account]) {
      this.regionalVpcs[account] = [];
    }
    this.regionalVpcs[account].push({
      name: vpc.name,
      region: vpc.region,
      account,
      id: vpc.id,
      label: vpc.label,
      deprecated: vpc.deprecated,
      cloudProvider: vpc.cloudProvider
    });
  }
  enableCrossAccount() {
    var _a;
    this.rule.crossAccountEnabled = true;
    this.crossAccountAccounts = this.accounts;
    const exclusions = (_a = AWSProviderSettings) == null ? void 0 : _a.crossAccountIngressExclusions[this.securityGroup.credentials];
    if (exclusions && Array.isArray(exclusions)) {
      this.crossAccountAccounts = this.accounts.filter((account) => !exclusions.includes(account.name));
    }
    this.rule.accountName = this.securityGroup.credentials;
    this.rule.vpcId = this.securityGroup.vpcId;
  }
  disableCrossAccount() {
    this.rule.crossAccountEnabled = false;
    this.rule.accountName = void 0;
    this.rule.vpcId = void 0;
  }
  $onInit() {
    this.setAvailableSecurityGroups();
    this.coordinatesChangedListener = this.coordinatesChanged.subscribe(() => this.setAvailableSecurityGroups());
    this.securityGroupsUpdatedListener = this.allSecurityGroupsUpdated.subscribe(() => this.setAvailableSecurityGroups());
  }
  $onDestroy() {
    this.coordinatesChangedListener.unsubscribe();
    this.securityGroupsUpdatedListener.unsubscribe();
  }
  setAvailableSecurityGroups() {
    const account = this.rule.accountName || this.securityGroup.credentials;
    const regions = this.securityGroup.regions;
    const vpcId = this.rule.vpcId || this.securityGroup.vpcId || null;
    let existingSecurityGroupNames = [];
    let availableSecurityGroups = [];
    if (regions.length > 1) {
      this.disableCrossAccount();
    }
    regions.forEach((region) => {
      var _a, _b, _c, _d;
      let regionalVpcId = null;
      if (vpcId) {
        const baseVpc = this.vpcs.find((vpc) => vpc.id === vpcId);
        const regionalVpc = this.vpcs.find((vpc) => vpc.account === account && vpc.region === region && vpc.name === baseVpc.name);
        regionalVpcId = regionalVpc ? regionalVpc.id : void 0;
      }
      const regionalGroupNames = ((_d = (_c = (_b = (_a = this.allSecurityGroups) == null ? void 0 : _a[account]) == null ? void 0 : _b.aws) == null ? void 0 : _c[region]) != null ? _d : []).filter((sg) => sg.vpcId === regionalVpcId).map((sg) => sg.name);
      existingSecurityGroupNames = uniq(existingSecurityGroupNames.concat(regionalGroupNames));
      if (!availableSecurityGroups.length) {
        availableSecurityGroups = existingSecurityGroupNames;
      } else {
        availableSecurityGroups = intersection(availableSecurityGroups, regionalGroupNames);
      }
    });
    if (regions.length === 1) {
      this.configureAvailableVpcs();
    }
    this.availableSecurityGroups = availableSecurityGroups;
    if (!availableSecurityGroups.includes(this.rule.name) && !this.rule.existing) {
      this.rule.name = null;
    }
  }
  configureAvailableVpcs() {
    const region = this.securityGroup.regions[0];
    const filtered = this.vpcs.filter((vpc) => vpc.region === region);
    this.regionalVpcs = {};
    filtered.forEach((vpc) => this.addRegionalVpc(vpc));
    this.reconcileRuleVpc(filtered);
  }
  reconcileRuleVpc(filtered) {
    if (this.rule.vpcId && !this.rule.existing) {
      if (!this.securityGroup.vpcId) {
        this.rule.vpcId = null;
        this.rule.name = null;
        return;
      }
      const baseVpc = filtered.find((vpc) => vpc.id === this.rule.vpcId);
      const regionalVpc = filtered.find((vpc) => vpc.account === this.rule.accountName && vpc.name === baseVpc.name);
      if (regionalVpc) {
        this.rule.vpcId = regionalVpc.id;
      } else {
        this.rule.vpcId = null;
        this.rule.name = null;
      }
    }
  }
}
const ingressRuleSelector = {
  bindings: {
    rule: "=",
    securityGroup: "=",
    accounts: "=",
    vpcs: "=",
    allSecurityGroups: "=",
    coordinatesChanged: "=",
    allSecurityGroupsUpdated: "="
  },
  templateUrl: "amazon/src/securityGroup/configure/ingressRuleGroupSelector.component.html",
  controller: IngressRuleSelectorController
};
const INGRESS_RULE_GROUP_SELECTOR_COMPONENT = "spinnaker.amazon.securityGroup.configure.ingressRuleGroupSelector";
module(INGRESS_RULE_GROUP_SELECTOR_COMPONENT, []).component("ingressRuleGroupSelector", ingressRuleSelector);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/securityGroup/configure/ingressRuleGroupSelector.component.html", `<span class="form-control-static" ng-if="$ctrl.rule.existing">
  <account-tag
    account="$ctrl.rule.accountName"
    ng-if="$ctrl.rule.accountName !== $ctrl.securityGroup.accountName"
  ></account-tag>
  {{ $ctrl.rule.name || $ctrl.rule.id }}
</span>

<div ng-if="$ctrl.rule.crossAccountEnabled && $ctrl.securityGroup.regions.length === 1" class="cross-account-select">
  <div class="row">
    <div class="col-md-3"><span class="small">Account</span></div>
    <div class="col-md-9">
      <account-select-field
        component="$ctrl.rule"
        field="accountName"
        accounts="$ctrl.crossAccountAccounts"
        provider="'aws'"
        on-change="$ctrl.setAvailableSecurityGroups()"
      ></account-select-field>
    </div>
  </div>
  <div class="row" ng-if="$ctrl.securityGroup.vpcId">
    <div class="col-md-3"><span class="small">VPC</span></div>
    <div class="col-md-9">
      <select class="form-control input-sm" ng-model="$ctrl.rule.vpcId" ng-change="$ctrl.setAvailableSecurityGroups()">
        <option
          ng-repeat="vpc in $ctrl.regionalVpcs[$ctrl.rule.accountName]"
          value="{{ vpc.id }}"
          ng-selected="$ctrl.rule.vpcId === vpc.id"
        >
          {{ vpc.label }}
        </option>
      </select>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-md-3">
    <span class="small" ng-if="$ctrl.rule.crossAccountEnabled">Group</span>
  </div>
  <div class="col-md-{{ $ctrl.rule.crossAccountEnabled ? 9 : 12 }}">
    <ui-select
      ng-if="!$ctrl.rule.existing"
      ng-model="$ctrl.rule.name"
      uis-open-close="$ctrl.resetCurrentItems()"
      class="form-control input-sm"
      required
      style="width: 100%"
    >
      <ui-select-match>{{ $select.selected }}</ui-select-match>
      <ui-select-choices
        repeat="securityGroup as securityGroup in $ctrl.availableSecurityGroups | filter: $select.search | limitTo: $ctrl.infiniteScroll.currentItems"
        infinite-scroll="$ctrl.addMoreItems()"
        infinite-scroll-distance="4"
      >
        <span ng-bind-html="securityGroup | highlight: $select.search"></span>
      </ui-select-choices>
    </ui-select>
  </div>
</div>

<a
  href
  class="small"
  ng-if="!$ctrl.rule.existing && $ctrl.securityGroup.regions.length === 1 && !$ctrl.rule.crossAccountEnabled"
  ng-click="$ctrl.enableCrossAccount($index)"
>
  Select from a different account <span ng-if="$ctrl.securityGroup.vpcId">or VPC</span>
</a>

<div ng-if="$ctrl.crossAccountAccounts && $ctrl.crossAccountAccounts.length !== $ctrl.accounts.length">
  <help-field key="aws.securityGroup.cross.account.ingress.help" expand="true"></help-field>
</div>
<span ng-if="$ctrl.securityGroup.regions.length > 1" class="small">
  Cross-account rules disabled when 2+ regions selected
</span>
`);
}]);

var __defProp$5 = Object.defineProperty;
var __getOwnPropDesc$5 = Object.getOwnPropertyDescriptor;
var __decorateClass$5 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$5(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$5(target, key, result);
  return result;
};
let SecurityGroupDetailsCustom = class extends React__default.Component {
  render() {
    return null;
  }
};
SecurityGroupDetailsCustom = __decorateClass$5([
  Overridable("aws.securityGroup.details.custom")
], SecurityGroupDetailsCustom);

const AWS_SECURITY_GROUP_DETAILS_CUSTOM = "spinnaker.amazon.securityGroups.details.custom.component";
module(AWS_SECURITY_GROUP_DETAILS_CUSTOM, []).component("securityGroupDetailsCustom", react2angular(withErrorBoundary(SecurityGroupDetailsCustom, "securityGroupDetailsCustom"), [
  "securityGroupDetails",
  "ctrl",
  "scope"
]));

const AMAZON_SECURITYGROUP_DETAILS_SECURITYGROUPDETAIL_CONTROLLER = "spinnaker.amazon.securityGroup.details.controller";
angular.module(AMAZON_SECURITYGROUP_DETAILS_SECURITYGROUPDETAIL_CONTROLLER, [
  UIROUTER_ANGULARJS,
  SECURITY_GROUP_READER,
  AMAZON_SECURITYGROUP_CLONE_CLONESECURITYGROUP_CONTROLLER,
  MANAGED_RESOURCE_DETAILS_INDICATOR
]).controller("awsSecurityGroupDetailsCtrl", [
  "$scope",
  "$state",
  "resolvedSecurityGroup",
  "app",
  "securityGroupReader",
  "$uibModal",
  function($scope, $state, resolvedSecurityGroup, app, securityGroupReader, $uibModal) {
    this.application = app;
    const application = app;
    const securityGroup = resolvedSecurityGroup;
    this.firewallLabel = FirewallLabels.get("Firewall");
    $scope.detailsTemplateUrl = CloudProviderRegistry.getValue("aws", "securityGroup.detailsTemplateUrl");
    $scope.isDisabled = !AWSProviderSettings.adHocInfraWritesEnabled;
    $scope.state = {
      loading: true,
      standalone: app.isStandalone
    };
    function extractSecurityGroup() {
      return securityGroupReader.getSecurityGroupDetails(application, securityGroup.accountId, securityGroup.provider, securityGroup.region, securityGroup.vpcId, securityGroup.name).then(function(details) {
        return VpcReader.getVpcName(details.vpcId).then((name2) => {
          details.vpcName = name2;
          return details;
        });
      }).then(function(details) {
        $scope.state.loading = false;
        if (!details || _.isEmpty(details)) {
          fourOhFour();
        } else {
          const applicationSecurityGroup = securityGroupReader.getApplicationSecurityGroup(application, securityGroup.accountId, securityGroup.region, securityGroup.name);
          angular.extend(securityGroup, applicationSecurityGroup, details);
          $scope.securityGroup = securityGroup;
          $scope.ipRules = buildIpRulesModel(securityGroup);
          $scope.securityGroupRules = buildSecurityGroupRulesModel(securityGroup);
        }
      }, fourOhFour);
    }
    function buildIpRulesModel(details) {
      const groupedRangeRules = _.groupBy(details.ipRangeRules, (rule) => rule.range.ip + rule.range.cidr);
      return Object.keys(groupedRangeRules).map((addr) => {
        return {
          address: addr,
          rules: buildRuleModel(groupedRangeRules, addr)
        };
      }).filter((rule) => rule.rules.length);
    }
    function buildSecurityGroupRulesModel(details) {
      const groupedRangeRules = _.groupBy(details.securityGroupRules, (rule) => rule.securityGroup.id);
      return Object.keys(groupedRangeRules).map((addr) => {
        return {
          securityGroup: groupedRangeRules[addr][0].securityGroup,
          rules: buildRuleModel(groupedRangeRules, addr)
        };
      }).filter((rule) => rule.rules.length);
    }
    function buildRuleModel(groupedRangeRules, addr) {
      const rules = [];
      groupedRangeRules[addr].forEach((rule) => {
        (rule.portRanges || []).forEach((range) => {
          if (rule.protocol === "-1" || range.startPort !== void 0 && range.endPort !== void 0) {
            rules.push({
              startPort: range.startPort,
              endPort: range.endPort,
              protocol: rule.protocol,
              description: rule.description
            });
          }
        });
      });
      return rules;
    }
    function fourOhFour() {
      if ($scope.$$destroyed) {
        return;
      }
      if (app.isStandalone) {
        $scope.group = securityGroup.name;
        $scope.state.notFound = true;
        $scope.state.loading = false;
        RecentHistoryService.removeLastItem("securityGroups");
      } else {
        $state.go("^", { allowModalToStayOpen: true }, { location: "replace" });
      }
    }
    extractSecurityGroup().then(() => {
      if (!$scope.$$destroyed && !app.isStandalone) {
        app.securityGroups.onRefresh($scope, extractSecurityGroup);
      }
    });
    this.editInboundRules = function editInboundRules() {
      confirmNotManaged($scope.securityGroup, application).then((notManaged) => {
        return new Promise((resolve) => setTimeout(resolve, 500)).then(() => {
          if (notManaged) {
            $uibModal.open({
              templateUrl: "amazon/src/securityGroup/configure/editSecurityGroup.html",
              controller: "awsEditSecurityGroupCtrl as ctrl",
              size: "lg",
              resolve: {
                securityGroup: function() {
                  return angular.copy($scope.securityGroup);
                },
                application: function() {
                  return application;
                }
              }
            });
          }
        });
      });
    };
    this.cloneSecurityGroup = function cloneSecurityGroup() {
      $uibModal.open({
        templateUrl: "amazon/src/securityGroup/clone/cloneSecurityGroup.html",
        controller: "awsCloneSecurityGroupController as ctrl",
        size: "lg",
        resolve: {
          securityGroup: function() {
            const securityGroup2 = angular.copy($scope.securityGroup);
            if (securityGroup2.region) {
              securityGroup2.regions = [securityGroup2.region];
            }
            return securityGroup2;
          },
          application: function() {
            return application;
          }
        }
      });
    };
    this.deleteSecurityGroup = function deleteSecurityGroup() {
      let isRetry = false;
      const retryParams = { removeDependencies: true };
      const taskMonitor = {
        application,
        title: "Deleting " + securityGroup.name,
        onTaskRetry: () => {
          isRetry = true;
        }
      };
      const submitMethod = () => {
        const params = {
          cloudProvider: securityGroup.provider,
          vpcId: securityGroup.vpcId
        };
        if (isRetry) {
          Object.assign(params, retryParams);
        }
        return SecurityGroupWriter.deleteSecurityGroup(securityGroup, application, params);
      };
      confirmNotManaged($scope.securityGroup, application).then((notManaged) => {
        notManaged && ConfirmationModalService.confirm({
          header: "Really delete " + securityGroup.name + "?",
          buttonText: "Delete " + securityGroup.name,
          account: securityGroup.accountId,
          taskMonitorConfig: taskMonitor,
          submitMethod,
          retryBody: `<div><p>Retry deleting the ${FirewallLabels.get("firewall")} and revoke any dependent ingress rules?</p><p>Any instance or load balancer associations will have to removed manually.</p></div>`
        });
      });
    };
    if (app.isStandalone) {
      app.securityGroups = {
        refresh: extractSecurityGroup
      };
    }
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/securityGroup/configure/editSecurityGroup.html", `<ng-form role="form" name="form" novalidate>
  <v2-modal-wizard
    heading="Edit {{securityGroup.name}}: {{securityGroup.region}}: {{securityGroup.accountName}}"
    task-monitor="taskMonitor"
    dismiss="$dismiss()"
  >
    <v2-wizard-page key="Ingress" label="Ingress" done="true">
      <ng-include src="pages.ingress"></ng-include>
    </v2-wizard-page>
  </v2-modal-wizard>
  <div class="modal-footer">
    <button class="btn btn-default" ng-click="ctrl.cancel()">Cancel</button>
    <submit-button
      is-disabled="form.$invalid || !wizard.isComplete() || state.submitting || !customComponentIsvalid"
      submitting="state.submitting"
      on-click="ctrl.upsert()"
      is-new="state.isNew"
    ></submit-button>
  </div>
</ng-form>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/securityGroup/clone/cloneSecurityGroup.html", `<ng-form role="form" name="form" novalidate>
  <v2-modal-wizard heading="Clone {{ctrl.firewallLabel}}" task-monitor="taskMonitor" dismiss="$dismiss()">
    <v2-wizard-page key="Location" label="Location">
      <ng-include src="pages.location"></ng-include>
    </v2-wizard-page>
    <v2-wizard-page key="Ingress" label="Ingress" done="true" mark-clean-on-view="false">
      <ng-include src="pages.ingress"></ng-include>
    </v2-wizard-page>
  </v2-modal-wizard>
  <div class="modal-footer">
    <button class="btn btn-default" ng-click="ctrl.cancel()">Cancel</button>
    <submit-button
      is-disabled="form.$invalid || !wizard.isComplete() || state.submitting || state.removedRules.length > 0 || !customComponentIsvalid || state.regionError"
      submitting="state.submitting"
      on-click="ctrl.upsert()"
      is-new="isNew"
    ></submit-button>
  </div>
</ng-form>
`);
}]);

var __defProp$4 = Object.defineProperty;
var __getOwnPropDesc$4 = Object.getOwnPropertyDescriptor;
var __decorateClass$4 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$4(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$4(target, key, result);
  return result;
};
let IPRangeRules = class extends React__default.Component {
  render() {
    const ipRules = this.props.ipRules || [];
    const heading = `IP Range Rules (${ipRules.length})`;
    return /* @__PURE__ */ React__default.createElement(CollapsibleSection, {
      heading
    }, ipRules.map((rule) => /* @__PURE__ */ React__default.createElement(LabeledValueList, {
      className: "horizontal-when-filters-collapsed"
    }, /* @__PURE__ */ React__default.createElement(LabeledValue, {
      label: "IP Range",
      value: rule.address
    }), /* @__PURE__ */ React__default.createElement(LabeledValue, {
      label: "Port Ranges",
      value: rule.rules.map((r) => r.protocol === "-1" ? /* @__PURE__ */ React__default.createElement("span", null, "All ports and protocols", rule.rules.length > 1 ? /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("em", null, "Additional port ranges are specified, but redundant:")) : null) : /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("span", null, r.protocol, ":", r.startPort, " \u2192 ", r.endPort)))
    }))));
  }
};
IPRangeRules = __decorateClass$4([
  Overridable("aws.securityGroup.ip.rules")
], IPRangeRules);

const AWS_SECURITY_GROUP_IP_RANGE_RULES = "spinnaker.amazon.securityGroups.details.securityGroups.component";
module(AWS_SECURITY_GROUP_IP_RANGE_RULES, []).component("ipRangeRules", react2angular(withErrorBoundary(IPRangeRules, "ipRangeRules"), ["ipRules"]));

class AwsSecurityGroupReader {
  resolveIndexedSecurityGroup(indexedSecurityGroups, container, securityGroupId) {
    return AwsSecurityGroupReader.resolveIndexedSecurityGroup(indexedSecurityGroups, container, securityGroupId);
  }
  static resolveIndexedSecurityGroup(indexedSecurityGroups, container, securityGroupId) {
    return indexedSecurityGroups[container.account][container.region][securityGroupId];
  }
}
const AWS_SECURITY_GROUP_READER = "spinnaker.amazon.securityGroup.reader";
module(AWS_SECURITY_GROUP_READER, []).service("awsSecurityGroupReader", AwsSecurityGroupReader);

const AMAZON_SECURITYGROUP_SECURITYGROUP_TRANSFORMER = "spinnaker.amazon.securityGroup.transformer";
module(AMAZON_SECURITYGROUP_SECURITYGROUP_TRANSFORMER, []).factory("awsSecurityGroupTransformer", function() {
  function normalizeSecurityGroup(securityGroup) {
    return VpcReader.listVpcs().then(addVpcNameToSecurityGroup(securityGroup));
  }
  function addVpcNameToSecurityGroup(securityGroup) {
    return function(vpcs) {
      const matches = vpcs.filter(function(test) {
        return test.id === securityGroup.vpcId;
      });
      securityGroup.vpcName = matches.length ? matches[0].name : "";
    };
  }
  function compress(securityGroups) {
    const grouped = groupBy(securityGroups, "vpcId");
    Object.keys(grouped).forEach((vpcId) => {
      grouped[vpcId] = grouped[vpcId].map((g) => [g.name, g.id]);
    });
    return grouped;
  }
  function decompress(groupedGroups) {
    const flattened = [];
    Object.keys(groupedGroups).forEach((vpcId) => {
      groupedGroups[vpcId].forEach((g) => {
        flattened.push({ name: g[0], id: g[1], vpcId });
      });
    });
    return flattened;
  }
  return {
    normalizeSecurityGroup,
    compress,
    decompress,
    supportsCompression: true
  };
});

const AWS_SECURITY_GROUP_MODULE = "spinnaker.amazon.securityGroup";
module(AWS_SECURITY_GROUP_MODULE, [
  AWS_SECURITY_GROUP_READER,
  AMAZON_SECURITYGROUP_CLONE_CLONESECURITYGROUP_CONTROLLER,
  INGRESS_RULE_GROUP_SELECTOR_COMPONENT,
  AMAZON_SECURITYGROUP_CONFIGURE_CONFIGSECURITYGROUP_MIXIN_CONTROLLER,
  AMAZON_SECURITYGROUP_CONFIGURE_CREATESECURITYGROUPCTRL,
  AMAZON_SECURITYGROUP_CONFIGURE_EDITSECURITYGROUPCTRL,
  AMAZON_SECURITYGROUP_DETAILS_SECURITYGROUPDETAIL_CONTROLLER,
  AMAZON_SECURITYGROUP_SECURITYGROUP_TRANSFORMER,
  AWS_SECURITY_GROUP_IP_RANGE_RULES,
  AWS_SECURITY_GROUP_DETAILS_CUSTOM
]);

class ServerGroupTemplateSelection extends React__default.Component {
  constructor(props) {
    super(props);
    this.state = {
      templateSelectionText: {
        copied: [
          "account, region, subnet, cluster name (stack, details)",
          "load balancers",
          FirewallLabels.get("firewalls"),
          "instance type",
          "all fields on the Advanced Settings page"
        ],
        notCopied: ["the following suspended scaling processes: Launch, Terminate, AddToLoadBalancer"],
        additionalCopyText: "If a server group exists in this cluster at the time of deployment, its scaling policies will be copied over to the new server group."
      }
    };
    if (!props.command.viewState.disableStrategySelection) {
      this.state.templateSelectionText.notCopied.push("the deployment strategy (if any) used to deploy the most recent server group");
    }
  }
  render() {
    const { app, command, onDismiss, onTemplateSelected } = this.props;
    const { templateSelectionText } = this.state;
    return /* @__PURE__ */ React__default.createElement(DeployInitializer, {
      cloudProvider: "aws",
      application: app,
      command,
      onDismiss,
      onTemplateSelected,
      templateSelectionText
    });
  }
}

class AmazonImageSelectInput extends React__default.Component {
  constructor() {
    super(...arguments);
    this.state = {
      errorMessage: null,
      selectionMode: "packageImages",
      searchString: "",
      searchResults: null,
      isSearching: false,
      packageImages: null,
      isLoadingPackageImages: true
    };
    this.awsImageReader = new AwsImageReader();
    this.props$ = new Subject();
    this.searchInput$ = new Subject();
    this.destroy$ = new Subject();
    this.sortImagesBy$ = new BehaviorSubject("ts");
    this.buildImageMenu = (params) => {
      const { ImageMenuHeading, ImageLabel } = this;
      const { options } = params;
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "Select-menu-outer"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "Select-menu",
        role: "listbox"
      }, options.length > 0 && /* @__PURE__ */ React__default.createElement(ImageMenuHeading, null), options.map((o) => /* @__PURE__ */ React__default.createElement(ImageLabel, {
        key: o.imageName,
        option: o,
        params
      }))));
    };
    this.ImageMenuHeading = () => {
      const sortImagesBy = this.sortImagesBy$.value;
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "sp-padding-s-xaxis sp-padding-xs-yaxis small",
        style: {
          borderBottom: "1px solid var(--color-silver)",
          position: "sticky",
          top: 0,
          backgroundColor: "var(--color-white)"
        }
      }, /* @__PURE__ */ React__default.createElement("b", null, "Sort by: "), /* @__PURE__ */ React__default.createElement("a", {
        className: "clickable sp-padding-xs-xaxis",
        onClick: () => this.setSortImagesBy("ts")
      }, sortImagesBy === "ts" ? /* @__PURE__ */ React__default.createElement("b", null, "timestamp (newest first)") : "timestamp (newest first)"), /* @__PURE__ */ React__default.createElement("span", null, " | "), /* @__PURE__ */ React__default.createElement("a", {
        className: "clickable sp-padding-xs-xaxis",
        onClick: () => this.setSortImagesBy("name")
      }, sortImagesBy === "name" ? /* @__PURE__ */ React__default.createElement("b", null, "name (A-Z)") : "name (A-Z)"));
    };
    this.ImageLabel = (imageLabelProps) => {
      const { credentials, region } = this.props;
      const { option, params } = imageLabelProps;
      const amiLabel = option.amis[region] && option.amis[region][0] ? option.amis[region][0] : ` - not found in ${credentials}/${region}`;
      return /* @__PURE__ */ React__default.createElement("div", {
        key: option.imageName,
        onClick: () => params.selectValue(option),
        onMouseOver: () => params.focusOption(option),
        className: `Select-option ${params.focusedOption && params.focusedOption.imageName === option.imageName ? "is-focused" : ""}`,
        role: "option"
      }, /* @__PURE__ */ React__default.createElement("div", null, option.imageName), /* @__PURE__ */ React__default.createElement("div", {
        className: "small"
      }, /* @__PURE__ */ React__default.createElement("b", null, "Created: "), option.attributes.creationDate, /* @__PURE__ */ React__default.createElement("b", {
        className: "sp-padding-s-left"
      }, "AMI: "), amiLabel));
    };
  }
  static makeFakeImage(imageName, imageId, region) {
    if (!imageName && !imageId) {
      return null;
    }
    const amis = { [region]: [imageId] };
    const attributes = { virtualizationType: "*", creationDate: new Date().toISOString() };
    return { imageName, amis, attributes };
  }
  loadImagesFromApplicationName(application) {
    const query = application.name.replace(/_/g, "[_\\-]") + "*";
    return this.awsImageReader.findImages({ q: query });
  }
  buildQueryForSimilarImages(imageName) {
    let addDashToQuery = false;
    let packageBase = imageName.split("_")[0];
    const parts = packageBase.split("-");
    if (parts.length > 3) {
      packageBase = parts.slice(0, -3).join("-");
      addDashToQuery = true;
    }
    const tooShort = !packageBase || packageBase.length < 3;
    return tooShort ? null : packageBase + (addDashToQuery ? "-*" : "*");
  }
  loadImageById(imageId, region, credentials) {
    return !imageId ? $q.when(null) : this.awsImageReader.getImage(imageId, region, credentials).catch(() => null);
  }
  searchForImages(query) {
    const hasMinLength = query && query.length >= 3;
    return hasMinLength ? this.awsImageReader.findImages({ q: query }) : $q.when([]);
  }
  fetchPackageImages(value, region, credentials, application) {
    const imageId = value && value.amis && value.amis[region] && value.amis[region][0];
    return this.loadImageById(imageId, region, credentials).then((image) => {
      if (!image) {
        return this.loadImagesFromApplicationName(application);
      }
      return this.searchForImages(this.buildQueryForSimilarImages(image.imageName)).then((similarImages) => {
        if (!similarImages.find((img) => img.imageName === image.imageName)) {
          return similarImages.concat(image);
        }
        return similarImages;
      });
    });
  }
  selectImage(selectedImage) {
    if (this.props.value !== selectedImage) {
      this.props.onChange(selectedImage);
    }
  }
  findMatchingImage(images, selectedImage) {
    return images.find((img) => selectedImage && selectedImage.imageName === img.imageName);
  }
  componentDidMount() {
    const region$ = this.props$.pipe(map((x) => x.region), distinctUntilChanged());
    const { value, region, credentials, application } = this.props;
    this.setState({ isLoadingPackageImages: true });
    const fetchPromise = this.fetchPackageImages(value, region, credentials, application);
    const packageImages$ = from(fetchPromise).pipe(catchError((err) => {
      console.error(err);
      this.setState({ errorMessage: "Unable to load package images" });
      return of([]);
    }), tap(() => this.setState({ isLoadingPackageImages: false })));
    const packageImagesInRegion$ = combineLatest([packageImages$, region$, this.sortImagesBy$]).pipe(map(([packageImages, latestRegion, sortImagesBy]) => {
      const images = packageImages.filter((img) => !!img.amis[latestRegion]);
      return this.sortImages(images, sortImagesBy);
    }));
    const searchString$ = this.searchInput$.pipe(tap((searchString) => this.setState({ searchString })), distinctUntilChanged(), debounceTime(250));
    const searchImages$ = searchString$.pipe(tap(() => this.setState({ isSearching: true })), switchMap((searchString) => this.searchForImages(searchString)), catchError((err) => {
      console.error(err);
      this.setState({ errorMessage: "Unable to search for images" });
      return of([]);
    }), tap(() => this.setState({ isSearching: false })));
    const searchImagesInRegion$ = combineLatest([searchImages$, region$, this.sortImagesBy$]).pipe(map(([searchResults, latestRegion, sortImagesBy]) => {
      const { searchString } = this.state;
      if (searchResults.length === 0 && !!/ami-[0-9a-f]{8,17}/.exec(searchString)) {
        const fakeImage = AmazonImageSelectInput.makeFakeImage(searchString, searchString, latestRegion);
        return [fakeImage].filter((x) => !!x);
      }
      const images = searchResults.filter((img) => !!img.amis[latestRegion]);
      return this.sortImages(images, sortImagesBy);
    }));
    searchImagesInRegion$.pipe(takeUntil(this.destroy$)).subscribe((searchResults) => this.setState({ searchResults }));
    packageImagesInRegion$.pipe(takeUntil(this.destroy$)).subscribe((packageImages) => {
      this.setState({ packageImages });
      this.selectImage(this.findMatchingImage(packageImages, this.props.value));
    });
    region$.pipe(switchMap((selectedRegion) => {
      const image = this.props.value;
      if (this.state.selectionMode === "packageImages") {
        return packageImagesInRegion$.pipe(map((images) => this.findMatchingImage(images, image)));
      } else {
        const hasAmiInRegion = !!(image && image.amis && image.amis[selectedRegion]);
        return of(hasAmiInRegion ? image : void 0);
      }
    }), takeUntil(this.destroy$)).subscribe((image) => this.selectImage(image));
  }
  setSortImagesBy(sortImagesBy) {
    this.sortImagesBy$.next(sortImagesBy);
  }
  sortImages(images, sortImagesBy) {
    return images.slice().sort((a, b) => {
      if (sortImagesBy === "ts") {
        return b.attributes.creationDate.localeCompare(a.attributes.creationDate);
      }
      return a.imageName.localeCompare(b.imageName);
    });
  }
  componentDidUpdate() {
    this.props$.next(this.props);
  }
  componentWillUnmount() {
    this.destroy$.next();
  }
  render() {
    const { value, credentials, region, onChange } = this.props;
    const {
      isLoadingPackageImages,
      isSearching,
      selectionMode,
      packageImages,
      searchResults,
      searchString
    } = this.state;
    const isPackageImagesLoaded = !!packageImages;
    const ImageOptionRenderer = (image) => {
      const amis = image.amis || {};
      const imageIdForSelectedRegion = amis[region] && amis[region][0];
      const message = imageIdForSelectedRegion ? `(${imageIdForSelectedRegion})` : ` - not found in ${credentials}/${region}`;
      return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("span", null, image.imageName), /* @__PURE__ */ React__default.createElement("span", null, message));
    };
    const commonReactSelectProps = {
      clearable: false,
      required: true,
      valueKey: "imageName",
      optionRenderer: ImageOptionRenderer,
      valueRenderer: ImageOptionRenderer,
      onSelectResetsInput: false,
      onBlurResetsInput: false,
      onCloseResetsInput: false,
      value
    };
    const error = this.state.errorMessage ? /* @__PURE__ */ React__default.createElement(ValidationMessage, {
      message: this.state.errorMessage,
      type: "error"
    }) : null;
    const noResultsText = `No results found in ${credentials}/${region}`;
    if (selectionMode === "searchAllImages") {
      const lessThanThreeChars = !searchString || searchString.length < 3;
      const searchNoResultsText = lessThanThreeChars ? "Please enter at least 3 characters" : isSearching ? "Searching..." : noResultsText;
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-9"
      }, /* @__PURE__ */ React__default.createElement(TetheredSelect, {
        ...commonReactSelectProps,
        menuRenderer: this.buildImageMenu,
        isLoading: isSearching,
        placeholder: "Search for an image...",
        filterOptions: false,
        noResultsText: searchNoResultsText,
        options: searchResults,
        onInputChange: (searchInput) => {
          this.searchInput$.next(searchInput);
          return searchInput;
        },
        onChange
      }), error);
    } else if (isPackageImagesLoaded) {
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-9"
      }, /* @__PURE__ */ React__default.createElement(TetheredSelect, {
        ...commonReactSelectProps,
        menuRenderer: this.buildImageMenu,
        isLoading: isLoadingPackageImages,
        placeholder: "Pick an image",
        noResultsText,
        options: packageImages,
        onChange
      }), error, /* @__PURE__ */ React__default.createElement("button", {
        type: "button",
        className: "link",
        onClick: () => this.setState({ selectionMode: "searchAllImages" })
      }, "Search All Images"), " ", /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "aws.serverGroup.allImages"
      }));
    } else {
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-9"
      }, /* @__PURE__ */ React__default.createElement(TetheredSelect, {
        ...commonReactSelectProps,
        isLoading: isLoadingPackageImages,
        disabled: true,
        options: [value].filter((x) => !!x)
      }), error, /* @__PURE__ */ React__default.createElement("button", {
        type: "button",
        className: "link",
        onClick: () => this.setState({ selectionMode: "searchAllImages" })
      }, "Search All Images"), " ", /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "aws.serverGroup.allImages"
      }));
    }
  }
}

const isExpressionLanguage = (field) => field && field.includes("${");
const isStackPattern = (stack) => !isExpressionLanguage(stack) ? /^([a-zA-Z_0-9._${}]*(\${.+})*)*$/.test(stack) : true;
const isDetailPattern = (detail) => !isExpressionLanguage(detail) ? /^([a-zA-Z_0-9._${}-]*(\${.+})*)*$/.test(detail) : true;
class ServerGroupBasicSettings extends React__default.Component {
  constructor(props) {
    super(props);
    this.imageChanged = (image) => {
      var _a, _b;
      const { setFieldValue, values } = this.props.formik;
      this.setState({ selectedImage: image });
      const virtualizationType = image && image.attributes.virtualizationType;
      const imageName = image && image.imageName;
      values.virtualizationType = virtualizationType;
      values.amiName = imageName;
      setFieldValue("virtualizationType", virtualizationType);
      setFieldValue("amiName", imageName);
      values.imageChanged(values);
      if (image && ((_a = SETTINGS.disabledImages) == null ? void 0 : _a.length) && ((_b = AWSProviderSettings.serverGroups) == null ? void 0 : _b.enableIPv6)) {
        const isImageDisabled = SETTINGS.disabledImages.some((i) => image.imageName.includes(i));
        if (isImageDisabled) {
          setFieldValue("associateIPv6Address", false);
        }
      }
      this.props.formik.validateForm();
    };
    this.accountUpdated = (account) => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
      const { setFieldValue, values } = this.props.formik;
      values.credentials = account;
      values.credentialsChanged(values);
      values.subnetChanged(values);
      setFieldValue("credentials", account);
      const accountDetails = values.backingData.credentialsKeyedByAccount[account];
      const enableIPv6InTest = ((_b = (_a = AWSProviderSettings) == null ? void 0 : _a.serverGroups) == null ? void 0 : _b.enableIPv6) && ((_d = (_c = AWSProviderSettings) == null ? void 0 : _c.serverGroups) == null ? void 0 : _d.setIPv6InTest) && accountDetails.environment === "test";
      setFieldValue("associateIPv6Address", enableIPv6InTest);
      if ((_e = AWSProviderSettings.serverGroups) == null ? void 0 : _e.enableIMDSv2) {
        const isIMDSv2AllowedOnAccount = !((_h = (_g = (_f = AWSProviderSettings) == null ? void 0 : _f.serverGroups) == null ? void 0 : _g.accountDenyListIMDSv2) == null ? void 0 : _h.includes(account));
        const appAgeRequirement = (_i = AWSProviderSettings.serverGroups) == null ? void 0 : _i.defaultIMDSv2AppAgeLimit;
        const creationDate = (_k = (_j = this.props.app) == null ? void 0 : _j.attributes) == null ? void 0 : _k.createTs;
        const setIMDSv2 = isIMDSv2AllowedOnAccount && appAgeRequirement && creationDate && Number(creationDate) > appAgeRequirement;
        setFieldValue("requireIMDSv2", setIMDSv2);
      }
    };
    this.regionUpdated = (region) => {
      const { values, setFieldValue } = this.props.formik;
      values.region = region;
      values.regionChanged(values);
      setFieldValue("region", region);
    };
    this.subnetUpdated = () => {
      const { setFieldValue, values } = this.props.formik;
      values.subnetChanged(values);
      setFieldValue("subnetType", values.subnetType);
    };
    this.clientRequestsChanged = () => {
      const { values, setFieldValue } = this.props.formik;
      values.toggleSuspendedProcess(values, "AddToLoadBalancer");
      setFieldValue("suspendedProcesses", values.suspendedProcesses);
      this.setState({});
    };
    this.navigateToLatestServerGroup = () => {
      const { values } = this.props.formik;
      const { latestServerGroup } = this.state;
      const params = {
        provider: values.selectedProvider,
        accountId: latestServerGroup.account,
        region: latestServerGroup.region,
        serverGroup: latestServerGroup.name
      };
      const { $state } = ReactInjector;
      if ($state.is("home.applications.application.insight.clusters")) {
        $state.go(".serverGroup", params);
      } else {
        $state.go("^.serverGroup", params);
      }
    };
    this.stackChanged = (stack) => {
      const { setFieldValue, values } = this.props.formik;
      values.stack = stack;
      setFieldValue("stack", stack);
      values.clusterChanged(values);
    };
    this.handleReasonChanged = (reason) => {
      this.props.formik.setFieldValue("reason", reason);
    };
    this.strategyChanged = (values, strategy) => {
      values.onStrategyChange(values, strategy);
      this.props.formik.setFieldValue("strategy", strategy.key);
    };
    this.onStrategyFieldChange = (key, value) => {
      this.props.formik.setFieldValue(key, value);
    };
    const {
      amiName,
      region,
      viewState: { imageId }
    } = props.formik.values;
    const selectedImage = AmazonImageSelectInput.makeFakeImage(amiName, imageId, region);
    this.state = { ...this.getStateFromProps(props), selectedImage };
  }
  getStateFromProps(props) {
    const { app } = props;
    const { values } = props.formik;
    const namePreview = NameUtils.getClusterName(app.name, values.stack, values.freeFormDetails);
    const createsNewCluster = !app.clusters.find((c) => c.name === namePreview);
    const inCluster = app.serverGroups.data.filter((serverGroup) => {
      return serverGroup.cluster === namePreview && serverGroup.account === values.credentials && serverGroup.region === values.region;
    }).sort((a, b) => a.createdTime - b.createdTime);
    const latestServerGroup = inCluster.length ? inCluster.pop() : null;
    return { namePreview, createsNewCluster, latestServerGroup };
  }
  validate(values) {
    const errors = {};
    if (!isStackPattern(values.stack)) {
      errors.stack = "Only dot(.) and underscore(_) special characters are allowed in the Stack field.";
    }
    if (!isDetailPattern(values.freeFormDetails)) {
      errors.freeFormDetails = "Only dot(.), underscore(_), and dash(-) special characters are allowed in the Detail field.";
    }
    if (!values.viewState.disableImageSelection && !values.amiName) {
      errors.amiName = "Image required.";
    }
    if (values.resourceSummary) {
      errors.resourceSummary = { id: "Cluster is managed" };
    }
    return errors;
  }
  componentWillReceiveProps(nextProps) {
    this.setState(this.getStateFromProps(nextProps));
  }
  render() {
    const { app, formik } = this.props;
    const { errors, values } = formik;
    const { createsNewCluster, latestServerGroup, namePreview } = this.state;
    const accounts = values.backingData.accounts;
    const readOnlyFields = values.viewState.readOnlyFields || {};
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "container-fluid form-horizontal"
    }, values.regionIsDeprecated(values) && /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12 error-message"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "alert alert-danger"
    }, "You are deploying into a deprecated region within the ", values.credentials, " account!"))), /* @__PURE__ */ React__default.createElement(DeployingIntoManagedClusterWarning, {
      app,
      formik
    }), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-3 sm-label-right"
    }, "Account"), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-7"
    }, /* @__PURE__ */ React__default.createElement(AccountSelectInput, {
      value: values.credentials,
      onChange: (evt) => this.accountUpdated(evt.target.value),
      readOnly: readOnlyFields.credentials,
      accounts,
      provider: "aws"
    }))), /* @__PURE__ */ React__default.createElement(RegionSelectField, {
      readOnly: readOnlyFields.region,
      labelColumns: 3,
      component: values,
      field: "region",
      account: values.credentials,
      regions: values.backingData.filtered.regions,
      onChange: this.regionUpdated
    }), /* @__PURE__ */ React__default.createElement(SubnetSelectField, {
      readOnly: readOnlyFields.subnet,
      labelColumns: 3,
      helpKey: "aws.serverGroup.subnet",
      component: values,
      field: "subnetType",
      region: values.region,
      application: app,
      subnets: values.backingData.filtered.subnetPurposes,
      onChange: this.subnetUpdated,
      showSubnetWarning: true
    }), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-3 sm-label-right"
    }, "Stack ", /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "aws.serverGroup.stack"
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-7"
    }, /* @__PURE__ */ React__default.createElement("input", {
      type: "text",
      className: "form-control input-sm no-spel",
      value: values.stack,
      onChange: (e) => this.stackChanged(e.target.value)
    }))), errors.stack && /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group row slide-in"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-sm-9 col-sm-offset-2 error-message"
    }, /* @__PURE__ */ React__default.createElement("span", null, errors.stack))), /* @__PURE__ */ React__default.createElement(ServerGroupDetailsField, {
      app,
      formik
    }), values.viewState.imageSourceText && /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-3 sm-label-right"
    }, "Image Source"), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-7",
      style: { marginTop: "5px" }
    }, /* @__PURE__ */ React__default.createElement(Markdown, {
      tag: "span",
      message: values.viewState.imageSourceText
    }))), !values.viewState.disableImageSelection && /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-3 sm-label-right"
    }, "Image ", /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "aws.serverGroup.imageName"
    })), isExpressionLanguage(values.amiName) ? /* @__PURE__ */ React__default.createElement(Field, {
      name: "amiName"
    }) : /* @__PURE__ */ React__default.createElement(AmazonImageSelectInput, {
      onChange: (image) => this.imageChanged(image),
      value: this.state.selectedImage,
      application: app,
      credentials: values.credentials,
      region: values.region
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-3 sm-label-right"
    }, "Traffic ", /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "aws.serverGroup.traffic"
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-9 checkbox"
    }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
      type: "checkbox",
      onChange: this.clientRequestsChanged,
      checked: !values.processIsSuspended(values, "AddToLoadBalancer"),
      disabled: values.strategy !== "" && values.strategy !== "custom"
    }), "Send client requests to new instances"))), !values.viewState.disableStrategySelection && values.selectedProvider && /* @__PURE__ */ React__default.createElement(DeploymentStrategySelector, {
      command: values,
      onFieldChange: this.onStrategyFieldChange,
      onStrategyChange: this.strategyChanged
    }), !values.viewState.hideClusterNamePreview && /* @__PURE__ */ React__default.createElement(ServerGroupNamePreview, {
      createsNewCluster,
      latestServerGroupName: latestServerGroup == null ? void 0 : latestServerGroup.name,
      mode: values.viewState.mode,
      namePreview,
      navigateToLatestServerGroup: this.navigateToLatestServerGroup
    }), /* @__PURE__ */ React__default.createElement(TaskReason, {
      reason: values.reason,
      onChange: this.handleReasonChanged
    }));
  }
}

class CapacitySelector extends React__default.Component {
  constructor() {
    super(...arguments);
    this.preferSourceCapacityOptions = [
      { label: "fail the stage", value: false },
      { label: "use fallback values", value: true }
    ];
    this.useSourceCapacityUpdated = (event) => {
      const value = event.target.value === "true";
      const { command } = this.props;
      this.props.setFieldValue("useSourceCapacity", value);
      if (!value) {
        delete command.preferSourceCapacity;
        this.props.setFieldValue("preferSourceCapacity", void 0);
      }
      this.setState({});
    };
    this.simpleInstancesChanged = (value) => {
      this.setMinMax(value);
    };
    this.preferSourceCapacityChanged = (option) => {
      this.props.setFieldValue("preferSourceCapacity", option && option.value ? true : void 0);
      this.setState({});
    };
    this.capacityFieldChanged = (fieldName, value) => {
      const { command, setFieldValue } = this.props;
      command.capacity = { ...command.capacity };
      command.capacity[fieldName] = value;
      setFieldValue("capacity", command.capacity);
    };
  }
  setSimpleCapacity(simpleCapacity) {
    const { command } = this.props;
    const newViewState = {
      ...command.viewState,
      useSimpleCapacity: simpleCapacity
    };
    this.props.setFieldValue("useSourceCapacity", false);
    this.props.setFieldValue("viewState", newViewState);
    this.setMinMax(command.capacity.desired);
    this.setState({});
  }
  setMinMax(value) {
    const { command } = this.props;
    if (command.viewState.useSimpleCapacity) {
      command.capacity = { min: value, max: value, desired: value };
      this.props.setFieldValue("useSourceCapacity", false);
      this.props.setFieldValue("capacity", command.capacity);
    }
    this.setState({});
  }
  render() {
    const { command, MinMaxDesired } = this.props;
    const readOnlyFields = command.viewState.readOnlyFields || {};
    if (!command.viewState.useSimpleCapacity || command.useSourceCapacity) {
      return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", {
        className: "form-group"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-12"
      }, /* @__PURE__ */ React__default.createElement("p", null, "Sets up auto-scaling constraints for this server group."), /* @__PURE__ */ React__default.createElement("p", null, "To set min, max, and desired instance counts to the same value use the", " ", /* @__PURE__ */ React__default.createElement("a", {
        className: "clickable",
        onClick: () => this.setSimpleCapacity(true)
      }, "Simple Mode"), "."))), !readOnlyFields.useSourceCapacity && command.viewState.mode === "editPipeline" && /* @__PURE__ */ React__default.createElement("div", {
        className: "form-group"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-3 sm-label-right"
      }, "Capacity"), /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-9 radio"
      }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
        type: "radio",
        checked: command.useSourceCapacity,
        value: "true",
        id: "useSourceCapacityTrue",
        onChange: this.useSourceCapacityUpdated
      }), "Copy the capacity from the current server group", /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "serverGroupCapacity.useSourceCapacityTrue"
      }))), command.useSourceCapacity && /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-9 col-md-offset-3 radio",
        style: { paddingLeft: "35px" }
      }, /* @__PURE__ */ React__default.createElement("div", null, "If no current server group is found,", /* @__PURE__ */ React__default.createElement(Select, {
        clearable: false,
        value: !!command.preferSourceCapacity,
        options: this.preferSourceCapacityOptions,
        onChange: this.preferSourceCapacityChanged
      })), command.preferSourceCapacity && /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("b", null, "Fallback values"), /* @__PURE__ */ React__default.createElement(MinMaxDesired, {
        command,
        fieldChanged: this.capacityFieldChanged
      }))), /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-9 col-md-offset-3 radio"
      }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
        type: "radio",
        checked: !command.useSourceCapacity,
        value: "false",
        id: "useSourceCapacityFalse",
        onChange: this.useSourceCapacityUpdated
      }), "Let me specify the capacity", /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "serverGroupCapacity.useSourceCapacityFalse"
      })))), (!command.useSourceCapacity || command.viewState.mode !== "editPipeline") && /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-9 col-md-offset-3"
      }, /* @__PURE__ */ React__default.createElement(MinMaxDesired, {
        command,
        fieldChanged: this.capacityFieldChanged
      }))));
    }
    return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12"
    }, /* @__PURE__ */ React__default.createElement("p", null, "Sets the min, max, and desired instance counts to the same value."), /* @__PURE__ */ React__default.createElement("p", null, " ", "To set capacity for auto-scaling, use the", " ", /* @__PURE__ */ React__default.createElement("a", {
      className: "clickable",
      onClick: () => this.setSimpleCapacity(false)
    }, "Advanced Mode"), "."))), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-3 sm-label-right"
    }, "Number of Instances"), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-8"
    }, /* @__PURE__ */ React__default.createElement(SpelNumberInput, {
      value: command.capacity.desired,
      min: 0,
      onChange: this.simpleInstancesChanged
    }))));
  }
}

class MinMaxDesired extends React__default.Component {
  render() {
    const {
      command: {
        capacity: { min, max, desired }
      },
      fieldChanged
    } = this.props;
    return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-2"
    }, "Min"), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-8"
    }, /* @__PURE__ */ React__default.createElement(SpelNumberInput, {
      value: min,
      min: 0,
      max: typeof max === "number" ? max : void 0,
      onChange: (v) => fieldChanged("min", v),
      required: true
    }))), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-2"
    }, "Max"), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-8"
    }, /* @__PURE__ */ React__default.createElement(SpelNumberInput, {
      value: max,
      min: typeof min === "number" ? min : void 0,
      onChange: (v) => fieldChanged("max", v),
      required: true
    }))), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-2"
    }, "Desired"), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-8"
    }, /* @__PURE__ */ React__default.createElement(SpelNumberInput, {
      value: desired,
      min: typeof min === "number" ? min : void 0,
      max: typeof max === "number" ? max : void 0,
      onChange: (v) => fieldChanged("desired", v),
      required: true
    }))));
  }
}

class ServerGroupCapacity extends React__default.Component {
  validate(values) {
    const errors = {};
    if (values.capacity.min < 0 || values.capacity.max < 0 || values.capacity.desired < 0) {
      errors.capacity = "Capacity min, max, and desired all have to be non-negative values.";
    }
    const amazonValues = values;
    if (amazonValues.targetHealthyDeployPercentage === void 0 || amazonValues.targetHealthyDeployPercentage === null) {
      errors.targetHealthyDeployPercentage = "Target Healthy Deploy Percentage required.";
    }
    return errors;
  }
  render() {
    const { setFieldValue, values } = this.props.formik;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "container-fluid form-horizontal"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12"
    }, /* @__PURE__ */ React__default.createElement(CapacitySelector, {
      command: values,
      setFieldValue,
      MinMaxDesired
    }))), /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group form-inline",
      style: { marginTop: "20px" }
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12"
    }, "Consider deployment successful when", " ", /* @__PURE__ */ React__default.createElement(Field, {
      type: "number",
      name: "targetHealthyDeployPercentage",
      min: "0",
      max: "100",
      className: "form-control input-sm inline-number",
      required: true
    }), " ", "percent of instances are healthy.")))));
  }
}

var css_248z$d = ".advanced-mode-selector .instance-profile-header {\n  display: inline-block;\n}\n.advanced-mode-selector .instance-profile-header button {\n  width: 100%;\n}\n.advanced-mode-selector .instance-profile-header h4 {\n  min-height: 52px;\n}\n.advanced-mode-selector .instance-profile-header .panel-heading {\n  padding: 0 0 0 0;\n}\n.advanced-mode-selector .instance-profile-header.profile-button {\n  width: calc(25% - 20px);\n  margin: 0 10px 15px 10px;\n}\n.advanced-mode-selector .sub-section {\n  padding: 0 15px;\n  margin-bottom: 5px;\n}\n.advanced-mode-selector .sub-section .description {\n  padding: 0 10px;\n}\n.advanced-mode-selector .sub-section tr.unavailable {\n  opacity: 0.5;\n}\n.advanced-mode-selector .sub-section tr.sortable .instance-type-drag-handle {\n  display: inline-block;\n  opacity: 0.9;\n  font-size: 100%;\n  padding-top: 8px;\n}\n.advanced-mode-selector .sub-section th {\n  font-size: 110%;\n}\n.custom-profile .select {\n  width: 80%;\n}\n.instance-profile {\n  vertical-align: top;\n  text-align: left;\n  min-height: 100px;\n  font-size: 90%;\n  border: 1px solid var(--color-silver);\n  border-radius: 3px;\n  color: var(--color-mineshaft);\n  background-color: transparent;\n}\n.instance-profile:hover,\n.instance-profile:focus {\n  color: var(--color-mineshaft);\n  text-decoration: none;\n}\n.instance-profile .selected-indicator {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  text-align: right;\n  padding-right: 5px;\n  font-size: 150%;\n  color: var(--color-accent);\n}\n.instance-profile .selected-indicator.custom {\n  margin-top: 5px;\n}\n.instance-profile h4 {\n  margin-top: 0;\n  text-align: center;\n  word-spacing: 300px;\n}\n.instance-profile ul {\n  font-size: 95%;\n  padding-left: 20px;\n}\n.instance-profile .panel-heading {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.instance-profile:hover,\n.instance-profile:focus,\n.instance-profile.active {\n  outline: 0;\n}\n.instance-profile.active {\n  -webkit-box-shadow: inset 0 0 3px 2px var(--color-accent);\n          box-shadow: inset 0 0 3px 2px var(--color-accent);\n  border-color: var(--color-accent);\n}\n.instance-profile:hover,\n.instance-profile:focus {\n  -webkit-box-shadow: 0 0 8px 2px var(--color-accent);\n          box-shadow: 0 0 8px 2px var(--color-accent);\n}\n";
styleInject(css_248z$d);

function InstanceProfileSelector(props) {
  return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("h4", {
    style: { marginTop: "10px" }
  }, "This application is"), props.instanceProfileList.map((profile) => /* @__PURE__ */ React__default.createElement("div", {
    key: profile.type,
    className: `instance-profile-header profile-button`
  }, /* @__PURE__ */ React__default.createElement("button", {
    type: "button",
    onClick: () => props.handleProfileChange(profile.type),
    className: props.currentProfile === profile.type ? "instance-profile active" : "instance-profile"
  }, props.currentProfile === profile.type && /* @__PURE__ */ React__default.createElement("span", {
    className: "far fa-check-circle selected-indicator"
  }), /* @__PURE__ */ React__default.createElement("div", {
    className: "panel-heading"
  }, /* @__PURE__ */ React__default.createElement("h4", null, /* @__PURE__ */ React__default.createElement("span", {
    className: `glyphicon glyphicon-${profile.icon}`
  }), /* @__PURE__ */ React__default.createElement("div", null, profile.label)))))));
}

function CpuCreditsToggle(props) {
  const { selectedInstanceTypes, currentProfile } = props;
  const isBurstingSupportedForAllTypes = AwsReactInjector.awsInstanceTypeService.isBurstingSupportedForAllTypes(selectedInstanceTypes);
  const isAtleastOneTypeInProfile = AwsReactInjector.awsInstanceTypeService.getInstanceTypesInCategory(selectedInstanceTypes, currentProfile).length ? true : false;
  const [showToggle, setShowToggle] = useState(false);
  useEffect(() => {
    if (selectedInstanceTypes && selectedInstanceTypes.length) {
      if (!isBurstingSupportedForAllTypes) {
        props.setUnlimitedCpuCredits(void 0);
      }
      setShowToggle(isBurstingSupportedForAllTypes);
    }
    if (currentProfile) {
      setShowToggle(selectedInstanceTypes && selectedInstanceTypes.length > 0 && isBurstingSupportedForAllTypes && isAtleastOneTypeInProfile);
    }
  }, [currentProfile, selectedInstanceTypes]);
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "row",
    style: { fontSize: "110%" }
  }, showToggle && /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(ToggleButtonGroup, {
    toggleSize: ToggleSize.XSMALL,
    propLabel: "Unlimited CPU credits ",
    propHelpFieldId: "aws.serverGroup.unlimitedCpuCredits",
    tooltipPropOffBtn: "Toggle to turn OFF unlimited CPU credits",
    displayTextPropOffBtn: "Off",
    tooltipPropOnBtn: "Toggle to turn ON unlimited CPU credits",
    displayTextPropOnBtn: "On",
    onClick: (b) => props.setUnlimitedCpuCredits(b),
    isPropertyActive: props.unlimitedCpuCredits
  })));
}

const CostFactor = ({ min, max }) => {
  const MAX_DOLLARS = 4;
  const minDollars = /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("span", {
    className: "cost"
  }, "$".repeat(min)), "$".repeat(MAX_DOLLARS - min));
  const maxDollars = /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("span", {
    className: "cost"
  }, "$".repeat(Math.min(MAX_DOLLARS, max))), "$".repeat(MAX_DOLLARS - Math.min(MAX_DOLLARS, max)));
  return /* @__PURE__ */ React__default.createElement("span", {
    className: "cost-factor"
  }, minDollars, max ? ` - ${maxDollars}` : "");
};

function InstanceTypeRow(props) {
  var _a, _b;
  const isRowSelected = props.selectedType ? true : false;
  const [newWeightedCap, setNewWeightedCap] = useState("");
  const instanceType = isRowSelected ? props.selectedType.instanceType : props.instanceTypeDetails.name;
  const disableRow = isRowSelected ? false : props.instanceTypeDetails.unavailable;
  const selectOrUpdateRow = (instanceType2, weight) => {
    if (!disableRow) {
      props.addOrUpdateInstanceType(instanceType2, weight);
    }
    setNewWeightedCap("");
  };
  const handleWeightChange = (e) => {
    setNewWeightedCap(e.target.value);
    if (isRowSelected) {
      selectOrUpdateRow(instanceType, e.target.value);
    } else {
      document.getElementById(`selectInstanceType-${instanceType}`).focus();
    }
  };
  let row;
  if (props.isCustom) {
    row = /* @__PURE__ */ React__default.createElement("tr", {
      key: instanceType,
      className: "sortable clickable"
    }, /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement(DragHandle, null)), /* @__PURE__ */ React__default.createElement("td", null, instanceType), /* @__PURE__ */ React__default.createElement("td", {
      title: "Enter optional weight (allowed values: 1 to 999)."
    }, /* @__PURE__ */ React__default.createElement(TextInput, {
      className: "form-control input input-sm",
      pattern: "[0-9]*",
      placeholder: "Enter optional weight (allowed values: 1 to 999).",
      value: ((_a = props.selectedType) == null ? void 0 : _a.weightedCapacity) || "",
      onChange: (e) => selectOrUpdateRow(instanceType, e.target.value)
    })), /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("a", {
      className: "btn btn-sm btn-link clickable",
      onClick: () => props.removeInstanceType(instanceType),
      style: { padding: "5px" }
    }, /* @__PURE__ */ React__default.createElement(Tooltip, {
      value: "Remove instance type"
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-trash"
    })))))));
  } else {
    const { cpu, memory, cpuCreditsPerHour, storage, costFactor } = props.instanceTypeDetails;
    row = /* @__PURE__ */ React__default.createElement("tr", {
      key: instanceType,
      className: isRowSelected ? "sortable clickable" : `non-sortable ${disableRow ? "unavailable" : "clickable"}`,
      title: isRowSelected ? "Click to unselect instance type" : disableRow ? "This instance type is not available for the selected configuration" : "Click to select instance type",
      onClick: (e) => {
        if (!$(e.target).is("input")) {
          isRowSelected ? props.removeInstanceType(instanceType) : selectOrUpdateRow(instanceType, newWeightedCap);
        }
      }
    }, isRowSelected ? /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement(DragHandle, null)) : /* @__PURE__ */ React__default.createElement("td", null), /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement(Checkbox, {
      id: `selectInstanceType-${instanceType}`,
      checked: isRowSelected ? true : false,
      disabled: disableRow,
      onChange: () => {
        isRowSelected ? props.removeInstanceType(instanceType) : selectOrUpdateRow(instanceType, newWeightedCap);
      }
    })), /* @__PURE__ */ React__default.createElement("td", null, instanceType), /* @__PURE__ */ React__default.createElement("td", null, cpu), /* @__PURE__ */ React__default.createElement("td", null, memory), cpuCreditsPerHour ? /* @__PURE__ */ React__default.createElement("td", null, cpuCreditsPerHour) : /* @__PURE__ */ React__default.createElement("td", {
      title: "Cpu credits not applicable to instance type."
    }, "-"), storage.type === "EBS" && /* @__PURE__ */ React__default.createElement("td", null, "EBS Only"), storage.type === "SSD" && /* @__PURE__ */ React__default.createElement("td", null, storage.count + "x" + storage.size), /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement(CostFactor, {
      min: costFactor
    })), /* @__PURE__ */ React__default.createElement("td", {
      title: !disableRow ? "Enter optional weight (allowed values: 1 to 999)." : ""
    }, /* @__PURE__ */ React__default.createElement(TextInput, {
      inputClassName: "form-control input input-sm",
      id: `weightedCapacity-${instanceType}`,
      pattern: "[0-9]*",
      placeholder: "Enter optional weight (allowed values: 1 to 999).",
      disabled: disableRow,
      value: ((_b = props.selectedType) == null ? void 0 : _b.weightedCapacity) || newWeightedCap || "",
      onChange: handleWeightChange
    })));
  }
  return row;
}
const DragHandle = SortableHandle(() => /* @__PURE__ */ React__default.createElement(Tooltip, {
  value: "Drag to change priority"
}, /* @__PURE__ */ React__default.createElement("span", {
  className: "instance-type-drag-handle glyphicon glyphicon-resize-vertical"
})));

function InstanceTypeTableBody(props) {
  return /* @__PURE__ */ React__default.createElement(TableRows, {
    isCustom: props.isCustom,
    selectedInstanceTypesMap: props.selectedInstanceTypesMap,
    removeInstanceType: props.removeInstanceType,
    addOrUpdateInstanceType: props.addOrUpdateInstanceType,
    instanceTypeDetails: props.isCustom ? null : new Map(Object.entries(keyBy(flatten(props.profileFamiliesDetails.map((f) => f.instanceTypes)), "name"))),
    onSortEnd: (sortEnd) => props.handleSortEnd(sortEnd),
    distance: 1
  });
}
const TableRows = SortableContainer((props) => {
  const { isCustom, selectedInstanceTypesMap } = props;
  let selectedRows, unselectedRows;
  if (isCustom) {
    selectedRows = selectedInstanceTypesMap.size > 0 && Array.from(selectedInstanceTypesMap.values()).sort((i1, i2) => i1.priority - i2.priority).map((selectedType, index) => /* @__PURE__ */ React__default.createElement(SortableRow, {
      key: `${selectedType.instanceType}-${index}`,
      index,
      isCustom: true,
      selectedType,
      removeInstanceType: props.removeInstanceType,
      addOrUpdateInstanceType: props.addOrUpdateInstanceType
    }));
  } else {
    const { instanceTypeDetails } = props;
    const instanceTypesInProfile = Array.from(instanceTypeDetails == null ? void 0 : instanceTypeDetails.keys());
    const unselectedInstanceTypes = difference(instanceTypesInProfile, Array.from(selectedInstanceTypesMap.keys()));
    const selectedRowsOrdered = Array.from(selectedInstanceTypesMap.values()).filter((selectedType) => instanceTypesInProfile.includes(selectedType.instanceType)).sort((i1, i2) => i1.priority - i2.priority);
    selectedRows = selectedRowsOrdered && selectedRowsOrdered.length > 0 && selectedRowsOrdered.map((selectedType, index) => /* @__PURE__ */ React__default.createElement(SortableRow, {
      key: `${selectedType.instanceType}-${index}`,
      index,
      isCustom: false,
      selectedType,
      instanceTypeDetails,
      removeInstanceType: props.removeInstanceType,
      addOrUpdateInstanceType: props.addOrUpdateInstanceType
    }));
    unselectedRows = unselectedInstanceTypes && unselectedInstanceTypes.length > 0 && unselectedInstanceTypes.map((instanceType) => /* @__PURE__ */ React__default.createElement(InstanceTypeRow, {
      key: instanceType,
      isCustom: false,
      instanceTypeDetails: instanceTypeDetails.get(instanceType),
      addOrUpdateInstanceType: props.addOrUpdateInstanceType
    }));
  }
  return /* @__PURE__ */ React__default.createElement("tbody", null, selectedRows, !isCustom ? unselectedRows : null);
});
const SortableRow = SortableElement((props) => /* @__PURE__ */ React__default.createElement(InstanceTypeRow, {
  key: props.selectedType.instanceType,
  isCustom: props.isCustom,
  selectedType: props.selectedType,
  instanceTypeDetails: !props.isCustom ? props.instanceTypeDetails.get(props.selectedType.instanceType) : null,
  removeInstanceType: props.removeInstanceType,
  addOrUpdateInstanceType: props.addOrUpdateInstanceType
}));

function Heading(props) {
  let description;
  if (props.isCustom) {
    description = /* @__PURE__ */ React__default.createElement("p", null, "Choose the instance types that best suit the needs of your application.");
  } else {
    description = /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("b", null, props.profileLabel)), /* @__PURE__ */ React__default.createElement("ul", null, props.profileDescriptionArr.map((d, index) => /* @__PURE__ */ React__default.createElement("li", {
      key: index
    }, d))));
  }
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "row sub-section"
  }, /* @__PURE__ */ React__default.createElement("h4", null, "Instance Types"), /* @__PURE__ */ React__default.createElement("div", {
    className: "description"
  }, description, /* @__PURE__ */ React__default.createElement("i", null, /* @__PURE__ */ React__default.createElement("b", null, "Note:"), /* @__PURE__ */ React__default.createElement("ul", null, /* @__PURE__ */ React__default.createElement("li", null, "The order of instance types sets their priority when On-Demand capacity is launched; instance type at the top is prioritized the highest."), /* @__PURE__ */ React__default.createElement("li", null, "Some instance types might not be available for the selected configuration.")))));
}
function Header(props) {
  let emptyHeaders, instanceTypeHeader, otherHeaders, tailingEmptyHeader;
  if (props.isCustom) {
    emptyHeaders = /* @__PURE__ */ React__default.createElement("th", null);
    instanceTypeHeader = /* @__PURE__ */ React__default.createElement("th", null, "Instance Type ", /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "aws.serverGroup.instanceTypes"
    }));
    otherHeaders = null;
    tailingEmptyHeader = /* @__PURE__ */ React__default.createElement("th", null);
  } else {
    emptyHeaders = /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("th", null), /* @__PURE__ */ React__default.createElement("th", null));
    instanceTypeHeader = /* @__PURE__ */ React__default.createElement("th", null, "InstanceType");
    otherHeaders = /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("th", null, "vCPU"), /* @__PURE__ */ React__default.createElement("th", null, "Mem (GiB)"), props.showCpuCredits && /* @__PURE__ */ React__default.createElement("th", null, "CPU Credits"), /* @__PURE__ */ React__default.createElement("th", null, "Storage (GB)", /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "aws.serverGroup.storageType"
    })), /* @__PURE__ */ React__default.createElement("th", null, "Cost"));
    tailingEmptyHeader = null;
  }
  return /* @__PURE__ */ React__default.createElement("thead", null, /* @__PURE__ */ React__default.createElement("tr", null, emptyHeaders, instanceTypeHeader, otherHeaders, /* @__PURE__ */ React__default.createElement("th", null, "Weight ", /* @__PURE__ */ React__default.createElement(HelpField, {
    id: "aws.serverGroup.instanceTypeWeight"
  })), tailingEmptyHeader));
}
function Footer(props) {
  return props.isCustom ? /* @__PURE__ */ React__default.createElement("tfoot", null, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement("span", {
    className: "glyphicon glyphicon-plus-sign",
    style: { paddingTop: "8px" }
  })), /* @__PURE__ */ React__default.createElement("td", {
    colSpan: 2
  }, /* @__PURE__ */ React__default.createElement(InstanceTypeSelect, {
    availableInstanceTypesList: props.availableInstanceTypesList,
    addOrUpdateInstanceType: props.addOrUpdateInstanceType
  })), /* @__PURE__ */ React__default.createElement("td", null))) : null;
}
const InstanceTypeSelect = (props) => {
  const instanceTypeListOptions = props.availableInstanceTypesList.map((instanceType) => {
    return { label: instanceType, value: instanceType };
  });
  return /* @__PURE__ */ React__default.createElement(Select, {
    clearable: false,
    multi: false,
    placeholder: "Select an instance type to add...",
    removeSelected: true,
    searchable: true,
    options: instanceTypeListOptions,
    onChange: (o) => props.addOrUpdateInstanceType(o.value, void 0)
  });
};

function InstanceTypeWarning(props) {
  if (props.dirty.instanceType || props.dirty.launchTemplateOverridesForInstanceType && props.dirty.launchTemplateOverridesForInstanceType.length > 0) {
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "alert alert-warning"
    }, /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("i", {
      className: "fa fa-exclamation-triangle"
    }), props.dirty.instanceType && "The following instance type was found incompatible with the selected image/region and was removed:", props.dirty.launchTemplateOverridesForInstanceType && props.dirty.launchTemplateOverridesForInstanceType.length > 0 && "The following instance type(s) were found incompatible with the selected image/region and were removed:"), /* @__PURE__ */ React__default.createElement("ul", null, props.dirty.instanceType && /* @__PURE__ */ React__default.createElement("li", {
      key: props.dirty.instanceType
    }, props.dirty.instanceType), props.dirty.launchTemplateOverridesForInstanceType && props.dirty.launchTemplateOverridesForInstanceType.length > 0 && props.dirty.launchTemplateOverridesForInstanceType.map((it) => /* @__PURE__ */ React__default.createElement("li", {
      key: it.instanceType
    }, it.instanceType, it.weightedCapacity ? " with weight " + it.weightedCapacity : ""))), /* @__PURE__ */ React__default.createElement("p", {
      className: "text-right"
    }, /* @__PURE__ */ React__default.createElement("a", {
      className: "btn btn-sm btn-default dirty-flag-dismiss clickable",
      onClick: () => props.clearWarnings()
    }, "Okay"))));
  } else {
    return null;
  }
}

function InstanceTypeTable(props) {
  var _a;
  const { currentProfile, selectedInstanceTypesMap } = props;
  const handleSortEnd = (sortEnd) => {
    const sortedInstanceTypes = Array.from(selectedInstanceTypesMap.values()).sort((i1, i2) => i1.priority - i2.priority).map((it) => it.instanceType);
    const instanceTypesInNewOrder = arrayMove(sortedInstanceTypes, sortEnd.oldIndex, sortEnd.newIndex);
    updatePriorityForSelectedTypes(instanceTypesInNewOrder);
  };
  const updatePriorityForSelectedTypes = (instanceTypesInNewOrder) => {
    selectedInstanceTypesMap.forEach((value, key) => {
      const newPriority = 1 + instanceTypesInNewOrder.indexOf(key);
      if (value.priority !== newPriority) {
        value.priority = newPriority;
      }
    });
    props.handleInstanceTypesChange(Array.from(selectedInstanceTypesMap.values()));
  };
  const removeInstanceType = (instanceType) => {
    const selectedInstanceTypesMapNew = new Map(selectedInstanceTypesMap);
    selectedInstanceTypesMapNew.delete(instanceType);
    props.handleInstanceTypesChange(Array.from(selectedInstanceTypesMapNew.values()));
  };
  const addOrUpdateInstanceType = (type, weight) => {
    const weightNum = Number(weight);
    const weightedCapacity = isNaN(weightNum) || weightNum === 0 ? void 0 : weightNum.toString();
    const itemToUpdate = selectedInstanceTypesMap.has(type) ? {
      ...selectedInstanceTypesMap.get(type),
      weightedCapacity
    } : {
      instanceType: type,
      weightedCapacity,
      priority: 1 + Array.from(selectedInstanceTypesMap.values()).reduce((max, it) => it.priority > max ? it.priority : max, 0)
    };
    selectedInstanceTypesMap.set(type, itemToUpdate);
    props.handleInstanceTypesChange(Array.from(selectedInstanceTypesMap.values()));
  };
  const isCpuCreditsEnabled = (_a = AWSProviderSettings.serverGroups) == null ? void 0 : _a.enableCpuCredits;
  const selectedInstanceTypeNames = Array.from(selectedInstanceTypesMap.keys());
  const cpuCreditsToggle = /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(CpuCreditsToggle, {
    unlimitedCpuCredits: props.unlimitedCpuCreditsInCmd,
    currentProfile,
    selectedInstanceTypes: selectedInstanceTypeNames,
    setUnlimitedCpuCredits: props.setUnlimitedCpuCredits
  }));
  if (currentProfile && currentProfile !== "custom") {
    const { label, descriptionListOverride, families, showCpuCredits } = props.profileDetails;
    const isCustom = false;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "row sub-section"
    }, /* @__PURE__ */ React__default.createElement(Heading, {
      isCustom,
      profileLabel: label,
      profileDescriptionArr: descriptionListOverride ? descriptionListOverride : families.map((f) => f.description)
    }), /* @__PURE__ */ React__default.createElement(InstanceTypeWarning, {
      dirty: props.viewState.dirty,
      clearWarnings: props.clearWarnings
    }), isCpuCreditsEnabled && cpuCreditsToggle, /* @__PURE__ */ React__default.createElement("table", {
      className: "table table-hover"
    }, /* @__PURE__ */ React__default.createElement(Header, {
      isCustom,
      showCpuCredits
    }), /* @__PURE__ */ React__default.createElement(InstanceTypeTableBody, {
      isCustom,
      profileFamiliesDetails: families,
      selectedInstanceTypesMap,
      addOrUpdateInstanceType,
      removeInstanceType,
      handleSortEnd
    })));
  } else {
    const isCustom = true;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "row sub-section"
    }, /* @__PURE__ */ React__default.createElement(Heading, {
      isCustom
    }), /* @__PURE__ */ React__default.createElement(InstanceTypeWarning, {
      dirty: props.viewState.dirty,
      clearWarnings: props.clearWarnings
    }), isCpuCreditsEnabled && cpuCreditsToggle, /* @__PURE__ */ React__default.createElement("table", {
      className: "table table-hover"
    }, /* @__PURE__ */ React__default.createElement(Header, {
      isCustom
    }), /* @__PURE__ */ React__default.createElement(InstanceTypeTableBody, {
      isCustom,
      selectedInstanceTypesMap,
      addOrUpdateInstanceType,
      removeInstanceType,
      handleSortEnd
    }), /* @__PURE__ */ React__default.createElement(Footer, {
      isCustom,
      availableInstanceTypesList: props.availableInstanceTypesList.filter((it) => !selectedInstanceTypeNames.includes(it)),
      addOrUpdateInstanceType
    })));
  }
}

var css_248z$c = ".InstancesDistribution .StandardFieldLayout_Label {\n  min-width: 300px;\n}\n";
styleInject(css_248z$c);

function useDefaultFormikValue(formik, field, defaultValue) {
  const value = get(formik.values, field);
  React__default.useEffect(() => {
    if (value === void 0 && defaultValue !== void 0) {
      formik.setFieldValue(field, defaultValue);
    }
  }, [field, defaultValue, value]);
}
function InstancesDistribution(props) {
  const { values: command, setFieldValue } = props.formik;
  const spotAllocStrategyOptions = [
    { label: "capacity-optimized (recommended)", value: "capacity-optimized" },
    { label: "capacity-optimized-prioritized", value: "capacity-optimized-prioritized" },
    { label: "lowest-price", value: "lowest-price" }
  ];
  React__default.useEffect(() => {
    if (command.spotAllocationStrategy !== "lowest-price") {
      setFieldValue("spotInstancePools", void 0);
    } else if (command.spotInstancePools === void 0) {
      setFieldValue("spotInstancePools", 2);
    }
  }, [command.spotAllocationStrategy]);
  useDefaultFormikValue(props.formik, "spotAllocationStrategy", "capacity-optimized");
  useDefaultFormikValue(props.formik, "onDemandAllocationStrategy", "prioritized");
  useDefaultFormikValue(props.formik, "onDemandBaseCapacity", 0);
  useDefaultFormikValue(props.formik, "onDemandPercentageAboveBaseCapacity", 100);
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "InstancesDistribution row sub-section form-group"
  }, /* @__PURE__ */ React__default.createElement("h4", null, "Instances Distribution"), /* @__PURE__ */ React__default.createElement("div", {
    className: "description"
  }, "Diversify and distribute instance types across purchase options.", " ", /* @__PURE__ */ React__default.createElement(HelpField, {
    id: "aws.serverGroup.instancesDistribution"
  })), /* @__PURE__ */ React__default.createElement("br", null), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    label: "Spot Allocation Strategy",
    name: "spotAllocationStrategy",
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "aws.serverGroup.spotAllocationStrategy"
    }),
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
      ...inputProps,
      mode: "PLAIN",
      options: spotAllocStrategyOptions
    })
  }), props.formik.values.spotAllocationStrategy === "lowest-price" && /* @__PURE__ */ React__default.createElement(FormikFormField, {
    label: "Spot Instance Pools Count",
    name: "spotInstancePools",
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "aws.serverGroup.spotInstancePoolCount"
    }),
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(NumberInput, {
      ...inputProps
    })
  }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    label: "On-Demand Allocation Strategy",
    name: "onDemandAllocationStrategy",
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "aws.serverGroup.odAllocationStrategy"
    }),
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(TextInput, {
      ...inputProps,
      disabled: true
    })
  }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    label: "On-Demand Base Capacity",
    name: "onDemandBaseCapacity",
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "aws.serverGroup.odBase"
    }),
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(NumberInput, {
      ...inputProps
    })
  }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    label: "On-Demand Percentage Above Base Capacity",
    name: "onDemandPercentageAboveBaseCapacity",
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "aws.serverGroup.odPercentAboveBase"
    }),
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(NumberInput, {
      ...inputProps
    })
  }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    label: "Spot Max Price",
    name: "spotPrice",
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "aws.serverGroup.spotMaxPrice"
    }),
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(Tooltip, {
      value: "Recommended to leave empty and use AWS default i.e. On-Demand price"
    }, /* @__PURE__ */ React__default.createElement(TextInput, {
      ...inputProps
    }))
  }));
}

function AdvancedModeSelector(props) {
  const { instanceTypeDetails, setUnlimitedCpuCredits } = props;
  const { values: command, setFieldValue } = props.formik;
  const { instanceType, launchTemplateOverridesForInstanceType } = command;
  useEffect(() => {
    if (!launchTemplateOverridesForInstanceType && instanceType) {
      props.formik.setFieldValue("launchTemplateOverridesForInstanceType", [
        { instanceType: command.instanceType, priority: 1 }
      ]);
    }
  });
  const instanceTypesInProps = command.launchTemplateOverridesForInstanceType ? command.launchTemplateOverridesForInstanceType : void 0;
  const selectedInstanceTypesMap = new Map(Object.entries(keyBy(instanceTypesInProps, "instanceType")));
  const [instanceProfile, setInstanceProfile] = useState(command.viewState.instanceProfile || "custom");
  const prevInstanceProfile = usePrevious(instanceProfile);
  const handleProfileChange = (newProfile) => {
    setInstanceProfile(newProfile);
    setFieldValue("viewState", {
      ...command.viewState,
      instanceProfile: newProfile
    });
    const hasProfileChanged = prevInstanceProfile && newProfile && prevInstanceProfile !== newProfile;
    const isInstanceTypesUpdateNeeded = newProfile !== "custom" && instanceTypesInProps && instanceTypesInProps.length;
    if (hasProfileChanged && isInstanceTypesUpdateNeeded) {
      const instanceTypesInProfile = AwsReactInjector.awsInstanceTypeService.getInstanceTypesInCategory(instanceTypesInProps.map((it) => it.instanceType), newProfile);
      const newMultipleTypes = instanceTypesInProps.filter((o) => instanceTypesInProfile.includes(o.instanceType));
      setFieldValue("launchTemplateOverridesForInstanceType", newMultipleTypes);
      command.launchTemplateOverridesChanged(command);
    }
  };
  const handleInstanceTypesChange = (types) => {
    setFieldValue("launchTemplateOverridesForInstanceType", types);
    command.launchTemplateOverridesChanged(command);
  };
  if (!(instanceTypeDetails && instanceTypeDetails.length > 0)) {
    return null;
  }
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "advanced-mode-selector"
  }, /* @__PURE__ */ React__default.createElement(InstanceProfileSelector, {
    currentProfile: instanceProfile,
    handleProfileChange,
    instanceProfileList: instanceTypeDetails
  }), /* @__PURE__ */ React__default.createElement(InstancesDistribution, {
    formik: props.formik
  }), /* @__PURE__ */ React__default.createElement(InstanceTypeTable, {
    currentProfile: instanceProfile,
    selectedInstanceTypesMap,
    unlimitedCpuCreditsInCmd: command.unlimitedCpuCredits,
    profileDetails: instanceTypeDetails.find((p) => p.type === instanceProfile),
    availableInstanceTypesList: command.backingData && command.backingData.filtered && command.backingData.filtered.instanceTypes || [],
    handleInstanceTypesChange,
    setUnlimitedCpuCredits,
    viewState: command.viewState,
    clearWarnings: props.clearWarnings
  }));
}

function SimpleModeSelector(props) {
  var _a, _b;
  const { command } = props;
  const { InstanceArchetypeSelector, InstanceTypeSelector } = NgReact;
  const isLaunchTemplatesEnabled = (_a = AWSProviderSettings.serverGroups) == null ? void 0 : _a.enableLaunchTemplates;
  const isCpuCreditsEnabled = (_b = AWSProviderSettings.serverGroups) == null ? void 0 : _b.enableCpuCredits;
  const instanceProfileChanged = (newProfile) => {
    props.setFieldValue("viewState", {
      ...command.viewState,
      instanceProfile: newProfile
    });
  };
  const instanceTypeChanged = (type) => {
    command.instanceTypeChanged(command);
    props.setFieldValue("instanceType", type);
  };
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "container-fluid form-horizontal"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement(InstanceArchetypeSelector, {
    command,
    onTypeChanged: instanceTypeChanged,
    onProfileChanged: instanceProfileChanged
  }), /* @__PURE__ */ React__default.createElement(InstanceTypeWarning, {
    dirty: command.viewState.dirty,
    clearWarnings: props.clearWarnings
  }), /* @__PURE__ */ React__default.createElement("div", {
    style: { padding: "0 15px" }
  }, command.viewState.instanceProfile && command.viewState.instanceProfile !== "custom" && /* @__PURE__ */ React__default.createElement(InstanceTypeSelector, {
    command,
    onTypeChanged: instanceTypeChanged
  }))), isLaunchTemplatesEnabled && isCpuCreditsEnabled && /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement(CpuCreditsToggle, {
    unlimitedCpuCredits: command.unlimitedCpuCredits,
    selectedInstanceTypes: [command.instanceType],
    currentProfile: command.viewState.instanceProfile,
    setUnlimitedCpuCredits: props.setUnlimitedCpuCredits
  })));
}

function InstanceTypeSelector(props) {
  var _a;
  const { instanceTypeDetails } = props;
  const { values, setFieldValue } = props.formik;
  const isLaunchTemplatesEnabled = (_a = AWSProviderSettings.serverGroups) == null ? void 0 : _a.enableLaunchTemplates;
  const useSimpleMode = values.viewState.useSimpleInstanceTypeSelector;
  const [unlimitedCpuCredits, setUnlimitedCpuCredits] = useState(values.unlimitedCpuCredits);
  useEffect(() => {
    if (values.unlimitedCpuCredits !== unlimitedCpuCredits) {
      setFieldValue("unlimitedCpuCredits", unlimitedCpuCredits);
    }
  }, [unlimitedCpuCredits]);
  const clearWarnings = () => {
    const { formik } = props;
    formik.values.viewState.dirty["instanceType"] = null;
    formik.values.viewState.dirty["launchTemplateOverridesForInstanceType"] = null;
    formik.validateForm();
  };
  const handleModeChange = (useSimpleModeNew) => {
    if (useSimpleMode !== useSimpleModeNew) {
      setFieldValue("viewState", {
        ...values.viewState,
        useSimpleInstanceTypeSelector: useSimpleModeNew
      });
      if (useSimpleModeNew) {
        const multipleInstanceTypesInProps = values.launchTemplateOverridesForInstanceType;
        const dirtyMultipleInstanceTypesInProps = values.viewState.dirty.launchTemplateOverridesForInstanceType;
        if (multipleInstanceTypesInProps == null ? void 0 : multipleInstanceTypesInProps.length) {
          const instanceTypeWithHighestPriority = multipleInstanceTypesInProps.reduce((prev, current) => {
            return prev.priority < current.priority ? prev : current;
          }).instanceType;
          setFieldValue("instanceType", instanceTypeWithHighestPriority);
          setFieldValue("launchTemplateOverridesForInstanceType", []);
          values.instanceTypeChanged(values);
        }
        if (dirtyMultipleInstanceTypesInProps == null ? void 0 : dirtyMultipleInstanceTypesInProps.length) {
          const instanceTypeWithHighestPriorityDirty = dirtyMultipleInstanceTypesInProps.reduce((prev, current) => {
            return prev.priority < current.priority ? prev : current;
          }).instanceType;
          setFieldValue("viewState.dirty.instanceType", instanceTypeWithHighestPriorityDirty);
          setFieldValue("viewState.dirty.launchTemplateOverridesForInstanceType", []);
        }
      } else if (!useSimpleModeNew) {
        const singleInstanceTypeInProps = values.instanceType;
        const dirtySingleInstanceTypeInProps = values.viewState.dirty.instanceType;
        if (singleInstanceTypeInProps) {
          const instanceTypes = [
            {
              instanceType: singleInstanceTypeInProps,
              priority: 1
            }
          ];
          setFieldValue("instanceType", void 0);
          setFieldValue("launchTemplateOverridesForInstanceType", instanceTypes);
          values.launchTemplateOverridesChanged(values);
        }
        if (dirtySingleInstanceTypeInProps) {
          const dirtyInstanceTypes = [
            {
              instanceType: dirtySingleInstanceTypeInProps,
              priority: 1
            }
          ];
          setFieldValue("viewState.dirty.instanceType", void 0);
          setFieldValue("viewState.dirty.launchTemplateOverridesForInstanceType", dirtyInstanceTypes);
        }
      }
    }
  };
  const showAdvancedMode = isLaunchTemplatesEnabled && !useSimpleMode;
  if (showAdvancedMode) {
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "container-fluid form-horizontal",
      style: { padding: "0 15px" }
    }, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("p", null, "To configure a single instance type, use", /* @__PURE__ */ React__default.createElement("a", {
      className: "clickable",
      onClick: () => handleModeChange(true)
    }, /* @__PURE__ */ React__default.createElement("span", null, " Simple Mode")), "."), /* @__PURE__ */ React__default.createElement("i", null, /* @__PURE__ */ React__default.createElement("b", null, "Note:"), " If multiple instance types are already selected in advanced mode, the instance type with highest priority will be preserved in simple mode.")), /* @__PURE__ */ React__default.createElement(AdvancedModeSelector, {
      formik: props.formik,
      instanceTypeDetails,
      setUnlimitedCpuCredits,
      clearWarnings
    }));
  }
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "container-fluid form-horizontal",
    style: { padding: "0 15px" }
  }, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("span", null, "To configure mixed server groups with multiple instance types,"), !isLaunchTemplatesEnabled && /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("a", {
    href: "https://spinnaker.io/docs/setup/other_config/server-group-launch-settings/aws-ec2/launch-templates-setup/"
  }, /* @__PURE__ */ React__default.createElement("span", null, " enable launch templates")), /* @__PURE__ */ React__default.createElement("span", null, " and")), /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("a", {
    className: isLaunchTemplatesEnabled ? "clickable" : "disabled",
    onClick: isLaunchTemplatesEnabled ? () => handleModeChange(false) : () => {
    }
  }, /* @__PURE__ */ React__default.createElement("span", null, " use Advanced Mode ")), /* @__PURE__ */ React__default.createElement(HelpField, {
    id: "aws.serverGroup.advancedMode"
  }), "."), /* @__PURE__ */ React__default.createElement("p", null), isLaunchTemplatesEnabled && /* @__PURE__ */ React__default.createElement("i", null, /* @__PURE__ */ React__default.createElement("b", null, "Note:"), " If an instance type is already selected in simple mode, it will be preserved in advanced mode.")), /* @__PURE__ */ React__default.createElement(SimpleModeSelector, {
    command: values,
    setUnlimitedCpuCredits,
    setFieldValue,
    clearWarnings
  }));
}

class ServerGroupInstanceType extends React__default.Component {
  constructor() {
    super(...arguments);
    this.state = {
      instanceTypeDetails: []
    };
    this.props$ = new Subject();
    this.destroy$ = new Subject();
  }
  validate(values) {
    const errors = {};
    if (values.viewState.useSimpleInstanceTypeSelector) {
      if (values.viewState.dirty.instanceType) {
        errors.instanceType = "You must confirm removed instance type and pick a compatible instance type.";
      } else if (!values.instanceType) {
        errors.instanceType = "Instance Type required.";
      }
    } else {
      const prevInstanceTypes = values.viewState.dirty.launchTemplateOverridesForInstanceType;
      if (prevInstanceTypes && prevInstanceTypes.length > 0) {
        errors.instanceType = "You must confirm removed instance types and/or pick more instance types.";
      } else {
        const advancedModeErrors = this.validateAdvancedModeFields(values, errors);
        Object.assign(errors, { ...advancedModeErrors });
      }
    }
    return errors;
  }
  validateAdvancedModeFields(values, errors) {
    if (!values.launchTemplateOverridesForInstanceType.length) {
      errors.instanceType = "At least one instance type required.";
    }
    if (values.launchTemplateOverridesForInstanceType.length > 40) {
      errors.instanceType = "Maximum of 40 instance types are allowed.";
    }
    const weightsSpecified = values.launchTemplateOverridesForInstanceType.filter((it) => it.weightedCapacity !== void 0);
    if (!(weightsSpecified.length === values.launchTemplateOverridesForInstanceType.length || weightsSpecified.length === 0)) {
      errors.instanceType = "Weighted capacity must be specified for all instance types selected or none.";
    }
    if (some(weightsSpecified, function(instanceType) {
      const weightedCapacity = Number(instanceType.weightedCapacity);
      return weightedCapacity < 1 || weightedCapacity > 999;
    })) {
      errors.instanceType = "Weighted capacity must be a number between 1 and 999.";
    }
    if (values.onDemandBaseCapacity < 0) {
      errors.onDemandBaseCapacity = "On-Demand base capacity must be non-negative.";
    }
    if (values.onDemandBaseCapacity > values.capacity.max) {
      errors.onDemandBaseCapacity = "On-Demand base capacity must be less than or equal to max capacity.";
    }
    if (values.onDemandPercentageAboveBaseCapacity < 0 || values.onDemandPercentageAboveBaseCapacity > 100) {
      errors.onDemandPercentageAboveBaseCapacity = "On-Demand percentage above base capacity must be a number between 0 and 100.";
    }
    if (values.spotPrice) {
      const spotPriceNum = Number(values.spotPrice);
      if (Number.isNaN(spotPriceNum)) {
        errors.spotPrice = "Spot Max Price must be a number or empty string, used to unset previous max price.";
      }
      if (spotPriceNum <= 0) {
        errors.spotPrice = "Spot Max Price must be greater than 0, if specified.";
      }
    }
    if (values.spotInstancePools && values.spotAllocationStrategy !== "lowest-price") {
      errors.spotInstancePools = "Spot Instance Pools is only supported for 'lowest-price' Spot Allocation Strategy.";
    }
    if (values.spotInstancePools <= 0 || values.spotInstancePools > 20) {
      errors.spotInstancePools = "Spot Instance Pools count must be a number between 1 and 20, when applicable.";
    }
    return errors;
  }
  componentDidMount() {
    Promise.resolve(AwsReactInjector.awsInstanceTypeService.getCategories()).then((categories) => {
      this.setState({ instanceTypeDetails: categories });
    });
  }
  componentDidUpdate() {
    this.props$.next(this.props);
  }
  componentWillUnmount() {
    this.destroy$.next();
  }
  render() {
    var _a, _b, _c;
    const { values } = this.props.formik;
    const showTypeSelector = !!(values.viewState.disableImageSelection || values.amiName);
    const availableInstanceTypesForConfig = (_c = (_b = (_a = values.backingData) == null ? void 0 : _a.filtered) == null ? void 0 : _b.instanceTypes) != null ? _c : [];
    const markedInstanceTypeDetails = Array.from(this.state.instanceTypeDetails);
    if (!values.viewState.disableImageSelection && availableInstanceTypesForConfig.length) {
      markedInstanceTypeDetails.forEach((profile) => {
        profile.families.forEach((family) => {
          family.instanceTypes.forEach((instanceType) => {
            instanceType.unavailable = !availableInstanceTypesForConfig.includes(instanceType.name);
          });
        });
      });
    }
    if (showTypeSelector && values) {
      return /* @__PURE__ */ React__default.createElement(InstanceTypeSelector, {
        formik: this.props.formik,
        instanceTypeDetails: markedInstanceTypeDetails
      });
    }
    return /* @__PURE__ */ React__default.createElement("h5", {
      className: "text-center"
    }, "Please select an image.");
  }
}

class ServerGroupZones extends React__default.Component {
  constructor() {
    super(...arguments);
    this.handleAvailabilityZonesChanged = (zones) => {
      const { values, setFieldValue } = this.props.formik;
      values.usePreferredZonesChanged(values);
      setFieldValue("availabilityZones", zones);
    };
    this.rebalanceToggled = () => {
      const { values, setFieldValue } = this.props.formik;
      values.toggleSuspendedProcess(values, "AZRebalance");
      setFieldValue("suspendedProcesses", values.suspendedProcesses);
      this.setState({});
    };
  }
  validate(values) {
    const errors = {};
    if (!values.availabilityZones || values.availabilityZones.length === 0) {
      errors.availabilityZones = "You must select at least one availability zone.";
    }
    return errors;
  }
  render() {
    const { values } = this.props.formik;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "container-fluid form-horizontal"
    }, /* @__PURE__ */ React__default.createElement(AvailabilityZoneSelector, {
      credentials: values.credentials,
      region: values.region,
      onChange: this.handleAvailabilityZonesChanged,
      selectedZones: values.availabilityZones,
      allZones: values.backingData.filtered.availabilityZones,
      usePreferredZones: values.viewState.usePreferredZones
    }), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-3 sm-label-right"
    }, /* @__PURE__ */ React__default.createElement("b", null, "AZ Rebalance")), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-7 checkbox"
    }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
      type: "checkbox",
      onChange: this.rebalanceToggled,
      checked: !values.processIsSuspended(values, "AZRebalance")
    }), "Keep instances evenly distributed across zones"))));
  }
}

const stringToOption = (value) => {
  return { value, label: value };
};
class ServerGroupLoadBalancers extends React__default.Component {
  constructor() {
    super(...arguments);
    this.state = {
      refreshing: false,
      refreshed: false,
      showVpcLoadBalancers: false
    };
    this.refreshLoadBalancers = () => {
      const { values } = this.props.formik;
      this.setState({ refreshing: true });
      const configurationService = ReactInjector.providerServiceDelegate.getDelegate(values.cloudProvider || values.selectedProvider, "serverGroup.configurationService");
      configurationService.refreshLoadBalancers(values).then(() => {
        this.setState({
          refreshing: false,
          refreshed: true
        });
      });
    };
    this.targetGroupsChanged = (options) => {
      const targetGroups = options.map((o) => o.value);
      this.props.formik.setFieldValue("targetGroups", targetGroups);
    };
    this.loadBalancersChanged = (options) => {
      const loadBalancers = options.map((o) => o.value);
      this.props.formik.setFieldValue("loadBalancers", loadBalancers);
    };
    this.vpcLoadBalancersChanged = (options) => {
      const vpcLoadBalancers = options.map((o) => o.value);
      this.props.formik.setFieldValue("vpcLoadBalancers", vpcLoadBalancers);
    };
  }
  validate(values) {
    const errors = {};
    if (values.viewState.dirty.targetGroups) {
      errors.targetGroups = "You must confirm the removed target groups.";
    }
    if (values.viewState.dirty.loadBalancers) {
      errors.loadBalancers = "You must confirm the removed load balancers.";
    }
    return errors;
  }
  clearWarnings(key) {
    this.props.formik.values.viewState.dirty[key] = null;
    this.props.formik.validateForm();
  }
  render() {
    var _a;
    const { hideLoadBalancers, hideTargetGroups } = this.props;
    const { values } = this.props.formik;
    const { dirty } = values.viewState;
    const { refreshed, refreshing, showVpcLoadBalancers } = this.state;
    let targetGroupSection = null;
    if (!hideTargetGroups) {
      const targetGroupOptions = (values.backingData.filtered.targetGroups || []).concat(values.viewState.spelTargetGroups || []).map(stringToOption);
      targetGroupSection = /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, dirty.targetGroups && /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-12"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "alert alert-warning"
      }, /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("i", {
        className: "fa fa-exclamation-triangle"
      }), "The following target groups could not be found in the selected account/region/VPC and were removed:"), /* @__PURE__ */ React__default.createElement("ul", null, dirty.targetGroups.map((tg) => /* @__PURE__ */ React__default.createElement("li", {
        key: tg
      }, tg))), /* @__PURE__ */ React__default.createElement("p", {
        className: "text-right"
      }, /* @__PURE__ */ React__default.createElement("a", {
        className: "btn btn-sm btn-default dirty-flag-dismiss clickable",
        onClick: () => this.clearWarnings("targetGroups")
      }, "Okay")))), /* @__PURE__ */ React__default.createElement("div", {
        className: "form-group"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-4 sm-label-right"
      }, /* @__PURE__ */ React__default.createElement("b", null, "Target Groups "), /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "aws.loadBalancer.targetGroups"
      })), /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-7"
      }, targetGroupOptions.length === 0 && /* @__PURE__ */ React__default.createElement("div", {
        className: "form-control-static"
      }, "No ", /* @__PURE__ */ React__default.createElement("b", null, (_a = this.props.targetGroupTypeHelpText) != null ? _a : "instance"), " target groups found in the selected account/region/VPC"), targetGroupOptions.length > 0 && /* @__PURE__ */ React__default.createElement(TetheredSelect, {
        multi: true,
        options: targetGroupOptions,
        value: values.targetGroups,
        onChange: this.targetGroupsChanged
      }))));
    }
    let loadBalancersSection = null;
    if (!hideLoadBalancers) {
      const loadBalancerOptions = (values.backingData.filtered.loadBalancers || []).concat(values.viewState.spelLoadBalancers || []).map(stringToOption);
      const vpcLoadBalancerOptions = (values.backingData.filtered.vpcLoadBalancers || []).map(stringToOption);
      const hasVpcLoadBalancers = values.vpcLoadBalancers && values.vpcLoadBalancers.length > 0;
      loadBalancersSection = /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, dirty.loadBalancers && /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-12"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "alert alert-warning"
      }, /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("i", {
        className: "fa fa-exclamation-triangle"
      }), "The following load balancers could not be found in the selected account/region/VPC and were removed:"), /* @__PURE__ */ React__default.createElement("ul", null, dirty.loadBalancers.map((lb) => /* @__PURE__ */ React__default.createElement("li", {
        key: lb
      }, lb))), /* @__PURE__ */ React__default.createElement("p", {
        className: "text-right"
      }, /* @__PURE__ */ React__default.createElement("a", {
        className: "btn btn-sm btn-default dirty-flag-dismiss clickable",
        onClick: () => this.clearWarnings("loadBalancers")
      }, "Okay")))), /* @__PURE__ */ React__default.createElement("div", {
        className: "form-group"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-4 sm-label-right"
      }, /* @__PURE__ */ React__default.createElement("b", null, "Classic Load Balancers "), /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "aws.loadBalancer.loadBalancers"
      })), /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-7"
      }, loadBalancerOptions.length === 0 && /* @__PURE__ */ React__default.createElement("div", {
        className: "form-control-static"
      }, "No load balancers found in the selected account/region/VPC"), loadBalancerOptions.length > 0 && /* @__PURE__ */ React__default.createElement(TetheredSelect, {
        multi: true,
        options: loadBalancerOptions,
        value: values.loadBalancers,
        onChange: this.loadBalancersChanged
      }))), !values.vpcId && /* @__PURE__ */ React__default.createElement("div", {
        className: "form-group"
      }, !hasVpcLoadBalancers && !showVpcLoadBalancers && /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-8 col-md-offset-3"
      }, /* @__PURE__ */ React__default.createElement("a", {
        className: "clickable",
        onClick: () => this.setState({ showVpcLoadBalancers: true })
      }, "Add VPC Load Balancers"))), hasVpcLoadBalancers && /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-4 sm-label-right"
      }, /* @__PURE__ */ React__default.createElement("b", null, "VPC Load Balancers")), /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-8"
      }, vpcLoadBalancerOptions.length > 0 && /* @__PURE__ */ React__default.createElement(TetheredSelect, {
        multi: true,
        options: vpcLoadBalancerOptions,
        value: values.vpcLoadBalancers,
        onChange: this.vpcLoadBalancersChanged
      })))), !refreshed && /* @__PURE__ */ React__default.createElement("div", {
        className: "form-group small",
        style: { marginTop: "20px" }
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-8 col-md-offset-4"
      }, refreshing && /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("span", {
        className: "fa fa-sync-alt fa-spin"
      }), /* @__PURE__ */ React__default.createElement("span", null, " refreshing...")), !refreshing && /* @__PURE__ */ React__default.createElement("p", null, "If you are looking for a load balancer or target group from a different application, ", /* @__PURE__ */ React__default.createElement("br", null), /* @__PURE__ */ React__default.createElement("a", {
        className: "clickable",
        onClick: this.refreshLoadBalancers
      }, "click here"), " ", "to load all load balancers."))));
    }
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "container-fluid form-horizontal"
    }, targetGroupSection, loadBalancersSection);
  }
}

class SecurityGroupSelector extends React__default.Component {
  constructor(props) {
    super(props);
    this.refreshSecurityGroups = () => {
      this.setState({ refreshing: true });
      if (this.props.refresh) {
        this.props.refresh().then(() => this.setState({ refreshing: false }));
      } else {
        ReactInjector.providerServiceDelegate.getDelegate(this.props.command.selectedProvider, "serverGroup.configurationService").refreshSecurityGroups(this.props.command).then(() => {
          this.setState({
            refreshing: false,
            refreshTime: InfrastructureCaches.get("securityGroups").getStats().ageMax
          });
        });
      }
    };
    this.onChange = (options) => {
      const securityGroups = options.map((o) => o.value);
      this.props.onChange(securityGroups);
    };
    this.state = {
      refreshing: false,
      refreshTime: InfrastructureCaches.get("securityGroups").getStats().ageMax
    };
  }
  render() {
    const { availableGroups, groupsToEdit, helpKey, hideLabel } = this.props;
    const { refreshing, refreshTime } = this.state;
    const availableGroupOptions = availableGroups.map((g) => ({ label: `${g.name} (${g.id})`, value: g.id }));
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, !hideLabel && /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-3 sm-label-right"
    }, /* @__PURE__ */ React__default.createElement("b", null, FirewallLabels.get("Firewalls")), helpKey && /* @__PURE__ */ React__default.createElement(HelpField, {
      key: helpKey
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-8"
    }, /* @__PURE__ */ React__default.createElement(VirtualizedSelect, {
      ignoreAccents: true,
      options: availableGroupOptions,
      onChange: this.onChange,
      value: groupsToEdit,
      multi: true
    }))), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group small",
      style: { marginTop: "20px" }
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: `col-md-${hideLabel ? 12 : 9} col-md-offset-${hideLabel ? 0 : 3}`
    }, /* @__PURE__ */ React__default.createElement("p", null, refreshing && /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("span", {
      className: "fa fa-sync-alt fa-spin"
    })), FirewallLabels.get("Firewalls"), !refreshing && /* @__PURE__ */ React__default.createElement("span", null, " last refreshed ", timestamp(refreshTime)), refreshing && /* @__PURE__ */ React__default.createElement("span", null, " refreshing...")), /* @__PURE__ */ React__default.createElement("p", null, "If you're not finding a ", FirewallLabels.get("firewall"), " that was recently added,", " ", /* @__PURE__ */ React__default.createElement("a", {
      className: "clickable",
      onClick: this.refreshSecurityGroups
    }, "click here"), " ", "to refresh the list."))));
  }
}

class ServerGroupSecurityGroupsRemoved extends React__default.Component {
  render() {
    const { command, onClear, removed } = this.props;
    const dirtySecurityGroups = (command && command.viewState.dirty.securityGroups || []).concat(removed || []);
    if (dirtySecurityGroups.length === 0) {
      return null;
    }
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "alert alert-warning"
    }, /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("i", {
      className: "fa fa-exclamation-triangle"
    }), "The following ", FirewallLabels.get("firewalls"), " could not be found in the selected account/region/VPC and were removed:"), /* @__PURE__ */ React__default.createElement("ul", null, dirtySecurityGroups.map((s) => /* @__PURE__ */ React__default.createElement("li", {
      key: s
    }, s))), /* @__PURE__ */ React__default.createElement("p", {
      className: "text-right"
    }, /* @__PURE__ */ React__default.createElement("a", {
      className: "btn btn-sm btn-default dirty-flag-dismiss clickable",
      onClick: onClear
    }, "Okay"))));
  }
}
ServerGroupSecurityGroupsRemoved.defaultProps = {
  onClear: noop
};

class ServerGroupSecurityGroups extends React__default.Component {
  constructor() {
    super(...arguments);
    this.onChange = (securityGroups) => {
      this.props.formik.setFieldValue("securityGroups", securityGroups);
    };
    this.acknowledgeRemovedGroups = () => {
      const { viewState } = this.props.formik.values;
      viewState.dirty.securityGroups = null;
      this.props.formik.setFieldValue("viewState", viewState);
    };
  }
  validate(values) {
    const errors = {};
    if (values.viewState.dirty.securityGroups) {
      errors.securityGroups = "You must acknowledge removed security groups.";
    }
    return errors;
  }
  render() {
    const { values } = this.props.formik;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "container-fluid form-horizontal"
    }, /* @__PURE__ */ React__default.createElement(ServerGroupSecurityGroupsRemoved, {
      command: values,
      onClear: this.acknowledgeRemovedGroups
    }), /* @__PURE__ */ React__default.createElement(SecurityGroupSelector, {
      command: values,
      availableGroups: values.backingData.filtered.securityGroups,
      groupsToEdit: values.securityGroups,
      onChange: this.onChange
    }));
  }
}

class ServerGroupAdvancedSettingsCommon extends React__default.Component {
  constructor() {
    super(...arguments);
    this.duplicateKeys = false;
    this.validate = (values) => {
      const errors = {};
      if (!values.keyPair) {
        errors.keyPair = "Key Name is required";
      }
      if (this.duplicateKeys) {
        errors.tags = "Tags have duplicate keys.";
      }
      return errors;
    };
    this.selectBlockDeviceMappingsSource = (source) => {
      const { values } = this.props.formik;
      values.selectBlockDeviceMappingsSource(values, source);
      this.setState({});
    };
    this.toggleSuspendedProcess = (process) => {
      const { values, setFieldValue } = this.props.formik;
      values.toggleSuspendedProcess(values, process);
      setFieldValue("suspendedProcesses", values.suspendedProcesses);
      this.setState({});
    };
    this.platformHealthOverrideChanged = (healthNames) => {
      this.props.formik.setFieldValue("interestingHealthProviderNames", healthNames);
    };
    this.tagsChanged = (tags, duplicateKeys) => {
      this.duplicateKeys = duplicateKeys;
      this.props.formik.setFieldValue("tags", tags);
    };
  }
  render() {
    const { app } = this.props;
    const { setFieldValue, values } = this.props.formik;
    const blockDeviceMappingsSource = values.getBlockDeviceMappingsSource(values);
    const keyPairs = values.backingData.filtered.keyPairs || [];
    const asgSettings = AWSProviderSettings.serverGroups;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "container-fluid form-horizontal"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-5 sm-label-right"
    }, /* @__PURE__ */ React__default.createElement("b", null, "Cooldown")), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-2"
    }, /* @__PURE__ */ React__default.createElement(Field, {
      type: "text",
      required: true,
      name: "cooldown",
      className: "form-control input-sm no-spel"
    })), " ", "seconds"), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-5 sm-label-right"
    }, /* @__PURE__ */ React__default.createElement("b", null, "Enabled Metrics "), /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "aws.serverGroup.enabledMetrics"
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6"
    }, /* @__PURE__ */ React__default.createElement(Select, {
      multi: true,
      value: values.enabledMetrics,
      options: values.backingData.enabledMetrics.map((m) => ({ label: m, value: m })),
      onChange: (option) => setFieldValue("enabledMetrics", option.map((o) => o.value))
    }))), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-5 sm-label-right"
    }, /* @__PURE__ */ React__default.createElement("b", null, "Health Check Type")), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6"
    }, /* @__PURE__ */ React__default.createElement(Select, {
      value: values.healthCheckType,
      clearable: false,
      placeholder: "Select...",
      options: values.backingData.healthCheckTypes.map((t) => ({ label: t, value: t })),
      onChange: (option) => setFieldValue("healthCheckType", option.value)
    }))), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-5 sm-label-right"
    }, /* @__PURE__ */ React__default.createElement("b", null, "Health Check Grace Period")), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-2"
    }, /* @__PURE__ */ React__default.createElement(Field, {
      type: "text",
      required: true,
      className: "form-control input-sm no-spel",
      name: "healthCheckGracePeriod"
    })), " ", "seconds"), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-5 sm-label-right"
    }, /* @__PURE__ */ React__default.createElement("b", null, "Termination Policies")), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6"
    }, /* @__PURE__ */ React__default.createElement(Select, {
      multi: true,
      value: values.terminationPolicies,
      options: values.backingData.terminationPolicies.map((m) => ({ label: m, value: m })),
      onChange: (option) => setFieldValue("terminationPolicies", option.map((o) => o.value))
    }))), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-5 sm-label-right"
    }, /* @__PURE__ */ React__default.createElement("b", null, "Key Name")), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6"
    }, /* @__PURE__ */ React__default.createElement(Select, {
      value: values.keyPair,
      required: true,
      clearable: false,
      options: keyPairs.map((t) => ({ label: t, value: t })),
      onChange: (option) => setFieldValue("keyPair", option.value)
    }))), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-5 sm-label-right"
    }, /* @__PURE__ */ React__default.createElement("b", null, "Ramdisk Id (optional)")), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6"
    }, /* @__PURE__ */ React__default.createElement(Field, {
      type: "text",
      name: "ramdiskId",
      className: "form-control input-sm no-spel"
    }))), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-5 sm-label-right"
    }, /* @__PURE__ */ React__default.createElement("b", null, "IAM Instance Profile (optional)")), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6"
    }, /* @__PURE__ */ React__default.createElement(Field, {
      type: "text",
      className: "form-control input-sm no-spel",
      name: "iamRole"
    }))), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-5 sm-label-right"
    }, /* @__PURE__ */ React__default.createElement("b", null, "UserData (optional) "), /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "aws.serverGroup.base64UserData"
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6"
    }, /* @__PURE__ */ React__default.createElement(Field, {
      type: "text",
      className: "form-control input-sm no-spel",
      name: "base64UserData"
    }))), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-5 sm-label-right"
    }, /* @__PURE__ */ React__default.createElement("b", null, "Instance Monitoring "), /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "aws.serverGroup.instanceMonitoring"
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6 checkbox"
    }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
      type: "checkbox",
      checked: values.instanceMonitoring,
      onChange: (e) => setFieldValue("instanceMonitoring", e.target.checked)
    }), " ", "Enforce Instance Monitoring", " "))), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-5 sm-label-right"
    }, /* @__PURE__ */ React__default.createElement("b", null, "EBS Optimized")), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6 checkbox"
    }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
      type: "checkbox",
      checked: values.ebsOptimized,
      onChange: (e) => setFieldValue("ebsOptimized", e.target.checked)
    }), " ", "Optimize Instances for EBS"))), (asgSettings == null ? void 0 : asgSettings.enableIMDSv2) && /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-5 sm-label-right"
    }, /* @__PURE__ */ React__default.createElement("b", null, "IMDSv2 "), /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "aws.serverGroup.imdsv2"
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6 checkbox"
    }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
      type: "checkbox",
      checked: values.requireIMDSv2 === true,
      onChange: (e) => setFieldValue("requireIMDSv2", e.target.checked)
    }), " ", "Require IMDSv2", " "))), !AWSProviderSettings.disableSpotPricing && values.viewState.useSimpleInstanceTypeSelector && /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-5 sm-label-right"
    }, /* @__PURE__ */ React__default.createElement("b", null, "Spot Instances Price (optional)"), " ", /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "aws.serverGroup.spotMaxPrice"
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-2"
    }, /* @__PURE__ */ React__default.createElement(Field, {
      type: "text",
      className: "form-control input-sm",
      name: "spotPrice"
    }))), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-5 sm-label-right"
    }, /* @__PURE__ */ React__default.createElement("b", null, "AMI Block Device Mappings")), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6 radio"
    }, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
      type: "radio",
      onChange: () => this.selectBlockDeviceMappingsSource("source"),
      checked: blockDeviceMappingsSource === "source",
      name: "blockDeviceMappingsSource"
    }), "Copy from current server group ", /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "aws.blockDeviceMappings.useSource"
    }))), /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
      type: "radio",
      onChange: () => this.selectBlockDeviceMappingsSource("ami"),
      checked: blockDeviceMappingsSource === "ami",
      name: "blockDeviceMappingsSource"
    }), "Prefer AMI block device mappings ", /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "aws.blockDeviceMappings.useAMI"
    }))), /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
      type: "radio",
      onChange: () => this.selectBlockDeviceMappingsSource("default"),
      checked: blockDeviceMappingsSource === "default",
      name: "blockDeviceMappingsSource"
    }), "Defaults for selected instance type ", /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "aws.blockDeviceMappings.useDefaults"
    }))))), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-5 sm-label-right"
    }, /* @__PURE__ */ React__default.createElement("b", null, `Associate ${(asgSettings == null ? void 0 : asgSettings.enableIPv6) ? "IPv6 (Recommended)" : "Public IPv4"} Address`), /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "serverGroup.ipv6"
    })), (asgSettings == null ? void 0 : asgSettings.enableIPv6) && /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6 checkbox"
    }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
      type: "checkbox",
      checked: values.associateIPv6Address === true,
      onChange: (e) => setFieldValue("associateIPv6Address", e.target.checked),
      id: "associateIPv6AddressToggle"
    }), " ", "Assign an IPv6 address to instances", " ")), !(asgSettings == null ? void 0 : asgSettings.enableIPv6) && /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-2 radio"
    }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
      type: "radio",
      checked: values.associatePublicIpAddress === true,
      onChange: () => setFieldValue("associatePublicIpAddress", true),
      id: "associatePublicIpAddressTrue"
    }), "Yes")), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-2 radio"
    }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
      type: "radio",
      checked: values.associatePublicIpAddress === false,
      onChange: () => setFieldValue("associatePublicIpAddress", false),
      id: "associatePublicIpAddressFalse"
    }), "No")), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-2 radio"
    }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
      type: "radio",
      checked: values.associatePublicIpAddress === null,
      onChange: () => setFieldValue("associatePublicIpAddress", null),
      id: "associatePublicIpAddressDefault"
    }), "Default")))), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-5 sm-label-right"
    }, /* @__PURE__ */ React__default.createElement("b", null, "Scaling Processes")), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6 checkbox"
    }, values.backingData.scalingProcesses.map((process) => /* @__PURE__ */ React__default.createElement("div", {
      key: process.name
    }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
      type: "checkbox",
      onChange: () => this.toggleSuspendedProcess(process.name),
      checked: !values.suspendedProcesses.includes(process.name)
    }), " ", process.name, " ", /* @__PURE__ */ React__default.createElement(HelpField, {
      content: process.description
    })))))), app.attributes.platformHealthOnlyShowOverride && /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-5 sm-label-right"
    }, /* @__PURE__ */ React__default.createElement("b", null, "Task Completion")), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6"
    }, /* @__PURE__ */ React__default.createElement(PlatformHealthOverride, {
      interestingHealthProviderNames: values.interestingHealthProviderNames,
      platformHealthType: "Amazon",
      onChange: this.platformHealthOverrideChanged
    }))), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "sm-label-left"
    }, /* @__PURE__ */ React__default.createElement("b", null, "Tags (optional)"), /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "aws.serverGroup.tags"
    })), /* @__PURE__ */ React__default.createElement(MapEditor, {
      model: values.tags,
      allowEmpty: true,
      onChange: this.tagsChanged
    })));
  }
}

var __defProp$3 = Object.defineProperty;
var __getOwnPropDesc$3 = Object.getOwnPropertyDescriptor;
var __decorateClass$3 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$3(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$3(target, key, result);
  return result;
};
let ServerGroupAdvancedSettingsInner = class extends React__default.Component {
  constructor() {
    super(...arguments);
    this.validators = new Map();
    this.validate = (values) => {
      const errors = {};
      this.validators.forEach((validator) => {
        const subErrors = validator(values);
        Object.assign(errors, { ...subErrors });
      });
      return errors;
    };
    this.handleRef = (ele) => {
      if (ele) {
        this.validators.set("common", ele.validate);
      } else {
        this.validators.delete("common");
      }
    };
  }
  render() {
    const { formik, app } = this.props;
    return /* @__PURE__ */ React__default.createElement(ServerGroupAdvancedSettingsCommon, {
      formik,
      app,
      ref: this.handleRef
    });
  }
};
ServerGroupAdvancedSettingsInner = __decorateClass$3([
  Overridable("aws.serverGroup.advancedSettings")
], ServerGroupAdvancedSettingsInner);

class ServerGroupAdvancedSettings extends React__default.Component {
  constructor() {
    super(...arguments);
    this.ref = React__default.createRef();
  }
  validate(values) {
    if (this.ref && this.ref.current) {
      return this.ref.current.validate(values);
    }
    return {};
  }
  render() {
    const { app, formik } = this.props;
    return /* @__PURE__ */ React__default.createElement(ServerGroupAdvancedSettingsInner, {
      formik,
      app,
      ref: this.ref
    });
  }
}

const _AmazonCloneServerGroupModal = class extends React__default.Component {
  constructor(props) {
    super(props);
    this._isUnmounted = false;
    this.templateSelected = () => {
      this.setState({ requiresTemplateSelection: false });
      this.configureCommand();
    };
    this.onTaskComplete = () => {
      this.props.application.serverGroups.refresh();
      this.props.application.serverGroups.onNextRefresh(null, this.onApplicationRefresh);
    };
    this.onApplicationRefresh = () => {
      if (this._isUnmounted) {
        return;
      }
      const { command } = this.props;
      const { taskMonitor } = this.state;
      const cloneStage = taskMonitor.task.execution.stages.find((stage) => stage.type === "cloneServerGroup");
      if (cloneStage && cloneStage.context["deploy.server.groups"]) {
        const newServerGroupName = cloneStage.context["deploy.server.groups"][command.region];
        if (newServerGroupName) {
          const newStateParams = {
            serverGroup: newServerGroupName,
            accountId: command.credentials,
            region: command.region,
            provider: "aws"
          };
          let transitionTo = "^.^.^.clusters.serverGroup";
          if (ReactInjector.$state.includes("**.clusters.serverGroup")) {
            transitionTo = "^.serverGroup";
          }
          if (ReactInjector.$state.includes("**.clusters.cluster.serverGroup")) {
            transitionTo = "^.^.serverGroup";
          }
          if (ReactInjector.$state.includes("**.clusters")) {
            transitionTo = ".serverGroup";
          }
          ReactInjector.$state.go(transitionTo, newStateParams);
        }
      }
    };
    this.initializeCommand = () => {
      const { command } = this.props;
      command.credentialsChanged(command);
      command.regionChanged(command);
      AwsReactInjector.awsServerGroupConfigurationService.configureSubnetPurposes(command);
    };
    this.configureCommand = () => {
      const { application, command } = this.props;
      AwsReactInjector.awsServerGroupConfigurationService.configureCommand(application, command).then(() => {
        this.initializeCommand();
        this.setState({ loaded: true, requiresTemplateSelection: false });
      });
    };
    this.normalizeCommand = ({ tags }) => {
      if (!tags) {
        return;
      }
      Object.keys(tags).forEach((key) => {
        if (!key.length && !tags[key].length) {
          delete tags[key];
        }
      });
    };
    this.submit = (command) => {
      this.normalizeCommand(command);
      const forPipelineConfig = command.viewState.mode === "editPipeline" || command.viewState.mode === "createPipeline";
      if (forPipelineConfig) {
        this.props.closeModal && this.props.closeModal(command);
      } else {
        this.state.taskMonitor.submit(() => ReactInjector.serverGroupWriter.cloneServerGroup(command, this.props.application));
      }
    };
    const requiresTemplateSelection = get(props, "command.viewState.requiresTemplateSelection", false);
    if (!requiresTemplateSelection) {
      this.configureCommand();
    }
    this.state = {
      firewallsLabel: FirewallLabels.get("Firewalls"),
      loaded: false,
      requiresTemplateSelection,
      taskMonitor: new TaskMonitor({
        application: props.application,
        title: "Creating your server group",
        modalInstance: TaskMonitor.modalInstanceEmulation(() => this.props.dismissModal()),
        onTaskComplete: this.onTaskComplete
      })
    };
  }
  static show(props) {
    const modalProps = { dialogClassName: "wizard-modal modal-lg" };
    return ReactModal.show(_AmazonCloneServerGroupModal, props, modalProps);
  }
  componentWillUnmount() {
    this._isUnmounted = true;
    if (this.refreshUnsubscribe) {
      this.refreshUnsubscribe();
    }
  }
  render() {
    const { application, command, dismissModal, title } = this.props;
    const { loaded, taskMonitor, requiresTemplateSelection } = this.state;
    if (requiresTemplateSelection) {
      return /* @__PURE__ */ React__default.createElement(ServerGroupTemplateSelection, {
        app: application,
        command,
        onDismiss: dismissModal,
        onTemplateSelected: this.templateSelected
      });
    }
    return /* @__PURE__ */ React__default.createElement(WizardModal, {
      heading: title,
      initialValues: command,
      loading: !loaded,
      taskMonitor,
      dismissModal,
      closeModal: this.submit,
      submitButtonLabel: command.viewState.submitButtonLabel,
      render: ({ formik, nextIdx, wizard }) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(WizardPage, {
        label: "Basic Settings",
        wizard,
        order: nextIdx(),
        render: ({ innerRef }) => /* @__PURE__ */ React__default.createElement(ServerGroupBasicSettings, {
          ref: innerRef,
          formik,
          app: application
        })
      }), /* @__PURE__ */ React__default.createElement(WizardPage, {
        label: "Load Balancers",
        wizard,
        order: nextIdx(),
        render: ({ innerRef }) => /* @__PURE__ */ React__default.createElement(ServerGroupLoadBalancers, {
          ref: innerRef,
          formik
        })
      }), /* @__PURE__ */ React__default.createElement(WizardPage, {
        label: FirewallLabels.get("Firewalls"),
        wizard,
        order: nextIdx(),
        render: ({ innerRef }) => /* @__PURE__ */ React__default.createElement(ServerGroupSecurityGroups, {
          ref: innerRef,
          formik
        })
      }), /* @__PURE__ */ React__default.createElement(WizardPage, {
        label: command.viewState.useSimpleInstanceTypeSelector ? "Instance Type" : "Instance Types",
        wizard,
        order: nextIdx(),
        render: ({ innerRef }) => /* @__PURE__ */ React__default.createElement(ServerGroupInstanceType, {
          ref: innerRef,
          formik
        })
      }), /* @__PURE__ */ React__default.createElement(WizardPage, {
        label: "Capacity",
        wizard,
        order: nextIdx(),
        render: ({ innerRef }) => /* @__PURE__ */ React__default.createElement(ServerGroupCapacity, {
          ref: innerRef,
          formik
        })
      }), /* @__PURE__ */ React__default.createElement(WizardPage, {
        label: "Availability Zones",
        wizard,
        order: nextIdx(),
        render: ({ innerRef }) => /* @__PURE__ */ React__default.createElement(ServerGroupZones, {
          ref: innerRef,
          formik
        })
      }), /* @__PURE__ */ React__default.createElement(WizardPage, {
        label: "Advanced Settings",
        wizard,
        order: nextIdx(),
        render: ({ innerRef }) => /* @__PURE__ */ React__default.createElement(ServerGroupAdvancedSettings, {
          ref: innerRef,
          formik,
          app: application
        })
      }))
    });
  }
};
let AmazonCloneServerGroupModal = _AmazonCloneServerGroupModal;
AmazonCloneServerGroupModal.defaultProps = {
  closeModal: noop,
  dismissModal: noop
};

class AwsModalFooter extends React__default.Component {
  constructor() {
    super(...arguments);
    this.state = { verified: false, requireVerification: false };
    this.handleVerification = (verified) => {
      this.setState({ verified });
    };
  }
  componentDidMount() {
    AccountService.accounts$.pipe(take(1), map((accounts) => accounts.find((account) => account.name === this.props.account))).subscribe((account) => {
      this.setState({ requireVerification: !!account && account.challengeDestructiveActions });
    });
  }
  render() {
    const { account, onCancel, onSubmit, isValid } = this.props;
    const { verified, requireVerification } = this.state;
    const handleSubmit = () => {
      this.props.onSubmit();
      return false;
    };
    return /* @__PURE__ */ React__default.createElement(ModalFooter, null, /* @__PURE__ */ React__default.createElement("form", {
      onSubmit: handleSubmit
    }, requireVerification && /* @__PURE__ */ React__default.createElement(UserVerification, {
      expectedValue: account,
      onValidChange: this.handleVerification
    })), /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-default",
      onClick: onCancel
    }, "Cancel"), /* @__PURE__ */ React__default.createElement("button", {
      type: "submit",
      className: "btn btn-primary",
      onClick: onSubmit,
      disabled: !isValid || requireVerification && !verified
    }, "Submit"));
  }
}
AwsModalFooter.defaultProps = {
  isValid: true
};

const _AmazonResizeServerGroupModal = class extends React__default.Component {
  constructor(props) {
    super(props);
    this.formikRef = React__default.createRef();
    this.validate = (values) => {
      const { min, max, desired } = values;
      const errors = {};
      if (!this.state.advancedMode) {
        return errors;
      }
      if (min > max && min > desired) {
        errors.min = "Min cannot be larger than Max/Desired";
      } else if (max < min && max < desired) {
        errors.max = "Max cannot be smaller than Min/Desired";
      } else {
        if (min > max) {
          errors.min = "Min cannot be larger than Max";
        }
        if (!this.isDesiredControlledByAutoscaling()) {
          if (desired < min) {
            errors.desired = "Desired cannot be smaller than Min";
          }
          if (desired > max) {
            errors.desired = "Desired cannot be larger than Max";
          }
        }
      }
      return errors;
    };
    this.toggleAdvancedMode = () => {
      const { desired } = this.formikRef.current.getFormikContext().values;
      this.formikRef.current.setFieldValue("min", desired);
      this.formikRef.current.setFieldValue("max", desired);
      this.setState({ advancedMode: !this.state.advancedMode });
    };
    this.close = (args) => {
      this.props.dismissModal.apply(null, args);
    };
    this.platformHealthOverrideChanged = (interestingHealthProviderNames) => {
      this.setState({ interestingHealthProviderNames });
    };
    this.isDesiredControlledByAutoscaling = () => {
      const { serverGroup } = this.props;
      const { suspendedProcesses } = serverGroup.asg;
      const { advancedMode } = this.state;
      const scalingPolicies = serverGroup.scalingPolicies || [];
      return scalingPolicies.length && advancedMode && suspendedProcesses.every((p) => p.processName !== "AlarmNotification");
    };
    this.submit = (values) => {
      const { min, max, desired, enforceCapacityConstraints, reason } = values;
      const { interestingHealthProviderNames } = this.state;
      const { serverGroup, application } = this.props;
      const { asg } = serverGroup;
      const capacity = pickBy({
        min: min !== asg.minSize ? min : void 0,
        max: max !== asg.maxSize ? max : void 0,
        desired: desired !== asg.desiredCapacity ? desired : void 0
      }, (x) => x !== void 0);
      const command = {
        capacity,
        reason,
        interestingHealthProviderNames
      };
      if (enforceCapacityConstraints) {
        command.constraints = {
          capacity: {
            min: asg.minSize,
            max: asg.maxSize,
            desired: asg.desiredCapacity
          }
        };
      }
      this.state.taskMonitor.submit(() => {
        return ReactInjector.serverGroupWriter.resizeServerGroup(serverGroup, application, command);
      });
    };
    const { minSize, maxSize, desiredCapacity } = props.serverGroup.asg;
    const { attributes } = props.application;
    this.state = {
      advancedMode: minSize !== maxSize,
      initialValues: {
        min: minSize,
        max: maxSize,
        desired: desiredCapacity,
        enforceCapacityConstraints: false
      },
      taskMonitor: new TaskMonitor({
        application: props.application,
        title: "Resizing your server group",
        modalInstance: TaskMonitor.modalInstanceEmulation(() => this.props.dismissModal()),
        onTaskComplete: () => this.props.application.serverGroups.refresh()
      }),
      platformHealthOnlyShowOverride: attributes.platformHealthOnlyShowOverride,
      interestingHealthProviderNames: attributes.platformHealthOnlyShowOverride && attributes.platformHealthOnly ? ["Amazon"] : null
    };
  }
  static show(props) {
    const modalProps = {};
    const { serverGroup, application } = props;
    return confirmNotManaged(serverGroup, application).then((notManaged) => {
      notManaged && ReactModal.show(_AmazonResizeServerGroupModal, props, modalProps);
    });
  }
  autoIncrementDesiredIfNeeded() {
    if (!this.isDesiredControlledByAutoscaling()) {
      return;
    }
    const formik = this.formikRef.current.getFormikContext();
    const { asg } = this.props.serverGroup;
    const { min, max, desired } = formik.values;
    const newDesired = Math.min(max, Math.max(min, asg.desiredCapacity));
    if (desired !== newDesired) {
      formik.setFieldValue("desired", newDesired);
    }
  }
  renderSimpleMode(formik) {
    const { serverGroup } = this.props;
    const { asg } = serverGroup;
    return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("p", null, "Sets min, max, and desired instance counts to the same value."), /* @__PURE__ */ React__default.createElement("p", null, "To allow autoscaling, use the", " ", /* @__PURE__ */ React__default.createElement("a", {
      className: "clickable",
      onClick: () => this.toggleAdvancedMode()
    }, "Advanced Mode"), "."), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-3 sm-label-right"
    }, "Current size"), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-4"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "horizontal middle"
    }, /* @__PURE__ */ React__default.createElement("input", {
      type: "number",
      className: "NumberInput form-control",
      value: asg.desiredCapacity,
      disabled: true
    }), /* @__PURE__ */ React__default.createElement("div", {
      className: "sp-padding-xs-xaxis"
    }, "instances")))), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-3 sm-label-right"
    }, "Resize to"), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-4"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "horizontal middle"
    }, /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "desired",
      input: (props) => /* @__PURE__ */ React__default.createElement(NumberInput, {
        ...props,
        min: 0
      }),
      touched: true,
      onChange: (value) => {
        formik.setFieldValue("min", value);
        formik.setFieldValue("max", value);
      }
    }), /* @__PURE__ */ React__default.createElement("div", {
      className: "sp-padding-xs-xaxis"
    }, "instances")))));
  }
  renderAdvancedMode(formik) {
    const { serverGroup } = this.props;
    const { errors } = formik;
    const { asg } = serverGroup;
    const surfacedErrorMessage = errors.min || errors.max || errors.desired;
    return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("p", null, "Sets up autoscaling for this server group."), /* @__PURE__ */ React__default.createElement("p", null, "To disable autoscaling, use the", " ", /* @__PURE__ */ React__default.createElement("a", {
      className: "clickable",
      onClick: () => this.toggleAdvancedMode()
    }, "Simple Mode"), "."), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group bold"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-2 col-md-offset-3"
    }, "Min"), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-2"
    }, "Max"), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-2"
    }, "Desired")), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-3 sm-label-right"
    }, "Current"), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-2"
    }, /* @__PURE__ */ React__default.createElement("input", {
      type: "number",
      className: "NumberInput form-control",
      value: asg.minSize,
      disabled: true
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-2"
    }, /* @__PURE__ */ React__default.createElement("input", {
      type: "number",
      className: "NumberInput form-control",
      value: asg.maxSize,
      disabled: true
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-2"
    }, /* @__PURE__ */ React__default.createElement("input", {
      type: "number",
      className: "NumberInput form-control",
      value: asg.desiredCapacity,
      disabled: true
    }))), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-3 sm-label-right"
    }, "Resize to"), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-2"
    }, /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "min",
      input: (props) => /* @__PURE__ */ React__default.createElement(NumberInput, {
        ...props,
        min: 0
      }),
      onChange: () => this.autoIncrementDesiredIfNeeded(),
      layout: ({ input }) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, input),
      touched: true
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-2"
    }, /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "max",
      input: (props) => /* @__PURE__ */ React__default.createElement(NumberInput, {
        ...props,
        min: 0
      }),
      onChange: () => this.autoIncrementDesiredIfNeeded(),
      layout: ({ input }) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, input),
      touched: true
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-2"
    }, /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "desired",
      input: (props) => /* @__PURE__ */ React__default.createElement(NumberInput, {
        ...props,
        min: 0,
        disabled: this.isDesiredControlledByAutoscaling()
      }),
      layout: ({ input }) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, input),
      touched: true
    }))), !!surfacedErrorMessage && /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-offset-3 col-md-9"
    }, /* @__PURE__ */ React__default.createElement(ValidationMessage, {
      message: surfacedErrorMessage,
      type: "error"
    })));
  }
  renderCapacityConstraintSelector() {
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-7 col-md-offset-3"
    }, /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "enforceCapacityConstraints",
      input: (props) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(CheckboxInput, {
        ...props,
        text: "Enforce Capacity Constraints"
      }), /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "aws.serverGroup.capacityConstraint"
      }))
    })));
  }
  renderScalingPolicyWarning(formik) {
    const { serverGroup } = this.props;
    const { min, max } = formik.values;
    const { advancedMode } = this.state;
    const scalingPolicies = serverGroup.scalingPolicies || [];
    if (scalingPolicies.length && min === max) {
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "form-group"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-7 col-md-offset-3"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "well-compact alert alert-warning"
      }, /* @__PURE__ */ React__default.createElement("b", null, "Warning"), ": this server group has", scalingPolicies.length === 1 && /* @__PURE__ */ React__default.createElement("span", null, " a scaling policy. "), scalingPolicies.length > 1 && /* @__PURE__ */ React__default.createElement("span", null, " scaling policies. "), !advancedMode && /* @__PURE__ */ React__default.createElement("span", null, "Scaling policies will not take effect in Simple Mode. Switch to", " ", /* @__PURE__ */ React__default.createElement("a", {
        className: "clickable",
        onClick: () => this.toggleAdvancedMode()
      }, "Advanced Mode"), "."), advancedMode && /* @__PURE__ */ React__default.createElement("span", null, "Scaling policies will not take effect when ", /* @__PURE__ */ React__default.createElement("b", null, "Min"), " is the same as ", /* @__PURE__ */ React__default.createElement("b", null, "Max"), "."))));
    }
    if (this.isDesiredControlledByAutoscaling()) {
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "form-group"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-8 col-md-offset-1"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "well-compact alert alert-warning"
      }, /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("b", null, "Desired"), " capacity is managed by Autoscaling Policies."), /* @__PURE__ */ React__default.createElement("p", null, "If you need to scale ", /* @__PURE__ */ React__default.createElement("b", null, "down"), " this server group, set ", /* @__PURE__ */ React__default.createElement("b", null, "Max"), " to the new desired size."), /* @__PURE__ */ React__default.createElement("p", null, "If you need to scale ", /* @__PURE__ */ React__default.createElement("b", null, "up"), " this server group, set ", /* @__PURE__ */ React__default.createElement("b", null, "Min"), " to the new desired size."))));
    }
    return null;
  }
  render() {
    const { serverGroup } = this.props;
    const { advancedMode, initialValues, platformHealthOnlyShowOverride } = this.state;
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(TaskMonitorWrapper, {
      monitor: this.state.taskMonitor
    }), /* @__PURE__ */ React__default.createElement(SpinFormik, {
      ref: this.formikRef,
      initialValues,
      validate: this.validate,
      onSubmit: this.submit,
      render: (formik) => {
        const { asg } = serverGroup;
        const currentCapacity = { min: asg.minSize, max: asg.maxSize, desired: asg.desiredCapacity };
        const nextCapacity = formik.values;
        return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(ModalClose, {
          dismiss: this.close
        }), /* @__PURE__ */ React__default.createElement(Modal.Header, null, /* @__PURE__ */ React__default.createElement(Modal.Title, null, "Resize ", serverGroup.name)), /* @__PURE__ */ React__default.createElement(Modal.Body, null, /* @__PURE__ */ React__default.createElement(Form, {
          className: "form-horizontal"
        }, advancedMode && this.renderAdvancedMode(formik), !advancedMode && this.renderSimpleMode(formik), this.renderScalingPolicyWarning(formik), this.renderCapacityConstraintSelector(), platformHealthOnlyShowOverride && /* @__PURE__ */ React__default.createElement("div", {
          className: "form-group"
        }, /* @__PURE__ */ React__default.createElement("div", {
          className: "col-md-8 col-md-offset-3"
        }, /* @__PURE__ */ React__default.createElement(PlatformHealthOverride, {
          interestingHealthProviderNames: this.state.interestingHealthProviderNames,
          platformHealthType: "Amazon",
          onChange: this.platformHealthOverrideChanged,
          showHelpDetails: true
        }))), /* @__PURE__ */ React__default.createElement(TaskReason, {
          reason: formik.values.reason,
          onChange: (val) => formik.setFieldValue("reason", val)
        }), /* @__PURE__ */ React__default.createElement("div", {
          className: "form-group"
        }, /* @__PURE__ */ React__default.createElement("div", {
          className: "col-md-3 sm-label-right"
        }, "Changes"), /* @__PURE__ */ React__default.createElement("div", {
          className: "col-md-9 sm-control-field"
        }, /* @__PURE__ */ React__default.createElement(MinMaxDesiredChanges, {
          current: currentCapacity,
          next: nextCapacity
        }))))), /* @__PURE__ */ React__default.createElement(AwsModalFooter, {
          onSubmit: () => this.submit(formik.values),
          onCancel: this.close,
          isValid: formik.isValid,
          account: serverGroup.account
        }));
      }
    }));
  }
};
let AmazonResizeServerGroupModal = _AmazonResizeServerGroupModal;
AmazonResizeServerGroupModal.defaultProps = {
  closeModal: noop,
  dismissModal: noop
};

var __defProp$2 = Object.defineProperty;
var __getOwnPropDesc$2 = Object.getOwnPropertyDescriptor;
var __decorateClass$2 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$2(target, key, result);
  return result;
};
let AmazonServerGroupActionsResize = class extends React__default.Component {
  constructor() {
    super(...arguments);
    this.resizeServerGroup = () => {
      AmazonResizeServerGroupModal.show(this.props);
    };
  }
  render() {
    return /* @__PURE__ */ React__default.createElement(MenuItem, {
      onClick: this.resizeServerGroup
    }, "Resize");
  }
};
AmazonServerGroupActionsResize = __decorateClass$2([
  Overridable("AmazonServerGroupActions.resize")
], AmazonServerGroupActionsResize);
class AmazonServerGroupActions extends React__default.Component {
  constructor() {
    super(...arguments);
    this.destroyServerGroup = () => {
      const { app, serverGroup } = this.props;
      const taskMonitor = {
        application: app,
        title: "Destroying " + serverGroup.name,
        onTaskComplete: () => {
          if (ReactInjector.$state.includes("**.serverGroup", stateParams)) {
            ReactInjector.$state.go("^");
          }
        }
      };
      const submitMethod = (params) => ReactInjector.serverGroupWriter.destroyServerGroup(serverGroup, app, params);
      const stateParams = {
        name: serverGroup.name,
        accountId: serverGroup.account,
        region: serverGroup.region
      };
      const confirmationModalParams = {
        header: "Really destroy " + serverGroup.name + "?",
        buttonText: "Destroy " + serverGroup.name,
        account: serverGroup.account,
        taskMonitorConfig: taskMonitor,
        interestingHealthProviderNames: void 0,
        submitMethod,
        askForReason: true,
        platformHealthOnlyShowOverride: app.attributes.platformHealthOnlyShowOverride,
        platformHealthType: "Amazon"
      };
      ServerGroupWarningMessageService.addDestroyWarningMessage(app, serverGroup, confirmationModalParams);
      if (app.attributes.platformHealthOnlyShowOverride && app.attributes.platformHealthOnly) {
        confirmationModalParams.interestingHealthProviderNames = ["Amazon"];
      }
      ConfirmationModalService.confirm(confirmationModalParams);
    };
    this.disableServerGroup = () => {
      const { app, serverGroup } = this.props;
      const taskMonitor = {
        application: app,
        title: "Disabling " + serverGroup.name
      };
      const submitMethod = (params) => {
        return ReactInjector.serverGroupWriter.disableServerGroup(serverGroup, app.name, params);
      };
      const confirmationModalParams = {
        header: "Really disable " + serverGroup.name + "?",
        buttonText: "Disable " + serverGroup.name,
        account: serverGroup.account,
        interestingHealthProviderNames: void 0,
        taskMonitorConfig: taskMonitor,
        platformHealthOnlyShowOverride: app.attributes.platformHealthOnlyShowOverride,
        platformHealthType: "Amazon",
        submitMethod,
        askForReason: true
      };
      ServerGroupWarningMessageService.addDisableWarningMessage(app, serverGroup, confirmationModalParams);
      if (app.attributes.platformHealthOnlyShowOverride && app.attributes.platformHealthOnly) {
        confirmationModalParams.interestingHealthProviderNames = ["Amazon"];
      }
      ConfirmationModalService.confirm(confirmationModalParams);
    };
    this.enableServerGroup = () => {
      if (!this.isRollbackEnabled()) {
        this.showEnableServerGroupModal();
        return;
      }
      const confirmationModalParams = {
        header: "Rolling back?",
        body: `Spinnaker provides an orchestrated rollback feature to carefully restore a different version of this
             server group. Do you want to use the orchestrated rollback?`,
        buttonText: `Yes, take me to the rollback settings modal`,
        cancelButtonText: "No, I just want to enable the server group"
      };
      ConfirmationModalService.confirm(confirmationModalParams).then(() => new Promise((resolve) => setTimeout(resolve, 500))).then(() => this.rollbackServerGroup()).catch((error) => {
        if ((error == null ? void 0 : error.source) === "footer") {
          this.showEnableServerGroupModal();
        }
      });
    };
    this.rollbackServerGroup = () => {
      const { app } = this.props;
      let serverGroup = this.props.serverGroup;
      let previousServerGroup;
      let allServerGroups = app.getDataSource("serverGroups").data.filter((g) => g.cluster === serverGroup.cluster && g.region === serverGroup.region && g.account === serverGroup.account);
      if (serverGroup.isDisabled) {
        previousServerGroup = serverGroup;
        serverGroup = orderBy(allServerGroups.filter((g) => g.name !== previousServerGroup.name && !g.isDisabled), ["instanceCounts.total", "createdTime"], ["desc", "desc"])[0];
      }
      allServerGroups = allServerGroups.filter((g) => g.name !== serverGroup.name);
      if (allServerGroups.length === 1 && !previousServerGroup) {
        previousServerGroup = allServerGroups[0];
      }
      ModalInjector.modalService.open({
        templateUrl: ReactInjector.overrideRegistry.getTemplate("aws.rollback.modal", "amazon/src/serverGroup/details/rollback/rollbackServerGroup.html"),
        controller: "awsRollbackServerGroupCtrl as ctrl",
        resolve: {
          serverGroup: () => serverGroup,
          previousServerGroup: () => previousServerGroup,
          disabledServerGroups: () => {
            const cluster = find(app.clusters, {
              name: serverGroup.cluster,
              account: serverGroup.account,
              serverGroups: []
            });
            return filter(cluster.serverGroups, { isDisabled: true, region: serverGroup.region });
          },
          allServerGroups: () => allServerGroups,
          application: () => app
        }
      });
    };
    this.cloneServerGroup = () => {
      const { app, serverGroup } = this.props;
      AwsReactInjector.awsServerGroupCommandBuilder.buildServerGroupCommandFromExisting(app, serverGroup).then((command) => {
        const title = `Clone ${serverGroup.name}`;
        AmazonCloneServerGroupModal.show({ title, application: app, command });
      });
    };
  }
  isEnableLocked() {
    if (this.props.serverGroup.isDisabled) {
      const resizeTasks = (this.props.serverGroup.runningTasks || []).filter((task) => get(task, "execution.stages", []).some((stage) => stage.type === "resizeServerGroup"));
      if (resizeTasks.length) {
        return true;
      }
    }
    return false;
  }
  isRollbackEnabled() {
    const { app, serverGroup } = this.props;
    if (!serverGroup.isDisabled) {
      return true;
    }
    return app.getDataSource("serverGroups").data.some((g) => g.cluster === serverGroup.cluster && g.region === serverGroup.region && g.account === serverGroup.account && !g.isDisabled);
  }
  hasDisabledInstances() {
    return this.props.serverGroup.isDisabled || get(this.props.serverGroup, "instanceCounts.outOfService", 0) > 0;
  }
  showEnableServerGroupModal() {
    const { app, serverGroup } = this.props;
    const taskMonitor = {
      application: app,
      title: "Enabling " + serverGroup.name
    };
    const submitMethod = (params) => {
      return ReactInjector.serverGroupWriter.enableServerGroup(serverGroup, app, params);
    };
    const confirmationModalParams = {
      header: "Really enable " + serverGroup.name + "?",
      buttonText: "Enable " + serverGroup.name,
      account: serverGroup.account,
      interestingHealthProviderNames: void 0,
      taskMonitorConfig: taskMonitor,
      platformHealthOnlyShowOverride: app.attributes.platformHealthOnlyShowOverride,
      platformHealthType: "Amazon",
      submitMethod,
      askForReason: true
    };
    if (app.attributes.platformHealthOnlyShowOverride && app.attributes.platformHealthOnly) {
      confirmationModalParams.interestingHealthProviderNames = ["Amazon"];
    }
    ConfirmationModalService.confirm(confirmationModalParams);
  }
  render() {
    const { app, serverGroup } = this.props;
    const showEntityTags = SETTINGS.feature && SETTINGS.feature.entityTags;
    const entityTagTargets = ClusterTargetBuilder.buildClusterTargets(serverGroup);
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, AWSProviderSettings.adHocInfraWritesEnabled && /* @__PURE__ */ React__default.createElement(Dropdown, {
      className: "dropdown",
      id: "server-group-actions-dropdown"
    }, /* @__PURE__ */ React__default.createElement(Dropdown.Toggle, {
      className: "btn btn-sm btn-primary dropdown-toggle"
    }, "Server Group Actions"), /* @__PURE__ */ React__default.createElement(Dropdown.Menu, {
      className: "dropdown-menu"
    }, this.isRollbackEnabled() && /* @__PURE__ */ React__default.createElement(ManagedMenuItem, {
      resource: serverGroup,
      application: app,
      onClick: this.rollbackServerGroup
    }, "Rollback"), this.isRollbackEnabled() && /* @__PURE__ */ React__default.createElement("li", {
      role: "presentation",
      className: "divider"
    }), /* @__PURE__ */ React__default.createElement(AmazonServerGroupActionsResize, {
      application: app,
      serverGroup
    }), !serverGroup.isDisabled && /* @__PURE__ */ React__default.createElement(ManagedMenuItem, {
      resource: serverGroup,
      application: app,
      onClick: this.disableServerGroup
    }, "Disable"), this.hasDisabledInstances() && !this.isEnableLocked() && /* @__PURE__ */ React__default.createElement(ManagedMenuItem, {
      resource: serverGroup,
      application: app,
      onClick: this.enableServerGroup
    }, "Enable"), this.isEnableLocked() && /* @__PURE__ */ React__default.createElement("li", {
      className: "disabled"
    }, /* @__PURE__ */ React__default.createElement(Tooltip$1, {
      value: "Cannot enable this server group until resize operation completes",
      placement: "left"
    }, /* @__PURE__ */ React__default.createElement("a", null, /* @__PURE__ */ React__default.createElement("span", {
      className: "small glyphicon glyphicon-lock"
    }), " Enable"))), /* @__PURE__ */ React__default.createElement(ManagedMenuItem, {
      resource: serverGroup,
      application: app,
      onClick: this.destroyServerGroup
    }, "Destroy"), /* @__PURE__ */ React__default.createElement("li", null, /* @__PURE__ */ React__default.createElement("a", {
      className: "clickable",
      onClick: this.cloneServerGroup
    }, "Clone")), showEntityTags && /* @__PURE__ */ React__default.createElement(AddEntityTagLinks, {
      component: serverGroup,
      application: app,
      entityType: "serverGroup",
      ownerOptions: entityTagTargets,
      onUpdate: () => app.serverGroups.refresh()
    }))));
  }
}
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/serverGroup/details/rollback/rollbackServerGroup.html", `<div modal-page class="confirmation-modal">
  <task-monitor monitor="taskMonitor"></task-monitor>
  <form role="form">
    <modal-close dismiss="$dismiss()"></modal-close>
    <div class="modal-header">
      <h4 class="modal-title">Rollback {{serverGroup.name}}</h4>
    </div>
    <div class="modal-body confirmation-modal">
      <div class="row">
        <div class="col-sm-3 sm-label-right">Restore to</div>
        <div class="col-md-7">
          <ui-select
            ng-model="command.rollbackContext.restoreServerGroupName"
            class="form-control input-sm"
            ng-if="command.rollbackType === 'EXPLICIT'"
          >
            <ui-select-match placeholder="Select...">{{ctrl.label($select.selected)}}</ui-select-match>
            <ui-select-choices group-by="ctrl.group" repeat="serverGroup.name as serverGroup in allServerGroups">
              <span ng-bind-html="ctrl.label(serverGroup)"></span>
            </ui-select-choices>
          </ui-select>
          <div ng-if="command.rollbackType === 'PREVIOUS_IMAGE'" style="margin-top: 5px">
            {{ previousServerGroup.name }} <span class="small">(no longer deployed)</span><br />
            <span class="small">
              <strong>Image</strong>: {{ previousServerGroup.imageName}}
              <span ng-if="previousServerGroup.imageId">({{ previousServerGroup.imageId }})</span><br />
            </span>
            <span class="small" ng-if="previousServerGroup.buildNumber">
              <strong>Build</strong> #{{ previousServerGroup.buildNumber }}
            </span>
          </div>
        </div>
      </div>

      <div class="row" ng-if="command.platformHealthOnlyShowOverride">
        <div class="col-sm-10 col-sm-offset-1">
          <platform-health-override
            command="command"
            platform-health-type="'Amazon'"
            show-help-details="true"
            field-columns="12"
          >
          </platform-health-override>
        </div>
      </div>

      <task-reason command="command"></task-reason>

      <div class="row">
        <div class="col-sm-11 col-sm-offset-1">
          Wait
          <input
            placeholder="0"
            min="0"
            type="number"
            ng-model="command.rollbackContext.delayBeforeDisableSeconds"
            class="form-control input-sm inline-number"
          />
          seconds before disabling <em>{{ ctrl.label(serverGroup) }}</em>.
        </div>
      </div>

      <div class="row">
        <div class="col-sm-11 col-sm-offset-1">
          Consider rollback successful when
          <input
            type="number"
            min="0"
            max="100"
            ng-model="command.rollbackContext.targetHealthyRollbackPercentage"
            class="form-control input-sm inline-number"
          />
          percent of instances are healthy.
        </div>
      </div>

      <div class="row">
        <div class="col-sm-4 sm-label-right">Rollback Operations</div>
      </div>
      <div class="row" ng-if="command.rollbackType === 'EXPLICIT'">
        <div class="col-sm-11 col-sm-offset-1">
          <ol>
            <li>Enable <em>{{ command.rollbackContext.restoreServerGroupName || 'previous server group' }}</em></li>
            <li>
              Resize <em>{{ command.rollbackContext.restoreServerGroupName || 'previous server group' }}</em> to [
              <strong>min</strong>: {{serverGroup.capacity.desired}}, <strong>max</strong>: {{ serverGroup.capacity.max
              }}, <strong>desired</strong>: {{ serverGroup.capacity.desired }} ] <br />(minimum capacity pinned at
              {{serverGroup.capacity.desired}} to prevent autoscaling down during rollback)
            </li>

            <li ng-if="command.rollbackContext.targetHealthyRollbackPercentage < 100">
              Wait for at least {{minHealthy(command.rollbackContext.targetHealthyRollbackPercentage)}} instances to
              report as healthy
            </li>
            <li ng-if="command.rollbackContext.delayBeforeDisableSeconds > 0">
              Wait {{ command.rollbackContext.delayBeforeDisableSeconds }} seconds
            </li>
            <li>Disable <em>{{ serverGroup.name }}</em></li>
            <li>
              Restore minimum capacity of
              <em>{{ command.rollbackContext.restoreServerGroupName || 'previous server group' }}</em> [
              <strong>min</strong>: {{ serverGroup.capacity.min }} ]
            </li>
          </ol>
          <p>This rollback will affect server groups in {{ serverGroup.account }} ({{ serverGroup.region }}).</p>
        </div>
      </div>
      <div class="row" ng-if="command.rollbackType === 'PREVIOUS_IMAGE'">
        <div class="col-sm-11 col-sm-offset-1">
          <ol>
            <li>
              Deploy <em>{{ previousServerGroup.imageId }}</em> [ <strong>min</strong>:
              {{serverGroup.capacity.desired}}, <strong>max</strong>: {{ serverGroup.capacity.max }},
              <strong>desired</strong>: {{ serverGroup.capacity.desired }} ] <br />(minimum capacity pinned at
              {{serverGroup.capacity.desired}} to prevent autoscaling down during deploy)
            </li>
            <li ng-if="command.rollbackContext.targetHealthyRollbackPercentage < 100">
              Wait for at least {{minHealthy(command.rollbackContext.targetHealthyRollbackPercentage)}} instances to
              report as healthy
            </li>
            <li>Disable {{ serverGroup.name }}</li>
            <li>
              Restore minimum capacity of <em>new server group</em> [ <strong>min</strong>: {{ serverGroup.capacity.min
              }} ]
            </li>
          </ol>
          <p>This rollback will affect server groups in {{ serverGroup.account }} ({{ serverGroup.region }}).</p>
        </div>
      </div>
    </div>
    <aws-footer
      action="ctrl.rollback()"
      cancel="ctrl.cancel()"
      is-valid="ctrl.isValid()"
      account="serverGroup.account"
      verification="verification"
    ></aws-footer>
  </form>
</div>
`);
}]);

class AutoScalingProcessService {
  static getDisabledDate(serverGroup) {
    if (serverGroup.isDisabled) {
      const processes = this.normalizeScalingProcesses(serverGroup);
      const disabledProcess = processes.find((process) => process.name === "AddToLoadBalancer" && !process.enabled);
      if (disabledProcess) {
        return disabledProcess.suspensionDate;
      }
    }
    return null;
  }
  static normalizeScalingProcesses(serverGroup) {
    if (!serverGroup.asg || !serverGroup.asg.suspendedProcesses) {
      return [];
    }
    const disabled = serverGroup.asg.suspendedProcesses;
    const allProcesses = this.listProcesses();
    return allProcesses.map((process) => {
      const disabledProcess = disabled.find((p) => p.processName === process.name);
      const scalingProcess = {
        name: process.name,
        enabled: !disabledProcess,
        description: process.description
      };
      if (disabledProcess) {
        const suspensionDate = disabledProcess.suspensionReason.replace("User suspended at ", "");
        scalingProcess.suspensionDate = new Date(suspensionDate).getTime();
      }
      return scalingProcess;
    });
  }
  static listProcesses() {
    return [
      {
        name: "Launch",
        description: "Controls if new instances should be launched into the ASG. If this is disabled, scale-up events will not produce new instances."
      },
      {
        name: "Terminate",
        description: "Controls if instances should be terminated during a scale-down event."
      },
      {
        name: "AddToLoadBalancer",
        description: "Controls if new instances should be added to the ASG\u2019s ELB."
      },
      {
        name: "AlarmNotification",
        description: "This disables autoscaling."
      },
      {
        name: "AZRebalance",
        description: "Controls whether AWS should attempt to maintain an even distribution of instances across all healthy Availability Zones configured for the ASG."
      },
      {
        name: "HealthCheck",
        description: "If disabled, the instance\u2019s health will no longer be reported to the autoscaling processor."
      },
      {
        name: "ReplaceUnhealthy",
        description: "Controls whether instances should be replaced if they failed the health check."
      },
      {
        name: "ScheduledActions",
        description: "Controls whether scheduled actions should be executed."
      }
    ];
  }
}

function extractServerGroupSummary(props) {
  const { app, serverGroup } = props;
  return app.ready().then(() => {
    let summary = app.serverGroups.data.find((toCheck) => {
      return toCheck.name === serverGroup.name && toCheck.account === serverGroup.accountId && toCheck.region === serverGroup.region;
    });
    if (!summary) {
      app.loadBalancers.data.some((loadBalancer) => {
        if (loadBalancer.account === serverGroup.accountId && loadBalancer.region === serverGroup.region) {
          return loadBalancer.serverGroups.some((possibleServerGroup) => {
            if (possibleServerGroup.name === serverGroup.name) {
              summary = possibleServerGroup;
              return true;
            }
            return false;
          });
        }
        return false;
      });
    }
    return summary;
  });
}
function amazonServerGroupDetailsGetter(props, autoClose) {
  const { app, serverGroup: serverGroupInfo } = props;
  return new Observable((observer) => {
    extractServerGroupSummary(props).then((summary) => {
      ServerGroupReader.getServerGroup(app.name, serverGroupInfo.accountId, serverGroupInfo.region, serverGroupInfo.name).then((details) => {
        Object.assign(details, summary, { account: serverGroupInfo.accountId });
        const serverGroup = AwsReactInjector.awsServerGroupTransformer.normalizeServerGroupDetails(details);
        AccountService.getAccountDetails(serverGroup.account).then((accountDetails) => {
          serverGroup.accountDetails = accountDetails;
          observer.next(serverGroup);
        });
        if (!isEmpty(serverGroup)) {
          const vpc = serverGroup.asg ? serverGroup.asg.vpczoneIdentifier : "";
          if (vpc !== "") {
            const subnetId = vpc.split(",")[0];
            SubnetReader.listSubnets().then((subnets) => {
              const subnet = subnets.find((s) => s.id === subnetId);
              serverGroup.subnetType = subnet.purpose;
              observer.next(serverGroup);
            });
          }
          serverGroup.disabledDate = AutoScalingProcessService.getDisabledDate(serverGroup);
          observer.next(serverGroup);
        } else {
          autoClose();
        }
      }, autoClose);
    }, autoClose);
  });
}

Chart.register(LineController, LineElement, PointElement, LinearScale, Title, TimeScale, Tooltip$2, Legend, Filler);
function makeChart(canvasElement) {
  const xScaleOptions = {
    type: "time",
    display: true,
    scaleLabel: {
      labelString: "Date"
    },
    ticks: {
      major: { enabled: true }
    }
  };
  const yScaleOptions = {
    min: 0,
    stacked: true
  };
  const chartConfig = {
    type: "line",
    data: {
      labels: [],
      datasets: [{ data: [] }]
    },
    options: {
      plugins: {
        tooltip: {
          mode: "index",
          itemSort: (a, b) => {
            var _a, _b;
            const labels = a.chart.data.datasets.map((d) => d.label);
            const labelA = (_a = a.dataset.label) != null ? _a : labels[0];
            const labelB = (_b = b.dataset.label) != null ? _b : labels[0];
            return labels.indexOf(labelB) - labels.indexOf(labelA);
          }
        }
      },
      hover: {
        mode: "index"
      },
      elements: {
        point: {
          hitRadius: 12,
          radius: 1,
          hoverRadius: 5
        }
      },
      scales: {
        x: xScaleOptions,
        y: yScaleOptions
      }
    }
  };
  return new Chart(canvasElement, chartConfig);
}
function DateLineChart(props) {
  const chartContainerRef = React.useRef();
  const chartRef = React.useRef();
  const { lines, className = "", style = {} } = props;
  React.useEffect(() => {
    if (chartContainerRef) {
      chartRef.current = makeChart(chartContainerRef.current);
      return () => {
        var _a;
        return (_a = chartRef.current) == null ? void 0 : _a.destroy();
      };
    }
    return null;
  }, [chartContainerRef.current]);
  React.useEffect(() => {
    const chart = chartRef.current;
    if (chart && lines) {
      chart.options.animation = false;
      chart.data.datasets = lines;
      chart.update();
    }
  }, [chartRef.current, lines]);
  return /* @__PURE__ */ React.createElement("canvas", {
    ref: chartContainerRef,
    ...style,
    className
  });
}

function MetricAlarmChart(props) {
  return props.serverGroup && props.alarm ? /* @__PURE__ */ React.createElement(MetricAlarmChartImpl, {
    ...props
  }) : null;
}
function MetricAlarmChartImpl(props) {
  var _a, _b;
  const alarm = (_a = props.alarm) != null ? _a : {};
  const serverGroup = (_b = props.serverGroup) != null ? _b : {};
  const { account, awsAccount, region, type } = serverGroup;
  const { metricName, namespace, statistic, period } = alarm;
  const { status, result } = useData(async () => {
    var _a2;
    const parameters = { namespace, statistics: statistic, period };
    alarm.dimensions.forEach((dimension) => parameters[dimension.name] = dimension.value);
    const metricAccount = type === "aws" ? account : awsAccount;
    const result2 = await CloudMetricsReader.getMetricStatistics("aws", metricAccount, region, metricName, parameters);
    result2.datapoints = result2.datapoints || [];
    (_a2 = props.onChartLoaded) == null ? void 0 : _a2.call(props, result2);
    return result2;
  }, { datapoints: [], unit: "" }, [namespace, statistic, period, type, account, region, metricName]);
  if (status === "PENDING") {
    return /* @__PURE__ */ React.createElement("div", {
      className: "flex-container-v middle center sp-margin-xl"
    }, /* @__PURE__ */ React.createElement(Spinner, null));
  } else if (status === "REJECTED") {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", null, "no data"), /* @__PURE__ */ React.createElement("div", null, "something went wrong fetching stats"));
  } else if (result.datapoints.length === 0) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, "no data");
  }
  const now = new Date();
  const oneDayAgo = new Date(Date.now() - 1e3 * 60 * 60 * 24);
  const line = {
    label: metricName,
    fill: "stack",
    borderColor: "green",
    borderWidth: 2,
    data: result.datapoints.map((dp) => ({ x: new Date(dp.timestamp), y: dp.average }))
  };
  const setline = {
    label: "threshold",
    borderWidth: 1,
    borderColor: "red",
    data: [
      { x: oneDayAgo, y: alarm.threshold },
      { x: now, y: alarm.threshold }
    ]
  };
  return /* @__PURE__ */ React.createElement(DateLineChart, {
    lines: [line, setline]
  });
}

const predefinedMetricTypeMapping = {
  ASGAverageCPUUtilization: "CPUUtilization",
  ASGAverageNetworkIn: "NetworkIn",
  ASGAverageNetworkOut: "NetworkOut"
};
const TargetTrackingChart = ({ config, serverGroup, updateUnit }) => {
  const [alarm, setAlarm] = React.useState({
    alarmName: null,
    alarmArn: null,
    metricName: null,
    namespace: null,
    statistic: "Average",
    dimensions: [],
    period: 60,
    threshold: config.targetValue,
    comparisonOperator: "GreaterThanThreshold",
    okactions: [],
    insufficientDataActions: [],
    alarmActions: [],
    evaluationPeriods: null,
    alarmDescription: null,
    unit: null
  });
  const synchronizeAlarm = () => {
    var _a;
    const customMetric = config == null ? void 0 : config.customizedMetricSpecification;
    const updatedAlarm = {
      ...alarm,
      dimensions: (customMetric == null ? void 0 : customMetric.dimensions) || [{ name: "AutoScalingGroupName", value: serverGroup.name }],
      metricName: (customMetric == null ? void 0 : customMetric.metricName) || predefinedMetricTypeMapping[(_a = config == null ? void 0 : config.predefinedMetricSpecification) == null ? void 0 : _a.predefinedMetricType],
      namespace: (customMetric == null ? void 0 : customMetric.namespace) || "AWS/EC2",
      threshold: config == null ? void 0 : config.targetValue
    };
    if (customMetric) {
      updatedAlarm.statistic = customMetric == null ? void 0 : customMetric.statistic;
    }
    setAlarm(updatedAlarm);
  };
  React.useEffect(() => {
    synchronizeAlarm();
  }, [config]);
  const onChartLoaded = (stats) => {
    if (updateUnit) {
      updateUnit(stats.unit);
    }
  };
  return /* @__PURE__ */ React.createElement(MetricAlarmChart, {
    alarm,
    onChartLoaded,
    serverGroup
  });
};

var css_248z$b = "dimensions-editor {\n  display: block;\n  padding-left: 5px;\n}\ndimensions-editor h5 {\n  margin-bottom: 0;\n}\ndimensions-editor .dimensions-row {\n  margin-top: 5px;\n  margin-left: -20px;\n}\ndimensions-editor .add-new {\n  margin-left: 0;\n  padding: 4px;\n  width: 100%;\n}\n";
styleInject(css_248z$b);

const DimensionsEditor = ({ alarm, serverGroup, updateAvailableMetrics }) => {
  const dimensions = alarm.dimensions || [];
  const fetchDimensions = () => {
    return CloudMetricsReader.listMetrics("aws", serverGroup.account, serverGroup.region, {
      namespace: alarm.namespace
    }).then((results) => {
      const allDimensions = flatMap(results, (r) => r.dimensions);
      const sortedDimensions = uniq(allDimensions.filter((d) => d).map((d) => d.name)).sort();
      return sortedDimensions;
    }).catch(() => {
      return [];
    });
  };
  const { result: dimensionOptions } = useData(fetchDimensions, [], [alarm.namespace, serverGroup.name]);
  const addDimension = () => {
    const newDimensions = [...dimensions, {}];
    updateAvailableMetrics(newDimensions);
  };
  const removeDimension = (index) => {
    const newDimensions = alarm.dimensions.filter((_d, i) => i !== index);
    updateAvailableMetrics(newDimensions);
  };
  const updateDimension = (key, value, index) => {
    const newDimensions = [...dimensions];
    const updatedDimension = newDimensions[index];
    updatedDimension[key] = value;
    updateAvailableMetrics(newDimensions);
  };
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "col-md-12 small"
  }, /* @__PURE__ */ React.createElement("h5", null, "Dimensions"))), dimensions.map((dimension, i) => /* @__PURE__ */ React.createElement("div", {
    key: `dimension-${i}`,
    className: "row dimensions-row horizontal middle"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "col-md-6"
  }, /* @__PURE__ */ React.createElement(ReactSelectInput, {
    onChange: (e) => updateDimension("name", e.target.value, i),
    value: dimension.name,
    stringOptions: dimensionOptions
  })), /* @__PURE__ */ React.createElement(TextInput, {
    onChange: (e) => updateDimension("value", e.target.value, i),
    value: dimension.value
  }), !alarm.disableEditingDimensions && /* @__PURE__ */ React.createElement("div", {
    className: "col-md-1",
    onClick: () => removeDimension(i)
  }, /* @__PURE__ */ React.createElement("a", null, /* @__PURE__ */ React.createElement("i", {
    className: "glyphicon glyphicon-trash clickable"
  }))))), !alarm.disableEditingDimensions && /* @__PURE__ */ React.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("button", {
    type: "button",
    className: "btn btn-block btn-xs add-new",
    onClick: addDimension
  }, /* @__PURE__ */ React.createElement("span", {
    className: "glyphicon glyphicon-plus-sign sp-margin-xs-left"
  }), "Add dimension"))));
};

const NAMESPACES = [
  "AWS/ApplicationELB",
  "AWS/AutoScaling",
  "AWS/AmazonMQ",
  "AWS/Billing",
  "AWS/CloudFront",
  "AWS/CloudSearch",
  "AWS/Events",
  "AWS/DynamoDB",
  "AWS/ECS",
  "AWS/ElastiCache",
  "AWS/EBS",
  "AWS/EC2",
  "AWS/ELB",
  "AWS/ElasticMapReduce",
  "AWS/ES",
  "AWS/Kinesis",
  "AWS/Lambda",
  "AWS/ML",
  "AWS/OpsWorks",
  "AWS/Redshift",
  "AWS/RDS",
  "AWS/Route53",
  "AWS/SNS",
  "AWS/SQS",
  "AWS/S3",
  "AWS/SWF",
  "AWS/StorageGateway",
  "AWS/WAF",
  "AWS/WorkSpaces"
];

var css_248z$a = ".MetricSelector {\n  font-size: 12px;\n}\n.MetricSelector .simple-input {\n  width: 216px;\n}\n.MetricSelector .advanced-input-namespace {\n  width: 138px;\n}\n.MetricSelector .advanced-input-metric {\n  width: 300px;\n}\n";
styleInject(css_248z$a);

const MetricSelector = ({ alarm, updateAlarm, serverGroup }) => {
  var _a, _b;
  const namespaces = (((_b = (_a = AWSProviderSettings) == null ? void 0 : _a.metrics) == null ? void 0 : _b.customNamespaces) || []).concat(NAMESPACES);
  const [advancedMode, setAdvancedMode] = React.useState(false);
  const dimensionsObject = ((alarm == null ? void 0 : alarm.dimensions) || []).reduce((acc, dimension) => {
    acc[dimension.name] = dimension.value;
    return acc;
  }, {});
  const buildDimensionValues = (dimensions) => dimensions.sort((a, b) => {
    var _a2;
    return (_a2 = a.name) == null ? void 0 : _a2.localeCompare(b.name);
  }).map((d) => d.value).join(", ");
  const fetchCloudMetrics = () => {
    const account = serverGroup.cloudProvider === "aws" ? serverGroup.account : serverGroup == null ? void 0 : serverGroup.awsAccount;
    const queryParams = advancedMode ? { namespace: alarm == null ? void 0 : alarm.namespace } : { AutoScalingGroupName: serverGroup.name };
    return CloudMetricsReader.listMetrics("aws", account, serverGroup.region, queryParams).then((results) => {
      const sortedMetrics = (results || []).map((m) => ({
        label: `(${m.namespace}) ${m.name}`,
        dimensions: [],
        dimensionValues: buildDimensionValues(m.dimensions || []),
        value: m,
        ...m
      })).sort((a, b) => {
        var _a2;
        return (_a2 = a.label) == null ? void 0 : _a2.localeCompare(b.label);
      });
      return sortedMetrics;
    }).catch(() => {
      return [];
    });
  };
  const { result: metrics } = useData(fetchCloudMetrics, [], [serverGroup, alarm == null ? void 0 : alarm.namespace]);
  const metricsByNamespace = (metrics || []).filter((m) => m.namespace === (alarm == null ? void 0 : alarm.namespace));
  const selectedMetric = metricsByNamespace.find((m) => m.name === (alarm == null ? void 0 : alarm.metricName) && m.namespace === (alarm == null ? void 0 : alarm.namespace)) || metricsByNamespace.find((m) => m.name.match("CPUUtilization")) || metricsByNamespace[0];
  const { name: metricName, namespace } = selectedMetric || {};
  const toggleMode = () => {
    const newMode = !advancedMode;
    if (newMode) {
      dimensionsObject.namespace = alarm == null ? void 0 : alarm.namespace;
    } else {
      const newAlarm = {
        ...alarm,
        dimension: [{ name: "AutoScalingGroupName", value: serverGroup.name }]
      };
      updateAlarm(newAlarm);
    }
    setAdvancedMode(newMode);
  };
  const onMetricChange = (metric) => {
    const newAlarm = {
      ...alarm,
      metricName: metric.name,
      namespace: metric.namespace,
      dimensions: metric.dimensions
    };
    updateAlarm(newAlarm);
  };
  const onAdvancedChange = (newNamespace, newName) => {
    const newAlarm = {
      ...alarm,
      metricName: newName,
      namespace: newNamespace
    };
    updateAlarm(newAlarm);
  };
  const updateDimensions = (dimensions) => {
    const newAlarm = {
      ...alarm,
      dimensions
    };
    updateAlarm(newAlarm);
  };
  React.useEffect(() => {
    if (selectedMetric) {
      onMetricChange(selectedMetric);
    }
  }, [selectedMetric]);
  if (!advancedMode) {
    return /* @__PURE__ */ React.createElement("div", {
      className: "MetricSelector horizontal middle"
    }, /* @__PURE__ */ React.createElement(ReactSelectInput, {
      value: selectedMetric,
      onChange: (e) => onMetricChange(e.target.value),
      options: metrics,
      clearable: false,
      inputClassName: "sp-margin-s-right simple-input"
    }), /* @__PURE__ */ React.createElement("a", {
      className: "clickable",
      onClick: toggleMode
    }, /* @__PURE__ */ React.createElement("span", {
      className: "sp-margin-xs-right"
    }, "Search all metrics"), /* @__PURE__ */ React.createElement(HelpField, {
      id: "aws.scalingPolicy.search.all"
    })));
  }
  return /* @__PURE__ */ React.createElement("div", {
    className: "MetricSelector"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "horizontal middle"
  }, /* @__PURE__ */ React.createElement(ReactSelectInput, {
    value: namespace,
    onChange: (e) => onAdvancedChange(e.target.value, alarm == null ? void 0 : alarm.metricName),
    stringOptions: namespaces,
    inputClassName: "advanced-input-namespace sp-margin-m-right"
  }), /* @__PURE__ */ React.createElement(ReactSelectInput, {
    value: metricName,
    onChange: (e) => onAdvancedChange(alarm == null ? void 0 : alarm.namespace, e.target.value),
    stringOptions: metrics.map((m) => m.name),
    placeholder: "name",
    searchable: true,
    inputClassName: "advanced-input-metric"
  })), /* @__PURE__ */ React.createElement("div", {
    className: "vertical"
  }, !Boolean(metrics.length) && /* @__PURE__ */ React.createElement("span", {
    className: "input-label"
  }, /* @__PURE__ */ React.createElement("b", null, "Note:"), " no metrics found for selected namespace + dimensions"), /* @__PURE__ */ React.createElement("a", {
    className: "clickable",
    onClick: toggleMode
  }, /* @__PURE__ */ React.createElement("span", {
    className: "sp-margin-s-yaxis sp-margin-xs-right"
  }, "Only show metrics for this auto scaling group"), /* @__PURE__ */ React.createElement(HelpField, {
    id: "aws.scalingPolicy.search.restricted"
  }))), /* @__PURE__ */ React.createElement(DimensionsEditor, {
    alarm,
    serverGroup,
    updateAvailableMetrics: updateDimensions
  }));
};

var css_248z$9 = ".TargetMetricFields .metric-select-input {\n  font-size: 12px;\n  width: 180px;\n}\n.TargetMetricFields .target-input {\n  width: 120px;\n}\n";
styleInject(css_248z$9);

const TargetMetricFields = ({
  allowDualMode,
  cloudwatch,
  command,
  isCustomMetric,
  serverGroup,
  toggleMetricType,
  updateCommand
}) => {
  var _a, _b;
  const predefinedMetrics = ["ASGAverageCPUUtilization", "ASGAverageNetworkOut", "ASGAverageNetworkIn"];
  const statistics = ["Average", "Maximum", "Minimum", "SampleCount", "Sum"];
  const [unit, setUnit] = React.useState(null);
  const setCommandField = (path, value) => {
    const newCommand = cloneDeep(command);
    set(newCommand, path, value);
    updateCommand(newCommand);
  };
  const updateAlarm = (newAlarm) => {
    setCommandField("targetTrackingConfiguration.customizedMetricSpecification", newAlarm);
  };
  const onMetricTypeChange = () => {
    const newCommand = cloneDeep(command);
    if (isCustomMetric) {
      set(newCommand, "targetTrackingConfiguration.predefinedMetricSpecification", {
        predefinedMetricType: "ASGAverageCPUUtilization"
      });
      set(newCommand, "targetTrackingConfiguration.customizedMetricSpecification", null);
    } else {
      set(newCommand, "targetTrackingConfiguration.predefinedMetricSpecification", null);
      set(newCommand, "targetTrackingConfiguration.customizedMetricSpecification", {
        metricName: "CPUUtilization",
        namespace: "AWS/EC2",
        dimensions: [{ name: "AutoScalingGroupName", value: serverGroup.name }],
        statistic: "Average"
      });
    }
    updateCommand(newCommand);
    toggleMetricType(isCustomMetric ? "predefined" : "custom");
  };
  return /* @__PURE__ */ React.createElement("div", {
    className: "TargetMetricFields sp-margin-l-xaxis"
  }, /* @__PURE__ */ React.createElement("p", null, "With target tracking policies, Amazon will automatically adjust the size of your ASG to keep the selected metric as close as possible to the selected value."), cloudwatch && /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement("b", null, "Note:"), ' metrics must be sent to Amazon CloudWatch before they can be used in auto scaling. If you do not see a metric below, click "Configure available metrics" in the server group details to set up forwarding from Atlas to CloudWatch.'), /* @__PURE__ */ React.createElement("div", {
    className: "row sp-margin-s-yaxis"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "col-md-2 sm-label-right"
  }, "Metric"), /* @__PURE__ */ React.createElement("div", {
    className: "col-md-10 content-fields"
  }, !isCustomMetric && /* @__PURE__ */ React.createElement(ReactSelectInput, {
    value: (_a = command.targetTrackingConfiguration.predefinedMetricSpecification) == null ? void 0 : _a.predefinedMetricType,
    stringOptions: predefinedMetrics,
    onChange: (e) => setCommandField("targetTrackingConfiguration.predefinedMetricSpecification.predefinedMetricType", e.target.value),
    inputClassName: "metric-select-input"
  }), isCustomMetric && /* @__PURE__ */ React.createElement(MetricSelector, {
    alarm: command.targetTrackingConfiguration.customizedMetricSpecification,
    serverGroup,
    updateAlarm
  }), allowDualMode && /* @__PURE__ */ React.createElement("a", {
    className: "clickable",
    onClick: onMetricTypeChange
  }, isCustomMetric ? "Use a predefined metric" : "Select a custom metric"))), /* @__PURE__ */ React.createElement("div", {
    className: "row sp-margin-s-yaxis"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "col-md-2 sm-label-right"
  }, "Target"), /* @__PURE__ */ React.createElement("div", {
    className: "col-md-10 content-fields horizontal"
  }, isCustomMetric && /* @__PURE__ */ React.createElement("div", {
    className: "horizontal middle"
  }, /* @__PURE__ */ React.createElement(ReactSelectInput, {
    value: (_b = command.targetTrackingConfiguration.customizedMetricSpecification) == null ? void 0 : _b.statistic,
    stringOptions: statistics,
    onChange: (e) => setCommandField("targetTrackingConfiguration.customizedMetricSpecification.statistic", e.target.value),
    inputClassName: "form-control input-sm target-input"
  }), /* @__PURE__ */ React.createElement("span", {
    className: "sp-margin-xs-xaxis"
  }, "of")), /* @__PURE__ */ React.createElement("div", {
    className: "horizontal middle"
  }, /* @__PURE__ */ React.createElement(NumberInput, {
    value: command.targetTrackingConfiguration.targetValue,
    onChange: (e) => setCommandField("targetTrackingConfiguration.targetValue", Number.parseInt(e.target.value)),
    inputClassName: "form-control input-sm sp-margin-xs-right"
  }), /* @__PURE__ */ React.createElement("span", null, unit)))), /* @__PURE__ */ React.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "col-md-10 col-md-offset-1"
  }, /* @__PURE__ */ React.createElement(TargetTrackingChart, {
    config: command.targetTrackingConfiguration,
    serverGroup,
    unit,
    updateUnit: (u) => setUnit(u)
  }))));
};

var css_248z$8 = ".TargetTrackingAdditionalSettings {\n  font-size: 14px;\n}\n.TargetTrackingAdditionalSettings .row {\n  margin-bottom: 10px;\n}\n.TargetTrackingAdditionalSettings .number-input-sm {\n  width: 120px;\n}\n";
styleInject(css_248z$8);

const TargetTrackingAdditionalSettings = ({
  command,
  cooldowns,
  policyName,
  updateCommand
}) => {
  var _a;
  const setCommandField = (path, value) => {
    const newCommand = { ...command };
    set(newCommand, path, value);
    updateCommand(newCommand);
  };
  const scaleInDisabled = (_a = command.targetTrackingConfiguration) == null ? void 0 : _a.disableScaleIn;
  return /* @__PURE__ */ React.createElement("div", {
    className: "section-body TargetTrackingAdditionalSettings"
  }, policyName && /* @__PURE__ */ React.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "col-md-2 sm-label-right"
  }, "Policy Name"), /* @__PURE__ */ React.createElement("div", {
    className: "col-md-10 horizontal middle"
  }, policyName)), Boolean(command.estimatedInstanceWarmup) && /* @__PURE__ */ React.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "col-md-2 sm-label-right"
  }, "Warmup"), /* @__PURE__ */ React.createElement("div", {
    className: "col-md-10 horizontal middle"
  }, /* @__PURE__ */ React.createElement("span", {
    className: "form-control-static"
  }, "Instances need"), /* @__PURE__ */ React.createElement(NumberInput, {
    value: command.estimatedInstanceWarmup,
    onChange: (e) => setCommandField("estimatedInstanceWarmup", Number.parseInt(e.target.value)),
    inputClassName: "form-control number-input-sm sp-margin-xs-xaxis"
  }), /* @__PURE__ */ React.createElement("span", {
    className: "input-label"
  }, " seconds to warm up "))), /* @__PURE__ */ React.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "col-md-2 sm-label-right"
  }, "Scale In"), /* @__PURE__ */ React.createElement("div", {
    className: "col-md-9"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "checkbox"
  }, /* @__PURE__ */ React.createElement(CheckboxInput, {
    text: "Disable Scale-downs",
    checked: scaleInDisabled,
    onChange: (e) => setCommandField("targetTrackingConfiguration.disableScaleIn", e.target.checked)
  }), /* @__PURE__ */ React.createElement("div", {
    className: "small"
  }, /* @__PURE__ */ React.createElement("p", null, "This option disables scale-downs for the target tracking policy, while keeping the scale-ups. This means that ASG will not scale down unless you explicitly set up a separate step policy to scale it down."), /* @__PURE__ */ React.createElement("p", null, "This is useful when you have special requirements, such as gradual or delayed scale-down."))))), /* @__PURE__ */ React.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "col-md-10 col-md-offset-1"
  }, scaleInDisabled && /* @__PURE__ */ React.createElement("div", {
    className: "well"
  }, "This policy will not scale down. Make sure you have another policy (either TT or Step) that will scale down this ASG."), scaleInDisabled === false && /* @__PURE__ */ React.createElement("div", {
    className: "well"
  }, "This policy will scale both up and down. Make sure you don't have other scaling policies, as they will likely interfere with each other."))), cooldowns && !scaleInDisabled && /* @__PURE__ */ React.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "col-md-3 sm-label-right"
  }, /* @__PURE__ */ React.createElement("span", {
    className: "sp-margin-xs-right"
  }, "Scale In Cooldown"), /* @__PURE__ */ React.createElement(HelpField, {
    id: "titus.autoscaling.scaleIn.cooldown"
  })), /* @__PURE__ */ React.createElement("div", {
    className: "col-md-9 horizontal middle"
  }, /* @__PURE__ */ React.createElement(NumberInput, {
    value: command.targetTrackingConfiguration.scaleInCooldown,
    onChange: (e) => setCommandField("targetTrackingConfiguration.scaleInCooldown", Number.parseInt(e.target.value)),
    inputClassName: "sp-margin-xs-xaxis number-input-sm"
  }), /* @__PURE__ */ React.createElement("span", {
    className: "input-label"
  }, " seconds "))), cooldowns && /* @__PURE__ */ React.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "col-md-3 sm-label-right"
  }, /* @__PURE__ */ React.createElement("span", {
    className: "sp-margin-xs-right"
  }, "Scale Out Cooldown"), /* @__PURE__ */ React.createElement(HelpField, {
    id: "titus.autoscaling.scaleOut.cooldown"
  })), /* @__PURE__ */ React.createElement("div", {
    className: "col-md-9 horizontal middle"
  }, /* @__PURE__ */ React.createElement(NumberInput, {
    value: command.targetTrackingConfiguration.scaleOutCooldown,
    onChange: (e) => setCommandField("targetTrackingConfiguration.scaleOutCooldown", Number.parseInt(e.target.value)),
    inputClassName: "sp-margin-xs-xaxis number-input-sm"
  }), /* @__PURE__ */ React.createElement("span", {
    className: "input-label"
  }, " seconds "))));
};

const ScalingPolicyCommandBuilder = {
  buildAlarm: (policy, region, asgName) => {
    const alarm = (policy == null ? void 0 : policy.alarms) ? policy.alarms[0] : {};
    return {
      name: alarm.alarmName,
      actionsEnabled: true,
      alarmActionArns: alarm.alarmActions,
      alarmDescription: alarm.alarmDescription,
      asgName,
      comparisonOperator: alarm.comparisonOperator,
      dimensions: alarm.dimensions,
      evaluationPeriods: alarm.evaluationPeriods,
      insufficientDataActionArns: alarm.insufficientDataActions,
      metricName: alarm.metricName,
      namespace: alarm.namespace,
      okActionArns: alarm.okactions,
      period: alarm.period,
      region,
      statistic: alarm.statistic,
      threshold: alarm.threshold,
      unit: alarm.unit
    };
  },
  buildStepPolicy: (policy, threshold, cooldown) => {
    var _a, _b;
    const stepAdjustments = policy.stepAdjustments.map((adjustment) => {
      const step = {
        scalingAdjustment: Math.abs(adjustment.scalingAdjustment)
      };
      if (adjustment.metricIntervalUpperBound !== void 0) {
        step.metricIntervalUpperBound = adjustment.metricIntervalUpperBound + threshold;
      }
      if (adjustment.metricIntervalLowerBound !== void 0) {
        step.metricIntervalLowerBound = adjustment.metricIntervalLowerBound + threshold;
      }
      return step;
    });
    return {
      estimatedInstanceWarmup: (_b = (_a = policy.estimatedInstanceWarmup) != null ? _a : cooldown) != null ? _b : 600,
      metricAggregationType: "Average",
      stepAdjustments
    };
  },
  buildSimplePolicy: (policy) => {
    var _a, _b;
    return {
      cooldown: (_a = policy.cooldown) != null ? _a : 600,
      scalingAdjustment: (_b = Math.abs(policy.scalingAdjustment)) != null ? _b : 1
    };
  },
  buildNewCommand: (type, serverGroup, policy) => {
    var _a, _b, _c;
    const command = {
      name: policy.policyName,
      adjustmentType: type === "Step" ? policy.adjustmentType : null,
      cloudProvider: serverGroup.cloudProvider,
      credentials: serverGroup.account,
      provider: serverGroup.type,
      region: serverGroup.region,
      serverGroupName: serverGroup.name
    };
    if (type === "Step") {
      command.alarm = ScalingPolicyCommandBuilder.buildAlarm(policy, serverGroup.region, serverGroup.name);
      command.minAdjustmentMagnitude = (_a = policy.minAdjustmentMagnitude) != null ? _a : 1;
      if ((_b = policy.stepAdjustments) == null ? void 0 : _b.length) {
        command.step = ScalingPolicyCommandBuilder.buildStepPolicy(policy, command.alarm.threshold, command.cooldown);
      } else {
        command.simple = ScalingPolicyCommandBuilder.buildSimplePolicy(policy);
      }
    }
    if (type === "TargetTracking") {
      command.estimatedInstanceWarmup = (_c = policy.estimatedInstanceWarmup) != null ? _c : 600;
      command.targetTrackingConfiguration = { ...policy.targetTrackingConfiguration };
    }
    return command;
  },
  prepareCommandForUpsert: (command, isRemove) => {
    const commandToSubmit = cloneDeep(command);
    if (commandToSubmit.adjustmentType !== "PercentChangeInCapacity") {
      delete commandToSubmit.minAdjustmentMagnitude;
    }
    if (commandToSubmit.step) {
      commandToSubmit.step.stepAdjustments.forEach((step) => {
        if (isRemove) {
          step.scalingAdjustment = 0 - step.scalingAdjustment;
          delete commandToSubmit.step.estimatedInstanceWarmup;
        }
        if (step.metricIntervalLowerBound !== void 0) {
          step.metricIntervalLowerBound -= commandToSubmit.alarm.threshold;
        }
        if (step.metricIntervalUpperBound !== void 0) {
          step.metricIntervalUpperBound -= commandToSubmit.alarm.threshold;
        }
      });
    } else {
      if (isRemove) {
        command.simple.scalingAdjustment = 0 - command.simple.scalingAdjustment;
      }
    }
    return commandToSubmit;
  }
};

const UpsertTargetTrackingModal = ({
  app,
  closeModal,
  dismissModal,
  policy,
  serverGroup
}) => {
  var _a;
  const [isCustom, setIsCustom] = React.useState(Boolean((_a = policy.targetTrackingConfiguration) == null ? void 0 : _a.customizedMetricSpecification));
  const [command, setCommand] = React.useState({});
  React.useEffect(() => {
    const baseCommand = ScalingPolicyCommandBuilder.buildNewCommand("TargetTracking", serverGroup, policy);
    setCommand(baseCommand);
  }, []);
  const mode = policy.policyName ? "Update" : "Create";
  return /* @__PURE__ */ React.createElement(TaskMonitorModal, {
    closeModal,
    dismissModal,
    title: `${mode} scaling policy`,
    application: app,
    description: `${mode} scaling policy for ${serverGroup.name}`,
    initialValues: command,
    mapValuesToTask: () => ({
      application: app,
      job: [
        {
          type: "upsertScalingPolicy",
          ...command
        }
      ]
    }),
    render: () => /* @__PURE__ */ React.createElement("div", {
      className: "modal-body"
    }, /* @__PURE__ */ React.createElement("h4", {
      className: "section-heading"
    }, "Target Metric"), /* @__PURE__ */ React.createElement(TargetMetricFields, {
      allowDualMode: true,
      cloudwatch: false,
      command,
      isCustomMetric: isCustom,
      serverGroup,
      toggleMetricType: (t) => setIsCustom(t === "custom"),
      updateCommand: setCommand
    }), /* @__PURE__ */ React.createElement("h4", {
      className: "section-heading"
    }, "Additional Settings"), /* @__PURE__ */ React.createElement(TargetTrackingAdditionalSettings, {
      command,
      cooldowns: false,
      policyName: policy.policyName,
      updateCommand: setCommand
    }))
  });
};

function PolicyTypeSelectionModal(props) {
  const [typeSelection, setTypeSelection] = React__default.useState(null);
  const selectType = (e) => {
    setTypeSelection(e.currentTarget.id);
  };
  const confirmTypeSelection = () => {
    props.typeSelectedCallback(typeSelection);
  };
  const stepClass = typeSelection === "step" ? "card active" : "card";
  const targetClass = typeSelection === "targetTracking" ? "card active" : "card";
  const customHelpKey = "aws.scalingPolicy.additionalHelp";
  const hasCustomHelpMessage = !!HelpContentsRegistry.getHelpField(customHelpKey);
  return /* @__PURE__ */ React__default.createElement(Modal, {
    show: true,
    onHide: props.showCallback
  }, /* @__PURE__ */ React__default.createElement(Modal.Header, {
    closeButton: true
  }, /* @__PURE__ */ React__default.createElement("h3", null, "Select a policy type")), /* @__PURE__ */ React__default.createElement(Modal.Body, null, /* @__PURE__ */ React__default.createElement("div", {
    className: "card-choices"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: targetClass,
    onClick: selectType,
    id: "targetTracking"
  }, /* @__PURE__ */ React__default.createElement("h3", null, "Target Tracking"), /* @__PURE__ */ React__default.createElement("div", null, "Continuously adjusts the size of the ASG to keep a specified metric at the target value")), /* @__PURE__ */ React__default.createElement("div", {
    className: stepClass,
    onClick: selectType,
    id: "step"
  }, /* @__PURE__ */ React__default.createElement("h3", null, "Step"), /* @__PURE__ */ React__default.createElement("div", null, "Rule-based scaling, with the ability to define different scaling amounts depending on the magnitude of the alarm breach"))), hasCustomHelpMessage && /* @__PURE__ */ React__default.createElement(ValidationMessage, {
    type: "info",
    message: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: customHelpKey,
      expand: true
    })
  }), props.warnOnMinMaxCapacity && /* @__PURE__ */ React__default.createElement(ValidationMessage, {
    type: "warning",
    message: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("p", null, "This server group's ", /* @__PURE__ */ React__default.createElement("em", null, "min"), " and ", /* @__PURE__ */ React__default.createElement("em", null, "max"), " capacity are identical, so scaling policies will have ", /* @__PURE__ */ React__default.createElement("b", null, "no effect.")), /* @__PURE__ */ React__default.createElement("p", null, "Scaling policies work by adjusting the server group's ", /* @__PURE__ */ React__default.createElement("em", null, "desired"), " capacity to a value between the min and max."))
  })), /* @__PURE__ */ React__default.createElement(Modal.Footer, null, /* @__PURE__ */ React__default.createElement("button", {
    className: "btn btn-default",
    onClick: props.showCallback
  }, "Cancel"), /* @__PURE__ */ React__default.createElement("button", {
    className: "btn btn-primary",
    disabled: !typeSelection,
    onClick: confirmTypeSelection
  }, "Next")));
}

var css_248z$7 = ".ScalingPolicyAdditionalSettings .section-additional-settings .row {\n  margin-bottom: 10px;\n}\n.ScalingPolicyAdditionalSettings .section-additional-settings .number-input-sm {\n  width: 60px;\n}\n";
styleInject(css_248z$7);

const ScalingPolicyAdditionalSettings = ({
  command,
  isInstanceType,
  isNew,
  operator,
  updateCommand
}) => {
  var _a, _b, _c, _d;
  const setCommandField = (path, value) => {
    const newCommand = { ...command };
    set(newCommand, path, value);
    updateCommand(newCommand);
  };
  return /* @__PURE__ */ React.createElement("div", {
    className: "ScalingPolicyAdditionalSettings"
  }, /* @__PURE__ */ React.createElement("h4", {
    className: "section-heading"
  }, "Additional Settings"), /* @__PURE__ */ React.createElement("div", {
    className: "section-body section-additional-settings"
  }, !isNew && /* @__PURE__ */ React.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "col-md-2 sm-label-right"
  }, "Policy Name"), /* @__PURE__ */ React.createElement("div", {
    className: "col-md-10 horizontal middle"
  }, /* @__PURE__ */ React.createElement("span", {
    className: "form-control-static select-placeholder"
  }, command.name))), !isInstanceType && /* @__PURE__ */ React.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "col-md-2 sm-label-right"
  }, "Adjustment Step"), /* @__PURE__ */ React.createElement("div", {
    className: "col-md-10 horizontal middle"
  }, /* @__PURE__ */ React.createElement("span", {
    className: "form-control-static select-placeholder"
  }, `${operator} instances in increments of at least `), /* @__PURE__ */ React.createElement(NumberInput, {
    value: command.minAdjustmentMagnitude,
    onChange: (e) => setCommandField("minAdjustmentMagnitude", Number.parseInt(e.target.value)),
    inputClassName: "sp-margin-xs-xaxis input-sm number-input-sm"
  }), /* @__PURE__ */ React.createElement("span", {
    className: "input-label"
  }, " instance(s) "))), Boolean(command.simple) && /* @__PURE__ */ React.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "col-md-2 sm-label-right"
  }, "Cooldown"), /* @__PURE__ */ React.createElement("div", {
    className: "col-md-10 horizontal middle"
  }, /* @__PURE__ */ React.createElement("span", {
    className: "form-control-static select-placeholder"
  }, " Wait at least "), /* @__PURE__ */ React.createElement(NumberInput, {
    value: (_a = command.simple) == null ? void 0 : _a.cooldown,
    onChange: (e) => setCommandField("simple.cooldown", Number.parseInt(e.target.value)),
    inputClassName: "sp-margin-xs-xaxis input-sm number-input-sm"
  }), /* @__PURE__ */ React.createElement("span", {
    className: "input-label"
  }, " seconds before another scaling event "))), Boolean((_b = command.step) == null ? void 0 : _b.estimatedInstanceWarmup) && operator !== "Remove" && /* @__PURE__ */ React.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "col-md-2 sm-label-right"
  }, "Warmup"), /* @__PURE__ */ React.createElement("div", {
    className: "col-md-10 horizontal middle"
  }, /* @__PURE__ */ React.createElement("span", {
    className: "form-control-static select-placeholder"
  }, "Instances need"), /* @__PURE__ */ React.createElement(NumberInput, {
    value: command.step.estimatedInstanceWarmup,
    onChange: (e) => setCommandField("step.estimatedInstanceWarmup", Number.parseInt(e.target.value)),
    inputClassName: "sp-margin-xs-xaxis input-sm number-input-sm"
  }), /* @__PURE__ */ React.createElement("span", {
    className: "input-label"
  }, " seconds to warm up after each step "))), Boolean((_c = command.step) == null ? void 0 : _c.cooldown) && operator !== "Remove" && /* @__PURE__ */ React.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "col-md-2 sm-label-right"
  }, /* @__PURE__ */ React.createElement("span", {
    className: "sp-margin-xs-right"
  }, "Cooldown"), /* @__PURE__ */ React.createElement(HelpField, {
    id: `${command.cloudProvider || command.provider}.autoscaling.cooldown`
  })), /* @__PURE__ */ React.createElement("div", {
    className: "col-md-10 horizontal middle"
  }, /* @__PURE__ */ React.createElement(NumberInput, {
    value: (_d = command.step) == null ? void 0 : _d.cooldown,
    onChange: (e) => setCommandField("step.cooldown", Number.parseInt(e.target.value)),
    inputClassName: "sp-margin-xs-xaxis input-sm number-input-sm"
  }), /* @__PURE__ */ React.createElement("span", {
    className: "input-label"
  }, " seconds ")))));
};

var css_248z$6 = ".AlarmConfigurer {\n  font-size: 12px;\n  margin: 0px;\n}\n.AlarmConfigurer .configurer-field-lg {\n  width: 90px;\n}\n.AlarmConfigurer .configurer-field-small {\n  width: 32px;\n}\n.AlarmConfigurer .configurer-field-med {\n  width: 60px;\n}\n.AlarmConfigurer .number-input-field {\n  margin: 0px;\n}\n";
styleInject(css_248z$6);

const STATISTICS = ["Average", "Maximum", "Minimum", "SampleCount", "Sum"];
const COMPARATORS = [
  { label: ">=", value: "GreaterThanOrEqualToThreshold" },
  { label: ">", value: "GreaterThanThreshold" },
  { label: "<=", value: "LessThanOrEqualToThreshold" },
  { label: "<", value: "LessThanThreshold" }
];
const PERIODS = [
  { label: "1 minute", value: 60 },
  { label: "5 minutes", value: 60 * 5 },
  { label: "15 minutes", value: 60 * 15 },
  { label: "1 hour", value: 60 * 60 },
  { label: "4 hours", value: 60 * 60 * 4 },
  { label: "1 day", value: 60 * 60 * 24 }
];
const AlarmConfigurer = ({
  alarm,
  multipleAlarms,
  serverGroup,
  stepAdjustments,
  stepsChanged,
  updateAlarm
}) => {
  var _a, _b;
  const comparatorBound = ((_a = alarm.comparisonOperator) == null ? void 0 : _a.indexOf("Greater")) === 0 ? "max" : "min";
  const [unit, setUnit] = React.useState(alarm == null ? void 0 : alarm.unit);
  const prevComparator = usePrevious(comparatorBound);
  React.useEffect(() => {
    if (stepAdjustments && prevComparator !== void 0) {
      const source = comparatorBound === "max" ? "metricIntervalLowerBound" : "metricIntervalUpperBound";
      const newStep = {
        scalingAdjustment: 1,
        [source]: alarm.threshold
      };
      stepsChanged([newStep]);
    }
  }, [comparatorBound]);
  React.useEffect(() => {
    const source = comparatorBound === "max" ? "metricIntervalLowerBound" : "metricIntervalUpperBound";
    if (stepAdjustments == null ? void 0 : stepAdjustments.length) {
      const updatedStepAdjustments = [...stepAdjustments];
      updatedStepAdjustments[0][source] = alarm.threshold;
      stepsChanged(updatedStepAdjustments);
    }
  }, [alarm.threshold]);
  const onChartLoaded = (stats) => setUnit(stats.unit);
  const onAlarmChange = (key, value) => {
    const newAlarm = {
      ...alarm,
      [key]: value
    };
    updateAlarm(newAlarm);
  };
  const onMetricChange = (newAlarm) => {
    updateAlarm(newAlarm);
  };
  return /* @__PURE__ */ React.createElement("div", {
    className: "AlarmConfigurer"
  }, multipleAlarms && /* @__PURE__ */ React.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "col-md-12"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "alert alert-warning"
  }, /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement("i", {
    className: "fa fa-exclamation-triangle"
  }), " This scaling policy is configured with multiple alarms. You are only editing the first alarm."), /* @__PURE__ */ React.createElement("p", null, "To edit or remove the additional alarms, you will need to use the AWS console.")))), ((_b = alarm.alarmActionArns) == null ? void 0 : _b.length) > 1 && /* @__PURE__ */ React.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "col-md-12"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "alert alert-warning"
  }, /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement("i", {
    className: "fa fa-exclamation-triangle"
  }), " This alarm is used in multiple scaling policies. Any changes here will affect those other scaling policies.")))), /* @__PURE__ */ React.createElement("div", {
    className: "row sp-margin-s-yaxis"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "col-md-2 sm-label-right"
  }, "Whenever"), /* @__PURE__ */ React.createElement("div", {
    className: "col-md-10 horizontal"
  }, /* @__PURE__ */ React.createElement(ReactSelectInput, {
    value: alarm.statistic,
    onChange: (e) => onAlarmChange("statistic", e.target.value),
    stringOptions: STATISTICS,
    clearable: false,
    inputClassName: "sp-margin-xs-right configurer-field-lg"
  }), /* @__PURE__ */ React.createElement("span", {
    className: "input-label sp-margin-xs-right sp-margin-s-top"
  }, " of "), /* @__PURE__ */ React.createElement(MetricSelector, {
    alarm,
    serverGroup,
    updateAlarm: onMetricChange
  }))), /* @__PURE__ */ React.createElement("div", {
    className: "row sp-margin-s-yaxis"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "col-md-2 sm-label-right"
  }, "is"), /* @__PURE__ */ React.createElement("div", {
    className: "col-md-10 horizontal middle"
  }, /* @__PURE__ */ React.createElement(ReactSelectInput, {
    value: alarm.comparisonOperator,
    onChange: (e) => onAlarmChange("comparisonOperator", e.target.value),
    options: COMPARATORS,
    clearable: false,
    inputClassName: "sp-margin-s-right configurer-field-small"
  }), /* @__PURE__ */ React.createElement("div", {
    className: "sp-margin-xl-left"
  }, /* @__PURE__ */ React.createElement(NumberInput, {
    value: alarm.threshold,
    onChange: (e) => onAlarmChange("threshold", Number.parseInt(e.target.value)),
    inputClassName: "sp-margin-xs-right configurer-field-lg"
  })), /* @__PURE__ */ React.createElement("span", {
    className: "input-label"
  }, unit))), /* @__PURE__ */ React.createElement("div", {
    className: "row sp-margin-s-yaxis"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "col-md-2 sm-label-right"
  }, "for at least"), /* @__PURE__ */ React.createElement("div", {
    className: "col-md-10 horizontal middle"
  }, /* @__PURE__ */ React.createElement(NumberInput, {
    value: alarm.evaluationPeriods,
    onChange: (e) => onAlarmChange("evaluationPeriods", Number.parseInt(e.target.value)),
    inputClassName: "configurer-field-med number-input-field"
  }), /* @__PURE__ */ React.createElement("span", {
    className: "input-label sp-margin-s-xaxis"
  }, " consecutive period(s) of "), /* @__PURE__ */ React.createElement(ReactSelectInput, {
    value: alarm.period,
    onChange: (e) => onAlarmChange("period", e.target.value),
    options: PERIODS,
    clearable: false,
    inputClassName: "sp-margin-xs-right configurer-field-lg"
  }))), /* @__PURE__ */ React.createElement("div", {
    className: "row sp-margin-s-yaxis"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "col-md-10 col-md-offset-1"
  }, alarm && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(MetricAlarmChart, {
    alarm,
    serverGroup,
    onChartLoaded
  })))));
};

var css_248z$5 = ".SimplePolicyAction .action-input {\n  width: 65px;\n}\n.SimplePolicyAction .adjustment-type-input {\n  width: 110px;\n}\n";
styleInject(css_248z$5);

const SimplePolicyAction = ({
  adjustmentType,
  adjustmentTypeChanged,
  operator,
  scalingAdjustment,
  updateScalingAdjustment
}) => {
  const availableActions = ["Add", "Remove", "Set to"];
  const adjustmentTypeOptions = operator === "Set to" ? ["instances"] : ["instances", "percent of group"];
  const onActionChange = (val) => {
    adjustmentTypeChanged(val, adjustmentType);
  };
  const [adjustmentTypeView, setAdjustmentTypeView] = React.useState(adjustmentType);
  const onAdjustmentTypeChange = (type) => {
    setAdjustmentTypeView(type);
    adjustmentTypeChanged(operator, type);
  };
  const [adjustment, setAdjustment] = React.useState(scalingAdjustment);
  const onScalingAdjustmentChange = (adj) => {
    setAdjustment(adj);
    updateScalingAdjustment(adj);
  };
  return /* @__PURE__ */ React.createElement("div", {
    className: "SimplePolicyAction row"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "col-md-10 col-md-offset-1 horizontal middle"
  }, /* @__PURE__ */ React.createElement(ReactSelectInput, {
    value: operator,
    stringOptions: availableActions,
    onChange: (e) => onActionChange(e.target.value),
    clearable: false,
    inputClassName: "action-input"
  }), /* @__PURE__ */ React.createElement(NumberInput, {
    value: adjustment,
    min: 1,
    onChange: (e) => onScalingAdjustmentChange(Number.parseInt(e.target.value)),
    inputClassName: "action-input"
  }), /* @__PURE__ */ React.createElement(ReactSelectInput, {
    value: adjustmentTypeView,
    stringOptions: adjustmentTypeOptions,
    onChange: (e) => onAdjustmentTypeChange(e.target.value),
    clearable: false,
    inputClassName: "adjustment-type-input"
  })));
};

var css_248z$4 = ".StepPolicyAction .step-policy-row {\n  padding: 5px 0;\n  border-bottom: 1px solid var(--color-seashell);\n}\n.StepPolicyAction .step-policy-row .action-input {\n  width: 65px !important;\n}\n.StepPolicyAction .step-policy-row .adjustment-type-input {\n  width: 110px;\n}\n.StepPolicyAction .step-policy-row .remove-step-action-icon {\n  margin-left: auto;\n}\n";
styleInject(css_248z$4);

const StepPolicyAction = ({
  adjustmentType,
  adjustmentTypeChanged,
  alarm,
  isMin,
  operator,
  step,
  stepAdjustments,
  stepsChanged
}) => {
  const hasEqualTo = alarm == null ? void 0 : alarm.comparisonOperator.includes("Equal");
  const availableActions = ["Add", "Remove", "Set to"];
  const adjustmentTypeOptions = operator === "Set to" ? ["instances"] : ["instances", "percent of group"];
  const onActionChange = (val) => {
    adjustmentTypeChanged(val, adjustmentType);
  };
  const onAdjustmentTypeChange = (type) => {
    adjustmentTypeChanged(operator, type);
  };
  const steps = (step == null ? void 0 : step.stepAdjustments) || stepAdjustments;
  const addStep = () => {
    const newStep = { scalingAdjustment: 1 };
    const newSteps = [...steps, newStep];
    stepsChanged(newSteps);
  };
  const removeStep = (index) => {
    const newSteps = steps.filter((_s, i) => i !== index);
    stepsChanged(newSteps);
  };
  const updateStep = (updatedStep, index) => {
    const newSteps = [...steps];
    newSteps[index] = updatedStep;
    stepsChanged(newSteps);
  };
  return /* @__PURE__ */ React.createElement("div", {
    className: "StepPolicyAction row"
  }, steps == null ? void 0 : steps.map((step2, index) => /* @__PURE__ */ React.createElement("div", {
    key: `step-adjustment-${index}`,
    className: "step-policy-row col-md-10 col-md-offset-1 horizontal middle"
  }, Boolean(index) ? /* @__PURE__ */ React.createElement("span", {
    className: "action-input sp-margin-xs-left"
  }, operator) : /* @__PURE__ */ React.createElement(ReactSelectInput, {
    value: operator,
    stringOptions: availableActions,
    onChange: (e) => onActionChange(e.target.value),
    clearable: false,
    inputClassName: "action-input sp-margin-xs-right"
  }), /* @__PURE__ */ React.createElement(NumberInput, {
    value: step2.scalingAdjustment,
    min: 1,
    onChange: (e) => updateStep({ ...step2, scalingAdjustment: Number.parseInt(e.target.value) }, index),
    inputClassName: "action-input"
  }), Boolean(index) ? /* @__PURE__ */ React.createElement("span", {
    className: "sp-margin-xs-left"
  }, adjustmentType) : /* @__PURE__ */ React.createElement(ReactSelectInput, {
    value: adjustmentType,
    stringOptions: adjustmentTypeOptions,
    onChange: (e) => onAdjustmentTypeChange(e.target.value),
    clearable: false,
    inputClassName: "adjustment-type-input sp-margin-xs-left"
  }), /* @__PURE__ */ React.createElement("span", {
    className: "sp-margin-xs-xaxis"
  }, " ", "when ", /* @__PURE__ */ React.createElement("b", null, alarm == null ? void 0 : alarm.metricName), " is", " "), index === steps.length - 1 && /* @__PURE__ */ React.createElement("span", null, ` ${isMin ? "less" : "greater"} than${!Boolean(index) || hasEqualTo ? " or equal to" : ""} ${isMin ? step2.metricIntervalUpperBound || "" : step2.metricIntervalLowerBound || ""} `), index < steps.length - 1 && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", {
    className: "sp-margin-xs-xaxis"
  }, "between"), isMin ? /* @__PURE__ */ React.createElement(NumberInput, {
    value: step2.metricIntervalLowerBound,
    max: step2.metricIntervalUpperBound,
    onChange: (e) => updateStep({ ...step2, metricIntervalLowerBound: Number.parseInt(e.target.value) }, index),
    inputClassName: "action-input"
  }) : /* @__PURE__ */ React.createElement("span", null, step2.metricIntervalLowerBound), /* @__PURE__ */ React.createElement("span", {
    className: "sp-margin-xs-xaxis"
  }, "and"), isMin ? /* @__PURE__ */ React.createElement("span", null, step2.metricIntervalUpperBound) : /* @__PURE__ */ React.createElement(NumberInput, {
    value: step2.metricIntervalUpperBound,
    min: step2.metricIntervalLowerBound,
    onChange: (e) => updateStep({ ...step2, metricIntervalUpperBound: Number.parseInt(e.target.value) }, index),
    inputClassName: "action-input"
  })), Boolean(index) && /* @__PURE__ */ React.createElement("a", {
    className: "glyphicon glyphicon-trash clickable sp-margin-xs-xaxis remove-step-action-icon",
    onClick: () => removeStep(index)
  }))), /* @__PURE__ */ React.createElement("div", {
    className: "row sp-margin-s"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "col-md-10 col-md-offset-1"
  }, /* @__PURE__ */ React.createElement("button", {
    type: "button",
    className: "btn btn-block btn-sm add-new",
    onClick: addStep
  }, /* @__PURE__ */ React.createElement("span", {
    className: "glyphicon glyphicon-plus-sign"
  }), "Add step"))), /* @__PURE__ */ React.createElement("div", {
    className: "row sp-margin-s-xaxis"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "col-md-10 col-md-offset-1"
  }, /* @__PURE__ */ React.createElement("a", {
    href: "http://docs.aws.amazon.com/autoscaling/latest/userguide/as-scale-based-on-demand.html#as-scaling-steps",
    target: "_blank"
  }, /* @__PURE__ */ React.createElement("i", {
    className: "far fa-file-alt sp-margin-xs-right"
  }), "Documentation"))));
};

const UpsertScalingPolicyModal = ({
  app,
  closeModal,
  dismissModal,
  policy,
  serverGroup
}) => {
  var _a, _b, _c;
  const modalProps = { closeModal, dismissModal };
  const [command, setCommand] = React.useState({});
  React.useEffect(() => {
    const baseCommand = ScalingPolicyCommandBuilder.buildNewCommand("Step", serverGroup, policy);
    setCommand(baseCommand);
  }, []);
  const adjustmentBasis = ((_a = policy.stepAdjustments) == null ? void 0 : _a.length) ? policy.stepAdjustments[0].scalingAdjustment : policy.scalingAdjustment;
  const [action, setAction] = React.useState(command.adjustmentType === "ExactCapacity" ? "Set to" : adjustmentBasis > 0 ? "Add" : "Remove");
  const adjustmentTypeView = command.adjustmentType === "ExactCapacity" || command.adjustmentType === "ChangeInCapacity" ? "instances" : "percent of group";
  const isStep = command.step;
  const mode = !policy.policyARN ? "Create" : "Edit";
  const comparatorBound = ((_c = (_b = command == null ? void 0 : command.alarm) == null ? void 0 : _b.comparisonOperator) == null ? void 0 : _c.indexOf("Greater")) === 0 ? "max" : "min";
  const boundsChanged = (step) => {
    const source = comparatorBound === "min" ? "metricIntervalLowerBound" : "metricIntervalUpperBound";
    const target = source === "metricIntervalLowerBound" ? "metricIntervalUpperBound" : "metricIntervalLowerBound";
    const adjustments = step.stepAdjustments;
    (adjustments || []).forEach((a, index) => {
      if (adjustments.length > index + 1) {
        adjustments[index + 1][target] = a[source];
      }
    });
    delete adjustments[adjustments.length - 1][source];
  };
  const scalingAdjustmentChanged = (adjustment) => {
    const newCommand = cloneDeep(command);
    newCommand.simplescalingAdjustment = adjustment;
    setCommand(newCommand);
  };
  const stepsChanged = (newSteps) => {
    const newCommand = cloneDeep(command);
    newCommand.step.stepAdjustments = newSteps;
    boundsChanged(newCommand.step);
    setCommand(newCommand);
  };
  const adjustmentTypeChanged = (action2, type) => {
    setAction(action2);
    const newType = type !== "instances" ? "PercentChangeInCapacity" : action2 === "Set to" ? "ExactCapacity" : "ChangeInCapacity";
    setCommand({
      ...command,
      adjustmentType: newType
    });
  };
  const toggleMode = () => {
    const updatedCommand = cloneDeep(command);
    const cooldownOrWarmup = command.step ? command.step.estimatedInstanceWarmup : command.simple.cooldown;
    if (command.step) {
      delete updatedCommand.step;
      updatedCommand.simple = ScalingPolicyCommandBuilder.buildSimplePolicy({
        cooldown: cooldownOrWarmup
      });
    } else {
      const stepAdjustments = [
        {
          scalingAdjustment: command.simple.scalingAdjustment
        }
      ];
      if (comparatorBound === "min") {
        stepAdjustments[0].metricIntervalUpperBound = 0;
      } else {
        stepAdjustments[0].metricIntervalLowerBound = 0;
      }
      const stepPolicy = {
        estimatedInstanceWarmup: cooldownOrWarmup,
        stepAdjustments
      };
      delete updatedCommand.simple;
      updatedCommand.step = ScalingPolicyCommandBuilder.buildStepPolicy(stepPolicy, updatedCommand.alarm.threshold, cooldownOrWarmup);
      boundsChanged(updatedCommand.step);
    }
    setCommand(updatedCommand);
  };
  return /* @__PURE__ */ React.createElement(TaskMonitorModal, {
    ...modalProps,
    title: `${mode} scaling policy`,
    application: app,
    description: `${mode} scaling policy for ${serverGroup.name}`,
    initialValues: command,
    mapValuesToTask: () => {
      const preppedValues = ScalingPolicyCommandBuilder.prepareCommandForUpsert(command, action === "Remove");
      return {
        application: app,
        job: [
          {
            type: preppedValues.type || "upsertScalingPolicy",
            ...preppedValues
          }
        ]
      };
    },
    render: () => {
      var _a2, _b2, _c2, _d, _e;
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h4", {
        className: "section-heading"
      }, "Conditions"), /* @__PURE__ */ React.createElement("div", {
        className: "section-body"
      }, /* @__PURE__ */ React.createElement(AlarmConfigurer, {
        alarm: command.alarm,
        multipleAlarms: Boolean(((_a2 = policy == null ? void 0 : policy.alarms) == null ? void 0 : _a2.length) > 1),
        serverGroup,
        stepAdjustments: command.step.stepAdjustments,
        stepsChanged,
        updateAlarm: (alarm) => setCommand({ ...command, alarm })
      })), /* @__PURE__ */ React.createElement("h4", {
        className: "section-heading"
      }, "Actions"), /* @__PURE__ */ React.createElement("div", {
        className: "section-body"
      }, !((_b2 = command.alarm) == null ? void 0 : _b2.metricName) && /* @__PURE__ */ React.createElement("h4", {
        className: "text-center"
      }, "Select a metric"), ((_c2 = command.alarm) == null ? void 0 : _c2.metricName) && !isStep && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", {
        className: "row"
      }, /* @__PURE__ */ React.createElement("div", {
        className: "col-md-10 col-md-offset-1"
      }, /* @__PURE__ */ React.createElement("p", null, "This is a simple scaling policy. To declare different actions based on the magnitude of the alarm,", /* @__PURE__ */ React.createElement("b", null, "switch to a", /* @__PURE__ */ React.createElement("a", {
        className: "clickable sp-margin-xs-l",
        onClick: toggleMode
      }, "step policy"), ".")))), /* @__PURE__ */ React.createElement(SimplePolicyAction, {
        adjustmentType: adjustmentTypeView,
        adjustmentTypeChanged,
        operator: action,
        scalingAdjustment: (_d = command.simple) == null ? void 0 : _d.scalingAdjustment,
        updateScalingAdjustment: scalingAdjustmentChanged
      })), ((_e = command.alarm) == null ? void 0 : _e.metricName) && isStep && /* @__PURE__ */ React.createElement(StepPolicyAction, {
        adjustmentType: adjustmentTypeView,
        adjustmentTypeChanged,
        alarm: command.alarm,
        isMin: comparatorBound === "min",
        operator: action,
        step: command.step,
        stepsChanged
      })), /* @__PURE__ */ React.createElement(ScalingPolicyAdditionalSettings, {
        command,
        isInstanceType: adjustmentTypeView === "instances",
        isNew: Boolean(!policy.policyARN),
        operator: action,
        updateCommand: setCommand
      }));
    }
  });
};

class CreateScalingPolicyButton extends React__default.Component {
  constructor(props) {
    super(props);
    this.handleClick = () => {
      this.setState({ showSelection: true });
    };
    this.typeSelected = (typeSelection) => {
      this.setState({ typeSelection, showSelection: false, showModal: true });
      if (typeSelection === "step") {
        this.createStepPolicy();
      }
      if (typeSelection === "targetTracking") {
        this.createTargetTrackingPolicy();
      }
    };
    this.showModalCallback = () => {
      this.setState({ showSelection: false, showModal: false, typeSelection: null });
    };
    this.state = {
      showSelection: false,
      showModal: false,
      typeSelection: null
    };
  }
  createStepPolicy() {
    const { serverGroup, application } = this.props;
    const upsertProps = {
      app: application,
      policy: AwsReactInjector.awsServerGroupTransformer.constructNewStepScalingPolicyTemplate(serverGroup),
      serverGroup
    };
    const modalProps = { dialogClassName: "wizard-modal modal-lg" };
    ReactModal.show(UpsertScalingPolicyModal, upsertProps, modalProps);
  }
  createTargetTrackingPolicy() {
    const { serverGroup, application } = this.props;
    const upsertProps = {
      app: application,
      policy: AwsReactInjector.awsServerGroupTransformer.constructNewTargetTrackingPolicyTemplate(),
      serverGroup
    };
    const modalProps = { dialogClassName: "wizard-modal modal-lg" };
    ReactModal.show(UpsertTargetTrackingModal, upsertProps, modalProps);
  }
  render() {
    const { min, max } = this.props.serverGroup.capacity;
    return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("a", {
      className: "clickable",
      onClick: this.handleClick
    }, "Create new scaling policy"), this.state.showSelection && /* @__PURE__ */ React__default.createElement(PolicyTypeSelectionModal, {
      warnOnMinMaxCapacity: min === max,
      typeSelectedCallback: this.typeSelected,
      showCallback: this.showModalCallback
    }));
  }
}

class ScalingPolicyWriter {
  static upsertScalingPolicy(application, command) {
    command.type = command.type || "upsertScalingPolicy";
    return TaskExecutor.executeTask({
      application,
      description: "Upsert scaling policy " + (command.name || command.serverGroupName),
      job: [command]
    });
  }
  static deleteScalingPolicy(application, serverGroup, scalingPolicy) {
    return TaskExecutor.executeTask({
      application,
      description: "Delete scaling policy " + scalingPolicy.policyName,
      job: [
        {
          type: "deleteScalingPolicy",
          cloudProvider: "aws",
          credentials: serverGroup.account,
          region: serverGroup.region,
          policyName: scalingPolicy.policyName,
          serverGroupName: serverGroup.name
        }
      ]
    });
  }
}

const comparatorMap = {
  GreaterThanOrEqualToThreshold: ">=",
  GreaterThanThreshold: ">",
  LessThanOrEqualToThreshold: "<=",
  LessThanThreshold: "<"
};
const AlarmSummary = ({ alarm }) => /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("b", null, "Whenever"), ` ${alarm.statistic} of ${alarm.metricName}`), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("b", null, "for at least"), ` ${alarm.evaluationPeriods} consecutive periods of ${alarm.period} seconds`));

const StepPolicyPopoverContent = ({ policy, serverGroup }) => {
  var _a;
  const { adjustmentType, alarms, cooldown, estimatedInstanceWarmup, minAdjustmentMagnitude, stepAdjustments } = policy;
  const showWait = cooldown ? true : ((_a = stepAdjustments == null ? void 0 : stepAdjustments[0]) == null ? void 0 : _a.operator) === "decrease";
  const alarm = alarms[0] || {};
  const isGreater = alarm == null ? void 0 : alarm.comparisonOperator.includes("Greater");
  const getAdjustmentTypeString = (step) => {
    if (adjustmentType === "ExactCapacity") {
      return `set capacity to ${step.scalingAdjustment} instance${step.scalingAdjustment > 1 ? "s" : ""}`;
    }
    return `${step.operator} capacity by ${step.absAdjustment}${adjustmentType === "PercentChangeInCapacity" ? "%" : " instance"}${adjustmentType === "ChangeInCapacity" && step.absAdjustment > 1 ? "s" : ""}`;
  };
  const getBoundaryStr = (step) => {
    const middleBounds = step.metricIntervalLowerBound !== void 0 && step.metricIntervalUpperBound !== void 0 ? `is between ${alarm.threshold + step.metricIntervalLowerBound} and ${alarm.threshold + step.metricIntervalUpperBound} ` : "";
    const sourceBound = isGreater ? step.metricIntervalLowerBound : step.metricIntervalUpperBound;
    const finalBound = `is ${isGreater ? "greater" : "less"} than ${alarm.threshold + sourceBound}`;
    return `if ${alarm.metricName} ${middleBounds}${finalBound}`;
  };
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(LabeledValueList, {
    className: "dl-horizontal dl-narrow"
  }, /* @__PURE__ */ React.createElement(LabeledValue, {
    label: "Whenever",
    value: `${alarm.statistic} of ${alarm.metricName} is ${comparatorMap[alarm.comparisonOperator]} ${alarm.threshold}`
  }), /* @__PURE__ */ React.createElement(LabeledValue, {
    label: "for at least",
    value: `${alarm.evaluationPeriods} consecutive periods of ${alarm.period} seconds`
  }), Boolean(stepAdjustments == null ? void 0 : stepAdjustments.length) && /* @__PURE__ */ React.createElement(LabeledValue, {
    label: "then",
    value: stepAdjustments.map((sa, index) => /* @__PURE__ */ React.createElement("div", {
      key: `step-adjustment-boundary-${index}`
    }, stepAdjustments.length > 1 && /* @__PURE__ */ React.createElement("span", null, getBoundaryStr(sa)), /* @__PURE__ */ React.createElement("span", null, getAdjustmentTypeString(sa))))
  }), !Boolean(stepAdjustments == null ? void 0 : stepAdjustments.length) && /* @__PURE__ */ React.createElement(LabeledValue, {
    label: "then",
    value: getAdjustmentTypeString(policy)
  }), Boolean(minAdjustmentMagnitude) && /* @__PURE__ */ React.createElement(LabeledValue, {
    label: "in",
    value: `increments of at least ${minAdjustmentMagnitude} instance${minAdjustmentMagnitude > 1 ? "s" : ""}`
  }), Boolean(showWait) && /* @__PURE__ */ React.createElement(LabeledValue, {
    label: "wait",
    value: `${cooldown} seconds before allowing another scaling activity.`
  }), Boolean(estimatedInstanceWarmup) && /* @__PURE__ */ React.createElement(LabeledValue, {
    label: "wait",
    value: `${estimatedInstanceWarmup} seconds to warm up after each step.`
  })), /* @__PURE__ */ React.createElement(MetricAlarmChart, {
    alarm,
    serverGroup
  }));
};

var css_248z$3 = ".StepPolicySummary .HoverablePopover {\n  text-decoration: none;\n}\n.StepPolicySummary .actions {\n  margin: 0 0 15px 0;\n  border-bottom: 1px solid var(--color-alto);\n}\n";
styleInject(css_248z$3);

const StepPolicySummary = ({ application, policy, serverGroup }) => {
  var _a, _b;
  const provider = serverGroup.type || serverGroup.cloudProvider || "aws";
  const providerConfig = CloudProviderRegistry.getValue(provider, "serverGroup");
  const policyTitle = provider === "aws" ? policy.policyName : policy.id;
  const UpsertModalComponent = providerConfig.UpsertStepPolicyModal;
  const editPolicy = () => {
    const upsertProps = {
      app: application,
      policy,
      serverGroup
    };
    const modalProps = { dialogClassName: "wizard-modal modal-lg" };
    ReactModal.show(UpsertModalComponent, upsertProps, modalProps);
  };
  const deletePolicy = () => {
    const taskMonitor = {
      application,
      title: `Deleting scaling policy ${policyTitle}`
    };
    const jobToSubmit = {
      type: "deleteScalingPolicy",
      cloudProvider: provider,
      credentials: serverGroup.account,
      region: serverGroup.region,
      scalingPolicyID: policy.id,
      serverGroupName: serverGroup.name
    };
    if (provider === "aws") {
      delete jobToSubmit.scalingPolicyID;
      jobToSubmit.policyName = policy.policyName;
    }
    ConfirmationModalService.confirm({
      header: `Really delete ${policyTitle}?`,
      buttonText: "Delete scaling policy",
      account: serverGroup.account,
      taskMonitorConfig: taskMonitor,
      submitMethod: () => TaskExecutor.executeTask({
        application,
        description: `Delete scaling policy ${policyTitle}`,
        job: [jobToSubmit]
      })
    });
  };
  return /* @__PURE__ */ React.createElement("div", {
    className: "StepPolicySummary"
  }, /* @__PURE__ */ React.createElement("div", null, !Boolean((_a = policy.alarms) == null ? void 0 : _a.length) && /* @__PURE__ */ React.createElement("div", null, "No alarms configured for this policy - it's safe to delete."), Boolean((_b = policy.alarms) == null ? void 0 : _b.length) && policy.alarms.map((a) => /* @__PURE__ */ React.createElement("div", {
    key: `step-summary-${policy.policyName}`
  }, /* @__PURE__ */ React.createElement(HoverablePopover, {
    Component: () => /* @__PURE__ */ React.createElement(StepPolicyPopoverContent, {
      policy,
      serverGroup
    }),
    placement: "left",
    title: policy.policyName
  }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", {
    className: "label label-default"
  }, robotToHuman(policy.policyType).toUpperCase()), /* @__PURE__ */ React.createElement(AlarmSummary, {
    alarm: a
  }))), /* @__PURE__ */ React.createElement("div", {
    className: "actions"
  }, /* @__PURE__ */ React.createElement("button", {
    className: "btn btn-xs btn-link",
    onClick: editPolicy
  }, /* @__PURE__ */ React.createElement("span", {
    className: "glyphicon glyphicon-cog"
  }), /* @__PURE__ */ React.createElement("span", {
    className: "sr-only"
  }, "Edit policy")), /* @__PURE__ */ React.createElement("button", {
    className: "btn btn-xs btn-link",
    onClick: deletePolicy
  }, /* @__PURE__ */ React.createElement("span", {
    className: "glyphicon glyphicon-trash"
  }), /* @__PURE__ */ React.createElement("span", {
    className: "sr-only"
  }, "Delete policy")))))));
};

var css_248z$2 = ".TargetTrackingSummary .HoverablePopover {\n  min-height: 600px;\n  text-decoration: none;\n}\n.TargetTrackingSummary .actions {\n  margin: 0 0 15px 0;\n  border-bottom: 1px solid var(--color-alto);\n}\n";
styleInject(css_248z$2);

const TargetTrackingSummary = ({ application, policy, serverGroup }) => {
  var _a, _b, _c;
  const provider = serverGroup.type || serverGroup.cloudProvider || "aws";
  const providerConfig = CloudProviderRegistry.getValue(provider, "serverGroup");
  const policyTitle = provider === "aws" ? policy.policyName : policy.id;
  const UpsertModalComponent = providerConfig.UpsertTargetTrackingModal;
  const PopoverContent = providerConfig.TargetTrackingChart;
  const editPolicy = () => {
    const upsertProps = {
      app: application,
      policy,
      serverGroup
    };
    const modalProps = { dialogClassName: "wizard-modal modal-lg" };
    ReactModal.show(UpsertModalComponent, upsertProps, modalProps);
  };
  const deletePolicy = () => {
    const taskMonitor = {
      application,
      title: `Deleting scaling policy ${policyTitle}`
    };
    const jobToSubmit = {
      type: "deleteScalingPolicy",
      cloudProvider: provider,
      credentials: serverGroup.account,
      region: serverGroup.region,
      scalingPolicyID: policy.id,
      serverGroupName: serverGroup.name
    };
    if (provider === "aws") {
      delete jobToSubmit.scalingPolicyID;
      jobToSubmit.policyName = policy.policyName;
    }
    ConfirmationModalService.confirm({
      header: `Really delete ${policyTitle}?`,
      buttonText: "Delete scaling policy",
      account: serverGroup.account,
      taskMonitorConfig: taskMonitor,
      submitMethod: () => TaskExecutor.executeTask({
        application,
        description: `Delete scaling policy ${policyTitle}`,
        job: [jobToSubmit]
      })
    });
  };
  const config = policy.targetTrackingConfiguration;
  return /* @__PURE__ */ React.createElement("div", {
    className: "TargetTrackingSummary"
  }, /* @__PURE__ */ React.createElement(HoverablePopover, {
    Component: () => /* @__PURE__ */ React.createElement(PopoverContent, {
      config: policy.targetTrackingConfiguration,
      serverGroup
    }),
    placement: "left",
    title: policyTitle
  }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", {
    className: "label label-default"
  }, robotToHuman(policy.policyType).toUpperCase()), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("b", null, "Target"), /* @__PURE__ */ React.createElement("span", {
    className: "sp-margin-xs-left"
  }, ((_a = config.predefinedMetricSpecification) == null ? void 0 : _a.predefinedMetricType) || ((_b = config.customizedMetricSpecification) == null ? void 0 : _b.metricName)), Boolean((_c = config.customizedMetricSpecification) == null ? void 0 : _c.statistic) && /* @__PURE__ */ React.createElement("span", null, ` @ ${config.targetValue}`)))), /* @__PURE__ */ React.createElement("div", {
    className: "actions"
  }, /* @__PURE__ */ React.createElement("button", {
    className: "btn btn-xs btn-link",
    onClick: editPolicy
  }, /* @__PURE__ */ React.createElement("span", {
    className: "glyphicon glyphicon-cog"
  }), /* @__PURE__ */ React.createElement("span", {
    className: "sr-only"
  }, "Edit policy")), /* @__PURE__ */ React.createElement("button", {
    className: "btn btn-xs btn-link",
    onClick: deletePolicy
  }, /* @__PURE__ */ React.createElement("span", {
    className: "glyphicon glyphicon-trash"
  }), /* @__PURE__ */ React.createElement("span", {
    className: "sr-only"
  }, "Delete policy"))));
};

const ScalingPolicySummary = ({ application, policy, serverGroup }) => {
  const scalingPolicyType = policy.policyType ? policy.policyType : policy.targetTrackingConfiguration ? "TargetTrackingScaling" : "StepScaling";
  if (scalingPolicyType === "TargetTrackingScaling") {
    return /* @__PURE__ */ React.createElement(TargetTrackingSummary, {
      application,
      policy,
      serverGroup
    });
  }
  return /* @__PURE__ */ React.createElement(StepPolicySummary, {
    application,
    policy,
    serverGroup
  });
};

class AdvancedSettingsDetailsSection extends React__default.Component {
  constructor() {
    super(...arguments);
    this.editAdvancedSettings = () => {
      const { app, serverGroup } = this.props;
      confirmNotManaged(serverGroup, app).then((notManaged) => notManaged && ModalInjector.modalService.open({
        templateUrl: "amazon/src/serverGroup/details/advancedSettings/editAsgAdvancedSettings.modal.html",
        controller: "EditAsgAdvancedSettingsCtrl as ctrl",
        resolve: {
          application: () => app,
          serverGroup: () => serverGroup
        }
      }));
    };
  }
  render() {
    const { serverGroup } = this.props;
    const asg = serverGroup.asg;
    return /* @__PURE__ */ React__default.createElement(CollapsibleSection, {
      heading: "Advanced Settings"
    }, /* @__PURE__ */ React__default.createElement("dl", {
      className: "horizontal-when-filters-collapsed"
    }, /* @__PURE__ */ React__default.createElement("dt", null, "Cooldown"), /* @__PURE__ */ React__default.createElement("dd", null, asg.defaultCooldown, " seconds"), asg.enabledMetrics.length > 0 && [
      /* @__PURE__ */ React__default.createElement("dt", {
        key: "t-metrics"
      }, "Enabled Metrics"),
      /* @__PURE__ */ React__default.createElement("dd", {
        key: "d-metrics"
      }, asg.enabledMetrics.map((m) => m.metric).join(", "))
    ], /* @__PURE__ */ React__default.createElement("dt", null, "Health Check Type"), /* @__PURE__ */ React__default.createElement("dd", null, asg.healthCheckType), /* @__PURE__ */ React__default.createElement("dt", null, "Grace Period"), /* @__PURE__ */ React__default.createElement("dd", null, asg.healthCheckGracePeriod, " seconds"), /* @__PURE__ */ React__default.createElement("dt", null, "Termination Policies"), /* @__PURE__ */ React__default.createElement("dd", null, asg.terminationPolicies.join(", ")), asg.capacityRebalance && [
      /* @__PURE__ */ React__default.createElement("dt", null, "Capacity Rebalance ", /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "aws.serverGroup.capacityRebalance"
      })),
      /* @__PURE__ */ React__default.createElement("dd", null, `${asg.capacityRebalance}`)
    ]), AWSProviderSettings.adHocInfraWritesEnabled && /* @__PURE__ */ React__default.createElement("a", {
      className: "clickable",
      onClick: this.editAdvancedSettings
    }, "Edit Advanced Settings"));
  }
}
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/serverGroup/details/advancedSettings/editAsgAdvancedSettings.modal.html", `<div modal-page>
  <task-monitor monitor="taskMonitor"></task-monitor>
  <form role="form" name="form">
    <modal-close dismiss="$dismiss()"></modal-close>
    <div class="modal-header">
      <h4 class="modal-title">Edit Advanced Settings for {{serverGroup.name}}</h4>
    </div>
    <div class="modal-body container-fluid form-horizontal">
      <div class="form-group">
        <div class="col-md-5 sm-label-right"><b>Cooldown</b></div>
        <div class="col-md-2">
          <input type="number" required class="form-control input-sm" ng-model="command.cooldown" />
        </div>
        &nbsp;seconds
      </div>
      <div class="form-group">
        <div class="col-md-5 sm-label-right">
          <b>Enabled Metrics</b>
          <help-field key="aws.serverGroup.enabledMetrics"></help-field>
        </div>
        <div class="col-md-6">
          <ui-select multiple ng-model="command.enabledMetrics" class="form-control input-sm">
            <ui-select-match>{{$item}}</ui-select-match>
            <ui-select-choices
              repeat="enabledMetric in command.backingData.enabledMetrics | filter: $select.search | orderBy: 'toString()'"
            >
              <span ng-bind-html="enabledMetric | highlight: $select.search"></span>
            </ui-select-choices>
          </ui-select>
        </div>
      </div>
      <div class="form-group">
        <div class="col-md-5 sm-label-right"><b>Health Check Type</b></div>
        <div class="col-md-6">
          <ui-select ng-model="command.healthCheckType" class="form-control input-sm">
            <ui-select-match placeholder="Select...">{{$select.selected}}</ui-select-match>
            <ui-select-choices
              repeat="healthCheckType in command.backingData.healthCheckTypes | filter: $select.search"
            >
              <span ng-bind-html="healthCheckType | highlight: $select.search"></span>
            </ui-select-choices>
          </ui-select>
        </div>
      </div>
      <div class="form-group">
        <div class="col-md-5 sm-label-right"><b>Health Check Grace Period</b></div>
        <div class="col-md-2">
          <input type="text" required class="form-control input-sm" ng-model="command.healthCheckGracePeriod" />
        </div>
        &nbsp;seconds
      </div>
      <div class="form-group">
        <div class="col-md-5 sm-label-right"><b>Termination Policies</b></div>
        <div class="col-md-6">
          <ui-select multiple ng-model="command.terminationPolicies" class="form-control input-sm">
            <ui-select-match>{{$item}}</ui-select-match>
            <ui-select-choices
              repeat="terminationPolicy in command.backingData.terminationPolicies | filter: $select.search | orderBy: 'toString()'"
            >
              <span ng-bind-html="terminationPolicy | highlight: $select.search"></span>
            </ui-select-choices>
          </ui-select>
        </div>
      </div>
      <div class="form-group">
        <div class="col-md-5 sm-label-right">
          <b>Capacity Rebalance</b><help-field key="aws.serverGroup.capacityRebalance" />
        </div>
        <div class="col-md-6">
          <input type="checkbox" ng-model="command.capacityRebalance" /> Enable capacity rebalance
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-default" ng-click="ctrl.cancel()">Cancel</button>
      <button type="submit" class="btn btn-primary" ng-disabled="form.$invalid" ng-click="ctrl.submit()">Submit</button>
    </div>
  </form>
</div>
`);
}]);

class AmazonInfoDetailsSection extends React__default.Component {
  constructor(props) {
    super(props);
    this.state = { changeConfig: this.getChangeConfig(props.serverGroup) };
  }
  getChangeConfig(serverGroup) {
    const changeConfig = {
      metadata: get(serverGroup.entityTags, "creationMetadata")
    };
    if (has(serverGroup, "buildInfo.jenkins")) {
      changeConfig.buildInfo = {
        ancestor: void 0,
        jenkins: serverGroup.buildInfo.jenkins,
        target: void 0
      };
    }
    return changeConfig;
  }
  componentWillReceiveProps(nextProps) {
    this.setState({ changeConfig: this.getChangeConfig(nextProps.serverGroup) });
  }
  render() {
    const { serverGroup } = this.props;
    const { changeConfig } = this.state;
    const showEntityTags = SETTINGS.feature && SETTINGS.feature.entityTags;
    const entityTags = serverGroup.entityTags || {};
    return /* @__PURE__ */ React__default.createElement(CollapsibleSection, {
      heading: "Server Group Information",
      defaultExpanded: true
    }, /* @__PURE__ */ React__default.createElement("dl", {
      className: "dl-horizontal dl-narrow"
    }, /* @__PURE__ */ React__default.createElement("dt", null, "Created"), /* @__PURE__ */ React__default.createElement("dd", null, timestamp(serverGroup.createdTime)), showEntityTags && /* @__PURE__ */ React__default.createElement(EntitySource, {
      metadata: entityTags.creationMetadata
    }), showEntityTags && /* @__PURE__ */ React__default.createElement(ViewChangesLink, {
      changeConfig,
      linkText: "view changes",
      nameItem: serverGroup,
      viewType: "description"
    }), /* @__PURE__ */ React__default.createElement("dt", null, "In"), /* @__PURE__ */ React__default.createElement("dd", null, /* @__PURE__ */ React__default.createElement(AccountTag, {
      account: serverGroup.account
    }), serverGroup.region), /* @__PURE__ */ React__default.createElement("dt", null, "VPC"), /* @__PURE__ */ React__default.createElement("dd", null, /* @__PURE__ */ React__default.createElement(VpcTag, {
      vpcId: serverGroup.vpcId
    })), serverGroup.vpcId && serverGroup.subnetType && /* @__PURE__ */ React__default.createElement("dt", null, "Subnet"), serverGroup.vpcId && serverGroup.subnetType && /* @__PURE__ */ React__default.createElement("dd", null, serverGroup.subnetType), serverGroup.asg && /* @__PURE__ */ React__default.createElement("dt", null, "Zones"), serverGroup.asg && /* @__PURE__ */ React__default.createElement("dd", null, /* @__PURE__ */ React__default.createElement("ul", null, serverGroup.asg.availabilityZones.map((zone) => /* @__PURE__ */ React__default.createElement("li", {
      key: zone
    }, zone))))));
  }
}

var __defProp$1 = Object.defineProperty;
var __getOwnPropDesc$1 = Object.getOwnPropertyDescriptor;
var __decorateClass$1 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$1(target, key, result);
  return result;
};
let AmazonCapacityDetailsSection = class extends React__default.Component {
  render() {
    const { serverGroup, app: application } = this.props;
    const capacity = {
      min: serverGroup.asg.minSize,
      max: serverGroup.asg.maxSize,
      desired: serverGroup.asg.desiredCapacity
    };
    return /* @__PURE__ */ React__default.createElement(CollapsibleSection, {
      heading: "Capacity",
      defaultExpanded: true
    }, /* @__PURE__ */ React__default.createElement(CapacityDetailsSection, {
      current: serverGroup.instances.length,
      capacity
    }), /* @__PURE__ */ React__default.createElement("div", null, AWSProviderSettings.adHocInfraWritesEnabled && /* @__PURE__ */ React__default.createElement("a", {
      className: "clickable",
      onClick: () => AmazonResizeServerGroupModal.show({ application, serverGroup })
    }, "Resize Server Group")), /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(ViewScalingActivitiesLink, {
      serverGroup
    })));
  }
};
AmazonCapacityDetailsSection = __decorateClass$1([
  Overridable("amazon.serverGroup.CapacityDetailsSection")
], AmazonCapacityDetailsSection);

class HealthDetailsSection extends React__default.Component {
  render() {
    const { serverGroup } = this.props;
    if (serverGroup.instanceCounts.total > 0) {
      return /* @__PURE__ */ React__default.createElement(CollapsibleSection, {
        heading: "Health",
        defaultExpanded: true
      }, /* @__PURE__ */ React__default.createElement("dl", {
        className: "dl-horizontal dl-narrow"
      }, /* @__PURE__ */ React__default.createElement("dt", null, "Instances"), /* @__PURE__ */ React__default.createElement("dd", null, /* @__PURE__ */ React__default.createElement(HealthCounts, {
        container: serverGroup.instanceCounts,
        className: "pull-left"
      }))));
    }
    return null;
  }
}

const InstancesDistributionDetailsSection = ({ serverGroup }) => {
  if (!serverGroup.mixedInstancesPolicy) {
    return null;
  }
  const instancesDistribution = serverGroup.mixedInstancesPolicy.instancesDistribution;
  return /* @__PURE__ */ React__default.createElement(CollapsibleSection, {
    heading: "Instances Distribution"
  }, /* @__PURE__ */ React__default.createElement(LabeledValueList, {
    className: "horizontal-when-filters-collapsed"
  }, /* @__PURE__ */ React__default.createElement(LabeledValue, {
    label: "On-Demand Allocation Strategy",
    helpFieldId: "aws.serverGroup.odAllocationStrategy",
    value: instancesDistribution.onDemandAllocationStrategy
  }), /* @__PURE__ */ React__default.createElement(LabeledValue, {
    label: "On-Demand Base Capacity",
    helpFieldId: "aws.serverGroup.odBase",
    value: instancesDistribution.onDemandBaseCapacity
  }), /* @__PURE__ */ React__default.createElement(LabeledValue, {
    label: "On-Demand Percentage Above Base Capacity",
    helpFieldId: "aws.serverGroup.odPercentAboveBase",
    value: instancesDistribution.onDemandPercentageAboveBaseCapacity
  }), /* @__PURE__ */ React__default.createElement(LabeledValue, {
    label: "Spot Allocation Strategy",
    helpFieldId: "aws.serverGroup.spotAllocationStrategy",
    value: instancesDistribution.spotAllocationStrategy
  }), instancesDistribution.spotInstancePools && /* @__PURE__ */ React__default.createElement(LabeledValue, {
    label: "Spot Instance Pools",
    helpFieldId: "aws.serverGroup.spotInstancePoolCount",
    value: instancesDistribution.spotInstancePools
  }), /* @__PURE__ */ React__default.createElement(LabeledValue, {
    label: "Max Spot Price",
    helpFieldId: "aws.serverGroup.spotMaxPrice",
    value: instancesDistribution.spotMaxPrice || "on-demand price, default"
  })));
};

const getBaseImageName = (description) => {
  let name;
  const tags = (description || "").split(", ");
  tags.forEach((tag) => {
    const keyVal = tag.split("=");
    if (keyVal.length === 2 && keyVal[0] === "ancestor_name") {
      name = keyVal[1];
    }
  });
  return name;
};

class LaunchConfigDetailsSection extends React__default.Component {
  constructor(props) {
    super(props);
    this.state = { image: this.getImage(props.serverGroup) };
  }
  getImage(serverGroup) {
    const image = serverGroup.image ? serverGroup.image : void 0;
    if (serverGroup.image && serverGroup.image.description) {
      image.baseImage = getBaseImageName(serverGroup.image.description);
    }
    return image;
  }
  componentWillReceiveProps(nextProps) {
    this.setState({ image: this.getImage(nextProps.serverGroup) });
  }
  render() {
    const { name, launchConfig } = this.props.serverGroup;
    const { image } = this.state;
    if (launchConfig) {
      return /* @__PURE__ */ React__default.createElement(CollapsibleSection, {
        heading: "Launch Configuration"
      }, /* @__PURE__ */ React__default.createElement("dl", {
        className: "horizontal-when-filters-collapsed"
      }, /* @__PURE__ */ React__default.createElement("dt", null, "Name"), /* @__PURE__ */ React__default.createElement("dd", null, launchConfig.launchConfigurationName), /* @__PURE__ */ React__default.createElement("dt", null, "Image ID"), /* @__PURE__ */ React__default.createElement("dd", null, launchConfig.imageId), image && image.imageLocation && /* @__PURE__ */ React__default.createElement("dt", null, "Image Name"), image && image.imageLocation && /* @__PURE__ */ React__default.createElement("dd", null, image.imageLocation), image && image.baseImage && /* @__PURE__ */ React__default.createElement("dt", null, "Base Image Name"), image && image.baseImage && /* @__PURE__ */ React__default.createElement("dd", null, image.baseImage), /* @__PURE__ */ React__default.createElement("dt", null, "Instance Type"), /* @__PURE__ */ React__default.createElement("dd", null, launchConfig.instanceType), /* @__PURE__ */ React__default.createElement("dt", null, "IAM Profile"), /* @__PURE__ */ React__default.createElement("dd", null, launchConfig.iamInstanceProfile), /* @__PURE__ */ React__default.createElement("dt", null, "Instance Monitoring"), /* @__PURE__ */ React__default.createElement("dd", null, launchConfig.instanceMonitoring.enabled ? "enabled" : "disabled"), launchConfig.spotPrice && /* @__PURE__ */ React__default.createElement("dt", null, "Spot Price"), launchConfig.spotPrice && /* @__PURE__ */ React__default.createElement("dd", null, launchConfig.spotPrice), launchConfig.keyName && /* @__PURE__ */ React__default.createElement("dt", null, "Key Name"), launchConfig.keyName && /* @__PURE__ */ React__default.createElement("dd", null, launchConfig.keyName), launchConfig.kernelId && /* @__PURE__ */ React__default.createElement("dt", null, "Kernel ID"), launchConfig.kernelId && /* @__PURE__ */ React__default.createElement("dd", null, launchConfig.kernelId), launchConfig.ramdiskId && /* @__PURE__ */ React__default.createElement("dt", null, "Ramdisk ID"), launchConfig.ramdiskId && /* @__PURE__ */ React__default.createElement("dd", null, launchConfig.ramdiskId), /* @__PURE__ */ React__default.createElement("dt", null, "User Data"), launchConfig.userData && /* @__PURE__ */ React__default.createElement("dd", null, /* @__PURE__ */ React__default.createElement(ShowUserData, {
        serverGroupName: name,
        userData: launchConfig.userData
      })), !launchConfig.userData && /* @__PURE__ */ React__default.createElement("dd", null, "[none]")));
    }
    return null;
  }
}

var css_248z$1 = ".multiple-instance-types-subsection {\n  padding: 0;\n}\n.multiple-instance-types-subsection a.subsection-heading {\n  color: var(--color-black);\n}\n.multiple-instance-types-subsection h4.collapsible-subheading {\n  padding: 10px 0px;\n  background-color: var(--color-alabaster);\n  margin: 0;\n  font-size: 103%;\n  font-weight: 600;\n  text-transform: none;\n}\n.multiple-instance-types-subsection h4.collapsible-subheading .glyphicon {\n  font-size: 10px;\n  opacity: 0.5;\n  margin-right: 4px;\n}\n.multiple-instance-types-subsection .content-body {\n  -webkit-animation: 0.15 ease-in 0 fadeIn;\n          animation: 0.15 ease-in 0 fadeIn;\n  -webkit-animation-iteration-count: 1;\n          animation-iteration-count: 1;\n  padding-left: 17px;\n  margin: 10px 0 20px 0;\n}\n.multiple-instance-types-subsection .content-body:before,\n.multiple-instance-types-subsection .content-body:after {\n  display: table;\n  content: \" \";\n}\n.multiple-instance-types-subsection .content-body:after {\n  clear: both;\n}\n.multiple-instance-types-subsection .content-body ul {\n  list-style-type: none;\n  padding-left: 0;\n}\n.multiple-instance-types-subsection:last-child {\n  border-bottom-width: 0;\n}\n.multiple-instance-types-subsection:first-child {\n  padding-top: 0;\n}\n";
styleInject(css_248z$1);

function MultipleInstanceTypesSubSection(props) {
  if (!props.instanceTypeOverrides) {
    return null;
  }
  return /* @__PURE__ */ React__default.createElement(CollapsibleSection, {
    heading: "Instance Types",
    defaultExpanded: true,
    outerDivClassName: "multiple-instance-types-subsection",
    toggleClassName: "clickable subsection-heading",
    headingClassName: "collapsible-subheading"
  }, /* @__PURE__ */ React__default.createElement("table", {
    className: "table table-condensed packed",
    id: "MultipleInstanceTypes"
  }, /* @__PURE__ */ React__default.createElement("thead", null, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("th", {
    id: "instanceType"
  }, "Type ", /* @__PURE__ */ React__default.createElement(HelpField, {
    id: "aws.serverGroup.multipleInstanceTypes"
  })), /* @__PURE__ */ React__default.createElement("th", {
    id: "weight"
  }, "Weighted Capacity ", /* @__PURE__ */ React__default.createElement(HelpField, {
    id: "aws.serverGroup.instanceTypeWeight"
  })))), /* @__PURE__ */ React__default.createElement("tbody", null, props.instanceTypeOverrides.map((override) => [
    /* @__PURE__ */ React__default.createElement("tr", {
      key: override.instanceType
    }, /* @__PURE__ */ React__default.createElement("td", {
      headers: "instanceType"
    }, override.instanceType), /* @__PURE__ */ React__default.createElement("td", {
      headers: "weight"
    }, override.weightedCapacity))
  ]))));
}

const LaunchTemplateDetailsSection = ({ serverGroup }) => {
  var _a, _b, _c;
  const { image } = serverGroup;
  const baseImage = getBaseImageName(image == null ? void 0 : image.description);
  if (!serverGroup.launchTemplate && !serverGroup.mixedInstancesPolicy) {
    return null;
  }
  const isMip = serverGroup.mixedInstancesPolicy ? true : false;
  const launchTemplate = isMip ? serverGroup.mixedInstancesPolicy.launchTemplates[0] : serverGroup.launchTemplate;
  const { launchTemplateData } = launchTemplate;
  const maxSpotPrice = isMip ? serverGroup.mixedInstancesPolicy.instancesDistribution.spotMaxPrice : (_b = (_a = launchTemplateData == null ? void 0 : launchTemplateData.instanceMarketOptions) == null ? void 0 : _a.spotOptions) == null ? void 0 : _b.maxPrice;
  const creditSpecification = (_c = launchTemplateData == null ? void 0 : launchTemplateData.creditSpecification) == null ? void 0 : _c.cpuCredits;
  const launchTemplateOverrides = isMip ? serverGroup.mixedInstancesPolicy.launchTemplateOverridesForInstanceType : null;
  return /* @__PURE__ */ React__default.createElement(CollapsibleSection, {
    heading: "Launch Template"
  }, /* @__PURE__ */ React__default.createElement(LabeledValueList, {
    className: "horizontal-when-filters-collapsed"
  }, /* @__PURE__ */ React__default.createElement(LabeledValue, {
    label: "Name",
    value: launchTemplate.launchTemplateName
  }), /* @__PURE__ */ React__default.createElement(LabeledValue, {
    label: "Image ID",
    value: launchTemplateData.imageId
  }), (image == null ? void 0 : image.imageLocation) && /* @__PURE__ */ React__default.createElement(LabeledValue, {
    label: "Image Name",
    value: image == null ? void 0 : image.imageLocation
  }), baseImage && /* @__PURE__ */ React__default.createElement(LabeledValue, {
    label: "Base Image Name",
    value: baseImage
  }), launchTemplateOverrides && launchTemplateOverrides.length > 0 ? /* @__PURE__ */ React__default.createElement(MultipleInstanceTypesSubSection, {
    instanceTypeOverrides: launchTemplateOverrides
  }) : /* @__PURE__ */ React__default.createElement(LabeledValue, {
    label: "Instance Type",
    value: launchTemplateData.instanceType
  }), creditSpecification && /* @__PURE__ */ React__default.createElement(LabeledValue, {
    label: "CPU Credit Specification",
    value: creditSpecification
  }), /* @__PURE__ */ React__default.createElement(LabeledValue, {
    label: "IAM Profile",
    value: launchTemplateData.iamInstanceProfile.name
  }), launchTemplateData.monitoring && /* @__PURE__ */ React__default.createElement(LabeledValue, {
    label: "Instance Monitoring",
    value: launchTemplateData.monitoring.enabled ? "enabled" : "disabled"
  }), maxSpotPrice && /* @__PURE__ */ React__default.createElement(LabeledValue, {
    label: "Max Spot Price",
    value: maxSpotPrice
  }), launchTemplateData.keyName && /* @__PURE__ */ React__default.createElement(LabeledValue, {
    label: "Key Name",
    value: launchTemplateData.keyName
  }), launchTemplateData.kernelId && /* @__PURE__ */ React__default.createElement(LabeledValue, {
    label: "Kernel ID",
    value: launchTemplateData.kernelId
  }), launchTemplateData.ramDiskId && /* @__PURE__ */ React__default.createElement(LabeledValue, {
    label: "Ramdisk ID",
    value: launchTemplateData.ramDiskId
  }), launchTemplateData.userData && /* @__PURE__ */ React__default.createElement(LabeledValue, {
    label: "User Data",
    value: /* @__PURE__ */ React__default.createElement(ShowUserData, {
      serverGroupName: serverGroup.name,
      userData: launchTemplateData.userData
    })
  })));
};

class LogsDetailsSection extends React__default.Component {
  render() {
    return /* @__PURE__ */ React__default.createElement(CollapsibleSection, {
      heading: "Logs"
    }, /* @__PURE__ */ React__default.createElement("ul", null, /* @__PURE__ */ React__default.createElement("li", null, /* @__PURE__ */ React__default.createElement(ViewScalingActivitiesLink, {
      serverGroup: this.props.serverGroup
    }))));
  }
}

class PackageDetailsSection extends React__default.Component {
  constructor(props) {
    super(props);
    this.state = this.getState(props);
  }
  getState(props) {
    const { serverGroup } = props;
    const buildInfo = serverGroup.buildInfo || {};
    let commitHash = null;
    if (buildInfo.commit) {
      commitHash = serverGroup.buildInfo.commit.substring(0, 8);
    }
    let jenkinsLink = null;
    if (buildInfo.buildInfoUrl) {
      jenkinsLink = serverGroup.buildInfo.buildInfoUrl;
    } else if (buildInfo.jenkins) {
      const jenkins = serverGroup.buildInfo.jenkins;
      jenkinsLink = `${jenkins.host}job/${jenkins.name}/${jenkins.number}`;
    }
    return { commitHash, jenkinsLink };
  }
  componentWillReceiveProps(nextProps) {
    this.setState(this.getState(nextProps));
  }
  render() {
    const { serverGroup } = this.props;
    const { commitHash, jenkinsLink } = this.state;
    if (serverGroup.buildInfo && serverGroup.buildInfo.jenkins) {
      return /* @__PURE__ */ React__default.createElement(CollapsibleSection, {
        heading: "Package"
      }, /* @__PURE__ */ React__default.createElement("dl", {
        className: "horizontal-when-filters-collapsed"
      }, /* @__PURE__ */ React__default.createElement("dt", null, "Job"), /* @__PURE__ */ React__default.createElement("dd", null, serverGroup.buildInfo.jenkins.name), /* @__PURE__ */ React__default.createElement("dt", null, "Package"), /* @__PURE__ */ React__default.createElement("dd", null, serverGroup.buildInfo.package_name), /* @__PURE__ */ React__default.createElement("dt", null, "Build"), /* @__PURE__ */ React__default.createElement("dd", null, serverGroup.buildInfo.jenkins.number), /* @__PURE__ */ React__default.createElement("dt", null, "Commit"), /* @__PURE__ */ React__default.createElement("dd", null, commitHash), /* @__PURE__ */ React__default.createElement("dt", null, "Version"), /* @__PURE__ */ React__default.createElement("dd", null, serverGroup.buildInfo.version), /* @__PURE__ */ React__default.createElement("dt", null, "Build Link"), /* @__PURE__ */ React__default.createElement("dd", null, /* @__PURE__ */ React__default.createElement("a", {
        target: "_blank",
        href: jenkinsLink
      }, jenkinsLink))));
    }
    return null;
  }
}

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ScalingPoliciesDetailsSection = class extends React__default.Component {
  constructor(props) {
    super(props);
  }
  static arePoliciesDisabled(serverGroup) {
    const autoScalingProcesses = AutoScalingProcessService.normalizeScalingProcesses(serverGroup);
    return serverGroup.scalingPolicies.length > 0 && autoScalingProcesses.filter((p) => !p.enabled).some((p) => ["Launch", "Terminate", "AlarmNotification"].includes(p.name));
  }
  render() {
    const { app, serverGroup } = this.props;
    const scalingPoliciesDisabled = ScalingPoliciesDetailsSection.arePoliciesDisabled(serverGroup);
    return /* @__PURE__ */ React__default.createElement(CollapsibleSection, {
      cacheKey: "Scaling Policies",
      heading: ({ chevron }) => /* @__PURE__ */ React__default.createElement("h4", {
        className: "collapsible-heading"
      }, chevron, /* @__PURE__ */ React__default.createElement("span", null, scalingPoliciesDisabled && /* @__PURE__ */ React__default.createElement(Tooltip, {
        value: "Some scaling processes are disabled that may prevent scaling policies from working"
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "fa fa-exclamation-circle warning-text"
      })), "Scaling Policies"))
    }, scalingPoliciesDisabled && /* @__PURE__ */ React__default.createElement("div", {
      className: "band band-warning"
    }, "Some scaling processes are disabled that may prevent scaling policies from working."), serverGroup.scalingPolicies.map((policy) => /* @__PURE__ */ React__default.createElement(ScalingPolicySummary, {
      key: policy.policyARN,
      policy,
      serverGroup,
      application: app
    })), AWSProviderSettings.adHocInfraWritesEnabled ? /* @__PURE__ */ React__default.createElement(CreateScalingPolicyButton, {
      serverGroup,
      application: app
    }) : /* @__PURE__ */ React__default.createElement("p", null, "Can not create scaling policy, because ad-hoc operations are disabled for AWS providers."));
  }
};
ScalingPoliciesDetailsSection = __decorateClass([
  Overridable("aws.serverGroup.ScalingPoliciesDetailsSection")
], ScalingPoliciesDetailsSection);

class ScalingProcessesDetailsSection extends React__default.Component {
  constructor(props) {
    super(props);
    this.toggleScalingProcesses = () => {
      const { app, serverGroup } = this.props;
      confirmNotManaged(serverGroup, app).then((isNotManaged) => isNotManaged && ModalInjector.modalService.open({
        templateUrl: "amazon/src/serverGroup/details/scalingProcesses/modifyScalingProcesses.html",
        controller: "ModifyScalingProcessesCtrl as ctrl",
        resolve: {
          serverGroup: () => serverGroup,
          application: () => app,
          processes: () => this.state.autoScalingProcesses
        }
      }));
    };
    this.state = this.getState(props);
  }
  getState(props) {
    const { serverGroup } = props;
    const autoScalingProcesses = AutoScalingProcessService.normalizeScalingProcesses(serverGroup);
    const scalingPoliciesDisabled = serverGroup.scalingPolicies.length > 0 && autoScalingProcesses.filter((p) => !p.enabled).some((p) => ["Launch", "Terminate", "AlarmNotification"].includes(p.name));
    const scheduledActionsDisabled = serverGroup.scheduledActions.length > 0 && autoScalingProcesses.filter((p) => !p.enabled).some((p) => ["Launch", "Terminate", "ScheduledAction"].includes(p.name));
    return { autoScalingProcesses, scalingPoliciesDisabled, scheduledActionsDisabled };
  }
  componentWillReceiveProps(nextProps) {
    this.setState(this.getState(nextProps));
  }
  render() {
    const { autoScalingProcesses, scalingPoliciesDisabled, scheduledActionsDisabled } = this.state;
    return /* @__PURE__ */ React__default.createElement(CollapsibleSection, {
      cacheKey: "Scaling Processes",
      heading: ({ chevron }) => /* @__PURE__ */ React__default.createElement("h4", {
        className: "collapsible-heading"
      }, chevron, /* @__PURE__ */ React__default.createElement("span", null, scalingPoliciesDisabled && /* @__PURE__ */ React__default.createElement(Tooltip, {
        value: "Some scaling processes are disabled that may prevent scaling policies from working"
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "fa fa-exclamation-circle warning-text"
      })), scheduledActionsDisabled && /* @__PURE__ */ React__default.createElement(Tooltip, {
        value: "Some scaling processes are disabled that may prevent scheduled actions from working"
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "fa fa-exclamation-circle warning-text"
      })), "Scaling Processes"))
    }, /* @__PURE__ */ React__default.createElement("ul", {
      className: "scaling-processes"
    }, autoScalingProcesses.map((process) => /* @__PURE__ */ React__default.createElement("li", {
      key: process.name
    }, /* @__PURE__ */ React__default.createElement("span", {
      style: { visibility: process.enabled ? "visible" : "hidden" },
      className: "fa fa-check small"
    }), /* @__PURE__ */ React__default.createElement("span", {
      className: !process.enabled ? "text-disabled" : ""
    }, process.name, " "), /* @__PURE__ */ React__default.createElement(HelpField, {
      content: process.description,
      placement: "bottom"
    }), process.suspensionDate && /* @__PURE__ */ React__default.createElement("div", {
      className: "text-disabled small",
      style: { marginLeft: "35px" }
    }, "Suspended ", timestamp(process.suspensionDate))))), AWSProviderSettings.adHocInfraWritesEnabled && /* @__PURE__ */ React__default.createElement("a", {
      className: "clickable",
      onClick: this.toggleScalingProcesses
    }, "Edit Scaling Processes"));
  }
}
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/serverGroup/details/scalingProcesses/modifyScalingProcesses.html", `<div modal-page class="confirmation-modal">
  <task-monitor monitor="taskMonitor"></task-monitor>
  <form role="form">
    <modal-close dismiss="$dismiss()"></modal-close>
    <div class="modal-header">
      <h4 class="modal-title">Modify Scaling Processes for {{serverGroup.name}}</h4>
    </div>
    <div class="modal-body container-fluid form-horizontal">
      <div class="form-group">
        <div class="col-sm-offset-2 col-sm-10">
          <div class="checkbox" ng-repeat="process in command">
            <label>
              <input type="checkbox" ng-model="process.enabled" />
              {{process.name}}
            </label>
            <help-field content="{{process.description}}" placement="right"></help-field>
          </div>
        </div>
      </div>
    </div>
    <task-reason command="command"></task-reason>
    <aws-footer
      action="ctrl.submit()"
      cancel="ctrl.cancel()"
      is-valid="ctrl.isValid()"
      account="serverGroup.account"
      verification="verification"
    ></aws-footer>
  </form>
</div>
`);
}]);

class ScheduledAction extends React__default.Component {
  render() {
    const { action } = this.props;
    return /* @__PURE__ */ React__default.createElement("dl", {
      className: "horizontal-when-filters-collapsed",
      style: { marginBottom: "20px" }
    }, /* @__PURE__ */ React__default.createElement("dt", null, "Schedule"), /* @__PURE__ */ React__default.createElement("dd", null, action.recurrence), action.minSize !== void 0 && /* @__PURE__ */ React__default.createElement("dt", null, "Min Size"), action.minSize !== void 0 && /* @__PURE__ */ React__default.createElement("dd", null, action.minSize), action.maxSize !== void 0 && /* @__PURE__ */ React__default.createElement("dt", null, "Max Size"), action.maxSize !== void 0 && /* @__PURE__ */ React__default.createElement("dd", null, action.maxSize), action.desiredCapacity !== void 0 && /* @__PURE__ */ React__default.createElement("dt", null, "Desired Size"), action.desiredCapacity !== void 0 && /* @__PURE__ */ React__default.createElement("dd", null, action.desiredCapacity));
  }
}

class ScheduledActionsDetailsSection extends React__default.Component {
  constructor(props) {
    super(props);
    this.editScheduledActions = () => {
      ModalInjector.modalService.open({
        templateUrl: "amazon/src/serverGroup/details/scheduledAction/editScheduledActions.modal.html",
        controller: "EditScheduledActionsCtrl as ctrl",
        resolve: {
          application: () => this.props.app,
          serverGroup: () => this.props.serverGroup
        }
      });
    };
    this.state = this.getState(props);
  }
  getState(props) {
    const { serverGroup } = props;
    const autoScalingProcesses = AutoScalingProcessService.normalizeScalingProcesses(serverGroup);
    const scheduledActionsDisabled = serverGroup.scheduledActions.length > 0 && autoScalingProcesses.filter((p) => !p.enabled).some((p) => ["Launch", "Terminate", "ScheduledAction"].includes(p.name));
    return { scheduledActionsDisabled };
  }
  componentWillReceiveProps(nextProps) {
    this.setState(this.getState(nextProps));
  }
  render() {
    const { serverGroup } = this.props;
    const { scheduledActionsDisabled } = this.state;
    return /* @__PURE__ */ React__default.createElement(CollapsibleSection, {
      cacheKey: "Scheduled Actions",
      heading: ({ chevron }) => /* @__PURE__ */ React__default.createElement("h4", {
        className: "collapsible-heading"
      }, chevron, /* @__PURE__ */ React__default.createElement("span", null, scheduledActionsDisabled && /* @__PURE__ */ React__default.createElement(Tooltip, {
        value: "Some scaling processes are disabled that may prevent scheduled actions from working"
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "fa fa-exclamation-circle warning-text"
      })), "Scheduled Actions"))
    }, serverGroup.scheduledActions.map((action, index) => /* @__PURE__ */ React__default.createElement(ScheduledAction, {
      key: index,
      action
    })), serverGroup.scheduledActions.length > 0 && /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("strong", null, "Note:"), " Schedules are evaluated in UTC."), serverGroup.scheduledActions.length === 0 && /* @__PURE__ */ React__default.createElement("p", null, "No Scheduled Actions are configured for this server group."), AWSProviderSettings.adHocInfraWritesEnabled && /* @__PURE__ */ React__default.createElement("a", {
      className: "clickable",
      onClick: this.editScheduledActions
    }, "Edit Scheduled Actions"));
  }
}
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/serverGroup/details/scheduledAction/editScheduledActions.modal.html", `<div modal-page>
  <task-monitor monitor="taskMonitor"></task-monitor>
  <form role="form" name="form">
    <modal-close dismiss="$dismiss()"></modal-close>
    <div class="modal-header">
      <h4 class="modal-title">Edit Scheduled Actions for {{serverGroup.name}}</h4>
    </div>
    <div class="modal-body container-fluid form-horizontal">
      <div class="form-group">
        <div class="col-md-12">
          <p>You must specify at least one of: Min Size, Max Size, Desired Capacity</p>
          <p><strong>Note:</strong> CRON expressions are evaluated in UTC.</p>
          <table class="table table-condensed packed">
            <thead>
              <tr>
                <th>Recurrence (CRON)</th>
                <th>Min Size</th>
                <th>Max Size</th>
                <th>Desired Capacity</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr ng-repeat="action in command.scheduledActions">
                <td>
                  <input
                    class="form-control input-sm no-spel"
                    type="text"
                    ng-model="action.recurrence"
                    name="recurrence-{{$index}}"
                    required
                  />
                  <!-- TODO: Add cron-validator when endpoint is fixed -->
                  <div class="form-group row slide-in" ng-if="form['recurrence-' + $index].$error.cronExpression">
                    <div class="error-message">{{cronErrors['action.recurrence.cronExpression']}}</div>
                  </div>
                </td>
                <td>
                  <input
                    class="form-control input-sm"
                    type="number"
                    min="0"
                    max="{{action.maxSize || Infinity}}"
                    ng-model="action.minSize"
                  />
                </td>
                <td>
                  <input
                    class="form-control input-sm"
                    type="number"
                    min="{{action.minSize || 0}}"
                    ng-model="action.maxSize"
                  />
                </td>
                <td>
                  <input
                    class="form-control input-sm"
                    type="number"
                    ng-model="action.desiredCapacity"
                    min="{{command.minSize || 0}}"
                    max="{{command.maxSize || Infinity}}"
                  />
                </td>
                <td>
                  <a href class="sm-label" ng-click="ctrl.removeScheduledAction($index)"
                    ><span class="glyphicon glyphicon-trash"></span
                  ></a>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="5">
                  <button class="add-new col-md-12" ng-click="ctrl.addScheduledAction()">
                    <span class="glyphicon glyphicon-plus-sign"></span> Add new Scheduled Action
                  </button>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-default" ng-click="ctrl.cancel()">Cancel</button>
      <button type="submit" class="btn btn-primary" ng-disabled="form.$invalid" ng-click="ctrl.submit()">Submit</button>
    </div>
  </form>
</div>
`);
}]);

class SecurityGroupsDetailsSection extends React__default.Component {
  constructor(props) {
    super(props);
    this.updateSecurityGroups = () => {
      const { app, serverGroup } = this.props;
      confirmNotManaged(serverGroup, app).then((notManaged) => notManaged && ModalInjector.modalService.open({
        templateUrl: "amazon/src/serverGroup/details/securityGroup/editSecurityGroups.modal.html",
        controller: "EditSecurityGroupsCtrl as $ctrl",
        resolve: {
          application: () => app,
          serverGroup: () => serverGroup,
          securityGroups: () => this.state.securityGroups
        }
      }));
    };
    this.state = { securityGroups: this.getSecurityGroups(props) };
  }
  tryFindingSecurityGroupInIndex(index, account, region, securityGroupId) {
    try {
      return AwsSecurityGroupReader.resolveIndexedSecurityGroup(index, { account, region }, securityGroupId);
    } catch (e) {
      return void 0;
    }
  }
  getSecurityGroups(props) {
    let securityGroups;
    const { app, serverGroup } = props;
    if (serverGroup.securityGroups && serverGroup.securityGroups.length) {
      securityGroups = chain(serverGroup.securityGroups).map((id) => {
        return find(app.securityGroups.data, { accountName: serverGroup.account, region: serverGroup.region, id }) || find(app.securityGroups.data, { accountName: serverGroup.account, region: serverGroup.region, name: id }) || this.tryFindingSecurityGroupInIndex(app["securityGroupsIndex"], serverGroup.account, serverGroup.region, id) || { id, name: id };
      }).compact().value();
    }
    return securityGroups;
  }
  componentWillReceiveProps(nextProps) {
    this.setState({ securityGroups: this.getSecurityGroups(nextProps) });
  }
  render() {
    const { serverGroup } = this.props;
    const { securityGroups } = this.state;
    return /* @__PURE__ */ React__default.createElement(CollapsibleSection, {
      heading: FirewallLabels.get("Firewalls")
    }, /* @__PURE__ */ React__default.createElement("ul", null, sortBy(securityGroups, "name").map((securityGroup) => /* @__PURE__ */ React__default.createElement("li", {
      key: securityGroup.name
    }, /* @__PURE__ */ React__default.createElement(UISref, {
      to: "^.firewallDetails",
      params: {
        name: securityGroup.name,
        accountId: securityGroup.accountName,
        region: serverGroup.region,
        vpcId: serverGroup.vpcId,
        provider: serverGroup.type
      }
    }, /* @__PURE__ */ React__default.createElement("a", null, securityGroup.name, " (", securityGroup.id, ")"))))), AWSProviderSettings.adHocInfraWritesEnabled && serverGroup.vpcId && /* @__PURE__ */ React__default.createElement("a", {
      className: "clickable",
      onClick: this.updateSecurityGroups
    }, "Edit ", FirewallLabels.get("Firewalls")));
  }
}
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/serverGroup/details/securityGroup/editSecurityGroups.modal.html", `<div modal-page>
  <task-monitor monitor="$ctrl.taskMonitor"></task-monitor>
  <form role="form" name="form">
    <modal-close dismiss="$dismiss()"></modal-close>
    <div class="modal-header">
      <h4 class="modal-title">
        Edit <firewall-label label="Firewalls"></firewall-label> for {{$ctrl.serverGroup.name}}
      </h4>
    </div>
    <div class="modal-body container-fluid form-horizontal">
      <div class="form-group">
        <div class="col-md-10 col-md-offset-1">
          <ui-select
            multiple
            ng-model="$ctrl.command.securityGroups"
            uis-open-close="$ctrl.resetCurrentItems()"
            class="form-control input-sm"
          >
            <ui-select-match>{{$item.name}} ({{$item.id}})</ui-select-match>
            <ui-select-choices
              repeat="securityGroup as securityGroup in $ctrl.availableSecurityGroups | filter: $select.search | limitTo: $ctrl.infiniteScroll.currentItems"
              infinite-scroll="$ctrl.addMoreItems()"
              infinite-scroll-distance="4"
            >
              <span ng-bind-html="securityGroup.name | highlight: $select.search"></span>
              (<span ng-bind-html="securityGroup.id  | highlight: $select.search"></span>)
            </ui-select-choices>
          </ui-select>
        </div>
      </div>
    </div>
    <aws-footer
      action="$ctrl.submit()"
      cancel="$ctrl.cancel()"
      is-valid="$ctrl.isValid()"
      account="$ctrl.serverGroup.account"
      verification="$ctrl.state.verification"
    ></aws-footer>
  </form>
</div>
`);
}]);

class TagsDetailsSection extends React__default.Component {
  render() {
    const { serverGroup } = this.props;
    return /* @__PURE__ */ React__default.createElement(CollapsibleSection, {
      heading: "Tags"
    }, serverGroup.asg.tags.length === 0 && /* @__PURE__ */ React__default.createElement("div", null, "No tags associated with this server group"), serverGroup.asg.tags.length > 0 && /* @__PURE__ */ React__default.createElement("dl", null, sortBy(serverGroup.asg.tags, "key").map((tag) => [
      /* @__PURE__ */ React__default.createElement("dt", {
        key: tag.key
      }, tag.key),
      /* @__PURE__ */ React__default.createElement("dd", {
        key: tag.value
      }, tag.value)
    ])));
  }
}

class KeyPairsReader {
  static listKeyPairs() {
    return REST("/keyPairs").useCache().get().then((keyPairs) => keyPairs.sort((a, b) => a.keyName.localeCompare(b.keyName)));
  }
}

class AwsServerGroupConfigurationService {
  constructor(securityGroupReader, awsInstanceTypeService, cacheInitializer, loadBalancerReader, serverGroupCommandRegistry) {
    this.securityGroupReader = securityGroupReader;
    this.awsInstanceTypeService = awsInstanceTypeService;
    this.cacheInitializer = cacheInitializer;
    this.loadBalancerReader = loadBalancerReader;
    this.serverGroupCommandRegistry = serverGroupCommandRegistry;
    this.enabledMetrics = [
      "GroupMinSize",
      "GroupMaxSize",
      "GroupDesiredCapacity",
      "GroupInServiceInstances",
      "GroupPendingInstances",
      "GroupStandbyInstances",
      "GroupTerminatingInstances",
      "GroupTotalInstances"
    ];
    this.healthCheckTypes = ["EC2", "ELB"];
    this.terminationPolicies = [
      "OldestInstance",
      "NewestInstance",
      "OldestLaunchConfiguration",
      "ClosestToNextInstanceHour",
      "Default"
    ];
  }
  configureUpdateCommand(command) {
    command.backingData = {
      enabledMetrics: clone(this.enabledMetrics),
      healthCheckTypes: clone(this.healthCheckTypes),
      terminationPolicies: clone(this.terminationPolicies)
    };
  }
  configureCommand(application, cmd) {
    this.applyOverrides("beforeConfiguration", cmd);
    cmd.toggleSuspendedProcess = (command, process) => {
      command.suspendedProcesses = command.suspendedProcesses || [];
      const processIndex = command.suspendedProcesses.indexOf(process);
      if (processIndex === -1) {
        command.suspendedProcesses = command.suspendedProcesses.concat(process);
      } else {
        command.suspendedProcesses = command.suspendedProcesses.filter((p) => p !== process);
      }
    };
    cmd.processIsSuspended = (command, process) => command.suspendedProcesses.includes(process);
    cmd.onStrategyChange = (command, strategy) => {
      var _a;
      if ((_a = AWSProviderSettings.serverGroups) == null ? void 0 : _a.enableLaunchTemplates) {
        command.setLaunchTemplate = strategy.key === "rollingpush" ? true : void 0;
      }
      if (strategy.key !== "" && strategy.key !== "custom") {
        command.suspendedProcesses = (command.suspendedProcesses || []).filter((p) => p !== "AddToLoadBalancer");
      }
    };
    cmd.getBlockDeviceMappingsSource = (command) => {
      if (command.copySourceCustomBlockDeviceMappings) {
        return "source";
      } else if (command.useAmiBlockDeviceMappings) {
        return "ami";
      }
      return "default";
    };
    cmd.selectBlockDeviceMappingsSource = (command, selection) => {
      if (selection === "source") {
        command.copySourceCustomBlockDeviceMappings = true;
        command.useAmiBlockDeviceMappings = false;
      } else if (selection === "ami") {
        command.copySourceCustomBlockDeviceMappings = false;
        command.useAmiBlockDeviceMappings = true;
      } else {
        command.copySourceCustomBlockDeviceMappings = false;
        command.useAmiBlockDeviceMappings = false;
      }
    };
    cmd.regionIsDeprecated = (command) => {
      return has(command, "backingData.filtered.regions") && command.backingData.filtered.regions.some((region) => region.name === command.region && region.deprecated);
    };
    return $q.all([
      AccountService.getCredentialsKeyedByAccount("aws"),
      this.securityGroupReader.getAllSecurityGroups(),
      SubnetReader.listSubnets(),
      AccountService.getPreferredZonesByAccount("aws"),
      KeyPairsReader.listKeyPairs(),
      this.awsInstanceTypeService.getAllTypesByRegion(),
      $q.when(clone(this.enabledMetrics)),
      $q.when(clone(this.healthCheckTypes)),
      $q.when(clone(this.terminationPolicies))
    ]).then(([
      credentialsKeyedByAccount,
      securityGroups,
      subnets,
      preferredZones,
      keyPairs,
      instanceTypesInfo,
      enabledMetrics,
      healthCheckTypes,
      terminationPolicies
    ]) => {
      var _a, _b;
      const backingData = {
        credentialsKeyedByAccount,
        securityGroups,
        subnets,
        preferredZones,
        keyPairs,
        instanceTypesInfo,
        enabledMetrics,
        healthCheckTypes,
        terminationPolicies
      };
      let securityGroupReloader = $q.when();
      backingData.accounts = keys(backingData.credentialsKeyedByAccount);
      backingData.filtered = {};
      backingData.scalingProcesses = AutoScalingProcessService.listProcesses();
      backingData.appLoadBalancers = application.getDataSource("loadBalancers").data;
      backingData.managedResources = (_b = (_a = application.getDataSource("managedResources")) == null ? void 0 : _a.data) == null ? void 0 : _b.resources;
      cmd.backingData = backingData;
      this.configureVpcId(cmd);
      backingData.filtered.securityGroups = this.getRegionalSecurityGroups(cmd);
      if (cmd.viewState.disableImageSelection) {
        this.configureInstanceTypes(cmd);
      }
      if (cmd.securityGroups && cmd.securityGroups.length) {
        const regionalSecurityGroupIds = map$1(this.getRegionalSecurityGroups(cmd), "id");
        if (intersection(cmd.securityGroups, regionalSecurityGroupIds).length < cmd.securityGroups.length) {
          securityGroupReloader = this.refreshSecurityGroups(cmd, true);
        }
      }
      return securityGroupReloader.then(() => {
        this.applyOverrides("afterConfiguration", cmd);
        this.attachEventHandlers(cmd);
      });
    });
  }
  applyOverrides(phase, command) {
    this.serverGroupCommandRegistry.getCommandOverrides("aws").forEach((override) => {
      if (override[phase]) {
        override[phase](command);
      }
    });
  }
  configureKeyPairs(command) {
    const result = { dirty: {} };
    if (command.credentials && command.region) {
      const isDefault = some(command.backingData.credentialsKeyedByAccount, (c) => c.defaultKeyPair && command.keyPair && command.keyPair.indexOf(c.defaultKeyPair.replace("{{region}}", "")) === 0);
      const filtered = chain(command.backingData.keyPairs).filter({ account: command.credentials, region: command.region }).map("keyName").value();
      if (command.keyPair && filtered.length && !filtered.includes(command.keyPair)) {
        const acct = command.backingData.credentialsKeyedByAccount[command.credentials] || {
          regions: [],
          defaultKeyPair: null
        };
        if (acct.defaultKeyPair) {
          const defaultKeyPair = acct.defaultKeyPair.replace("{{region}}", command.region);
          if (isDefault && filtered.includes(defaultKeyPair)) {
            command.keyPair = defaultKeyPair;
          } else {
            command.keyPair = null;
            result.dirty.keyPair = true;
          }
        } else {
          command.keyPair = null;
          result.dirty.keyPair = true;
        }
      }
      command.backingData.filtered.keyPairs = filtered;
    } else {
      command.backingData.filtered.keyPairs = [];
    }
    return result;
  }
  configureInstanceTypes(command) {
    const result = { dirty: {} };
    if (command.region && (command.virtualizationType || command.viewState.disableImageSelection)) {
      let filteredTypesInfo = this.awsInstanceTypeService.getAvailableTypesForRegions(command.backingData.instanceTypesInfo, [command.region]);
      if (command.virtualizationType || command.amiArchitecture) {
        filteredTypesInfo = this.awsInstanceTypeService.filterInstanceTypes(filteredTypesInfo, command.virtualizationType, !!command.vpcId, command.amiArchitecture);
      }
      const filteredTypes = map$1(filteredTypesInfo, "name");
      if (command.instanceType && !filteredTypes.includes(command.instanceType)) {
        result.dirty.instanceType = command.instanceType;
        command.instanceType = null;
      }
      const multipleInstanceTypes = map$1(command.launchTemplateOverridesForInstanceType, "instanceType");
      const validInstanceTypes = intersection(multipleInstanceTypes, filteredTypes);
      const invalidInstanceTypes = difference(multipleInstanceTypes, validInstanceTypes);
      if (command.launchTemplateOverridesForInstanceType && invalidInstanceTypes.length > 0) {
        result.dirty.launchTemplateOverridesForInstanceType = command.launchTemplateOverridesForInstanceType.filter((it) => invalidInstanceTypes.includes(it.instanceType));
        command.launchTemplateOverridesForInstanceType = command.launchTemplateOverridesForInstanceType.filter((it) => validInstanceTypes.includes(it.instanceType));
      }
      command.backingData.filtered.instanceTypes = filteredTypes;
      command.backingData.filtered.instanceTypesInfo = filteredTypesInfo;
    } else {
      command.backingData.filtered.instanceTypes = [];
      command.backingData.filtered.instanceTypesInfo = [];
    }
    extend(command.viewState.dirty, result.dirty);
    return result;
  }
  configureImages(command) {
    const result = { dirty: {} };
    if (!command.amiName) {
      command.virtualizationType = null;
      command.amiArchitecture = null;
    }
    if (command.viewState.disableImageSelection) {
      return result;
    }
    if (command.amiName && !command.region) {
      result.dirty.amiName = true;
      command.amiName = null;
    }
    return result;
  }
  configureAvailabilityZones(command) {
    command.backingData.filtered.availabilityZones = find(command.backingData.credentialsKeyedByAccount[command.credentials].regions, { name: command.region }).availabilityZones;
  }
  configureSubnetPurposes(command) {
    const result = { dirty: {} };
    const filteredData = command.backingData.filtered;
    if (command.region === null) {
      return result;
    }
    filteredData.subnetPurposes = chain(command.backingData.subnets).filter({ account: command.credentials, region: command.region }).reject({ target: "elb" }).reject({ purpose: null }).uniqBy("purpose").value();
    if (!chain(filteredData.subnetPurposes).some({ purpose: command.subnetType }).value()) {
      command.subnetType = null;
      result.dirty.subnetType = true;
    }
    return result;
  }
  getRegionalSecurityGroups(command) {
    const newSecurityGroups = command.backingData.securityGroups[command.credentials] || { aws: {} };
    return chain(newSecurityGroups.aws[command.region]).filter({ vpcId: command.vpcId || null }).sortBy("name").value();
  }
  configureSecurityGroupOptions(command) {
    const result = { dirty: {} };
    const currentOptions = command.backingData.filtered.securityGroups;
    const newRegionalSecurityGroups = this.getRegionalSecurityGroups(command);
    const isExpression = typeof command.securityGroups === "string" && command.securityGroups.includes("${");
    if (currentOptions && command.securityGroups && !isExpression) {
      const currentGroupNames = command.securityGroups.map((groupId) => {
        const match = find(currentOptions, { id: groupId });
        return match ? match.name : groupId;
      });
      const matchedGroups = command.securityGroups.map((groupId) => {
        const securityGroup = find(currentOptions, { id: groupId }) || find(currentOptions, { name: groupId });
        return securityGroup ? securityGroup.name : null;
      }).map((groupName) => find(newRegionalSecurityGroups, { name: groupName })).filter((group) => group);
      const matchedGroupNames = map$1(matchedGroups, "name");
      const removed = xor(currentGroupNames, matchedGroupNames);
      command.securityGroups = map$1(matchedGroups, "id");
      if (removed.length) {
        result.dirty.securityGroups = removed;
      }
    }
    command.backingData.filtered.securityGroups = newRegionalSecurityGroups.sort((a, b) => {
      return a.name.localeCompare(b.name);
    });
    return result;
  }
  refreshSecurityGroups(command, skipCommandReconfiguration) {
    return this.cacheInitializer.refreshCache("securityGroups").then(() => {
      return this.securityGroupReader.getAllSecurityGroups().then((securityGroups) => {
        command.backingData.securityGroups = securityGroups;
        if (!skipCommandReconfiguration) {
          this.configureSecurityGroupOptions(command);
        }
      });
    });
  }
  getLoadBalancerMap(command) {
    if (command.backingData.loadBalancers) {
      return chain(command.backingData.loadBalancers).map("accounts").flattenDeep().filter({ name: command.credentials }).map("regions").flattenDeep().filter({ name: command.region }).map("loadBalancers").flattenDeep().value();
    }
    const appLoadBalancers = command.backingData.appLoadBalancers || [];
    return appLoadBalancers.filter((lb) => lb.region === command.region && lb.account === command.credentials);
  }
  getLoadBalancerNames(command) {
    const loadBalancers = this.getLoadBalancerMap(command).filter((lb) => (!lb.loadBalancerType || lb.loadBalancerType === "classic") && lb.vpcId === command.vpcId);
    return loadBalancers.map((lb) => lb.name).sort();
  }
  getVpcLoadBalancerNames(command) {
    const loadBalancersForVpc = this.getLoadBalancerMap(command).filter((lb) => (!lb.loadBalancerType || lb.loadBalancerType === "classic") && lb.vpcId);
    return loadBalancersForVpc.map((lb) => lb.name).sort();
  }
  getTargetGroupNames(command) {
    const loadBalancersV2 = this.getLoadBalancerMap(command).filter((lb) => lb.loadBalancerType !== "classic");
    const instanceTargetGroups = flatten(loadBalancersV2.map((lb) => lb.targetGroups.filter((tg) => tg.targetType === "instance")));
    return instanceTargetGroups.map((tg) => tg.name).sort();
  }
  getValidMatches(all, current) {
    const spel = current.filter((v) => v.includes("${"));
    const matched = intersection(all, current);
    const [valid, invalid] = partition(current, (c) => matched.includes(c) || spel.includes(c));
    return { valid, invalid, spel };
  }
  configureLoadBalancerOptions(command) {
    const result = { dirty: {} };
    const currentLoadBalancers = (command.loadBalancers || []).concat(command.vpcLoadBalancers || []);
    const currentTargetGroups = command.targetGroups || [];
    const newLoadBalancers = this.getLoadBalancerNames(command);
    const vpcLoadBalancers = this.getVpcLoadBalancerNames(command);
    const allTargetGroups = this.getTargetGroupNames(command);
    if (currentLoadBalancers && command.loadBalancers) {
      const allValidLoadBalancers = command.vpcId ? newLoadBalancers : newLoadBalancers.concat(vpcLoadBalancers);
      const { valid, invalid, spel } = this.getValidMatches(allValidLoadBalancers, currentLoadBalancers);
      command.loadBalancers = intersection(newLoadBalancers.concat(spel), valid);
      if (!command.vpcId) {
        command.vpcLoadBalancers = intersection(vpcLoadBalancers, valid);
      } else {
        delete command.vpcLoadBalancers;
      }
      if (invalid.length) {
        result.dirty.loadBalancers = invalid;
      }
      command.viewState.spelLoadBalancers = spel || [];
    }
    if (currentTargetGroups && command.targetGroups && !currentTargetGroups.includes("${")) {
      const { valid, invalid, spel } = this.getValidMatches(allTargetGroups, currentTargetGroups);
      command.targetGroups = valid;
      if (invalid.length) {
        result.dirty.targetGroups = invalid;
      }
      command.viewState.spelTargetGroups = spel || [];
    }
    command.backingData.filtered.loadBalancers = newLoadBalancers;
    command.backingData.filtered.vpcLoadBalancers = vpcLoadBalancers;
    command.backingData.filtered.targetGroups = allTargetGroups;
    return result;
  }
  refreshLoadBalancers(command, skipCommandReconfiguration) {
    return this.loadBalancerReader.listLoadBalancers("aws").then((loadBalancers) => {
      command.backingData.loadBalancers = loadBalancers;
      if (!skipCommandReconfiguration) {
        this.configureLoadBalancerOptions(command);
      }
    });
  }
  configureVpcId(command) {
    const result = { dirty: {} };
    if (!command.subnetType) {
      command.vpcId = null;
      result.dirty.vpcId = true;
    } else {
      const subnet = find(command.backingData.subnets, {
        purpose: command.subnetType,
        account: command.credentials,
        region: command.region
      });
      command.vpcId = subnet ? subnet.vpcId : null;
    }
    extend(result.dirty, this.configureInstanceTypes(command).dirty);
    return result;
  }
  attachEventHandlers(cmd) {
    cmd.usePreferredZonesChanged = (command) => {
      const currentZoneCount = command.availabilityZones ? command.availabilityZones.length : 0;
      const result = { dirty: {} };
      const preferredZonesForAccount = command.backingData.preferredZones[command.credentials];
      if (preferredZonesForAccount && preferredZonesForAccount[command.region] && command.viewState.usePreferredZones) {
        command.availabilityZones = cloneDeep(preferredZonesForAccount[command.region].sort());
      } else {
        command.availabilityZones = intersection(command.availabilityZones, command.backingData.filtered.availabilityZones);
        const newZoneCount = command.availabilityZones ? command.availabilityZones.length : 0;
        if (currentZoneCount !== newZoneCount) {
          result.dirty.availabilityZones = true;
        }
      }
      return result;
    };
    cmd.subnetChanged = (command) => {
      const result = this.configureVpcId(command);
      extend(result.dirty, this.configureSecurityGroupOptions(command).dirty);
      extend(result.dirty, this.configureLoadBalancerOptions(command).dirty);
      command.viewState.dirty = command.viewState.dirty || {};
      extend(command.viewState.dirty, result.dirty);
      return result;
    };
    cmd.regionChanged = (command) => {
      const result = { dirty: {} };
      const filteredData = command.backingData.filtered;
      extend(result.dirty, this.configureSubnetPurposes(command).dirty);
      if (command.region) {
        extend(result.dirty, command.subnetChanged(command).dirty);
        extend(result.dirty, this.configureInstanceTypes(command).dirty);
        this.configureAvailabilityZones(command);
        extend(result.dirty, command.usePreferredZonesChanged(command).dirty);
        extend(result.dirty, this.configureImages(command).dirty);
        extend(result.dirty, this.configureKeyPairs(command).dirty);
      } else {
        filteredData.regionalAvailabilityZones = null;
      }
      setMatchingResourceSummary(command);
      return result;
    };
    cmd.clusterChanged = (command) => {
      command.moniker = NameUtils.getMoniker(command.application, command.stack, command.freeFormDetails);
      setMatchingResourceSummary(command);
    };
    cmd.credentialsChanged = (command) => {
      const result = { dirty: {} };
      const backingData = command.backingData;
      if (command.credentials) {
        const regionsForAccount = backingData.credentialsKeyedByAccount[command.credentials] || { regions: [], defaultKeyPair: null };
        backingData.filtered.regions = regionsForAccount.regions;
        if (!some(backingData.filtered.regions, { name: command.region })) {
          command.region = null;
          result.dirty.region = true;
        } else {
          extend(result.dirty, command.regionChanged(command).dirty);
        }
      } else {
        command.region = null;
      }
      setMatchingResourceSummary(command);
      return result;
    };
    cmd.imageChanged = (command) => this.configureInstanceTypes(command);
    cmd.instanceTypeChanged = (command) => {
      command.ebsOptimized = this.awsInstanceTypeService.isEbsOptimized(command.instanceType);
    };
    cmd.launchTemplateOverridesChanged = (command) => {
      var _a;
      command.ebsOptimized = (_a = command.launchTemplateOverridesForInstanceType) == null ? void 0 : _a.every((o) => this.awsInstanceTypeService.isEbsOptimized(o.instanceType));
    };
    this.applyOverrides("attachEventHandlers", cmd);
  }
}
AwsServerGroupConfigurationService.$inject = [
  "securityGroupReader",
  "awsInstanceTypeService",
  "cacheInitializer",
  "loadBalancerReader",
  "serverGroupCommandRegistry"
];
const AWS_SERVER_GROUP_CONFIGURATION_SERVICE = "spinnaker.amazon.serverGroup.configure.service";
module(AWS_SERVER_GROUP_CONFIGURATION_SERVICE, [
  SECURITY_GROUP_READER,
  AMAZON_INSTANCE_AWSINSTANCETYPE_SERVICE,
  LOAD_BALANCER_READ_SERVICE,
  CACHE_INITIALIZER_SERVICE,
  SERVER_GROUP_COMMAND_REGISTRY_PROVIDER
]).service("awsServerGroupConfigurationService", AwsServerGroupConfigurationService);

const AMAZON_SERVERGROUP_CONFIGURE_SERVERGROUPCOMMANDBUILDER_SERVICE = "spinnaker.amazon.serverGroupCommandBuilder.service";
angular.module(AMAZON_SERVERGROUP_CONFIGURE_SERVERGROUPCOMMANDBUILDER_SERVICE, [
  INSTANCE_TYPE_SERVICE,
  AWS_SERVER_GROUP_CONFIGURATION_SERVICE
]).factory("awsServerGroupCommandBuilder", [
  "$q",
  "instanceTypeService",
  "awsServerGroupConfigurationService",
  function($q, instanceTypeService, awsServerGroupConfigurationService) {
    function buildNewServerGroupCommand(application, defaults) {
      defaults = defaults || {};
      const credentialsLoader = AccountService.getCredentialsKeyedByAccount("aws");
      const defaultCredentials = defaults.account || application.defaultCredentials.aws || AWSProviderSettings.defaults.account;
      const defaultRegion = defaults.region || application.defaultRegions.aws || AWSProviderSettings.defaults.region;
      const defaultSubnet = defaults.subnet || AWSProviderSettings.defaults.subnetType || "";
      const preferredZonesLoader = AccountService.getAvailabilityZonesForAccountAndRegion("aws", defaultCredentials, defaultRegion);
      return $q.all([preferredZonesLoader, credentialsLoader]).then(function([preferredZones, credentialsKeyedByAccount]) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const credentials = credentialsKeyedByAccount[defaultCredentials];
        const keyPair = credentials ? credentials.defaultKeyPair : null;
        const applicationAwsSettings = (_c = (_b = (_a = application.attributes) == null ? void 0 : _a.providerSettings) == null ? void 0 : _b.aws) != null ? _c : {};
        let defaultIamRole = AWSProviderSettings.defaults.iamRole || "BaseIAMRole";
        defaultIamRole = defaultIamRole.replace("{{application}}", application.name);
        const useAmiBlockDeviceMappings = applicationAwsSettings.useAmiBlockDeviceMappings || false;
        const command = {
          application: application.name,
          credentials: defaultCredentials,
          region: defaultRegion,
          strategy: "",
          capacity: {
            min: 1,
            max: 1,
            desired: 1
          },
          targetHealthyDeployPercentage: 100,
          cooldown: 10,
          enabledMetrics: [],
          healthCheckType: "EC2",
          healthCheckGracePeriod: 600,
          instanceMonitoring: false,
          ebsOptimized: false,
          selectedProvider: "aws",
          iamRole: defaultIamRole,
          terminationPolicies: ["Default"],
          vpcId: null,
          subnetType: defaultSubnet,
          availabilityZones: preferredZones,
          keyPair,
          suspendedProcesses: [],
          securityGroups: [],
          stack: "",
          freeFormDetails: "",
          spotPrice: "",
          tags: {},
          useAmiBlockDeviceMappings,
          copySourceCustomBlockDeviceMappings: false,
          viewState: {
            instanceProfile: "custom",
            useSimpleInstanceTypeSelector: true,
            useAllImageSelection: false,
            useSimpleCapacity: true,
            usePreferredZones: true,
            mode: defaults.mode || "create",
            disableStrategySelection: true,
            dirty: {},
            submitButtonLabel: getSubmitButtonLabel(defaults.mode || "create")
          }
        };
        if (((_d = application.attributes) == null ? void 0 : _d.platformHealthOnlyShowOverride) && ((_e = application.attributes) == null ? void 0 : _e.platformHealthOnly)) {
          command.interestingHealthProviderNames = ["Amazon"];
        }
        if (defaultCredentials === "test" && ((_f = AWSProviderSettings.serverGroups) == null ? void 0 : _f.enableIPv6)) {
          command.associateIPv6Address = true;
        }
        if ((_g = AWSProviderSettings.serverGroups) == null ? void 0 : _g.enableIMDSv2) {
          const appAgeRequirement = AWSProviderSettings.serverGroups.defaultIMDSv2AppAgeLimit;
          const creationDate = (_h = application.attributes) == null ? void 0 : _h.createTs;
          command.requireIMDSv2 = appAgeRequirement && creationDate && Number(creationDate) > appAgeRequirement;
        }
        return command;
      });
    }
    function buildServerGroupCommandFromPipeline(application, originalCluster) {
      const pipelineCluster = _.cloneDeep(originalCluster);
      const region = Object.keys(pipelineCluster.availabilityZones)[0];
      const instanceTypes = pipelineCluster.launchTemplateOverridesForInstanceType ? pipelineCluster.launchTemplateOverridesForInstanceType.map((o) => o.instanceType) : [pipelineCluster.instanceType];
      const instanceTypeCategoryLoader = instanceTypeService.getCategoryForMultipleInstanceTypes("aws", instanceTypes);
      const commandOptions = { account: pipelineCluster.account, region };
      const asyncLoader = $q.all([
        buildNewServerGroupCommand(application, commandOptions),
        instanceTypeCategoryLoader
      ]);
      return asyncLoader.then(function([command, instanceProfile]) {
        const zones = pipelineCluster.availabilityZones[region];
        const usePreferredZones = zones.join(",") === command.availabilityZones.join(",");
        const viewState = {
          instanceProfile,
          disableImageSelection: true,
          useSimpleCapacity: pipelineCluster.capacity.min === pipelineCluster.capacity.max && pipelineCluster.useSourceCapacity !== true,
          usePreferredZones,
          mode: "editPipeline",
          submitButtonLabel: "Done",
          templatingEnabled: true,
          existingPipelineCluster: true,
          dirty: {},
          useSimpleInstanceTypeSelector: isSimpleModeEnabled(pipelineCluster)
        };
        const viewOverrides = {
          region,
          credentials: pipelineCluster.account,
          availabilityZones: pipelineCluster.availabilityZones[region],
          iamRole: pipelineCluster.iamRole,
          viewState
        };
        pipelineCluster.strategy = pipelineCluster.strategy || "";
        return angular.extend({}, command, pipelineCluster, viewOverrides);
      });
    }
    function buildNewServerGroupCommandForPipeline() {
      return $q.when({
        viewState: {
          requiresTemplateSelection: true
        }
      });
    }
    function getSubmitButtonLabel(mode) {
      switch (mode) {
        case "createPipeline":
          return "Add";
        case "editPipeline":
          return "Done";
        case "clone":
          return "Clone";
        default:
          return "Create";
      }
    }
    function buildUpdateServerGroupCommand(serverGroup) {
      var _a, _b;
      const command = {
        type: "modifyAsg",
        asgs: [{ asgName: serverGroup.name, region: serverGroup.region }],
        cooldown: serverGroup.asg.defaultCooldown,
        enabledMetrics: ((_b = (_a = serverGroup.asg) == null ? void 0 : _a.enabledMetrics) != null ? _b : []).map((m) => m.metric),
        healthCheckGracePeriod: serverGroup.asg.healthCheckGracePeriod,
        healthCheckType: serverGroup.asg.healthCheckType,
        terminationPolicies: angular.copy(serverGroup.asg.terminationPolicies),
        credentials: serverGroup.account,
        capacityRebalance: serverGroup.asg.capacityRebalance
      };
      awsServerGroupConfigurationService.configureUpdateCommand(command);
      return command;
    }
    function buildServerGroupCommandFromExisting(application, serverGroup, mode = "clone") {
      var _a, _b, _c, _d;
      const preferredZonesLoader = AccountService.getPreferredZonesByAccount("aws");
      const subnetsLoader = SubnetReader.listSubnets();
      const serverGroupName = NameUtils.parseServerGroupName(serverGroup.asg.autoScalingGroupName);
      let instanceTypes;
      if (serverGroup.mixedInstancesPolicy) {
        const ltOverrides = (_a = serverGroup.mixedInstancesPolicy) == null ? void 0 : _a.launchTemplateOverridesForInstanceType;
        instanceTypes = ltOverrides ? ltOverrides.map((o) => o.instanceType) : [(_d = (_c = (_b = serverGroup.mixedInstancesPolicy) == null ? void 0 : _b.launchTemplates[0]) == null ? void 0 : _c.launchTemplateData) == null ? void 0 : _d.instanceType];
      } else if (serverGroup.launchTemplate) {
        instanceTypes = [_.get(serverGroup, "launchTemplate.launchTemplateData.instanceType")];
      } else if (serverGroup.launchConfig) {
        instanceTypes = [_.get(serverGroup, "launchConfig.instanceType")];
      }
      const instanceTypeCategoryLoader = instanceTypeService.getCategoryForMultipleInstanceTypes("aws", instanceTypes);
      return $q.all([preferredZonesLoader, subnetsLoader, instanceTypeCategoryLoader]).then(([preferredZones, subnets, instanceProfile]) => {
        var _a2, _b2, _c2, _d2, _e, _f, _g, _h, _i, _j, _k, _l, _m;
        const zones = serverGroup.asg.availabilityZones.sort();
        let usePreferredZones = false;
        const preferredZonesForAccount = preferredZones[serverGroup.account];
        if (preferredZonesForAccount) {
          const preferredZones2 = preferredZonesForAccount[serverGroup.region].sort();
          usePreferredZones = zones.join(",") === preferredZones2.join(",");
        }
        const enabledProcesses = ["Launch", "Terminate", "AddToLoadBalancer"];
        const applicationAwsSettings = (_c2 = (_b2 = (_a2 = application.attributes) == null ? void 0 : _a2.providerSettings) == null ? void 0 : _b2.aws) != null ? _c2 : {};
        const useAmiBlockDeviceMappings = applicationAwsSettings.useAmiBlockDeviceMappings || false;
        const existingTags = {};
        const reservedTags = ["spinnaker:application", "spinnaker:stack", "spinnaker:details"];
        if (serverGroup.asg.tags) {
          serverGroup.asg.tags.filter((t) => !reservedTags.includes(t.key)).forEach((tag) => {
            existingTags[tag.key] = tag.value;
          });
        }
        const command = {
          application: application.name,
          strategy: "",
          stack: serverGroupName.stack,
          freeFormDetails: serverGroupName.freeFormDetails,
          credentials: serverGroup.account,
          cooldown: serverGroup.asg.defaultCooldown,
          enabledMetrics: _.get(serverGroup, "asg.enabledMetrics", []).map((m) => m.metric),
          healthCheckGracePeriod: serverGroup.asg.healthCheckGracePeriod,
          healthCheckType: serverGroup.asg.healthCheckType,
          terminationPolicies: serverGroup.asg.terminationPolicies,
          loadBalancers: serverGroup.asg.loadBalancerNames,
          region: serverGroup.region,
          useSourceCapacity: false,
          capacity: {
            min: serverGroup.asg.minSize,
            max: serverGroup.asg.maxSize,
            desired: serverGroup.asg.desiredCapacity
          },
          targetHealthyDeployPercentage: 100,
          availabilityZones: zones,
          selectedProvider: "aws",
          source: {
            account: serverGroup.account,
            region: serverGroup.region,
            asgName: serverGroup.asg.autoScalingGroupName
          },
          suspendedProcesses: (serverGroup.asg.suspendedProcesses || []).map((process) => process.processName).filter((name2) => !enabledProcesses.includes(name2)),
          tags: Object.assign({}, serverGroup.tags, existingTags),
          targetGroups: serverGroup.targetGroups,
          useAmiBlockDeviceMappings,
          copySourceCustomBlockDeviceMappings: mode === "clone",
          viewState: {
            instanceProfile,
            useAllImageSelection: false,
            useSimpleCapacity: serverGroup.asg.minSize === serverGroup.asg.maxSize,
            usePreferredZones,
            mode,
            submitButtonLabel: getSubmitButtonLabel(mode),
            isNew: false,
            dirty: {}
          }
        };
        if (((_d2 = application.attributes) == null ? void 0 : _d2.platformHealthOnlyShowOverride) && ((_e = application.attributes) == null ? void 0 : _e.platformHealthOnly)) {
          command.interestingHealthProviderNames = ["Amazon"];
        }
        if (mode === "editPipeline") {
          command.useSourceCapacity = true;
          command.viewState.useSimpleCapacity = false;
          command.strategy = "redblack";
          const redblack = DeploymentStrategyRegistry.getStrategy("redblack");
          redblack.initializationMethod && redblack.initializationMethod(command);
          command.suspendedProcesses = [];
        }
        const vpcZoneIdentifier = serverGroup.asg.vpczoneIdentifier;
        if (vpcZoneIdentifier !== "") {
          const subnetId = vpcZoneIdentifier.split(",")[0];
          const subnet = subnets.find((x) => x.id === subnetId);
          command.subnetType = subnet.purpose;
          command.vpcId = subnet.vpcId;
        } else {
          command.subnetType = "";
          command.vpcId = null;
        }
        if (serverGroup.launchConfig) {
          angular.extend(command, {
            instanceType: serverGroup.launchConfig.instanceType,
            iamRole: serverGroup.launchConfig.iamInstanceProfile,
            keyPair: serverGroup.launchConfig.keyName,
            associatePublicIpAddress: serverGroup.launchConfig.associatePublicIpAddress,
            ramdiskId: serverGroup.launchConfig.ramdiskId,
            instanceMonitoring: serverGroup.launchConfig.instanceMonitoring && serverGroup.launchConfig.instanceMonitoring.enabled,
            ebsOptimized: serverGroup.launchConfig.ebsOptimized,
            spotPrice: serverGroup.launchConfig.spotPrice
          });
          if (serverGroup.launchConfig.userData) {
            command.base64UserData = serverGroup.launchConfig.userData;
          }
          command.viewState.imageId = serverGroup.launchConfig.imageId;
          command.viewState.useSimpleInstanceTypeSelector = true;
        }
        if (serverGroup.launchTemplate || serverGroup.mixedInstancesPolicy) {
          let launchTemplateData, spotMaxPrice;
          if (serverGroup.launchTemplate) {
            launchTemplateData = serverGroup.launchTemplate.launchTemplateData;
            spotMaxPrice = (_g = (_f = launchTemplateData.instanceMarketOptions) == null ? void 0 : _f.spotOptions) == null ? void 0 : _g.maxPrice;
            command.instanceType = launchTemplateData.instanceType;
            command.viewState.useSimpleInstanceTypeSelector = true;
          }
          if (serverGroup.mixedInstancesPolicy) {
            const mip = serverGroup.mixedInstancesPolicy;
            launchTemplateData = (_i = (_h = mip == null ? void 0 : mip.launchTemplates) == null ? void 0 : _h[0]) == null ? void 0 : _i.launchTemplateData;
            spotMaxPrice = (_j = mip == null ? void 0 : mip.instancesDistribution) == null ? void 0 : _j.spotMaxPrice;
            command.securityGroups = launchTemplateData.networkInterfaces ? ((_k = launchTemplateData.networkInterfaces.find((ni) => ni.deviceIndex === 0)) != null ? _k : {}).groups : launchTemplateData.securityGroups;
            command.onDemandAllocationStrategy = mip.instancesDistribution.onDemandAllocationStrategy;
            command.onDemandBaseCapacity = mip.instancesDistribution.onDemandBaseCapacity;
            command.onDemandPercentageAboveBaseCapacity = mip.instancesDistribution.onDemandPercentageAboveBaseCapacity;
            command.spotAllocationStrategy = mip.instancesDistribution.spotAllocationStrategy;
            command.spotInstancePools = mip.instancesDistribution.spotInstancePools;
            if (mip.launchTemplateOverridesForInstanceType) {
              command.launchTemplateOverridesForInstanceType = getInstanceTypesWithPriority(mip.launchTemplateOverridesForInstanceType);
            } else {
              command.instanceType = launchTemplateData.instanceType;
            }
            command.viewState.useSimpleInstanceTypeSelector = isSimpleModeEnabled(command);
          }
          const ipv6AddressCount = _.get(launchTemplateData, "networkInterfaces[0]");
          const asgSettings = AWSProviderSettings.serverGroups;
          const isTestEnv = serverGroup.accountDetails && serverGroup.accountDetails.environment === "test";
          const shouldAutoEnableIPv6 = asgSettings && asgSettings.enableIPv6 && asgSettings.setIPv6InTest && isTestEnv;
          angular.extend(command, {
            iamRole: launchTemplateData.iamInstanceProfile.name,
            keyPair: launchTemplateData.keyName,
            associateIPv6Address: shouldAutoEnableIPv6 || Boolean(ipv6AddressCount),
            ramdiskId: launchTemplateData.ramdiskId,
            instanceMonitoring: launchTemplateData.monitoring && launchTemplateData.monitoring.enabled,
            ebsOptimized: launchTemplateData.ebsOptimized,
            spotPrice: spotMaxPrice || void 0,
            requireIMDSv2: Boolean(((_l = launchTemplateData.metadataOptions) == null ? void 0 : _l.httpTokens) === "required"),
            unlimitedCpuCredits: launchTemplateData.creditSpecification ? launchTemplateData.creditSpecification.cpuCredits === "unlimited" : void 0
          });
          command.viewState.imageId = launchTemplateData.imageId;
        }
        if (mode === "clone" && serverGroup.image && serverGroup.image.name) {
          command.amiName = serverGroup.image.name;
        }
        if (serverGroup.launchConfig && serverGroup.launchConfig.securityGroups.length) {
          command.securityGroups = serverGroup.launchConfig.securityGroups;
        }
        if (serverGroup.launchTemplate && serverGroup.launchTemplate.launchTemplateData.securityGroups.length) {
          command.securityGroups = serverGroup.launchTemplate.launchTemplateData.securityGroups;
        }
        if (serverGroup.launchTemplate && serverGroup.launchTemplate.launchTemplateData.networkInterfaces) {
          const networkInterface = (_m = serverGroup.launchTemplate.launchTemplateData.networkInterfaces.find((ni) => ni.deviceIndex === 0)) != null ? _m : {};
          command.securityGroups = networkInterface.groups;
        }
        return command;
      });
    }
    function getInstanceTypesWithPriority(instanceTypeOverrides) {
      let explicitPriority = 1;
      return _.sortBy(instanceTypeOverrides, ["priority"]).map((override) => {
        const { instanceType, weightedCapacity } = override;
        let priority;
        if (override.priority) {
          priority = override.priority;
          explicitPriority = override.priority + 1;
        } else {
          priority = explicitPriority++;
        }
        return { instanceType, weightedCapacity, priority };
      });
    }
    function isSimpleModeEnabled(command) {
      const isAdvancedModeEnabledInCommand = command.onDemandAllocationStrategy || command.onDemandBaseCapacity || command.onDemandPercentageAboveBaseCapacity || command.spotAllocationStrategy || command.spotInstancePools || command.launchTemplateOverridesForInstanceType && command.launchTemplateOverridesForInstanceType.length > 0;
      return !isAdvancedModeEnabledInCommand;
    }
    return {
      buildNewServerGroupCommand,
      buildServerGroupCommandFromExisting,
      buildNewServerGroupCommandForPipeline,
      buildServerGroupCommandFromPipeline,
      buildUpdateServerGroupCommand
    };
  }
]);

const AMAZON_SERVERGROUP_DETAILS_ADVANCEDSETTINGS_EDITASGADVANCEDSETTINGS_MODAL_CONTROLLER = "spinnaker.amazon.serverGroup.editAsgAdvancedSettings.modal.controller";
module(AMAZON_SERVERGROUP_DETAILS_ADVANCEDSETTINGS_EDITASGADVANCEDSETTINGS_MODAL_CONTROLLER, [
  AMAZON_SERVERGROUP_CONFIGURE_SERVERGROUPCOMMANDBUILDER_SERVICE
]).controller("EditAsgAdvancedSettingsCtrl", [
  "$scope",
  "$uibModalInstance",
  "application",
  "serverGroup",
  "awsServerGroupCommandBuilder",
  function($scope, $uibModalInstance, application, serverGroup, awsServerGroupCommandBuilder) {
    $scope.command = awsServerGroupCommandBuilder.buildUpdateServerGroupCommand(serverGroup);
    $scope.serverGroup = serverGroup;
    $scope.taskMonitor = new TaskMonitor({
      application,
      title: "Update Advanced Settings for " + serverGroup.name,
      modalInstance: $uibModalInstance,
      onTaskComplete: () => application.serverGroups.refresh()
    });
    this.submit = () => {
      const job = [$scope.command];
      const submitMethod = function() {
        return TaskExecutor.executeTask({
          job,
          application,
          description: "Update Advanced Settings for " + serverGroup.name
        });
      };
      $scope.taskMonitor.submit(submitMethod);
    };
    this.cancel = $uibModalInstance.dismiss;
  }
]);

const AMAZON_SERVERGROUP_DETAILS_ROLLBACK_ROLLBACKSERVERGROUP_CONTROLLER = "spinnaker.amazon.serverGroup.details.rollback.controller";
module(AMAZON_SERVERGROUP_DETAILS_ROLLBACK_ROLLBACKSERVERGROUP_CONTROLLER, [SERVER_GROUP_WRITER]).controller("awsRollbackServerGroupCtrl", [
  "$scope",
  "$uibModalInstance",
  "serverGroupWriter",
  "application",
  "serverGroup",
  "previousServerGroup",
  "disabledServerGroups",
  "allServerGroups",
  function($scope, $uibModalInstance, serverGroupWriter, application, serverGroup, previousServerGroup, disabledServerGroups, allServerGroups) {
    $scope.serverGroup = serverGroup;
    $scope.disabledServerGroups = disabledServerGroups.sort((a, b) => b.name.localeCompare(a.name));
    $scope.allServerGroups = allServerGroups.sort((a, b) => b.name.localeCompare(a.name));
    $scope.verification = {};
    const desired = serverGroup.capacity.desired;
    let rollbackType = "EXPLICIT";
    if (allServerGroups.length === 0 && serverGroup.entityTags) {
      const previousServerGroup2 = get(serverGroup, "entityTags.creationMetadata.value.previousServerGroup");
      if (previousServerGroup2) {
        rollbackType = "PREVIOUS_IMAGE";
        $scope.previousServerGroup = {
          name: previousServerGroup2.name,
          imageName: previousServerGroup2.imageName
        };
        if (previousServerGroup2.imageId && previousServerGroup2.imageId !== previousServerGroup2.imageName) {
          $scope.previousServerGroup.imageId = previousServerGroup2.imageId;
        }
        const buildNumber = get(previousServerGroup2, "buildInfo.jenkins.number");
        if (buildNumber) {
          $scope.previousServerGroup.buildNumber = buildNumber;
        }
      }
    }
    let healthyPercent;
    if (desired < 10) {
      healthyPercent = 100;
    } else if (desired < 20) {
      healthyPercent = 90;
    } else {
      healthyPercent = 95;
    }
    $scope.command = {
      rollbackType,
      rollbackContext: {
        rollbackServerGroupName: serverGroup.name,
        restoreServerGroupName: previousServerGroup ? previousServerGroup.name : void 0,
        targetHealthyRollbackPercentage: healthyPercent,
        delayBeforeDisableSeconds: 0
      }
    };
    $scope.minHealthy = function(percent) {
      return Math.ceil(desired * percent / 100);
    };
    if (application && application.attributes) {
      if (application.attributes.platformHealthOnlyShowOverride && application.attributes.platformHealthOnly) {
        $scope.command.interestingHealthProviderNames = ["Amazon"];
      }
      $scope.command.platformHealthOnlyShowOverride = application.attributes.platformHealthOnlyShowOverride;
    }
    this.isValid = function() {
      const command = $scope.command;
      if (!$scope.verification.verified) {
        return false;
      }
      if (rollbackType === "PREVIOUS_IMAGE") {
        return true;
      }
      return command.rollbackContext.restoreServerGroupName !== void 0;
    };
    $scope.taskMonitor = new TaskMonitor({
      application,
      title: "Rollback " + serverGroup.name,
      modalInstance: $uibModalInstance
    });
    this.rollback = function() {
      if (!this.isValid()) {
        return;
      }
      const submitMethod = function() {
        return serverGroupWriter.rollbackServerGroup(serverGroup, application, $scope.command);
      };
      $scope.taskMonitor.submit(submitMethod);
    };
    this.cancel = function() {
      $uibModalInstance.dismiss();
    };
    this.label = function(serverGroup2) {
      if (!serverGroup2) {
        return "";
      }
      if (!serverGroup2.buildInfo || !serverGroup2.buildInfo.jenkins || !serverGroup2.buildInfo.jenkins.number) {
        return serverGroup2.name;
      }
      return serverGroup2.name + " (build #" + serverGroup2.buildInfo.jenkins.number + ")";
    };
    this.group = function(serverGroup2) {
      return serverGroup2.isDisabled ? "Disabled Server Groups" : "Enabled Server Groups";
    };
  }
]);

const SCALING_POLICY_SUMMARY_COMPONENT = "spinnaker.amazon.scalingPolicy.scalingPolicySummary.component";
module(SCALING_POLICY_SUMMARY_COMPONENT, []).component("scalingPolicySummary", react2angular(withErrorBoundary(ScalingPolicySummary, "scalingPolicySummary"), [
  "application",
  "policy",
  "serverGroup"
]));

const SCALING_POLICY_MODULE = "spinnaker.amazon.scalingPolicy.module";
module(SCALING_POLICY_MODULE, [SCALING_POLICY_SUMMARY_COMPONENT]);

const AMAZON_SERVERGROUP_DETAILS_SCALINGPROCESSES_MODIFYSCALINGPROCESSES_CONTROLLER = "spinnaker.amazon.serverGroup.details.autoscaling.process.controller";
angular.module(AMAZON_SERVERGROUP_DETAILS_SCALINGPROCESSES_MODIFYSCALINGPROCESSES_CONTROLLER, []).controller("ModifyScalingProcessesCtrl", [
  "$scope",
  "$uibModalInstance",
  "application",
  "serverGroup",
  "processes",
  function($scope, $uibModalInstance, application, serverGroup, processes) {
    $scope.command = angular.copy(processes);
    $scope.serverGroup = serverGroup;
    $scope.verification = {};
    this.isValid = function() {
      if (!$scope.verification.verified) {
        return false;
      }
      return this.isDirty();
    };
    const currentlyEnabled = _.chain($scope.command).filter({ enabled: true }).map("name").value();
    const currentlySuspended = _.chain($scope.command).filter({ enabled: false }).map("name").value();
    this.isDirty = function() {
      const enabledSelections = _.chain($scope.command).filter({ enabled: true }).map("name").value();
      const suspendedSelections = _.chain($scope.command).filter({ enabled: false }).map("name").value();
      const toEnable = _.intersection(currentlySuspended, enabledSelections);
      const toSuspend = _.intersection(currentlyEnabled, suspendedSelections);
      return !!(toEnable.length || toSuspend.length);
    };
    $scope.taskMonitor = new TaskMonitor({
      application,
      title: "Update Auto Scaling Processes for " + serverGroup.name,
      modalInstance: $uibModalInstance,
      onTaskComplete: () => application.serverGroups.refresh()
    });
    this.submit = function() {
      const enabledSelections = _.chain($scope.command).filter({ enabled: true }).map("name").value();
      const suspendedSelections = _.chain($scope.command).filter({ enabled: false }).map("name").value();
      const toEnable = _.intersection(currentlySuspended, enabledSelections);
      const toSuspend = _.intersection(currentlyEnabled, suspendedSelections);
      const job = [];
      if (toEnable.length) {
        job.push({
          type: "modifyScalingProcess",
          action: "resume",
          processes: toEnable,
          asgName: serverGroup.name,
          regions: [serverGroup.region],
          credentials: serverGroup.account,
          cloudProvider: "aws",
          reason: $scope.command.reason
        });
      }
      if (toSuspend.length) {
        job.push({
          type: "modifyScalingProcess",
          action: "suspend",
          processes: toSuspend,
          asgName: serverGroup.name,
          regions: [serverGroup.region],
          credentials: serverGroup.account,
          cloudProvider: "aws",
          reason: $scope.command.reason
        });
      }
      const submitMethod = function() {
        return TaskExecutor.executeTask({
          job,
          application,
          description: "Update Auto Scaling Processes for " + serverGroup.name
        });
      };
      $scope.taskMonitor.submit(submitMethod);
    };
    this.cancel = $uibModalInstance.dismiss;
  }
]);

const AMAZON_SERVERGROUP_DETAILS_SCHEDULEDACTION_EDITSCHEDULEDACTIONS_MODAL_CONTROLLER = "spinnaker.amazon.serverGroup.details.scheduledActions.editScheduledActions.modal.controller";
module(AMAZON_SERVERGROUP_DETAILS_SCHEDULEDACTION_EDITSCHEDULEDACTIONS_MODAL_CONTROLLER, []).controller("EditScheduledActionsCtrl", [
  "$scope",
  "$uibModalInstance",
  "application",
  "serverGroup",
  function($scope, $uibModalInstance, application, serverGroup) {
    $scope.command = {
      scheduledActions: serverGroup.scheduledActions.map((action) => {
        return {
          recurrence: action.recurrence,
          minSize: action.minSize,
          maxSize: action.maxSize,
          desiredCapacity: action.desiredCapacity
        };
      })
    };
    $scope.serverGroup = serverGroup;
    this.addScheduledAction = () => {
      $scope.command.scheduledActions.push({});
    };
    this.removeScheduledAction = (index) => {
      $scope.command.scheduledActions.splice(index, 1);
    };
    $scope.taskMonitor = new TaskMonitor({
      application,
      title: "Update Scheduled Actions for " + serverGroup.name,
      modalInstance: $uibModalInstance,
      onTaskComplete: () => application.serverGroups.refresh()
    });
    this.submit = () => {
      const job = [
        {
          type: "upsertAsgScheduledActions",
          asgs: [{ asgName: serverGroup.name, region: serverGroup.region }],
          scheduledActions: $scope.command.scheduledActions,
          credentials: serverGroup.account
        }
      ];
      const submitMethod = function() {
        return TaskExecutor.executeTask({
          job,
          application,
          description: "Update Scheduled Actions for " + serverGroup.name
        });
      };
      $scope.taskMonitor.submit(submitMethod);
    };
    this.cancel = $uibModalInstance.dismiss;
  }
]);

const AMAZON_SERVERGROUP_DETAILS_SECURITYGROUP_EDITSECURITYGROUPS_MODAL_CONTROLLER = "spinnaker.amazon.serverGroup.details.securityGroup.editSecurityGroups.modal.controller";
module(AMAZON_SERVERGROUP_DETAILS_SECURITYGROUP_EDITSECURITYGROUPS_MODAL_CONTROLLER, [
  SERVER_GROUP_WRITER,
  SECURITY_GROUP_READER
]).controller("EditSecurityGroupsCtrl", [
  "$scope",
  "$uibModalInstance",
  "serverGroupWriter",
  "securityGroupReader",
  "application",
  "serverGroup",
  "securityGroups",
  function($scope, $uibModalInstance, serverGroupWriter, securityGroupReader, application, serverGroup, securityGroups) {
    this.command = {
      securityGroups: (securityGroups || []).slice(0).sort((a, b) => a.name.localeCompare(b.name))
    };
    this.state = {
      securityGroupsLoaded: false,
      submitting: false,
      verification: {}
    };
    this.infiniteScroll = {
      currentItems: 20
    };
    this.addMoreItems = () => this.infiniteScroll.currentItems += 20;
    this.resetCurrentItems = () => this.infiniteScroll.currentItems = 20;
    this.isValid = () => this.state.verification.verified;
    securityGroupReader.getAllSecurityGroups().then((allGroups) => {
      const account = serverGroup.account;
      const region = serverGroup.region;
      const vpcId = serverGroup.vpcId;
      this.availableSecurityGroups = _.get(allGroups, [account, "aws", region].join("."), []).filter((group) => group.vpcId === vpcId).sort((a, b) => {
        if (this.command.securityGroups.some((g) => g.id === a.id)) {
          return -1;
        }
        if (this.command.securityGroups.some((g) => g.id === b.id)) {
          return 1;
        }
        return a.name.localeCompare(b.name);
      });
      this.state.securityGroupsLoaded = true;
    });
    this.serverGroup = serverGroup;
    this.taskMonitor = new TaskMonitor({
      application,
      title: `Update ${FirewallLabels.get("Firewalls")} for ${serverGroup.name}`,
      modalInstance: $uibModalInstance,
      onTaskComplete: () => application.serverGroups.refresh()
    });
    this.submit = () => {
      const submitMethod = () => {
        this.state.submitting = true;
        const hasLaunchTemplate = Boolean(serverGroup.launchTemplate);
        return serverGroupWriter.updateSecurityGroups(serverGroup, this.command.securityGroups, application, hasLaunchTemplate);
      };
      this.taskMonitor.submit(submitMethod);
    };
    this.cancel = $uibModalInstance.dismiss;
  }
]);

const SERVER_GROUP_DETAILS_MODULE = "spinnaker.amazon.serverGroup.details";
module(SERVER_GROUP_DETAILS_MODULE, [
  SCALING_POLICY_MODULE,
  AMAZON_SERVERGROUP_DETAILS_SECURITYGROUP_EDITSECURITYGROUPS_MODAL_CONTROLLER,
  AMAZON_SERVERGROUP_DETAILS_SCALINGPROCESSES_MODIFYSCALINGPROCESSES_CONTROLLER,
  AMAZON_SERVERGROUP_DETAILS_SCHEDULEDACTION_EDITSCHEDULEDACTIONS_MODAL_CONTROLLER,
  AMAZON_SERVERGROUP_DETAILS_ADVANCEDSETTINGS_EDITASGADVANCEDSETTINGS_MODAL_CONTROLLER,
  AMAZON_SERVERGROUP_DETAILS_ROLLBACK_ROLLBACKSERVERGROUP_CONTROLLER
]);

class AwsServerGroupTransformer {
  addComparator(alarm) {
    if (!alarm.comparisonOperator) {
      return;
    }
    switch (alarm.comparisonOperator) {
      case "LessThanThreshold":
        alarm.comparator = "&lt;";
        break;
      case "GreaterThanThreshold":
        alarm.comparator = "&gt;";
        break;
      case "LessThanOrEqualToThreshold":
        alarm.comparator = "&le;";
        break;
      case "GreaterThanOrEqualToThreshold":
        alarm.comparator = "&ge;";
        break;
    }
  }
  addAdjustmentAttributes(policyOrStepAdjustment) {
    policyOrStepAdjustment.operator = policyOrStepAdjustment.scalingAdjustment < 0 ? "decrease" : "increase";
    policyOrStepAdjustment.absAdjustment = Math.abs(policyOrStepAdjustment.scalingAdjustment);
  }
  transformScalingPolicy(policy) {
    const view = { ...policy };
    const upperBoundSorter = (a, b) => b.metricIntervalUpperBound - a.metricIntervalUpperBound;
    const lowerBoundSorter = (a, b) => a.metricIntervalLowerBound - b.metricIntervalLowerBound;
    view.alarms = policy.alarms || [];
    view.alarms.forEach((alarm) => this.addComparator(alarm));
    this.addAdjustmentAttributes(view);
    if (view.stepAdjustments && view.stepAdjustments.length) {
      view.stepAdjustments.forEach((sa) => this.addAdjustmentAttributes(sa));
      const sorter = policy.stepAdjustments.every((a) => a.metricIntervalUpperBound !== void 0) ? upperBoundSorter : lowerBoundSorter;
      view.stepAdjustments.sort((a, b) => sorter(a, b));
    }
    return view;
  }
  normalizeServerGroupDetails(serverGroup) {
    const view = { ...serverGroup };
    if (serverGroup.scalingPolicies) {
      view.scalingPolicies = serverGroup.scalingPolicies.map((policy) => this.transformScalingPolicy(policy));
    }
    return view;
  }
  normalizeServerGroup(serverGroup) {
    serverGroup.instances.forEach((instance) => {
      instance.vpcId = serverGroup.vpcId;
    });
    return VpcReader.listVpcs().then((vpc) => this.addVpcNameToServerGroup(serverGroup)(vpc));
  }
  addVpcNameToServerGroup(serverGroup) {
    return (vpcs) => {
      const match = vpcs.find((test) => test.id === serverGroup.vpcId);
      serverGroup.vpcName = match ? match.name : "";
      return serverGroup;
    };
  }
  convertServerGroupCommandToDeployConfiguration(base) {
    const deployConfig = { ...base };
    deployConfig.cloudProvider = "aws";
    deployConfig.availabilityZones = { [deployConfig.region]: base.availabilityZones };
    deployConfig.loadBalancers = (base.loadBalancers || []).concat(base.vpcLoadBalancers || []);
    deployConfig.targetGroups = base.targetGroups || [];
    deployConfig.account = deployConfig.credentials;
    deployConfig.subnetType = deployConfig.subnetType || "";
    deployConfig.instanceType = deployConfig.instanceType || deployConfig.launchTemplateOverridesForInstanceType && deployConfig.launchTemplateOverridesForInstanceType[0].instanceType;
    if (base.viewState.mode !== "clone") {
      delete deployConfig.source;
    }
    if (!deployConfig.ramdiskId) {
      delete deployConfig.ramdiskId;
    }
    const deleteFields = ["region", "viewState", "backingData", "selectedProvider", "instanceProfile", "vpcId"];
    deleteFields.forEach((key) => {
      delete deployConfig[key];
    });
    return deployConfig;
  }
  constructNewStepScalingPolicyTemplate(serverGroup) {
    return {
      alarms: [
        {
          namespace: "AWS/EC2",
          metricName: "CPUUtilization",
          threshold: 50,
          statistic: "Average",
          comparisonOperator: "GreaterThanThreshold",
          evaluationPeriods: 1,
          dimensions: [{ name: "AutoScalingGroupName", value: serverGroup.name }],
          period: 60
        }
      ],
      adjustmentType: "ChangeInCapacity",
      stepAdjustments: [
        {
          scalingAdjustment: 1,
          metricIntervalLowerBound: 0
        }
      ],
      estimatedInstanceWarmup: 600
    };
  }
  constructNewTargetTrackingPolicyTemplate() {
    return {
      alarms: [],
      estimatedInstanceWarmup: 300,
      targetTrackingConfiguration: {
        targetValue: null,
        predefinedMetricSpecification: {
          predefinedMetricType: "ASGAverageCPUUtilization"
        }
      }
    };
  }
}
const AWS_SERVER_GROUP_TRANSFORMER = "spinnaker.amazon.serverGroup.transformer";
module(AWS_SERVER_GROUP_TRANSFORMER, []).service("awsServerGroupTransformer", AwsServerGroupTransformer);

class AwsSubnetRenderer {
  render(serverGroup) {
    return serverGroup.subnetType;
  }
}
const SUBNET_RENDERER = "spinnaker.amazon.subnet.renderer";
module(SUBNET_RENDERER, []).service("awsSubnetRenderer", AwsSubnetRenderer);

class AmazonApplicationNameValidator {
  validateSpecialCharacters(name, errors) {
    const pattern = /^[a-zA-Z_0-9.]*$/g;
    if (!pattern.test(name)) {
      errors.push("Only dot(.) and underscore(_) special characters are allowed.");
    }
  }
  validateClassicLock(warnings) {
    const lockoutDate = AWSProviderSettings.classicLaunchLockout;
    if (lockoutDate && lockoutDate < new Date().getTime()) {
      warnings.push(`New applications deployed to AWS are restricted to VPC; you cannot create server groups,
          load balancers, or ${FirewallLabels.get("firewalls")} in EC2 Classic.`);
    }
  }
  validateLoadBalancerCharacters(name, warnings) {
    if (name.includes(".") || name.includes("_")) {
      warnings.push(`If the application's name contains an underscore(_) or dot(.),
            you will not be able to create a load balancer,
            preventing it from being used as a front end service.
            Any hostname constructed with this application name may have issues.`);
    }
  }
  validateLength(name, warnings, errors) {
    if (name.length > 250) {
      errors.push("The maximum length for an application in Amazon is 250 characters.");
      return;
    }
    if (name.length > 240) {
      if (name.length >= 248) {
        warnings.push(`You will not be able to include a stack or detail field for clusters or ${FirewallLabels.get("firewalls")}.`);
      } else {
        const remaining = 248 - name.length;
        warnings.push(`If you plan to include a stack or detail field for clusters, you will only
            have ~${remaining} characters to do so.`);
      }
    }
    if (name.length > 20) {
      if (name.length > 32) {
        warnings.push(`You will not be able to create an Amazon load balancer for this application if the
            application's name is longer than 32 characters (currently: ${name.length} characters)`);
      } else {
        if (name.length >= 30) {
          warnings.push(`If you plan to create load balancers for this application, be aware that the character limit
              for load balancer names is 32 (currently: ${name.length} characters). With separators ("-"), you will not
              be able to add a stack and detail field to any load balancer.`);
        } else {
          const remaining = 30 - name.length;
          warnings.push(`If you plan to create load balancers for this application, be aware that the character limit
              for load balancer names is 32. You will only have ~${remaining} characters to add a stack or detail
              field to any load balancer.`);
        }
      }
    }
  }
  validate(name = "") {
    const warnings = [];
    const errors = [];
    if (name.length) {
      this.validateClassicLock(warnings);
      this.validateSpecialCharacters(name, errors);
      this.validateLoadBalancerCharacters(name, warnings);
      this.validateLength(name, warnings, errors);
    }
    return {
      warnings,
      errors
    };
  }
}
ApplicationNameValidator.registerValidator("aws", new AmazonApplicationNameValidator());

const VPC_MODULE = "spinnaker.amazon.vpc";
module(VPC_MODULE, []).component("vpcTag", react2angular(withErrorBoundary(VpcTag, "vpcTag"), ["vpcId"]));

var css_248z = ".cloud-provider-logo .icon-aws {\n  -webkit-mask-image: url(\"data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22utf-8%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 x%3D%220px%22 y%3D%220px%22%09 width%3D%22130px%22 height%3D%22130px%22 viewBox%3D%220 0 27 27%22%3E%3Cg%3E%09%3Cpolygon fill%3D%22%23000000%22 stroke%3D%22%23FFFFFF%22 stroke-width%3D%220%22 points%3D%2213.2%2C27 2.4%2C23.1 2.4%2C8.5 13.2%2C12.5 %22%2F%3E%09%3Cpolygon fill%3D%22%23000000%22 stroke%3D%22%23FFFFFF%22 stroke-width%3D%220%22 points%3D%2226.5%2C23.1 15.2%2C27 15.2%2C12.5 26.5%2C8 %22%2F%3E%09%3Cpolygon fill%3D%22%23000000%22 stroke%3D%22%23FFFFFF%22 stroke-width%3D%220%22 points%3D%2214.2%2C3.4 25.5%2C7 14.2%2C11.0 2.9%2C7 %22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E\");\n          mask-image: url(\"data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22utf-8%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 x%3D%220px%22 y%3D%220px%22%09 width%3D%22130px%22 height%3D%22130px%22 viewBox%3D%220 0 27 27%22%3E%3Cg%3E%09%3Cpolygon fill%3D%22%23000000%22 stroke%3D%22%23FFFFFF%22 stroke-width%3D%220%22 points%3D%2213.2%2C27 2.4%2C23.1 2.4%2C8.5 13.2%2C12.5 %22%2F%3E%09%3Cpolygon fill%3D%22%23000000%22 stroke%3D%22%23FFFFFF%22 stroke-width%3D%220%22 points%3D%2226.5%2C23.1 15.2%2C27 15.2%2C12.5 26.5%2C8 %22%2F%3E%09%3Cpolygon fill%3D%22%23000000%22 stroke%3D%22%23FFFFFF%22 stroke-width%3D%220%22 points%3D%2214.2%2C3.4 25.5%2C7 14.2%2C11.0 2.9%2C7 %22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E\");\n}\n";
styleInject(css_248z);

const AMAZON_MODULE = "spinnaker.amazon";
module(AMAZON_MODULE, [
  AWS_REACT_MODULE,
  AMAZON_PIPELINE_STAGES_BAKE_AWSBAKESTAGE,
  AMAZON_PIPELINE_STAGES_CLONESERVERGROUP_AWSCLONESERVERGROUPSTAGE,
  AMAZON_PIPELINE_STAGES_DESTROYASG_AWSDESTROYASGSTAGE,
  AMAZON_PIPELINE_STAGES_DISABLEASG_AWSDISABLEASGSTAGE,
  AMAZON_PIPELINE_STAGES_DISABLECLUSTER_AWSDISABLECLUSTERSTAGE,
  AMAZON_PIPELINE_STAGES_ROLLBACKCLUSTER_AWSROLLBACKCLUSTERSTAGE,
  AMAZON_PIPELINE_STAGES_ENABLEASG_AWSENABLEASGSTAGE,
  AMAZON_PIPELINE_STAGES_FINDAMI_AWSFINDAMISTAGE,
  AMAZON_PIPELINE_STAGES_FINDIMAGEFROMTAGS_AWSFINDIMAGEFROMTAGSSTAGE,
  AMAZON_PIPELINE_STAGES_MODIFYSCALINGPROCESS_MODIFYSCALINGPROCESSSTAGE,
  AMAZON_PIPELINE_STAGES_RESIZEASG_AWSRESIZEASGSTAGE,
  AMAZON_PIPELINE_STAGES_SCALEDOWNCLUSTER_AWSSCALEDOWNCLUSTERSTAGE,
  AMAZON_PIPELINE_STAGES_SHRINKCLUSTER_AWSSHRINKCLUSTERSTAGE,
  AMAZON_PIPELINE_STAGES_TAGIMAGE_AWSTAGIMAGESTAGE,
  SERVER_GROUP_DETAILS_MODULE,
  COMMON_MODULE,
  AWS_SERVER_GROUP_TRANSFORMER,
  AMAZON_INSTANCE_AWSINSTANCETYPE_SERVICE,
  AWS_LOAD_BALANCER_MODULE,
  AWS_FUNCTION_MODULE,
  AMAZON_INSTANCE_DETAILS_INSTANCE_DETAILS_CONTROLLER,
  AWS_SECURITY_GROUP_MODULE,
  SUBNET_RENDERER,
  VPC_MODULE,
  AMAZON_SEARCH_SEARCHRESULTFORMATTER,
  DEPLOY_CLOUDFORMATION_STACK_STAGE,
  CLOUDFORMATION_TEMPLATE_ENTRY,
  CLOUD_FORMATION_CHANGE_SET_INFO,
  AWS_EVALUATE_CLOUD_FORMATION_CHANGE_SET_EXECUTION_SERVICE,
  INSTANCE_STATUS_COMPONENT,
  INSTANCE_TAGS_COMPONENT,
  INSTANCE_SECURITY_GROUPS_COMPONENT,
  INSTANCE_DNS_COMPONENT,
  AMAZON_INSTANCE_INFORMATION_COMPONENT
]).config(() => {
  CloudProviderRegistry.registerProvider("aws", {
    name: "Amazon",
    adHocInfrastructureWritesEnabled: AWSProviderSettings.adHocInfraWritesEnabled,
    logo: {
      path: amazonLogo
    },
    image: {
      reader: AwsImageReader
    },
    serverGroup: {
      transformer: "awsServerGroupTransformer",
      detailsActions: AmazonServerGroupActions,
      detailsGetter: amazonServerGroupDetailsGetter,
      detailsSections: [
        AmazonInfoDetailsSection,
        AmazonCapacityDetailsSection,
        HealthDetailsSection,
        InstancesDistributionDetailsSection,
        LaunchConfigDetailsSection,
        LaunchTemplateDetailsSection,
        SecurityGroupsDetailsSection,
        ScalingProcessesDetailsSection,
        ScalingPoliciesDetailsSection,
        ScheduledActionsDetailsSection,
        TagsDetailsSection,
        PackageDetailsSection,
        AdvancedSettingsDetailsSection,
        LogsDetailsSection
      ],
      CloneServerGroupModal: AmazonCloneServerGroupModal,
      commandBuilder: "awsServerGroupCommandBuilder",
      configurationService: "awsServerGroupConfigurationService",
      scalingActivitiesEnabled: true,
      TargetTrackingChart,
      UpsertStepPolicyModal: UpsertScalingPolicyModal,
      UpsertTargetTrackingModal: UpsertTargetTrackingModal
    },
    instance: {
      instanceTypeService: "awsInstanceTypeService",
      detailsTemplateUrl: "amazon/src/instance/details/instanceDetails.html",
      detailsController: "awsInstanceDetailsCtrl"
    },
    loadBalancer: {
      transformer: AwsLoadBalancerTransformer,
      detailsTemplateUrl: "amazon/src/loadBalancer/details/loadBalancerDetails.html",
      detailsController: "awsLoadBalancerDetailsCtrl",
      CreateLoadBalancerModal: AmazonLoadBalancerChoiceModal,
      targetGroupDetailsTemplateUrl: "amazon/src/loadBalancer/details/targetGroupDetails.html",
      targetGroupDetailsController: "awsTargetGroupDetailsCtrl",
      ClusterContainer: AmazonLoadBalancerClusterContainer,
      LoadBalancersTag: AmazonLoadBalancersTag
    },
    function: {
      details: AmazonFunctionDetails,
      CreateFunctionModal: CreateLambdaFunction,
      transformer: AwsFunctionTransformer
    },
    securityGroup: {
      transformer: "awsSecurityGroupTransformer",
      reader: "awsSecurityGroupReader",
      detailsTemplateUrl: "amazon/src/securityGroup/details/securityGroupDetail.html",
      detailsController: "awsSecurityGroupDetailsCtrl",
      createSecurityGroupTemplateUrl: "amazon/src/securityGroup/configure/createSecurityGroup.html",
      createSecurityGroupController: "awsCreateSecurityGroupCtrl"
    },
    subnet: {
      renderer: "awsSubnetRenderer"
    },
    search: {
      resultFormatter: "awsSearchResultFormatter"
    },
    applicationProviderFields: {
      templateUrl: "amazon/src/applicationProviderFields/awsFields.html"
    }
  });
});
DeploymentStrategyRegistry.registerProvider("aws", [
  "custom",
  "redblack",
  "rollingpush",
  "rollingredblack",
  "monitored"
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/instance/details/instanceDetails.html", `<div class="text-center" ng-if="state.notFoundStandalone">
  <h3>Could not find instance {{instanceIdNotFound}}.</h3>
  <a ui-sref="home.infrastructure">Back to search results</a>
</div>
<div class="details-panel" ng-if="!state.notFoundStandalone">
  <div class="header">
    <instance-details-header
      health-state="instance.healthState"
      instance-id="instance.instanceId || instanceIdNotFound"
      loading="state.loading"
      standalone="state.standalone"
    ></instance-details-header>
    <div ng-if="!state.loading" ng-hide="isDisabled">
      <div class="actions" ng-class="{ insights: instance.insightActions.length > 0 }" ng-if="instance.placement">
        <instance-actions actions="instanceActions"></instance-actions>
        <instance-insights insights="instance.insightActions" instance="instance"></instance-insights>
      </div>
    </div>
  </div>
  <div class="content" ng-if="!state.loading && instance">
    <amazon-instance-information instance="instance"></amazon-instance-information>
    <instance-status
      health-metrics="healthMetrics"
      health-state="instance.healthState"
      metric-types="['LoadBalancer', 'TargetGroup']"
      private-ip-address="instance.privateIpAddress"
    >
    </instance-status>
    <collapsible-section heading="DNS">
      <instance-dns
        instance-port="state.instancePort"
        ipv6-addresses="instance.ipv6Addresses"
        permanent-ips="instance.permanentIps"
        private-dns-name="instance.privateDnsName"
        private-ip-address="instance.privateIpAddress"
        public-dns-name="instance.publicDnsName"
        public-ip-address="instance.publicIpAddress"
      >
      </instance-dns>
    </collapsible-section>
    <instance-security-groups instance="instance"></instance-security-groups>
    <instance-tags tags="instance.tags"></instance-tags>
    <collapsible-section heading="Console Output" ng-if="baseIpAddress">
      <ul>
        <li>
          <console-output-link instance="instance"></console-output-link>
        </li>
      </ul>
    </collapsible-section>
    <instance-links
      address="baseIpAddress"
      application="application"
      instance="instance"
      moniker="moniker"
      environment="environment"
    ></instance-links>
  </div>
  <div class="content" ng-if="!state.loading && !instance">
    <div class="content-section">
      <div class="content-body text-center">
        <h3>Instance not found.</h3>
      </div>
    </div>
  </div>
</div>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/loadBalancer/details/loadBalancerDetails.html", `<div class="details-panel">
  <div ng-if="ctrl.state.loading" class="header">
    <div class="close-button">
      <a class="btn btn-link" ui-sref="^">
        <span class="glyphicon glyphicon-remove"></span>
      </a>
    </div>
    <div class="horizontal center middle spinner-container">
      <loading-spinner size="'small'"></loading-spinner>
    </div>
  </div>

  <div ng-if="!ctrl.state.loading" class="header">
    <div class="close-button">
      <a class="btn btn-link" ui-sref="^">
        <span class="glyphicon glyphicon-remove"></span>
      </a>
    </div>
    <div class="header-text horizontal middle">
      <i class="fa icon-sitemap"></i>
      <h3 class="horizontal middle space-between flex-1" select-on-dbl-click>
        {{ctrl.loadBalancer.name}}
        <render-if-feature feature="entityTags">
          <entity-notifications
            entity="ctrl.loadBalancer"
            application="ctrl.application"
            placement="bottom"
            h-offset-percent="90%"
            entity-type="loadBalancer"
            page-location="details"
            on-update="ctrl.application.loadBalancers.refresh()"
          ></entity-notifications>
        </render-if-feature>
      </h3>
    </div>
    <div>
      <div class="actions">
        <load-balancer-actions
          app="ctrl.application"
          load-balancer="ctrl.loadBalancer"
          load-balancer-from-params="ctrl.loadBalancerFromParams"
        ></load-balancer-actions>
        <div
          class="dropdown"
          ng-if="ctrl.loadBalancer.elb.insightActions.length > 0"
          uib-dropdown
          dropdown-append-to-body
        >
          <button type="button" class="btn btn-sm btn-default dropdown-toggle" uib-dropdown-toggle>
            Insight <span class="caret"></span>
          </button>
          <ul class="dropdown-menu" uib-dropdown-menu role="menu">
            <li ng-repeat="action in ctrl.loadBalancer.elb.insightActions">
              <a target="_blank" href="{{action.url}}">{{action.label}}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <managed-resource-details-indicator
    ng-if="!ctrl.state.loading && ctrl.loadBalancer.isManaged"
    resource-summary="ctrl.loadBalancer.managedResourceSummary"
    application="ctrl.application"
  >
  </managed-resource-details-indicator>
  <div ng-if="!ctrl.state.loading" class="content">
    <collapsible-section heading="Load Balancer Details" expanded="true">
      <dl class="dl-horizontal dl-narrow">
        <dt>Created</dt>
        <dd>{{ctrl.loadBalancer.elb.createdTime | timestamp}}</dd>
        <dt>In</dt>
        <dd>
          <account-tag account="ctrl.loadBalancer.account" pad="right"></account-tag> {{ctrl.loadBalancer.region}}
        </dd>
        <dt>VPC</dt>
        <dd>
          <vpc-tag vpc-id="ctrl.loadBalancer.elb.vpcId"></vpc-tag>
        </dd>
        <dt>Subnet</dt>
        <dd>{{ctrl.getFirstSubnetPurpose(ctrl.loadBalancer.subnetDetails)}}</dd>
        <dt>Scheme</dt>
        <dd>{{ ctrl.loadBalancer.scheme }}</dd>
        <dt ng-if="ctrl.loadBalancer.loadBalancerType">Type</dt>
        <dd ng-if="ctrl.loadBalancer.loadBalancerType">{{ctrl.loadBalancer.loadBalancerType}}</dd>
        <dt ng-if="ctrl.ipAddressTypeDescription">IP Type</dt>
        <dd ng-if="ctrl.ipAddressTypeDescription">{{ctrl.ipAddressTypeDescription}}</dd>
      </dl>
      <dl class="horizontal-when-filters-collapsed">
        <dt>Availability Zones</dt>
        <dd>
          <ul class="collapse-margin-on-filter-collapse">
            <li ng-repeat="availabilityZone in ctrl.loadBalancer.elb.availabilityZones">{{availabilityZone}}</li>
          </ul>
        </dd>
      </dl>
      <dl
        ng-if="ctrl.loadBalancer.serverGroups && ctrl.loadBalancer.serverGroups.length"
        class="horizontal-when-filters-collapsed"
      >
        <dt>Server Groups</dt>
        <dd>
          <ul class="collapse-margin-on-filter-collapse">
            <li ng-repeat="serverGroup in ctrl.loadBalancer.serverGroups | orderBy: ['isDisabled', '-name']">
              <a
                ui-sref="^.serverGroup({region: serverGroup.region,
                                          accountId: serverGroup.account,
                                          serverGroup: serverGroup.name,
                                          provider: 'aws'})"
              >
                {{serverGroup.name}}
              </a>
            </li>
          </ul>
        </dd>
      </dl>
      <dl
        ng-if="ctrl.loadBalancer.targetGroups && ctrl.loadBalancer.targetGroups.length"
        class="horizontal-when-filters-collapsed"
      >
        <dt>Target Groups</dt>
        <dd>
          <ul class="collapse-margin-on-filter-collapse">
            <li ng-repeat="targetGroup in ctrl.loadBalancer.targetGroups | orderBy: ['isDisabled', '-name']">
              <a
                ui-sref="^.targetGroupDetails({region: targetGroup.region,
                                          loadBalancerName: ctrl.loadBalancer.name,
                                          accountId: targetGroup.account,
                                          name: targetGroup.name,
                                          vpcId: targetGroup.vpcId,
                                          provider: 'aws'})"
              >
                {{targetGroup.name}}
              </a>
            </li>
          </ul>
        </dd>
      </dl>
      <dl class="horizontal-when-filters-collapsed">
        <dt ng-if="ctrl.loadBalancer.elb.dnsname">DNS Name</dt>
        <dd>
          <a target="_blank" href="{{ctrl.elbProtocol}}//{{ctrl.loadBalancer.elb.dnsname}}"
            >{{ctrl.loadBalancer.elb.dnsname}}</a
          >
          <copy-to-clipboard
            class="copy-to-clipboard copy-to-clipboard-sm"
            text="ctrl.loadBalancer.elb.dnsname"
            tool-tip="'Copy DNS Name to clipboard'"
          >
          </copy-to-clipboard>
        </dd>
      </dl>
    </collapsible-section>
    <collapsible-section heading="Status" expanded="true" ng-if="ctrl.loadBalancer.loadBalancerType === 'classic'">
      <health-counts class="pull-left" container="ctrl.loadBalancer.instanceCounts"></health-counts>
    </collapsible-section>
    <collapsible-section heading="Status" expanded="false" ng-if="ctrl.loadBalancer.loadBalancerType !== 'classic'">
      Select a target group to check the instance health status from the view of the target group.
    </collapsible-section>
    <collapsible-section ng-if="ctrl.loadBalancer.loadBalancerType === 'classic'" heading="Listeners">
      <dl>
        <dt>Load Balancer &rarr; Instance</dt>
        <dd ng-repeat="listener in ctrl.loadBalancer.elb.listenerDescriptions">
          {{listener.listener.protocol}}:{{listener.listener.loadBalancerPort}} &rarr;
          {{listener.listener.instanceProtocol}}:{{listener.listener.instancePort}}
        </dd>
      </dl>
    </collapsible-section>
    <collapsible-section ng-if="ctrl.loadBalancer.loadBalancerType !== 'classic'" heading="Listeners">
      <div ng-repeat="listener in ctrl.listeners">
        <div class="listener-targets">{{listener.in}} &rarr;</div>
        <div class="listener-targets">
          <div ng-repeat="action in listener.actions">
            <!-- redirect -->
            <span ng-if="action.type === 'redirect'">
              <span ng-if="action.redirectConfig.protocol !== listener.protocol">
                {{action.redirectConfig.protocol}}:
              </span>
              <span ng-if="action.redirectConfig.host !== '#{host}'"> {{action.redirectConfig.host}} </span>
              <span ng-if="action.redirectConfig.port !== '#{port}'"> {{action.redirectConfig.port}} </span>
              <span ng-if="action.redirectConfig.path !== '/#{path}'"> {{action.redirectConfig.path}} </span>
              <span ng-if="action.redirectConfig.query !== '#{query}'"> ?{{action.redirectConfig.query}} </span>
              ({{action.redirectConfig.statusCode}})
            </span>
            <!-- authenticate-oidc -->
            <span ng-if="action.type === 'authenticate-oidc'">
              <i class="fas fa-fw fa-user-lock"></i>
              <a
                ng-if="ctrl.oidcConfigPath"
                href="{{ctrl.oidcConfigPath}}{{action.authenticateOidcConfig.clientId}}"
                target="_blank"
              >
                {{action.authenticateOidcConfig.clientId}}
              </a>
              <span ng-if="!ctrl.oidcConfigPath"> {{action.authenticateOidcConfig.clientId}} </span>
            </span>
            <!-- forward -->
            <span ng-if="action.targetGroupName && action.targetGroup">
              <i class="fa fa-fw fa-crosshairs icon" aria-hidden="true"></i>
              <a
                ui-sref="^.targetGroupDetails({region: action.targetGroup.region,
                              loadBalancerName: ctrl.loadBalancer.name,
                              accountId: action.targetGroup.account,
                              name: action.targetGroup.name,
                              vpcId: action.targetGroup.vpcId,
                              provider: 'aws'})"
              >
                {{action.targetGroupName}}
              </a>
            </span>
            <span ng-if="action.targetGroupName && !action.targetGroup">
              <i class="fa fa-fw fa-crosshairs icon" aria-hidden="true"></i>
              {{action.targetGroupName}}
            </span>
          </div>
        </div>
      </div>
    </collapsible-section>
    <collapsible-section
      heading="{{ctrl.firewallsLabel}}"
      ng-if="ctrl.loadBalancer.loadBalancerType !== 'network' || (ctrl.loadBalancer.loadBalancerType === 'network' && ctrl.securityGroups && ctrl.securityGroups.length > 0)"
    >
      <ul>
        <li ng-repeat="securityGroup in ctrl.securityGroups | orderBy:'name'">
          <a
            ui-sref="^.firewallDetails({name:securityGroup.name, accountId: ctrl.loadBalancer.account, region: ctrl.loadBalancer.region, vpcId: ctrl.loadBalancer.vpcId, provider: ctrl.loadBalancer.provider})"
          >
            {{securityGroup.name}} ({{securityGroup.id}})
          </a>
        </li>
      </ul>
    </collapsible-section>
    <collapsible-section heading="Subnets">
      <div ng-if="ctrl.loadBalancer.subnetDetails.length === 0">
        <h5>No subnets</h5>
      </div>
      <div ng-repeat="subnet in ctrl.loadBalancer.subnetDetails" ng-class="{'bottom-border': !$last}">
        <h5><strong>{{subnet.id}}</strong></h5>
        <dl class="dl-horizontal dl-narrow">
          <dt>Purpose</dt>
          <dd>{{subnet.purpose}}</dd>

          <dt>State</dt>
          <dd>{{subnet.state}}</dd>

          <dt>Cidr Block</dt>
          <dd>{{subnet.cidrBlock}}</dd>
        </dl>
      </div>
    </collapsible-section>
    <collapsible-section ng-if="ctrl.loadBalancer.loadBalancerType === 'classic'" heading="Health Checks">
      <dl class="horizontal-when-filters-collapsed">
        <dt>Target</dt>
        <dd>{{ctrl.loadBalancer.elb.healthCheck.target}}</dd>
        <dt>Timeout</dt>
        <dd>{{ctrl.loadBalancer.elb.healthCheck.timeout}} seconds</dd>
        <dt>Interval</dt>
        <dd>{{ctrl.loadBalancer.elb.healthCheck.interval}} seconds</dd>
        <dt>Healthy Threshold</dt>
        <dd>{{ctrl.loadBalancer.elb.healthCheck.healthyThreshold}}</dd>
        <dt>Unhealthy Threshold</dt>
        <dd>{{ctrl.loadBalancer.elb.healthCheck.unhealthyThreshold}}</dd>
      </dl>
    </collapsible-section>
  </div>
</div>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/loadBalancer/details/targetGroupDetails.html", `<div class="details-panel">
  <div ng-if="ctrl.state.loading" class="header">
    <div class="close-button">
      <a class="btn btn-link" ui-sref="^">
        <span class="glyphicon glyphicon-remove"></span>
      </a>
    </div>
    <div class="horizontal center middle">
      <loading-spinner size="'small'"></loading-spinner>
    </div>
  </div>

  <div ng-if="!ctrl.state.loading" class="header">
    <div class="close-button">
      <a class="btn btn-link" ui-sref="^">
        <span class="glyphicon glyphicon-remove"></span>
      </a>
    </div>
    <div class="header-text horizontal middle">
      <i class="fa fa-crosshairs icon" aria-hidden="true"></i>
      <h3 class="horizontal middle space-between flex-1" select-on-dbl-click>{{ctrl.targetGroup.name}}</h3>
    </div>
  </div>
  <managed-resource-details-indicator
    ng-if="!ctrl.state.loading && ctrl.loadBalancer.isManaged"
    resource-summary="ctrl.loadBalancer.managedResourceSummary"
    application="ctrl.application"
  >
  </managed-resource-details-indicator>
  <div ng-if="!ctrl.state.loading" class="content">
    <collapsible-section heading="Target Group Details" expanded="true">
      <dl class="dl-horizontal dl-narrow">
        <dt>In</dt>
        <dd><account-tag account="ctrl.targetGroup.account" pad="right"></account-tag> {{ctrl.targetGroup.region}}</dd>
        <dt>VPC</dt>
        <dd>
          <vpc-tag vpc-id="ctrl.targetGroup.vpcId"></vpc-tag>
        </dd>
        <dt>Protocol</dt>
        <dd>{{ctrl.targetGroup.protocol}}</dd>
        <dt>Port</dt>
        <dd>{{ctrl.targetGroup.port}}</dd>
        <dt>Target Type</dt>
        <dd>{{ctrl.targetGroup.targetType}}</dd>
      </dl>
      <dl ng-if="ctrl.loadBalancer" class="horizontal-when-filters-collapsed">
        <dt>Load Balancer</dt>
        <dd>
          <ul class="collapse-margin-on-filter-collapse">
            <li>
              <a
                ui-sref="^.loadBalancerDetails({ name: ctrl.loadBalancer.name,
                                                  region: ctrl.loadBalancer.region,
                                                  accountId: ctrl.loadBalancer.account,
                                                  vpcId: ctrl.loadBalancer.vpcId,
                                                  provider: 'aws'})"
              >
                {{ctrl.loadBalancer.name}}
              </a>
            </li>
          </ul>
        </dd>
      </dl>
      <dl class="horizontal-when-filters-collapsed">
        <dt ng-if="ctrl.loadBalancer.dnsname">Load Balancer DNS Name</dt>
        <dd ng-if="ctrl.loadBalancer.dnsname">
          <a target="_blank" href="{{ctrl.elbProtocol}}//{{ctrl.loadBalancer.dnsname}}"
            >{{ctrl.loadBalancer.dnsname}}</a
          >
          <copy-to-clipboard
            class="copy-to-clipboard copy-to-clipboard-sm"
            text="ctrl.loadBalancer.dnsname"
            tool-tip="'Copy DNS Name to clipboard'"
          >
          </copy-to-clipboard>
        </dd>
      </dl>
      <dl
        ng-if="ctrl.targetGroup.serverGroups && ctrl.targetGroup.serverGroups.length"
        class="horizontal-when-filters-collapsed"
      >
        <dt>Server Groups</dt>
        <dd>
          <ul class="collapse-margin-on-filter-collapse">
            <li ng-repeat="serverGroup in ctrl.targetGroup.serverGroups | orderBy: ['isDisabled', '-name']">
              <a
                ui-sref="^.serverGroup({region: serverGroup.region,
                                          accountId: serverGroup.account,
                                          serverGroup: serverGroup.name,
                                          provider: serverGroup.cloudProvider})"
              >
                {{serverGroup.name}}
              </a>
            </li>
          </ul>
        </dd>
      </dl>
    </collapsible-section>
    <collapsible-section heading="Status" expanded="true">
      <health-counts class="pull-left" container="ctrl.targetGroup.instanceCounts"></health-counts>
    </collapsible-section>
    <collapsible-section heading="Health Checks">
      <dl class="horizontal-when-filters-collapsed">
        <dt>Target</dt>
        <dd>
          {{ctrl.targetGroup.healthCheckProtocol}}:{{ctrl.targetGroup.healthCheckPort}}
          {{ctrl.targetGroup.healthCheckPath}}
        </dd>
        <dt>Timeout</dt>
        <dd>{{ctrl.targetGroup.healthCheckTimeoutSeconds}} seconds</dd>
        <dt>Interval</dt>
        <dd>{{ctrl.targetGroup.healthCheckIntervalSeconds}} seconds</dd>
        <dt>Healthy Threshold</dt>
        <dd>{{ctrl.targetGroup.healthyThresholdCount}}</dd>
        <dt>Unhealthy Threshold</dt>
        <dd>{{ctrl.targetGroup.unhealthyThresholdCount}}</dd>
        <dt>Matcher</dt>
        <dd>HTTP Code(s): {{ctrl.targetGroup.matcher.httpCode}}</dd>
      </dl>
    </collapsible-section>
    <collapsible-section heading="Attributes" expanded="true">
      <dl class="horizontal-when-filters-collapsed">
        <dt>Deregistration Delay Timeout</dt>
        <dd>{{ctrl.targetGroup.attributes['deregistration_delay.timeout_seconds']}} seconds</dd>
        <dt>Stickiness Enabled</dt>
        <dd>{{ctrl.targetGroup.attributes['stickiness.enabled']}}</dd>
        <dt ng-if-start="ctrl.targetGroup.attributes['stickiness.enabled'] === 'true'">
          Stickiness Load Balancer Cookie Duration
        </dt>
        <dd>{{ctrl.targetGroup.attributes['stickiness.lb_cookie.duration_seconds']}} seconds</dd>
        <dt>Stickiness Type</dt>
        <dd ng-if-end>{{ctrl.targetGroup.attributes['stickiness.type']}}</dd>
        <dt ng-if-start="ctrl.loadBalancer.loadBalancerType === 'network'">Preserve Client IP</dt>
        <dd ng-if-end>{{ctrl.targetGroup.attributes['preserve_client_ip.enabled']}}</dd>
      </dl>
    </collapsible-section>
  </div>
</div>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/securityGroup/details/securityGroupDetail.html", `<div class="text-center" ng-if="state.notFound">
  <h3>Could not find <firewall-label label="firewall"></firewall-label> {{group}}.</h3>
  <a ui-sref="home.infrastructure">Back to search results</a>
</div>
<div class="details-panel" ng-if="!state.notFound">
  <div class="header">
    <div class="close-button" ng-if="!state.standalone">
      <a class="btn btn-link" ui-sref="^">
        <span class="glyphicon glyphicon-remove"></span>
      </a>
    </div>
    <div ng-if="state.loading" class="horizontal center middle">
      <loading-spinner size="'small'"></loading-spinner>
    </div>
    <div class="header-text horizontal middle" ng-if="!state.loading">
      <span class="glyphicon glyphicon-transfer"></span>
      <h3 class="horizontal middle space-between flex-1" select-on-dbl-click>
        {{securityGroup.name || '(not found)'}}
        <render-if-feature feature="entityTags">
          <entity-notifications
            entity="securityGroup"
            application="ctrl.application"
            placement="bottom"
            h-offset-percent="90%"
            entity-type="securityGroup"
            page-location="details"
            on-update="ctrl.application.securityGroups.refresh()"
          ></entity-notifications>
        </render-if-feature>
      </h3>
    </div>
    <div class="actions" ng-hide="isDisabled">
      <div class="dropdown" uib-dropdown dropdown-append-to-body>
        <button type="button" class="btn btn-sm btn-primary dropdown-toggle" ng-disabled="disabled" uib-dropdown-toggle>
          <firewall-label label="Firewall"></firewall-label> Actions <span class="caret"></span>
        </button>
        <ul class="dropdown-menu" uib-dropdown-menu role="menu">
          <li><a href ng-click="ctrl.editInboundRules()">Edit Inbound Rules</a></li>
          <li>
            <a href ng-click="ctrl.deleteSecurityGroup()">Delete <firewall-label label="Firewall"></firewall-label></a>
          </li>
          <li>
            <a href ng-click="ctrl.cloneSecurityGroup()">Clone <firewall-label label="Firewall"></firewall-label></a>
          </li>
          <render-if-feature feature="entityTags">
            <add-entity-tag-links
              component="securityGroup"
              application="ctrl.application"
              entity-type="securityGroup"
              on-update="ctrl.application.securityGroups.refresh"
            ></add-entity-tag-links>
          </render-if-feature>
        </ul>
      </div>
    </div>
  </div>
  <managed-resource-details-indicator
    ng-if="!state.loading && securityGroup.isManaged"
    resource-summary="securityGroup.managedResourceSummary"
    application="ctrl.application"
  >
  </managed-resource-details-indicator>
  <div class="content" ng-if="!state.loading">
    <collapsible-section heading="{{ctrl.firewallLabel}} Details" expanded="true">
      <dl class="dl-horizontal dl-medium">
        <dt>ID</dt>
        <dd>{{securityGroup.id}}</dd>
        <dt>Account</dt>
        <dd>
          <account-tag account="securityGroup.accountName"></account-tag>
        </dd>
        <dt>Region</dt>
        <dd>{{securityGroup.region}}</dd>
        <dt>VPC</dt>
        <dd>
          <vpc-tag vpc-id="securityGroup.vpcId"></vpc-tag>
        </dd>
        <dt>Description</dt>
        <dd>{{securityGroup.description}}</dd>
      </dl>
    </collapsible-section>
    <ip-range-rules ip-rules="ipRules"></ip-range-rules>
    <collapsible-section
      heading="{{ctrl.firewallLabel}} Rules ({{securityGroupRules.length || 0}})"
      expanded="{{securityGroupRules.length > 0}}"
    >
      <div ng-if="!securityGroupRules.length">None</div>

      <dl
        ng-class="insightCtrl.vm.filtersExpanded ? '' : 'dl-horizontal dl-medium'"
        ng-repeat="rule in securityGroupRules | orderBy: 'securityGroup.name' "
      >
        <dt>
          <firewall-label label="Firewall"></firewall-label>
        </dt>
        <dd ng-if="rule.securityGroup.name">
          <a
            ui-sref="^.firewallDetails({name: rule.securityGroup.name, accountId: rule.securityGroup.accountName, region: rule.securityGroup.region, vpcId: rule.securityGroup.vpcId, provider: 'aws'})"
          >
            <account-tag
              account="rule.securityGroup.accountName || rule.securityGroup.accountId"
              ng-if="rule.securityGroup.accountName !== securityGroup.accountName"
            ></account-tag>
            {{rule.securityGroup.name}} ({{rule.securityGroup.id}})
          </a>
        </dd>
        <dt>Port Ranges</dt>
        <dd ng-repeat="portRange in rule.rules">
          {{portRange.protocol}}: {{portRange.startPort}} &rarr; {{portRange.endPort}}
        </dd>
      </dl>
    </collapsible-section>
  </div>
</div>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/securityGroup/configure/createSecurityGroup.html", `<ng-form role="form" name="form" novalidate>
  <v2-modal-wizard heading="Create New {{ctrl.translate('Firewall')}}" task-monitor="taskMonitor" dismiss="$dismiss()">
    <v2-wizard-page key="Location" label="Location">
      <ng-include src="pages.location"></ng-include>
    </v2-wizard-page>
    <v2-wizard-page key="Ingress" label="Ingress" done="true">
      <ng-include src="pages.ingress"></ng-include>
    </v2-wizard-page>
  </v2-modal-wizard>
  <div class="modal-footer">
    <button class="btn btn-default" ng-click="ctrl.cancel()">Cancel</button>
    <submit-button
      is-disabled="form.$invalid || !wizard.isComplete() || state.submitting || !customComponentIsvalid"
      submitting="state.submitting"
      on-click="ctrl.upsert()"
      is-new="state.isNew"
    ></submit-button>
  </div>
</ng-form>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("amazon/src/applicationProviderFields/awsFields.html", `<div class="form-group row">
  <div class="col-sm-3 sm-label-right">AWS Settings</div>
  <div class="col-sm-9 checkbox" style="margin-bottom: 0; margin-top: 5px">
    <label>
      <input
        type="checkbox"
        ng-init="$ctrl.initializeApplicationField('aws.useAmiBlockDeviceMappings')"
        ng-model="$ctrl.application.providerSettings.aws.useAmiBlockDeviceMappings"
      />
      Prefer AMI Block Device Mappings
    </label>
  </div>
</div>
`);
}]);

export { AMAZON_MODULE, AWSProviderSettings, AWS_SERVER_GROUP_CONFIGURATION_SERVICE, AdvancedSettingsDetailsSection, AlarmConfigurer, AmazonCapacityDetailsSection, AmazonCertificateReader, AmazonCertificateSelectField, AmazonFunctionDetails, AmazonImageSelectInput, AmazonInfoDetailsSection, AmazonInstanceWriter, AmazonLoadBalancerChoiceModal, AmazonLoadBalancerClusterContainer, AmazonLoadBalancerDataUtils, AmazonLoadBalancersTag, AmazonResizeServerGroupModal, UpsertScalingPolicyModal as AmazonUpsertScalingPolicyModal, UpsertTargetTrackingModal as AmazonUpsertTargetTrackingModal, AwsFunctionTransformer, AwsLoadBalancerTransformer, AwsModalFooter, AwsReactInject, AwsReactInjector, AwsServerGroupConfigurationService, COMPARATORS, CreateLambdaFunction, CreateScalingPolicyButton, DateLineChart, DimensionsEditor, FunctionActions, FunctionBasicInformation, HealthDetailsSection, IPRangeRules, InstanceDns, InstanceInformation, InstanceStatus, InstancesDistributionDetailsSection, KeyPairsReader, LaunchConfigDetailsSection, LaunchTemplateDetailsSection, LoadBalancerTypes, LogsDetailsSection, MetricAlarmChart, MetricSelector, PackageDetailsSection, PolicyTypeSelectionModal, ScalingPoliciesDetailsSection, ScalingPolicyAdditionalSettings, ScalingPolicySummary, ScalingPolicyWriter, ScalingProcessesDetailsSection, ScheduledActionsDetailsSection, SecurityGroupSelector, SecurityGroupsDetailsSection, ServerGroupAdvancedSettings, ServerGroupAdvancedSettingsCommon, ServerGroupBasicSettings, ServerGroupCapacity, ServerGroupInstanceType, ServerGroupLoadBalancers, ServerGroupSecurityGroups, ServerGroupSecurityGroupsRemoved, ServerGroupZones, StepPolicyAction, StepPolicySummary, SubnetSelectField, SubnetSelectInput, TagsDetailsSection, TargetGroup, TargetGroupDetails, TargetMetricFields, TargetTrackingAdditionalSettings, TargetTrackingChart, TargetTrackingSummary, VpcReader, applyHealthCheckInfoToTargetGroups, getAllTargetGroups, getBaseImageName };
//# sourceMappingURL=index.js.map
